(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb8d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb8d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';

var $k1s95 = parcelRequire("k1s95");
var $dd934af551f44020$var$n = 60103, $dd934af551f44020$var$p = 60106;
$dd934af551f44020$export$ffb0004e005737fa = 60107;
$dd934af551f44020$export$5f8d39834fd61797 = 60108;
$dd934af551f44020$export$e2c29f18771995cb = 60114;
var $dd934af551f44020$var$q = 60109, $dd934af551f44020$var$r = 60110, $dd934af551f44020$var$t = 60112;
$dd934af551f44020$export$74bf444e3cd11ea5 = 60113;
var $dd934af551f44020$var$u = 60115, $dd934af551f44020$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $dd934af551f44020$var$w = Symbol.for;
    $dd934af551f44020$var$n = $dd934af551f44020$var$w("react.element");
    $dd934af551f44020$var$p = $dd934af551f44020$var$w("react.portal");
    $dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$w("react.fragment");
    $dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$w("react.strict_mode");
    $dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$w("react.profiler");
    $dd934af551f44020$var$q = $dd934af551f44020$var$w("react.provider");
    $dd934af551f44020$var$r = $dd934af551f44020$var$w("react.context");
    $dd934af551f44020$var$t = $dd934af551f44020$var$w("react.forward_ref");
    $dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w("react.suspense");
    $dd934af551f44020$var$u = $dd934af551f44020$var$w("react.memo");
    $dd934af551f44020$var$v = $dd934af551f44020$var$w("react.lazy");
}
var $dd934af551f44020$var$x = "function" === typeof Symbol && Symbol.iterator;
function $dd934af551f44020$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$x && a[$dd934af551f44020$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $dd934af551f44020$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $dd934af551f44020$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$B = {};
function $dd934af551f44020$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$B;
    this.updater = c || $dd934af551f44020$var$A;
}
$dd934af551f44020$var$C.prototype.isReactComponent = {};
$dd934af551f44020$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($dd934af551f44020$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$D() {}
$dd934af551f44020$var$D.prototype = $dd934af551f44020$var$C.prototype;
function $dd934af551f44020$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$B;
    this.updater = c || $dd934af551f44020$var$A;
}
var $dd934af551f44020$var$F = $dd934af551f44020$var$E.prototype = new $dd934af551f44020$var$D;
$dd934af551f44020$var$F.constructor = $dd934af551f44020$var$E;
$k1s95($dd934af551f44020$var$F, $dd934af551f44020$var$C.prototype);
$dd934af551f44020$var$F.isPureReactComponent = !0;
var $dd934af551f44020$var$G = {
    current: null
}, $dd934af551f44020$var$H = Object.prototype.hasOwnProperty, $dd934af551f44020$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$H.call(b, e) && !$dd934af551f44020$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $dd934af551f44020$var$G.current
    };
}
function $dd934af551f44020$var$K(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$n;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$M = /\/+/g;
function $dd934af551f44020$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$n:
                case $dd934af551f44020$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $dd934af551f44020$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($dd934af551f44020$var$M, "$&/") + "/"), $dd934af551f44020$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($dd934af551f44020$var$L(d) && (d = $dd934af551f44020$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($dd934af551f44020$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $dd934af551f44020$var$N(k, g);
        h += $dd934af551f44020$var$O(k, b, c, f, d);
    }
    else if (f = $dd934af551f44020$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $dd934af551f44020$var$N(k, g++), h += $dd934af551f44020$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($dd934af551f44020$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $dd934af551f44020$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $dd934af551f44020$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $dd934af551f44020$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $dd934af551f44020$var$R = {
    current: null
};
function $dd934af551f44020$var$S() {
    var a = $dd934af551f44020$var$R.current;
    if (null === a) throw Error($dd934af551f44020$var$z(321));
    return a;
}
var $dd934af551f44020$var$T = {
    ReactCurrentDispatcher: $dd934af551f44020$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $dd934af551f44020$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $k1s95
};
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$P,
    forEach: function(a, b, c) {
        $dd934af551f44020$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$L(a)) throw Error($dd934af551f44020$var$z(143));
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$C;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$E;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$T;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($dd934af551f44020$var$z(267, a));
    var e = $k1s95({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$H.call(b, f) && !$dd934af551f44020$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $dd934af551f44020$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$J;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$J.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$t,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$L;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$Q
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$S().useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a, b) {
    return $dd934af551f44020$var$S().useContext(a, b);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$S().useEffect(a, b);
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, c) {
    return $dd934af551f44020$var$S().useImperativeHandle(a, b, c);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$S().useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$S().useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, c) {
    return $dd934af551f44020$var$S().useReducer(a, b, c);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$S().useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$S().useState(a);
};
$dd934af551f44020$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("k1s95", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $e939bbc6f2d9bc5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e939bbc6f2d9bc5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e939bbc6f2d9bc5d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $e939bbc6f2d9bc5d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $e939bbc6f2d9bc5d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $e939bbc6f2d9bc5d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $e939bbc6f2d9bc5d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($e939bbc6f2d9bc5d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($e939bbc6f2d9bc5d$var$getOwnPropertySymbols) {
            symbols = $e939bbc6f2d9bc5d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($e939bbc6f2d9bc5d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("23wBm", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $8NFma = parcelRequire("8NFma");

var $k1s95 = parcelRequire("k1s95");

var $clk2u = parcelRequire("clk2u");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$8NFma) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $k1s95({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $8NFma.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $k1s95({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $k1s95({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $k1s95({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $clk2u.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $clk2u.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $clk2u.unstable_UserBlockingPriority, ed = $clk2u.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $k1s95(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $k1s95({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $k1s95({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $k1s95({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $k1s95({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $k1s95({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $k1s95({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $k1s95({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $k1s95({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $k1s95({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $k1s95({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $k1s95({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $k1s95({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $k1s95({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $clk2u.unstable_runWithPriority, Of = $clk2u.unstable_scheduleCallback, Pf = $clk2u.unstable_cancelCallback, Qf = $clk2u.unstable_shouldYield, Rf = $clk2u.unstable_requestPaint, Sf = $clk2u.unstable_now, Tf = $clk2u.unstable_getCurrentPriorityLevel, Uf = $clk2u.unstable_ImmediatePriority, Vf = $clk2u.unstable_UserBlockingPriority, Wf = $clk2u.unstable_NormalPriority, Xf = $clk2u.unstable_LowPriority, Yf = $clk2u.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $k1s95({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $k1s95({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $8NFma.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $k1s95({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $k1s95({}, e, {
                    value: void 0
                });
                d = $k1s95({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $k1s95({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});

parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
var $3d3ce0c592af0505$var$f, $3d3ce0c592af0505$var$g, $3d3ce0c592af0505$var$h, $3d3ce0c592af0505$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$t = null, $3d3ce0c592af0505$var$u = null, $3d3ce0c592af0505$var$w = function() {
        if (null !== $3d3ce0c592af0505$var$t) try {
            var a = $3d3ce0c592af0505$export$c4744153514ff05d();
            $3d3ce0c592af0505$var$t(!0, a);
            $3d3ce0c592af0505$var$t = null;
        } catch (b) {
            throw setTimeout($3d3ce0c592af0505$var$w, 0), b;
        }
    };
    $3d3ce0c592af0505$var$f = function(a) {
        null !== $3d3ce0c592af0505$var$t ? setTimeout($3d3ce0c592af0505$var$f, 0, a) : ($3d3ce0c592af0505$var$t = a, setTimeout($3d3ce0c592af0505$var$w, 0));
    };
    $3d3ce0c592af0505$var$g = function(a, b) {
        $3d3ce0c592af0505$var$u = setTimeout(a, b);
    };
    $3d3ce0c592af0505$var$h = function() {
        clearTimeout($3d3ce0c592af0505$var$u);
    };
    $3d3ce0c592af0505$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $3d3ce0c592af0505$var$k = $3d3ce0c592af0505$export$d66a1c1c77bd778b = function() {};
} else {
    var $3d3ce0c592af0505$var$x = window.setTimeout, $3d3ce0c592af0505$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $3d3ce0c592af0505$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $3d3ce0c592af0505$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = null, $3d3ce0c592af0505$var$C = -1, $3d3ce0c592af0505$var$D = 5, $3d3ce0c592af0505$var$E = 0;
    $3d3ce0c592af0505$export$b5836b71941fa3ed = function() {
        return $3d3ce0c592af0505$export$c4744153514ff05d() >= $3d3ce0c592af0505$var$E;
    };
    $3d3ce0c592af0505$var$k = function() {};
    $3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $3d3ce0c592af0505$var$F = new MessageChannel, $3d3ce0c592af0505$var$G = $3d3ce0c592af0505$var$F.port2;
    $3d3ce0c592af0505$var$F.port1.onmessage = function() {
        if (null !== $3d3ce0c592af0505$var$B) {
            var a = $3d3ce0c592af0505$export$c4744153514ff05d();
            $3d3ce0c592af0505$var$E = a + $3d3ce0c592af0505$var$D;
            try {
                $3d3ce0c592af0505$var$B(!0, a) ? $3d3ce0c592af0505$var$G.postMessage(null) : ($3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = null);
            } catch (b) {
                throw $3d3ce0c592af0505$var$G.postMessage(null), b;
            }
        } else $3d3ce0c592af0505$var$A = !1;
    };
    $3d3ce0c592af0505$var$f = function(a) {
        $3d3ce0c592af0505$var$B = a;
        $3d3ce0c592af0505$var$A || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$G.postMessage(null));
    };
    $3d3ce0c592af0505$var$g = function(a, b) {
        $3d3ce0c592af0505$var$C = $3d3ce0c592af0505$var$x(function() {
            a($3d3ce0c592af0505$export$c4744153514ff05d());
        }, b);
    };
    $3d3ce0c592af0505$var$h = function() {
        $3d3ce0c592af0505$var$y($3d3ce0c592af0505$var$C);
        $3d3ce0c592af0505$var$C = -1;
    };
}
function $3d3ce0c592af0505$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $3d3ce0c592af0505$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $3d3ce0c592af0505$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $3d3ce0c592af0505$var$I(n, c)) void 0 !== r && 0 > $3d3ce0c592af0505$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $3d3ce0c592af0505$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $3d3ce0c592af0505$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $3d3ce0c592af0505$var$L = [], $3d3ce0c592af0505$var$M = [], $3d3ce0c592af0505$var$N = 1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$P = 3, $3d3ce0c592af0505$var$Q = !1, $3d3ce0c592af0505$var$R = !1, $3d3ce0c592af0505$var$S = !1;
function $3d3ce0c592af0505$var$T(a) {
    for(var b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$M);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$M), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$L, b);
        else break;
        b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
    }
}
function $3d3ce0c592af0505$var$U(a) {
    $3d3ce0c592af0505$var$S = !1;
    $3d3ce0c592af0505$var$T(a);
    if (!$3d3ce0c592af0505$var$R) {
        if (null !== $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L)) $3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V);
        else {
            var b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
            null !== b && $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$V(a, b) {
    $3d3ce0c592af0505$var$R = !1;
    $3d3ce0c592af0505$var$S && ($3d3ce0c592af0505$var$S = !1, $3d3ce0c592af0505$var$h());
    $3d3ce0c592af0505$var$Q = !0;
    var c = $3d3ce0c592af0505$var$P;
    try {
        $3d3ce0c592af0505$var$T(b);
        for($3d3ce0c592af0505$var$O = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L); null !== $3d3ce0c592af0505$var$O && (!($3d3ce0c592af0505$var$O.expirationTime > b) || a && !$3d3ce0c592af0505$export$b5836b71941fa3ed());){
            var d = $3d3ce0c592af0505$var$O.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$O.callback = null;
                $3d3ce0c592af0505$var$P = $3d3ce0c592af0505$var$O.priorityLevel;
                var e = d($3d3ce0c592af0505$var$O.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$O.callback = e : $3d3ce0c592af0505$var$O === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L) && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$L);
                $3d3ce0c592af0505$var$T(b);
            } else $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$L);
            $3d3ce0c592af0505$var$O = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L);
        }
        if (null !== $3d3ce0c592af0505$var$O) var m = !0;
        else {
            var n = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
            null !== n && $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$P = c, $3d3ce0c592af0505$var$Q = !1;
    }
}
var $3d3ce0c592af0505$var$W = $3d3ce0c592af0505$var$k;
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$R || $3d3ce0c592af0505$var$Q || ($3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V));
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$P;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$P;
    }
    var c = $3d3ce0c592af0505$var$P;
    $3d3ce0c592af0505$var$P = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$P = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = $3d3ce0c592af0505$var$W;
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$P;
    $3d3ce0c592af0505$var$P = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$P = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$M, a), null === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L) && a === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M) && ($3d3ce0c592af0505$var$S ? $3d3ce0c592af0505$var$h() : $3d3ce0c592af0505$var$S = !0, $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$L, a), $3d3ce0c592af0505$var$R || $3d3ce0c592af0505$var$Q || ($3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V)));
    return a;
};
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$P;
    return function() {
        var c = $3d3ce0c592af0505$var$P;
        $3d3ce0c592af0505$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$P = c;
        }
    };
};

});



parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';
parcelRequire("k1s95");

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$g = 60103;
$5ef850295e0236ca$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $5ef850295e0236ca$var$h = Symbol.for;
    $5ef850295e0236ca$var$g = $5ef850295e0236ca$var$h("react.element");
    $5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$h("react.fragment");
}
var $5ef850295e0236ca$var$m = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$n = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$5ef850295e0236ca$var$n.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $5ef850295e0236ca$var$m.current
    };
}
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});

parcelRegister("ejyEb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6T5ne")).default);

var $6T5ne = parcelRequire("6T5ne");

});
parcelRegister("6T5ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $503c0c39b18940dc$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $503c0c39b18940dc$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("iB2j3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aKSKj")).default);

var $aKSKj = parcelRequire("aKSKj");

});
parcelRegister("aKSKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d48aaaa456e2107$export$2e2bcd8739ae039);
function $7d48aaaa456e2107$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $7d48aaaa456e2107$export$2e2bcd8739ae039 = $7d48aaaa456e2107$var$clamp;

});


parcelRegister("gpUM7", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $bf3b0579824ef26a$export$2b8d127b894957b9, (v) => $bf3b0579824ef26a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $bf3b0579824ef26a$export$cea3a54a6425200c, (v) => $bf3b0579824ef26a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $bf3b0579824ef26a$export$a7c73072b1a182ae, (v) => $bf3b0579824ef26a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bf3b0579824ef26a$export$9f27bc3417b4524d, (v) => $bf3b0579824ef26a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bf3b0579824ef26a$export$db77ccec0bb4ccac, (v) => $bf3b0579824ef26a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bf3b0579824ef26a$export$8392c0c9d3dcbd35, (v) => $bf3b0579824ef26a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bf3b0579824ef26a$export$ffb0004e005737fa, (v) => $bf3b0579824ef26a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bf3b0579824ef26a$export$b624eff549462981, (v) => $bf3b0579824ef26a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bf3b0579824ef26a$export$7897aa7841a5380c, (v) => $bf3b0579824ef26a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bf3b0579824ef26a$export$602eac185826482c, (v) => $bf3b0579824ef26a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bf3b0579824ef26a$export$e2c29f18771995cb, (v) => $bf3b0579824ef26a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bf3b0579824ef26a$export$5f8d39834fd61797, (v) => $bf3b0579824ef26a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bf3b0579824ef26a$export$74bf444e3cd11ea5, (v) => $bf3b0579824ef26a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $bf3b0579824ef26a$export$92387174baf9b227, (v) => $bf3b0579824ef26a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $bf3b0579824ef26a$export$ec112efeb987d9c6, (v) => $bf3b0579824ef26a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bf3b0579824ef26a$export$b706b080d889d2c9, (v) => $bf3b0579824ef26a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bf3b0579824ef26a$export$5be5a87408f70ddc, (v) => $bf3b0579824ef26a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bf3b0579824ef26a$export$45a5e7f76e0caa8d, (v) => $bf3b0579824ef26a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bf3b0579824ef26a$export$455c2e768291efa6, (v) => $bf3b0579824ef26a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bf3b0579824ef26a$export$9522e17588c12572, (v) => $bf3b0579824ef26a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bf3b0579824ef26a$export$2110ac352bb060b9, (v) => $bf3b0579824ef26a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bf3b0579824ef26a$export$56885ab8b9c456ab, (v) => $bf3b0579824ef26a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bf3b0579824ef26a$export$d927fcb6adf8f9de, (v) => $bf3b0579824ef26a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bf3b0579824ef26a$export$b82d16f27459e05a, (v) => $bf3b0579824ef26a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bf3b0579824ef26a$export$522c17b4f5e123e8, (v) => $bf3b0579824ef26a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bf3b0579824ef26a$export$1aabd8a0274ecfd6, (v) => $bf3b0579824ef26a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $bf3b0579824ef26a$export$9b621391a187a31a, (v) => $bf3b0579824ef26a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bf3b0579824ef26a$export$f5bbd400c2f4426f, (v) => $bf3b0579824ef26a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bf3b0579824ef26a$export$2b8d127b894957b9;
var $bf3b0579824ef26a$export$cea3a54a6425200c;
var $bf3b0579824ef26a$export$a7c73072b1a182ae;
var $bf3b0579824ef26a$export$9f27bc3417b4524d;
var $bf3b0579824ef26a$export$db77ccec0bb4ccac;
var $bf3b0579824ef26a$export$8392c0c9d3dcbd35;
var $bf3b0579824ef26a$export$ffb0004e005737fa;
var $bf3b0579824ef26a$export$b624eff549462981;
var $bf3b0579824ef26a$export$7897aa7841a5380c;
var $bf3b0579824ef26a$export$602eac185826482c;
var $bf3b0579824ef26a$export$e2c29f18771995cb;
var $bf3b0579824ef26a$export$5f8d39834fd61797;
var $bf3b0579824ef26a$export$74bf444e3cd11ea5;
var $bf3b0579824ef26a$export$92387174baf9b227;
var $bf3b0579824ef26a$export$ec112efeb987d9c6;
var $bf3b0579824ef26a$export$b706b080d889d2c9;
var $bf3b0579824ef26a$export$5be5a87408f70ddc;
var $bf3b0579824ef26a$export$45a5e7f76e0caa8d;
var $bf3b0579824ef26a$export$455c2e768291efa6;
var $bf3b0579824ef26a$export$9522e17588c12572;
var $bf3b0579824ef26a$export$2110ac352bb060b9;
var $bf3b0579824ef26a$export$56885ab8b9c456ab;
var $bf3b0579824ef26a$export$d927fcb6adf8f9de;
var $bf3b0579824ef26a$export$b82d16f27459e05a;
var $bf3b0579824ef26a$export$522c17b4f5e123e8;
var $bf3b0579824ef26a$export$1aabd8a0274ecfd6;
var $bf3b0579824ef26a$export$9b621391a187a31a;
var $bf3b0579824ef26a$export$f5bbd400c2f4426f;
'use strict';
var $bf3b0579824ef26a$var$b = "function" === typeof Symbol && Symbol.for, $bf3b0579824ef26a$var$c = $bf3b0579824ef26a$var$b ? Symbol.for("react.element") : 60103, $bf3b0579824ef26a$var$d = $bf3b0579824ef26a$var$b ? Symbol.for("react.portal") : 60106, $bf3b0579824ef26a$var$e = $bf3b0579824ef26a$var$b ? Symbol.for("react.fragment") : 60107, $bf3b0579824ef26a$var$f = $bf3b0579824ef26a$var$b ? Symbol.for("react.strict_mode") : 60108, $bf3b0579824ef26a$var$g = $bf3b0579824ef26a$var$b ? Symbol.for("react.profiler") : 60114, $bf3b0579824ef26a$var$h = $bf3b0579824ef26a$var$b ? Symbol.for("react.provider") : 60109, $bf3b0579824ef26a$var$k = $bf3b0579824ef26a$var$b ? Symbol.for("react.context") : 60110, $bf3b0579824ef26a$var$l = $bf3b0579824ef26a$var$b ? Symbol.for("react.async_mode") : 60111, $bf3b0579824ef26a$var$m = $bf3b0579824ef26a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bf3b0579824ef26a$var$n = $bf3b0579824ef26a$var$b ? Symbol.for("react.forward_ref") : 60112, $bf3b0579824ef26a$var$p = $bf3b0579824ef26a$var$b ? Symbol.for("react.suspense") : 60113, $bf3b0579824ef26a$var$q = $bf3b0579824ef26a$var$b ? Symbol.for("react.suspense_list") : 60120, $bf3b0579824ef26a$var$r = $bf3b0579824ef26a$var$b ? Symbol.for("react.memo") : 60115, $bf3b0579824ef26a$var$t = $bf3b0579824ef26a$var$b ? Symbol.for("react.lazy") : 60116, $bf3b0579824ef26a$var$v = $bf3b0579824ef26a$var$b ? Symbol.for("react.block") : 60121, $bf3b0579824ef26a$var$w = $bf3b0579824ef26a$var$b ? Symbol.for("react.fundamental") : 60117, $bf3b0579824ef26a$var$x = $bf3b0579824ef26a$var$b ? Symbol.for("react.responder") : 60118, $bf3b0579824ef26a$var$y = $bf3b0579824ef26a$var$b ? Symbol.for("react.scope") : 60119;
function $bf3b0579824ef26a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bf3b0579824ef26a$var$c:
                switch(a = a.type, a){
                    case $bf3b0579824ef26a$var$l:
                    case $bf3b0579824ef26a$var$m:
                    case $bf3b0579824ef26a$var$e:
                    case $bf3b0579824ef26a$var$g:
                    case $bf3b0579824ef26a$var$f:
                    case $bf3b0579824ef26a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bf3b0579824ef26a$var$k:
                            case $bf3b0579824ef26a$var$n:
                            case $bf3b0579824ef26a$var$t:
                            case $bf3b0579824ef26a$var$r:
                            case $bf3b0579824ef26a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bf3b0579824ef26a$var$d:
                return u;
        }
    }
}
function $bf3b0579824ef26a$var$A(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$m;
}
$bf3b0579824ef26a$export$2b8d127b894957b9 = $bf3b0579824ef26a$var$l;
$bf3b0579824ef26a$export$cea3a54a6425200c = $bf3b0579824ef26a$var$m;
$bf3b0579824ef26a$export$a7c73072b1a182ae = $bf3b0579824ef26a$var$k;
$bf3b0579824ef26a$export$9f27bc3417b4524d = $bf3b0579824ef26a$var$h;
$bf3b0579824ef26a$export$db77ccec0bb4ccac = $bf3b0579824ef26a$var$c;
$bf3b0579824ef26a$export$8392c0c9d3dcbd35 = $bf3b0579824ef26a$var$n;
$bf3b0579824ef26a$export$ffb0004e005737fa = $bf3b0579824ef26a$var$e;
$bf3b0579824ef26a$export$b624eff549462981 = $bf3b0579824ef26a$var$t;
$bf3b0579824ef26a$export$7897aa7841a5380c = $bf3b0579824ef26a$var$r;
$bf3b0579824ef26a$export$602eac185826482c = $bf3b0579824ef26a$var$d;
$bf3b0579824ef26a$export$e2c29f18771995cb = $bf3b0579824ef26a$var$g;
$bf3b0579824ef26a$export$5f8d39834fd61797 = $bf3b0579824ef26a$var$f;
$bf3b0579824ef26a$export$74bf444e3cd11ea5 = $bf3b0579824ef26a$var$p;
$bf3b0579824ef26a$export$92387174baf9b227 = function(a) {
    return $bf3b0579824ef26a$var$A(a) || $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$l;
};
$bf3b0579824ef26a$export$ec112efeb987d9c6 = $bf3b0579824ef26a$var$A;
$bf3b0579824ef26a$export$b706b080d889d2c9 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$k;
};
$bf3b0579824ef26a$export$5be5a87408f70ddc = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$h;
};
$bf3b0579824ef26a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bf3b0579824ef26a$var$c;
};
$bf3b0579824ef26a$export$455c2e768291efa6 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$n;
};
$bf3b0579824ef26a$export$9522e17588c12572 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$e;
};
$bf3b0579824ef26a$export$2110ac352bb060b9 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$t;
};
$bf3b0579824ef26a$export$56885ab8b9c456ab = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$r;
};
$bf3b0579824ef26a$export$d927fcb6adf8f9de = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$d;
};
$bf3b0579824ef26a$export$b82d16f27459e05a = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$g;
};
$bf3b0579824ef26a$export$522c17b4f5e123e8 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$f;
};
$bf3b0579824ef26a$export$1aabd8a0274ecfd6 = function(a) {
    return $bf3b0579824ef26a$var$z(a) === $bf3b0579824ef26a$var$p;
};
$bf3b0579824ef26a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bf3b0579824ef26a$var$e || a === $bf3b0579824ef26a$var$m || a === $bf3b0579824ef26a$var$g || a === $bf3b0579824ef26a$var$f || a === $bf3b0579824ef26a$var$p || a === $bf3b0579824ef26a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bf3b0579824ef26a$var$t || a.$$typeof === $bf3b0579824ef26a$var$r || a.$$typeof === $bf3b0579824ef26a$var$h || a.$$typeof === $bf3b0579824ef26a$var$k || a.$$typeof === $bf3b0579824ef26a$var$n || a.$$typeof === $bf3b0579824ef26a$var$w || a.$$typeof === $bf3b0579824ef26a$var$x || a.$$typeof === $bf3b0579824ef26a$var$y || a.$$typeof === $bf3b0579824ef26a$var$v);
};
$bf3b0579824ef26a$export$f5bbd400c2f4426f = $bf3b0579824ef26a$var$z;

});

parcelRegister("lBRDc", function(module, exports) {
function $fbb6a7bc8836e7ee$var$_extends() {
    return module.exports = $fbb6a7bc8836e7ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fbb6a7bc8836e7ee$var$_extends.apply(null, arguments);
}
module.exports = $fbb6a7bc8836e7ee$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("33qfW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $239604d2eaf37a70$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $239604d2eaf37a70$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $239604d2eaf37a70$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iSBXh")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("9XmJK")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("9XmJK")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("44xgL")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("oqjrU")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jE0f9 = parcelRequire("jE0f9");

var $gLVll = parcelRequire("gLVll");

var $9XmJK = parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");

var $44xgL = parcelRequire("44xgL");

var $oqjrU = parcelRequire("oqjrU");
'use client';
function $239604d2eaf37a70$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jE0f9.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $239604d2eaf37a70$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $239604d2eaf37a70$var$wrapper = [];
function $239604d2eaf37a70$export$13a2d3ef13012b32(styles) {
    $239604d2eaf37a70$var$wrapper[0] = styles;
    return (0, $gLVll.serializeStyles)($239604d2eaf37a70$var$wrapper);
}

});
parcelRegister("jE0f9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d1f1143f0576fb$export$2e2bcd8739ae039);

var $acdsL = parcelRequire("acdsL");
parcelRequire("lBRDc");

parcelRequire("gLVll");
parcelRequire("gwJ0Y");
parcelRequire("i1Adn");
parcelRequire("8NFma");
parcelRequire("hcFfS");
var $e4d1f1143f0576fb$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $e4d1f1143f0576fb$export$2e2bcd8739ae039 = (0, $acdsL.default).bind(null);
$e4d1f1143f0576fb$var$tags.forEach(function(tagName) {
    $e4d1f1143f0576fb$export$2e2bcd8739ae039[tagName] = $e4d1f1143f0576fb$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("acdsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c577d4a53a87dd$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");
parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");

var $gLVll = parcelRequire("gLVll");

var $gwJ0Y = parcelRequire("gwJ0Y");

var $i1Adn = parcelRequire("i1Adn");

var $8NFma = parcelRequire("8NFma");

var $hcFfS = parcelRequire("hcFfS");
var $76c577d4a53a87dd$var$isBrowser = typeof document !== 'undefined';
var $76c577d4a53a87dd$var$isDevelopment = false;
var $76c577d4a53a87dd$var$testOmitPropsOnStringTag = (0, $hcFfS.default);
var $76c577d4a53a87dd$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $76c577d4a53a87dd$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $76c577d4a53a87dd$var$testOmitPropsOnStringTag : $76c577d4a53a87dd$var$testOmitPropsOnComponent;
};
var $76c577d4a53a87dd$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $76c577d4a53a87dd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $i1Adn.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $i1Adn.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$76c577d4a53a87dd$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $76c577d4a53a87dd$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $76c577d4a53a87dd$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $76c577d4a53a87dd$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $iSBXh.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8NFma.useContext((0, $iSBXh.T));
            }
            if (typeof props.className === 'string') className = (0, $i1Adn.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $gLVll.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $76c577d4a53a87dd$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($76c577d4a53a87dd$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8NFma.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $76c577d4a53a87dd$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $jz4iA.default)({}, options, nextOptions, {
                shouldForwardProp: $76c577d4a53a87dd$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("jz4iA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e49ed681292e30$export$2e2bcd8739ae039);
function $e3e49ed681292e30$export$2e2bcd8739ae039() {
    return $e3e49ed681292e30$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e3e49ed681292e30$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9XmJK", function(module, exports) {

$parcel$export(module.exports, "Global", () => $01dee42c9ca53feb$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $01dee42c9ca53feb$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $01dee42c9ca53feb$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iSBXh")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("iSBXh")).w);

var $iSBXh = parcelRequire("iSBXh");

var $8NFma = parcelRequire("8NFma");

var $i1Adn = parcelRequire("i1Adn");

var $gwJ0Y = parcelRequire("gwJ0Y");

var $gLVll = parcelRequire("gLVll");
parcelRequire("dMiGn");
parcelRequire("lBRDc");
parcelRequire("dBNhP");

parcelRequire("l3NX5");
var $01dee42c9ca53feb$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $iSBXh.h).call(props, 'css')) return $8NFma.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iSBXh.E);
    createElementArgArray[1] = (0, $iSBXh.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8NFma.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($01dee42c9ca53feb$export$c8a8987d4410bf2d || ($01dee42c9ca53feb$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $01dee42c9ca53feb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $gLVll.serializeStyles)([
        styles
    ], undefined, $8NFma.useContext((0, $iSBXh.T)));
    if (!(0, $iSBXh.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8NFma.useRef();
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gwJ0Y.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $i1Adn.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $01dee42c9ca53feb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gLVll.serializeStyles)(args);
}
function $01dee42c9ca53feb$export$d25ddfdf17c3ad3e() {
    var insertable = $01dee42c9ca53feb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $01dee42c9ca53feb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $01dee42c9ca53feb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $i1Adn.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $01dee42c9ca53feb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $i1Adn.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iSBXh.i) && res !== undefined) rules += res;
        }
        if (!(0, $iSBXh.i)) return rules;
    });
    if (!(0, $iSBXh.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $01dee42c9ca53feb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iSBXh.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $gLVll.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $i1Adn.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iSBXh.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $01dee42c9ca53feb$var$merge(cache.registered, css, $01dee42c9ca53feb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8NFma.useContext((0, $iSBXh.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($01dee42c9ca53feb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("iSBXh", function(module, exports) {

$parcel$export(module.exports, "a", () => $dbeab63edf3287cf$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $dbeab63edf3287cf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $dbeab63edf3287cf$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $dbeab63edf3287cf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $dbeab63edf3287cf$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $dbeab63edf3287cf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $dbeab63edf3287cf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $dbeab63edf3287cf$export$a9c23c6ac3fc3eca);

var $8NFma = parcelRequire("8NFma");

var $dMiGn = parcelRequire("dMiGn");

var $jz4iA = parcelRequire("jz4iA");

var $dBNhP = parcelRequire("dBNhP");

var $69vM6 = parcelRequire("69vM6");

var $i1Adn = parcelRequire("i1Adn");

var $gLVll = parcelRequire("gLVll");

var $gwJ0Y = parcelRequire("gwJ0Y");
var $dbeab63edf3287cf$export$407448d2b89b1813 = false;
var $dbeab63edf3287cf$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $dbeab63edf3287cf$var$EmotionCacheContext = /* #__PURE__ */ $8NFma.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $dMiGn.default)({
    key: 'css'
}) : null);
var $dbeab63edf3287cf$export$e7094788287c5e9b = $dbeab63edf3287cf$var$EmotionCacheContext.Provider;
var $dbeab63edf3287cf$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
};
var $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8NFma.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$dbeab63edf3287cf$export$23f2a1d2818174ef) $dbeab63edf3287cf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8NFma.useContext)($dbeab63edf3287cf$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $dMiGn.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $dbeab63edf3287cf$export$971d5caa766a69d7 = /* #__PURE__ */ $8NFma.createContext({});
var $dbeab63edf3287cf$export$3b14a55fb2447963 = function useTheme() {
    return $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
};
var $dbeab63edf3287cf$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jz4iA.default)({}, outerTheme, theme);
};
var $dbeab63edf3287cf$var$createCacheWithTheme = /* #__PURE__ */ (0, $dBNhP.default)(function(outerTheme) {
    return (0, $dBNhP.default)(function(theme) {
        return $dbeab63edf3287cf$var$getTheme(outerTheme, theme);
    });
});
var $dbeab63edf3287cf$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $dbeab63edf3287cf$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $dbeab63edf3287cf$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8NFma.forwardRef(function render(props, ref) {
        var theme = $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8NFma.createElement(Component, (0, $jz4iA.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $69vM6.default)(WithTheme, Component);
}
var $dbeab63edf3287cf$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $dbeab63edf3287cf$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $dbeab63edf3287cf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$dbeab63edf3287cf$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $dbeab63edf3287cf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $i1Adn.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gwJ0Y.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $i1Adn.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$dbeab63edf3287cf$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8NFma.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $dbeab63edf3287cf$var$Emotion = /* #__PURE__ */ $dbeab63edf3287cf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$dbeab63edf3287cf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $i1Adn.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $gLVll.serializeStyles)(registeredStyles, undefined, $8NFma.useContext($dbeab63edf3287cf$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($dbeab63edf3287cf$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $dbeab63edf3287cf$var$typePropName && !$dbeab63edf3287cf$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($dbeab63edf3287cf$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8NFma.createElement(WrappedComponent, newProps));
});
var $dbeab63edf3287cf$export$a9c23c6ac3fc3eca = $dbeab63edf3287cf$var$Emotion;

});
parcelRegister("dMiGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07e4002c0412599$export$2e2bcd8739ae039);

var $2Dt2A = parcelRequire("2Dt2A");

var $5ZhKJ = parcelRequire("5ZhKJ");

var $dBNhP = parcelRequire("dBNhP");

var $b9Xpj = parcelRequire("b9Xpj");
var $a07e4002c0412599$var$isBrowser = typeof document !== 'undefined';
var $a07e4002c0412599$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $5ZhKJ.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $5ZhKJ.token)(character)) break;
        (0, $5ZhKJ.next)();
    }
    return (0, $5ZhKJ.slice)(begin, (0, $5ZhKJ.position));
};
var $a07e4002c0412599$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $5ZhKJ.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $5ZhKJ.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $a07e4002c0412599$var$identifierWithPointTracking((0, $5ZhKJ.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $5ZhKJ.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $5ZhKJ.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5ZhKJ.from)(character);
    }
    while (character = (0, $5ZhKJ.next)());
    return parsed;
};
var $a07e4002c0412599$var$getRules = function getRules(value, points) {
    return (0, $5ZhKJ.dealloc)($a07e4002c0412599$var$toRules((0, $5ZhKJ.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $a07e4002c0412599$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $a07e4002c0412599$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$a07e4002c0412599$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $a07e4002c0412599$var$fixedElements.set(element, true);
    var points = [];
    var rules = $a07e4002c0412599$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $a07e4002c0412599$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $a07e4002c0412599$var$prefix(value, length) {
    switch((0, $5ZhKJ.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $5ZhKJ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $5ZhKJ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MOZ) + value + (0, $5ZhKJ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
        // order
        case 6165:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.replace)(value, /(\w+).+(:[^]+)/, (0, $5ZhKJ.WEBKIT) + 'box-$1$2' + (0, $5ZhKJ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-item-' + (0, $5ZhKJ.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + 'flex-line-pack' + (0, $5ZhKJ.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $5ZhKJ.WEBKIT) + 'box-' + (0, $5ZhKJ.replace)(value, '-grow', '') + (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $5ZhKJ.WEBKIT) + (0, $5ZhKJ.replace)(value, /([^-])(transform)/g, '$1' + (0, $5ZhKJ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(zoom-|grab)/, (0, $5ZhKJ.WEBKIT) + '$1'), /(image-set)/, (0, $5ZhKJ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5ZhKJ.replace)(value, /(image-set\([^]*)/, (0, $5ZhKJ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5ZhKJ.replace)((0, $5ZhKJ.replace)(value, /(.+:)(flex-)?(.*)/, (0, $5ZhKJ.WEBKIT) + 'box-pack:$3' + (0, $5ZhKJ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $5ZhKJ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5ZhKJ.replace)(value, /(.+)-inline(.+)/, (0, $5ZhKJ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5ZhKJ.strlen)(value) - 1 - length > 6) switch((0, $5ZhKJ.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5ZhKJ.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5ZhKJ.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $5ZhKJ.WEBKIT) + '$2-$3' + '$1' + (0, $5ZhKJ.MOZ) + ((0, $5ZhKJ.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5ZhKJ.indexof)(value, 'stretch') ? $a07e4002c0412599$var$prefix((0, $5ZhKJ.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5ZhKJ.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5ZhKJ.charat)(value, (0, $5ZhKJ.strlen)(value) - 3 - (~(0, $5ZhKJ.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5ZhKJ.replace)(value, ':', ':' + (0, $5ZhKJ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5ZhKJ.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $5ZhKJ.WEBKIT) + ((0, $5ZhKJ.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $5ZhKJ.WEBKIT) + '$2$3' + '$1' + (0, $5ZhKJ.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5ZhKJ.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + (0, $5ZhKJ.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $5ZhKJ.WEBKIT) + value + (0, $5ZhKJ.MS) + value + value;
    }
    return value;
}
var $a07e4002c0412599$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $5ZhKJ.DECLARATION:
                element["return"] = $a07e4002c0412599$var$prefix(element.value, element.length);
                break;
            case 0, $5ZhKJ.KEYFRAMES:
                return (0, $5ZhKJ.serialize)([
                    (0, $5ZhKJ.copy)(element, {
                        value: (0, $5ZhKJ.replace)(element.value, '@', '@' + (0, $5ZhKJ.WEBKIT))
                    })
                ], callback);
            case 0, $5ZhKJ.RULESET:
                if (element.length) return (0, $5ZhKJ.combine)(element.props, function(value) {
                    switch((0, $5ZhKJ.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(read-\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $5ZhKJ.serialize)([
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, ':' + (0, $5ZhKJ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $5ZhKJ.copy)(element, {
                                    props: [
                                        (0, $5ZhKJ.replace)(value, /:(plac\w+)/, (0, $5ZhKJ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $a07e4002c0412599$var$getServerStylisCache = $a07e4002c0412599$var$isBrowser ? undefined : (0, $dBNhP.default)(function() {
    return (0, $b9Xpj.default)(function() {
        return {};
    });
});
var $a07e4002c0412599$var$defaultStylisPlugins = [
    $a07e4002c0412599$var$prefixer
];
var $a07e4002c0412599$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($a07e4002c0412599$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $a07e4002c0412599$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($a07e4002c0412599$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $a07e4002c0412599$var$compat,
        $a07e4002c0412599$var$removeLabel
    ];
    if (!$a07e4002c0412599$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $5ZhKJ.stringify),
            (0, $5ZhKJ.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $5ZhKJ.stringify)
        ];
        var _serializer = (0, $5ZhKJ.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $5ZhKJ.serialize)((0, $5ZhKJ.compile)(styles), _serializer);
        };
        var serverStylisCache = $a07e4002c0412599$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $2Dt2A.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("2Dt2A", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $1eb5c02cfaf58a20$export$9d753cd7ae895cce);
var $1eb5c02cfaf58a20$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $1eb5c02cfaf58a20$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $1eb5c02cfaf58a20$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $1eb5c02cfaf58a20$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$1eb5c02cfaf58a20$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($1eb5c02cfaf58a20$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $1eb5c02cfaf58a20$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("5ZhKJ", function(module, exports) {

$parcel$export(module.exports, "MS", () => $e36f1de21b27a557$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $e36f1de21b27a557$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $e36f1de21b27a557$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $e36f1de21b27a557$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $e36f1de21b27a557$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $e36f1de21b27a557$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $e36f1de21b27a557$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $e36f1de21b27a557$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e36f1de21b27a557$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $e36f1de21b27a557$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e36f1de21b27a557$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e36f1de21b27a557$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $e36f1de21b27a557$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $e36f1de21b27a557$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $e36f1de21b27a557$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $e36f1de21b27a557$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $e36f1de21b27a557$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e36f1de21b27a557$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $e36f1de21b27a557$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e36f1de21b27a557$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e36f1de21b27a557$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e36f1de21b27a557$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e36f1de21b27a557$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $e36f1de21b27a557$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $e36f1de21b27a557$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e36f1de21b27a557$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $e36f1de21b27a557$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $e36f1de21b27a557$export$38bcb760f1d4871c);
var $e36f1de21b27a557$export$71ad59f2e432cfe8 = "-ms-";
var $e36f1de21b27a557$export$2c0f367103c8d01c = "-moz-";
var $e36f1de21b27a557$export$39dfd62a25e0fe93 = "-webkit-";
var $e36f1de21b27a557$export$a29989082612d0d9 = "comm";
var $e36f1de21b27a557$export$aa3a2e812ca8570d = "rule";
var $e36f1de21b27a557$export$527d108ccf083c2b = "decl";
var $e36f1de21b27a557$export$d3d35020fa5b54f0 = "@page";
var $e36f1de21b27a557$export$500415a86c544f73 = "@media";
var $e36f1de21b27a557$export$a763edbf796b780a = "@import";
var $e36f1de21b27a557$export$2790aeb8b4e5c826 = "@charset";
var $e36f1de21b27a557$export$1cc683e23b84b133 = "@viewport";
var $e36f1de21b27a557$export$9447a5efea57e862 = "@supports";
var $e36f1de21b27a557$export$ef011b4e114b1fba = "@document";
var $e36f1de21b27a557$export$6aad947bda0f3f46 = "@namespace";
var $e36f1de21b27a557$export$b44a8529a35fcb60 = "@keyframes";
var $e36f1de21b27a557$export$2c16de31893252e6 = "@font-face";
var $e36f1de21b27a557$export$3d846dd52e150c6f = "@counter-style";
var $e36f1de21b27a557$export$22314bfbb57653fe = "@font-feature-values";
var $e36f1de21b27a557$export$d773506282b3cfe6 = "@layer";
var $e36f1de21b27a557$export$2335f513bbd82c6d = Math.abs;
var $e36f1de21b27a557$export$6788812c4e6611e6 = String.fromCharCode;
var $e36f1de21b27a557$export$e6e34fd1f2686227 = Object.assign;
function $e36f1de21b27a557$export$d6af199866bfb566(e, r) {
    return $e36f1de21b27a557$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 0)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 1)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 2)) << 2 ^ $e36f1de21b27a557$export$a9db5e087081082d(e, 3) : 0;
}
function $e36f1de21b27a557$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e36f1de21b27a557$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e36f1de21b27a557$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e36f1de21b27a557$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e36f1de21b27a557$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e36f1de21b27a557$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e36f1de21b27a557$export$36776f635604f274(e) {
    return e.length;
}
function $e36f1de21b27a557$export$f9084667e487ed46(e) {
    return e.length;
}
function $e36f1de21b27a557$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e36f1de21b27a557$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e36f1de21b27a557$export$53f1d5ea8de3d7c = 1;
var $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1;
var $e36f1de21b27a557$export$f24224f1c91d8156 = 0;
var $e36f1de21b27a557$export$5880b8b5730aff45 = 0;
var $e36f1de21b27a557$export$c0306caf338ac095 = 0;
var $e36f1de21b27a557$export$30a86d91af8ff6e6 = "";
function $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e36f1de21b27a557$export$53f1d5ea8de3d7c,
        column: $e36f1de21b27a557$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e36f1de21b27a557$export$784d13d8ee351f07(e, r) {
    return $e36f1de21b27a557$export$e6e34fd1f2686227($e36f1de21b27a557$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e36f1de21b27a557$export$eba6f6f03b0a92e7() {
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$232faf9add678146() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 > 0 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, --$e36f1de21b27a557$export$5880b8b5730aff45) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3--, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c--;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$48cfd1e771a65c4f() {
    $e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$5880b8b5730aff45 < $e36f1de21b27a557$export$f24224f1c91d8156 ? $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45++) : 0;
    if ($e36f1de21b27a557$export$4e0c71f277ca26b3++, $e36f1de21b27a557$export$c0306caf338ac095 === 10) $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$53f1d5ea8de3d7c++;
    return $e36f1de21b27a557$export$c0306caf338ac095;
}
function $e36f1de21b27a557$export$4d3fb11e950abb9e() {
    return $e36f1de21b27a557$export$a9db5e087081082d($e36f1de21b27a557$export$30a86d91af8ff6e6, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$e88cb2efb12ae807() {
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$58adb3bec8346d0f(e, r) {
    return $e36f1de21b27a557$export$2f35ab04d2335697($e36f1de21b27a557$export$30a86d91af8ff6e6, e, r);
}
function $e36f1de21b27a557$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e36f1de21b27a557$export$2de70f21292aac9e(e) {
    return $e36f1de21b27a557$export$53f1d5ea8de3d7c = $e36f1de21b27a557$export$4e0c71f277ca26b3 = 1, $e36f1de21b27a557$export$f24224f1c91d8156 = $e36f1de21b27a557$export$36776f635604f274($e36f1de21b27a557$export$30a86d91af8ff6e6 = e), $e36f1de21b27a557$export$5880b8b5730aff45 = 0, [];
}
function $e36f1de21b27a557$export$45918ac1574455b1(e) {
    return $e36f1de21b27a557$export$30a86d91af8ff6e6 = "", e;
}
function $e36f1de21b27a557$export$410ac95b9ec204b8(e) {
    return $e36f1de21b27a557$export$87c2784dc9fc4ab($e36f1de21b27a557$export$58adb3bec8346d0f($e36f1de21b27a557$export$5880b8b5730aff45 - 1, $e36f1de21b27a557$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e36f1de21b27a557$export$660b2ee2d4fb4eff(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$5f8c09e3ae6f64e1($e36f1de21b27a557$export$2de70f21292aac9e(e)));
}
function $e36f1de21b27a557$export$7af1228ff777d175(e) {
    while($e36f1de21b27a557$export$c0306caf338ac095 = $e36f1de21b27a557$export$4d3fb11e950abb9e())if ($e36f1de21b27a557$export$c0306caf338ac095 < 33) $e36f1de21b27a557$export$48cfd1e771a65c4f();
    else break;
    return $e36f1de21b27a557$export$9e1725a4cfeada27(e) > 2 || $e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e36f1de21b27a557$export$5f8c09e3ae6f64e1(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$c0306caf338ac095)){
        case 0:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$c0306caf338ac095), e);
            break;
        default:
            $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$c0306caf338ac095), e);
    }
    return e;
}
function $e36f1de21b27a557$export$955ba06d119e085e(e, r) {
    while(--r && $e36f1de21b27a557$export$48cfd1e771a65c4f())if ($e36f1de21b27a557$export$c0306caf338ac095 < 48 || $e36f1de21b27a557$export$c0306caf338ac095 > 102 || $e36f1de21b27a557$export$c0306caf338ac095 > 57 && $e36f1de21b27a557$export$c0306caf338ac095 < 65 || $e36f1de21b27a557$export$c0306caf338ac095 > 70 && $e36f1de21b27a557$export$c0306caf338ac095 < 97) break;
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$e88cb2efb12ae807() + (r < 6 && $e36f1de21b27a557$export$4d3fb11e950abb9e() == 32 && $e36f1de21b27a557$export$48cfd1e771a65c4f() == 32));
}
function $e36f1de21b27a557$export$c889f2fcc19dbf12(e) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())switch($e36f1de21b27a557$export$c0306caf338ac095){
        case e:
            return $e36f1de21b27a557$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e36f1de21b27a557$export$c889f2fcc19dbf12($e36f1de21b27a557$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e36f1de21b27a557$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e36f1de21b27a557$export$48cfd1e771a65c4f();
            break;
    }
    return $e36f1de21b27a557$export$5880b8b5730aff45;
}
function $e36f1de21b27a557$export$4254d4e2b3745c4c(e, r) {
    while($e36f1de21b27a557$export$48cfd1e771a65c4f())if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 57) break;
    else if (e + $e36f1de21b27a557$export$c0306caf338ac095 === 84 && $e36f1de21b27a557$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e36f1de21b27a557$export$58adb3bec8346d0f(r, $e36f1de21b27a557$export$5880b8b5730aff45 - 1) + "*" + $e36f1de21b27a557$export$6788812c4e6611e6(e === 47 ? e : $e36f1de21b27a557$export$48cfd1e771a65c4f());
}
function $e36f1de21b27a557$export$c2ab62c7bf24634(e) {
    while(!$e36f1de21b27a557$export$9e1725a4cfeada27($e36f1de21b27a557$export$4d3fb11e950abb9e()))$e36f1de21b27a557$export$48cfd1e771a65c4f();
    return $e36f1de21b27a557$export$58adb3bec8346d0f(e, $e36f1de21b27a557$export$5880b8b5730aff45);
}
function $e36f1de21b27a557$export$ef7acd7185315e22(e) {
    return $e36f1de21b27a557$export$45918ac1574455b1($e36f1de21b27a557$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e36f1de21b27a557$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e36f1de21b27a557$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e36f1de21b27a557$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e36f1de21b27a557$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e36f1de21b27a557$export$f8e21b1e77979a08(j += $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e36f1de21b27a557$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e36f1de21b27a557$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e36f1de21b27a557$export$955ba06d119e085e($e36f1de21b27a557$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e36f1de21b27a557$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$4a34f930e789283c($e36f1de21b27a557$export$4254d4e2b3745c4c($e36f1de21b27a557$export$48cfd1e771a65c4f(), $e36f1de21b27a557$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e36f1de21b27a557$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e36f1de21b27a557$export$36776f635604f274(j) - l) $e36f1de21b27a557$export$10d8903dec122b9d(p > 32 ? $e36f1de21b27a557$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e36f1de21b27a557$export$f8483753829ec8f3($e36f1de21b27a557$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e36f1de21b27a557$export$10d8903dec122b9d(y = $e36f1de21b27a557$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e36f1de21b27a557$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e36f1de21b27a557$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e36f1de21b27a557$export$98e6a39c04603d36(e, y, y, n && $e36f1de21b27a557$export$10d8903dec122b9d($e36f1de21b27a557$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e36f1de21b27a557$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e36f1de21b27a557$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e36f1de21b27a557$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e36f1de21b27a557$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e36f1de21b27a557$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e36f1de21b27a557$export$4d3fb11e950abb9e() === 45) j += $e36f1de21b27a557$export$410ac95b9ec204b8($e36f1de21b27a557$export$48cfd1e771a65c4f());
                    v = $e36f1de21b27a557$export$4d3fb11e950abb9e(), o = l = $e36f1de21b27a557$export$36776f635604f274(g = j += $e36f1de21b27a557$export$c2ab62c7bf24634($e36f1de21b27a557$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e36f1de21b27a557$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e36f1de21b27a557$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e36f1de21b27a557$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e36f1de21b27a557$export$2f35ab04d2335697(e, v + 1, v = $e36f1de21b27a557$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e36f1de21b27a557$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e36f1de21b27a557$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, s === 0 ? $e36f1de21b27a557$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e36f1de21b27a557$export$4a34f930e789283c(e, r, a) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$a29989082612d0d9, $e36f1de21b27a557$export$6788812c4e6611e6($e36f1de21b27a557$export$eba6f6f03b0a92e7()), $e36f1de21b27a557$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e36f1de21b27a557$export$f8483753829ec8f3(e, r, a, n) {
    return $e36f1de21b27a557$export$35059013cd4a06db(e, r, a, $e36f1de21b27a557$export$527d108ccf083c2b, $e36f1de21b27a557$export$2f35ab04d2335697(e, 0, n), $e36f1de21b27a557$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e36f1de21b27a557$export$82e9f45cca5ba907(n, c, s) {
    switch($e36f1de21b27a557$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e36f1de21b27a557$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$2c0f367103c8d01c + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-$1$2" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-item-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-line-pack" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-" + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e36f1de21b27a557$export$39dfd62a25e0fe93 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "box-pack:$3" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e36f1de21b27a557$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e36f1de21b27a557$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-column-align" + $e36f1de21b27a557$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e36f1de21b27a557$export$f8e21b1e77979a08(s, "span") ? $e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) : +$e36f1de21b27a557$export$4659b591c19bdf3d(s, /\d+/) - +$e36f1de21b27a557$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e36f1de21b27a557$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e36f1de21b27a557$export$71ad59f2e432cfe8 + $e36f1de21b27a557$export$77ad94ebf1c2b9ed($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e36f1de21b27a557$export$36776f635604f274(n) - 1 - c > 6) switch($e36f1de21b27a557$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e36f1de21b27a557$export$2c0f367103c8d01c + ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e36f1de21b27a557$export$f8e21b1e77979a08(n, "stretch") ? $e36f1de21b27a557$export$82e9f45cca5ba907($e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e36f1de21b27a557$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e36f1de21b27a557$export$a9db5e087081082d(n, c + 6) === 121) return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e36f1de21b27a557$export$a9db5e087081082d(n, $e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + ($e36f1de21b27a557$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e36f1de21b27a557$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, ":", ":" + $e36f1de21b27a557$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e36f1de21b27a557$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e36f1de21b27a557$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e36f1de21b27a557$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e36f1de21b27a557$export$a763edbf796b780a:
        case $e36f1de21b27a557$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e36f1de21b27a557$export$a29989082612d0d9:
            return "";
        case $e36f1de21b27a557$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e36f1de21b27a557$export$36776f635604f274(a = $e36f1de21b27a557$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e36f1de21b27a557$export$5a7767152ae0305f(e) {
    var r = $e36f1de21b27a557$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e36f1de21b27a557$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e36f1de21b27a557$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e36f1de21b27a557$export$527d108ccf083c2b:
                n.return = $e36f1de21b27a557$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e36f1de21b27a557$export$b44a8529a35fcb60:
                return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                    $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                        value: $e36f1de21b27a557$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e36f1de21b27a557$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e36f1de21b27a557$export$aa3a2e812ca8570d:
                if (n.length) return $e36f1de21b27a557$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e36f1de21b27a557$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e36f1de21b27a557$export$dfdc1655ccc5b9cb([
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e36f1de21b27a557$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e36f1de21b27a557$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e36f1de21b27a557$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e36f1de21b27a557$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e36f1de21b27a557$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e36f1de21b27a557$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e36f1de21b27a557$export$1be1fc439b849fdf($e36f1de21b27a557$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e36f1de21b27a557$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e36f1de21b27a557$export$2f35ab04d2335697(r, 1, $e36f1de21b27a557$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e36f1de21b27a557$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e36f1de21b27a557$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e36f1de21b27a557$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("dBNhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e84f658cb2e4b7e$export$2e2bcd8739ae039);
var $9e84f658cb2e4b7e$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("b9Xpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $81fe9e0845417c5e$export$2e2bcd8739ae039);
function $81fe9e0845417c5e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("69vM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ac3b2531c94e30$export$2e2bcd8739ae039);

var $l3NX5 = parcelRequire("l3NX5");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $47ac3b2531c94e30$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($l3NX5)))(targetComponent, sourceComponent);
};

});
parcelRegister("l3NX5", function(module, exports) {
'use strict';

var $eLJDK = parcelRequire("eLJDK");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$eLJDK.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$eLJDK.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($eLJDK.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component['$$typeof']] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;

});
parcelRegister("eLJDK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gpUM7"));

});



parcelRegister("i1Adn", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $d1f46976782075db$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d1f46976782075db$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d1f46976782075db$export$6f077d94b33a01aa);
var $d1f46976782075db$var$isBrowser = typeof document !== 'undefined';
function $d1f46976782075db$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d1f46976782075db$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d1f46976782075db$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d1f46976782075db$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d1f46976782075db$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$d1f46976782075db$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$d1f46976782075db$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("gLVll", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $c35d8451a28681ad$export$6321afa313b251b5);

var $ei1c3 = parcelRequire("ei1c3");

var $ia3Zd = parcelRequire("ia3Zd");

var $b9Xpj = parcelRequire("b9Xpj");
var $c35d8451a28681ad$var$isDevelopment = false;
var $c35d8451a28681ad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c35d8451a28681ad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c35d8451a28681ad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c35d8451a28681ad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $c35d8451a28681ad$var$processStyleName = /* #__PURE__ */ (0, $b9Xpj.default)(function(styleName) {
    return $c35d8451a28681ad$var$isCustomProperty(styleName) ? styleName : styleName.replace($c35d8451a28681ad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $c35d8451a28681ad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($c35d8451a28681ad$var$animationRegex, function(match, p1, p2) {
                $c35d8451a28681ad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c35d8451a28681ad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $ia3Zd.default)[key] !== 1 && !$c35d8451a28681ad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $c35d8451a28681ad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $c35d8451a28681ad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $c35d8451a28681ad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c35d8451a28681ad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c35d8451a28681ad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $c35d8451a28681ad$var$cursor;
                var result = interpolation(mergedProps);
                $c35d8451a28681ad$var$cursor = previousCursor;
                return $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $c35d8451a28681ad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($c35d8451a28681ad$var$isProcessableValue(asString)) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $c35d8451a28681ad$var$isDevelopment) throw new Error($c35d8451a28681ad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($c35d8451a28681ad$var$isProcessableValue(value[_i])) string += $c35d8451a28681ad$var$processStyleName(key) + ":" + $c35d8451a28681ad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $c35d8451a28681ad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $c35d8451a28681ad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $c35d8451a28681ad$var$cursor;
function $c35d8451a28681ad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $c35d8451a28681ad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c35d8451a28681ad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $c35d8451a28681ad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c35d8451a28681ad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ei1c3.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c35d8451a28681ad$var$cursor
    };
}

});
parcelRegister("ei1c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a673ac1d41d20e76$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a673ac1d41d20e76$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("ia3Zd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38c40c43cea0c69$export$2e2bcd8739ae039);
var $d38c40c43cea0c69$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gwJ0Y", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $c0828d75d37a5f18$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $c0828d75d37a5f18$export$811a713a7276cb9d);

var $8NFma = parcelRequire("8NFma");
var $c0828d75d37a5f18$var$isBrowser = typeof document !== 'undefined';
var $c0828d75d37a5f18$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c0828d75d37a5f18$var$useInsertionEffect = $8NFma.useInsertionEffect ? $8NFma.useInsertionEffect : false;
var $c0828d75d37a5f18$export$db21c7ffa21794e7 = !$c0828d75d37a5f18$var$isBrowser ? $c0828d75d37a5f18$var$syncFallback : $c0828d75d37a5f18$var$useInsertionEffect || $c0828d75d37a5f18$var$syncFallback;
var $c0828d75d37a5f18$export$811a713a7276cb9d = $c0828d75d37a5f18$var$useInsertionEffect || $8NFma.useLayoutEffect;

});



parcelRegister("hcFfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8638f08acca5456$export$2e2bcd8739ae039);

var $b9Xpj = parcelRequire("b9Xpj");
// eslint-disable-next-line no-undef
var $c8638f08acca5456$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c8638f08acca5456$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $b9Xpj.default)(function(prop) {
    return $c8638f08acca5456$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("44xgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7157c49935287f$export$2e2bcd8739ae039);

var $8NFma = parcelRequire("8NFma");


var $iSBXh = parcelRequire("iSBXh");

var $dMiGn = parcelRequire("dMiGn");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $2f7157c49935287f$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $dMiGn.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $2f7157c49935287f$var$cacheMap = new Map();
function $2f7157c49935287f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8NFma.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $2f7157c49935287f$var$cacheMap.has(cacheKey)) return $2f7157c49935287f$var$cacheMap.get(cacheKey);
        const fresh = $2f7157c49935287f$var$getCache(injectFirst, enableCssLayer);
        $2f7157c49935287f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $iSBXh.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("1IdZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89wqa"));

});


parcelRegister("oqjrU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0496a728bfd60082$export$2e2bcd8739ae039);
parcelRequire("8NFma");


var $9XmJK = parcelRequire("9XmJK");

var $1IdZj = parcelRequire("1IdZj");
'use client';
function $0496a728bfd60082$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $0496a728bfd60082$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($0496a728bfd60082$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9XmJK.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("6oOAi", function(module, exports) {
function $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lLrTz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("em3Bd")).default);

var $em3Bd = parcelRequire("em3Bd");

});
parcelRegister("em3Bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a735e97f62346f26$export$2e2bcd8739ae039);

var $6T5ne = parcelRequire("6T5ne");
function $a735e97f62346f26$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $6T5ne.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("kpMWV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5FZXi")).default);

var $5FZXi = parcelRequire("5FZXi");
$parcel$exportWildcard(module.exports, $5FZXi);

});
parcelRegister("5FZXi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $4220d721651e98d2$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $4220d721651e98d2$export$2e2bcd8739ae039);

var $1TAMD = parcelRequire("1TAMD");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $4220d721651e98d2$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $4220d721651e98d2$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($4220d721651e98d2$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $4220d721651e98d2$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $4220d721651e98d2$export$aad197c7121a6651(Component) || fallback;
}
function $4220d721651e98d2$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $4220d721651e98d2$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $4220d721651e98d2$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $4220d721651e98d2$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $1TAMD.ForwardRef:
            return $4220d721651e98d2$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $1TAMD.Memo:
            return $4220d721651e98d2$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("1TAMD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cGq6Z"));

});
parcelRegister("cGq6Z", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $93bda98a65f2a027$export$a7c73072b1a182ae, (v) => $93bda98a65f2a027$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $93bda98a65f2a027$export$9f27bc3417b4524d, (v) => $93bda98a65f2a027$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $93bda98a65f2a027$export$db77ccec0bb4ccac, (v) => $93bda98a65f2a027$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $93bda98a65f2a027$export$8392c0c9d3dcbd35, (v) => $93bda98a65f2a027$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $93bda98a65f2a027$export$ffb0004e005737fa, (v) => $93bda98a65f2a027$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $93bda98a65f2a027$export$b624eff549462981, (v) => $93bda98a65f2a027$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $93bda98a65f2a027$export$7897aa7841a5380c, (v) => $93bda98a65f2a027$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $93bda98a65f2a027$export$602eac185826482c, (v) => $93bda98a65f2a027$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $93bda98a65f2a027$export$e2c29f18771995cb, (v) => $93bda98a65f2a027$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $93bda98a65f2a027$export$5f8d39834fd61797, (v) => $93bda98a65f2a027$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $93bda98a65f2a027$export$74bf444e3cd11ea5, (v) => $93bda98a65f2a027$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $93bda98a65f2a027$export$998bcd577473dd93, (v) => $93bda98a65f2a027$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $93bda98a65f2a027$export$b706b080d889d2c9, (v) => $93bda98a65f2a027$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $93bda98a65f2a027$export$5be5a87408f70ddc, (v) => $93bda98a65f2a027$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $93bda98a65f2a027$export$45a5e7f76e0caa8d, (v) => $93bda98a65f2a027$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $93bda98a65f2a027$export$455c2e768291efa6, (v) => $93bda98a65f2a027$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $93bda98a65f2a027$export$9522e17588c12572, (v) => $93bda98a65f2a027$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $93bda98a65f2a027$export$2110ac352bb060b9, (v) => $93bda98a65f2a027$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $93bda98a65f2a027$export$56885ab8b9c456ab, (v) => $93bda98a65f2a027$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $93bda98a65f2a027$export$d927fcb6adf8f9de, (v) => $93bda98a65f2a027$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $93bda98a65f2a027$export$b82d16f27459e05a, (v) => $93bda98a65f2a027$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $93bda98a65f2a027$export$522c17b4f5e123e8, (v) => $93bda98a65f2a027$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $93bda98a65f2a027$export$1aabd8a0274ecfd6, (v) => $93bda98a65f2a027$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $93bda98a65f2a027$export$3d6c20d97e46b957, (v) => $93bda98a65f2a027$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $93bda98a65f2a027$export$9b621391a187a31a, (v) => $93bda98a65f2a027$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $93bda98a65f2a027$export$f5bbd400c2f4426f, (v) => $93bda98a65f2a027$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $93bda98a65f2a027$export$a7c73072b1a182ae;
var $93bda98a65f2a027$export$9f27bc3417b4524d;
var $93bda98a65f2a027$export$db77ccec0bb4ccac;
var $93bda98a65f2a027$export$8392c0c9d3dcbd35;
var $93bda98a65f2a027$export$ffb0004e005737fa;
var $93bda98a65f2a027$export$b624eff549462981;
var $93bda98a65f2a027$export$7897aa7841a5380c;
var $93bda98a65f2a027$export$602eac185826482c;
var $93bda98a65f2a027$export$e2c29f18771995cb;
var $93bda98a65f2a027$export$5f8d39834fd61797;
var $93bda98a65f2a027$export$74bf444e3cd11ea5;
var $93bda98a65f2a027$export$998bcd577473dd93;
var $93bda98a65f2a027$export$b706b080d889d2c9;
var $93bda98a65f2a027$export$5be5a87408f70ddc;
var $93bda98a65f2a027$export$45a5e7f76e0caa8d;
var $93bda98a65f2a027$export$455c2e768291efa6;
var $93bda98a65f2a027$export$9522e17588c12572;
var $93bda98a65f2a027$export$2110ac352bb060b9;
var $93bda98a65f2a027$export$56885ab8b9c456ab;
var $93bda98a65f2a027$export$d927fcb6adf8f9de;
var $93bda98a65f2a027$export$b82d16f27459e05a;
var $93bda98a65f2a027$export$522c17b4f5e123e8;
var $93bda98a65f2a027$export$1aabd8a0274ecfd6;
var $93bda98a65f2a027$export$3d6c20d97e46b957;
var $93bda98a65f2a027$export$9b621391a187a31a;
var $93bda98a65f2a027$export$f5bbd400c2f4426f;
"use strict";
var $93bda98a65f2a027$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $93bda98a65f2a027$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $93bda98a65f2a027$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $93bda98a65f2a027$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $93bda98a65f2a027$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $93bda98a65f2a027$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $93bda98a65f2a027$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $93bda98a65f2a027$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $93bda98a65f2a027$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $93bda98a65f2a027$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $93bda98a65f2a027$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE:
                    case $93bda98a65f2a027$var$REACT_PROFILER_TYPE:
                    case $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE:
                    case $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE:
                    case $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE:
                    case $93bda98a65f2a027$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $93bda98a65f2a027$var$REACT_CONTEXT_TYPE:
                            case $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE:
                            case $93bda98a65f2a027$var$REACT_LAZY_TYPE:
                            case $93bda98a65f2a027$var$REACT_MEMO_TYPE:
                                return object;
                            case $93bda98a65f2a027$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $93bda98a65f2a027$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$93bda98a65f2a027$export$a7c73072b1a182ae = $93bda98a65f2a027$var$REACT_CONSUMER_TYPE;
$93bda98a65f2a027$export$9f27bc3417b4524d = $93bda98a65f2a027$var$REACT_CONTEXT_TYPE;
$93bda98a65f2a027$export$db77ccec0bb4ccac = $93bda98a65f2a027$var$REACT_ELEMENT_TYPE;
$93bda98a65f2a027$export$8392c0c9d3dcbd35 = $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE;
$93bda98a65f2a027$export$ffb0004e005737fa = $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE;
$93bda98a65f2a027$export$b624eff549462981 = $93bda98a65f2a027$var$REACT_LAZY_TYPE;
$93bda98a65f2a027$export$7897aa7841a5380c = $93bda98a65f2a027$var$REACT_MEMO_TYPE;
$93bda98a65f2a027$export$602eac185826482c = $93bda98a65f2a027$var$REACT_PORTAL_TYPE;
$93bda98a65f2a027$export$e2c29f18771995cb = $93bda98a65f2a027$var$REACT_PROFILER_TYPE;
$93bda98a65f2a027$export$5f8d39834fd61797 = $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE;
$93bda98a65f2a027$export$74bf444e3cd11ea5 = $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE;
$93bda98a65f2a027$export$998bcd577473dd93 = $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE;
$93bda98a65f2a027$export$b706b080d889d2c9 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_CONSUMER_TYPE;
};
$93bda98a65f2a027$export$5be5a87408f70ddc = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_CONTEXT_TYPE;
};
$93bda98a65f2a027$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $93bda98a65f2a027$var$REACT_ELEMENT_TYPE;
};
$93bda98a65f2a027$export$455c2e768291efa6 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE;
};
$93bda98a65f2a027$export$9522e17588c12572 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE;
};
$93bda98a65f2a027$export$2110ac352bb060b9 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_LAZY_TYPE;
};
$93bda98a65f2a027$export$56885ab8b9c456ab = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_MEMO_TYPE;
};
$93bda98a65f2a027$export$d927fcb6adf8f9de = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_PORTAL_TYPE;
};
$93bda98a65f2a027$export$b82d16f27459e05a = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_PROFILER_TYPE;
};
$93bda98a65f2a027$export$522c17b4f5e123e8 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE;
};
$93bda98a65f2a027$export$1aabd8a0274ecfd6 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE;
};
$93bda98a65f2a027$export$3d6c20d97e46b957 = function(object) {
    return $93bda98a65f2a027$var$typeOf(object) === $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE;
};
$93bda98a65f2a027$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $93bda98a65f2a027$var$REACT_FRAGMENT_TYPE || type === $93bda98a65f2a027$var$REACT_PROFILER_TYPE || type === $93bda98a65f2a027$var$REACT_STRICT_MODE_TYPE || type === $93bda98a65f2a027$var$REACT_SUSPENSE_TYPE || type === $93bda98a65f2a027$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $93bda98a65f2a027$var$REACT_LAZY_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_MEMO_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CONTEXT_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CONSUMER_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $93bda98a65f2a027$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$93bda98a65f2a027$export$f5bbd400c2f4426f = $93bda98a65f2a027$var$typeOf;

});




parcelRegister("bnNVB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1l95P")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("f8DLr")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("chQYm")).default);

var $1l95P = parcelRequire("1l95P");

var $f8DLr = parcelRequire("f8DLr");

var $chQYm = parcelRequire("chQYm");

});
parcelRegister("1l95P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9ece443838697b$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");

var $f8DLr = parcelRequire("f8DLr");

var $j3j6y = parcelRequire("j3j6y");

var $4EcDD = parcelRequire("4EcDD");

var $aobdI = parcelRequire("aobdI");

var $4ZuKt = parcelRequire("4ZuKt");

var $chQYm = parcelRequire("chQYm");
const $0f9ece443838697b$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $0f9ece443838697b$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hQtye.default)(options, $0f9ece443838697b$var$_excluded);
    const breakpoints = (0, $f8DLr.default)(breakpointsInput);
    const spacing = (0, $4EcDD.default)(spacingInput);
    let muiTheme = (0, $5eWZU.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $jz4iA.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $jz4iA.default)({}, (0, $j3j6y.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $chQYm.default);
    muiTheme = args.reduce((acc, argument)=>(0, $5eWZU.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $jz4iA.default)({}, (0, $4ZuKt.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aobdI.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $0f9ece443838697b$export$2e2bcd8739ae039 = $0f9ece443838697b$var$createTheme;

});
parcelRegister("hQtye", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfde373be945f92b$export$2e2bcd8739ae039);
function $cfde373be945f92b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("5eWZU", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $3d0c0639d3a1b210$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $3d0c0639d3a1b210$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");
function $3d0c0639d3a1b210$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $3d0c0639d3a1b210$var$deepClone(source) {
    if (/*#__PURE__*/ $8NFma.isValidElement(source) || !$3d0c0639d3a1b210$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $3d0c0639d3a1b210$var$deepClone(source[key]);
    });
    return output;
}
function $3d0c0639d3a1b210$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $jz4iA.default)({}, target) : target;
    if ($3d0c0639d3a1b210$export$53b83ca8eaab0383(target) && $3d0c0639d3a1b210$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $8NFma.isValidElement(source[key])) output[key] = source[key];
        else if ($3d0c0639d3a1b210$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $3d0c0639d3a1b210$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $3d0c0639d3a1b210$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $3d0c0639d3a1b210$export$53b83ca8eaab0383(source[key]) ? $3d0c0639d3a1b210$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("f8DLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05672b1f29fe83d$export$2e2bcd8739ae039);

var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");
const $b05672b1f29fe83d$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $b05672b1f29fe83d$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $b05672b1f29fe83d$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $jz4iA.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $b05672b1f29fe83d$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $hQtye.default)(breakpoints, $b05672b1f29fe83d$var$_excluded);
    const sortedValues = $b05672b1f29fe83d$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $jz4iA.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("j3j6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $dded1deb3d18245c$export$2e2bcd8739ae039);
const $dded1deb3d18245c$var$shape = {
    borderRadius: 4
};
var $dded1deb3d18245c$export$2e2bcd8739ae039 = $dded1deb3d18245c$var$shape;

});

parcelRegister("4EcDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3624b38e4bb35628$export$2e2bcd8739ae039);

var $6mCcy = parcelRequire("6mCcy");
function $3624b38e4bb35628$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $6mCcy.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("6mCcy", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $4a226e2d766ef610$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $4a226e2d766ef610$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $4a226e2d766ef610$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $4a226e2d766ef610$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $4a226e2d766ef610$export$6f98e8eaf0be1996);


var $iCSOB = parcelRequire("iCSOB");

var $ddfZG = parcelRequire("ddfZG");

var $03F05 = parcelRequire("03F05");

var $iPGfy = parcelRequire("iPGfy");
const $4a226e2d766ef610$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $4a226e2d766ef610$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $4a226e2d766ef610$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $4a226e2d766ef610$var$getCssProperties = (0, $iPGfy.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($4a226e2d766ef610$var$aliases[prop]) prop = $4a226e2d766ef610$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $4a226e2d766ef610$var$properties[a];
    const direction = $4a226e2d766ef610$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $4a226e2d766ef610$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $4a226e2d766ef610$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $4a226e2d766ef610$var$spacingKeys = [
    ...$4a226e2d766ef610$export$aab52a0dde05ad8a,
    ...$4a226e2d766ef610$export$f8397d44f03ab6ad
];
function $4a226e2d766ef610$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $ddfZG.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $4a226e2d766ef610$export$1def6f833384e3d1(theme) {
    return $4a226e2d766ef610$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $4a226e2d766ef610$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $4a226e2d766ef610$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $4a226e2d766ef610$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $4a226e2d766ef610$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $4a226e2d766ef610$var$getCssProperties(prop);
    const styleFromPropValue = $4a226e2d766ef610$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $iCSOB.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $4a226e2d766ef610$var$style(props, keys) {
    const transformer = $4a226e2d766ef610$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$4a226e2d766ef610$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $03F05.default), {});
}
function $4a226e2d766ef610$export$7ede87f9b603dd3c(props) {
    return $4a226e2d766ef610$var$style(props, $4a226e2d766ef610$export$aab52a0dde05ad8a);
}
$4a226e2d766ef610$export$7ede87f9b603dd3c.propTypes = {};
$4a226e2d766ef610$export$7ede87f9b603dd3c.filterProps = $4a226e2d766ef610$export$aab52a0dde05ad8a;
function $4a226e2d766ef610$export$6f98e8eaf0be1996(props) {
    return $4a226e2d766ef610$var$style(props, $4a226e2d766ef610$export$f8397d44f03ab6ad);
}
$4a226e2d766ef610$export$6f98e8eaf0be1996.propTypes = {};
$4a226e2d766ef610$export$6f98e8eaf0be1996.filterProps = $4a226e2d766ef610$export$f8397d44f03ab6ad;
function $4a226e2d766ef610$var$spacing(props) {
    return $4a226e2d766ef610$var$style(props, $4a226e2d766ef610$var$spacingKeys);
}
$4a226e2d766ef610$var$spacing.propTypes = {};
$4a226e2d766ef610$var$spacing.filterProps = $4a226e2d766ef610$var$spacingKeys;
var $4a226e2d766ef610$export$2e2bcd8739ae039 = $4a226e2d766ef610$var$spacing;

});
parcelRegister("iCSOB", function(module, exports) {

$parcel$export(module.exports, "values", () => $d8f64bbb8ab6617a$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $d8f64bbb8ab6617a$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $d8f64bbb8ab6617a$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $d8f64bbb8ab6617a$export$8922c90b6e020726);

var $jz4iA = parcelRequire("jz4iA");


var $5eWZU = parcelRequire("5eWZU");

var $03F05 = parcelRequire("03F05");
const $d8f64bbb8ab6617a$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $d8f64bbb8ab6617a$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$d8f64bbb8ab6617a$export$68c286be0e7e55b7[key]}px)`
};
function $d8f64bbb8ab6617a$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $d8f64bbb8ab6617a$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $d8f64bbb8ab6617a$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $d8f64bbb8ab6617a$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $d8f64bbb8ab6617a$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $d8f64bbb8ab6617a$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $jz4iA.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $03F05.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $d8f64bbb8ab6617a$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $d8f64bbb8ab6617a$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $d8f64bbb8ab6617a$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $d8f64bbb8ab6617a$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $5eWZU.default)(prev, next), {});
    return $d8f64bbb8ab6617a$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $d8f64bbb8ab6617a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $d8f64bbb8ab6617a$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $d8f64bbb8ab6617a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $d8f64bbb8ab6617a$export$2e2bcd8739ae039 = $d8f64bbb8ab6617a$var$breakpoints;

});
parcelRegister("03F05", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b015c3e00c3a2b$export$2e2bcd8739ae039);

var $5eWZU = parcelRequire("5eWZU");
function $00b015c3e00c3a2b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $5eWZU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $00b015c3e00c3a2b$export$2e2bcd8739ae039 = $00b015c3e00c3a2b$var$merge;

});


parcelRegister("ddfZG", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $99e8e55339f767a7$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $99e8e55339f767a7$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $99e8e55339f767a7$export$2e2bcd8739ae039);

var $em3Bd = parcelRequire("em3Bd");


var $iCSOB = parcelRequire("iCSOB");
function $99e8e55339f767a7$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $99e8e55339f767a7$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $99e8e55339f767a7$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $99e8e55339f767a7$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $99e8e55339f767a7$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $99e8e55339f767a7$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $99e8e55339f767a7$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $em3Bd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $iCSOB.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $99e8e55339f767a7$export$2e2bcd8739ae039 = $99e8e55339f767a7$var$style;

});

parcelRegister("iPGfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5dc3561409bae0$export$2e2bcd8739ae039);
function $db5dc3561409bae0$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("aobdI", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $7904d96217b0a058$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $7904d96217b0a058$export$2e2bcd8739ae039);

var $em3Bd = parcelRequire("em3Bd");

var $03F05 = parcelRequire("03F05");

var $ddfZG = parcelRequire("ddfZG");

var $iCSOB = parcelRequire("iCSOB");

var $4ZuKt = parcelRequire("4ZuKt");
function $7904d96217b0a058$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $7904d96217b0a058$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $7904d96217b0a058$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ddfZG.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ddfZG.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ddfZG.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $em3Bd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $iCSOB.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $4ZuKt.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $iCSOB.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $7904d96217b0a058$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $03F05.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $iCSOB.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($7904d96217b0a058$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $03F05.default)(css, breakpointsValues);
                        }
                    } else css = (0, $03F05.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $iCSOB.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $iCSOB.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $7904d96217b0a058$var$styleFunctionSx = $7904d96217b0a058$export$7d53d8bf2911e013();
$7904d96217b0a058$var$styleFunctionSx.filterProps = [
    'sx'
];
var $7904d96217b0a058$export$2e2bcd8739ae039 = $7904d96217b0a058$var$styleFunctionSx;

});
parcelRegister("4ZuKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a24b5f91ea4c080$export$2e2bcd8739ae039);

var $6mCcy = parcelRequire("6mCcy");

var $co2JT = parcelRequire("co2JT");

var $lEBws = parcelRequire("lEBws");

var $fwzhp = parcelRequire("fwzhp");

var $8K3z2 = parcelRequire("8K3z2");
const $3a24b5f91ea4c080$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $co2JT.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $co2JT.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $fwzhp.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $fwzhp.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $fwzhp.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $6mCcy.padding)
    },
    pt: {
        style: (0, $6mCcy.padding)
    },
    pr: {
        style: (0, $6mCcy.padding)
    },
    pb: {
        style: (0, $6mCcy.padding)
    },
    pl: {
        style: (0, $6mCcy.padding)
    },
    px: {
        style: (0, $6mCcy.padding)
    },
    py: {
        style: (0, $6mCcy.padding)
    },
    padding: {
        style: (0, $6mCcy.padding)
    },
    paddingTop: {
        style: (0, $6mCcy.padding)
    },
    paddingRight: {
        style: (0, $6mCcy.padding)
    },
    paddingBottom: {
        style: (0, $6mCcy.padding)
    },
    paddingLeft: {
        style: (0, $6mCcy.padding)
    },
    paddingX: {
        style: (0, $6mCcy.padding)
    },
    paddingY: {
        style: (0, $6mCcy.padding)
    },
    paddingInline: {
        style: (0, $6mCcy.padding)
    },
    paddingInlineStart: {
        style: (0, $6mCcy.padding)
    },
    paddingInlineEnd: {
        style: (0, $6mCcy.padding)
    },
    paddingBlock: {
        style: (0, $6mCcy.padding)
    },
    paddingBlockStart: {
        style: (0, $6mCcy.padding)
    },
    paddingBlockEnd: {
        style: (0, $6mCcy.padding)
    },
    m: {
        style: (0, $6mCcy.margin)
    },
    mt: {
        style: (0, $6mCcy.margin)
    },
    mr: {
        style: (0, $6mCcy.margin)
    },
    mb: {
        style: (0, $6mCcy.margin)
    },
    ml: {
        style: (0, $6mCcy.margin)
    },
    mx: {
        style: (0, $6mCcy.margin)
    },
    my: {
        style: (0, $6mCcy.margin)
    },
    margin: {
        style: (0, $6mCcy.margin)
    },
    marginTop: {
        style: (0, $6mCcy.margin)
    },
    marginRight: {
        style: (0, $6mCcy.margin)
    },
    marginBottom: {
        style: (0, $6mCcy.margin)
    },
    marginLeft: {
        style: (0, $6mCcy.margin)
    },
    marginX: {
        style: (0, $6mCcy.margin)
    },
    marginY: {
        style: (0, $6mCcy.margin)
    },
    marginInline: {
        style: (0, $6mCcy.margin)
    },
    marginInlineStart: {
        style: (0, $6mCcy.margin)
    },
    marginInlineEnd: {
        style: (0, $6mCcy.margin)
    },
    marginBlock: {
        style: (0, $6mCcy.margin)
    },
    marginBlockStart: {
        style: (0, $6mCcy.margin)
    },
    marginBlockEnd: {
        style: (0, $6mCcy.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $lEBws.gap)
    },
    rowGap: {
        style: (0, $lEBws.rowGap)
    },
    columnGap: {
        style: (0, $lEBws.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8K3z2.sizingTransform)
    },
    maxWidth: {
        style: (0, $8K3z2.maxWidth)
    },
    minWidth: {
        transform: (0, $8K3z2.sizingTransform)
    },
    height: {
        transform: (0, $8K3z2.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8K3z2.sizingTransform)
    },
    minHeight: {
        transform: (0, $8K3z2.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3a24b5f91ea4c080$export$2e2bcd8739ae039 = $3a24b5f91ea4c080$var$defaultSxConfig;

});
parcelRegister("co2JT", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $9049d9e452dd4079$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $9049d9e452dd4079$export$7a57f79000377ca2);


var $ddfZG = parcelRequire("ddfZG");

var $40y76 = parcelRequire("40y76");

var $6mCcy = parcelRequire("6mCcy");

var $iCSOB = parcelRequire("iCSOB");
function $9049d9e452dd4079$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $9049d9e452dd4079$var$createBorderStyle(prop, transform) {
    return (0, $ddfZG.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $9049d9e452dd4079$export$1edee58a52776cd9 = $9049d9e452dd4079$var$createBorderStyle('border', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$f9a7b6bd24892946 = $9049d9e452dd4079$var$createBorderStyle('borderTop', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$5abca33e6be905d2 = $9049d9e452dd4079$var$createBorderStyle('borderRight', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$e2ce9f12a980a822 = $9049d9e452dd4079$var$createBorderStyle('borderBottom', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$47658cca1a909427 = $9049d9e452dd4079$var$createBorderStyle('borderLeft', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$e7fb0694ba2404fc = $9049d9e452dd4079$var$createBorderStyle('borderColor');
const $9049d9e452dd4079$export$126a92c968acdb85 = $9049d9e452dd4079$var$createBorderStyle('borderTopColor');
const $9049d9e452dd4079$export$85cc51cb8fbb8c0e = $9049d9e452dd4079$var$createBorderStyle('borderRightColor');
const $9049d9e452dd4079$export$340b0327727f6d1a = $9049d9e452dd4079$var$createBorderStyle('borderBottomColor');
const $9049d9e452dd4079$export$60beef91a985b4bf = $9049d9e452dd4079$var$createBorderStyle('borderLeftColor');
const $9049d9e452dd4079$export$f9258c55612cbed7 = $9049d9e452dd4079$var$createBorderStyle('outline', $9049d9e452dd4079$export$34e2febe53ae29cc);
const $9049d9e452dd4079$export$621fe586efeb64b9 = $9049d9e452dd4079$var$createBorderStyle('outlineColor');
const $9049d9e452dd4079$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $6mCcy.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $6mCcy.getValue)(transformer, propValue)
            });
        return (0, $iCSOB.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$9049d9e452dd4079$export$7a57f79000377ca2.propTypes = {};
$9049d9e452dd4079$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $9049d9e452dd4079$var$borders = (0, $40y76.default)($9049d9e452dd4079$export$1edee58a52776cd9, $9049d9e452dd4079$export$f9a7b6bd24892946, $9049d9e452dd4079$export$5abca33e6be905d2, $9049d9e452dd4079$export$e2ce9f12a980a822, $9049d9e452dd4079$export$47658cca1a909427, $9049d9e452dd4079$export$e7fb0694ba2404fc, $9049d9e452dd4079$export$126a92c968acdb85, $9049d9e452dd4079$export$85cc51cb8fbb8c0e, $9049d9e452dd4079$export$340b0327727f6d1a, $9049d9e452dd4079$export$60beef91a985b4bf, $9049d9e452dd4079$export$7a57f79000377ca2, $9049d9e452dd4079$export$f9258c55612cbed7, $9049d9e452dd4079$export$621fe586efeb64b9);
var $9049d9e452dd4079$export$2e2bcd8739ae039 = $9049d9e452dd4079$var$borders;

});
parcelRegister("40y76", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb19fbcdcfbf857$export$2e2bcd8739ae039);

var $03F05 = parcelRequire("03F05");
function $2eb19fbcdcfbf857$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $03F05.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $2eb19fbcdcfbf857$export$2e2bcd8739ae039 = $2eb19fbcdcfbf857$var$compose;

});


parcelRegister("lEBws", function(module, exports) {

$parcel$export(module.exports, "gap", () => $fc3a7097cddb072d$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $fc3a7097cddb072d$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $fc3a7097cddb072d$export$8a833ffa5f5dbeda);

var $ddfZG = parcelRequire("ddfZG");

var $40y76 = parcelRequire("40y76");

var $6mCcy = parcelRequire("6mCcy");

var $iCSOB = parcelRequire("iCSOB");

const $fc3a7097cddb072d$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $6mCcy.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $6mCcy.getValue)(transformer, propValue)
            });
        return (0, $iCSOB.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$fc3a7097cddb072d$export$5df9adcb0db95e1e.propTypes = {};
$fc3a7097cddb072d$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $fc3a7097cddb072d$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $6mCcy.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $6mCcy.getValue)(transformer, propValue)
            });
        return (0, $iCSOB.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$fc3a7097cddb072d$export$ec60d70ff941a580.propTypes = {};
$fc3a7097cddb072d$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $fc3a7097cddb072d$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $6mCcy.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $6mCcy.getValue)(transformer, propValue)
            });
        return (0, $iCSOB.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$fc3a7097cddb072d$export$8a833ffa5f5dbeda.propTypes = {};
$fc3a7097cddb072d$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $fc3a7097cddb072d$export$baf44164ca3a34e8 = (0, $ddfZG.default)({
    prop: 'gridColumn'
});
const $fc3a7097cddb072d$export$8f7213a1cd01e832 = (0, $ddfZG.default)({
    prop: 'gridRow'
});
const $fc3a7097cddb072d$export$b0e0abbc49ba668 = (0, $ddfZG.default)({
    prop: 'gridAutoFlow'
});
const $fc3a7097cddb072d$export$bcd8b929d4b4142 = (0, $ddfZG.default)({
    prop: 'gridAutoColumns'
});
const $fc3a7097cddb072d$export$e5039a674e14c828 = (0, $ddfZG.default)({
    prop: 'gridAutoRows'
});
const $fc3a7097cddb072d$export$42bd9088661ffb03 = (0, $ddfZG.default)({
    prop: 'gridTemplateColumns'
});
const $fc3a7097cddb072d$export$920682ae05b999bc = (0, $ddfZG.default)({
    prop: 'gridTemplateRows'
});
const $fc3a7097cddb072d$export$1b88fbdd482fd33a = (0, $ddfZG.default)({
    prop: 'gridTemplateAreas'
});
const $fc3a7097cddb072d$export$bdb486e40d52d26f = (0, $ddfZG.default)({
    prop: 'gridArea'
});
const $fc3a7097cddb072d$var$grid = (0, $40y76.default)($fc3a7097cddb072d$export$5df9adcb0db95e1e, $fc3a7097cddb072d$export$ec60d70ff941a580, $fc3a7097cddb072d$export$8a833ffa5f5dbeda, $fc3a7097cddb072d$export$baf44164ca3a34e8, $fc3a7097cddb072d$export$8f7213a1cd01e832, $fc3a7097cddb072d$export$b0e0abbc49ba668, $fc3a7097cddb072d$export$bcd8b929d4b4142, $fc3a7097cddb072d$export$e5039a674e14c828, $fc3a7097cddb072d$export$42bd9088661ffb03, $fc3a7097cddb072d$export$920682ae05b999bc, $fc3a7097cddb072d$export$1b88fbdd482fd33a, $fc3a7097cddb072d$export$bdb486e40d52d26f);
var $fc3a7097cddb072d$export$2e2bcd8739ae039 = $fc3a7097cddb072d$var$grid;

});

parcelRegister("fwzhp", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $b4d53602ebaeea06$export$dbaffd4420ea0ac6);

var $ddfZG = parcelRequire("ddfZG");

var $40y76 = parcelRequire("40y76");
function $b4d53602ebaeea06$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b4d53602ebaeea06$export$35e9368ef982300f = (0, $ddfZG.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b4d53602ebaeea06$export$dbaffd4420ea0ac6
});
const $b4d53602ebaeea06$export$2506f56c10355b33 = (0, $ddfZG.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b4d53602ebaeea06$export$dbaffd4420ea0ac6
});
const $b4d53602ebaeea06$export$8c5a050822fd698c = (0, $ddfZG.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b4d53602ebaeea06$export$dbaffd4420ea0ac6
});
const $b4d53602ebaeea06$var$palette = (0, $40y76.default)($b4d53602ebaeea06$export$35e9368ef982300f, $b4d53602ebaeea06$export$2506f56c10355b33, $b4d53602ebaeea06$export$8c5a050822fd698c);
var $b4d53602ebaeea06$export$2e2bcd8739ae039 = $b4d53602ebaeea06$var$palette;

});

parcelRegister("8K3z2", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $65d5625b16cc5260$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $65d5625b16cc5260$export$488fda99655ff65a);

var $ddfZG = parcelRequire("ddfZG");

var $40y76 = parcelRequire("40y76");

var $iCSOB = parcelRequire("iCSOB");
function $65d5625b16cc5260$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $65d5625b16cc5260$export$7e3df82ee760448c = (0, $ddfZG.default)({
    prop: 'width',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $iCSOB.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $65d5625b16cc5260$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $iCSOB.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$65d5625b16cc5260$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $65d5625b16cc5260$export$ee148fbbe8357dd2 = (0, $ddfZG.default)({
    prop: 'minWidth',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$ac607276a8fe9f0a = (0, $ddfZG.default)({
    prop: 'height',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$dc0d8bd0b94f8570 = (0, $ddfZG.default)({
    prop: 'maxHeight',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$a43cf604e12f3b17 = (0, $ddfZG.default)({
    prop: 'minHeight',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$ffed9f14fb65e276 = (0, $ddfZG.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$905076ed6620e671 = (0, $ddfZG.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $65d5625b16cc5260$export$8afece71750ec241
});
const $65d5625b16cc5260$export$6ccc93f785106a58 = (0, $ddfZG.default)({
    prop: 'boxSizing'
});
const $65d5625b16cc5260$var$sizing = (0, $40y76.default)($65d5625b16cc5260$export$7e3df82ee760448c, $65d5625b16cc5260$export$488fda99655ff65a, $65d5625b16cc5260$export$ee148fbbe8357dd2, $65d5625b16cc5260$export$ac607276a8fe9f0a, $65d5625b16cc5260$export$dc0d8bd0b94f8570, $65d5625b16cc5260$export$a43cf604e12f3b17, $65d5625b16cc5260$export$6ccc93f785106a58);
var $65d5625b16cc5260$export$2e2bcd8739ae039 = $65d5625b16cc5260$var$sizing;

});



parcelRegister("chQYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f2029d35a5dbe6e$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $8f2029d35a5dbe6e$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("TjE6F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aobdI")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("aobdI")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("3JC4a")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("4ZuKt")).default);

var $aobdI = parcelRequire("aobdI");

var $3JC4a = parcelRequire("3JC4a");

var $4ZuKt = parcelRequire("4ZuKt");

});
parcelRegister("3JC4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b831a340c9d944a$export$2e2bcd8739ae039);

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");

var $4ZuKt = parcelRequire("4ZuKt");
const $2b831a340c9d944a$var$_excluded = [
    "sx"
];
const $2b831a340c9d944a$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $4ZuKt.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $2b831a340c9d944a$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hQtye.default)(props, $2b831a340c9d944a$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $2b831a340c9d944a$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5eWZU.isPlainObject)(result)) return systemProps;
        return (0, $jz4iA.default)({}, systemProps, result);
    };
    else finalSx = (0, $jz4iA.default)({}, systemProps, inSx);
    return (0, $jz4iA.default)({}, otherProps, {
        sx: finalSx
    });
}

});


/**
 * Units Conversion Modes available.
 * NB: the first key is normally used as the default setting if none found/set.
 */ var $f423c86e63025694$export$b7e51c16914c4c09 = /*#__PURE__*/ function(UnitsConversionModes) {
    UnitsConversionModes["DEFAULT"] = "Default (no conversion)";
    UnitsConversionModes["IMPERIAL"] = "Imperial";
    UnitsConversionModes["METRIC"] = "Metric";
    return UnitsConversionModes;
}({});
const $f423c86e63025694$export$369c46f21624ab3a = 'unitsConversionPreference';
function $f423c86e63025694$export$796b35110415361b(mode) {
    /*let keys = Object.keys(UnitsConversionModes).map(x => x.toLowerCase());
    if (keys.indexOf(mode.toLowerCase()) >= 0) {

    }*/ if (mode && mode.toUpperCase() in $f423c86e63025694$export$b7e51c16914c4c09) return $f423c86e63025694$export$b7e51c16914c4c09[mode.toUpperCase()];
    else {
        const tsOffset = -new Date().getTimezoneOffset();
        console.log(`Detecting default unit conversions using time zone offset: ${tsOffset} minutes`);
        return tsOffset < 0 ? "Imperial" : "Default (no conversion)";
    }
}
class $f423c86e63025694$export$e7bb765e9e942e99 {
    static find(sourceUnits, mode, isVisibility = false) {
        if (mode == "Imperial") {
            if (sourceUnits == 'm') return isVisibility ? this.meters_to_miles : this.meters_to_feet;
            if (sourceUnits == 'm/s' || sourceUnits == 'mps') return this.mps_to_kts;
            if (sourceUnits == "m/s\xb2" || sourceUnits == "mps\xb2") return this.mps2_to_ftps2;
            if (sourceUnits == 'degC' || sourceUnits == "\xb0C") return this.degC_to_degF;
        }
        if (mode == "Metric") {
            if (sourceUnits == 'ft') return this.feet_to_meters;
            if (sourceUnits == 'mi') return this.miles_to_meters;
            if (sourceUnits == 'kts') return this.kts_to_mps;
            if (sourceUnits == "ft/s\xb2") return this.ftps2_to_mps2;
            if (sourceUnits == 'degF' || sourceUnits == "\xb0F") return this.degF_to_degC;
        }
        return null;
    }
    static{
        //: metric to imperial:
        this.meters_to_feet = {
            sourceUnits: 'm',
            convertedUnits: 'ft',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 3.28084 : value;
            }
        };
    }
    static{
        this.meters_to_miles = {
            sourceUnits: 'm',
            convertedUnits: 'mi',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 0.000621371 : value;
            }
        };
    }
    static{
        this.mps_to_kts = {
            sourceUnits: 'm/s',
            convertedUnits: 'kts',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 1.94384 : value;
            }
        };
    }
    static{
        this.mps2_to_ftps2 = {
            sourceUnits: "m/s\xb2",
            convertedUnits: "ft/s\xb2",
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 3.28084 : value;
            }
        };
    }
    static{
        this.degC_to_degF = {
            sourceUnits: 'degC',
            convertedUnits: "\xb0F",
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 1.8 + 32 : value;
            }
        };
    }
    static{
        //: imperial to metric:
        this.kts_to_mps = {
            sourceUnits: 'kts',
            convertedUnits: 'm/s',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 0.514444 : value;
            }
        };
    }
    static{
        this.feet_to_meters = {
            sourceUnits: 'ft',
            convertedUnits: 'm',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 0.3048 : value;
            }
        };
    }
    static{
        this.miles_to_meters = {
            sourceUnits: 'mi',
            convertedUnits: 'm',
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 1609.34 : value;
            }
        };
    }
    static{
        this.ftps2_to_mps2 = {
            sourceUnits: "ft/s\xb2",
            convertedUnits: "m/s\xb2",
            convertValue: (value)=>{
                return typeof value == 'number' ? value * 0.3048 : value;
            }
        };
    }
    static{
        this.degF_to_degC = {
            sourceUnits: 'degF',
            convertedUnits: "\xb0C",
            convertValue: (value)=>{
                return typeof value == 'number' ? (value - 32) / 1.8 : value;
            }
        };
    }
}



class $4eb6084635bdf082$export$35091a304fd420cb {
    constructor(mode = (0, $f423c86e63025694$export$b7e51c16914c4c09).DEFAULT){
        this.mode = mode;
        console.info('Selected UnitsConversionMode: ', this.mode);
    }
    getConversionSet(sourceUnits, parameterGroupOrParamId) {
        if (this.mode !== (0, $f423c86e63025694$export$b7e51c16914c4c09).DEFAULT) {
            if (parameterGroupOrParamId && typeof parameterGroupOrParamId == 'string') return (0, $f423c86e63025694$export$e7bb765e9e942e99).find(sourceUnits, this.mode, parameterGroupOrParamId.indexOf('Visibility') !== -1);
            else return (0, $f423c86e63025694$export$e7bb765e9e942e99).find(sourceUnits, this.mode, false);
        }
        return null;
    }
    getConvertedUnits(sourceUnits, parameterGroupOrParamId) {
        if (this.mode == (0, $f423c86e63025694$export$b7e51c16914c4c09).DEFAULT) return sourceUnits;
        else {
            let _set = this.getConversionSet(sourceUnits, parameterGroupOrParamId);
            if (!_set) return sourceUnits;
            else return _set.convertedUnits;
        }
    }
    convert(value, sourceUnits, parameterGroupOrParamId) {
        if (this.mode == (0, $f423c86e63025694$export$b7e51c16914c4c09).DEFAULT) return value;
        else {
            let _set = this.getConversionSet(sourceUnits, parameterGroupOrParamId);
            if (!_set) return value;
            else //console.info('UnitConvert', parameterGroupOrParamId, value, sourceUnits, '*', _set.factor, '=', value * _set.factor, _set.convertedUnits);
            //return value * _set.factor;
            return _set.convertValue(value);
        }
    }
}


class $caf8dff7ec31a733$export$a57056401d57e984 {
    constructor(jqXHR){
        this.Aborted = jqXHR.statusText == 'abort';
        if (jqXHR.responseJSON && 'Message' in jqXHR.responseJSON) this.Message = jqXHR.responseJSON.Message;
        else this.Message = jqXHR.statusText;
    }
}


var $4b7cacdb38b8b78b$var$BASE_URL = '/api/Users';
var $4b7cacdb38b8b78b$export$7676726d9cb38d1f = /*#__PURE__*/ function(DownloadPermissionType) {
    DownloadPermissionType[DownloadPermissionType["None"] = 0] = "None";
    DownloadPermissionType[DownloadPermissionType["Regional"] = 1] = "Regional";
    DownloadPermissionType[DownloadPermissionType["All"] = 2] = "All";
    return DownloadPermissionType;
}({});
var $4b7cacdb38b8b78b$export$43fbffa919743dc0 = /*#__PURE__*/ function(MetnetSpatialPermissions) {
    MetnetSpatialPermissions[MetnetSpatialPermissions["None"] = 0] = "None";
    MetnetSpatialPermissions[MetnetSpatialPermissions["User"] = 1] = "User";
    MetnetSpatialPermissions[MetnetSpatialPermissions["Administrator"] = 2] = "Administrator";
    return MetnetSpatialPermissions;
}({});
var $4b7cacdb38b8b78b$export$c71834b3651dbd0b = /*#__PURE__*/ function(DigitalWeatherPermissions) {
    DigitalWeatherPermissions[DigitalWeatherPermissions["None"] = 0] = "None";
    DigitalWeatherPermissions[DigitalWeatherPermissions["User"] = 1] = "User";
    DigitalWeatherPermissions[DigitalWeatherPermissions["Essential"] = 2] = "Essential";
    return DigitalWeatherPermissions;
}({});
function $4b7cacdb38b8b78b$export$925a4945a6cd0f3e(callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}
function $4b7cacdb38b8b78b$export$6503ec6e8aabbaf(email, password, shellEmail, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/Register', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Password": password,
            "ShellEmail": shellEmail
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$b51ea21071015da9(email, region, admin, globalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, userExpiry, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/CreateNewUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Region": region,
            "Admin": admin,
            "GlobalAdmin": globalAdmin,
            "DownloadPermission": 2,
            "UserExpiry": userExpiry,
            "SingleRegionPermission": false,
            "MetnetSpatialPermissions": metnetSpatialPermissions,
            "DigitalWeatherPermissions": digitalWeatherPermissions
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$7d0f10f273c0438a(email, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/DeleteUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$dc726c8e334dd814(email, oldPassword, newPassword, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/ResetPassword', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "OldPassword": oldPassword,
            "NewPassword": newPassword
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$566de75f74361f11(email, clientConfiguration, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/UpdateClientConfiguration', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "ClientConfiguration": clientConfiguration
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $4b7cacdb38b8b78b$export$1d59b9693988d1a4(email, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/GetClientConfiguration', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $4b7cacdb38b8b78b$export$e3ac7a5d19605772(email, region, admin, globalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, userExpiry, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/UpdateUser', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Region": region,
            "Admin": admin,
            "GlobalAdmin": globalAdmin,
            "DownloadPermission": 2,
            "UserExpiry": userExpiry,
            "SingleRegionPermission": false,
            "MetnetSpatialPermissions": metnetSpatialPermissions,
            "DigitalWeatherPermissions": digitalWeatherPermissions
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$d5f449767c078dbf(email, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/ForgottenPassword', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$e330e04c9b8dc86(email, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/ForgottenPassword2Step1', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$17c16f8221447ee4(token, email, password, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/ForgottenPassword2Step2', {
        cache: false,
        type: 'POST',
        data: {
            "Token": token,
            "NewPassword": password,
            "Email": email
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$519200fc1fa018be(token, minValidityMinutes, callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/TokenVerify', {
        cache: false,
        type: 'POST',
        dataType: 'json',
        data: {
            "Token": token,
            "MinValidityMinutes": minValidityMinutes
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $4b7cacdb38b8b78b$export$ec4426d16f40cbaa(callback) {
    $.ajax($4b7cacdb38b8b78b$var$BASE_URL + '/GetRegionalAdministrators', {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}



class $4e3ab02d91c77432$export$c84cc8efbd816502 {
    encode(data) {
        return "#" + $.param(data);
    }
    decode(hash) {
        if (hash.length != 0 && hash.charAt(0) == '#') hash = hash.substr(1);
        return $.deparam(hash);
    }
}


'use client';
class $e51d30a246217e6f$export$f14c0e3f98d164c0 {
    render() {
        //for small viewports, we want a responsive log in page. But not the rest of the site (see cleanup)
        document.getElementById("viewport").setAttribute("content", "width = device-width");
        this.hash = window.location.hash;
        if (window.location.hash == '' && location.protocol !== 'https:' && window.location.port !== '51729' && window.location.port !== '51730') {
            console.info('Redirecting to HTTPS connection to ensure cookies work properly.');
            location.replace(`https:${location.href.substring(location.protocol.length)}`);
            return;
        }
        $('body').empty();
        this.mainContainer = $('<div></div>').appendTo('body');
        //splash on left hand side
        this.splashContainer = $('<div class="midi_LoginPage_splashContainer"></div>').appendTo(this.mainContainer);
        //yellow box on top of splash
        var infoContainer = $('<div class="midi_LoginPage_splashContainer_infoBox"></div>').appendTo(this.splashContainer);
        //$('<h2 class="midi_common_shell-font"></h2>').appendTo(infoContainer).text("About");
        $('<div></div>').appendTo(infoContainer).append($('<p class="midi_LoginPage_splashContainer_infoBox_header"></p>').text(branding.loginWelcomeText)).append($('<p></p>').text("Users with an @shell.com email address can create an account now to get full access to this site."));
        //right hand pannel
        this.loginRegisterContainer = $('<div class="midi_LoginPage_loginRegisterContainer"></div>').appendTo(this.mainContainer);
        var titleContainer = $('<div class="midi_LoginPage_pageTitleContainer"></div>').appendTo(this.loginRegisterContainer);
        $('<img class= "midi_LoginPage_shell" src = "/images/shell.png" />').appendTo(titleContainer);
        $('<h1 class="midi_LoginPage_pageTitle"></h1>').appendTo(titleContainer).text(branding.siteName);
        //content of right hand side pannel ( within inputandButtonContainer)
        this.inputandButtonContainer = $('<div class= "midi_LoginPage_inputandButtonContainer" > </div>').appendTo(this.loginRegisterContainer);
        this.hashChange();
        $(window).on('hashchange', ()=>{
            this.hashChange();
        });
    }
    checkLoginInputs() {
        this.inputValidation = true;
        if (!this.emailLoginInput.val() || !this.passwordLoginInput.val()) {
            var error = "Please complete all fields.";
            this.setError(error);
            this.inputValidation = false;
        } else this.setError(null);
        if (!this.emailLoginInput.val()) this.emailLoginInput.addClass("midi_common_validation_warning");
        else this.emailLoginInput.removeClass("midi_common_validation_warning");
        if (!this.passwordLoginInput.val()) this.passwordLoginInput.addClass("midi_common_validation_warning");
        else this.passwordLoginInput.removeClass("midi_common_validation_warning");
        if (!this.inputValidation) return;
        if (this.emailLoginInput.val() && this.passwordLoginInput.val()) this.inputValidation = true;
    }
    renderLoginPage(userEmail) {
        this.inputandButtonContainer.empty();
        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);
        if (branding.siteName == "METNET Global") $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i><strong>Coming from METNET 4G?</strong> Click Create an account below. Your email address should be pre-approved to register immediately.</div>').appendTo(topContainer);
        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Log in</span>').appendTo(topContainer);
        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class= "midi_LoginPage_link" href="#LoginPage=Register">Create an account </a>').appendTo(createAccount);
        if (userEmail) $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check-circle fa-3x pull-left"></i><strong>Your account is now active!</strong><p>Please log in using your password.</p></div>').appendTo(this.inputandButtonContainer);
        var emailLoginContainer = $('<div class="input-group"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(emailLoginContainer);
        this.emailLoginInput = $('<input type="text" class="form-control"aria-describedby="basic-addon1" placeholder="Email address">').appendTo(emailLoginContainer);
        if (userEmail) this.emailLoginInput.val(userEmail);
        var passwordLoginContainer = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(passwordLoginContainer);
        this.passwordLoginInput = $('<input id="midi_LoginPage_login_password"type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Password">').appendTo(passwordLoginContainer);
        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);
        this.loginButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Log in</button>').appendTo(bottomContainer).click(()=>{
            if (this.errorContainer) this.errorContainer.remove();
            this.checkLoginInputs();
            if (this.inputValidation) (0, $52db63ea8facb471$export$1a86835baa79d770).instance.tryLogin(this.emailLoginInput.val(), this.passwordLoginInput.val());
        });
        this.passwordLoginInput.keypress((e)=>{
            if (e.which == 13) {
                this.loginButton.click();
                return false;
            }
        });
        $('<a class="midi_LoginPage_link" id="midi_LoginPage_forgotPassword" href="#LoginPage=ForgottenPassword">Forgotten your password?</a>').appendTo(bottomContainer);
        this.validationContainer = $('<div id="midi_LoginPage_login_input_validation_container"></div>').appendTo(this.loginRegisterContainer);
    }
    renderRegisterPage(userEmail) {
        this.inputandButtonContainer.empty();
        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);
        if (userEmail) $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Complete Registration</span>').appendTo(topContainer);
        else $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Register</span>').appendTo(topContainer);
        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);
        if (userEmail) $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i>Your account has been pre-approved. Please choose a password for access to ' + branding.siteName + '.</div>').appendTo(topContainer);
        else {
            var regionalAdminLink = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.setupRegionalAdminPopover($('<strong>Regional Administrator</strong>').css("cursor", "pointer"));
            $('<div class="midi_LoginPage_alert alert alert-info"><i class="fa fa-info-circle fa-3x pull-left"></i><p><strong>Have an @shell.com email address or an old METNET 4G account?</strong> If so then you can register instantly for access to ' + branding.siteName + '.</p><span><strong>Other users:</strong> please contact your </span>').append(regionalAdminLink).append(' to register.</div>').appendTo(topContainer);
        }
        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input id="midi_LoginPage_registration_email_address" type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
        if (userEmail) this.emailInput.val(userEmail);
        this.password1Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password1Container);
        this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Password">').appendTo(this.password1Container);
        this.password2Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password2Container);
        this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Confirm Password">').appendTo(this.password2Container);
        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);
        var submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Register</button>').appendTo(bottomContainer).click(()=>{
            this.checkRegistrationInputs();
            if (this.inputValidation) this.tryRegister(this.emailInput.val(), this.password1Input.val(), this.password2Input.val());
        });
        this.password2Container.keypress((e)=>{
            if (e.which == 13) {
                submitButton.click();
                return false;
            }
        });
    }
    checkRegistrationInputs() {
        this.inputValidation = true;
        if (!this.emailInput.val() || !this.password1Input.val() || !this.password2Input.val()) {
            var error = "Please complete all fields.";
            this.setError(error);
            this.inputValidation = false;
        } else this.setError(null);
        if (this.password1Input.val() != this.password2Input.val()) {
            this.password1Input.remove();
            this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1">').appendTo(this.password1Container);
            this.password2Input.remove();
            this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1">').appendTo(this.password2Container);
            var error = "Passwords do not match.";
            this.setError(error);
            this.inputValidation = false;
        }
        if (!this.emailInput.val()) this.emailInput.addClass("midi_common_validation_warning");
        else this.emailInput.removeClass("midi_common_validation_warning");
        if (!this.password1Input.val()) this.password1Input.addClass("midi_common_validation_warning");
        else this.password1Input.removeClass("midi_common_validation_warning");
        if (!this.password2Input.val()) this.password2Input.addClass("midi_common_validation_warning");
        else this.password2Input.removeClass("midi_common_validation_warning");
        if (!this.inputValidation) return;
        if (this.emailInput.val() && this.password1Input.val() && this.password2Input.val()) this.inputValidation = true;
    }
    tryRegister(email, password1, password2) {
        var shellEmailBool = false;
        if (email.length > 10) {
            if (email.slice(email.length - 10, email.length) == "@shell.com") //need to check whether user has been pre-approved
            shellEmailBool = true;
        }
        (0, $4b7cacdb38b8b78b$export$6503ec6e8aabbaf)(email, password1, shellEmailBool, (err)=>{
            if (this.errorContainer) this.errorContainer.remove();
            if (err) // there has been an error registering
            this.setError(err.Message);
            else {
                // registration has worked
                this.inputandButtonContainer.empty();
                //this.container = $('<div class="midi_LoginPage_main_container"></div>').appendTo('body');
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check-circle fa-3x pull-left"></i><strong>Registration complete.</strong><p>A confirmation email will be sent shortly. Please click the link in the email to verify your email address and complete the registration process.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }
    renderPasswordResetPage() {
        this.inputandButtonContainer.empty();
        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);
        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password</span>').appendTo(topContainer);
        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);
        $('<div class="midi_LoginPage_alert panel panel-default"><div class="panel-body">Please enter your email address to <strong>reset your password</strong>. You will then be sent a new password by email.</div></div>').appendTo(topContainer);
        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);
        var resetPasswordButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Reset Password</button>').appendTo(bottomContainer).click(()=>{
            if (!this.emailInput.val()) {
                var error = "Please enter an email address.";
                this.setError(error);
                this.emailInput.addClass("midi_common_validation_warning");
                return;
            } else this.emailInput.removeClass("midi_common_validation_warning");
            this.tryForgottenPasswordReset(this.emailInput.val());
        });
        this.emailInput.keypress((e)=>{
            if (e.which == 13) {
                resetPasswordButton.click();
                return false;
            }
        });
    }
    renderPasswordResetPage2Step1() {
        this.inputandButtonContainer.empty();
        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);
        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password (step 1)</span>').appendTo(topContainer);
        var createAccount = $('<div class="midi_LoginPage_rightHandLink"></div>').appendTo(topContainer);
        $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a>').appendTo(createAccount);
        $('<div class="midi_LoginPage_alert panel panel-default"><div class="panel-body">Please enter your email address to <strong>reset your password</strong>. You will then be sent a link that will allow you to set a new password.</div></div>').appendTo(topContainer);
        this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
        this.emailInput = $('<input type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
        var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);
        this.submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Send me a password reset link</button>').appendTo(bottomContainer).click(()=>{
            if (!this.emailInput.val()) {
                var error = "Please enter an email address.";
                this.setError(error);
                this.emailInput.addClass("midi_common_validation_warning");
                return;
            } else {
                this.emailInput.removeClass("midi_common_validation_warning");
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //: thanks to: https://stackoverflow.com/a/46181
                if (!re.test(this.emailInput.val())) {
                    var error = "Please enter a valid email address.";
                    this.setError(error);
                    this.emailInput.addClass("midi_common_validation_warning");
                    return;
                }
            }
            this.tryForgottenPasswordReset2Step1(this.emailInput.val());
        });
        this.emailInput.keypress((e)=>{
            if (e.which == 13) {
                this.submitButton.click();
                return false;
            }
        });
    }
    renderPasswordResetPage2Step2(userToken) {
        this.inputandButtonContainer.empty();
        var topContainer = $('<div class= "midi_LoginPage_inputandButtonContainer_top"> </div>').appendTo(this.inputandButtonContainer);
        $('<span class="midi_LoginPage_inputandButtonContainer_top_title">Reset Password (step 2)</span>').appendTo(topContainer);
        $('<div class="midi_LoginPage_rightHandLink"><a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in </a></div>').appendTo(topContainer);
        var loadingContainer = $('<div class="midi_LoginPage_alert alert alert-warning"><i class="fa fa-refresh fa-spin"></i> Checking the validity of the token...</div>').appendTo(this.inputandButtonContainer);
        this.hiddenInputToken = $('<input type="hidden" name="Token">').appendTo(this.inputandButtonContainer);
        if (userToken) this.hiddenInputToken.val(userToken);
        (0, $4b7cacdb38b8b78b$export$519200fc1fa018be)(userToken, 10, (err, data)=>{
            if (err) {
                this.setError(err.Message);
                loadingContainer.remove();
            } else {
                loadingContainer.remove();
                this.emailContainer = $('<div class="input-group" id="midi_LoginPage_registration_email_container"></div>').appendTo(this.inputandButtonContainer);
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(this.emailContainer);
                this.emailInput = $('<input id="midi_LoginPage_registration_email_address" type="text" class="form-control" aria-describedby="basic-addon1" placeholder="Email address">').appendTo(this.emailContainer);
                this.emailInput.prop("readonly", true);
                if (data.UserAccountId) this.emailInput.val(data.UserAccountId);
                this.password1Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password1Container);
                this.password1Input = $('<input id="midi_LoginPage_registration_password_1" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="New Password">').appendTo(this.password1Container);
                this.password2Container = $('<div class="input-group midi_LoginPage_topMargin"></div>').appendTo(this.inputandButtonContainer);
                $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-key fa-fw"></i></span>').appendTo(this.password2Container);
                this.password2Input = $('<input id="midi_LoginPage_registration_password_2" type="password" class="form-control" aria-describedby="basic-addon1" placeholder="Confirm Password">').appendTo(this.password2Container);
                var bottomContainer = $('<div class= "midi_LoginPage_topMargin"> </div>').appendTo(this.inputandButtonContainer);
                this.submitButton = $('<button type="button" class="btn btn-success midi_LoginPage_button">Change my password</button>').appendTo(bottomContainer).click(()=>{
                    this.checkRegistrationInputs();
                    if (this.inputValidation) this.tryForgottenPasswordReset2Step2(this.hiddenInputToken.val(), this.emailInput.val(), this.password2Input.val());
                });
                this.password2Container.keypress((e)=>{
                    if (e.which == 13) {
                        this.submitButton.click();
                        return false;
                    }
                });
            }
        });
    }
    tryForgottenPasswordReset(email) {
        if (this.errorContainer) this.errorContainer.remove();
        (0, $4b7cacdb38b8b78b$export$d5f449767c078dbf)(email, (err)=>{
            if (err) // error registering
            this.setError(err.Message);
            else {
                // registration has worked
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><strong>Success!</strong> A new password has been sent to your email address. Please use this to log in and then change your password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }
    tryForgottenPasswordReset2Step1(email) {
        if (this.errorContainer) this.errorContainer.remove();
        let btnHtml = this.submitButton.html();
        this.submitButton.html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Sending a reset link via email...');
        this.submitButton.prop("disabled", true);
        (0, $4b7cacdb38b8b78b$export$e330e04c9b8dc86)(email, (err)=>{
            if (err) {
                this.setError(err.Message);
                this.submitButton.html(btnHtml);
                this.submitButton.prop("disabled", false);
            } else {
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check"></i> A link has been sent to your email address. Follow this link to set your new password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }
    tryForgottenPasswordReset2Step2(token, email, password) {
        if (this.errorContainer) this.errorContainer.remove();
        let btnHtml = this.submitButton.html();
        this.submitButton.html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Changing your password...');
        this.submitButton.prop("disabled", true);
        (0, $4b7cacdb38b8b78b$export$17c16f8221447ee4)(token, email, password, (err)=>{
            if (err) {
                this.setError(err.Message);
                this.submitButton.html(btnHtml);
                this.submitButton.prop("disabled", false);
            } else {
                this.inputandButtonContainer.empty();
                $('<div class="midi_LoginPage_alert alert alert-success"><i class="fa fa-check"></i> <strong>Your password was changed.</strong><br>You may now log in with your <strong>new</strong> password.</div>').appendTo(this.inputandButtonContainer);
                $('<a class="midi_LoginPage_link" href="#LoginPage=Login">Return to log in.</a>').appendTo(this.inputandButtonContainer);
            }
        });
    }
    /**
     * Displays a login error, or hides the error if null is passed.
     */ setError(error) {
        if (this.errorContainer) this.errorContainer.remove();
        if (!error) return;
        if (typeof error !== 'undefined' && error !== 'No session cookie') this.errorContainer = $('<div class="midi_LoginPage_alert alert alert-danger"><i class="fa fa-exclamation-triangle"></i> ' + error + '</div>').appendTo(this.inputandButtonContainer);
    }
    /*
    * Specifies whether or not we are logging in in the background. In this case, the
    * user should not be able to click the login button a second time.
    */ setLoggingInInProgressState(loggingInInProgress) {
        if (this.loginButton) {
            if (loggingInInProgress) {
                // disable the button
                this.loginButton.prop('disabled', true);
                // show the loading spinner and text
                this.loginButton.html('<i class="fa fa-spinner fa-spin"></i> Logging in...');
            } else {
                // enable the button and 
                this.loginButton.prop('disabled', false);
                // show the original text
                this.loginButton.html('Log in');
            }
        }
    }
    hashChange() {
        this.loginHashData = this.loginHashDataManager.decode(window.location.hash);
        var userEmail = this.loginHashData.UserEmail;
        var loginPage = this.loginHashData.LoginPage;
        if (loginPage) {
            if (loginPage == "Register") this.renderRegisterPage(userEmail);
            else if (loginPage == "Login") this.renderLoginPage(userEmail);
            else if (loginPage == "ForgottenPassword-Old") this.renderPasswordResetPage();
            else if (loginPage == "ForgottenPassword") this.renderPasswordResetPage2Step1();
            else if (loginPage == "ResetPassword") {
                let userToken = this.loginHashData.Token;
                this.renderPasswordResetPage2Step2(userToken);
            } else this.renderLoginPage();
        } else this.renderLoginPage();
    }
    cleanUp() {
        document.getElementById("viewport").setAttribute("content", "width = 1000px");
        $('body').empty();
        window.location.hash = this.hash;
        $(window).off('hashchange');
    }
    constructor(){
        this.mainContainer = null;
        this.splashContainer = null;
        this.loginRegisterContainer = null;
        this.inputandButtonContainer = null;
        this.emailContainer = null;
        this.emailLoginInput = null;
        this.passwordLoginInput = null;
        this.emailInput = null;
        this.password1Container = null;
        this.password1Input = null;
        this.password2Container = null;
        this.password2Input = null;
        this.submitButton = null;
        this.validationContainer = null;
        this.errorContainer = null;
        this.loginHashDataManager = new (0, $4e3ab02d91c77432$export$c84cc8efbd816502)();
        this.hiddenInputToken = null;
    }
}


var $15ad78b8e8363913$var$BASE_URL = '/api/Schema';
function $15ad78b8e8363913$export$19a621270f26273c(callback) {
    $.ajax($15ad78b8e8363913$var$BASE_URL + '/Get', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 120000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}


class $b71f12c6d614c68e$export$e6fac6e2831a7e0c {
    getStaticData(callback) {
        (0, $15ad78b8e8363913$export$19a621270f26273c)((err, data)=>{
            this.Schema = data;
            callback(err);
        });
    }
    constructor(){
        this.Schema = null;
    }
}


class $0c26b1f9a32f22f6$export$2e5b55ed27df6e11 {
    encode(data) {
        return "#" + $.param(data);
    }
    decode(hash) {
        if (hash.length != 0 && hash.charAt(0) == '#') hash = hash.substr(1);
        return $.deparam(hash);
    }
}


var $d391c862b0fffdce$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status[Status["Good"] = 0] = "Good";
    Status[Status["Expiring"] = 1] = "Expiring";
    Status[Status["Expired"] = 2] = "Expired";
    return Status;
}({});



class $d9b7173911f93686$export$82033fbb642dfaa2 {
    static{
        this.Parameters = {
            // Wind
            "WindSpeed/kts_Raw": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "WindSpeed/kts_Raw_Filtered": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "WindDirection/deg_Raw": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "WindDirection/deg_Raw_Filtered": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "WindSpeed/kts_10min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "WindSpeed/kts_1min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "1 min"
            },
            "WindSpeed/kts_2min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "2 min"
            },
            "WindSpeed/kts_3sec_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "3 sec"
            },
            "WindSpeed/kts_8min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "8 min"
            },
            "GustSpeed/kts_10min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "GustSpeed/kts_1min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "1 min"
            },
            "GustSpeed/kts_8min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "8 min"
            },
            "WindDirection/deg_10min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "WindDirection/deg_1min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "1 min"
            },
            "WindDirection/deg_3sec_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "3 sec"
            },
            "WindDirection/deg_2min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "2 min"
            },
            "WindDirection/deg_8min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "8 min"
            },
            "WindDirection/Backed_deg_10min": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "WindDirection/Veered_deg_10min": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "WindSelectedSensorId": {
                AllowPlot: false,
                Default: true
            },
            //Forecast
            "WindDirection/deg_10m": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 m"
            },
            "WindSpeed/kts_10m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 m"
            },
            "WindSpeed/kts_50m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "50 m"
            },
            "WindSpeed/kts_100m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "100 m"
            },
            "GustSpeed/kts_10m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 m"
            },
            "GustSpeed/kts_50m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "50 m"
            },
            "GustSpeed/kts_100m": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "100 m"
            },
            "Tp_WindSea/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tp_Swell1/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Visibility/m": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "First_CloudBaseHeight/ft": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "BarometricPressure_QNH/mbar": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true
            },
            "BarometricPressure/mbar": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true
            },
            "BarometricPressure/mbar_10min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true
            },
            // Meteorological
            "WaterTemp/degC": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true
            },
            "WaterTemp/degC_10min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "WaterTemp/degC_60min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "AirTempDryBulb/degC": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true
            },
            "AirTempDryBulb/degC_10min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "AirTempDryBulb/degC_60min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "AirTempDryBulb/degC_20min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "BarometricPressure/QFE_mbar_10min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "BarometricPressure_QNH/mbar_10min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "BarometricPressure_QFE/mbar_20min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "BarometricPressure_QNH/mbar_20min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "BarometricPressure_QNH/mbar_60min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "Dewpoint/degC_10min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "RelativeHumidity/pc_10min_Mean": {
                AxisLabel: "Humidity",
                PlotLine: true,
                Units: "%",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "RelativeHumidity/pc_20min_Mean": {
                AxisLabel: "Humidity",
                PlotLine: true,
                Units: "%",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "AirTempDryBulb/degC_1min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "BarometricPressure/QFE_mbar_1min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "BarometricPressure_QNH/mbar_1min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Dewpoint/degC_1min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Dewpoint/degC_20min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "RelativeHumidity/pc_1min_Mean": {
                AxisLabel: "Humidity",
                PlotLine: true,
                Units: "%",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "WindChill/degC_10min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "SolarRadiation/mWpcm2_10min_Mean": {
                AxisLabel: "Solar",
                PlotLine: true,
                Units: "Wb / cm^2",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "SolarRadiation/mWpcm2_60min_Mean": {
                AxisLabel: "Solar",
                PlotLine: true,
                Units: "Wb / cm^2",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "METAR": {
                AllowPlot: false,
                Default: true
            },
            // Cloud, Vis, Weather
            "Visibility/m_10min_Mean": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Visibility/m_20min_Mean": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Visibility/m_Inst_Mean": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "Inst"
            },
            "PresentWeather": {
                AllowPlot: false,
                Default: true
            },
            "RainfallIntensity/mmphour": {
                AxisLabel: "Rainfall",
                PlotLine: true,
                Units: "mm / hour",
                AllowPlot: true,
                Default: true
            },
            "Evaporation/mmphour": {
                AxisLabel: "Evaporation",
                PlotLine: true,
                Units: "mm / hour",
                AllowPlot: true,
                Default: true
            },
            "Rainfall/mmSince9am": {
                AxisLabel: "Rainfall",
                PlotLine: true,
                Units: "mm",
                AllowPlot: true,
                Default: true
            },
            "First_CloudBaseHeight/ft_30min": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Second_CloudBaseHeight/ft_30min": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Third_CloudBaseHeight/ft_30min": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "First_CloudCover/30min": {
                AllowPlot: false,
                Default: true,
                Suffix: "30 min"
            },
            "Second_CloudCover/30min": {
                AllowPlot: false,
                Default: true,
                Suffix: "30 min"
            },
            "Third_CloudCover/30min": {
                AllowPlot: false,
                Default: true,
                Suffix: "30 min"
            },
            "First_CloudBaseHeight/ft_Inst": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Second_CloudBaseHeight/ft_Inst": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Third_CloudBaseHeight/ft_Inst": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            // Vessel
            "Heading/deg": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Vessel_Latitude/deg": {
                AxisLabel: "Latitude",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Vessel_Longitude/deg": {
                AxisLabel: "Longitude",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Pitch/BowUp_deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Pitch/BowDown_deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Roll/Left_deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Roll/Right_deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Inclination/deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Heave/Rate_mps_20min_Max": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "mps",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Heave/Period_s_20min_Mean": {
                AxisLabel: "Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Heave/m_20min_Max": {
                AxisLabel: "Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "MMS/20min": {
                AxisLabel: "MMS",
                PlotLine: true,
                AllowPlot: true,
                Default: true
            },
            "MSI/20min": {
                AxisLabel: "MSI",
                PlotLine: true,
                AllowPlot: true,
                Default: true
            },
            "WSI/20min": {
                AxisLabel: "WSI",
                PlotLine: true,
                AllowPlot: true,
                Default: true
            },
            "Excursion/Bearing_deg_1min": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "1 min"
            },
            "Excursion/Distance_m_1min_Max": {
                AxisLabel: "Distance",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            // Wave (Time Domain)
            "HsT/m_30min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "HmaxT/m_30min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "HmaxT/m": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "THmaxT/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "CmaxT/m_30min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "CassT/m_30min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Tz/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "TmaxT/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Draft/m_30min": {
                AxisLabel: "Draft",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "AirGap/m_30min": {
                AxisLabel: "Air Gap",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "AirGap/m_10min": {
                AxisLabel: "Air Gap",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "AirGap/m_Raw": {
                AxisLabel: "Air Gap",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            // Wave (Spectral)
            "Hs/m_30min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Hs/m_20min": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "20 min"
            },
            "Hs/m": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Hs_WindSea/m": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Hs_Swell1/m": {
                AxisLabel: "Wave Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "MeanWaveDirection/deg_30min": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "PeakWaveDirection/deg_30min": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "MeanSpreading/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "MeanSpreading_WindSea/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "MeanSpreading_Swell1/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "PeakSpreading/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "PeakSpreading_WindSea/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "PeakSpreading_Swell1/deg_30min": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "30 min"
            },
            "MeanWaveDirection/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanWaveDirection_WindSea/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanWaveDirection_Swell1/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanWaveDirection/degM": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0M FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanWaveDirection_WindSea/degM": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0M FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanWaveDirection_Swell1/degM": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0M FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakWaveDirection/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakWaveDirection_WindSea/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakWaveDirection_Swell1/deg": {
                AxisLabel: "Wave Direction",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanSpreading/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakSpreading/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Tc/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "T1/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "T2/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "Tp/s_30min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "30 min"
            },
            "T1/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tm/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tm_WindSea/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tm_Swell1/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "T2/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "T2_WindSea/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "T2_Swell1/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tm-1/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "UnidirectivityIndex": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tp/s": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Tp/s_20min": {
                AxisLabel: "Wave Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "20 min"
            },
            "WaveSpectrum/30min": {
                AllowPlot: false,
                Default: true,
                Suffix: "30 min"
            },
            // Current
            "Total_CurrentSpeed/Peak_mps_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Surface_mps_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Surface_mps_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Middle_mps_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Bottom_mps_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Peak_kts_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Surface_kts_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Surface_kts_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Middle_kts_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentSpeed/Bottom_kts_10min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentDirection/Peak_deg_10min_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentDirection/Surface_deg_10min_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentDirection/Surface_deg_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Total_CurrentDirection/Middle_deg_10min_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentDirection/Bottom_deg_10min_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "MeasurementDepth/Total_Current_Peak_deg_10min_Mean": {
                AxisLabel: "Depth",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            // Water Level
            "Total_SeaElevation/m_30min_Max": {
                AxisLabel: "Sea Surface",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "30 min"
            },
            "Total_SeaElevation/m_30min_Mean": {
                AxisLabel: "Sea Surface",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "30 min"
            },
            "Total_SeaElevation/m_10min_Max": {
                AxisLabel: "Sea Surface",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Total_SeaElevation/m_10min_Mean": {
                AxisLabel: "Sea Surface",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            //Tide
            "Tide_Predicted/m_LAT": {
                AxisLabel: "Tide",
                PlotLine: true,
                Units: "m (LAT)",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Tide/m": {
                AxisLabel: "Tide",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            // Buoy
            "Buoy_Latitude/deg": {
                AxisLabel: "Latitude",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Buoy_Longitude/deg": {
                AxisLabel: "Longitude",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Buoy_Excursion/m": {
                AxisLabel: "Buoy Excursion",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "Buoy_BatteryLife/weeks": {
                AxisLabel: "Battery Life",
                PlotLine: true,
                Units: "weeks",
                AllowPlot: true,
                Default: true
            },
            "Buoy_BatteryVoltage/V": {
                AxisLabel: "Battery Voltage",
                PlotLine: true,
                Units: "V",
                AllowPlot: true,
                Default: true
            },
            "BatteryVoltage/V": {
                AxisLabel: "Battery Voltage",
                PlotLine: true,
                Units: "V",
                AllowPlot: true,
                Default: true
            },
            // Helideck Status
            "Helideck_Status": {
                AxisLabel: "Status",
                PlotLine: true,
                Units: "",
                AllowPlot: true,
                Default: true
            },
            "RiserTension/kN": {
                AxisLabel: "Riser Tension",
                PlotLine: true,
                Units: "kN",
                AllowPlot: true,
                Default: true
            },
            "RiserTensionerPressure1/psi": {
                AxisLabel: "Tensioner Pressure",
                PlotLine: true,
                Units: "psi",
                AllowPlot: true,
                Default: true
            },
            "RiserTensionerPressure2/psi": {
                AxisLabel: "Tensioner Pressure",
                PlotLine: true,
                Units: "psi",
                AllowPlot: true,
                Default: true
            },
            "RiserTensionerPressure3/psi": {
                AxisLabel: "Tensioner Pressure",
                PlotLine: true,
                Units: "psi",
                AllowPlot: true,
                Default: true
            },
            "RiserTensionerPressure4/psi": {
                AxisLabel: "Tensioner Pressure",
                PlotLine: true,
                Units: "psi",
                AllowPlot: true,
                Default: true
            },
            "Draft/m": {
                AxisLabel: "Draft",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "InclinationNS/deg": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "InclinationEW/deg": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Pitch/deg": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Roll/deg": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true
            },
            "Heave/m": {
                AxisLabel: "Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "SurgeAcceleration/mps2": {
                AxisLabel: "Acceleration",
                PlotLine: true,
                Units: "mps^2",
                AllowPlot: true,
                Default: true
            },
            "SwayAcceleration/mps2": {
                AxisLabel: "Acceleration",
                PlotLine: true,
                Units: "mps^2",
                AllowPlot: true,
                Default: true
            },
            "BuoyDisplacementNorth/m_Raw": {
                AxisLabel: "Buoy Displacement",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "BuoyDisplacementWest/m_Raw": {
                AxisLabel: "Buoy Displacement",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "BuoyDisplacementVertical/m_Raw": {
                AxisLabel: "Buoy Displacement",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true
            },
            "AirTempDryBulb/degC_4min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "4 min"
            },
            "AirTempWetBulb/degC_10min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "BarometricPressure/mbar_1min_Mean": {
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Dewpoint/degC_4min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "4 min"
            },
            "First_CloudBaseHeight/ft_10min": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "GustSpeed/kts_10m_10min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 m, 10 min"
            },
            "GustSpeed/kts_10m_2min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 m, 2 min"
            },
            "GustSpeed/kts_2min": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "2 min"
            },
            "Heading/deg_10min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "Heading/deg_1min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "1 min"
            },
            "Heading/deg_20min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "20 min"
            },
            "Heading/deg_2min_Mean": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "2 min"
            },
            "Heading/deg_Inst": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Heave/Period_s_10min_Mean": {
                AxisLabel: "Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Heave/Period_s_1min_Mean": {
                AxisLabel: "Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Heave/Rate_mps_10min_2rms": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "mps",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "10 min"
            },
            "Heave/Rate_mps_10min_Max": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "mps",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Heave/Rate_mps_20min_2rms": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "mps",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Heave/Rate_mps_20min_4rms": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "mps",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Heave/m_10min_Max": {
                AxisLabel: "Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Heave/m_1min_Max": {
                AxisLabel: "Height",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "MeanSpreading_Swell1/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeanSpreading_WindSea/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "MeasurementDepth/Total_Current_Peak_deg_Mean": {
                AxisLabel: "Depth",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakSpreading_Swell1/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "PeakSpreading_WindSea/deg": {
                AxisLabel: "Wave Spreading",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Pitch/deg_10min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Pitch/deg_10min_Min": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Pitch/deg_1min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Pitch/deg_1min_Min": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Pitch/deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Pitch/deg_20min_Min": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "RainfallIntensity/mmp10min": {
                AxisLabel: "Rainfall",
                PlotLine: true,
                Units: "mm / 10 min",
                AllowPlot: true,
                Default: true
            },
            "RainfallIntensity/mmpday": {
                AxisLabel: "Rainfall",
                PlotLine: true,
                Units: "mm / day",
                AllowPlot: true,
                Default: true
            },
            "RainfallIntensity/mmpmin": {
                AxisLabel: "Rainfall",
                PlotLine: true,
                Units: "mm / min",
                AllowPlot: true,
                Default: true
            },
            "RelativeHumidity/pc_4min_Mean": {
                AxisLabel: "Humidity",
                PlotLine: true,
                Units: "%",
                AllowPlot: true,
                Default: true,
                Suffix: "4 min"
            },
            "Roll/deg_10min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Roll/deg_1min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Roll/deg_1min_Min": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Roll/deg_20min_Max": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Roll/deg_20min_Min": {
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "SeaTemp/deg_1hour_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "Second_CloudBaseHeight/ft_10min": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "SolarRadiation/mWpcm2_1min_Mean": {
                AxisLabel: "Solar",
                PlotLine: true,
                Units: "W / cm^2",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "Surge/m_10min_Max": {
                AxisLabel: "Surge/Sway",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Sway/m_10min_Max": {
                AxisLabel: "Surge/Sway",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "10 min"
            },
            "Tc/s": {
                AxisLabel: "Period",
                PlotLine: true,
                Units: "s",
                AllowPlot: true,
                Default: true
            },
            "Third_CloudBaseHeight/ft_10min": {
                AxisLabel: "Cloud Height",
                PlotLine: true,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "Total_CurrentDirection/Bottom_deg_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Total_CurrentDirection/Middle_deg_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Total_CurrentDirection/Peak_deg_1hour_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "1 hour"
            },
            "Total_CurrentDirection/Peak_deg_20min_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "20 min"
            },
            "Total_CurrentDirection/Peak_deg_Mean": {
                AxisLabel: "Direction To",
                PlotLine: false,
                Units: "\xb0T TO",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true
            },
            "Total_CurrentSpeed/Bottom_kts_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Bottom_mps_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Middle_kts_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Middle_mps_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Peak_kts_1hour_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "Total_CurrentSpeed/Peak_kts_20min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Total_CurrentSpeed/Peak_kts_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "Total_CurrentSpeed/Peak_mps_1hour_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "Total_CurrentSpeed/Peak_mps_20min_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true,
                Suffix: "20 min"
            },
            "Total_CurrentSpeed/Peak_mps_Mean": {
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s",
                AllowPlot: true,
                Default: true
            },
            "VerticalVisibility/ft_Inst": {
                AxisLabel: "Cloud Height",
                PlotLine: false,
                Units: "ft",
                AllowPlot: true,
                AxisMin: 0,
                Default: true
            },
            "Visibility/m_1hour_Mean": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "60 min"
            },
            "Visibility/m_1min_Mean": {
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "WaterTemp/degC_1min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "WindChill/degC_1min_Mean": {
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C",
                AllowPlot: true,
                Default: true,
                Suffix: "1 min"
            },
            "WindDirection/Backed_deg_2min": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "2 min"
            },
            "WindDirection/Veered_deg_2min": {
                AxisLabel: "Direction From",
                PlotLine: false,
                Units: "\xb0T FROM",
                AllowPlot: true,
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                Suffix: "2 min"
            },
            "WindSpeed/kts_10m_10min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "10 min"
            },
            "WindSpeed/kts_10m_2min_Mean": {
                AxisLabel: "Speed",
                PlotLine: true,
                Units: "kts",
                AllowPlot: true,
                AxisMin: 0,
                Default: true,
                Suffix: "2 min"
            },
            // added by Nicolas after setting up data copy from MET-REACH to MNG (not grouped by type):
            "AirTempDryBulb/degC_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Temperature",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "\xb0C"
            },
            "BarometricPressure/QFE_mbar_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "hPa"
            },
            "BarometricPressure/mbar_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "hPa"
            },
            "BarometricPressure_Cell1/QNH_mbar_4min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "4 min",
                Units: "hPa"
            },
            "BarometricPressure_Cell1/mbar": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Units: "hPa"
            },
            "BarometricPressure_Cell2/QNH_mbar_4min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "4 min",
                Units: "hPa"
            },
            "BarometricPressure_Cell2/mbar": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Units: "hPa"
            },
            "BarometricPressure_Cell3/QNH_mbar_4min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "4 min",
                Units: "hPa"
            },
            "BarometricPressure_Cell3/mbar": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Units: "hPa"
            },
            "BarometricPressure_QNH/mbar_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Pressure",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "hPa"
            },
            "Buoy_BatteryLife/%": {
                AllowPlot: true,
                AxisLabel: "Battery %",
                Default: true,
                PlotLine: true,
                Units: "%"
            },
            "CurrentProfile": {
                AllowPlot: false,
                Default: true
            },
            "CurrentProfileRaw": {
                AllowPlot: false,
                Default: true
            },
            "DayNightIndicator": {
                AllowPlot: false,
                Default: true
            },
            "Dewpoint/degC_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Temperature",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "\xb0C"
            },
            "Heave/Period_s_20min_Max": {
                AllowPlot: true,
                AxisLabel: "Period",
                Default: true,
                PlotLine: true,
                Suffix: "20 min",
                Units: "s"
            },
            "Heave/Period_s_20min_Min": {
                AllowPlot: true,
                AxisLabel: "Period",
                Default: true,
                PlotLine: true,
                Suffix: "20 min",
                Units: "s"
            },
            "Heave/Rate_mps_20min_Mean": {
                AllowPlot: true,
                AxisLabel: "Speed",
                Default: true,
                PlotLine: true,
                Suffix: "20 min",
                Units: "mps"
            },
            "Heave/m_20min_Mean": {
                AllowPlot: true,
                AxisLabel: "Height",
                Default: true,
                PlotLine: true,
                Suffix: "20 min",
                Units: "m"
            },
            "HmaxT/m_30min_CrestToTrough": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "30 min",
                Units: "m"
            },
            "HmaxT/m_30min_TroughToCrest": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "30 min",
                Units: "m"
            },
            "HmaxT/m_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "45 min",
                Units: "m"
            },
            "Hmax_m": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Units: "m"
            },
            "Hs/m_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "45 min",
                Units: "m"
            },
            "Hs_Swell2/m": {
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Units: "m"
            },
            "InvalidAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M-1/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M-1/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M-2/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M-2/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M0/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M0/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M1/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M1/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M2/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M2/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M3/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M3/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "M4/30min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "M4/45min": {
                AllowPlot: true,
                AxisLabel: "Spectral Moments",
                Default: true,
                PlotLine: true,
                Suffix: "45 min"
            },
            "MeanSpreading/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0"
            },
            "MeanSpreading_Swell1/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0"
            },
            "MeanSpreading_Swell2/deg_30min": {
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                Default: true,
                PlotLine: false,
                Suffix: "30 min",
                Units: "\xb0"
            },
            "MeanSpreading_WindSea/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0"
            },
            "MeanWaveDirection/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "MeanWaveDirection_Swell1/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "MeanWaveDirection_Swell2/deg_30min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "30 min",
                Units: "\xb0T FROM"
            },
            "MeanWaveDirection_WindSea/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "NormalRangeFailAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "PeakWaveDirection/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "PeakWaveDirection_Swell1/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "PeakWaveDirection_WindSea/deg_45min": {
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0T FROM"
            },
            "RainfallIntensity_mmphour": {
                AllowPlot: true,
                AxisLabel: "Rainfall",
                Default: true,
                PlotLine: true,
                Units: "mm / hour"
            },
            "RangeFailAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "RateFailAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: false,
                Suffix: "30 min"
            },
            "RawString": {
                AllowPlot: false,
                Default: true
            },
            "RelativeHumidity/pc_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Humidity",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "%"
            },
            "SHR/mps_10min_Mean": {
                AllowPlot: true,
                AxisLabel: "Heave Rate",
                Default: true,
                PlotLine: true,
                Suffix: "10 min",
                Units: "mps"
            },
            "SHR/mps_20min_Mean": {
                AllowPlot: true,
                AxisLabel: "Heave Rate",
                Default: true,
                PlotLine: true,
                Suffix: "20 min",
                Units: "mps"
            },
            "SHR/mps_2min_Min": {
                AllowPlot: true,
                AxisLabel: "Heave Rate",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "mps"
            },
            "SHR/mps_Inst": {
                AllowPlot: true,
                AxisLabel: "Heave Rate",
                Default: true,
                PlotLine: true,
                Suffix: "Inst",
                Units: "mps"
            },
            "SensorRange/ft": {
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                Default: true,
                PlotLine: true,
                Units: "ft"
            },
            "SensorStatus": {
                AllowPlot: false,
                Default: true
            },
            "Skewness/30min": {
                AllowPlot: true,
                AxisLabel: "Skewness",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "SpectrumHighPortion/30min": {
                AllowPlot: true,
                AxisLabel: "Spectrum Energy",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "SpectrumLowPortion/30min": {
                AllowPlot: true,
                AxisLabel: "Spectrum Energy",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "SpikeFilterFailCount/1min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "1 min"
            },
            "SpikeFilterFailCountA/1min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "1 min"
            },
            "SpikeFilterFailCountB/1min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "1 min"
            },
            "SpikeFilterFailCountC/1min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "1 min"
            },
            "StationarityFailAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "T2/s_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "45 min",
                Units: "s"
            },
            "T2_Swell2/s_30min": {
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "30 min",
                Units: "s"
            },
            "TEMPSC_Status": {
                AllowPlot: false,
                Default: true
            },
            "Total_CurrentDirection/Surface_deg_90min_Mean": {
                AllowPlot: true,
                AxisLabel: "Direction To",
                AxisMin: 0,
                AxisMax: 360,
                Default: true,
                PlotLine: false,
                Suffix: "90 min",
                Units: "\xb0T TO"
            },
            "Total_CurrentSpeed/Surface_kts_90min_Mean": {
                AllowPlot: true,
                AxisLabel: "Current Speed",
                Default: true,
                PlotLine: true,
                Suffix: "90 min",
                Units: "kts"
            },
            "Total_SeaElevationAtCmax/m_30min": {
                AllowPlot: true,
                AxisLabel: "Sea Surface",
                Default: true,
                PlotLine: true,
                Suffix: "30 min",
                Units: "m"
            },
            "Tp/s_45min": {
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                Default: true,
                PlotLine: true,
                Suffix: "45 min",
                Units: "s"
            },
            "ValidAirGapCount/30min": {
                AllowPlot: true,
                AxisLabel: "Air Gap",
                Default: true,
                PlotLine: true,
                Suffix: "30 min",
                Units: "m"
            },
            "ValidValueCount/30min": {
                AllowPlot: true,
                AxisLabel: "Count",
                Default: true,
                PlotLine: true,
                Suffix: "30 min"
            },
            "WaveFiltersStatus": {
                AllowPlot: false,
                Default: true
            },
            "WaveSpectrum": {
                AllowPlot: false,
                Default: true
            },
            "WindChill/degC_2min_Mean": {
                AllowPlot: true,
                AxisLabel: "Temperature",
                Default: true,
                PlotLine: true,
                Suffix: "2 min",
                Units: "\xb0C"
            },
            // added by Nicolas - missing from dbo.ParameterListEntries :
            "AirTemperature_degC": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C"
            },
            "Cass_m": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                PlotLine: true,
                Units: "m"
            },
            "Cmax_m": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                PlotLine: true,
                Units: "m"
            },
            "DewPoint_degC": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C"
            },
            "First_CloudBaseHeight_ft": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Units: "ft"
            },
            "First_CloudBaseHeight_ft_Inst": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Suffix: "Inst",
                Units: "ft"
            },
            "First_CloudCover": {
                Default: true,
                AllowPlot: false
            },
            "GustSpeed_kts": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Speed",
                AxisMin: 0,
                PlotLine: true,
                Units: "kts"
            },
            "Heave/m_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Height",
                PlotLine: true,
                Units: "m"
            },
            "Hs_m": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Height",
                AxisMin: 0,
                PlotLine: true,
                Units: "m"
            },
            "MeanSpreading_PrimaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                AxisMin: 0,
                PlotLine: false,
                Units: "\xb0"
            },
            "MeanSpreading_PrimaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                AxisMin: 0,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0"
            },
            "MeanSpreading_SecondaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                AxisMin: 0,
                PlotLine: false,
                Units: "\xb0"
            },
            "MeanSpreading_SecondaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Spreading",
                AxisMin: 0,
                PlotLine: false,
                Suffix: "45 min",
                Units: "\xb0"
            },
            "MeanWaveDirection_PrimaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "MeanWaveDirection_PrimaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "45 min"
            },
            "MeanWaveDirection_SecondaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "MeanWaveDirection_SecondaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "45 min"
            },
            "MeanWaveDirection_Swell1/deg_30min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "30 min"
            },
            "MeanWaveDirection_WindSea/deg_30min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "30 min"
            },
            "MotionAccelerationX/mps2_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Acceleration",
                PlotLine: true,
                Units: "m/s^2"
            },
            "MotionAccelerationY/mps2_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Acceleration",
                PlotLine: true,
                Units: "m/s^2"
            },
            "MotionAccelerationZ/mps2_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Acceleration",
                PlotLine: true,
                Units: "m/s^2"
            },
            "PeakWaveDirection_PrimaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "PeakWaveDirection_PrimaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "45 min"
            },
            "PeakWaveDirection_SecondaryWaveComponent/deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "PeakWaveDirection_SecondaryWaveComponent/deg_45min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM",
                Suffix: "45 min"
            },
            "Pitch/deg_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0"
            },
            "QNH_mbar": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Pressure",
                PlotLine: true,
                Units: "hPa"
            },
            "RelativeHumidity_pc": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Humidity",
                PlotLine: true,
                Units: "%"
            },
            "Roll/deg_Raw": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Angle",
                PlotLine: true,
                Units: "\xb0"
            },
            "Second_CloudBaseHeight_ft": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Units: "ft"
            },
            "Second_CloudBaseHeight_ft_Inst": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Units: "ft",
                Suffix: "Inst"
            },
            "Second_CloudCover": {
                Default: true,
                AllowPlot: false
            },
            "T2_s": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                PlotLine: true,
                Units: "s"
            },
            "T2_Swell1/s_30min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                PlotLine: true,
                Units: "s",
                Suffix: "30 min"
            },
            "T2_WindSea/s_30min": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                PlotLine: true,
                Units: "s",
                Suffix: "30 min"
            },
            "Third_CloudBaseHeight_ft": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Units: "ft"
            },
            "Third_CloudBaseHeight_ft_Inst": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Cloud Height",
                AxisMin: 0,
                PlotLine: false,
                Units: "ft",
                Suffix: "Inst"
            },
            "Third_CloudCover": {
                Default: true,
                AllowPlot: false
            },
            "Total_CurrentDirection/Surface_deg_Mean_BCM": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: true,
                Units: "\xb0 TO"
            },
            "Total_CurrentSpeed/Surface_mps_Mean_BCM": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Current Speed",
                PlotLine: true,
                Units: "m/s"
            },
            "Tp_s": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                PlotLine: true,
                Units: "s"
            },
            "Tz_s": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Wave Period",
                AxisMin: 0,
                PlotLine: true,
                Units: "s"
            },
            "Visibility_m": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Visibility",
                PlotLine: true,
                Units: "m"
            },
            "WindChill_degC": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Temperature",
                PlotLine: true,
                Units: "\xb0C"
            },
            "WindDirection_Backed_deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "WindDirection_deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "WindDirection_Veered_deg": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Direction From",
                AxisMin: 0,
                AxisMax: 360,
                PlotLine: false,
                Units: "\xb0T FROM"
            },
            "WindSpeed_kts": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Speed",
                AxisMin: 0,
                PlotLine: true,
                Units: "kts"
            },
            "WindSpeed/mps_10min_Mean": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Speed",
                AxisMin: 0,
                PlotLine: true,
                Units: "m/s",
                Suffix: "10 min"
            },
            "WindSpeed/mps_2min_Mean": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Speed",
                AxisMin: 0,
                PlotLine: true,
                Units: "m/s",
                Suffix: "2 min"
            },
            "WindSpeed/mps_3sec_Mean": {
                Default: true,
                AllowPlot: true,
                AxisLabel: "Speed",
                AxisMin: 0,
                PlotLine: true,
                Units: "m/s",
                Suffix: "3 sec"
            }
        };
    }
}



var $3f0b9745f7124153$export$23811558a05557 = /*#__PURE__*/ function(WarningThreshold) {
    WarningThreshold[WarningThreshold["OK"] = 0] = "OK";
    WarningThreshold[WarningThreshold["Level1"] = 1] = "Level1";
    WarningThreshold[WarningThreshold["Level2"] = 2] = "Level2";
    WarningThreshold[WarningThreshold["Level3"] = 3] = "Level3";
    return WarningThreshold;
}({});


function $8ed788ecc5d8a807$export$ba9136f38d1702aa(warningGroup, value, parameterGroupInfo, station) {
    if (warningGroup.IsFrontEndWarningRuleSet && warningGroup.Id in FrontEndWarningRules.map) {
        var ruleSet = FrontEndWarningRules.map[warningGroup.Id];
        return ruleSet.getWarningThreshold(parameterGroupInfo, value, station);
    } else if (parameterGroupInfo.Id in warningGroup.Rules) {
        // old-style server-side warning groups
        var rule = warningGroup.Rules[parameterGroupInfo.Id];
        if (rule.Gt_HighPriority !== null && value > rule.Gt_HighPriority || rule.Lt_HighPriority !== null && value < rule.Lt_HighPriority) return (0, $3f0b9745f7124153$export$23811558a05557).Level3;
        else if (rule.Gt_MediumPriority !== null && value > rule.Gt_MediumPriority || rule.Lt_MediumPriority !== null && value < rule.Lt_MediumPriority) return (0, $3f0b9745f7124153$export$23811558a05557).Level2;
        else if (rule.Gt_LowPriority !== null && value > rule.Gt_LowPriority || rule.Lt_LowPriority !== null && value < rule.Lt_LowPriority) return (0, $3f0b9745f7124153$export$23811558a05557).Level1;
        else return (0, $3f0b9745f7124153$export$23811558a05557).OK;
    } else return (0, $3f0b9745f7124153$export$23811558a05557).OK;
}


class $24b391ec3014929b$export$5d65fdcfff509e37 {
    static{
        // Wind
        this.WindSpeed_kts = {
            Id: 'WindSpeed_kts',
            ShortName: 'Wind Spd',
            Units: 'kts',
            Description: 'Scalar mean speed of wind velocity',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts = {
            Id: 'GustSpeed_kts',
            ShortName: 'Gust Spd',
            Units: 'kts',
            Description: 'Maximum gust speed in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.WindDirection_deg = {
            Id: 'WindDirection_deg',
            ShortName: 'Wind Dir.',
            Units: "\xb0T FROM",
            Description: 'Vector mean direction of wind velocity',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WindDirection_Backed_deg = {
            Id: 'WindDirection_Backed_deg',
            ShortName: 'Wind Backed',
            Units: "\xb0T FROM",
            Description: 'Maximum counter-clockwise extent of wind variation',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WindDirection_Veered_deg = {
            Id: 'WindDirection_Veered_deg',
            ShortName: 'Wind Veered',
            Units: "\xb0T FROM",
            Description: 'Maximum clockwise extent of wind variation',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WindSelectedSensorId = {
            Id: 'WindSelectedSensorId',
            ShortName: 'Wind Selected Sensor',
            Units: null,
            Description: 'The selected wind sensor',
            Format: null,
            Plottable: false
        };
    }
    static{
        // Wind Fixed Interval
        this.WindSpeed_kts_10min = {
            Id: 'WindSpeed_kts_10min',
            ShortName: 'Wind Spd (10 min)',
            Units: 'kts',
            Description: 'Vector mean speed of wind velocity',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts_10min = {
            Id: 'GustSpeed_kts_10min',
            ShortName: 'Gust Spd (10 min)',
            Units: 'kts',
            Description: 'Maximum gust speed in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.WindDirection_deg_10min = {
            Id: 'WindDirection_deg_10min',
            ShortName: 'Wind Dir. (10 min)',
            Units: "\xb0T FROM",
            Description: 'Vector mean direction of wind velocity',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WindSpeed_kts_1min = {
            Id: 'WindSpeed_kts_1min',
            ShortName: 'Wind Spd (1 min)',
            Units: 'kts',
            Description: 'Vector mean speed of wind velocity',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts_1min = {
            Id: 'GustSpeed_kts_1min',
            ShortName: 'Gust Spd (1 min)',
            Units: 'kts',
            Description: 'Maximum gust speed in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.WindDirection_deg_1min = {
            Id: 'WindDirection_deg_1min',
            ShortName: 'Wind Dir. (1 min)',
            Units: "\xb0T FROM",
            Description: 'Vector mean direction of wind velocity',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WindSpeed_kts_10m = {
            Id: 'WindSpeed_kts_10m',
            ShortName: 'Wind Spd 10m',
            Units: 'kts',
            Description: 'Scalar mean speed of wind velocity at 10m',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts_10m = {
            Id: 'GustSpeed_kts_10m',
            ShortName: 'Gust Spd 10m',
            Units: 'kts',
            Description: 'Maximum gust speed at 10m in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.WindSpeed_kts_10m_1min = {
            Id: 'WindSpeed_kts_10m_1min',
            ShortName: 'Wind Spd 10m (1 min)',
            Units: 'kts',
            Description: 'Vector mean speed of wind velocity at 10m',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts_10m_1min = {
            Id: 'GustSpeed_kts_10m_1min',
            ShortName: 'Gust Spd 10m (1 min)',
            Units: 'kts',
            Description: 'Maximum gust speed at 10m in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.WindSpeed_kts_10m_10min = {
            Id: 'WindSpeed_kts_10m_10min',
            ShortName: 'Wind Spd 10m (10 min)',
            Units: 'kts',
            Description: 'Vector mean speed of wind velocity at 10m',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.GustSpeed_kts_10m_10min = {
            Id: 'GustSpeed_kts_10m_10min',
            ShortName: 'Gust Spd 10m (10 min)',
            Units: 'kts',
            Description: 'Maximum gust speed at 10m in recording interval',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        // Meteorological
        this.AirTemperature_degC = {
            Id: 'AirTemperature_degC',
            ShortName: 'Air Temp',
            Units: "\xb0C",
            Description: 'Dry bulb air temperature',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.WaterTemp_degC = {
            Id: 'WaterTemp_degC',
            ShortName: 'Water Temp',
            Units: "\xb0C",
            Description: 'Water temperature',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.QFE_mbar = {
            Id: 'QFE_mbar',
            ShortName: 'QFE',
            Units: 'hPa',
            Description: 'Barometric pressure adjusted to field elevation',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.QFE_mbar_HelideckC = {
            Id: 'QFE_mbar',
            ShortName: 'QFE C',
            Units: 'hPa',
            Description: 'Barometric pressure adjusted to field elevation',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.QFE_mbar_HelideckP = {
            Id: 'QFE_mbar',
            ShortName: 'QFE P',
            Units: 'hPa',
            Description: 'Barometric pressure adjusted to field elevation',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.QNH_mbar = {
            Id: 'QNH_mbar',
            ShortName: 'QNH',
            Units: 'hPa',
            Description: 'Barometric pressure adjusted to sea level',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.DewPoint_degC = {
            Id: 'DewPoint_degC',
            ShortName: 'Dew Point',
            Units: "\xb0C",
            Description: 'The temperature at which condensation occurs',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.RelativeHumidity_pc = {
            Id: 'RelativeHumidity_pc',
            ShortName: 'Humidity',
            Units: '%',
            Description: 'Percentage of the maximum possible amount of water contained in the air',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 100
        };
    }
    static{
        this.WindChill_degC = {
            Id: 'WindChill_degC',
            ShortName: 'Wind Chill',
            Units: "\xb0C",
            Description: 'The apparent temperature felt on exposed skin due to wind',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.SolarRadiation_mWpcm2 = {
            Id: 'SolarRadiation_mWpcm2',
            ShortName: 'Solar Rad.',
            Units: 'mW/cm^2',
            Description: 'Solar radiation flux density',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.METAR = {
            Id: 'METAR',
            ShortName: 'METAR',
            Units: null,
            Description: 'METAR',
            Format: null,
            Plottable: false
        };
    }
    static{
        // Cloud, Vis, Weather
        this.Visibility_m = {
            Id: 'Visibility_m',
            ShortName: 'Visibility',
            Units: 'm',
            Description: 'Distance that can be seen clearly',
            Format: '%.0f',
            Plottable: true
        };
    }
    static{
        this.PresentWeather = {
            Id: 'PresentWeather',
            ShortName: 'Present Weather',
            Units: null,
            Description: 'Present Weather in METAR coding format',
            Format: null,
            Plottable: false
        };
    }
    static{
        this.RainfallIntensity_mmphour = {
            Id: 'RainfallIntensity_mmphour',
            ShortName: 'Rainfall',
            Units: 'mm / hour',
            Description: 'Total rainfall in 1 hour',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.First_CloudBaseHeight_ft = {
            Id: 'First_CloudBaseHeight_ft',
            ShortName: 'Cloud Ht 1',
            Units: 'ft',
            Description: 'Height of lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        this.Second_CloudBaseHeight_ft = {
            Id: 'Second_CloudBaseHeight_ft',
            ShortName: 'Cloud Ht 2',
            Units: 'ft',
            Description: 'Height of second lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        this.Third_CloudBaseHeight_ft = {
            Id: 'Third_CloudBaseHeight_ft',
            ShortName: 'Cloud Ht 3',
            Units: 'ft',
            Description: 'Height of third lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        this.First_CloudCover = {
            Id: 'First_CloudCover',
            ShortName: 'Cloud Amt 1',
            Units: null,
            Description: 'The amount of sky obscured by clouds in the lowest cloud base',
            Format: null,
            Plottable: false
        };
    }
    static{
        this.Second_CloudCover = {
            Id: 'Second_CloudCover',
            ShortName: 'Cloud Amt 2',
            Units: null,
            Description: 'The amount of sky obscured by clouds in the second lowest cloud base',
            Format: null,
            Plottable: false
        };
    }
    static{
        this.Third_CloudCover = {
            Id: 'Third_CloudCover',
            ShortName: 'Cloud Amt 3',
            Units: null,
            Description: 'The amount of sky obscured by clouds in the third lowest cloud base',
            Format: null,
            Plottable: false
        };
    }
    static{
        this.First_CloudBaseHeight_ft_Inst = {
            Id: 'First_CloudBaseHeight_ft_Inst',
            ShortName: 'Cloud Ht 1 Inst',
            Units: 'ft',
            Description: 'Instantaneous height of lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        this.Second_CloudBaseHeight_ft_Inst = {
            Id: 'Second_CloudBaseHeight_ft_Inst',
            ShortName: 'Cloud Ht 2 Inst',
            Units: 'ft',
            Description: 'Instantaneous height of second lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        this.Third_CloudBaseHeight_ft_Inst = {
            Id: 'Third_CloudBaseHeight_ft_Inst',
            ShortName: 'Cloud Ht 3 Inst',
            Units: 'ft',
            Description: 'Instantaneous height of third lowest cloud base',
            Format: '%.0f',
            Plottable: true,
            PlotLine: false,
            AxisMin: 0
        };
    }
    static{
        // Vessel
        this.Heading_deg = {
            Id: 'Heading_deg',
            ShortName: 'Heading',
            Units: "\xb0",
            Description: 'Heading towards which bow of vessel is pointing',
            Format: '%.0f',
            Plottable: true
        };
    }
    static{
        this.Vessel_Latitude_deg = {
            Id: 'Vessel_Latitude_deg',
            ShortName: 'Latitude',
            Units: "\xb0",
            Description: 'Vessel Latitude',
            Format: '%.3f',
            Plottable: true
        };
    }
    static{
        this.Vessel_Longitude_deg = {
            Id: 'Vessel_Longitude_deg',
            ShortName: 'Longitude',
            Units: "\xb0",
            Description: 'Vessel Longitude',
            Format: '%.3f',
            Plottable: true
        };
    }
    static{
        this.PitchBowUp_deg_Max = {
            Id: 'PitchBowUp_deg_Max',
            ShortName: 'Max Pitch Bow Up',
            Units: "\xb0",
            Description: 'Maximum angle of rotation from vertical, positive bow up',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.PitchBowDown_deg_Max = {
            Id: 'PitchBowDown_deg_Max',
            ShortName: 'Max Pitch Bow Down',
            Units: "\xb0",
            Description: 'Maximum angle of rotation from vertical, positive bow down',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Roll_Left_deg_Max = {
            Id: 'Roll_Left_deg_Max',
            ShortName: 'Max Roll Left',
            Units: "\xb0",
            Description: 'Maximum angle of rotation from vertical, positive portside down',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Roll_Right_deg_Max = {
            Id: 'Roll_Right_deg_Max',
            ShortName: 'Max Roll Right',
            Units: "\xb0",
            Description: 'Maximum angle of rotation from vertical, positive portside up',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Inclination_deg_Max = {
            Id: 'Inclination_deg_Max',
            ShortName: 'Max Inclination',
            Units: "\xb0",
            Description: 'Maximum angle of deck from normal',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Heave_Rate_mps_Max = {
            Id: 'Heave_Rate_mps_Max',
            ShortName: 'Max Heave Rate',
            Units: 'm/s',
            Description: 'Maximum rate of vertical displacement',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Heave_Period_s_Mean = {
            Id: 'Heave_Period_s_Mean',
            ShortName: 'Mean Heave Period',
            Units: 's',
            Description: 'Mean period of vertical displacement motion',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Heave_m_Max = {
            Id: 'Heave_m_Max',
            ShortName: 'Max Heave',
            Units: 'm',
            Description: 'Maximum magnitude of vertical displacement',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.MMS = {
            Id: 'MMS',
            ShortName: 'MMS',
            Units: null,
            Description: 'Measure of motion severity',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.MSI = {
            Id: 'MSI',
            ShortName: 'MSI',
            Units: null,
            Description: 'Motion severity index',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Excursion_Distance_m_Max = {
            Id: 'Excursion_Distance_m_Max',
            ShortName: 'Max Excursion',
            Units: 'm',
            Description: 'Maximum Excursion Distance',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Excursion_Bearing_deg = {
            Id: 'Excursion_Bearing_deg',
            ShortName: 'Excursion Bearing',
            Units: "\xb0T FROM",
            Description: 'Bearing of Maximum Excursion',
            Format: '%03.0f',
            Plottable: true
        };
    }
    static{
        // Wave
        this.Hs_m = {
            Id: 'Hs_m',
            ShortName: 'Hs',
            Units: 'm',
            Description: 'Significant wave height',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.Hmax_m = {
            Id: 'Hmax_m',
            ShortName: 'Hmax',
            Units: 'm',
            Description: 'Maximum upcrossing individual wave height from time domain',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.Cmax_m = {
            Id: 'Cmax_m',
            ShortName: 'Cmax',
            Units: 'm',
            Description: 'Maximum crest height',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.Cass_m = {
            Id: 'Cass_m',
            ShortName: 'Cass',
            Units: 'm',
            Description: 'Crest associated with the maximum wave height',
            Format: '%.1f',
            Plottable: false,
            AxisMin: 0
        };
    }
    static{
        this.Tp_s = {
            Id: 'Tp_s',
            ShortName: 'Tp',
            Units: 's',
            Description: 'Spectral peak period of the full spectrum',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0,
            PlotLine: false
        };
    }
    static{
        this.Tz_s = {
            Id: 'Tz_s',
            ShortName: 'Tz',
            Units: 's',
            Description: 'Mean zero-upcrossing wave period from time domain',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.T2_s = {
            Id: 'T2_s',
            ShortName: 'T2',
            Units: 's',
            Description: 'Average wave period defined by SQRT(M0/M2) from frequency domain',
            Format: '%.1f',
            Plottable: true,
            AxisMin: 0
        };
    }
    static{
        this.MeanWaveDirection_deg = {
            Id: 'MeanWaveDirection_deg',
            ShortName: 'Mean Dir.',
            Units: "\xb0T FROM",
            Description: 'Average wave direction of the full spectrum',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.PeakWaveDirection_deg = {
            Id: 'PeakWaveDirection_deg',
            ShortName: 'Peak Dir.',
            Units: "\xb0T FROM",
            Description: 'Peak wave direction of the full spectrum',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.PeakSpreading_deg = {
            Id: 'PeakSpreading_deg',
            ShortName: 'Peak Spread',
            Units: "\xb0",
            Description: 'Directional spreading of peak frequency',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.MeanSpreading_deg = {
            Id: 'MeanSpreading_deg',
            ShortName: 'Mean Spread',
            Units: "\xb0",
            Description: 'Average directional spreading of the full spectrum',
            Format: '%.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.WaveSpectrum = {
            Id: 'WaveSpectrum',
            ShortName: 'Spectrum',
            Units: null,
            Description: 'Wave spectrum',
            Format: null,
            Plottable: false
        };
    }
    static{
        // Current
        this.Total_CurrentSpeed_Peak_mps_Mean = {
            Id: 'Total_CurrentSpeed_Peak_mps_Mean',
            ShortName: 'Peak Current Spd',
            Units: 'mps',
            Description: 'Peak current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentDirection_Peak_deg_Mean = {
            Id: 'Total_CurrentDirection_Peak_deg_Mean',
            ShortName: 'Peak Current Dir.',
            Units: "\xb0T TO",
            Description: 'Peak current direction',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.MeasurementDepth_Total_Current_Peak_deg_Mean = {
            Id: 'MeasurementDepth_Total_Current_Peak_deg_Mean',
            ShortName: 'Peak Current Depth',
            Units: 'm',
            Description: 'Peak current depth',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentSpeed_Surface_mps_Mean = {
            Id: 'Total_CurrentSpeed_Surface_mps_Mean',
            ShortName: 'Near Sfc. Current Spd',
            Units: 'mps',
            Description: 'Near surface current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentDirection_Surface_deg_Mean = {
            Id: 'Total_CurrentDirection_Surface_deg_Mean',
            ShortName: 'Near Sfc. Current Dir.',
            Units: "\xb0T TO",
            Description: 'Near surface current direction',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.Total_CurrentSpeed_Middle_mps_Mean = {
            Id: 'Total_CurrentSpeed_Middle_mps_Mean',
            ShortName: 'Mid. Current Spd',
            Units: 'mps',
            Description: 'Middle current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentDirection_Middle_deg_Mean = {
            Id: 'Total_CurrentDirection_Middle_deg_Mean',
            ShortName: 'Mid. Current Dir.',
            Units: "\xb0T TO",
            Description: 'Middle current direction',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.Total_CurrentSpeed_Bottom_mps_Mean = {
            Id: 'Total_CurrentSpeed_Bottom_mps_Mean',
            ShortName: 'Bottom Current Spd',
            Units: 'mps',
            Description: 'Btm. current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentDirection_Bottom_deg_Mean = {
            Id: 'Total_CurrentDirection_Bottom_deg_Mean',
            ShortName: 'Btm. Current Dir.',
            Units: "\xb0T TO",
            Description: 'Bottom current direction',
            Format: '%03.0f',
            Plottable: true,
            AxisMin: 0,
            AxisMax: 360,
            PlotLine: false
        };
    }
    static{
        this.Total_CurrentSpeed_Peak_kts_Mean = {
            Id: 'Total_CurrentSpeed_Peak_kts_Mean',
            ShortName: 'Peak Current Spd',
            Units: 'kts',
            Description: 'Peak current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentSpeed_Surface_kts_Mean = {
            Id: 'Total_CurrentSpeed_Surface_kts_Mean',
            ShortName: 'Sfc. Current Spd',
            Units: 'kts',
            Description: 'Surface current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentSpeed_Middle_kts_Mean = {
            Id: 'Total_CurrentSpeed_Middle_kts_Mean',
            ShortName: 'Mid. Current Spd',
            Units: 'kts',
            Description: 'Middle current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_CurrentSpeed_Bottom_kts_Mean = {
            Id: 'Total_CurrentSpeed_Bottom_kts_Mean',
            ShortName: 'Bottom Current Spd',
            Units: 'kts',
            Description: 'Btm. current speed',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.CurrentProfile = {
            Id: 'CurrentProfile',
            ShortName: 'Current Profile',
            Units: 'm',
            Description: 'Current Profile',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        // Water Level
        this.Total_SeaElevation_m_Mean = {
            Id: 'Total_SeaElevation_m_Mean',
            ShortName: 'Mean WL',
            Units: 'm',
            Description: 'Total water level (Mean)',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.Total_SeaElevation_m_Max = {
            Id: 'Total_SeaElevation_m_Max',
            ShortName: 'Max TWL',
            Units: 'm',
            Description: 'Total water level (Max)',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        this.AirGap_m = {
            Id: 'AirGap_m',
            ShortName: 'Air Gap',
            Units: 'm',
            Description: 'Radar air gap (Mean)',
            Format: '%.1f',
            Plottable: true
        };
    }
    static{
        // Wave Buoy
        this.Buoy_Latitude_deg = {
            Id: 'Buoy_Latitude_deg',
            ShortName: 'Latitude',
            Units: "\xb0",
            Description: 'Buoy Latitude',
            Format: '%.5f',
            Plottable: true
        };
    }
    static{
        this.Buoy_Longitude_deg = {
            Id: 'Buoy_Longitude_deg',
            ShortName: 'Longitude',
            Units: "\xb0",
            Description: 'Buoy Longitude',
            Format: '%.5f',
            Plottable: true
        };
    }
    static{
        this.Buoy_Excursion_m = {
            Id: 'Buoy_Excursion_m',
            ShortName: 'Excursion',
            Units: 'm',
            Description: 'Buoy excursion from target location',
            Format: '%.0f',
            Plottable: true
        };
    }
    static{
        // Helideck Status
        this.Helideck_Status = {
            Id: 'Helideck_Status',
            ShortName: 'Helideck Status',
            Units: 'm',
            Description: 'Helideck status based on station-specific wind speed and direction rules',
            Format: '1d',
            Plottable: true
        };
    }
    static{
        //Riser tension (implemented initially for Malikai)
        this.RiserTension_kN = {
            Id: 'RiserTension_kN',
            ShortName: 'Riser Tension',
            Units: 'kN',
            Description: 'Riser tension',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.RiserTensionerPressure1_psi = {
            Id: 'RiserTensionerPressure1_psi',
            ShortName: 'Tensioner Pressure (PT1)',
            Units: 'psi',
            Description: 'Tensioner pressure (PT1)',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.RiserTensionerPressure2_psi = {
            Id: 'RiserTensionerPressure2_psi',
            ShortName: 'Tensioner Pressure (PT2)',
            Units: 'psi',
            Description: 'Tensioner pressure (PT2)',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.RiserTensionerPressure3_psi = {
            Id: 'RiserTensionerPressure3_psi',
            ShortName: 'Tensioner Pressure (PT3)',
            Units: 'psi',
            Description: 'Tensioner pressure (PT3)',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.RiserTensionerPressure4_psi = {
            Id: 'RiserTensionerPressure4_psi',
            ShortName: 'Tensioner Pressure (PT4)',
            Units: 'psi',
            Description: 'Tensioner pressure (PT4)',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.Pitch_deg = {
            Id: 'Pitch_deg',
            ShortName: 'Pitch',
            Units: "\xb0",
            Description: 'Pitch',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.Roll_deg = {
            Id: 'Roll_deg',
            ShortName: 'Roll',
            Units: "\xb0",
            Description: 'Roll',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.SurgeAcceleration_mps2 = {
            Id: 'SurgeAcceleration_mps2',
            ShortName: 'Surge Acceleration',
            Units: "m/s\xb2",
            Description: 'Surge Acceleration',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.SwayAcceleration_mps2 = {
            Id: 'SwayAcceleration_mps2',
            ShortName: 'Sway Acceleration',
            Units: "m/s\xb2",
            Description: 'Sway Acceleration',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.Heave_m = {
            Id: 'Heave_m',
            ShortName: 'Heave',
            Units: 'm',
            Description: 'Heave',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.Draft_m = {
            Id: 'Draft_m',
            ShortName: 'Draft',
            Units: 'm',
            Description: 'Draft',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.InclinationNS_deg = {
            Id: 'InclinationNS_deg',
            ShortName: 'Inclination NS',
            Units: "\xb0",
            Description: 'Inclination NS',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.InclinationEW_deg = {
            Id: 'InclinationEW_deg',
            ShortName: 'Inclination EW',
            Units: "\xb0",
            Description: 'Inclination EW',
            Format: '%.1f',
            Plottable: false
        };
    }
    static{
        this.TEMPSC_Status = {
            Id: 'TEMPSC_Status',
            ShortName: 'TEMPSC Status',
            Units: null,
            Description: 'TEMPSC Status',
            Format: null,
            Plottable: false
        };
    }
}


class $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4 {
    constructor(parameterGroup, sensorId){
        this.parameterGroup = parameterGroup;
        this.sensorId = sensorId;
    }
    getShortName() {
        return this.parameterGroup.ShortName;
    }
    getUnits() {
        return (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.parameterGroup.Units, this.parameterGroup.Id);
    }
    getParameterGroupInfo() {
        return this.parameterGroup;
    }
    getDescription() {
        return this.parameterGroup.Description;
    }
    getId() {
        return this.parameterGroup.Id;
    }
    getSensorId() {
        return this.sensorId;
    }
    plottable() {
        if (typeof this.parameterGroup.Plottable == 'undefined') return true;
        return this.parameterGroup.Plottable;
    }
    axisMin() {
        if (typeof this.parameterGroup.AxisMin == 'undefined') return null;
        return this.parameterGroup.AxisMin;
    }
    axisMax() {
        if (typeof this.parameterGroup.AxisMax == 'undefined') return null;
        return this.parameterGroup.AxisMax;
    }
    plotLines() {
        if (typeof this.parameterGroup.PlotLine == 'undefined') return true;
        return this.parameterGroup.PlotLine;
    }
    getLiveDataSetValue(liveDataSetStation) {
        var value = null;
        //console.log('')
        //console.log('liveDataSetStation.GroupValues:', liveDataSetStation.GroupValues)
        //console.log('this.parameterGroup.Id', this.parameterGroup.Id)
        //console.log('liveDataSetStation.GroupValues', liveDataSetStation.GroupValues)
        //console.log('this.sensorId', this.sensorId)
        //console.log('')
        if (liveDataSetStation?.GroupValues && this.parameterGroup.Id in liveDataSetStation.GroupValues) {
            if (this.sensorId) {
                if (!liveDataSetStation.GroupValues[this.parameterGroup.Id].some((_value)=>{
                    if (_value.Sensor == this.sensorId) {
                        value = _value;
                        return true;
                    }
                    return false;
                })) // a sensor id has been specified, but the group value is not present for this sensor
                return null;
            } else value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
        }
        return value;
    }
    format(liveDataSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        };
        const value = this.getLiveDataSetValue(liveDataSetStation);
        if (value == null) return valueObject;
        if (!(0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[value.Sensor]) return valueObject;
        var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema?.Stations?.[liveDataSetStation.Station.Id]?.Sensors?.[value.Sensor]?.Parameters?.[value.Parameter]?.Variants?.[0]?.ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[value.Parameter];
        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        };
        if (value.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        // console.info(`DefaultGroupFormatter.getConversionSet...`, this.parameterGroup.Units, this.parameterGroup);
        let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.parameterGroup.Units, this.parameterGroup.Id);
        if (value.Value === null || value.Value === 'NIL') // can be the case for cloud heights, etc
        valueObject.Value = '';
        else if (typeof value.Value == 'number' && this.parameterGroup.Format) {
            // valueObject.Value = sprintf(this.parameterGroup.Format, MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup));
            if (unitsConversionSet) {
                if (this.parameterGroup == (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m) valueObject.Value = sprintf('%.2f', unitsConversionSet.convertValue(value.Value));
                else valueObject.Value = sprintf(this.parameterGroup.Format, unitsConversionSet.convertValue(value.Value));
            } else valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);
            if (warningRules) valueObject.WarningThreshold = (0, $8ed788ecc5d8a807$export$ba9136f38d1702aa)(warningRules, value.Value, this.parameterGroup, liveDataSetStation);
        } else valueObject.Value = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup.Id).toString();
        return valueObject;
    }
}





var $8NFma = parcelRequire("8NFma");
var $1c0f1e610963dfb8$exports = {};
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

$1c0f1e610963dfb8$exports = (parcelRequire("23wBm"));





var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");


var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $6T5ne = parcelRequire("6T5ne");

var $5eWZU = parcelRequire("5eWZU");

var $aobdI = parcelRequire("aobdI");
var $4ZuKt = parcelRequire("4ZuKt");

var $1l95P = parcelRequire("1l95P");


var $jz4iA = parcelRequire("jz4iA");
function $c3e46a7a3c550973$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $jz4iA.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $6T5ne = parcelRequire("6T5ne");

var $5eWZU = parcelRequire("5eWZU");
var $81e0702aaae9b086$exports = {};
"use strict";
var $32327384249c777c$exports = {};
function $32327384249c777c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$32327384249c777c$exports = $32327384249c777c$var$_interopRequireDefault, $32327384249c777c$exports.__esModule = true, $32327384249c777c$exports["default"] = $32327384249c777c$exports;


Object.defineProperty($81e0702aaae9b086$exports, "__esModule", {
    value: true
});
$81e0702aaae9b086$exports.alpha = $81e0702aaae9b086$var$alpha;
$81e0702aaae9b086$exports.blend = $81e0702aaae9b086$var$blend;
$81e0702aaae9b086$exports.colorChannel = void 0;
$81e0702aaae9b086$exports.darken = $81e0702aaae9b086$var$darken;
$81e0702aaae9b086$exports.decomposeColor = $81e0702aaae9b086$var$decomposeColor;
$81e0702aaae9b086$exports.emphasize = $81e0702aaae9b086$var$emphasize;
$81e0702aaae9b086$exports.getContrastRatio = $81e0702aaae9b086$var$getContrastRatio;
$81e0702aaae9b086$exports.getLuminance = $81e0702aaae9b086$var$getLuminance;
$81e0702aaae9b086$exports.hexToRgb = $81e0702aaae9b086$var$hexToRgb;
$81e0702aaae9b086$exports.hslToRgb = $81e0702aaae9b086$var$hslToRgb;
$81e0702aaae9b086$exports.lighten = $81e0702aaae9b086$var$lighten;
$81e0702aaae9b086$exports.private_safeAlpha = $81e0702aaae9b086$var$private_safeAlpha;
$81e0702aaae9b086$exports.private_safeColorChannel = void 0;
$81e0702aaae9b086$exports.private_safeDarken = $81e0702aaae9b086$var$private_safeDarken;
$81e0702aaae9b086$exports.private_safeEmphasize = $81e0702aaae9b086$var$private_safeEmphasize;
$81e0702aaae9b086$exports.private_safeLighten = $81e0702aaae9b086$var$private_safeLighten;
$81e0702aaae9b086$exports.recomposeColor = $81e0702aaae9b086$var$recomposeColor;
$81e0702aaae9b086$exports.rgbToHex = $81e0702aaae9b086$var$rgbToHex;

var $81e0702aaae9b086$var$_formatMuiErrorMessage2 = $32327384249c777c$exports((parcelRequire("ejyEb")));

var $81e0702aaae9b086$var$_clamp = $32327384249c777c$exports((parcelRequire("iB2j3")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $81e0702aaae9b086$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $81e0702aaae9b086$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $81e0702aaae9b086$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $81e0702aaae9b086$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $81e0702aaae9b086$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $81e0702aaae9b086$var$decomposeColor($81e0702aaae9b086$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $81e0702aaae9b086$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $81e0702aaae9b086$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $81e0702aaae9b086$var$colorChannel = (color)=>{
    const decomposedColor = $81e0702aaae9b086$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
$81e0702aaae9b086$exports.colorChannel = $81e0702aaae9b086$var$colorChannel;
const $81e0702aaae9b086$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $81e0702aaae9b086$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $81e0702aaae9b086$exports.private_safeColorChannel = $81e0702aaae9b086$var$private_safeColorChannel;
function $81e0702aaae9b086$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $81e0702aaae9b086$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $81e0702aaae9b086$var$decomposeColor(color);
    return `#${values.map((n, i)=>$81e0702aaae9b086$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $81e0702aaae9b086$var$hslToRgb(color) {
    color = $81e0702aaae9b086$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $81e0702aaae9b086$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $81e0702aaae9b086$var$getLuminance(color) {
    color = $81e0702aaae9b086$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $81e0702aaae9b086$var$decomposeColor($81e0702aaae9b086$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $81e0702aaae9b086$var$getContrastRatio(foreground, background) {
    const lumA = $81e0702aaae9b086$var$getLuminance(foreground);
    const lumB = $81e0702aaae9b086$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $81e0702aaae9b086$var$alpha(color, value) {
    color = $81e0702aaae9b086$var$decomposeColor(color);
    value = $81e0702aaae9b086$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $81e0702aaae9b086$var$recomposeColor(color);
}
function $81e0702aaae9b086$var$private_safeAlpha(color, value, warning) {
    try {
        return $81e0702aaae9b086$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $81e0702aaae9b086$var$darken(color, coefficient) {
    color = $81e0702aaae9b086$var$decomposeColor(color);
    coefficient = $81e0702aaae9b086$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $81e0702aaae9b086$var$recomposeColor(color);
}
function $81e0702aaae9b086$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $81e0702aaae9b086$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $81e0702aaae9b086$var$lighten(color, coefficient) {
    color = $81e0702aaae9b086$var$decomposeColor(color);
    coefficient = $81e0702aaae9b086$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $81e0702aaae9b086$var$recomposeColor(color);
}
function $81e0702aaae9b086$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $81e0702aaae9b086$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $81e0702aaae9b086$var$emphasize(color, coefficient = 0.15) {
    return $81e0702aaae9b086$var$getLuminance(color) > 0.5 ? $81e0702aaae9b086$var$darken(color, coefficient) : $81e0702aaae9b086$var$lighten(color, coefficient);
}
function $81e0702aaae9b086$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $81e0702aaae9b086$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $81e0702aaae9b086$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $81e0702aaae9b086$var$decomposeColor(background);
    const overlayColor = $81e0702aaae9b086$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $81e0702aaae9b086$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


const $11ad4beec672042a$var$common = {
    black: '#000',
    white: '#fff'
};
var $11ad4beec672042a$export$2e2bcd8739ae039 = $11ad4beec672042a$var$common;


const $573d4c3554a3feba$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $573d4c3554a3feba$export$2e2bcd8739ae039 = $573d4c3554a3feba$var$grey;


const $2c38fca6c8d165ee$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2c38fca6c8d165ee$export$2e2bcd8739ae039 = $2c38fca6c8d165ee$var$purple;


const $0ee61d24a788d83d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $0ee61d24a788d83d$export$2e2bcd8739ae039 = $0ee61d24a788d83d$var$red;


const $fc0adf7233d5e51f$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $fc0adf7233d5e51f$export$2e2bcd8739ae039 = $fc0adf7233d5e51f$var$orange;


const $5acc452236058cea$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $5acc452236058cea$export$2e2bcd8739ae039 = $5acc452236058cea$var$blue;


const $c548461d7baf0d5f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c548461d7baf0d5f$export$2e2bcd8739ae039 = $c548461d7baf0d5f$var$lightBlue;


const $3a988c4fae84ab2b$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $3a988c4fae84ab2b$export$2e2bcd8739ae039 = $3a988c4fae84ab2b$var$green;


const $2643a2fd3dce9d9c$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $2643a2fd3dce9d9c$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $11ad4beec672042a$export$2e2bcd8739ae039).white,
        default: (0, $11ad4beec672042a$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $2643a2fd3dce9d9c$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $11ad4beec672042a$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $11ad4beec672042a$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $2643a2fd3dce9d9c$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $81e0702aaae9b086$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $81e0702aaae9b086$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $2643a2fd3dce9d9c$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5acc452236058cea$export$2e2bcd8739ae039)[200],
        light: (0, $5acc452236058cea$export$2e2bcd8739ae039)[50],
        dark: (0, $5acc452236058cea$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $5acc452236058cea$export$2e2bcd8739ae039)[700],
        light: (0, $5acc452236058cea$export$2e2bcd8739ae039)[400],
        dark: (0, $5acc452236058cea$export$2e2bcd8739ae039)[800]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[200],
        light: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[50],
        dark: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[500],
        light: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[300],
        dark: (0, $2c38fca6c8d165ee$export$2e2bcd8739ae039)[700]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[500],
        light: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[300],
        dark: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[700],
        light: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[400],
        dark: (0, $0ee61d24a788d83d$export$2e2bcd8739ae039)[800]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[400],
        light: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[300],
        dark: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[700],
        light: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[500],
        dark: (0, $c548461d7baf0d5f$export$2e2bcd8739ae039)[900]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[400],
        light: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[300],
        dark: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[800],
        light: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[500],
        dark: (0, $3a988c4fae84ab2b$export$2e2bcd8739ae039)[900]
    };
}
function $2643a2fd3dce9d9c$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $fc0adf7233d5e51f$export$2e2bcd8739ae039)[400],
        light: (0, $fc0adf7233d5e51f$export$2e2bcd8739ae039)[300],
        dark: (0, $fc0adf7233d5e51f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $fc0adf7233d5e51f$export$2e2bcd8739ae039)[500],
        dark: (0, $fc0adf7233d5e51f$export$2e2bcd8739ae039)[900]
    };
}
function $2643a2fd3dce9d9c$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hQtye.default)(palette, $2643a2fd3dce9d9c$var$_excluded);
    const primary = palette.primary || $2643a2fd3dce9d9c$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $2643a2fd3dce9d9c$var$getDefaultSecondary(mode);
    const error = palette.error || $2643a2fd3dce9d9c$var$getDefaultError(mode);
    const info = palette.info || $2643a2fd3dce9d9c$var$getDefaultInfo(mode);
    const success = palette.success || $2643a2fd3dce9d9c$var$getDefaultSuccess(mode);
    const warning = palette.warning || $2643a2fd3dce9d9c$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $81e0702aaae9b086$exports.getContrastRatio)(background, $2643a2fd3dce9d9c$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $2643a2fd3dce9d9c$export$55ce6f3a06c59543.text.primary : $2643a2fd3dce9d9c$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $jz4iA.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $6T5ne.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $6T5ne.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $2643a2fd3dce9d9c$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $2643a2fd3dce9d9c$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $2643a2fd3dce9d9c$export$55ce6f3a06c59543,
        light: $2643a2fd3dce9d9c$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $5eWZU.default)((0, $jz4iA.default)({
        // A collection of common colors.
        common: (0, $jz4iA.default)({}, (0, $11ad4beec672042a$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $573d4c3554a3feba$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $5eWZU = parcelRequire("5eWZU");
const $6d82b707c923b73a$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $6d82b707c923b73a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $6d82b707c923b73a$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $6d82b707c923b73a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $6d82b707c923b73a$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $6d82b707c923b73a$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hQtye.default)(_ref, $6d82b707c923b73a$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $jz4iA.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $6d82b707c923b73a$var$defaultFontFamily ? {
            letterSpacing: `${$6d82b707c923b73a$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $6d82b707c923b73a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $6d82b707c923b73a$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $5eWZU.default)((0, $jz4iA.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $89fd534632cf1937$var$shadowKeyUmbraOpacity = 0.2;
const $89fd534632cf1937$var$shadowKeyPenumbraOpacity = 0.14;
const $89fd534632cf1937$var$shadowAmbientShadowOpacity = 0.12;
function $89fd534632cf1937$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$89fd534632cf1937$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $89fd534632cf1937$var$shadows = [
    'none',
    $89fd534632cf1937$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $89fd534632cf1937$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $89fd534632cf1937$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $89fd534632cf1937$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $89fd534632cf1937$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $89fd534632cf1937$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $89fd534632cf1937$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $89fd534632cf1937$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $89fd534632cf1937$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $89fd534632cf1937$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $89fd534632cf1937$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $89fd534632cf1937$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $89fd534632cf1937$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $89fd534632cf1937$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $89fd534632cf1937$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $89fd534632cf1937$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $89fd534632cf1937$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $89fd534632cf1937$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $89fd534632cf1937$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $89fd534632cf1937$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $89fd534632cf1937$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $89fd534632cf1937$export$2e2bcd8739ae039 = $89fd534632cf1937$var$shadows;



var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");
const $b3bd8bc81df264a5$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $b3bd8bc81df264a5$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b3bd8bc81df264a5$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3bd8bc81df264a5$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3bd8bc81df264a5$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $b3bd8bc81df264a5$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $jz4iA.default)({}, $b3bd8bc81df264a5$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $jz4iA.default)({}, $b3bd8bc81df264a5$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hQtye.default)(options, $b3bd8bc81df264a5$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b3bd8bc81df264a5$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b3bd8bc81df264a5$var$formatMs(delay)}`).join(',');
    };
    return (0, $jz4iA.default)({
        getAutoHeightDuration: $b3bd8bc81df264a5$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $afe9876d7dbd431a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $afe9876d7dbd431a$export$2e2bcd8739ae039 = $afe9876d7dbd431a$var$zIndex;


const $aef7542ad817395e$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $aef7542ad817395e$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hQtye.default)(options, $aef7542ad817395e$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $6T5ne.default)(18));
    const palette = (0, $2643a2fd3dce9d9c$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $1l95P.default)(options);
    let muiTheme = (0, $5eWZU.default)(systemTheme, {
        mixins: (0, $c3e46a7a3c550973$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $89fd534632cf1937$export$2e2bcd8739ae039).slice(),
        typography: (0, $6d82b707c923b73a$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $b3bd8bc81df264a5$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $jz4iA.default)({}, (0, $afe9876d7dbd431a$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $5eWZU.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $5eWZU.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $jz4iA.default)({}, (0, $4ZuKt.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $aobdI.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $aef7542ad817395e$var$warnedOnce = false;
function $aef7542ad817395e$export$c469355549431d9b(...args) {
    return $aef7542ad817395e$var$createTheme(...args);
}
var $aef7542ad817395e$export$2e2bcd8739ae039 = $aef7542ad817395e$var$createTheme;


var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");
parcelRequire("8NFma");


var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");
const $07f36a8b7aaa1c39$var$ThemeContext = /*#__PURE__*/ $8NFma.createContext(null);
var $07f36a8b7aaa1c39$export$2e2bcd8739ae039 = $07f36a8b7aaa1c39$var$ThemeContext;



var $8NFma = parcelRequire("8NFma");

function $d141a345236e0cc7$export$2e2bcd8739ae039() {
    const theme = $8NFma.useContext((0, $07f36a8b7aaa1c39$export$2e2bcd8739ae039));
    return theme;
}


const $2310eb0ca0aba1b5$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $2310eb0ca0aba1b5$export$2e2bcd8739ae039 = $2310eb0ca0aba1b5$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $1IdZj = parcelRequire("1IdZj");
function $73dc9497164c74a1$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $jz4iA.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $73dc9497164c74a1$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $d141a345236e0cc7$export$2e2bcd8739ae039)();
    const theme = $8NFma.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $73dc9497164c74a1$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2310eb0ca0aba1b5$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $07f36a8b7aaa1c39$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $73dc9497164c74a1$export$2e2bcd8739ae039 = $73dc9497164c74a1$var$ThemeProvider;



parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");

var $8NFma = parcelRequire("8NFma");
parcelRequire("9XmJK");
var $iSBXh = parcelRequire("iSBXh");
'use client';
function $f0a6da6ee5aa8af6$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $f0a6da6ee5aa8af6$var$useTheme(defaultTheme = null) {
    const contextTheme = $8NFma.useContext((0, $iSBXh.T));
    return !contextTheme || $f0a6da6ee5aa8af6$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $f0a6da6ee5aa8af6$export$2e2bcd8739ae039 = $f0a6da6ee5aa8af6$var$useTheme;



var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");


var $1IdZj = parcelRequire("1IdZj");
const $7fb2f133e6efe378$var$_excluded = [
    "value"
];
const $7fb2f133e6efe378$var$RtlContext = /*#__PURE__*/ $8NFma.createContext();
function $7fb2f133e6efe378$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $hQtye.default)(_ref, $7fb2f133e6efe378$var$_excluded);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($7fb2f133e6efe378$var$RtlContext.Provider, (0, $jz4iA.default)({
        value: value != null ? value : true
    }, props));
}
const $7fb2f133e6efe378$export$b2dd014b6c321cb = ()=>{
    const value = $8NFma.useContext($7fb2f133e6efe378$var$RtlContext);
    return value != null ? value : false;
};
var $7fb2f133e6efe378$export$2e2bcd8739ae039 = $7fb2f133e6efe378$var$RtlProvider;



var $8NFma = parcelRequire("8NFma");


var $jz4iA = parcelRequire("jz4iA");
function $fe4d2574a0dfbe93$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $jz4iA.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $jz4iA.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $jz4iA.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $fe4d2574a0dfbe93$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $348ef89b026f3609$var$PropsContext = /*#__PURE__*/ $8NFma.createContext(undefined);
function $348ef89b026f3609$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)($348ef89b026f3609$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $348ef89b026f3609$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $fe4d2574a0dfbe93$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $fe4d2574a0dfbe93$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $348ef89b026f3609$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8NFma.useContext($348ef89b026f3609$var$PropsContext);
    return $348ef89b026f3609$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $348ef89b026f3609$export$2e2bcd8739ae039 = $348ef89b026f3609$var$DefaultPropsProvider;


parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $2e091165f4c6c9c8$var$useEnhancedEffect = typeof window !== 'undefined' ? $8NFma.useLayoutEffect : $8NFma.useEffect;
var $2e091165f4c6c9c8$export$2e2bcd8739ae039 = $2e091165f4c6c9c8$var$useEnhancedEffect;



var $8NFma = parcelRequire("8NFma");
'use client';
let $42cae6f168e9b9ae$var$globalId = 0;
function $42cae6f168e9b9ae$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8NFma.useState(idOverride);
    const id = idOverride || defaultId;
    $8NFma.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $42cae6f168e9b9ae$var$globalId += 1;
            setDefaultId(`mui-${$42cae6f168e9b9ae$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $42cae6f168e9b9ae$var$maybeReactUseId = $8NFma['useId'.toString()];
function $42cae6f168e9b9ae$export$2e2bcd8739ae039(idOverride) {
    if ($42cae6f168e9b9ae$var$maybeReactUseId !== undefined) {
        const reactId = $42cae6f168e9b9ae$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $42cae6f168e9b9ae$var$useGlobalId(idOverride);
}


parcelRequire("8NFma");


var $oqjrU = parcelRequire("oqjrU");
var $33qfW = parcelRequire("33qfW");

var $1l95P = parcelRequire("1l95P");

'use client';
const $175604ad9cd01c87$export$35e57303dbd8a66 = (0, $1l95P.default)();
function $175604ad9cd01c87$var$useTheme(defaultTheme = $175604ad9cd01c87$export$35e57303dbd8a66) {
    return (0, $f0a6da6ee5aa8af6$export$2e2bcd8739ae039)(defaultTheme);
}
var $175604ad9cd01c87$export$2e2bcd8739ae039 = $175604ad9cd01c87$var$useTheme;



var $1IdZj = parcelRequire("1IdZj");
'use client';
function $5cc57275d47605c6$var$wrapGlobalLayer(styles) {
    const serialized = (0, $33qfW.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $5cc57275d47605c6$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $175604ad9cd01c87$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $5cc57275d47605c6$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $5cc57275d47605c6$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $5cc57275d47605c6$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $oqjrU.default), {
        styles: globalStyles
    });
}
var $5cc57275d47605c6$export$2e2bcd8739ae039 = $5cc57275d47605c6$var$GlobalStyles;




var $1IdZj = parcelRequire("1IdZj");
'use client';
function $882f1e2e35b9a85f$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $f0a6da6ee5aa8af6$export$2e2bcd8739ae039)();
    const id = (0, $42cae6f168e9b9ae$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $2e091165f4c6c9c8$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5cc57275d47605c6$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $37a3e9b0199d8644$var$EMPTY_THEME = {};
function $37a3e9b0199d8644$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8NFma.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $jz4iA.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $jz4iA.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $jz4iA.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $37a3e9b0199d8644$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $f0a6da6ee5aa8af6$export$2e2bcd8739ae039)($37a3e9b0199d8644$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $d141a345236e0cc7$export$2e2bcd8739ae039)() || $37a3e9b0199d8644$var$EMPTY_THEME;
    const engineTheme = $37a3e9b0199d8644$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $37a3e9b0199d8644$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $882f1e2e35b9a85f$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $73dc9497164c74a1$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $iSBXh.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7fb2f133e6efe378$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $348ef89b026f3609$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $37a3e9b0199d8644$export$2e2bcd8739ae039 = $37a3e9b0199d8644$var$ThemeProvider;


var $6b44440c4cabd1a9$export$2e2bcd8739ae039 = '$$material';



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $89db59c316d64b9f$var$_excluded = [
    "theme"
];
function $89db59c316d64b9f$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $hQtye.default)(_ref, $89db59c316d64b9f$var$_excluded);
    const scopedTheme = themeInput[0, $6b44440c4cabd1a9$export$2e2bcd8739ae039];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $jz4iA.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $jz4iA.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $37a3e9b0199d8644$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, props, {
        themeId: scopedTheme ? (0, $6b44440c4cabd1a9$export$2e2bcd8739ae039) : undefined,
        theme: finalTheme
    }));
}







function $fd959835eca46177$var$escapeSeriesNamePart(str) {
    return str.replace(/\./g, "..").replace(/\//g, "_").replace(/ /g, "_");
}
function $fd959835eca46177$export$1ff77a293e27e5c6(store, stationId, sensorId, parameterId, variant) {
    var r = store + "." + $fd959835eca46177$var$escapeSeriesNamePart(stationId) + "." + $fd959835eca46177$var$escapeSeriesNamePart(sensorId) + "." + $fd959835eca46177$var$escapeSeriesNamePart(parameterId);
    if (variant !== null) r += "." + $fd959835eca46177$var$escapeSeriesNamePart(variant);
    return r;
}
function $fd959835eca46177$export$13e771e3fa881cf2(stationId, parameterGroup, sensorId) {
    var sn = "G." + $fd959835eca46177$var$escapeSeriesNamePart(stationId) + "." + $fd959835eca46177$var$escapeSeriesNamePart(parameterGroup);
    if (sensorId !== undefined) sn += "." + $fd959835eca46177$var$escapeSeriesNamePart(sensorId);
    return sn;
}
function $fd959835eca46177$var$getInfluxServer() {
    return '/api/HistoricalData';
}
function $fd959835eca46177$var$decodeValueFromInflux(str) {
    if (str == null) return null;
    return JSON.parse(str);
}
function $fd959835eca46177$export$644e9f91c0b5bf9(callback, store, stationId, sensorId, parameterId, issueTime, baseVariant) {
    let str = '/api/v1/HistoricalForecasts/' + encodeURIComponent(store) + "/" + encodeURIComponent(stationId) + "/" + encodeURIComponent(sensorId) + "/" + encodeURIComponent($fd959835eca46177$var$escapeSeriesNamePart(parameterId)); //keep escapeSeriesNamePart here to ensure we keep the slash in parameterId (MESSY!)
    let queryParts = [];
    if (issueTime !== null) queryParts.push("issueTime=" + issueTime);
    queryParts.push("format=json"); //format may also be "csv"
    queryParts.push("output=inline"); //output may be "file"
    if (baseVariant !== null) queryParts.push("baseVariant=" + baseVariant);
    if (queryParts.length) str += "/?" + queryParts.join('&');
    return $.ajax(str, {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (resp)=>{
            callback(null, resp);
        },
        error: (jqXHR)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $fd959835eca46177$export$9bf04fc316538454(store, stationId, sensorId, parameterId, variant, startDate, endDate, callback, desiredResolution) {
    var startDateSeconds = startDate / 1000;
    var endDateSeconds = endDate / 1000;
    var startDateSecondsString = (startDate / 1000).toFixed(0);
    var endDateSecondsString = (endDate / 1000).toFixed(0);
    var seriesName = $fd959835eca46177$export$1ff77a293e27e5c6(store, stationId, sensorId, parameterId, variant);
    var resolution;
    //all
    if (desiredResolution == -1) {
        var q = 'SELECT value FROM "midi"."rp"."' + seriesName + '" WHERE time >= ' + startDateSecondsString + 's AND time < ' + endDateSecondsString + 's';
        resolution = 1;
    } else {
        var maxDataPoints = 1440;
        var groupByPeriod = 0;
        // assume a full sample of data
        var minutes = (endDateSeconds - startDateSeconds) / 60;
        if (desiredResolution == 0 || minutes > maxDataPoints) groupByPeriod = Math.ceil(minutes / maxDataPoints);
        else groupByPeriod = desiredResolution;
        q = 'SELECT FIRST(value) FROM "midi"."rp"."' + seriesName + '" WHERE time >= ' + startDateSecondsString + 's AND time < ' + endDateSecondsString + 's GROUP BY time(' + groupByPeriod + 'm)';
        resolution = groupByPeriod;
    }
    return $.ajax($fd959835eca46177$var$getInfluxServer() + '/?q=' + encodeURIComponent(q), {
        async: true,
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            var responseData = [];
            let tsFirst = null;
            let tsLast = null;
            if (data.results[0].series) data.results[0].series.forEach((series)=>{
                if (!series.values) return;
                // data can be chunked across multiple series
                series.values.forEach((value)=>{
                    // used for plotting only - nulls are plotted as gaps in a line chart
                    // group by can return nulls if frequency of data return less than grouping period
                    // all data points which can carry nulls (i.e. cloud height, amount) should be plotted as points anyway
                    // nulls will therfore be removed from data to avoid gaps in low frequency line data
                    if (value[1] == null) return;
                    value[0] = moment.utc(value[0], 'YYYY-MM-DD HH:mm:ss').valueOf();
                    value[1] = $fd959835eca46177$var$decodeValueFromInflux(value[1]);
                    if (value[1] == 'NIL') return;
                    //: first/last timestamps, to help with auto-refresh of plot data:
                    if (tsFirst == null || tsFirst > value[0]) tsFirst = value[0];
                    if (tsLast == null || tsLast < value[0]) tsLast = value[0];
                    responseData.push(value);
                });
            });
            var response = {
                Store: store,
                StationId: stationId,
                ParameterId: parameterId,
                ParameterDefinition: null,
                SensorId: sensorId,
                Data: responseData,
                Resolution: resolution,
                TimestampFirst: tsFirst,
                TimestampLast: tsLast
            };
            callback(null, response);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $fd959835eca46177$export$7a53cc19acfc9f90(stationId, parameterGroup, startDate, endDate, callback, sensorId) {
    var startDateSeconds = (startDate / 1000).toFixed(0);
    var endDateSeconds = (endDate / 1000).toFixed(0);
    var seriesName = $fd959835eca46177$export$13e771e3fa881cf2(stationId, parameterGroup, sensorId);
    var q = 'SELECT value FROM "midi"."rp"."' + seriesName + '" WHERE time >= ' + startDateSeconds + 's AND time < ' + endDateSeconds + 's';
    return $.ajax($fd959835eca46177$var$getInfluxServer() + '/?q=' + encodeURIComponent(q), {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            var responseData = null; // null if table doesn't exist
            if (data.results[0].series) {
                responseData = []; // empty if table exists, but no data
                data.results[0].series.forEach((series)=>{
                    if (!series.values) return;
                    // data can be chunked across multiple series
                    series.values.forEach((value)=>{
                        // used for plotting only - nulls are plotted as gaps in a line chart
                        // group by can return nulls if frequency of data return less than grouping period
                        // all data points which can carry nulls (i.e. cloud height, amount) should be plotted as points anyway
                        // nulls will therfore be removed from data to avoid gaps in low frequency line data
                        if (value[1] == null) return;
                        value[0] = moment.utc(value[0], 'YYYY-MM-DD HH:mm:ss').valueOf();
                        value[1] = $fd959835eca46177$var$decodeValueFromInflux(value[1]);
                        if (value[1] == 'NIL') return;
                        responseData.push(value);
                    });
                });
            }
            var response = {
                Store: 'G',
                StationId: stationId,
                ParameterId: parameterGroup,
                ParameterDefinition: null,
                SensorId: sensorId,
                Data: responseData
            };
            callback(null, response);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}


class $976af8e0bfbb0494$export$418e8f8fe20901f6 {
    constructor(mainSite, page, container, top, left, height, width, valueId, directionValueId, includeTimeSelector, sensorId = null){
        this.mainSite = mainSite;
        this.sensorId = sensorId;
        this.anyData = false;
        this.desiredPoints = 5000;
        this.currentData = [];
        this.stationId = page.station.Station.Id;
        this.selectedHours = 24; //initialization needed for the legend
        this.valueId = valueId;
        this.directionValueId = directionValueId;
        this.box = $('<div class="midi_SiteObservations_chart_container" id="plar-chart"></div>').css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        container.append(this.box);
        if (includeTimeSelector) var timeSelector = this.createTimeSelector();
        this.chartContainer = $('<div></div>').css('height', '83%').appendTo(this.box);
        this.chart = this.drawChart();
        //select default time period
        if (includeTimeSelector) timeSelector.children('li').first().click();
    }
    createTimeSelector() {
        let allowedTimePeriods = [
            24,
            168,
            720
        ];
        let timePeriodSelector = $('<div class="current_chart_selector"></div>').css('margin-top', '10px').append($('<span></span>').text("Time period: ")).appendTo(this.box);
        let tpul = $('<ul></ul>').appendTo(timePeriodSelector);
        allowedTimePeriods.forEach((a)=>{
            tpul.append($('<li></li>').text($976af8e0bfbb0494$export$418e8f8fe20901f6.formatHoursToDays(a)).attr('hours', a).click((ev)=>{
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                this.selectedHours = parseInt($(ev.target).attr('hours'));
                this.updateChart(this.selectedHours, true);
            }));
        });
        return tpul;
    }
    drawChart() {
        this.chartContainer.highcharts({
            chart: {
                polar: true,
                marginLeft: 10,
                marginRight: 3
            },
            exporting: {
                enabled: true
            },
            title: {
                text: ''
            },
            xAxis: {
                tickInterval: 22.5,
                min: 0,
                max: 360,
                labels: {
                    formatter: function() {
                        switch(this.value){
                            case 0:
                                return 'N';
                            case 22.5:
                                return 'NNE';
                            case 45:
                                return 'NE';
                            case 67.5:
                                return 'ENE';
                            case 90:
                                return 'E';
                            case 112.5:
                                return 'ESE';
                            case 135:
                                return 'SE';
                            case 157.5:
                                return 'SSE';
                            case 180:
                                return 'S';
                            case 202.5:
                                return 'SSW';
                            case 225:
                                return 'SW';
                            case 247.5:
                                return 'WSW';
                            case 270:
                                return 'W';
                            case 292.5:
                                return 'WNW';
                            case 315:
                                return 'NW';
                            case 337.5:
                                return 'NNW';
                        }
                    }
                }
            },
            yAxis: {
                min: 0,
                labels: {
                    style: {
                        fontWeight: 'bold'
                    }
                }
            },
            legend: {
                align: 'center'
            },
            plotOptions: {
                series: {
                    pointStart: 0,
                    pointInterval: 45,
                    turboThreshold: 0,
                    states: {
                        hover: {
                            lineWidthPlus: 0 // disable line between dots on hover
                        }
                    },
                    marker: {
                        radius: 3
                    }
                },
                column: {
                    pointPadding: 0,
                    groupPadding: 0
                }
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: false
            }
        });
        return this.chartContainer.highcharts();
    }
    setSelectedHours(hours) {
        this.selectedHours = hours;
    }
    liveDataChanged(latestData) {
        this.updateChart(this.selectedHours, false);
    }
    updateChart(hours, reload) {
        this.currentData = [];
        if (reload) this.chart.showLoading('Getting data...');
        if (!this.mainSite.liveDataManager.latestData) return;
        var toMoment = moment.utc();
        var fromMoment = moment.utc().subtract(hours, 'h');
        let latestDataFromStation = this.mainSite.liveDataManager.latestData.Stations[this.stationId];
        if (latestDataFromStation && latestDataFromStation.GroupValues[this.valueId] && latestDataFromStation.GroupValues[this.valueId].filter((v)=>v.Sensor == this.sensorId).length > 0 && latestDataFromStation.GroupValues[this.directionValueId] && latestDataFromStation.GroupValues[this.directionValueId].filter((v)=>v.Sensor == this.sensorId).length > 0) // If data is available for the this.sensorId, get the data and add to the chart
        // Get and handle speedData
        (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, this.valueId, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
            this.handleSpeedData(err, data, toMoment, fromMoment);
        }, this.sensorId).then(()=>{
            // Get and handle directionalData
            (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, this.directionValueId, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                this.handleDirectionalData(err, data, toMoment, fromMoment);
            }, this.sensorId).done(()=>{
                // Finalize chart
                this.finalizeDataAndUpdateChart(toMoment, fromMoment, hours);
            });
        });
        else {
            // If data is not available, show information on chart
            this.chart.showLoading('Data not available');
            return;
        }
    }
    handleSpeedData(err, data, toMoment, fromMoment) {
        if (err) {
            console.warn('Polar Chart - Error getting data: ', err);
            this.chart.showLoading('Error getting data...');
            return;
        }
        this.anyData = this.anyData || data.Data !== null;
        if (data.Data !== null) {
            data.Data.unshift([
                fromMoment.valueOf(),
                null
            ]);
            data.Data.push([
                toMoment.valueOf(),
                null
            ]);
        }
        let pointSkip = Math.floor(data.Data.length / this.desiredPoints);
        data.Data.forEach((dataPoint, i)=>{
            if (pointSkip !== 0 && i % pointSkip !== 0) return;
            let ts = dataPoint[0];
            let val = dataPoint[1];
            if (val) this.currentData.push({
                timestamp: ts,
                speed: val,
                direction: null
            });
        });
    }
    handleDirectionalData(err, data, toMoment, fromMoment) {
        if (err) {
            console.warn('Polar Chart - Error getting data: ', err);
            this.chart.showLoading('Error getting data...');
            return;
        }
        this.anyData = this.anyData || data.Data !== null;
        if (data.Data !== null) {
            data.Data.unshift([
                fromMoment.valueOf(),
                null
            ]);
            data.Data.push([
                toMoment.valueOf(),
                null
            ]);
        }
        let pointSkip = Math.floor(data.Data.length / this.desiredPoints);
        data.Data.forEach((dataPoint, i)=>{
            if (pointSkip !== 0 && i % pointSkip !== 0) return;
            let ts = dataPoint[0];
            let val = dataPoint[1];
            let x = this.currentData.filter((x)=>x.timestamp === ts);
            if (x.length) x[0].direction = val;
        });
    }
    finalizeDataAndUpdateChart(toMoment, fromMoment, hours) {
        let filteredCurrentData = this.currentData.filter((x)=>Number.isFinite(x.speed) && Number.isFinite(x.direction) && x.speed >= 0 && x.speed < 100 && x.direction >= 0 && x.direction <= 360);
        if (!filteredCurrentData.length) {
            this.chart.showLoading('Data not available');
            return;
        }
        filteredCurrentData.sort((a, b)=>{
            return a.direction - b.direction;
        });
        //draw chart
        let polarData = [];
        //the latest values must be drawen over the old values (points are sorted by direction, by x axis)
        let latestPolarData = [];
        filteredCurrentData.forEach((d, index)=>{
            let latest = d.timestamp < toMoment.unix() * 1000 && d.timestamp > toMoment.unix() * 1000 - hours / 12 * 3600000;
            if (latest) latestPolarData.push({
                x: d.direction,
                y: d.speed
            });
            else polarData.push({
                x: d.direction,
                y: d.speed
            });
        });
        this.chart.hideLoading();
        let polarSeries = {
            id: "Polar_Series",
            name: "All",
            lineWidth: 0,
            data: polarData,
            color: '#fbce07'
        };
        let latestPolarSeries = {
            id: "Latest_Polar_Series",
            name: "Latest",
            lineWidth: 0,
            color: '#f54e42',
            data: latestPolarData
        };
        if (this.chart.series.length < 1) {
            this.chart.addSeries(polarSeries);
            this.chart.addSeries(latestPolarSeries);
        } else {
            let cs = this.chart.get("Polar_Series");
            cs.setData(polarSeries.data);
            let latestCs = this.chart.get("Latest_Polar_Series");
            latestCs.setData(latestPolarSeries.data);
        }
        this.chart.update({
            legend: {
                labelFormatter: function() {
                    if (this.name == "All") return "Greater than " + hours / 12 + " hours";
                    else return "Less than " + hours / 12 + " hours";
                }
            }
        });
        this.chart.redraw();
    }
    static formatHoursToDays(hours) {
        let days = hours / 24;
        if (days === 1) return days + " day";
        return days + " days";
    }
}



class $e903168b3f468a55$export$17334619f3ac2224 {
    static{
        /**
     * DEBUGGING INFO: In Chrome console, add the following items (in order) to watch/live expressions: (NB: this assumes we're working on PVD chart in SiteObservations/Current page..)
     * 
     * - P = Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[3].pages[3]; //: gets the current page.
     * - [P._pvd.selectedHours, P._pvd.drp.getLastIncludedNow(), P._pvd.drp.timeFrom, P._pvd.drp.timeTo] //: an array of helpful live items.
     */ /** The default format for debugging Moment objects */ this.MOMENT_DEBUG_FORMAT = "YYYY-MM-DD HH:mm:ss ZZ (x)";
    }
    constructor(mainSite, $container, postUpdateEvent = null){
        this.mainSite = mainSite;
        this.$container = $container;
        this.postUpdateEvent = postUpdateEvent;
        this.rendered = false;
        this.preventUpdateEvents = false;
        this.lastUpdateSource = null;
        this.lastClickedDropdownItemId = null;
        this.lastChangedIncludedNow = false;
        this.onChangeDateViaSetValuesMethods = false;
        this.$dropdownWrap = null;
        this.$dropdownBtn = null;
        this.timeFrom = "00:00:00";
        this.timeTo = "23:59:59";
        this.options = {
            onManualChangeDateUpdateTime: true
        };
    }
    /**
     * Check the validity of a date provided as YYYY-MM-DD string.
     * @param Ymd The string to check.
     */ static checkYmdString(Ymd) {
        let m = moment(Ymd, "YYYY-MM-DD", true);
        return m && m.isValid();
    }
    getSelectedTimezoneData() {
        let data = null;
        try {
            let $opt = this.$inputTimezone.find('option[value="' + this.$inputTimezone.val() + '"]');
            let tzd = $opt.data("tzd");
            if (tzd) data = tzd;
        } catch (err) {
            let tzOpts = this.mainSite.getAllAvailableTimeZones();
            data = tzOpts.filter((x)=>x.timeZoneName == this.mainSite.getTimeZoneName())[0];
        }
        return data;
    }
    setReadonlyInputs(readonly = false) {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to setting inputs to readonly (or not).");
            return;
        }
        this.$inputFrom.prop('readonly', readonly);
        this.$inputTo.prop('readonly', readonly);
        this.$inputTimezone.prop('readonly', readonly);
    }
    getData() {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to getting data.");
            return;
        }
        let tzd = this.getSelectedTimezoneData();
        if (tzd == null) return null;
        let offset = tzd.offsetString; // this.mainSite.getTimeZoneStringFormat('ZZ');
        let formatParse = "YYYY-MM-DD HH:mm:ssZ";
        let formatDebug = $e903168b3f468a55$export$17334619f3ac2224.MOMENT_DEBUG_FORMAT;
        //: TODO: if inputs are not valid YYYY-MM-DD, then use invalid moments!
        let f = $e903168b3f468a55$export$17334619f3ac2224.checkYmdString(this.$inputFrom.val()) ? moment.parseZone(this.$inputFrom.val() + " " + this.timeFrom + offset, formatParse) : moment.invalid();
        let t = $e903168b3f468a55$export$17334619f3ac2224.checkYmdString(this.$inputTo.val()) ? moment.parseZone(this.$inputTo.val() + " " + this.timeTo + offset, formatParse) : moment.invalid();
        let data = {
            from: f.isValid() ? f : null,
            to: t.isValid() ? t : null,
            tzOffset: offset,
            tzName: tzd.timeZoneName,
            isValid: f.isValid() && t.isValid(),
            hasRange: f.isValid() && t.isValid() && t.isAfter(f),
            lastUpdateSource: this.lastUpdateSource,
            lastChangedIncludedNow: this.lastChangedIncludedNow,
            lastClickedDropdownItemId: this.lastClickedDropdownItemId,
            debug: {
                f: f.isValid() ? f.format(formatDebug) + ` [UTC: ${moment.utc(f.valueOf()).format(formatDebug)}]` : "INVALID",
                t: t.isValid() ? t.format(formatDebug) + ` [UTC: ${moment.utc(t.valueOf()).format(formatDebug)}]` : "INVALID"
            }
        };
        return data;
    }
    /**
     * A simpler method to retrieve the flag for whether last .setValues() included NOW or not, to avoid running range calculations.
     */ getLastIncludedNow() {
        return this.lastChangedIncludedNow;
    }
    /**
     * Helper method to check if the current NOW moment (adapted to selected timezone!) is contained in the selected range.
     * NB: this differs from the .getLastIncludedNow() in that the latter help determine if, at time of setting the range, NOW was included in range set.
     */ getCurrentRangeIncludesNow() {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to setting data/values.");
            return;
        }
        let result = false;
        let tzd = this.getSelectedTimezoneData();
        let now = moment.utc();
        if (tzd) now = moment.utc().tz(tzd.timeZoneName);
        let data = this.getData();
        if (data && data.isValid) {
            if (now.isBetween(data.from, data.to, 'seconds', '[]')) result = true;
        }
        return result;
    }
    setTimezone(tzName = null, defaultToUTC = true, runPostUpdateEvent = true) {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to setting data/values.");
            return;
        }
        this.preventUpdateEvents = true;
        this.onChangeDateViaSetValuesMethods = true;
        if (tzName == null) tzName = this.mainSite.getTimeZoneName();
        let tzOpts = this.mainSite.getAllAvailableTimeZones();
        if (tzOpts.filter((x)=>x.timeZoneName == tzName).length === 1) this.$inputTimezone.val(tzName).trigger("change");
        else if (tzOpts.filter((x)=>x.timeZoneName == "UTC").length === 1 && defaultToUTC) this.$inputTimezone.val("UTC").trigger("change");
        else console.error("Unable to set timezone on date-range picker, as neither the requested timezone nor UTC are available.");
        this.preventUpdateEvents = false;
        if (runPostUpdateEvent) this.triggerUpdate('DateRangePicker.setTimezone');
        this.onChangeDateViaSetValuesMethods = false;
    }
    /**
     * Set the values of the date range picker. Note if either **from** or **to** are set to null or invalid dates (as determined by momoent.isValid()), they will be set to blank, and thus INVALID values.
     * NOTE: if from/to are provided as string (needs to be YYYY-MM-DD formated date), then times are assumed to start at 00:00:00 and end at 23:59:59 (adapted to the timezone in select input)
     * @param from The from date, string in format YYYY-MM-DD, or a valid Moment object
     * @param to The to date, string in format YYYY-MM-DD, or a valid Moment object
     * @param runPostUpdateEvent Set to false if you want to prevent calling the update callbacks (i.e. to prevent some charts updates for example)
     */ setValues(from = null, to = null, runPostUpdateEvent = true, updateSource = null) {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to setting data/values.");
            return;
        }
        let tzd = this.getSelectedTimezoneData();
        let now = moment.utc();
        if (tzd) now = moment.utc().tz(tzd.timeZoneName);
        // console.warn("DRP .setValues() [BEFORE CHANGES]", { f: from, t: to, ff: moment.isMoment(from) && from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), tf: moment.isMoment(to) && to.format(DateRangePicker.MOMENT_DEBUG_FORMAT), nf: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), src: updateSource, xx: $.extend(true, {}, this.getData()) });
        this.preventUpdateEvents = true;
        this.onChangeDateViaSetValuesMethods = true;
        this.timeFrom = "00:00:00";
        this.timeTo = "23:59:59";
        if (from !== null && typeof from == 'string' && $e903168b3f468a55$export$17334619f3ac2224.checkYmdString(from)) this.$inputFrom.datepicker('setDate', from);
        else if (from !== null && moment.isMoment(from)) {
            this.$inputFrom.datepicker('setDate', from.format("YYYY-MM-DD"));
            this.timeFrom = from.format("HH:mm:ss");
        } else this.$inputFrom.datepicker('setDate', "");
        if (to !== null && typeof to == 'string' && $e903168b3f468a55$export$17334619f3ac2224.checkYmdString(to)) this.$inputTo.datepicker('setDate', to);
        else if (to !== null && moment.isMoment(to)) {
            this.$inputTo.datepicker('setDate', to.format("YYYY-MM-DD"));
            this.timeTo = to.format("HH:mm:ss");
        } else this.$inputTo.datepicker('setDate', "");
        this.lastChangedIncludedNow = false; //: NB: this defaults to false in case we encounter any errors in retrieving TZ or this.data..
        let data = this.getData();
        if (data && data.isValid) {
            if (now.isBetween(data.from, data.to, 'minutes', '[]')) this.lastChangedIncludedNow = true;
        }
        // console.warn("DRP .setValues()", { in: this.lastChangedIncludedNow, tzn: tzd.timeZoneName, xx: $.extend(true, {}, data), f: from, t: to, ff: moment.isMoment(from) && from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), tf: moment.isMoment(to) && to.format(DateRangePicker.MOMENT_DEBUG_FORMAT), nf: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), src: updateSource });
        this.preventUpdateEvents = false;
        if (runPostUpdateEvent) this.triggerUpdate(updateSource);
        this.onChangeDateViaSetValuesMethods = false;
        return this.getData();
    }
    /**
     * Automatically update the current range to include the now moment (adapted to selected timezone!).
     * Note: if current range already includes the now moment, then this will simply return the result of .getData() without any modifications (so no updates/callbacks are executed either!).
     * @param method "shift" or "extend". If "extend" is selected, then the range is extended (so TO extended to NOW if NOW is after TO, FROM extended to NOW if NOW is before FROM). 'shift" calculates the difference and appropriately shifts the range FROM/TO to include NOW, either at FROM or TO accordingly.
     * @param runPostUpdateEvent
     * @param updateSource
     */ autoIncludeNow(method = "extend", runPostUpdateEvent = true, updateSource = null) {
        let current = this.getData();
        if (current && current.isValid) {
            let tzd = this.getSelectedTimezoneData();
            let now = moment.utc();
            if (tzd) now = moment.utc().tz(tzd.timeZoneName);
            // console.info("DRP.autoIncludeNow()", { x: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), xi: now.isBetween(current.from, current.to, 'seconds', '[]'), z: tzd.timeZoneName, f: current.from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), t: current.to.format(DateRangePicker.MOMENT_DEBUG_FORMAT) });
            if (now.isBetween(current.from, current.to, 'seconds', '[]')) return current;
            else if (now.isBefore(current.from)) {
                let _to = current.to.clone();
                if (method == "shift") {
                    let diff = current.from.diff(now, 'milliseconds');
                    _to.subtract(diff, 'milliseconds');
                // console.info("DRP.autoIncludeNow() [SHIFT/before]", { diff: diff, x: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), z: tzd.timeZoneName, c_f: current.from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), c_t: current.to.format(DateRangePicker.MOMENT_DEBUG_FORMAT), n_f: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), n_t: _to.format(DateRangePicker.MOMENT_DEBUG_FORMAT) });
                }
                return this.setValues(now, _to, runPostUpdateEvent, updateSource);
            } else if (now.isAfter(current.to)) {
                let _from = current.from.clone();
                if (method == "shift") {
                    let diff = now.diff(current.to, 'milliseconds');
                    _from.add(diff, 'milliseconds');
                // console.info("DRP.autoIncludeNow() [SHIFT/after]", { diff: diff, x: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT), z: tzd.timeZoneName, c_f: current.from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), c_t: current.to.format(DateRangePicker.MOMENT_DEBUG_FORMAT), n_f: _from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), n_t: now.format(DateRangePicker.MOMENT_DEBUG_FORMAT) });
                }
                return this.setValues(_from, now, runPostUpdateEvent, updateSource);
            } else console.error("DateRangePicker ERROR: unable to automatically include NOW as it's impossible to determine which direction the range should be extended.");
        }
    }
    /**
     * Trigger the update for the date range picker (should call the update callbacks)
     */ triggerUpdate(updateSource = null) {
        if (!this.rendered) {
            console.error("DateRangePicker ERROR: the elements have not yet been rendered. Please render them prior to triggering update.");
            return;
        }
        this.lastUpdateSource = updateSource;
        if ($.isFunction(this.postUpdateEvent) && !this.preventUpdateEvents) this.postUpdateEvent(this, updateSource);
    }
    render(label = "Date&nbsp;Range", rowClass = "form-group", hideTimezoneSelect = false) {
        let $row = null, $col = null;
        $row = $('<div>').addClass(rowClass).appendTo(this.$container);
        let colsLabel = 2;
        let colsDates = 6;
        let colsTzSel = 4;
        if (label !== null && label !== "") $(`<label class="col-sm-${colsLabel} control-label">${label}</label>`).appendTo($row);
        else {
            colsLabel = 0;
            colsDates = 8;
        }
        if (hideTimezoneSelect) {
            colsTzSel = 0;
            colsDates = 12 - colsLabel;
        }
        let $dpWrap = $('<div class="input-daterange input-group input-group-sm"></div>');
        this.$inputFrom = $('<input class="form-control date-range-picker--from" type="text" name="start" placeholder="YYYY-MM-DD">').appendTo($dpWrap);
        let $divider = $('<span class="input-group-addon">to</span>').appendTo($dpWrap);
        this.$inputTo = $('<input class="form-control date-range-picker--to" type="text" name="end" placeholder="YYYY-MM-DD">').appendTo($dpWrap);
        $col = $(`<div class="col-sm-${colsDates}"></div>`).appendTo($row);
        let inputOnChange = (e)=>{
            // console.info("[[DRP.input.on(change)]]...", e.originalEvent, e.target);
            if (!this.onChangeDateViaSetValuesMethods && this.options.onManualChangeDateUpdateTime) {
                if ($(e.target).hasClass('date-range-picker--from')) this.timeFrom = "00:00:00";
                if ($(e.target).hasClass('date-range-picker--to')) this.timeTo = "23:59:59";
            }
        };
        this.$inputTo.on("change", inputOnChange);
        this.$inputFrom.on("change", inputOnChange);
        // this.$inputTimezone.on("change", inputOnChange); //: added to individual handler below.
        this.$datepicker = $dpWrap.appendTo($col).datepicker({
            weekStart: 1,
            format: "yyyy-mm-dd",
            multidate: false,
            clearBtn: false,
            immediateUpdates: false,
            keepEmptyValues: true,
            todayBtn: false
        }).on('changeDate', (e)=>{
            // console.info("DRP.datepicker.on(changeDate)", { event: e });
            //: auto-hide datepicker & move onto 'to' field if appropriate
            $(e.target).blur();
            $(e.target).datepicker('hide');
            if ($(e.target).hasClass("date-range-picker--from") && !this.preventUpdateEvents) this.$inputTo.trigger("focus");
            this.dropdownHighlightItem(null);
            this.triggerUpdate('DateRangePicker.datepicker.on(changeDate)');
        });
        //: add timezone select:
        $col = $('<div>').addClass(hideTimezoneSelect ? 'hidden' : `col-sm-${colsTzSel}`).appendTo($row);
        this.$inputTimezone = $("<select>").addClass('form-control input-sm').on("change", (e)=>{
            inputOnChange(e);
            this.triggerUpdate('DateRangePicker.[inputs_changes]');
        });
        this.$inputTimezone.appendTo($col);
        let tzOpts = this.mainSite.getAllAvailableTimeZones();
        let $opt = null;
        tzOpts.forEach((tzd)=>{
            $opt = $('<option>').attr('value', tzd.timeZoneName).text(tzd.label).data('tzOffsetMinutes', tzd.offsetMinutes).data('tzd', tzd);
            this.$inputTimezone.append($opt);
        });
        this.$inputTimezone.val(this.mainSite.getTimeZoneName());
        this.rendered = true;
    }
    dropdownSetButtonText(text = null) {
        if (this.$dropdownBtn) {
            let $span = this.$dropdownBtn.find('span.btn-text');
            if ($span.length == 0) $span = $('<span>').addClass('btn-text').prependTo(this.$dropdownBtn);
            $span.text(text);
        }
    }
    dropdownSetButtonElements($el = null) {
        if (this.$dropdownBtn) {
            let $span = this.$dropdownBtn.find('span.btn-text');
            if ($span.length == 0) $span = $('<span>').addClass('btn-text').prependTo(this.$dropdownBtn);
            $span.empty().append($el);
        }
    }
    /**
     * Trigger the onClick event for the desired dropdown menu item, retrieved by its id.
     * @param id
     */ dropdownTriggerItemClick(id = null) {
        let $a = this.$dropdownWrap.find(`[data-id="${encodeURI(id)}"] a`);
        if ($a.length === 1) $a.trigger("click");
    }
    /**
     * Helper to highlight a specific dropdown menu item based on its id.
     * @param id
     */ dropdownHighlightItem(id = null) {
        this.$dropdownWrap.find(".active").removeClass("active");
        let $item = this.$dropdownWrap.find(`[data-id="${encodeURI(id)}"]`);
        if ($item.length === 1) $item.addClass("active");
    }
    dropdownAddItem(id, label, onClick, className = null, iconClassName = null) {
        if (this.$dropdownWrap === null) {
            this.$dropdownWrap = $('<ul class="dropdown-menu dropdown-menu-right">');
            let $btnGroup = $('<div class="input-group-btn">').insertAfter(this.$inputTo);
            this.$dropdownBtn = $('<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><i class="fa fa-fw fa-caret-down"></i></button>');
            $btnGroup.append(this.$dropdownBtn);
            this.$dropdownWrap.appendTo($btnGroup);
        }
        let $item = null;
        if (id == "separator") $item = $('<li role="separator" class="divider"></li>');
        if (id == "header") {
            $item = $('<li class="dropdown-header"></li>').append($('<span>').text(label));
            if (iconClassName !== null && $item !== null) $('<i>').addClass("fa fa-fw").addClass(iconClassName).css({
                marginRight: 5
            }).prependTo($item);
        }
        if ($item == null) {
            let $a = $('<a>').attr("href", "#").append($('<span>').text(label));
            $item = $('<li>').addClass("dropdown-menu-item").attr("data-id", id).append($a);
            if (className) $item.addClass(className);
            $a.on("click", (e)=>{
                e.preventDefault();
                let disabled = $a.hasClass('disabled') || $item.hasClass('disabled');
                if (!disabled) {
                    this.lastClickedDropdownItemId = id;
                    this.dropdownHighlightItem(id);
                    if ($.isFunction(onClick)) onClick(this);
                }
            });
            if (iconClassName !== null && $item !== null) $('<i>').addClass("fa fa-fw").addClass(iconClassName).css({
                marginRight: 5
            }).prependTo($a);
        }
        $item.appendTo(this.$dropdownWrap);
        return $item;
    }
}


class $820c3ae16a934ae3$export$1df338bf50bb9e2c {
    liveDataChanged(latestData, ctx) {
        this.latestData = latestData;
        if (this.liveDataChangedCallback) this.liveDataChangedCallback(latestData, this);
    }
    // chart options to be applied (or overwritten) for all plots
    static chartOptionsDefault() {
        return {
            chart: {
                type: 'heatmap',
                zoomType: 'y',
                resetZoomButton: {
                    position: {
                        align: 'left',
                        x: 1,
                        y: 1
                    },
                    relativeTo: 'plotBox'
                }
            },
            xAxis: {
                type: 'datetime',
                gridZIndex: 4
            },
            yAxis: {
                gridZIndex: 4
            },
            colorAxis: {
                startOnTick: false,
                endOnTick: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: true
            },
            title: {
                text: ''
            }
        };
    }
    constructor(mainSite, page, $container, top, left, height, width, // chart options
    chartOptionsSpeed, chartOptionsDirection, //: intent: ability to make data retrieval a provided method so this chart can be flexible.. the callback will be responsible for handling appropriately formed data once retrieved and transformed.
    getDataMethod, //: intent: added this to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
    liveDataChangedCallback, reciprocalYAxisLabel){
        this.mainSite = mainSite;
        this.chartOptionsSpeed = chartOptionsSpeed;
        this.chartOptionsDirection = chartOptionsDirection;
        this.getDataMethod = getDataMethod;
        this.liveDataChangedCallback = liveDataChangedCallback;
        this.reciprocalYAxisLabel = reciprocalYAxisLabel;
        this.latestData = null;
        this.predefinedPeriods = [
            -24,
            -168,
            -720
        ];
        this.stationId = page.station.Station.Id;
        this.$box = $('<div class="midi_SiteObservations_chart_container"></div>').css('position', 'absolute').css('height', height + '%').css('width', width + '%').css('paddingTop', 5);
        $container.empty();
        $container.append(this.$box);
        let $chartToolbars = $('<div class="current_chart_selector no-select row" style="font-size: 0.9em;align-items: center;display: flex;"></div>').appendTo(this.$box);
        let $dateRangeSelector = $('<div class="col-sm-9" data-toolbar-type="dates"></div>').appendTo($chartToolbars);
        //: add DateRangePicker:
        this.drp = new (0, $e903168b3f468a55$export$17334619f3ac2224)(this.mainSite, $dateRangeSelector, (drp)=>{
            if (!drp.onChangeDateViaSetValuesMethods) {
                this.drp.dropdownSetButtonText("Custom range");
                this.selectedHours = null; //: important: we use this to determine if livedata should shift datepicker range..
            }
            let data = drp.getData();
            if (data && data.isValid && data.hasRange) this.updateChart();
        });
        this.drp.render(null, "row", true);
        if (this.reciprocalYAxisLabel) {
            let box = $('<div style="display:flex;align-items:center;"></div>').append($('<span style="font-size: 0.8em; margin-right: 0.3em;"></span>').text(this.reciprocalYAxisLabel)).appendTo($chartToolbars);
            this.reciprocalYAxisToggle = $('<input type="checkbox" style="margin-top: 0"/>').click(()=>{
                (0, $52db63ea8facb471$export$1a86835baa79d770).localStorageSet('reciprocalHovmollerYAxis', this.reciprocalYAxisToggle.is(':checked').toString());
                this.updateChart();
            }).appendTo(box);
            //note that if the reciprocalYAxisLabel is set (currently only for waves) then this will apply to
            //all charts (we do not currently separate into different Hovmollers)
            let isChecked = (0, $52db63ea8facb471$export$1a86835baa79d770).localStorageGet('reciprocalHovmollerYAxis', null) === "true";
            if (isChecked) this.reciprocalYAxisToggle.click();
        }
        // add drop-down with predefined data ranges
        this.predefinedPeriods.forEach((hours, i)=>{
            let prev = i == 0 ? null : this.predefinedPeriods[i - 1];
            if (i == 0) {
                this.drp.dropdownAddItem('header', 'Predefined periods', null);
                if (hours < 0) {
                    this.drp.dropdownAddItem('separator', null, null);
                    this.drp.dropdownAddItem('header', 'Past', null);
                }
            }
            if (prev < 0 && hours >= 0) {
                this.drp.dropdownAddItem('separator', null, null);
                this.drp.dropdownAddItem('header', 'Forecast', null);
            }
            let isForecast = hours > 0;
            let days = hours / 24;
            let label = `${Math.abs(days)} day${days == 1 || days == -1 ? '' : 's'}`;
            this.drp.dropdownAddItem(`predefined-hours-${hours}`, label, (drp)=>{
                this.selectedHours = Math.abs(hours);
                this.forecast = isForecast;
                this.updateChartHours(Math.abs(hours), true, isForecast);
                let $el = $('<span>');
                $el.append($(`<em class="text-primary">${isForecast ? 'Forecast' : 'Past'}</em>`).css({
                    marginRight: 5
                }));
                $el.append($(`<span>${label}</span>`));
                this.drp.dropdownSetButtonElements($el);
            }, i == 0 ? "active" : "", isForecast ? "fa-forward" : "fa-backward");
        });
        this.drp.dropdownSetButtonText("Select range");
        //: add a timezone indicator (tucked away in drop-down of predefined ranges)
        let tzd = this.drp.getSelectedTimezoneData();
        if (tzd) {
            if (this.predefinedPeriods.length > 0) this.drp.dropdownAddItem('separator', null, null);
            this.drp.dropdownAddItem('timezone-display', `${tzd.timeZoneCode} (${tzd.offsetString})`, null, "disabled", "fa-globe");
        }
        /*let originalContainerHeightPercent = 83;*/ let originalContainerHeightPercent = 50;
        //// Speed
        // create div for container and append to box
        this.$chartContainerSpeed = $('<div class="hovmoller-chart-container" id="hovmoller-speed"></div>').css('height', originalContainerHeightPercent + '%').appendTo(this.$box);
        // set css
        this.$chartContainerSpeed.css({
            marginTop: 5
        });
        // create color axis label and append to box
        this.$chartColorAxisLabelSpeed = $('<div class="hovmoller-chart-label" style="position: relative; margin-top: -23px; font-size: 12px; text-align: center;"></div>').appendTo(this.$box);
        //// Direction
        if (this.chartOptionsDirection) {
            // create div for container and append to box
            this.$chartContainerDirection = $('<div class="hovmoller-chart-container" id="hovmoller-direction"></div>').css('height', originalContainerHeightPercent + '%').appendTo(this.$box);
            // set css
            this.$chartContainerDirection.css({
                marginTop: 5
            });
            // create color axis label and append to box
            this.$chartColorAxisLabelDirection = $('<div class="hovmoller-chart-label" style="position: relative; margin-top: -23px; font-size: 12px; text-align: center;"></div>').appendTo(this.$box);
        }
        //// Add charts
        //copy options here
        this.chartSpeed = this.addChart(this.$chartContainerSpeed, JSON.parse(JSON.stringify(this.chartOptionsSpeed)));
        if (this.chartOptionsDirection) this.chartDirection = this.addChart(this.$chartContainerDirection, this.chartOptionsDirection);
        // In the drop down menu for predefined time ranges, select the first option
        this.drp.dropdownTriggerItemClick(`predefined-hours-${this.predefinedPeriods[0]}`);
        if (this.mainSite.liveDataManager.latestData) this.liveDataChanged(this.mainSite.liveDataManager.latestData, null);
    }
    updateChartHours(hours, reload, forecast) {
        let toMoment;
        let fromMoment;
        let tzd = this.drp.getSelectedTimezoneData();
        let tzn = 'UTC';
        if (tzd) tzn = tzd.timeZoneName;
        if (forecast) {
            fromMoment = moment.utc().tz(tzn);
            toMoment = moment.utc().tz(tzn).add(hours, 'h');
        } else {
            toMoment = moment.utc().tz(tzn);
            fromMoment = moment.utc().tz(tzn).subtract(hours, 'h');
        }
        this.drp.setValues(fromMoment, toMoment, true, "Hovmoeller.updateChartHours");
    }
    addChart(chartContainer, chartOptions) {
        try {
            chartContainer.highcharts(chartOptions);
            let chart = chartContainer.highcharts();
            return chart;
        } catch (err) {
            console.warn('unable to setup highchart: ', err);
            let chart = chartContainer.html('<div class="alert alert-danger">Error while trying to load chart.</div>');
            return chart;
        }
    }
    prepareChartSeries(data, measures, chartOptions) {
        let res = {
            boostThreshold: 100,
            //borderWidth: 0,
            nullColor: '#EFEFEF',
            colsize: 24 * 36e5,
            //colsize: 600000,
            //rowsize: 20,
            tooltip: chartOptions.tooltip,
            turboThreshold: Number.MAX_VALUE,
            id: "HOVMOL",
            data: this.chartDataPointsToArrays(data),
            connectEnds: true,
            connectNulls: true,
            interpolation: true
        };
        try {
            if (measures.x.gapMin && measures.x.gapMin > 0) res['colsize'] = measures.x.gapMin;
            if (measures.y.gapMax && measures.y.gapMax > 0) res['rowsize'] = measures.y.gapMax;
        } catch (err) {
            console.warn('HovmollerChart - prepareChartSeries ERROR: unable to apply measures to colsize & rowsize to series!', {
                err: err
            });
        }
        return res;
    }
    /**
     * Converts formatted data points (`ChartDataPoint`) to arrays for use in the chart data, as chart data does not know how to read objects necessarily.
     * @param data
     * @returns
     */ chartDataPointsToArrays(data) {
        let res = [];
        for(let i = 0; i < data.length; i++)res.push([
            data[i].timestamp,
            data[i].y,
            data[i].val
        ]);
        return res;
    }
    /**
     * Helper to get data 'measures', usually min/max/mid points for y/val arrays.
     * @param data
     * @returns
     */ chartDataMeasures(data) {
        let measures = {
            x: {
                min: -Infinity,
                max: Infinity,
                mid: null,
                gapMin: null,
                gapMax: null
            },
            y: {
                min: -Infinity,
                max: Infinity,
                mid: null,
                gapMin: null,
                gapMax: null
            },
            val: {
                min: -Infinity,
                max: Infinity,
                mid: null,
                gapMin: null,
                gapMax: null
            }
        };
        let uniquesY = [];
        let uniquesX = [];
        for(let i = 0; i < data.length; i++){
            let x = data[i];
            if (this.reciprocalYAxisToggle && this.reciprocalYAxisToggle.is(':checked')) x.y = 1 / x.y;
            if (x.timestamp && uniquesX.indexOf(x.timestamp) < 0) uniquesX.push(x.timestamp);
            if (x.y && uniquesY.indexOf(x.y) < 0) uniquesY.push(x.y);
            if (measures.x.min == -Infinity || measures.x.min > x.timestamp) measures.x.min = x.timestamp;
            if (measures.x.max == Infinity || measures.x.max < x.timestamp) measures.x.max = x.timestamp;
            if (measures.y.min == -Infinity || measures.y.min > x.y) measures.y.min = x.y;
            if (measures.y.max == Infinity || measures.y.max < x.y) measures.y.max = x.y;
            if (measures.val.min == -Infinity || measures.val.min > x.val) measures.val.min = x.val;
            if (measures.val.max == Infinity || measures.val.max < x.val) measures.val.max = x.val;
        }
        uniquesX.sort((a, b)=>a - b);
        uniquesY.sort((a, b)=>a - b);
        console.info('hovmol chart, data measures, uniques:', {
            x: uniquesX,
            y: uniquesY
        });
        let solveGapMinMax = (arr)=>{
            let gapMin = null;
            let gapMax = null;
            if (arr.length > 1) for(let i = 1; i < arr.length; i++){
                let current = arr[i];
                let previous = arr[i - 1];
                let gap = Math.abs(current - previous);
                if (gapMin == null || gapMin > gap) gapMin = gap;
                if (gapMax == null || gapMax < gap) gapMax = gap;
            }
            return {
                min: gapMin,
                max: gapMax
            };
        };
        let solveX = solveGapMinMax(uniquesX);
        let solveY = solveGapMinMax(uniquesY);
        measures.y.gapMin = solveY.min;
        measures.y.gapMax = solveY.max;
        measures.x.gapMin = solveX.min;
        measures.x.gapMax = solveX.max;
        measures.y.mid = (measures.y.min + measures.y.max) / 2;
        measures.val.mid = (measures.val.min + measures.val.max) / 2;
        return measures;
    }
    applyChartData(data, chart, chartOptions, chartColorAxisLabel) {
        // when waiting for data
        if (!data.length) {
            chart.showLoading('Data not available');
            return;
        }
        // prepare data for plotting
        let measures = this.chartDataMeasures(data);
        let series = this.prepareChartSeries(data, measures, chartOptions);
        // if rowsize is set in series, use it
        let rowsize = null;
        if (series && 'rowsize' in series) rowsize = series['rowsize'];
        // set y-axis limits
        if (rowsize && !isNaN(rowsize)) chartOptions.yAxis = {
            ...chartOptions.yAxis,
            min: measures.y.min + Math.abs(rowsize / 2),
            max: measures.y.max - Math.abs(rowsize / 2)
        };
        // Speed: setting color axis label
        try {
            chartColorAxisLabel.text(series.tooltip.headerFormat.replace('<br>', '').replace('<br/>', '')); //: hack, but idea is to show chart's values title/units below colorAxis..
        } catch (err) {
            chartColorAxisLabel.text('');
        }
        // update the chart
        chart.update(chartOptions, false);
        // not sure. if there is more than one chart, remove the first chart?
        if (chart.series.length >= 1) chart.series[0].remove();
        chart.addSeries(series);
        console.info("HOVMOL CHART (DATA received & options/series prepared)", {
            instance: this,
            data: data,
            measures: measures,
            series: series,
            chartOptions: chartOptions
        });
        chart.hideLoading();
        chart.reflow();
    }
    updateChart() {
        let range = this.drp.getData();
        if (range && range.isValid && range.hasRange) {
            // Speed: Get data and apply to chart
            this.chartSpeed.showLoading('Getting data...');
            this.getDataMethod(range.from, range.to, true, (cmp)=>cmp.Speed, this, (data, failed, msg)=>{
                if (failed) this.chartSpeed.showLoading(msg ?? 'Error while retrieving chart data.');
                else {
                    let opts = JSON.parse(JSON.stringify(this.chartOptionsSpeed));
                    if (this.reciprocalYAxisToggle && this.reciprocalYAxisToggle.is(':checked') && this.reciprocalYAxisLabel) opts.yAxis["title"]["text"] = this.reciprocalYAxisLabel;
                    this.applyChartData(data, this.chartSpeed, opts, this.$chartColorAxisLabelSpeed);
                }
            });
            if (this.chartOptionsDirection) {
                // Direction: Get data and apply to chart
                this.chartDirection.showLoading('Getting data...');
                this.getDataMethod(range.from, range.to, false, (cmp)=>cmp.Direction, this, (data, failed, msg)=>{
                    if (failed) this.chartDirection.showLoading(msg ?? 'Error while retrieving chart data.');
                    else this.applyChartData(data, this.chartDirection, this.chartOptionsDirection, this.$chartColorAxisLabelDirection);
                });
            }
        }
    }
}




class $07be79b8daca7111$export$3efe75ad489a5e73 {
    constructor(title, content, isBodyHtml = false, isConfirmDialog = false, confirmCallback = null){
        this.isBodyHtml = isBodyHtml;
        this._titleText = 'Message';
        this._contentText = 'This page says hello :)';
        this._destroyed = false;
        this.modal = null;
        this.modalContent = null;
        this.modalHeader = null;
        this.modalCloseButton = null;
        this.modalHeaderText = null;
        this.modalBody = null;
        this.modalFooter = null;
        this.modalFooterDismissButton = null;
        this.modalFooterConfirmButton = null;
        this._titleText = title;
        this._contentText = content;
        this.modal = $('<div class="modal fade SimpleDialog--modal"></div>').appendTo('body');
        this.modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));
        this.modalHeader = $('<div class="modal-header"></div>').appendTo(this.modalContent);
        this.modalCloseButton = $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(this.modalHeader);
        this.modalHeaderText = $('<h4 class="modal-title"></h4>').appendTo(this.modalHeader);
        if (this._titleText !== null) //this.modalHeaderText.text(this._titleText);
        this.setTitle(this._titleText);
        this.modalBody = $('<div class="modal-body"></div>').appendTo(this.modalContent);
        if (this._contentText !== null) {
            if (this.isBodyHtml) this.modalBody.html(this._contentText);
            else this.modalBody.append($('<p></p>').text(this._contentText));
        }
        this.modalFooter = $('<div class="modal-footer"></div>').appendTo(this.modalContent);
        if (isConfirmDialog) {
            this.modalFooterConfirmButton = $('<button type="button" class="btn btn-success">OK</button>').appendTo(this.modalFooter);
            let _this = this;
            this.modalFooterConfirmButton.on("click", (e)=>{
                if (confirmCallback) confirmCallback(_this);
                else {
                    console.warn("NO CALLBACK DEFINED FOR THE CONFIRM DIALOG!", _this);
                    alert("Error: no action defined for this confirmation.");
                    _this.hide();
                }
            });
            this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>').appendTo(this.modalFooter);
        } else this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">OK</button>').appendTo(this.modalFooter);
        this.modal.on("hidden.bs.modal", (e)=>{
            this.destroy();
        });
    }
    destroy() {
        if (this.modal) {
            this._destroyed = true;
            this.modal.remove();
            this.modal = null;
            this.modalContent = null;
            this.modalHeader = null;
            this.modalCloseButton = null;
            this.modalHeaderText = null;
            this.modalBody = null;
            this.modalFooter = null;
            this.modalFooterDismissButton = null;
            this.modalFooterConfirmButton = null;
        }
    }
    show() {
        this.modal.modal({
            backdrop: 'static',
            keyboard: false,
            show: true
        });
    }
    hide() {
        this.modal.modal('hide');
    }
    setTitle(title = "") {
        this.modalHeaderText.text(title); //: NB: not escaping string here as we're using the .text method from JQuery.
    }
    getModal() {
        return this.modal;
    }
    getBody() {
        return this.modalBody;
    }
    getFooter() {
        return this.modalFooter;
    }
    getDismissButton() {
        return this.modalFooterDismissButton;
    }
}



class $9616a178b649c555$var$DateTimeInputValue {
    constructor(){
        this.isValid = false;
        this.inputDate = "";
        this.inputTime = "";
        this.moment = null;
    }
}
var $9616a178b649c555$export$861facf577d6ed7a = /*#__PURE__*/ function(ProfileTypeEnum) {
    ProfileTypeEnum[ProfileTypeEnum["Depth"] = 0] = "Depth";
    ProfileTypeEnum[ProfileTypeEnum["Height"] = 1] = "Height";
    ProfileTypeEnum[ProfileTypeEnum["Horizontal"] = 2] = "Horizontal";
    return ProfileTypeEnum;
}({});
class $9616a178b649c555$export$7a7236f9a7498ef8 {
    constructor(page, container, top, left, height, width, speedUnits, profileName, profileEnumType, sensorId = null){
        this.page = page;
        this.speedUnits = speedUnits;
        this.profileName = profileName;
        this.profileEnumType = profileEnumType;
        this.sensorId = sensorId;
        this.useLiveData = true;
        this.profileData = null;
        this.timestamp = null;
        this.requestTimestamp = null;
        this.latestLiveDataValue = null;
        this.historicalValueKey = "P/{StationId}/{SensorId}/{ParameterId}";
        this.lsOptsKey = `${profileName}ProfileChartOpts`;
        this.stationId = page.station.Station.Id;
        window["_ProfileChart"] = this;
        var box = $('<div class="midi_SiteObservations_chart_container"></div>').css("position", "absolute").css("top", top + "%").css("left", left + "%").css("height", height + "%").css("width", width + "%");
        container.append(box);
        this.$toolbar = $("<div>").appendTo(box);
        this.$messagebar = $("<div>").addClass("CurrentProfile--MessageBar text-right small").css("height", "16px").css("marginTop", "2px").css("fontSize", "12px").css("overflow", "hidden").css("clear", "both").appendTo(box);
        this.chart = $("<div></div>").css("height", "100%").css("clear", "both").appendTo(box);
        this.$spinner = $("<div>").addClass("CurrentProfile--Spinner text-muted").appendTo(box);
        this.$spinner.css({
            position: "absolute",
            top: "3px",
            left: "4px",
            zIndex: 100,
            padding: "4px",
            backgroundColor: "rbga(255,255,255,.9)"
        });
        $("<div>").html('<i class="fa fa-spin fa-refresh"></i> <span>Loading</span>').appendTo(this.$spinner);
        var currentProfileStyle = " float: right;";
        var windProfileStyle = " margin: auto;";
        let $dpWrap = $('<div class="input-group input-group-sm" style="max-width: 380px; ' + (this.profileEnumType === 0 ? currentProfileStyle : windProfileStyle) + '"></div>');
        $dpWrap.appendTo(this.$toolbar);
        this.$chkUseLiveData = $('<input type="checkbox" checked />').prependTo($('<span class="input-group-addon"><strong style="margin-left: 5px; display: inline-block;">Live Data</strong></span>').appendTo($dpWrap));
        this.$chkUseLiveData.on("change", (e)=>{
            this.setUseLiveData(this.$chkUseLiveData.is(":checked"));
        });
        // $('<input type="text" disabled readonly class="form-control" style="width:0; border: 0;">').appendTo($dpWrap); // an invisible input, for styling..
        this.$btnDTPrev = $("<button>").html('<i class="fa fa-lg fa-fw fa-chevron-left"></i>').addClass("btn btn-default").css("borderRadius", 0).appendTo($('<span class="input-group-btn">').appendTo($dpWrap));
        this.$inputDate = $("<input>").addClass("form-control text-center").attr("placeholder", "YYYY-MM-DD").attr("type", "text").appendTo($dpWrap);
        $('<span class="input-group-addon" style="padding: 0; border: 0; width: 0;"></span>').appendTo($dpWrap);
        this.$inputTime = $("<input>").addClass("form-control text-center").attr("placeholder", "HH:MM:SS").attr("type", "text").appendTo($dpWrap);
        this.$btnDTNext = $("<button>").html('<i class="fa fa-lg fa-fw fa-chevron-right"></i>').addClass("btn btn-default").appendTo($('<span class="input-group-btn">').appendTo($dpWrap));
        this.$inputDate.on("change", ()=>{
            this.dtOnChange();
        });
        this.$inputTime.on("change", ()=>{
            this.dtOnChange();
        });
        this.$inputDate.prop("disabled", true);
        this.$inputTime.prop("disabled", true);
        this.$btnDTPrev.prop("disabled", true);
        this.$btnDTNext.prop("disabled", true);
        let im = new Inputmask("99:99:99");
        im.mask(this.$inputTime[0]);
        this.$inputDate.datepicker({
            //: https://bootstrap-datepicker.readthedocs.io/en/latest/options.html
            weekStart: 1,
            format: "yyyy-mm-dd",
            multidate: false,
            clearBtn: false,
            immediateUpdates: true,
            keepEmptyValues: true,
            todayBtn: true
        });
        this.chart.css("height", "calc(100% - " + Math.max(this.$toolbar.outerHeight() + this.$messagebar.outerHeight(), 48) + "px)");
        this.drawChartMessage("Waiting for " + this.profileName + " Profile Data...", true);
        this.$btnDTNext.on("click", (e)=>{
            $(e.target).blur();
            let newTs = moment.utc().utcOffset(this.page.mainSite.getTimeZoneUtcOffset()).valueOf();
            let dtiv = this.getDtInputsValue();
            if (dtiv && dtiv.moment && dtiv.moment.isValid()) newTs = dtiv.moment.valueOf();
            newTs += 1000;
            this.getData(newTs, false, true);
        });
        this.$btnDTPrev.on("click", (e)=>{
            $(e.target).blur();
            let newTs = moment.utc().utcOffset(this.page.mainSite.getTimeZoneUtcOffset()).valueOf();
            let dtiv = this.getDtInputsValue();
            if (dtiv && dtiv.moment && dtiv.moment.isValid()) newTs = dtiv.moment.valueOf();
            newTs -= 1000;
            this.getData(newTs, true, true);
        });
        box.on("click", ".custom-actions", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            let $target = $(e.currentTarget);
            $target.trigger("blur");
            let action = $target.data("action");
            try {
                //: wrapping in a UI silent try/catch just to prevent other failures in case of lack of browser support, although this should not cause any issues as support for following block is generally pretty good.
                if ($target.hasClass("actions--set-xaxis-range") || $target[0].classList.contains("actions--set-xaxis-range")) //: NB: .hasClass does not seem to work somehow.. SEE: https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
                action = "ProfileChart--set-xaxis-range";
            } catch (err) {
                console.error("Error while attempting to determine .custom-actions class..", err);
            }
            switch(action){
                default:
                    console.warn(`ERROR: Action '${action}' not recognised!`, {
                        e: e,
                        $target: $target,
                        action: action
                    });
                    break;
                case "ProfileChart--set-xaxis-range":
                    this.showSpeedOptionsModal();
                    break;
            }
        });
        if (page.mainSite.liveDataManager.latestData) this.liveDataChanged(page.mainSite.liveDataManager.latestData);
    }
    dtOnChange() {
        let dtiv = this.getDtInputsValue();
        if (dtiv.isValid) this.getData(dtiv.moment.valueOf(), false);
        else {
            this.setMessage(null);
            this.drawChartMessage("Date and/or Time indicated above not valid.");
        }
    }
    getDtInputsValue() {
        let dtiv = new $9616a178b649c555$var$DateTimeInputValue();
        dtiv.inputDate = this.$inputDate.val();
        dtiv.inputTime = this.$inputTime.val();
        let m = moment.utc(dtiv.inputDate + " " + dtiv.inputTime + "" + this.page.mainSite.getTimeZoneStringFormat("ZZ"), "YYYY-MM-DD HH:mm:ssZ", true);
        dtiv.isValid = m && m.isValid();
        if (dtiv.isValid) dtiv.moment = m;
        return dtiv;
    }
    setUseLiveData(flag = true) {
        this.useLiveData = flag;
        if (this.useLiveData) {
            this.setMessage(null);
            this.$inputDate.prop("disabled", true);
            this.$inputTime.prop("disabled", true);
            this.$btnDTPrev.prop("disabled", true);
            this.$btnDTNext.prop("disabled", true);
            //: now set inputs/chart to latest available data:
            if (this.latestLiveDataValue == null) {
                this.$inputDate.val("");
                this.$inputTime.val("");
                this.drawChartMessage(this.profileName + " Profile not available");
            } else {
                this.setDateTimeInputValues(this.latestLiveDataValue.Timestamp);
                this.drawChart(this.getProfileFromValue(this.latestLiveDataValue), this.latestLiveDataValue.Timestamp, null);
            }
        } else {
            this.$inputDate.prop("disabled", false);
            this.$inputTime.prop("disabled", false);
            this.$btnDTPrev.prop("disabled", false);
            this.$btnDTNext.prop("disabled", false);
        //: do nothing else until user modifies the date/time manually?
        }
    }
    setDateTimeInputValues(timestamp = null, triggerChange = false) {
        this.$inputDate.val("");
        this.$inputTime.val("");
        if (timestamp !== null) {
            let m = moment.utc(timestamp);
            if (m.isValid()) {
                m.utcOffset(this.page.mainSite.getTimeZoneUtcOffset());
                this.$inputDate.val(m.format("YYYY-MM-DD"));
                this.$inputDate.datepicker("update");
                //this.$inputDate.datepicker.setUTCDate(m.toDate()); // ?..
                this.$inputTime.val(m.format("HH:mm:ss"));
            }
        }
        if (triggerChange) this.$inputTime.trigger("change");
    }
    liveDataChanged(latestData) {
        let groupName = this.profileEnumType === 1 ? "WindProfile_mps" : this.speedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).kts ? this.profileName + "Profile/kts" : this.profileName + "Profile";
        if (this.profileEnumType === 2) groupName = "Horizontal" + groupName;
        this.historicalValueKey = this.historicalValueKey.replace("{StationId}", this.stationId).replace("{SensorId}", "Buoy").replace("{ParameterId}", groupName);
        if (latestData.Stations[this.stationId] && latestData.Stations[this.stationId].GroupValues[groupName] && (latestData.Stations[this.stationId].GroupValues[groupName].filter((v)=>v.Sensor == this.sensorId).length > 0 || !this.sensorId)) {
            if (latestData.Stations[this.stationId].GroupValues[groupName].filter((v)=>v.Sensor == this.sensorId).length > 0) // If the specified sensorId is available, use data from the specified sensorId
            this.latestLiveDataValue = latestData.Stations[this.stationId].GroupValues[groupName].filter((v)=>v.Sensor == this.sensorId)[0];
            else // If sensorId is not specified, use data from the first available sensorId
            this.latestLiveDataValue = latestData.Stations[this.stationId].GroupValues[groupName][0];
        } else // If the specified sensorId is not available
        this.latestLiveDataValue = null;
        if (this.useLiveData) {
            if (this.latestLiveDataValue) {
                this.setMessage(null);
                this.setDateTimeInputValues(this.latestLiveDataValue.Timestamp);
                this.drawChart(this.getProfileFromValue(this.latestLiveDataValue), this.latestLiveDataValue.Timestamp, null);
            } else {
                this.setMessage(null);
                this.drawChartMessage(this.profileName + " Profile not available");
            }
        }
    }
    getProfileFromValue(val) {
        if (val == null || val.ExpiryStatus === null || val.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) return null;
        return val.Value;
    }
    getData(requestedTimestamp = null, isBackwardRequested = false, isPrevNextButton = false) {
        this.setMessage(null);
        if (this.latestLiveDataValue == null) {
            console.warn(this.profileName + " Profile Chart: Unable to run .getData() as we haven't yet received any LiveData, required to determine SensorId & ParameterId for the HistoricalData request.");
            alert("Unable to query data: please wait for the page to have received at least one Live Data Value before requesting a different timestamp.");
        } else {
            if (requestedTimestamp == null) {
                let dtiv = this.getDtInputsValue();
                if (dtiv.isValid) requestedTimestamp = dtiv.moment.valueOf();
                else requestedTimestamp = moment.utc().utcOffset(this.page.mainSite.getTimeZoneUtcOffset()).valueOf();
            }
            let uri = `/api/v1/HistoricalData/P/${this.stationId}/${encodeURIComponent(this.latestLiveDataValue.Sensor)}/${encodeURIComponent(this.latestLiveDataValue.Parameter)}?limit=1&${isBackwardRequested ? "toUnixMillis" : "fromUnixMillis"}=${requestedTimestamp}`;
            // this.drawChartMessage("Retrieving Current Profile Data...", true);
            this.$spinner.show();
            $.ajax(uri + "", {
                cache: false,
                dataType: "json",
                type: "GET",
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    //callback(null, data);
                    let profile = null;
                    let timestamp = null;
                    try {
                        if (!Array.isArray(data.results[0].series[0].values) || data.results[0].series[0].values.length !== 1) {
                            console.warn("Server responded with none or more than 1 result, which is unexpected.");
                            if (isPrevNextButton) {
                                let typeWord = isBackwardRequested ? "previous" : "further";
                                this.drawChartMessage(`No ${typeWord} ${this.profileName} Profile available.`);
                            } else this.drawChartMessage("Unable to find ${this.profileName} Profile Data for the requested Date and Time.");
                            return;
                        }
                        let m = moment.utc(data.results[0].series[0].values[0][0], "YYYY-MM-DD HH:mm:ssZ", true);
                        if (m && m.isValid()) {
                            profile = JSON.parse(data.results[0].series[0].values[0][1]);
                            timestamp = m.valueOf();
                            // console.info('CurrentProfileData', { profile: profile, ts: timestamp, m: m, serverResponse: data });
                            this.drawChart(profile, timestamp, requestedTimestamp);
                            if (timestamp !== requestedTimestamp) {
                                this.setDateTimeInputValues(timestamp, false);
                                if (!isPrevNextButton) this.setMessage("Using nearest data to " + moment.utc(requestedTimestamp).utcOffset(this.page.mainSite.getTimeZoneUtcOffset()).format("YYYY-MM-DD HH:mm:ss Z"));
                            }
                        } else {
                            console.warn("Unable to parse " + this.profileName + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            this.drawChartMessage("Error while retrieving " + this.profileName + " Profile Data.");
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.profileName + " Profile Data from server response. Error: ", err);
                        this.drawChartMessage("Error while retrieving " + this.profileName + " Profile Data.");
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.profileName + " Profile Data from server response. Error: ", errorThrown);
                    this.drawChartMessage("Error while retrieving " + this.profileName + " Profile Data.");
                }
            });
        }
    }
    setMessage(msg = null, className = "text-muted", icon = "fa fa-fw fa-info-circle") {
        this.$messagebar.empty();
        if (msg) {
            let $div = $("<div>").addClass(className).append($("<span>").text(msg));
            if (icon) $div.prepend($("<i>").addClass(icon));
            $div.appendTo(this.$messagebar);
        }
    }
    drawChartMessage(msg = this.profileName + " Profile not available", isLoading = false) {
        this.chart.empty();
        let $div = $("<div>").addClass("midi_SiteObservations_chart_no_data").text(msg);
        if (isLoading) $div.prepend('<i class="fa fa-fw fa-refresh fa-spin" style="margin-right: 5px;"></i>');
        this.chart.append($div);
        this.$spinner.hide();
    }
    drawChart(profile = null, timestamp, requestTimestamp = null) {
        var speedUnitsStr = this.speedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? "m/s" : "kts";
        var unitsStrDepthOrHeight = "m";
        this.timestamp = timestamp;
        this.requestTimestamp = requestTimestamp;
        this.profileData = profile;
        this.chart.empty();
        if (profile == null) {
            this.chart.append($('<div class="midi_SiteObservations_chart_no_data">' + this.profileName + " Profile not available</div>"));
            this.$spinner.hide();
        } else {
            var seriesOptions = [];
            var upperXAxisData = [];
            var lowerXAxisData = [];
            //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
            let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet("m");
            let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
            let ucf_DepthOrHeight = (value)=>value;
            let ucf_Speed = (value)=>value;
            if (unitsConversionSet_DepthOrHeight) {
                ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
                unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
            }
            if (unitsConversionSet_Speed) {
                ucf_Speed = unitsConversionSet_Speed.convertValue;
                speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
            }
            profile.Components.forEach((component)=>{
                if (this.profileEnumType === 0 && component.Depth) {
                    if (component.Direction) upperXAxisData.push([
                        component.Direction,
                        ucf_DepthOrHeight(component.Depth)
                    ]);
                    if (component.Speed) lowerXAxisData.push([
                        ucf_Speed(component.Speed),
                        ucf_DepthOrHeight(component.Depth)
                    ]);
                }
                if (this.profileEnumType === 1 && component.Height) {
                    if (component.Direction) upperXAxisData.push([
                        component.Direction,
                        ucf_DepthOrHeight(component.Height)
                    ]);
                    if (component.Speed) lowerXAxisData.push([
                        ucf_Speed(component.Speed),
                        ucf_DepthOrHeight(component.Height)
                    ]);
                }
                if (this.profileEnumType === 2 && ucf_DepthOrHeight(component.Depth)) {
                    if (component.Direction) upperXAxisData.push([
                        ucf_DepthOrHeight(component.Depth),
                        component.Direction
                    ]);
                    if (component.Speed) lowerXAxisData.push([
                        ucf_DepthOrHeight(component.Depth),
                        ucf_Speed(component.Speed)
                    ]);
                }
            });
            var xAxisOptions = [];
            var yAxisOptions = [];
            seriesOptions.push({
                name: "Speed",
                color: "red",
                data: lowerXAxisData,
                xAxis: 0,
                yAxis: 0,
                dashStyle: "longdash",
                tooltip: {
                    headerFormat: "<b>{series.name}</b><br>",
                    pointFormatter: this.profileEnumType === 2 ? function() {
                        return sprintf("%.1f", this.y) + " " + speedUnitsStr + " at " + sprintf("%.1f", this.x) + " " + unitsStrDepthOrHeight;
                    } : function() {
                        return sprintf("%.1f", this.x) + " " + speedUnitsStr + " at " + sprintf("%.1f", this.y) + " " + unitsStrDepthOrHeight;
                    }
                }
            }, {
                name: "Direction " + (this.profileName == "Current" ? "To" : "From"),
                color: "green",
                data: upperXAxisData,
                xAxis: this.profileEnumType === 2 ? 0 : 1,
                yAxis: this.profileEnumType === 2 ? 1 : 0,
                lineWidth: 0,
                marker: {
                    enabled: true
                },
                tooltip: {
                    headerFormat: "<b>{series.name}</b><br>",
                    pointFormatter: this.profileEnumType === 2 ? function() {
                        return sprintf("%.0f", this.y) + " \xb0T " + (this.profileName == "Current" ? "TO" : "FROM") + " at " + sprintf("%.1f", this.x) + " " + unitsStrDepthOrHeight;
                    } : function() {
                        return sprintf("%.0f", this.x) + " \xb0T " + (this.profileName == "Current" ? "TO" : "FROM") + " at " + sprintf("%.1f", this.y) + " " + unitsStrDepthOrHeight;
                    }
                }
            });
            let speedAxisOptions = {
                title: {
                    text: `Speed (${speedUnitsStr}) <span class="custom-actions actions--set-xaxis-range" style="color: blue; text-decoration: underline; cursor: pointer;">Custom Range</span>`,
                    useHtml: true
                },
                alignTicks: false
            };
            let _opts = this.lsOptsGet();
            if (typeof _opts == "object" && _opts !== null && "xmin" in _opts && !isNaN(_opts.xmin) && _opts.xmin !== null) speedAxisOptions.min = _opts.xmin;
            if (typeof _opts == "object" && _opts !== null && "xmax" in _opts && !isNaN(_opts.xmax) && _opts.xmax !== null) speedAxisOptions.max = _opts.xmax;
            let dirAxisOptions = {
                title: {
                    text: "Direction (\xb0T " + (this.profileName == "Current" ? "TO" : "FROM") + ")"
                },
                min: 0,
                max: 360,
                opposite: true,
                tickInterval: 90,
                minTickInterval: 90,
                alignTicks: false
            };
            var depthAxisOptions = {
                title: {
                    text: "Depth (" + unitsStrDepthOrHeight + ")"
                },
                reversed: true
            };
            var heightAxisOptions = {
                title: {
                    text: "Height (" + unitsStrDepthOrHeight + ")"
                },
                reversed: false
            };
            var distanceAxisOptions = {
                title: {
                    text: "Distance (" + unitsStrDepthOrHeight + ")"
                },
                reversed: false
            };
            if (this.profileEnumType !== 2) {
                xAxisOptions.push(speedAxisOptions);
                xAxisOptions.push(dirAxisOptions);
                yAxisOptions.push(this.profileEnumType === 0 ? depthAxisOptions : heightAxisOptions);
            } else {
                xAxisOptions.push(distanceAxisOptions);
                yAxisOptions.push(speedAxisOptions);
                yAxisOptions.push(dirAxisOptions);
            }
            this.chart.highcharts({
                chart: {
                    type: "line",
                    marginTop: 60
                },
                exporting: {
                    enabled: true
                },
                title: {
                    text: ""
                },
                xAxis: xAxisOptions,
                yAxis: yAxisOptions,
                legend: {
                    enabled: true
                },
                plotOptions: {
                    line: {
                        marker: {
                            radius: 5,
                            enabled: true
                        }
                    },
                    series: {
                        animation: false,
                        // Line series default to 'x' only, which picks the wrong point on vertical profiles.
                        findNearestPointBy: "xy"
                    }
                },
                series: seriesOptions,
                credits: {
                    enabled: false
                }
            });
            this.$spinner.hide();
        }
    }
    /**
     * A helper method to just redraw the chart with exact same current data.
     * Added when providing ability to modify chart scales.
     */ refreshProfileChart() {
        this.drawChart(this.profileData, this.timestamp, this.requestTimestamp);
    }
    lsOptsGet() {
        let x = {
            xmin: 0,
            xmax: null
        };
        let ls = $.cookie(this.lsOptsKey);
        if (ls) try {
            let parsed = JSON.parse(ls);
            if (parsed) x = parsed;
        } catch (err) {
            console.warn("Unable to parse locally stored " + this.profileName + "ProfileChart Options..", {
                err: err,
                ls: ls
            });
        }
        return x;
    }
    lsOptsSet(x, redrawChart = true) {
        let s = JSON.stringify(x);
        $.cookie(this.lsOptsKey, s, {
            expires: 1825,
            path: "/"
        });
        if (redrawChart) this.refreshProfileChart();
    }
    showSpeedOptionsModal() {
        let opts = this.lsOptsGet();
        let sd = new (0, $07be79b8daca7111$export$3efe75ad489a5e73)(this.profileName + ` Profile Chart Speed Range`, null);
        let $body = sd.getBody();
        let $foot = sd.getFooter();
        $body.empty();
        let $form = $("<form>").addClass("form-horizontal").appendTo($body);
        let $group = null;
        let $check_label = null;
        let $inputMinVal = null;
        let $inputMaxVal = null;
        let $inputMinCheck = null;
        let $inputMaxCheck = null;
        //: code wrapper for inputs setup..
        //: min:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Minimum:").appendTo($group);
        $inputMinVal = $('<input type="text" style="text-align:right;" name="min" placeholder="Minimum">').addClass("input-sm form-control");
        $inputMinVal.appendTo($('<div class="col-sm-5">').appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($('<div class="col-sm-5">').appendTo($group));
        $inputMinCheck = $('<input type="checkbox" name="min_check">').appendTo($check_label);
        $check_label.append("<span>Auto</span>");
        $inputMinCheck.on("change", ()=>{
            if ($inputMinCheck.is(":checked")) $inputMinVal.val("").prop("disabled", true);
            else $inputMinVal.prop("disabled", false);
        });
        //: max:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Maximum:").appendTo($group);
        $inputMaxVal = $('<input type="text" style="text-align:right;" name="max" placeholder="Maximum">').addClass("input-sm form-control");
        $inputMaxVal.appendTo($('<div class="col-sm-5">').appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($('<div class="col-sm-5">').appendTo($group));
        $inputMaxCheck = $('<input type="checkbox" name="max_check">').appendTo($check_label);
        $check_label.append("<span>Auto</span>");
        $inputMaxCheck.on("change", ()=>{
            if ($inputMaxCheck.is(":checked")) $inputMaxVal.val("").prop("disabled", true);
            else $inputMaxVal.prop("disabled", false);
        });
        //: set values of inputs:
        $inputMinCheck.prop("checked", true).trigger("change");
        $inputMaxCheck.prop("checked", true).trigger("change");
        if (opts !== null && "xmin" in opts && opts.xmin !== null) {
            $inputMinCheck.prop("checked", false).trigger("change");
            $inputMinVal.val(opts.xmin.toString());
        }
        if (opts !== null && "xmax" in opts && opts.xmax !== null) {
            $inputMaxCheck.prop("checked", false).trigger("change");
            $inputMaxVal.val(opts.xmax.toString());
        }
        sd.getDismissButton().text("Cancel");
        let $save = $("<button>").addClass("btn btn-success").text("Save").prependTo($foot);
        $save.on("click", (e)=>{
            let x = {
                xmin: null,
                xmax: null
            };
            if ($inputMinCheck.prop("checked") == false && !isNaN(parseFloat($inputMinVal.val()))) x.xmin = parseFloat($inputMinVal.val());
            if ($inputMaxCheck.prop("checked") == false && !isNaN(parseFloat($inputMaxVal.val()))) x.xmax = parseFloat($inputMaxVal.val());
            this.lsOptsSet(x, true);
            sd.hide();
        });
        let $reset = $("<button>").addClass("btn btn-link pull-left").text("Reset").prependTo($foot);
        $reset.on("click", (e)=>{
            $.removeCookie(this.lsOptsKey);
            sd.hide();
            this.refreshProfileChart();
        });
        sd.show();
    }
}







class $afcc295e055250f2$export$269e444807daccc9 {
    constructor(mainSite, page, container, top, left, height, width, currentSpeedUnits, sensorId = null){
        this.mainSite = mainSite;
        this.currentSpeedUnits = currentSpeedUnits;
        this.sensorId = sensorId;
        this.scaleMin = null;
        this.scaleMax = null;
        this.lsOptsKey = "pvdOpts";
        this.lsSquareChartKey = "pvdSquareChart";
        this.stationId = page.station.Station.Id;
        this.box = $('<div class="midi_SiteObservations_chart_container"></div>').css("position", "absolute").css("top", top + "%").css("left", left + "%").css("height", height + "%").css("width", width + "%");
        container.append(this.box);
        let $chartToolbars = $('<div class="current_chart_selector no-select row" style="font-size: 0.9em;"></div>').appendTo(this.box);
        let $dateRangeSelector = $('<div class="col-sm-9" data-toolbar-type="dates"></div>').appendTo($chartToolbars);
        let timePeriodSelectorContainer = $('<div class="col-sm-3" data-toolbar-type="periods"></div>').appendTo($chartToolbars);
        //: add DateRangePicker:
        this.drp = new (0, $e903168b3f468a55$export$17334619f3ac2224)(this.mainSite, $dateRangeSelector, (drp)=>{
            if (!drp.onChangeDateViaSetValuesMethods) {
                this.drp.dropdownSetButtonText("Custom range");
                this.selectedHours = null; //: important: we use this to determine if livedata should shift datepicker range..
            }
            let data = drp.getData();
            if (data && data.isValid && data.hasRange) this.updateChart();
        });
        this.drp.render(null, "row", true);
        //this.drp.setTimezone("UTC"); //: this chart would use UTC 'hours' buttons before adding date-range picker..
        $("<button>Fullscreen</button>").appendTo($dateRangeSelector).click(()=>{
            this.chart.fullscreen.open();
        });
        let predefinedPeriods = [
            -24,
            -168,
            -720,
            120
        ]; //: negative = past, positives = forecasts (NB: if forecast data not available, positives get removed automatically)
        //check that we have any forecast data before appending the forecast time period selector
        let fcstParam = "Forecast_" + (this.currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id);
        //see if we have any forecast data before showing the forecast block
        (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, fcstParam, moment.utc().valueOf(), moment.utc().add("d", 1).valueOf(), (err, forecastData)=>{
            if (forecastData.Data !== null && forecastData.Data.length > 0) predefinedPeriods = predefinedPeriods.filter((x)=>x < 0); //: remove positives as they would be deemed as forecasts.
        }, this.sensorId ?? undefined);
        predefinedPeriods.forEach((hours, i)=>{
            let prev = i == 0 ? null : predefinedPeriods[i - 1];
            if (i == 0) {
                this.drp.dropdownAddItem("header", "Predefined periods", null);
                if (hours < 0) {
                    this.drp.dropdownAddItem("separator", null, null);
                    this.drp.dropdownAddItem("header", "Past", null);
                }
            }
            if (prev < 0 && hours >= 0) {
                this.drp.dropdownAddItem("separator", null, null);
                this.drp.dropdownAddItem("header", "Forecast", null);
            }
            let isForecast = hours > 0;
            let days = hours / 24;
            let label = `${Math.abs(days)} day${days == 1 || days == -1 ? "" : "s"}`;
            this.drp.dropdownAddItem(`predefined-hours-${hours}`, label, (drp)=>{
                this.selectedHours = Math.abs(hours);
                this.forecast = isForecast;
                this.updateChartHours(Math.abs(hours), true, isForecast);
                let $el = $("<span>");
                $el.append($(`<em class="text-primary">${isForecast ? "Forecast" : "Past"}</em>`).css({
                    marginRight: 5
                }));
                $el.append($(`<span>${label}</span>`));
                this.drp.dropdownSetButtonElements($el);
            }, i == 0 ? "active" : "", isForecast ? "fa-forward" : "fa-backward");
        });
        this.drp.dropdownSetButtonText("Select range");
        //: add a timezone indicator (tucked away in drop-down of predefined ranges)
        let tzd = this.drp.getSelectedTimezoneData();
        if (tzd) {
            if (predefinedPeriods.length > 0) this.drp.dropdownAddItem("separator", null, null);
            this.drp.dropdownAddItem("timezone-display", `${tzd.timeZoneCode} (${tzd.offsetString})`, null, "disabled", "fa-globe");
        }
        this.$ckboxScales = $('<input type="checkbox">').css({
            cursor: "pointer"
        });
        this.$ckboxScales.prependTo($("<label>").css({
            fontWeight: "normal",
            cursor: "pointer"
        }).text("Equal scales").appendTo($("<div>").addClass("checkbox-inline pull-right").css({
            marginTop: "4px"
        }).disableSelection().appendTo(timePeriodSelectorContainer)));
        this.$ckboxScales.on("change", (e)=>{
            if (this.$ckboxScales.prop("checked")) $.cookie(this.lsSquareChartKey, "true", {
                expires: 1825,
                path: "/"
            });
            else $.removeCookie(this.lsSquareChartKey);
            this.setSquareChart(this.$ckboxScales.prop("checked"), true);
            this.autoSetChartAxes();
        });
        //: set square chart if appropriate
        let cookiePVDSquare = $.cookie(this.lsSquareChartKey);
        if (typeof cookiePVDSquare == "string" && cookiePVDSquare == "true") this.$ckboxScales.prop("checked", true);
        this.originalContainerHeightPercent = 83;
        this.chartContainer = $("<div></div>").css("height", this.originalContainerHeightPercent + "%").appendTo(this.box);
        $(window).on("resize", (e)=>{
            this.setSquareChart(this.$ckboxScales.prop("checked"), true);
        });
        this.legendContainer = $('<div class="midi_SiteObservations_chart_heatmapLegend"></div>').hide();
        this.$speedLegendUL = $("<ul></ul>").appendTo(this.legendContainer);
        this.setSpeedLegend(0, 0.8, true, 1); //: default speed legend as was previously set..
        let $legendTitle = $('<div class="legendTitle"></div>');
        $("<span>").text("Current Speed (m/s)").appendTo($legendTitle);
        let $aSpeedOpts = $("<a>").text("Customise").attr("href", "#").css("marginLeft", "5px").addClass("btn btn-default btn-xs").appendTo($legendTitle);
        $aSpeedOpts.on("click", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.showSpeedOptionsModal();
            return false;
        });
        $legendTitle.appendTo(this.legendContainer);
        this.box.append(this.legendContainer);
        this.addChart();
        this.drp.dropdownTriggerItemClick(`predefined-hours-${predefinedPeriods[0]}`);
    }
    liveDataChanged(latestData) {
        if (!this.mainSite.liveDataManager.latestData) return;
        if (this.drp) {
            if (this.selectedHours !== null) //: alternatively check if the previously set range contained NOW : this.drp.getLastIncludedNow()
            this.drp.autoIncludeNow("shift", true, "PVD.liveDataChanged()");
            else if (this.drp.getCurrentRangeIncludesNow()) //: if current selected range contains NOW, then simply update the chart (with data refetch), without modifying the range.
            this.updateChart();
        }
    }
    addChart() {
        this.chartContainer.css({
            marginTop: 40
        });
        let chartOptions = {
            chart: {
                type: "scatter"
            },
            boost: {
                enabled: false
            },
            exporting: {
                enabled: true
            },
            title: {
                text: ""
            },
            xAxis: {
                title: {
                    text: "Virtual Distance E (km)"
                },
                startOnTick: false,
                endOnTick: false
            },
            yAxis: {
                title: {
                    text: "Virtual Distance N (km)"
                },
                startOnTick: false,
                endOnTick: false
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                line: {
                    marker: {
                        radius: 2,
                        enabled: true
                    }
                },
                series: {
                    animation: false,
                    turboThreshold: 0,
                    tooltip: {
                        pointFormat: "<b>{point.name}</b><br/>Virtual Distance E (km): <b>{point.x:.2f}</b><br/>Virtual Distance N (km): <b>{point.y:.2f}</b><br/>Speed: <b>{point.speed:.3f}</b>"
                    },
                    dataLabels: {
                        padding: 5,
                        allowOverlap: true
                    }
                }
            },
            credits: {
                enabled: false
            }
        };
        this.chartContainer.highcharts(chartOptions);
        this.chart = this.chartContainer.highcharts();
        Highcharts.SVGRenderer.prototype.symbols.cross = function(x, y, w, h) {
            return [
                "M",
                x,
                y,
                "L",
                x + w,
                y + h,
                "M",
                x + w,
                y,
                "L",
                x,
                y + h,
                "z"
            ];
        };
        if (Highcharts.VMLRenderer) Highcharts.VMLRenderer.prototype.symbols.cross = Highcharts.SVGRenderer.prototype.symbols.cross;
    }
    getChartDataAll(f = null, t = null, callback) {
        //: use this to retrieve data for chart (made a separate method to enable retrieving past and forecast data conjointly)
        if (!this.mainSite.liveDataManager.latestData) return;
        //: determine if we want forecast or not (ie split the from/to at now, and retrieve past then forecast ONLY IF forecasts available.)
        if (f == null || t == null) {
            let drpData = this.drp.getData();
            if (drpData && drpData.isValid && drpData.hasRange) {
                if (f == null) f = drpData.from;
                if (t == null) t = drpData.to;
            }
        }
        if (f == null || t == null) console.warn("PVD Chart WARNING: from or to dates are missing.");
        else if (!f.isValid() || !t.isValid()) console.warn("PVD Chart WARNING: from or to dates are not valid.");
        else if (!t.isAfter(f)) console.warn("PVD Chart WARNING: invalid date range ('to' needs to be after 'from'!).");
        else {
            let ranges = [];
            let now = moment.utc(); //: NB! this assumes we are (like historically for this chart) working in UTC
            if (now.isBetween(f, t)) {
                ranges.push({
                    from: f,
                    to: now,
                    forecast: false
                });
                ranges.push({
                    from: now,
                    to: t,
                    forecast: true
                });
            } else if (t.isSameOrBefore(now)) ranges.push({
                from: f,
                to: t,
                forecast: false
            });
            else if (f.isSameOrAfter(now)) ranges.push({
                from: f,
                to: t,
                forecast: true
            });
            let allData = [];
            let dataCallback = (i)=>{
                let range = ranges[i];
                this.getChartDataPart(range.from, range.to, range.forecast, (data)=>{
                    // console.info("getChartDataAll - RANGE DATA RETRIEVED", i, data.length, { myData: data, from: range.from.format(DateRangePicker.MOMENT_DEBUG_FORMAT), to: range.to.format(DateRangePicker.MOMENT_DEBUG_FORMAT), forecast: range.forecast, range: range });
                    allData = [].concat(allData, data);
                    if (i == ranges.length - 1) {
                        // console.info("getChartDataAll - ALL DATA RETRIEVED (TODO: UPDATE CHART)", i, allData.length, allData);
                        allData.sort((a, b)=>{
                            return a.timestamp - b.timestamp;
                        });
                        //this.applyChartData(allData);
                        if ($.isFunction(callback)) callback(allData);
                    } else {
                        i++;
                        dataCallback(i);
                    }
                });
            };
            dataCallback(0);
        }
    }
    getChartDataPart(fromMoment, toMoment, forecast, callback) {
        if (!this.mainSite.liveDataManager.latestData) return;
        const useMcpAi = forecast && (this.stationId == "Australia_Prelude" || this.stationId == "Australia_Crux");
        const usePreludeBin08 = this.stationId == "Australia_Prelude" && this.sensorId == "RTCP/Currents";
        let speedId = useMcpAi || this.currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id;
        let dirId = (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean.Id;
        if (forecast && !useMcpAi) {
            speedId = "Forecast_" + speedId;
            dirId = "Forecast_" + dirId;
        }
        if (usePreludeBin08) {
            speedId = "Total_CurrentSpeed_Bin08_mps_Mean";
            dirId = "Total_CurrentDirection_Bin08_deg_Mean";
        }
        // MCP-AI and Prelude Bin08 are raw series in m/s; forecast sensors have no sensor-specific group series.
        const rawSensorId = useMcpAi ? "Forecast/Currents/MCP_AI_v1" : usePreludeBin08 ? "RTCP/Currents" : null;
        const fetchData = (paramId, cb)=>rawSensorId ? (0, $fd959835eca46177$export$9bf04fc316538454)("P", this.stationId, rawSensorId, paramId, null, fromMoment.valueOf(), toMoment.valueOf(), cb, -1) : (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, paramId, fromMoment.valueOf(), toMoment.valueOf(), cb, this.sensorId ?? undefined);
        var anyData = false;
        let currentData = [];
        let desiredPoints = 5000;
        fetchData(speedId, (err, data)=>{
            if (err) {
                console.warn("PVD - Error getting data: ", err);
                this.chart.showLoading("Error getting data...");
                return;
            }
            anyData = anyData || data.Data !== null;
            if (data.Data !== null) {
                data.Data.unshift([
                    fromMoment.valueOf(),
                    null
                ]);
                data.Data.push([
                    toMoment.valueOf(),
                    null
                ]);
            }
            let pointSkip = Math.floor(data.Data.length / desiredPoints);
            data.Data.forEach((dataPoint, i)=>{
                if (pointSkip !== 0 && i % pointSkip !== 0) return;
                let ts = dataPoint[0];
                let val = dataPoint[1];
                if (!rawSensorId && this.currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).kts) val *= 0.514444;
                if (val) currentData.push({
                    timestamp: ts,
                    speed: val,
                    direction: null
                });
            });
        }).then(()=>{
            fetchData(dirId, (err, data)=>{
                if (err) {
                    console.warn("PVD - Error getting data: ", err);
                    this.chart.showLoading("Error getting data...");
                    return;
                }
                anyData = anyData || data.Data !== null;
                if (data.Data !== null) {
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                let pointSkip = Math.floor(data.Data.length / desiredPoints);
                data.Data.forEach((dataPoint, i)=>{
                    if (pointSkip !== 0 && i % pointSkip !== 0) return;
                    let ts = dataPoint[0];
                    let val = dataPoint[1];
                    let x = currentData.filter((x)=>x.timestamp === ts);
                    if (x.length) x[0].direction = val;
                });
            }).done(()=>{
                currentData = currentData.filter((x)=>x.speed && x.direction); //: NB: sorting has been moved to the all data fetching wrapper, so data from multiple sets is properly sorted.
                if ($.isFunction(callback)) callback(currentData);
            });
        });
    }
    applyChartData(data) {
        if (!data.length) {
            this.chart.showLoading("Data not available");
            return;
        }
        let axisMin = null;
        let axisMax = null;
        let axesSet = this.$ckboxScales.prop("checked");
        this.scaleMin = null;
        this.scaleMax = null;
        let opts = this.lsOptsGet();
        let speedMin = opts.min !== null ? opts.min : data.reduce((prev, curr)=>{
            return curr.speed <= prev.speed ? curr : prev;
        }).speed;
        let speedMax = opts.max !== null ? opts.max : data.reduce((prev, curr)=>{
            return curr.speed >= prev.speed ? curr : prev;
        }).speed;
        let gradient = this.getGradient(true, speedMin, speedMax);
        this.setSpeedLegend(speedMin, speedMax, opts.reversed, opts.textGranularity); // (speedMax >= 1.3 ? 2 : 1)
        //draw chart
        let pvdData = [];
        let datePoints = [];
        let pointX;
        let pointY;
        let lastTs;
        let lastDate = null;
        let tzn = "UTC";
        let tzd = this.drp.getSelectedTimezoneData();
        if (tzd) tzn = tzd.timeZoneName;
        data.forEach((d)=>{
            if (!lastTs) {
                pointX = 0;
                pointY = 0;
            } else {
                let r = (d.timestamp - lastTs) / 1000 * d.speed / 1000;
                let theta = d.direction * (Math.PI / 180);
                pointX = pointX + r * Math.sin(theta);
                pointY = pointY + r * Math.cos(theta);
            }
            let date = moment.unix(d.timestamp / 1000).format("DD-MM");
            if (date !== lastDate) datePoints.push({
                x: pointX,
                y: pointY,
                name: date
            });
            lastTs = d.timestamp;
            lastDate = date;
            let closest = gradient.reduce((prev, curr)=>{
                return Math.abs(curr.speed - d.speed) < Math.abs(prev.speed - d.speed) ? curr : prev;
            });
            //: set scaling min/max
            if (this.scaleMin == null || this.scaleMin > Math.min(pointX, pointY)) this.scaleMin = Math.min(pointX, pointY);
            if (this.scaleMax == null || this.scaleMax < Math.max(pointX, pointY)) this.scaleMax = Math.max(pointX, pointY);
            pvdData.push({
                x: pointX,
                y: pointY,
                color: closest.color,
                name: moment.utc(d.timestamp).tz(tzn).format("YYYY-MM-DD HH:mm (ZZ)"),
                speed: d.speed
            });
        });
        this.chart.hideLoading();
        let pvdSeries = {
            id: "PVD",
            name: "PVD",
            data: pvdData
        };
        let dateSeries = {
            id: "DateSeries",
            name: "DateSeries",
            data: datePoints,
            color: "black",
            enableMouseTracking: false,
            marker: {
                radius: 5,
                symbol: "cross",
                lineColor: null,
                lineWidth: 2
            },
            dataLabels: {
                format: "{point.name}",
                enabled: true
            }
        };
        if (this.chart.series.length < 1) {
            this.chart.addSeries(pvdSeries);
            this.chart.addSeries(dateSeries);
        } else {
            let cs = this.chart.get("PVD");
            cs.setData(pvdSeries.data);
            cs = this.chart.get("DateSeries");
            cs.setData(dateSeries.data);
        }
        if (axesSet) {
            axisMin = this.scaleMin;
            axisMax = this.scaleMax;
        }
        // console.info("AXES SET, DATA received", { count: pvdData.length, set: axesSet, min: axisMin, max: axisMax, sMin: this.scaleMin, sMax: this.scaleMax });
        this.updateChartAxes(axisMin, axisMax);
        this.chart.reflow();
        this.legendContainer.show();
    }
    updateChartHours(hours, reload, forecast) {
        let toMoment;
        let fromMoment;
        let tzd = this.drp.getSelectedTimezoneData();
        let tzn = "UTC";
        if (tzd) tzn = tzd.timeZoneName;
        if (forecast) {
            fromMoment = moment.utc().tz(tzn);
            toMoment = moment.utc().tz(tzn).add(hours, "h");
        } else {
            toMoment = moment.utc().tz(tzn);
            fromMoment = moment.utc().tz(tzn).subtract(hours, "h");
        }
        this.drp.setValues(fromMoment, toMoment, true, "PVD.updateChartHours");
    }
    updateChart() {
        let range = this.drp.getData();
        if (range && range.isValid && range.hasRange && this.mainSite.liveDataManager.latestData) {
            this.chart.showLoading("Getting data...");
            this.getChartDataAll(range.from, range.to, (data)=>{
                this.applyChartData(data);
            });
        }
    }
    updateChartAxes(min = null, max = null) {
        //: NB: keep as null to reset the extremes on the axes! (https://stackoverflow.com/a/27062784/753113)
        // console.info("chart scales - updateChartAxes().. [START]", { min: min, max: max, sMin: this.scaleMin, sMax: this.scaleMax });
        try {
            this.chart.showLoading("Updating chart scale...");
            this.chart.yAxis.forEach((axis)=>{
                axis.setExtremes(min, max, false, false);
            });
            this.chart.xAxis.forEach((axis)=>{
                axis.setExtremes(min, max, true, false);
            });
            this.chart.hideLoading();
        // console.info("chart scales - updateChartAxes().. [FINISHED]", { min: min, max: max, sMin: this.scaleMin, sMax: this.scaleMax });
        } catch (err) {
            console.warn("ERROR: unable to update chart axes: " + err.message, {
                err: err,
                chart: this.chart,
                min: min,
                max: max,
                sMin: this.scaleMin,
                sMax: this.scaleMax
            });
        }
    }
    autoSetChartAxes() {
        // console.info("chart scales - autoSetChartAxes()..");
        try {
            let axisMin = null; //: NB: keep as null to reset the extremes on the axes! (https://stackoverflow.com/a/27062784/753113)
            let axisMax = null;
            if (this.$ckboxScales.prop("checked")) {
                axisMin = this.scaleMin;
                axisMax = this.scaleMax;
            }
            //: now set:
            this.updateChartAxes(axisMin, axisMax);
        } catch (err) {
            console.warn("ERROR while automatically setting chart axes: ", err);
        }
    }
    setSquareChart(square = true, reflow = true) {
        try {
            if (square) {
                let w = this.chartContainer.outerWidth();
                this.chartContainer.css("height", w + "px"); //.css('border', '2px red dashed');
            } else this.chartContainer.css("height", this.originalContainerHeightPercent + "%"); //.css('border', '2px green dashed');
            if (reflow) this.chart.reflow();
        } catch (err) {
            console.warn("ERROR while automatically setting chart square (or not): ", {
                err: err,
                square: square,
                reflow: reflow
            });
        }
    }
    setSpeedLegend(min = null, max = null, reversed = true, textGranularity = null) {
        this.$speedLegendUL.empty();
        let gradient = this.getGradient(true, min, max);
        if (reversed) gradient.reverse();
        const w = 100 / gradient.length;
        // const textGranularity: number = 1;
        if (textGranularity == null) textGranularity = Math.max(1, Math.ceil(max));
        gradient.forEach((g)=>{
            this.$speedLegendUL.append($("<li></li>").css("width", w + "%").append($('<div class="heatmap_top"></div>').css("backgroundColor", g.color)).append($('<div class="heatmap_bottom"></div>').text(g.speed * 10 % textGranularity === 0 ? g.speed : "")));
        });
    }
    formatHoursToDays(hours) {
        let days = hours / 24;
        if (days === 1) return days + " day";
        return days + " days";
    }
    hex(c) {
        //: https://stackoverflow.com/a/32257791/753113
        var s = "0123456789abcdef";
        var i = parseInt(c);
        if (i == 0 || isNaN(c)) return "00";
        i = Math.round(Math.min(Math.max(0, i), 255));
        return s.charAt((i - i % 16) / 16) + s.charAt(i % 16);
    }
    convertToHex(rgb) {
        //: https://stackoverflow.com/a/32257791/753113 (Convert an RGB triplet to a hex string)
        return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
    }
    trim(s) {
        return s.charAt(0) == "#" ? s.substring(1, 7) : s;
    }
    convertToRGB(hex) {
        //: https://stackoverflow.com/a/32257791/753113 (Convert a hex string to an RGB triplet)
        var color = [];
        color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
        color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
        color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
        return color;
    }
    generateColor(colorStart, colorEnd, colorCount) {
        //: https://stackoverflow.com/a/32257791/753113 (Convert a hex string to an RGB triplet)
        // The beginning of your gradient
        var start = this.convertToRGB(colorStart);
        // The end of your gradient
        var end = this.convertToRGB(colorEnd);
        // The number of colors to compute
        var len = colorCount;
        //Alpha blending amount
        var alpha = 0.0;
        var saida = [];
        for(let i = 0; i < len; i++){
            var c = [];
            alpha += 1.0 / len;
            c[0] = start[0] * alpha + (1 - alpha) * end[0];
            c[1] = start[1] * alpha + (1 - alpha) * end[1];
            c[2] = start[2] * alpha + (1 - alpha) * end[2];
            saida.push("#" + this.convertToHex(c));
        }
        return saida;
    }
    getGradient(autogen = false, min = null, max = null, interval = 0.0125) {
        if (autogen && min !== null && max !== null) {
            let out = [];
            let arr = [];
            let n = min;
            while(n <= max){
                arr.push(n);
                // n = +(n + interval).toFixed(4); //: https://stackoverflow.com/a/12830454
                n = +(Math.ceil((n + interval) / interval) * interval).toFixed(4); //: https://stackoverflow.com/a/12830454  &&  https://stackoverflow.com/a/18953446/753113
            }
            const count = arr.length; // Math.floor(max / interval) - Math.floor((min - 1) / interval);
            let colours = [];
            //: split over 4 colours, to get a nicer gradient and closer to previous colours: colour stops: ['#3E26A8', '#2472BA', '#20CF96', '#36E41B', '#ECF915'] = [0.0, 0.2, 0.4, 0.6, 0.8]
            // NOTE: an alternative would be to try using an external library such as https://www.npmjs.com/package/gradstop, which seems to work nicely too. test (NB: only supports up to 4 colours in colorArray!): gradstop({ stops: 65, inputFormat: 'hex', colorArray: ['#3E26A8', '#2472BA', '#36E41B', '#ECF915'] }).forEach(x => { console.info(`%c       ` + `%c ${x}`, `background: ${x}`, `background: #fff, color: ${x}`); });
            colours = colours.concat(this.generateColor("#3E26A8", "#2472BA", Math.floor(count / 4)).reverse()); //: 1: static 0.0 - 0.2
            colours = colours.concat(this.generateColor("#2472BA", "#20CF96", Math.floor(count / 4)).reverse()); //: 2: static 0.2 - 0.4
            colours = colours.concat(this.generateColor("#20CF96", "#36E41B", Math.floor(count / 4)).reverse()); //: 3: static 0.4 - 0.6
            colours = colours.concat(this.generateColor("#36E41B", "#ECF915", count - Math.floor(count / 4) * 4 + Math.floor(count / 4)).reverse()); //: 4: static 0.6 - 0.8
            arr.forEach((n, i)=>{
                out.push({
                    speed: n,
                    color: colours[i]
                });
            });
            /*
            console.groupCollapsed("GRADIENT COLOURS PREVIEWS (COUNT: " + count + ")");
            console.info("getGradient..", { interval: interval, count: count, min: min, max: max, out: out, arr: arr, colours: colours });
            colours.forEach(x => {
                console.info(`%c       ` + `%c ${x}`, `background: ${x}`, `background: #fff, color: ${x}`);
            });
            console.groupEnd();
            */ return out;
        }
        return [
            {
                speed: 0.8,
                color: "#ECF915"
            },
            {
                speed: 0.7875,
                color: "#DFF815"
            },
            {
                speed: 0.775,
                color: "#D3F716"
            },
            {
                speed: 0.7625,
                color: "#C6F516"
            },
            {
                speed: 0.75,
                color: "#BAF417"
            },
            {
                speed: 0.7375,
                color: "#AEF317"
            },
            {
                speed: 0.725,
                color: "#A3F118"
            },
            {
                speed: 0.7125,
                color: "#97F018"
            },
            {
                speed: 0.7,
                color: "#8CEF18"
            },
            {
                speed: 0.6875,
                color: "#80ED19"
            },
            {
                speed: 0.675,
                color: "#75EC19"
            },
            {
                speed: 0.6625,
                color: "#6AEB1A"
            },
            {
                speed: 0.65,
                color: "#60E91A"
            },
            {
                speed: 0.6375,
                color: "#55E81A"
            },
            {
                speed: 0.625,
                color: "#4BE71B"
            },
            {
                speed: 0.6125,
                color: "#40E51B"
            },
            {
                speed: 0.6,
                color: "#36E41B"
            },
            {
                speed: 0.5875,
                color: "#2CE31C"
            },
            {
                speed: 0.575,
                color: "#23E11C"
            },
            {
                speed: 0.5625,
                color: "#1CE020"
            },
            {
                speed: 0.55,
                color: "#1DDF2A"
            },
            {
                speed: 0.5375,
                color: "#1DDE34"
            },
            {
                speed: 0.525,
                color: "#1DDC3E"
            },
            {
                speed: 0.5125,
                color: "#1EDB47"
            },
            {
                speed: 0.5,
                color: "#1EDA51"
            },
            {
                speed: 0.4875,
                color: "#1ED85A"
            },
            {
                speed: 0.475,
                color: "#1FD763"
            },
            {
                speed: 0.4625,
                color: "#1FD66C"
            },
            {
                speed: 0.45,
                color: "#1FD474"
            },
            {
                speed: 0.4375,
                color: "#20D37D"
            },
            {
                speed: 0.425,
                color: "#20D285"
            },
            {
                speed: 0.4125,
                color: "#20D08E"
            },
            {
                speed: 0.4,
                color: "#20CF96"
            },
            {
                speed: 0.3875,
                color: "#21CE9E"
            },
            {
                speed: 0.375,
                color: "#21CCA5"
            },
            {
                speed: 0.3625,
                color: "#21CBAD"
            },
            {
                speed: 0.35,
                color: "#21CAB5"
            },
            {
                speed: 0.3375,
                color: "#22C8BC"
            },
            {
                speed: 0.325,
                color: "#22C7C3"
            },
            {
                speed: 0.3125,
                color: "#22C2C6"
            },
            {
                speed: 0.3,
                color: "#22B8C4"
            },
            {
                speed: 0.2875,
                color: "#22AFC3"
            },
            {
                speed: 0.275,
                color: "#23A6C2"
            },
            {
                speed: 0.2625,
                color: "#239DC1"
            },
            {
                speed: 0.25,
                color: "#2394BF"
            },
            {
                speed: 0.2375,
                color: "#238BBE"
            },
            {
                speed: 0.225,
                color: "#2383BD"
            },
            {
                speed: 0.2125,
                color: "#247ABB"
            },
            {
                speed: 0.2,
                color: "#2472BA"
            },
            {
                speed: 0.1875,
                color: "#246AB9"
            },
            {
                speed: 0.175,
                color: "#2462B7"
            },
            {
                speed: 0.1625,
                color: "#245AB6"
            },
            {
                speed: 0.15,
                color: "#2452B5"
            },
            {
                speed: 0.1375,
                color: "#254BB3"
            },
            {
                speed: 0.125,
                color: "#2544B2"
            },
            {
                speed: 0.1125,
                color: "#253CB1"
            },
            {
                speed: 0.1,
                color: "#2535AF"
            },
            {
                speed: 0.0875,
                color: "#252EAE"
            },
            {
                speed: 0.075,
                color: "#2527AD"
            },
            {
                speed: 0.0625,
                color: "#2A25AB"
            },
            {
                speed: 0.05,
                color: "#3025AA"
            },
            {
                speed: 0.0375,
                color: "#3725A9"
            },
            {
                speed: 0.025,
                color: "#3E26A8"
            },
            {
                speed: 0.0125,
                color: "#3E26A8"
            },
            {
                speed: 0.0,
                color: "#3E26A8"
            }
        ];
    }
    lsOptsGet() {
        let x = {
            min: null,
            max: null,
            reversed: true,
            textGranularity: null
        };
        let ls = $.cookie(this.lsOptsKey);
        if (ls) try {
            let parsed = JSON.parse(ls);
            if (parsed) x = parsed;
        } catch (err) {
            console.warn("Unable to parse locally stored PVD Chart Options..", {
                err: err,
                ls: ls
            });
        }
        return x;
    }
    lsOptsSet(x, redrawChart = true) {
        let s = JSON.stringify(x);
        $.cookie(this.lsOptsKey, s, {
            expires: 1825,
            path: "/"
        });
        if (redrawChart) // this.updateChartHours(this.selectedHours, true, this.forecast);
        this.updateChart();
    }
    showSpeedOptionsModal() {
        let opts = this.lsOptsGet();
        let sd = new (0, $07be79b8daca7111$export$3efe75ad489a5e73)(`PVD Chart Speed Range`, null);
        let $body = sd.getBody();
        let $foot = sd.getFooter();
        $body.empty();
        let $form = $("<form>").addClass("form-horizontal").appendTo($body);
        let $group = null;
        let $check_label = null;
        let $inputMinVal = null;
        let $inputMaxVal = null;
        let $inputMinCheck = null;
        let $inputMaxCheck = null;
        let $inputReversedCheck = null;
        let $inputGranularityVal = null;
        //: code wrapper for inputs setup..
        //: min:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Minimum:").appendTo($group);
        $inputMinVal = $('<input type="text" style="text-align:right;" name="min" placeholder="Minimum">').addClass("input-sm form-control");
        $inputMinVal.appendTo($('<div class="col-sm-5">').appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($('<div class="col-sm-5">').appendTo($group));
        $inputMinCheck = $('<input type="checkbox" name="min_check">').appendTo($check_label);
        $check_label.append("<span>Auto</span>");
        $inputMinCheck.on("change", ()=>{
            if ($inputMinCheck.is(":checked")) $inputMinVal.val("").prop("disabled", true);
            else $inputMinVal.prop("disabled", false);
        });
        //: max:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Maximum:").appendTo($group);
        $inputMaxVal = $('<input type="text" style="text-align:right;" name="max" placeholder="Maximum">').addClass("input-sm form-control");
        $inputMaxVal.appendTo($('<div class="col-sm-5">').appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($('<div class="col-sm-5">').appendTo($group));
        $inputMaxCheck = $('<input type="checkbox" name="max_check">').appendTo($check_label);
        $check_label.append("<span>Auto</span>");
        $inputMaxCheck.on("change", ()=>{
            if ($inputMaxCheck.is(":checked")) $inputMaxVal.val("").prop("disabled", true);
            else $inputMaxVal.prop("disabled", false);
        });
        /*
            //: reversed:
            $group = $("<div>").addClass("form-group").appendTo($form);
            $("<label>").addClass("col-sm-2 control-label").text("Reversed:").appendTo($group);
            $check_label = $("<label>").addClass("checkbox inline").appendTo($("<div class=\"col-sm-10\">").appendTo($group));
            $inputReversedCheck = $("<input type=\"checkbox\" name=\"reversed\">").appendTo($check_label);
            $check_label.append("<span>Reversed (default: checked)</span>");

            //: text granularity:
            let selectOptions: number[] = [1, 2, 3];
            $group = $("<div>").addClass("form-group").appendTo($form);
            $("<label>").addClass("col-sm-2 control-label").text("Labels amount:").appendTo($group);
            $inputGranularityVal = $("<select style=\"text-align:right;\" name=\"textGranularity\">").addClass("input-sm form-control");
            selectOptions.forEach(n => {
                $inputGranularityVal.append(`<option value="${n}">${n}</option>`);
            });
            $inputGranularityVal.appendTo($("<div class=\"col-sm-3\">").appendTo($group));
            $("<em>").addClass("col-sm-7 text-muted").text("Set the granularity of labels on the Current Speed Legend.").appendTo($group);
            */ //: set values of inputs:
        $inputMinCheck.prop("checked", true).trigger("change");
        $inputMaxCheck.prop("checked", true).trigger("change");
        if (opts !== null && "min" in opts && opts.min !== null) {
            $inputMinCheck.prop("checked", false).trigger("change");
            $inputMinVal.val(opts.min.toString());
        }
        if (opts !== null && "max" in opts && opts.max !== null) {
            $inputMaxCheck.prop("checked", false).trigger("change");
            $inputMaxVal.val(opts.max.toString());
        }
        /*
            if (opts !== null && "reversed" in opts && opts.reversed !== null) {
                $inputReversedCheck.prop("checked", opts.reversed);
            }
            if (opts !== null && "textGranularity" in opts && opts.textGranularity !== null) {
                $inputGranularityVal.val((opts.textGranularity).toString());
            }
            */ $("<div>").addClass("alert alert-info").html("<strong>Note:</strong> The default values prior to these customisation options were:<br><u>min</u> = <strong>0</strong><br><u>max</u> = <strong>0.8</strong>.").css("marginBottom", 0).appendTo($form);
        sd.getDismissButton().text("Cancel");
        let $save = $("<button>").addClass("btn btn-success").text("Save").prependTo($foot);
        $save.on("click", (e)=>{
            let x = {
                min: null,
                max: null,
                reversed: true,
                textGranularity: null
            };
            if ($inputMinCheck.prop("checked") == false && !isNaN(parseFloat($inputMinVal.val()))) x.min = parseFloat($inputMinVal.val());
            if ($inputMaxCheck.prop("checked") == false && !isNaN(parseFloat($inputMaxVal.val()))) x.max = parseFloat($inputMaxVal.val());
            /*
            x.reversed = $inputReversedCheck.prop('checked');
            x.textGranularity = $inputGranularityVal.val();
            */ this.lsOptsSet(x, true);
            sd.hide();
        });
        let $reset = $("<button>").addClass("btn btn-link pull-left").text("Reset").prependTo($foot);
        $reset.on("click", (e)=>{
            $.removeCookie(this.lsOptsKey);
            sd.hide();
            this.updateChart();
        });
        sd.show();
    }
}






class $bfbbca38eee2856d$export$3f0be2c6920005ae {
    constructor(mainSite, station, valueFormatter){
        this.mainSite = mainSite;
        this.station = station;
        this.valueFormatter = valueFormatter;
        this.sensorLabelBox = $('<span>N/A</span>');
        this.timeStampBox = $('<span>N/A</span>');
    }
    renderPopup(e, openPopups = null) {
        if (this.popup || openPopups && openPopups.indexOf(this.station.Id + "_" + this.valueFormatter.getId()) > -1) {
            $('.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
            $(this.popup).css('z-index', '1000');
            return true;
        }
        this.popup = $('<div class="midi_siteObsPage_popup modal-content"></div>').appendTo('body');
        if (openPopups) openPopups.push(this.station.Id + "_" + this.valueFormatter.getId());
        $('.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
        $(this.popup).css('z-index', '1000');
        var oldTop;
        var oldLeft;
        // TODO: Doesn't actually seem to work
        var maximise = $('<a class="midi_siteObsPage_popup_maximise midi_siteObsPage_popup_tools" href="#"></a>').html('<i class= "fa fa-expand"> </i>').attr('title', 'Expand').click(()=>{
            this.popup.addClass('midi_siteObsPage_popup_maximised');
            oldLeft = this.popup.css('left');
            oldTop = this.popup.css('top');
            this.popup.css('top', '10%');
            this.popup.css('left', '5%');
            maximise.hide();
            restore.show();
            $(window).resize();
            return false;
        });
        var restore = $('<a class="midi_siteObsPage_popup_maximise midi_siteObsPage_popup_tools" href="#"></a>').html('<i class= "fa fa-compress"> </i>').css('display', 'none').attr('title', 'Restore').click(()=>{
            this.popup.removeClass('midi_siteObsPage_popup_maximised');
            this.popup.css('top', oldTop);
            this.popup.css('left', oldLeft);
            restore.hide();
            maximise.show();
            $(window).resize();
            return false;
        });
        this.popup.append(maximise);
        this.popup.append(restore);
        this.popup.append($('<a class="midi_siteObsPage_popup_close midi_siteObsPage_popup_tools" href="#"></a>').html('<i class= "fa fa-times"></i>').attr('title', 'Close').click(()=>{
            this.popup.remove();
            this.popup = null;
            if (openPopups) openPopups.splice(openPopups.indexOf(this.station.Id + "_" + this.valueFormatter.getId()), 1);
            return false;
        }));
        this.popup.append($('<div class="midi_siteObsPage_popup_station"></div>').text(this.station.Label));
        this.popup.append($('<div class="midi_siteObsPage_popup_title">' + this.valueFormatter.getShortName() + ' <span class="midi_siteObsPage_popup_units">' + (this.valueFormatter.getUnits() ? this.valueFormatter.getUnits() : '') + '</span></div>'));
        this.popup.append($('<div class="midi_siteObsPage_popup_timestamp"></div>').append(this.timeStampBox));
        this.popup.append($('<div class="midi_siteObsPage_popup_description"></div>').text(this.valueFormatter.getDescription()));
        this.popup.append($('<div class="midi_siteObsPage_popup_sensor"></div>').append($('<span>Sensor: </span>')).append(this.sensorLabelBox));
        this.popup.draggable({
            cancel: ".midi_siteObsPage_popup_chart_container"
        }).mousedown(()=>{
            $('div.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
            $(this.popup).css('z-index', '1000');
        });
        if (!this.valueFormatter.plottable()) $('<p><em>This parameter is not plottable.</em></p>').appendTo(this.popup);
        else {
            var fromMoment = moment.utc().add('d', -1);
            var timeZoneString;
            timeZoneString = this.mainSite.getTimeZoneString();
            this.loadingMessage = $('<p><em>Loading data...</em></p>');
            this.loadingMessage.css('text-align', 'center');
            this.loadingMessage.appendTo(this.popup);
            this.noDataLabel = $('<p><em>This parameter has returned no data in the last week.</em></p>');
            // Fetch historical and forecast data from InfluxDB
            (0, $fd959835eca46177$export$7a53cc19acfc9f90)(// Parameters for historical data fetch
            this.station.Id, "Forecast_" + this.valueFormatter.getId(), moment.utc().valueOf(), moment.utc().add('d', 1).valueOf(), // Callback function handling both historical and forecast data
            (err, forecastData)=>{
                (0, $fd959835eca46177$export$7a53cc19acfc9f90)(// Parameters for current data fetch
                this.station.Id, this.valueFormatter.getId(), fromMoment.valueOf(), moment.utc().valueOf(), // Callback handling combined historical and forecast data
                (err, data)=>{
                    // Remove loading indicator
                    this.loadingMessage.remove();
                    // Check if forecast data exists
                    let gotForecastData = forecastData.Data !== null && forecastData.Data.length > 0;
                    // Handle case where historical data doesn't exist but forecast does
                    if ((data.Data === null || data.Data.length < 1) && gotForecastData) {
                        // Display no data label and exit early
                        this.noDataLabel.appendTo(this.popup);
                        return;
                    }
                    // Initialize units conversion system
                    let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.valueFormatter.getParameterGroupInfo()?.Units ?? this.valueFormatter.getUnits(), this.valueFormatter.getId());
                    // Apply unit conversions to data if conversion set exists
                    if (unitsConversionSet) {
                        // Convert historical data values
                        data.Data = data.Data.map((x)=>{
                            if (Array.isArray(x) && x.length == 2) return [
                                x[0],
                                unitsConversionSet.convertValue(x[1])
                            ];
                            return x;
                        });
                        // Convert forecast data values if available
                        if (forecastData && forecastData.Data && Array.isArray(forecastData.Data)) forecastData.Data = forecastData.Data.map((x)=>{
                            if (Array.isArray(x) && x.length == 2) return [
                                x[0],
                                unitsConversionSet.convertValue(x[1])
                            ];
                            return x;
                        });
                    }
                    // Create navigation bar structure
                    var plottingNavBar = $('<nav class="nav navbar-default midi_siteObsPage_popup_navBar"></nav>').appendTo(this.popup);
                    // Create grouping navigation controls
                    var groupingNavBarList = $('<ul id="grouping_nav" class="nav navbar-nav"></ul>').appendTo(plottingNavBar).append($('<div></div>').text("Grouping:"));
                    // Add grouping options with click handlers
                    var highGrouping = $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>High</a></li>').click((e)=>{
                        this.setGrouping("high");
                        $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem').removeClass("active");
                        $(e.target).parent().addClass("active");
                    }).appendTo(groupingNavBarList);
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>Average</a></li>').click((e)=>{
                        this.setGrouping("average");
                        $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem').removeClass("active");
                        $(e.target).parent().addClass("active");
                    }).appendTo(groupingNavBarList);
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>Low</a></li>').click((e)=>{
                        this.setGrouping("low");
                        $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem').removeClass("active");
                        $(e.target).parent().addClass("active");
                    }).appendTo(groupingNavBarList);
                    // Create time navigation controls
                    var plottingNavBarList = $('<ul id="time_nav" class="nav navbar-nav"></ul>').appendTo(plottingNavBar);
                    // Add time period selection options
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>12 Hours</a></li>').click((e)=>{
                        this.requestDataForTimePeriod('h', 12, $(e.target));
                    //this.updateChart('h', 12, $(e.target));
                    }).appendTo(plottingNavBarList);
                    this.dateSelected = $('<li class="midi_siteObsPage_popup_navBar_listItem active"><a>24 Hours</a></li>').click((e)=>{
                        this.requestDataForTimePeriod('d', 1, $(e.target));
                    //this.updateChart('d', 1, $(e.target));
                    }).appendTo(plottingNavBarList);
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>2 Days</a></li>').click((e)=>{
                        this.requestDataForTimePeriod('d', 2, $(e.target));
                    //this.updateChart('d', 2, $(e.target));
                    }).appendTo(plottingNavBarList);
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>7 Days</a></li>').click((e)=>{
                        this.requestDataForTimePeriod('d', 7, $(e.target));
                    //this.updateChart('d', 7, $(e.target));
                    }).appendTo(plottingNavBarList);
                    $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>30 Days</a></li>').click((e)=>{
                        this.requestDataForTimePeriod('d', 30, $(e.target));
                    //this.updateChart('d', 30, $(e.target));
                    }).appendTo(plottingNavBarList);
                    // Create chart container
                    this.chartContainer = $('<div class="midi_siteObsPage_popup_chart_container"></div').appendTo(this.popup);
                    // Add padding points to data for better visualization
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        moment.utc().valueOf(),
                        null
                    ]);
                    // Initialize chart configuration
                    var axisId = data.ParameterId;
                    // Configure plot bands for warnings (currently commented out)
                    var plotBands = [];
                    /* 
                            // Warning system configuration (commented out)
                            if (this.warningGroup && this.warningGroup.Rules[this.valueFormatter.getId()]) {
                                var warningRuleSet: WarningRuleSet = this.warningGroup.Rules[this.valueFormatter.getId()];
                
                                if (warningRuleSet.Gt_LowPriority !== null) {
                                    plotBands.push({
                                        from: warningRuleSet.Gt_LowPriority,
                                        to: warningRuleSet.Gt_MediumPriority,
                                        color: '#FFFFE0'
                                    });
                                }
                
                                // ... rest of warning configuration ...
                            }
                            */ // Initialize Highcharts instance
                    this.chartContainer.highcharts('StockChart', {
                        chart: {
                            zoomType: 'x'
                        },
                        credits: {
                            enabled: false
                        },
                        exporting: {
                            enabled: false
                        },
                        legend: {
                            enabled: false
                        },
                        rangeSelector: {
                            enabled: false,
                            selected: 1
                        },
                        scrollbar: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                events: {
                                    legendItemClick: function() {
                                        return false;
                                    }
                                },
                                showInNavigator: true
                            },
                            line: {
                                dataGrouping: {
                                    approximation: "high"
                                }
                            }
                        },
                        xAxis: {
                            type: 'datetime',
                            ordinal: false
                        },
                        yAxis: {
                            opposite: false,
                            plotBands: plotBands,
                            min: this.valueFormatter.axisMin(),
                            max: this.valueFormatter.axisMax()
                        },
                        tooltip: {
                            xDateFormat: '%Y-%m-%d %H:%M:%S ' + timeZoneString,
                            valueDecimals: 2
                        },
                        series: [
                            {
                                name: `${this.valueFormatter.getShortName()} (${this.valueFormatter.getUnits()})`,
                                id: data.ParameterId,
                                data: data.Data,
                                lineWidth: (()=>{
                                    if (!this.valueFormatter.plotLines()) return 0;
                                    return 1;
                                })(),
                                marker: {
                                    enabled: !this.valueFormatter.plotLines(),
                                    radius: 3
                                },
                                gapSize: 7200000,
                                gapUnit: "value"
                            },
                            {
                                name: `${this.valueFormatter.getShortName()} (${this.valueFormatter.getUnits()}) [Forecast]`,
                                id: forecastData.ParameterId,
                                data: forecastData.Data,
                                lineWidth: (()=>{
                                    if (!this.valueFormatter.plotLines()) return 0;
                                    return 1;
                                })(),
                                marker: {
                                    enabled: !this.valueFormatter.plotLines(),
                                    radius: 3
                                }
                            }
                        ]
                    });
                    // Store chart instance reference
                    this.chart = this.chartContainer.highcharts();
                    // Set initial active grouping
                    highGrouping.addClass('active');
                }, this.valueFormatter.getSensorId());
            });
        }
        var mouseX = e.pageX;
        var mouseY = e.pageY;
        var padding = 0;
        if (mouseY + (this.popup.outerHeight(true) + 200) >= $(window).height() - padding && mouseX + this.popup.outerWidth(true) >= $(window).width() - padding) this.popup.css({
            "top": Math.max(60, mouseY - (this.popup.outerHeight(true) + 200) - padding),
            "left": mouseX - this.popup.outerWidth(true) - padding
        });
        else if (mouseY + (this.popup.outerHeight(true) + 200) >= $(window).height() - padding) this.popup.css({
            "top": Math.max(60, mouseY - (this.popup.outerHeight(true) + 200) - padding),
            "left": mouseX
        });
        else if (mouseX + this.popup.outerWidth(true) >= $(window).width() - padding) this.popup.css({
            "top": mouseY,
            "left": mouseX - this.popup.outerWidth(true) - padding
        });
        else this.popup.css({
            "top": mouseY,
            "left": mouseX
        });
        return true;
    }
    //private updateChart(timePeriod: moment.unitOfTime.DurationConstructor, quantity: number, selectedLabel: JQuery) {
    //    console.log('[PopupChartable:HERE2] Doing requestDataForTimePeriod()')
    //    console.log('[PopupChartable:HERE2] selectedLabel: ', selectedLabel)
    //    selectedLabel.parent().addClass("active");
    //    this.dateSelected.removeClass("active");
    //    this.dateSelected = selectedLabel.parent();
    //    this.dateSelected.addClass('active');
    //    this.chartContainer.remove();
    //    this.loadingMessage.appendTo(this.popup);
    //    this.requestDataForTimePeriod(timePeriod, quantity);
    //}
    requestDataForTimePeriod(timePeriod, quantity, selectedLabel) {
        console.log('[PopupChartable:HERE2] Doing requestDataForTimePeriod()');
        console.log('[PopupChartable:HERE2] selectedLabel: ', selectedLabel);
        selectedLabel.parent().addClass("active");
        this.dateSelected.removeClass("active");
        this.dateSelected = selectedLabel.parent();
        this.dateSelected.addClass('active');
        this.chartContainer.remove();
        this.loadingMessage.appendTo(this.popup);
        // Fetch historical and forecast data from InfluxDB
        (0, $fd959835eca46177$export$7a53cc19acfc9f90)(// Parameters for historical data fetch
        this.station.Id, "Forecast_" + this.valueFormatter.getId(), moment.utc().valueOf(), moment.utc().add(timePeriod, quantity).valueOf(), // Callback function handling both historical and forecast data
        (err, forecastData)=>{
            (0, $fd959835eca46177$export$7a53cc19acfc9f90)(// Parameters for current data fetch
            this.station.Id, this.valueFormatter.getId(), moment.utc().add(timePeriod, -1 * quantity).valueOf(), moment.utc().valueOf(), // Callback handling combined historical and forecast data
            (err, data)=>{
                // Remove loading indicator
                this.loadingMessage.remove();
                // Check if forecast data exists
                let gotForecastData = forecastData.Data !== null && forecastData.Data.length > 0;
                // Handle case where historical data doesn't exist but forecast does
                if ((data.Data === null || data.Data.length < 1) && gotForecastData) {
                    this.noDataLabel.appendTo(this.popup);
                    return;
                }
                // Initialize units conversion system
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.valueFormatter.getParameterGroupInfo()?.Units ?? this.valueFormatter.getUnits(), this.valueFormatter.getId());
                // Apply unit conversions to data if conversion set exists
                if (unitsConversionSet) {
                    console.log('[PopupChartable:HERE2] a');
                    // Convert historical data values
                    data.Data = data.Data.map((x)=>{
                        if (Array.isArray(x) && x.length == 2) {
                            console.log('[PopupChartable:HERE2] b');
                            return [
                                x[0],
                                unitsConversionSet.convertValue(x[1])
                            ];
                        }
                        return x;
                    });
                    // Convert forecast data values if available
                    if (forecastData && forecastData.Data && Array.isArray(forecastData.Data)) {
                        console.log('[PopupChartable:HERE2] c');
                        forecastData.Data = forecastData.Data.map((x)=>{
                            if (Array.isArray(x) && x.length == 2) {
                                console.log('[PopupChartable:HERE2] d');
                                return [
                                    x[0],
                                    unitsConversionSet.convertValue(x[1])
                                ];
                            }
                            return x;
                        });
                    }
                }
                // Update chart data
                var hours = timePeriod == 'h' ? quantity : quantity * 24;
                this.setDateWithButtons(hours, gotForecastData ? forecastData.Data[forecastData.Data.length - 1] : null);
                this.chart.series[0].update({
                    data: data.Data
                });
                this.chart.series[1].update({
                    data: forecastData.Data
                });
                this.chartContainer.appendTo(this.popup);
            }, this.valueFormatter.getSensorId());
        });
    }
    setDateWithButtons(numberOfHours, lastForecastDp) {
        var from = moment.utc().subtract(numberOfHours, 'h'); // 00:00 UTC    
        let to;
        if (lastForecastDp) {
            let lastTsUnixMiliSeconds = lastForecastDp[0];
            let lastTsMoment = moment.unix(lastTsUnixMiliSeconds / 1000);
            to = moment.utc().add(numberOfHours, 'h');
            if (lastTsMoment.diff(to) < 0) to = lastTsMoment;
        } else to = moment.utc();
        this.chart.xAxis[0].setExtremes(from.valueOf(), to.valueOf());
    }
    setGrouping(groupingApproximation) {
        var options = this.chart.options;
        options.plotOptions.line.dataGrouping.approximation = groupingApproximation;
        this.chart = this.chartContainer.highcharts(options).highcharts();
    }
    setSensor(sensorLabel) {
        this.sensorLabelBox.text(sensorLabel);
    }
    setTimestamp(timestamp) {
        this.timeStampBox.text(this.mainSite.getDisplayTime(timestamp, this.mainSite.selectedRegion.TimeZone));
    }
}


class $92d61d72cc040b2d$export$dd3ff450a300a06e extends (0, $bfbbca38eee2856d$export$3f0be2c6920005ae) {
    constructor(page, container, valueFormatter, top, left, height, width, ctx, showTitle = true, valueTextSizeEm = 2.5, titleTextSizeEm){
        super(page.mainSite);
        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;
        this.showTitle = showTitle;
        this.outerBox = $('<div></div>').addClass('midi_SiteObservations_value_box_outer').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%').attr('title', 'Click for parameter popup').click((e)=>{
            this.renderPopup(e);
        });
        this.innerBox = $('<div></div>').addClass('midi_SiteObservations_value_box_inner').appendTo(this.outerBox);
        this.valueBox = $('<div></div>').addClass('midi_SiteObservations_value_box_value').css('font-size', valueTextSizeEm + 'em').appendTo(this.innerBox);
        this.unitsBox = $('<div></div>').addClass('midi_SiteObservations_value_box_units').hide(); // start hidden, show if data
        if (showTitle) this.unitsBox.text(this.valueFormatter.getUnits() ? this.valueFormatter.getUnits() : '');
        this.suffixSpan = $('<span></span>').prependTo(this.unitsBox);
        if (showTitle) {
            let $title = $('<div></div>').addClass('midi_SiteObservations_value_box_header').text(this.valueFormatter.getShortName()).append(this.unitsBox); // units box in header
            if (titleTextSizeEm) $title.css('font-size', titleTextSizeEm + 'em');
            this.outerBox.prepend($title);
        } else this.innerBox.addClass('midi_SiteObservations_value_box_inner_no_header').append(this.unitsBox); // units box in inner
        container.append(this.outerBox);
        if (page.mainSite.liveDataManager.latestData) this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
    }
    liveDataChanged(latestData, ctx) {
        var valueObject = this.valueFormatter.format(latestData.Stations[this.station.Id], this.warningGroup);
        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        this.outerBox.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.');
        ctx.valueChanged(valueObject);
        this.valueBox.text(valueObject.Value); // valueObject handles the formatting
        if (valueObject.ParameterDefinition && valueObject.ParameterDefinition.Suffix && this.showTitle) this.suffixSpan.text(valueObject.ParameterDefinition.Suffix + (this.valueFormatter.getUnits() ? ', ' : ''));
        else this.suffixSpan.text('');
        if (valueObject.Status === null || valueObject.Status === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            // no valid data -> hide units and remove any colour coding
            this.unitsBox.hide();
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.innerBox.addClass('midi_siteObsPage_expiring');
            return;
        }
        if (valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) this.innerBox.removeClass('midi_siteObsPage_expiring');
        else this.innerBox.addClass('midi_siteObsPage_expiring');
        // by this point we will be showing some data
        this.unitsBox.show();
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.innerBox.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.innerBox.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}


var $29e97a05b53d587e$export$d95ff4a11a6fe4f9 = /*#__PURE__*/ function(SpeedUnits) {
    SpeedUnits[SpeedUnits["kts"] = 0] = "kts";
    SpeedUnits[SpeedUnits["mps"] = 1] = "mps";
    return SpeedUnits;
}({});
class $29e97a05b53d587e$export$856f0d8f68e923ca {
    notifyResize() {}
    show(station) {
        if (station.Station.Region == "GOM") // GOM has a specified Current page (GOMCurrentPage.ts), so don't show this one
        return false;
        const pages = [];
        // Go through all sensorIds
        for(let sensorId in station.Sensors){
            // if not useLiveData or forecast, skip
            if (!station.Sensors[sensorId].UseLiveData || sensorId.toLowerCase().includes("forecast")) continue;
            const sensor = station.Sensors[sensorId];
            if (sensorId.includes("orecast") || sensorId.includes("Diagnostics")) continue;
            // Check if the sensorId has any wave Current parameters. If so, generate a Currents-pages for this sensorId
            for(let paramId in sensor.Parameters)if (paramId.indexOf("Current") != -1) {
                const label = station.Sensors[sensorId].SensorDefinition?.DisplayName ?? sensorId;
                pages.push(new $29e97a05b53d587e$export$856f0d8f68e923ca(this.mainSite, this.ctx, sensorId, label));
                break;
            }
        }
        if (pages.length == 1) return true;
        else if (pages.length > 1) return pages;
        return false;
    }
    constructor(mainSite, ctx, sensorId, label){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.sensorId = sensorId;
        this.id = "current";
        this.label = "Current";
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
        // if sensorId is not set to null, update label and id to distinguish the pages
        if (this.sensorId !== null) {
            this.label += ` (${label})`;
            this.id += `${this.sensorId}`;
        }
    }
    render(container, listeners, station, warningGroup) {
        // Page instance is reused across stations; clear sensor IDs detected for the previous one
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
        this.station = station;
        this.warningGroup = warningGroup;
        /*
         * Quick and dirty fix to detect if current speed is shown as kts rather than mps.
         * It would be much better to allow the DefaultGroupFormatter to choose the group from
         * multiple options based on what is available.
         */ let currentSpeedUnits = 1;
        let hasHorizontal = false;
        for(const sensorId in station.Sensors){
            const sensor = station.Sensors[sensorId];
            Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile");
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile/kts")) currentSpeedUnits = 0;
            if (Object.keys(sensor.Parameters).some((pid)=>pid.indexOf("HorizontalCurrentProfile") === 0)) hasHorizontal = true;
        }
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $("<div></div>").css("position", "absolute").css("height", "47em").css("width", "15em").appendTo(page);
        var centrePanel = $("<div></div>").css("position", "absolute").css("height", "47em").css("left", "16em").css("width", "15em").appendTo(page);
        var rightPanel = $("<div></div>").css("position", "absolute").css("height", "47em").css("left", "32em").css("width", "32em").appendTo(page);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean, this.sensorId), 0, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Middle_deg_Mean, this.sensorId), 20.2, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Bottom_deg_Mean, this.sensorId), 40.4, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Peak_deg_Mean, this.sensorId), 60.6, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(currentSpeedUnits == 1 ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean, this.sensorId), 0, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(currentSpeedUnits == 1 ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Middle_mps_Mean : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Middle_kts_Mean, this.sensorId), 20.2, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(currentSpeedUnits == 1 ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Bottom_mps_Mean : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Bottom_kts_Mean, this.sensorId), 40.4, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(currentSpeedUnits == 1 ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Peak_mps_Mean : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Peak_kts_Mean, this.sensorId), 60.6, 0, 19.2, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean, this.sensorId), 80.8, 0, 19.2, 100, this.ctx));
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo(rightPanel);
        let currentBox = $('<div class="site-obs-current-charts" data-chart-type="vertical"></div>').appendTo(rightPanel).hide();
        let currentBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="horizontal"></div>').appendTo(rightPanel).hide();
        let pvdBox = $('<div class="site-obs-current-charts" data-chart-type="pvd"></div>').appendTo(rightPanel).hide();
        let polarBox = $('<div class="site-obs-current-charts" data-chart-type="polar"></div>').appendTo(rightPanel).hide();
        let hovmollerBoxVertical = $('<div class="site-obs-current-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(rightPanel).hide();
        let hovmollerBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="hovmoller-horizontal"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(rightPanel).hide();
        let showChart = (chartType, label)=>{
            /*spectrumBox.hide();
            polarSpectrumBox.hide();
            polarBox.hide();
            hovmoller01Box.hide();*/ $(".site-obs-current-charts").hide();
            $(`.site-obs-current-charts[data-chart-type="${chartType}"]`).show();
            $(".site-obs-current-chart-select-label").text(label);
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        chartSelectTabs.append("<span>Chart: </span>");
        let $buttonGroup = $('<div class="btn-group"></div>').appendTo(chartSelectTabs);
        $('<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><span class="site-obs-current-chart-select-label">Select chart..</span> <span class="caret"></span></button>').appendTo($buttonGroup);
        let tpul = $("<ul></ul>").addClass("dropdown-menu")// .append($('<span></span>').text("Chart: "))
        .appendTo($buttonGroup);
        this._dpc = new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 5, 0, 93, 100, currentSpeedUnits == 1 ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean.Id, true, this.sensorId);
        listeners.push(this._dpc);
        this._pvd = new (0, $afcc295e055250f2$export$269e444807daccc9)(this.mainSite, this, pvdBox, 5, 0, 93, 100, currentSpeedUnits, this.sensorId ?? undefined);
        listeners.push(this._pvd);
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBox, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $7135656329687c33$export$861facf577d6ed7a).Depth, this.sensorId));
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBoxHorizontal, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $7135656329687c33$export$861facf577d6ed7a).Horizontal, this.sensorId));
        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = currentSpeedUnits == 1 ? "m/s" : "kts";
        var unitsStrDepthOrHeight = "m";
        let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet("m");
        let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight = (value)=>value;
        let ucf_Speed = (value)=>value;
        let ucf_Direction = (value)=>value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }
        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    "#0000FF"
                ],
                [
                    0.33,
                    "#00FFFF"
                ],
                [
                    0.66,
                    "#FFFF00"
                ],
                [
                    1,
                    "#FF0000"
                ]
            ]
        };
        // Direction: Options specific to direction chart
        let hovmolOptionsDirection = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsDirection.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [
                    0.0,
                    "rgb(255, 0, 0)"
                ],
                [
                    0.25,
                    "rgb(160, 32, 240)"
                ],
                [
                    0.5,
                    "rgb(0, 0, 255)"
                ],
                [
                    0.75,
                    "rgb(252, 186, 3)"
                ],
                [
                    1.0,
                    "rgb(255, 0, 0)"
                ]
            ],
            tickPositions: [
                0,
                90,
                180,
                270,
                360
            ],
            startOnTick: true,
            endOnTick: true
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(//// mainSite
        this.mainSite, //// page
        this, //// $container
        hovmollerBoxVertical, //// top, left, height, width
        0, 0, 93, 100, //// specific chart options
        hovmolOptionsSpeed, hovmolOptionsDirection, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                console.warn("Current Hovmoller (Vertical) chart: no current profile sensor or param detected for this station.");
                callback([], false);
                return;
            }
            let sensor = this.currentProfileSensor;
            let parameter = this.currentProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info("Current Hovmoller (Vertical) - data fetch URI:", uri);
            $.ajax(uri + "", {
                cache: false,
                dataType: "json",
                type: "GET",
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let profile = JSON.parse(x[1]);
                                    let components = profile.Components.sort((a, b)=>b.Depth - a.Depth); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.Speed || isNaN(cp.Speed) || !isFinite(cp.Speed) || cp.Speed < 0 || cp.Speed > 10) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: ucf_DepthOrHeight(cp.Depth),
                                            val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
        (latestData, chart)=>{
            if (this.currentProfileParam !== null) {
                chart.updateChart();
                return; //: already dealt with.
            }
            let liveDataSetValue = null;
            if (latestData.Stations[this.station.Station.Id]) {
                if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "CurrentProfile")) {
                    liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["CurrentProfile"][0];
                    this.currentProfileSensor = liveDataSetValue.Sensor;
                    this.currentProfileParam = "CurrentProfile";
                }
            }
            chart.updateChart();
        });
        listeners.push(this._chartsHovmoller);
        if (hasHorizontal) {
            let hovmolOptionsSpeedHorizontal = {
                ...hovmolOptionsSpeed
            };
            hovmolOptionsSpeedHorizontal.yAxis = {
                ...hovmolOptionsSpeedHorizontal.yAxis,
                title: {
                    text: `Distance (${unitsStrDepthOrHeight})`
                },
                reversed: true
            };
            this._chartsHovmollerHorizontal = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBoxHorizontal, 0, 0, 93, 100, //// specific chart options
            hovmolOptionsSpeedHorizontal, hovmolOptionsDirection, //// getDataMethod
            (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
                let res = [];
                if (this.currentProfileHorizontalSensor == null || this.currentProfileHorizontalParam == null) {
                    console.warn("Current Hovmoller (Horizontal) chart: no current profile sensor or param detected for this station.");
                    callback([], false);
                    return;
                }
                let sensor = this.currentProfileHorizontalSensor;
                let parameter = this.currentProfileHorizontalParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info("Current Hovmoller (Horizontal) - data fetch URI:", uri);
                $.ajax(uri + "", {
                    cache: false,
                    dataType: "json",
                    type: "GET",
                    timeout: 30000,
                    success: (data, text, jqXHR)=>{
                        try {
                            if (Array.isArray(data.results[0].series[0].values)) {
                                for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                    let x = data.results[0].series[0].values[i];
                                    let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let profile = JSON.parse(x[1]);
                                        let components = profile.Components.sort((a, b)=>b.Distance ?? b.Depth - a.Distance ?? a.Depth);
                                        components.forEach((cp, cpi)=>{
                                            let val = extractProfileCmpValue(cp);
                                            if (!val || isNaN(val)) {
                                                console.log("val: ", val);
                                                return;
                                            }
                                            if (isSpeed) val = ucf_Speed(val);
                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: ucf_DepthOrHeight(cp.Distance ?? cp.Depth),
                                                val: val
                                            });
                                        });
                                    } else console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                }
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown)=>{
                        console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
            (latestData, chart)=>{
                if (this.currentProfileHorizontalParam !== null) return; //: already dealt with.
                let liveDataSetValue = null;
                if (latestData.Stations[this.station.Station.Id]) {
                    if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "HorizontalCurrentProfile")) {
                        liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["HorizontalCurrentProfile"][0];
                        this.currentProfileHorizontalSensor = liveDataSetValue.Sensor;
                        this.currentProfileHorizontalParam = "HorizontalCurrentProfile";
                    }
                }
                chart.updateChart();
            });
            listeners.push(this._chartsHovmollerHorizontal);
        }
        let tpulLiActiveClass = "active"; //: 'selected' prior to using drop-down
        let charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            // { key: 'horizontal', label: 'Horizontal Profile' },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Color Flood (Vertical)" : "Color Flood"
            }
        ];
        if (hasHorizontal) charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            {
                key: "horizontal",
                label: "Horizontal Profile"
            },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Color Flood (Vertical)" : "Color Flood"
            }
        ];
        for(var i = 0; i < charts.length; i++){
            let chart = charts[i];
            let $li = $(`<li class="dropdown-menu-item"></li>`);
            let $a = $(`<a href="">${chart.label}</a>`).appendTo($li);
            $a.on("click", (ev)=>{
                ev.preventDefault();
                tpul.children("li").removeClass(tpulLiActiveClass);
                $li.addClass(tpulLiActiveClass);
                showChart(chart.key, chart.label);
            });
            tpul.append($li);
        }
        // currentBox.show();
        setTimeout(()=>{
            //: somehow, if executed immediately, this would not display the correct box..
            tpul.children("li").first().find("a").trigger("click");
        }, 500);
        page.appendTo(container);
        //page resizes due to highcharts charts being drawn before the box size is fixed and
        //the chart subsequently not filling the available space
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
    }
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");


const $9e99f3b631656eac$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(undefined);
//interface LiveDataSetValue extends GroupAveragesSet {
//    Value: any;
//    ValueMin?: any;
//    ValueMax?: any;
//    ExpiryStatus: Status;
//}
const $9e99f3b631656eac$var$mapStationAveragesDataToLiveData = (averagesData, timeRange)=>{
    let Value;
    let ValueMin;
    let ValueMax;
    let ExpiryStatus;
    switch(timeRange){
        case "LatestValue":
            Value = averagesData.LatestValue.Value;
            ExpiryStatus = averagesData.LatestValue.ExpiryStatus;
            break;
        case "Average3h":
            Value = averagesData.Average3h;
            ValueMin = averagesData.Min3h;
            ValueMax = averagesData.Max3h;
            ExpiryStatus = averagesData.Average3h == null ? (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired : (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good;
            break;
        case "Average24h":
            Value = averagesData.Average24h;
            ValueMin = averagesData.Min24h;
            ValueMax = averagesData.Max24h;
            ExpiryStatus = averagesData.Average24h == null ? (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired : (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good;
            break;
    }
    return {
        ...averagesData.LatestValue,
        Value: Value,
        ValueMin: ValueMin,
        ValueMax: ValueMax,
        ExpiryStatus: ExpiryStatus
    };
//} as LiveDataSetValue;
};
const $9e99f3b631656eac$export$43c6ed89e8a21a35 = ({ liveDataListeners: liveDataListeners, GOMAveragesListeners: GOMAveragesListeners, timeRange: timeRange, children: children })=>{
    // Purpose: Making latestData available through a React context by binding to the ILiveDataListener functionality.
    const [latestData, setLatestData] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData);
    const [latestGOMAverages, setLatestGOMAverages] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState((0, $52db63ea8facb471$export$1a86835baa79d770).instance.GOMAveragesManager.latestData);
    // console.log("[DataProvider] timeRange: ", timeRange)
    // console.log("[DataProvider] latestGOMAverages: ", latestGOMAverages)
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        liveDataListeners.push({
            liveDataChanged: (newLatestData, ctx)=>setLatestData(newLatestData)
        });
        // TODO: FIX THIS?? GOMAveragesListeners is null. But is it actually needed?
        GOMAveragesListeners.push({
            GOMAveragesChanged: (newLatestGOMAverages)=>setLatestGOMAverages(newLatestGOMAverages)
        });
    }, [
        liveDataListeners,
        GOMAveragesListeners
    ]);
    //console.log("[DataProvider] timeRange.includes('Average'): ", timeRange.includes("Average"))
    if (timeRange.includes("Average")) {
        let convertedLatestGOMAverages = {
            Stations: {}
        };
        if (latestGOMAverages) {
            // convert the format from GOMAveragesSet to LiveDataSet
            const a = Object.entries(latestGOMAverages.Stations).map(([idx, station])=>[
                    station.Station.Id,
                    {
                        Station: station.Station,
                        GroupValues: Object.fromEntries(station.GroupAverages.map((ga)=>[
                                ga.ParameterGroup,
                                [
                                    $9e99f3b631656eac$var$mapStationAveragesDataToLiveData(ga, timeRange)
                                ]
                            ]))
                    }
                ]);
            //console.log("[DataProvider] a: ", a)
            convertedLatestGOMAverages = {
                Stations: Object.fromEntries(a)
            };
        }
        // console.log("[DataProvider] convertedLatestGOMAverages: ", convertedLatestGOMAverages)
        return /*#__PURE__*/ (0, $1IdZj.jsx)($9e99f3b631656eac$export$58d75f9829cbe158.Provider, {
            value: convertedLatestGOMAverages,
            children: children
        });
    } else // console.log("[DataProvider] latestData: ", latestData)
    return /*#__PURE__*/ (0, $1IdZj.jsx)($9e99f3b631656eac$export$58d75f9829cbe158.Provider, {
        value: latestData,
        children: children
    });
};


var $7135656329687c33$export$861facf577d6ed7a = /*#__PURE__*/ function(ProfileTypeEnum) {
    ProfileTypeEnum[ProfileTypeEnum["Depth"] = 0] = "Depth";
    ProfileTypeEnum[ProfileTypeEnum["Height"] = 1] = "Height";
    ProfileTypeEnum[ProfileTypeEnum["Horizontal"] = 2] = "Horizontal";
    return ProfileTypeEnum;
}({});
function $7135656329687c33$export$2b609b58a023f1d1(props) {
    const theme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)({
        //: https://mui.com/material-ui/customization/typography/#font-size  +  https://mui.com/material-ui/customization/theme-components/#theme-variables
        typography: {
            fontSize: 20
        }
    });
    const latestData = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $9e99f3b631656eac$export$58d75f9829cbe158));
    //// If data not available
    if (!latestData || Object.keys(latestData.Stations).length == 0 || !latestData?.Stations[props.station.Station.Id]?.GroupValues[props.parameterGroup] || !latestData?.Stations[props.station.Station.Id]?.GroupValues[props.parameterGroup][0]?.Value?.Components || latestData?.Stations[props.station.Station.Id]?.GroupValues[props.parameterGroup][0]?.Value?.Components.length == 0) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $89db59c316d64b9f$export$2e2bcd8739ae039), {
            theme: theme,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "midi_SiteObservations_chart_no_data",
                children: "Data not available"
            })
        })
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)($7135656329687c33$export$3ed8ae4ec4acecc1, {
        ...props
    });
}
function $7135656329687c33$export$3ed8ae4ec4acecc1(props) {
    const theme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)({
        //: https://mui.com/material-ui/customization/typography/#font-size  +  https://mui.com/material-ui/customization/theme-components/#theme-variables
        typography: {
            fontSize: 20
        }
    });
    const latestData = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $9e99f3b631656eac$export$58d75f9829cbe158));
    const chartContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(undefined);
    const chartRef = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(undefined);
    const profileData = latestData.Stations[props.station.Station.Id].GroupValues[props.parameterGroup][0];
    //// SET UP THE CHART
    let seriesOptions = [];
    let lowerXAxisData = []; // Speed axis
    let lowerXAxisDataMin = [];
    let lowerXAxisDataMax = [];
    let upperXAxisData = []; // Direction axis
    let upperXAxisDataMin = [];
    let upperXAxisDataMax = [];
    let speedUnitsStr = props.speedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? "m/s" : "kts";
    let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(props.unitsStrDepthOrHeight);
    let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
    let ucf_DepthOrHeight = (value)=>value;
    let ucf_Speed = (value)=>value;
    if (unitsConversionSet_DepthOrHeight) {
        ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
        props.unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
    }
    if (unitsConversionSet_Speed) {
        ucf_Speed = unitsConversionSet_Speed.convertValue;
        speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
    }
    const getFormattedAxisData = (values, lowerAxis, upperAxis)=>{
        values?.Components.forEach((component)=>{
            if (props.profileEnumType === 0 && component.Depth) {
                if (component.Direction) upperAxis.push([
                    component.Direction,
                    props.ucf_DepthOrHeight(component.Depth)
                ]);
                if (component.Speed) lowerAxis.push([
                    props.ucf_Speed(component.Speed),
                    props.ucf_DepthOrHeight(component.Depth)
                ]);
            }
            if (props.profileEnumType === 1 && component.Height) {
                if (component.Direction) upperAxis.push([
                    component.Direction,
                    props.ucf_DepthOrHeight(component.Height)
                ]);
                if (component.Speed) lowerAxis.push([
                    props.ucf_Speed(component.Speed),
                    props.ucf_DepthOrHeight(component.Height)
                ]);
            }
            if (props.profileEnumType === 2 && props.ucf_DepthOrHeight(component.Depth)) {
                if (component.Direction) upperAxis.push([
                    props.ucf_DepthOrHeight(component.Depth),
                    component.Direction
                ]);
                if (component.Speed) lowerAxis.push([
                    props.ucf_DepthOrHeight(component.Depth),
                    props.ucf_Speed(component.Speed)
                ]);
            }
        });
        return [
            lowerAxis,
            upperAxis
        ];
    };
    [lowerXAxisData, upperXAxisData] = getFormattedAxisData(profileData.Value, lowerXAxisData, upperXAxisData);
    [lowerXAxisDataMin, upperXAxisDataMin] = getFormattedAxisData(profileData.ValueMin, lowerXAxisDataMin, upperXAxisDataMin);
    [lowerXAxisDataMax, upperXAxisDataMax] = getFormattedAxisData(profileData.ValueMax, lowerXAxisDataMax, upperXAxisDataMax);
    let xAxisOptions = [];
    let yAxisOptions = [];
    seriesOptions.push(//// SPEED
    {
        name: "Speed",
        color: "rgba(255, 0, 0, 1)",
        data: lowerXAxisData,
        xAxis: 0,
        yAxis: 0,
        dashStyle: "longdash",
        marker: {
            enabled: true,
            symbol: "circle"
        },
        tooltip: {
            headerFormat: "<b>{series.name}</b><br>",
            pointFormatter: props.profileEnumType === 2 ? function() {
                return `${this.y.toFixed(1)} ${props.speedUnitsStr} at ${this.x.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            } : function() {
                return `${this.x.toFixed(1)} ${props.speedUnitsStr} at ${this.y.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            }
        }
    }, {
        name: "Min Speed",
        color: "rgba(255, 0, 0, 0.4)",
        data: lowerXAxisDataMin,
        xAxis: 0,
        yAxis: 0,
        dashStyle: "longdash",
        marker: {
            enabled: true,
            symbol: "circle"
        },
        tooltip: {
            headerFormat: "<b>{series.name}</b><br>",
            pointFormatter: props.profileEnumType === 2 ? function() {
                return `${this.y.toFixed(1)} ${props.speedUnitsStr} at ${this.x.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            } : function() {
                return `${this.x.toFixed(1)} ${props.speedUnitsStr} at ${this.y.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            }
        }
    }, {
        name: "Max Speed",
        color: "rgba(255, 0, 0, 0.4)",
        data: lowerXAxisDataMax,
        xAxis: 0,
        yAxis: 0,
        dashStyle: "longdash",
        marker: {
            enabled: true,
            symbol: "circle"
        },
        tooltip: {
            headerFormat: "<b>{series.name}</b><br>",
            pointFormatter: props.profileEnumType === 2 ? function() {
                return `${this.y.toFixed(1)} ${props.speedUnitsStr} at ${this.x.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            } : function() {
                return `${this.x.toFixed(1)} ${props.speedUnitsStr} at ${this.y.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            }
        }
    }, //// DIRECTION
    {
        name: "Direction " + (props.parameterGroup.includes("Current") ? "To" : "From"),
        color: "rgba(0, 128, 0, 1)",
        data: upperXAxisData,
        xAxis: props.profileEnumType === 2 ? 0 : 1,
        yAxis: props.profileEnumType === 2 ? 1 : 0,
        lineWidth: 0,
        marker: {
            enabled: true,
            symbol: "diamond"
        },
        tooltip: {
            headerFormat: "<b>{series.name}</b><br>",
            pointFormatter: props.profileEnumType === 2 ? function() {
                return `${Math.round(this.y)}\xb0T ${this.profileName === "Current" ? "TO" : "FROM"} at ${this.x.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            } : function() {
                return `${Math.round(this.x)}\xb0T ${this.profileName === "Current" ? "TO" : "FROM"} at ${this.y.toFixed(1)} ${props.unitsStrDepthOrHeight}`;
            }
        }
    });
    //// CONFIGURE AXIS
    let speedAxisOptions = {
        title: {
            text: `Speed (${props.speedUnitsStr}) <span class="custom-actions actions--set-xaxis-range" style="color: blue; text-decoration: underline; cursor: pointer;">Custom Range</span>`,
            useHtml: true
        },
        alignTicks: false
    };
    let dirAxisOptions = {
        title: {
            text: "Direction (\uFFFDT " + (props.parameterGroup.includes("Current") ? "TO" : "FROM") + ")"
        },
        min: 0,
        max: 360,
        opposite: true,
        tickInterval: 90,
        minTickInterval: 90,
        alignTicks: false
    };
    const depthAxisOptions = {
        title: {
            text: `Depth (${props.unitsStrDepthOrHeight})`
        },
        reversed: true
    };
    const heightAxisOptions = {
        title: {
            text: `Height (${props.unitsStrDepthOrHeight})`
        },
        reversed: false
    };
    const distanceAxisOptions = {
        title: {
            text: `Distance (${props.unitsStrDepthOrHeight})`
        },
        reversed: false
    };
    if (props.profileEnumType !== 2) {
        xAxisOptions.push(speedAxisOptions);
        xAxisOptions.push(dirAxisOptions);
        yAxisOptions.push(props.profileEnumType === 0 ? depthAxisOptions : heightAxisOptions);
    } else {
        xAxisOptions.push(distanceAxisOptions);
        yAxisOptions.push(speedAxisOptions);
        yAxisOptions.push(dirAxisOptions);
    }
    //// CONFIGURE CHARTS
    const options = {
        chart: {
            type: "line",
            marginTop: 60
        },
        exporting: {
            enabled: true
        },
        title: {
            text: ""
        },
        xAxis: xAxisOptions,
        yAxis: yAxisOptions,
        legend: {
            enabled: true
        },
        plotOptions: {
            line: {
                marker: {
                    radius: 5,
                    enabled: true
                }
            },
            series: {
                animation: false,
                // Line series default to 'x' only, which picks the wrong point on vertical profiles.
                findNearestPointBy: "xy"
            }
        },
        series: seriesOptions,
        credits: {
            enabled: false
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (!chartRef.current) chartRef.current = Highcharts.chart(chartContainerRef.current, options);
        else {
            while(chartRef.current.series.length)chartRef.current.series[0].remove();
            for(let i = 0; i < seriesOptions.length; i++)chartRef.current.addSeries(seriesOptions[i]);
            chartRef.current.reflow();
        }
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $89db59c316d64b9f$export$2e2bcd8739ae039), {
            theme: theme,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                ref: chartContainerRef,
                style: {
                    height: "100%",
                    width: "100%"
                }
            })
        })
    });
}








var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
function $6dceec7e5e9c27ce$export$b3d94834ede356da(props) {
    const mapParameterGroupToLabel = {
        "CurrentProfile": "Vertical Profile",
        "HorizontalCurrentProfile": "Horizontal Profile"
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("select", {
        onChange: (event)=>{
            props.setChartTypeToShow(event.target.value);
        },
        children: props.plots.map((plot, idx)=>/*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                value: `${plot.parameterGroup}`,
                children: mapParameterGroupToLabel[plot.parameterGroup] ?? plot.parameterGroup
            }, idx))
    });
}



function $aead4e3e868899f7$export$68bd6571e530c39f(props) {
    const theme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)({
        typography: {
            fontSize: 20
        }
    });
    const [chartTypeToShow, setChartTypeToShow] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(props.plots[0].parameterGroup);
    return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
        style: {
            position: 'absolute',
            height: '44.5em',
            width: '30em',
            top: '60pt'
        },
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $9e99f3b631656eac$export$43c6ed89e8a21a35), {
            liveDataListeners: props.liveDataListeners,
            GOMAveragesListeners: props.GOMAveragesListeners,
            timeRange: props.timeRange,
            children: [
                "Chart: ",
                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $6dceec7e5e9c27ce$export$b3d94834ede356da), {
                    plots: props.plots,
                    chartTypeToShow: chartTypeToShow,
                    setChartTypeToShow: setChartTypeToShow
                }),
                props.plots.map((plot)=>{
                    if (plot.parameterGroup == chartTypeToShow) return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $7135656329687c33$export$2b609b58a023f1d1), {
                        station: props.station,
                        profileName: plot.profileName,
                        parameterGroup: plot.parameterGroup,
                        profileEnumType: plot.profileEnumType,
                        speedUnits: props.speedUnits,
                        unitsStrDepthOrHeight: props.unitsStrDepthOrHeight,
                        ucf_DepthOrHeight: props.ucf_DepthOrHeight,
                        speedUnitsStr: props.speedUnitsStr,
                        ucf_Speed: props.ucf_Speed
                    });
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $jz4iA = parcelRequire("jz4iA");

var $hQtye = parcelRequire("hQtye");

var $8NFma = parcelRequire("8NFma");
function $4944fe05cfdb1e2e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4944fe05cfdb1e2e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4944fe05cfdb1e2e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4944fe05cfdb1e2e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4944fe05cfdb1e2e$export$2e2bcd8739ae039 = $4944fe05cfdb1e2e$export$4f5d2d50c9deca37;



var $33qfW = parcelRequire("33qfW");

var $aobdI = parcelRequire("aobdI");
var $3JC4a = parcelRequire("3JC4a");


var $1IdZj = parcelRequire("1IdZj");
'use client';
const $71bdae177f3fa0b5$var$_excluded = [
    "className",
    "component"
];
function $71bdae177f3fa0b5$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $33qfW.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $aobdI.default));
    const Box = /*#__PURE__*/ $8NFma.forwardRef(function Box(inProps, ref) {
        const theme = (0, $175604ad9cd01c87$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $3JC4a.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $hQtye.default)(_extendSxProp, $71bdae177f3fa0b5$var$_excluded);
        return /*#__PURE__*/ (0, $1IdZj.jsx)(BoxRoot, (0, $jz4iA.default)({
            as: component,
            ref: ref,
            className: (0, $4944fe05cfdb1e2e$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}



const $9ab9c83b20d59c88$var$defaultGenerator = (componentName)=>componentName;
const $9ab9c83b20d59c88$var$createClassNameGenerator = ()=>{
    let generate = $9ab9c83b20d59c88$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $9ab9c83b20d59c88$var$defaultGenerator;
        }
    };
};
const $9ab9c83b20d59c88$var$ClassNameGenerator = $9ab9c83b20d59c88$var$createClassNameGenerator();
var $9ab9c83b20d59c88$export$2e2bcd8739ae039 = $9ab9c83b20d59c88$var$ClassNameGenerator;





const $c01b352325a406cf$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $c01b352325a406cf$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $c01b352325a406cf$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $9ab9c83b20d59c88$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $c01b352325a406cf$export$34c0130b1f3e8ae3(slot) {
    return $c01b352325a406cf$export$9d6b9120de57c54[slot] !== undefined;
}


function $849007d053493250$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $c01b352325a406cf$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


const $0c634e20a22f8333$var$boxClasses = (0, $849007d053493250$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $0c634e20a22f8333$export$2e2bcd8739ae039 = $0c634e20a22f8333$var$boxClasses;


'use client';
const $5498c20b15dd5ce1$var$defaultTheme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)();
const $5498c20b15dd5ce1$var$Box = (0, $71bdae177f3fa0b5$export$2e2bcd8739ae039)({
    themeId: (0, $6b44440c4cabd1a9$export$2e2bcd8739ae039),
    defaultTheme: $5498c20b15dd5ce1$var$defaultTheme,
    defaultClassName: (0, $0c634e20a22f8333$export$2e2bcd8739ae039).root,
    generateClassName: (0, $9ab9c83b20d59c88$export$2e2bcd8739ae039).generate
});
var $5498c20b15dd5ce1$export$2e2bcd8739ae039 = $5498c20b15dd5ce1$var$Box;


var $hQtye = parcelRequire("hQtye");

var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");


function $1b026db85de7605c$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}



var $jz4iA = parcelRequire("jz4iA");
parcelRequire("8NFma");



var $1IdZj = parcelRequire("1IdZj");
'use client';
function $7b791778fe98c57f$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $348ef89b026f3609$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, props));
}
var $7b791778fe98c57f$export$2e2bcd8739ae039 = $7b791778fe98c57f$var$DefaultPropsProvider;
function $7b791778fe98c57f$export$2440da353cedad43(params) {
    return (0, $348ef89b026f3609$export$2440da353cedad43)(params);
}


var $c42c25d333d8397e$exports = {};
"use strict";

Object.defineProperty($c42c25d333d8397e$exports, "__esModule", {
    value: true
});
$c42c25d333d8397e$exports.default = $c42c25d333d8397e$var$createStyled;
$c42c25d333d8397e$exports.shouldForwardProp = $c42c25d333d8397e$var$shouldForwardProp;
$c42c25d333d8397e$exports.systemDefaultTheme = void 0;

var $c42c25d333d8397e$var$_extends2 = $32327384249c777c$exports((parcelRequire("lBRDc")));

var $c42c25d333d8397e$var$_objectWithoutPropertiesLoose2 = $32327384249c777c$exports((parcelRequire("6oOAi")));

var $c42c25d333d8397e$var$_styledEngine = $c42c25d333d8397e$var$_interopRequireWildcard((parcelRequire("33qfW")));

var $5eWZU = parcelRequire("5eWZU");

var $c42c25d333d8397e$var$_capitalize = $32327384249c777c$exports((parcelRequire("lLrTz")));

var $c42c25d333d8397e$var$_getDisplayName = $32327384249c777c$exports((parcelRequire("kpMWV")));

var $c42c25d333d8397e$var$_createTheme = $32327384249c777c$exports((parcelRequire("bnNVB")));

var $c42c25d333d8397e$var$_styleFunctionSx = $32327384249c777c$exports((parcelRequire("TjE6F")));
const $c42c25d333d8397e$var$_excluded = [
    "ownerState"
], $c42c25d333d8397e$var$_excluded2 = [
    "variants"
], $c42c25d333d8397e$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $c42c25d333d8397e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c42c25d333d8397e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c42c25d333d8397e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c42c25d333d8397e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c42c25d333d8397e$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c42c25d333d8397e$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $c42c25d333d8397e$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $c42c25d333d8397e$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $c42c25d333d8397e$var$systemDefaultTheme = $c42c25d333d8397e$exports.systemDefaultTheme = (0, $c42c25d333d8397e$var$_createTheme.default)();
const $c42c25d333d8397e$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $c42c25d333d8397e$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $c42c25d333d8397e$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $c42c25d333d8397e$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $c42c25d333d8397e$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $c42c25d333d8397e$var$_objectWithoutPropertiesLoose2.default)(_ref, $c42c25d333d8397e$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $c42c25d333d8397e$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$c42c25d333d8397e$var$processStyleArg(resolvedStyle, (0, $c42c25d333d8397e$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $c42c25d333d8397e$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $c42c25d333d8397e$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $c42c25d333d8397e$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $c42c25d333d8397e$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $c42c25d333d8397e$var$shallowLayer((0, $c42c25d333d8397e$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $c42c25d333d8397e$var$shallowLayer((0, $c42c25d333d8397e$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $c42c25d333d8397e$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c42c25d333d8397e$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $c42c25d333d8397e$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $c42c25d333d8397e$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $c42c25d333d8397e$var$_styleFunctionSx.default)((0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
            theme: $c42c25d333d8397e$var$resolveTheme((0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $c42c25d333d8397e$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c42c25d333d8397e$var$defaultOverridesResolver($c42c25d333d8397e$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $c42c25d333d8397e$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $c42c25d333d8397e$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $c42c25d333d8397e$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c42c25d333d8397e$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c42c25d333d8397e$var$_styledEngine.default)(tag, (0, $c42c25d333d8397e$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $5eWZU.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $c42c25d333d8397e$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $c42c25d333d8397e$var$processStyleArg(stylesArg, (0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c42c25d333d8397e$var$resolveTheme((0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $c42c25d333d8397e$var$processStyleArg(slotStyle, (0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $c42c25d333d8397e$var$resolveTheme((0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $c42c25d333d8397e$var$processStyleArg({
                    variants: themeVariants
                }, (0, $c42c25d333d8397e$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}



'use client';
const $5b347ac3ba7d187a$var$defaultTheme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)();
var $5b347ac3ba7d187a$export$2e2bcd8739ae039 = $5b347ac3ba7d187a$var$defaultTheme;



// copied from @mui/system/createStyled
function $21e05629fbdcc825$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $21e05629fbdcc825$export$2e2bcd8739ae039 = $21e05629fbdcc825$var$slotShouldForwardProp;


const $b4e96a8ac947c82c$var$rootShouldForwardProp = (prop)=>(0, $21e05629fbdcc825$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $b4e96a8ac947c82c$export$2e2bcd8739ae039 = $b4e96a8ac947c82c$var$rootShouldForwardProp;



'use client';
const $2379800afbd58d98$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($c42c25d333d8397e$exports)))({
    themeId: (0, $6b44440c4cabd1a9$export$2e2bcd8739ae039),
    defaultTheme: $5b347ac3ba7d187a$export$2e2bcd8739ae039,
    rootShouldForwardProp: $b4e96a8ac947c82c$export$2e2bcd8739ae039
});
var $2379800afbd58d98$export$2e2bcd8739ae039 = $2379800afbd58d98$var$styled;



var $jz4iA = parcelRequire("jz4iA");

var $8NFma = parcelRequire("8NFma");



var $jz4iA = parcelRequire("jz4iA");
parcelRequire("8NFma");





var $1IdZj = parcelRequire("1IdZj");
'use client';
function $be8656b6ac60bc0b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5cc57275d47605c6$export$2e2bcd8739ae039), (0, $jz4iA.default)({}, props, {
        defaultTheme: (0, $5b347ac3ba7d187a$export$2e2bcd8739ae039),
        themeId: (0, $6b44440c4cabd1a9$export$2e2bcd8739ae039)
    }));
}
var $be8656b6ac60bc0b$export$2e2bcd8739ae039 = $be8656b6ac60bc0b$var$GlobalStyles;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $0163360cc3dd6001$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $jz4iA.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $0163360cc3dd6001$export$32180ef41b15b513 = (theme)=>(0, $jz4iA.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $0163360cc3dd6001$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $jz4iA.default)({
        html: $0163360cc3dd6001$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $jz4iA.default)({
            margin: 0
        }, $0163360cc3dd6001$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $0163360cc3dd6001$var$CssBaseline(inProps) {
    const props = (0, $7b791778fe98c57f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $1IdZj.jsxs)($8NFma.Fragment, {
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $be8656b6ac60bc0b$export$2e2bcd8739ae039), {
                styles: (theme)=>$0163360cc3dd6001$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $0163360cc3dd6001$export$2e2bcd8739ae039 = $0163360cc3dd6001$var$CssBaseline;




function $ec45749f4118dad0$export$a3f1a6e59bdd9d27(slot) {
    return (0, $c01b352325a406cf$export$2e2bcd8739ae039)('MuiScopedCssBaseline', slot);
}
const $ec45749f4118dad0$var$scopedCssBaselineClasses = (0, $849007d053493250$export$2e2bcd8739ae039)('MuiScopedCssBaseline', [
    'root'
]);
var $ec45749f4118dad0$export$2e2bcd8739ae039 = $ec45749f4118dad0$var$scopedCssBaselineClasses;



var $1IdZj = parcelRequire("1IdZj");
'use client';
const $a86f219d010e43e7$var$_excluded = [
    "className",
    "component",
    "enableColorScheme"
];
const $a86f219d010e43e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1b026db85de7605c$export$2e2bcd8739ae039)(slots, (0, $ec45749f4118dad0$export$a3f1a6e59bdd9d27), classes);
};
const $a86f219d010e43e7$var$ScopedCssBaselineRoot = (0, $2379800afbd58d98$export$2e2bcd8739ae039)('div', {
    name: 'MuiScopedCssBaseline',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const colorSchemeStyles = {};
    if (ownerState.enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[`&${theme.getColorSchemeSelector(key).replace(/\s*&/, '')}`] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    return (0, $jz4iA.default)({}, (0, $0163360cc3dd6001$export$c0bb0b647f701bb5)(theme, ownerState.enableColorScheme), (0, $0163360cc3dd6001$export$32180ef41b15b513)(theme), {
        '& *, & *::before, & *::after': {
            boxSizing: 'inherit'
        },
        '& strong, & b': {
            fontWeight: theme.typography.fontWeightBold
        }
    }, colorSchemeStyles);
});
const $a86f219d010e43e7$var$ScopedCssBaseline = /*#__PURE__*/ $8NFma.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $7b791778fe98c57f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiScopedCssBaseline'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $hQtye.default)(props, $a86f219d010e43e7$var$_excluded);
    const ownerState = (0, $jz4iA.default)({}, props, {
        component: component
    });
    const classes = $a86f219d010e43e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $1IdZj.jsx)($a86f219d010e43e7$var$ScopedCssBaselineRoot, (0, $jz4iA.default)({
        as: component,
        className: (0, $4944fe05cfdb1e2e$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $a86f219d010e43e7$export$2e2bcd8739ae039 = $a86f219d010e43e7$var$ScopedCssBaseline;



var $8NFma = parcelRequire("8NFma");




var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");





const $2da112527112062c$var$defaultProps = {
    showTitle: true,
    valueTextSizeEm: 2.5
};
function $2da112527112062c$export$3e37981c83daa9b1(inputtedProps) {
    const props = {
        ...$2da112527112062c$var$defaultProps,
        ...inputtedProps
    };
    const latestData = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useContext((0, $9e99f3b631656eac$export$58d75f9829cbe158));
    let valueObject;
    let innerBoxClasses = "";
    if (latestData) {
        ////
        //// Differentiate between LiveDataSet and GOMAveragesSet
        // TODO: Why does this not work??
        //if (latestData instanceof Icon.Midi.WebApplication.FrontEnd.GOMAveragesSet) {
        //    console.log('[DataProvider, ValueBoxComponent] Averages...')
        //}
        //if (latestData.Stations[0].GroupAverages) {
        //    console.log('[DataProvider, ValueBoxComponent] Averages...')
        //}
        ////
        valueObject = props.valueFormatter.format(latestData.Stations[props.station.Id], (0, $52db63ea8facb471$export$1a86835baa79d770).instance.selectedWarningRules);
        // Collect css classes
        if (valueObject.Status === null || valueObject.Status === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired || valueObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) innerBoxClasses += " midi_siteObsPage_expiring";
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) innerBoxClasses += " midi_siteObsPage_exceeded_threshold_1";
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) innerBoxClasses += " midi_siteObsPage_exceeded_threshold_2";
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) innerBoxClasses += " midi_siteObsPage_exceeded_threshold_3";
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                className: "midi_SiteObservations_value_box_outer",
                style: {
                    top: `${props.top}%`,
                    left: `${props.left}%`,
                    height: `${props.height}%`,
                    width: `${props.width}%`
                },
                title: valueObject ? `Timestamp: ${moment(moment.utc(valueObject.Timestamp)).tz((0, $52db63ea8facb471$export$1a86835baa79d770).instance.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm")}. Click for parameter popup.` : "",
                onClick: (e)=>{
                    // Generate parameterPopup()
                    const parameterPopup = new (0, $bfbbca38eee2856d$export$3f0be2c6920005ae)((0, $52db63ea8facb471$export$1a86835baa79d770).instance, props.station, props.valueFormatter);
                    if (valueObject) {
                        parameterPopup.setSensor(props.valueFormatter.getSensorId() ?? valueObject.Sensor);
                        parameterPopup.setTimestamp(valueObject.Timestamp);
                    }
                    parameterPopup.renderPopup(e);
                },
                children: [
                    /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                        className: "midi_SiteObservations_value_box_header",
                        style: {
                            fontSize: `${props.titleTextSizeEm}em`
                        },
                        children: [
                            props.titleText ? props.titleText : props.valueFormatter.getShortName(),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                                className: "midi_SiteObservations_value_box_units",
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("span", {}),
                                    props.showTitle && props.valueFormatter.getUnits() && valueObject?.Status !== null && valueObject?.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired ? props.valueFormatter.getUnits() : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        className: "midi_SiteObservations_value_box_inner" + innerBoxClasses,
                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "midi_SiteObservations_value_box_value",
                            style: {
                                fontSize: `${props.valueTextSizeEm}em`
                            },
                            children: valueObject ? valueObject.Value : ''
                        })
                    })
                ]
            })
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");
function $17a092c1f2217352$export$f6b18543c7c0b778(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                className: "midi_SiteObservations_value_box_outer",
                style: {
                    top: `${props.top}%`,
                    left: `${props.left}%`,
                    height: `${props.height}%`,
                    width: `${props.width}%`,
                    cursor: "auto"
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "midi_SiteObservations_value_group_header",
                    style: {
                        fontSize: `${props.titleTextSizeEm}em`
                    },
                    children: props.text
                })
            })
        })
    });
}






class $f92650af130041e0$export$9d5ef501fe2d36c8 {
    constructor(parameterGroupSpeed, parameterGroupDirection){
        this.parameterGroupSpeed = parameterGroupSpeed;
        this.parameterGroupDirection = parameterGroupDirection;
    }
    getShortName() {
        // Will be used for PopupChartable
        return this.parameterGroupSpeed.ShortName;
    }
    getUnits() {
        // Will be used for PopupChartable
        return (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.parameterGroupSpeed.Units, this.parameterGroupSpeed.Id);
    }
    getParameterGroupInfo() {
        // Will be used for PopupChartable
        return this.parameterGroupSpeed;
    }
    getDescription() {
        return "Current Variation.";
    }
    getId() {
        // Will be used for PopupChartable
        return this.parameterGroupSpeed.Id;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return true;
    }
    axisMin() {
        // Will be used for PopupChartable
        if (typeof this.parameterGroupSpeed.AxisMin == 'undefined') return null;
        return this.parameterGroupSpeed.AxisMin;
    }
    axisMax() {
        // Will be used for PopupChartable
        if (typeof this.parameterGroupSpeed.AxisMax == 'undefined') return null;
        return this.parameterGroupSpeed.AxisMax;
    }
    plotLines() {
        if (typeof this.parameterGroupSpeed.PlotLine == 'undefined') return true;
        return this.parameterGroupSpeed.PlotLine;
    }
    format(liveDataSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Timestamp: null,
            Sensor: null
        };
        if (liveDataSetStation?.GroupValues && this.parameterGroupSpeed.Id in liveDataSetStation.GroupValues && this.parameterGroupDirection.Id in liveDataSetStation.GroupValues) {
            var speed = liveDataSetStation.GroupValues[this.parameterGroupSpeed.Id][0];
            var direction = liveDataSetStation.GroupValues[this.parameterGroupDirection.Id][0];
            var worstStatus = Math.max(speed.ExpiryStatus, direction.ExpiryStatus);
            var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[speed.Sensor].Parameters[speed.Parameter].Variants[0].ParameterDefinition;
            if ((!paramDef || paramDef.Default) && speed.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[speed.Parameter];
            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: worstStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: speed.Timestamp > direction.Timestamp ? speed.Timestamp : direction.Timestamp,
                Sensor: speed.Timestamp > direction.Timestamp ? speed.Sensor : direction.Sensor
            };
            if (speed.Value?.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired || direction.Value?.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) return valueObject; // leave value as "///" if expired
            if (typeof speed.Value == 'number' && typeof direction.Value == 'number' && (worstStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || worstStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) {
                //// Convert speed according to units
                let speedString;
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.parameterGroupSpeed.Units, this.parameterGroupSpeed.Id);
                if (this.parameterGroupSpeed.Format) {
                    if (unitsConversionSet) speedString = sprintf(this.parameterGroupSpeed.Format, unitsConversionSet.convertValue(speed.Value));
                    else speedString = sprintf(this.parameterGroupSpeed.Format, speed.Value);
                    if (warningRules) valueObject.WarningThreshold = (0, $8ed788ecc5d8a807$export$ba9136f38d1702aa)(warningRules, speed.Value, this.parameterGroupSpeed, liveDataSetStation);
                } else speedString = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(speed.Value, this.parameterGroupSpeed.Units, this.parameterGroupSpeed.Id).toString();
                //// Convert direction from degrees to cardinal/inter-cardinal notation
                const degreeRange = 45;
                let directionString;
                if (direction.Value > 360 - degreeRange / 2 || direction.Value <= degreeRange / 2 + degreeRange * 0) directionString = "N";
                else if (direction.Value > degreeRange / 2 + degreeRange * 0 && direction.Value <= degreeRange / 2 + degreeRange * 1) directionString = "NE";
                else if (direction.Value > degreeRange / 2 + degreeRange * 1 && direction.Value <= degreeRange / 2 + degreeRange * 2) directionString = "E";
                else if (direction.Value > degreeRange / 2 + degreeRange * 2 && direction.Value <= degreeRange / 2 + degreeRange * 3) directionString = "SE";
                else if (direction.Value > degreeRange / 2 + degreeRange * 3 && direction.Value <= degreeRange / 2 + degreeRange * 4) directionString = "S";
                else if (direction.Value > degreeRange / 2 + degreeRange * 4 && direction.Value <= degreeRange / 2 + degreeRange * 5) directionString = "SW";
                else if (direction.Value > degreeRange / 2 + degreeRange * 5 && direction.Value <= degreeRange / 2 + degreeRange * 6) directionString = "W";
                else if (direction.Value > degreeRange / 2 + degreeRange * 6 && direction.Value <= degreeRange / 2 + degreeRange * 7) directionString = "NW";
                //// Set valueObject.Value
                valueObject.Value = `${speedString} ${directionString}`;
            }
        }
        return valueObject;
    }
}







class $983c6f04b0a936bb$export$55bf2b94bc0796a2 {
    constructor(profileGroup){
        this.profileGroup = profileGroup;
    }
    getShortName() {
        return this.profileGroup.ShortName;
    }
    getUnits() {
        return (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.profileGroup.Units, this.profileGroup.Id);
    }
    getParameterGroupInfo() {
        return this.profileGroup;
    }
    getDescription() {
        return this.profileGroup.Description;
    }
    getId() {
        return this.profileGroup.Id;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return false;
    }
    axisMin() {
        return null;
    }
    axisMax() {
        return null;
    }
    plotLines() {
        return false;
    }
    format(liveDataSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Timestamp: null,
            Sensor: null
        };
        if (liveDataSetStation?.GroupValues && this.profileGroup.Id in liveDataSetStation?.GroupValues) {
            //var parameter: LiveDataSetValue = liveDataSetStation.GroupValues[this.profileGroup.Id][0];
            //var parameter: Partial<LiveDataSetValue> = liveDataSetStation.GroupValues[this.profileGroup.Id][0];
            // TODO: Do not cast as any! Find type definition.
            var parameter = liveDataSetStation.GroupValues[this.profileGroup.Id][0];
            var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[parameter.Sensor].Parameters[parameter.Parameter].Variants[0].ParameterDefinition;
            if ((!paramDef || paramDef.Default) && parameter.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[parameter.Parameter];
            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: parameter.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: parameter.Timestamp,
                Sensor: parameter.Sensor
            };
            if (parameter.Value != null && parameter.Value.Components?.length > 0 && typeof parameter.Value.Components?.at(-1).Depth == 'number' && (parameter.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || parameter.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) {
                const value = parameter.Value.Components.at(-1).Depth;
                //// Convert speed according to units
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.profileGroup.Units, this.profileGroup.Id);
                if (this.profileGroup.Format) {
                    if (unitsConversionSet) valueObject.Value = sprintf(this.profileGroup.Format, unitsConversionSet.convertValue(value));
                    else valueObject.Value = sprintf(this.profileGroup.Format, value);
                    if (warningRules) valueObject.WarningThreshold = (0, $8ed788ecc5d8a807$export$ba9136f38d1702aa)(warningRules, value, this.profileGroup, liveDataSetStation);
                } else valueObject.Value = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(value, this.profileGroup.Units, this.profileGroup.Id).toString();
            }
        }
        return valueObject;
    }
}



var $1IdZj = parcelRequire("1IdZj");

const $4e8fcc1b86169fc2$var$Item = ({ children: children, isActive: isActive, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
        onClick: onClick,
        sx: {
            p: 1,
            mr: 0.5,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            bgcolor: isActive ? 'grey.300' : 'grey.100',
            cursor: 'pointer',
            '&:hover': {
                bgcolor: 'grey.400'
            }
        },
        children: children
    });
};
function $4e8fcc1b86169fc2$export$d880734c77061ef3(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flexDirection: 'row'
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)($4e8fcc1b86169fc2$var$Item, {
                isActive: props.timeRange == "LatestValue",
                onClick: ()=>{
                    props.setTimeRange("LatestValue");
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Latest"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($4e8fcc1b86169fc2$var$Item, {
                isActive: props.timeRange == "Average3h",
                onClick: ()=>{
                    props.setTimeRange("Average3h");
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Last 3-hr"
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($4e8fcc1b86169fc2$var$Item, {
                isActive: props.timeRange == "Average24h",
                onClick: ()=>{
                    props.setTimeRange("Average24h");
                },
                children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Last 24-hr"
                })
            })
        ]
    });
}


function $13747905487d6d1e$export$28080c3709a4d4d9(props) {
    // console.log("[GOMCurrentPageComponent] props.mainSite: ", props.mainSite)
    // console.log("[GOMCurrentPageComponent] props.liveDataListeners: ", props.liveDataListeners)
    // console.log("[GOMCurrentPageComponent] props.GOMAveragesListeners: ", props.GOMAveragesListeners)
    // console.log("[GOMCurrentPageComponent] props.mainSite.GOMAveragesManager", props.mainSite.GOMAveragesManager)
    const [timeRange, setTimeRange] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("LatestValue");
    const theme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)({
        typography: {
            fontSize: 24
        }
    });
    // Heights of React components
    const headerHeight = 4;
    const boxHeight = 16.7;
    const getDepthRangeHeader = (type)=>{
        const convertedUnit = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits("m", (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean.Id);
        let minDepth;
        let maxDepth;
        // If available, take data from horisontal profile.Else, take data from first bin of vertical profile.
        // Define depths in units of m to comply with the unitConverter.
        // Unfortunate since the required depths are given in ft, and therefore requires manual conversion to m... Before being converted back to ft...
        if (type == "Surface") {
            //minDepth = 166; // [ft]
            minDepth = 50.5968; // [m]
            //maxDepth = 479; // [ft]
            maxDepth = 145.999; // [m]
        } else if (type == "Top") {
            //minDepth = 0; // [ft]
            minDepth = 0; // [m]
            //maxDepth = 100; // [ft]
            maxDepth = 30.48; // [m]
        } else if (type == "Middle") {
            // as specified by Luz
            //minDepth = 1000; // [ft]
            minDepth = 304.8; // [m]
            //maxDepth = 1500; // [ft]
            maxDepth = 457.2; // [m]
        } else if (type == "Bottom") {
            // as specified by Luz
            //minDepth = 2200; // [ft]
            minDepth = 670.56; // [m]
            //maxDepth = 2600; // [ft]
            maxDepth = 792.48; // [m]
        }
        const convertedMinDepth = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(minDepth, "m", (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean.Id);
        const convertedMaxDepth = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(maxDepth, "m", (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean.Id);
        const header = `${type} (${Math.round(convertedMinDepth)} - ${Math.round(convertedMaxDepth)} ${convertedUnit})`;
        return header;
    };
    //// source of CurrentSurface
    // if the GroupValues 'HorizontalCurrentProfile' and 'Total_CurrentSpeed_Surface_mps_Mean' exist,
    // and their sensors of are identical => isCurrentSurfaceFromHorizontalSensor = true
    const sensorHorizontalCurrentProfile = props.mainSite.liveDataManager.latestData?.Stations[props.station.Station.Id].GroupValues.HorizontalCurrentProfile?.[0].Sensor;
    const sensorTotal_CurrentSpeed_Surface_mps_Mean = props.mainSite.liveDataManager.latestData?.Stations[props.station.Station.Id].GroupValues.Total_CurrentSpeed_Surface_mps_Mean?.[0].Sensor;
    const isCurrentSurfaceFromHorizontalSensor = !!sensorHorizontalCurrentProfile && !!sensorTotal_CurrentSpeed_Surface_mps_Mean && sensorHorizontalCurrentProfile == sensorTotal_CurrentSpeed_Surface_mps_Mean ? true : false;
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $89db59c316d64b9f$export$2e2bcd8739ae039), {
                theme: theme,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a86f219d010e43e7$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                        className: "container",
                        sx: {
                            bgcolor: 'background.paper',
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                                sx: {
                                    bgcolor: 'background.paper',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    mb: 2,
                                    width: "100%"
                                },
                                mb: "-20px",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4e8fcc1b86169fc2$export$d880734c77061ef3), {
                                    timeRange: timeRange,
                                    setTimeRange: (newTimeRange)=>{
                                        setTimeRange(newTimeRange);
                                        props.timeRangeChanged(newTimeRange);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    height: '47em',
                                    width: '30em',
                                    top: '60pt'
                                },
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $9e99f3b631656eac$export$43c6ed89e8a21a35), {
                                    liveDataListeners: props.liveDataListeners,
                                    GOMAveragesListeners: props.GOMAveragesListeners,
                                    timeRange: timeRange,
                                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $17a092c1f2217352$export$f6b18543c7c0b778), {
                                                text: "Peak Current",
                                                top: 0,
                                                left: 0,
                                                height: headerHeight,
                                                width: 100
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean),
                                                top: headerHeight,
                                                left: 0,
                                                height: boxHeight,
                                                width: 100 / 3,
                                                titleText: "Depth"
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Peak_mps_Mean),
                                                top: headerHeight,
                                                left: 100 / 3,
                                                height: boxHeight,
                                                width: 100 / 3,
                                                titleText: "Speed"
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Peak_deg_Mean),
                                                top: headerHeight,
                                                left: 100 / 3 * 2,
                                                height: boxHeight,
                                                width: 100 / 3,
                                                titleText: "Direction"
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $17a092c1f2217352$export$f6b18543c7c0b778), {
                                                text: "Depth Averaged Current Speed",
                                                top: headerHeight + boxHeight,
                                                left: 0,
                                                height: headerHeight,
                                                width: 100
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $f92650af130041e0$export$9d5ef501fe2d36c8)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean),
                                                top: headerHeight * 2 + boxHeight,
                                                left: 0,
                                                height: boxHeight,
                                                width: 100,
                                                titleText: getDepthRangeHeader(isCurrentSurfaceFromHorizontalSensor ? "Surface" : "Top")
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $f92650af130041e0$export$9d5ef501fe2d36c8)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Middle_mps_Mean, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Middle_deg_Mean),
                                                top: headerHeight * 2 + boxHeight * 2,
                                                left: 0,
                                                height: boxHeight,
                                                width: 100,
                                                titleText: getDepthRangeHeader("Middle")
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $f92650af130041e0$export$9d5ef501fe2d36c8)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Bottom_mps_Mean, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Bottom_deg_Mean),
                                                top: headerHeight * 2 + boxHeight * 3,
                                                left: 0,
                                                height: boxHeight,
                                                width: 100,
                                                titleText: getDepthRangeHeader("Bottom")
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $17a092c1f2217352$export$f6b18543c7c0b778), {
                                                text: "Profile",
                                                top: headerHeight * 2 + boxHeight * 4,
                                                left: 0,
                                                height: headerHeight,
                                                width: 100
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)((0, $2da112527112062c$export$3e37981c83daa9b1), {
                                                station: props.station.Station,
                                                valueFormatter: new (0, $983c6f04b0a936bb$export$55bf2b94bc0796a2)((0, $24b391ec3014929b$export$5d65fdcfff509e37).CurrentProfile),
                                                top: headerHeight * 3 + boxHeight * 4,
                                                left: 0,
                                                height: boxHeight,
                                                width: 100,
                                                titleText: "Max Depth"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}


class $ae8320e57e7409f2$export$65c1f044ef715ed6 {
    notifyResize() {}
    GOMAveragesChanged(latestData) {
        for (const listener of this.GOMAveragesListeners)listener.GOMAveragesChanged(latestData);
    }
    show(station) {
        const pages = [];
        // Go through all sensorIds
        for(let sensorId in station.Sensors){
            // if not useLiveData or forecast, skip
            if (station.Station.Region != "GOM" || !station.Sensors[sensorId].UseLiveData || sensorId.toLowerCase().includes("forecast")) continue;
            const sensor = station.Sensors[sensorId];
            if (sensorId.includes("orecast")) continue;
            // Check if the sensorId has any wave Current parameters. If so, generate a Currents-pages for this sensorId
            for(let paramId in sensor.Parameters)if (paramId.indexOf("Current") != -1) {
                const label = station.Sensors[sensorId].SensorDefinition?.DisplayName ?? sensorId;
                pages.push(new $ae8320e57e7409f2$export$65c1f044ef715ed6(this.mainSite, this.ctx, sensorId, label));
                break;
            }
        }
        if (pages.length == 1 || pages.length > 1 && station.Station.Region === "GOM") // For GoM we typically have one vertical and one horizontal profiler, so only show one Current page
        return true;
        else if (pages.length > 1) return pages;
        return false;
    }
    constructor(mainSite, ctx, sensorId, label){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.sensorId = sensorId;
        this.id = "GOM current";
        this.label = "Current";
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
        this.plotsToShow = [
            {
                profileName: "Vertical Profile",
                parameterGroup: "CurrentProfile",
                profileEnumType: (0, $7135656329687c33$export$861facf577d6ed7a).Depth
            },
            {
                profileName: "Horizontal Profile",
                parameterGroup: "HorizontalCurrentProfile",
                profileEnumType: (0, $7135656329687c33$export$861facf577d6ed7a).Horizontal
            }
        ];
        this.container = null;
        this.$div = null;
        // if sensorId is not set to null, update label and id to distinguish the pages
        if (this.sensorId !== null) {
            this.label += ` (${label})`;
            this.id += `${this.sensorId}`;
        }
    }
    render(container, listeners, station, warningGroup, GOMAveragesListeners) {
        // Page instance is reused across stations; clear sensor IDs detected for the previous one
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
        this.listeners = listeners;
        this.GOMAveragesListeners = GOMAveragesListeners;
        this.station = station;
        this.warningGroup = warningGroup;
        /*
         * Quick and dirty fix to detect if current speed is shown as kts rather than mps.
         * It would be much better to allow the DefaultGroupFormatter to choose the group from
         * multiple options based on what is available.
         */ let currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps;
        let hasHorizontal = false;
        for(const sensorId in station.Sensors){
            const sensor = station.Sensors[sensorId];
            Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile");
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile/kts")) currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).kts;
            if (Object.keys(sensor.Parameters).some((pid)=>pid.indexOf("HorizontalCurrentProfile") === 0)) hasHorizontal = true;
        }
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        this.leftPanel = $('<div class="col-sm-12"></div>').css("position", "absolute").css("height", "47em").css("width", "30em").appendTo(page);
        this.rightPanel = $("<div></div>").css("position", "absolute").css("height", "47em").css("top", "76.72px").css("left", "32em").css("width", "32em").appendTo(page);
        this.rightPanelAverages = $("<div></div>").css("position", "absolute").css("height", "47em").css("left", "32em").css("width", "32em").hide().appendTo(page);
        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? "m/s" : "kts";
        var unitsStrDepthOrHeight = "m";
        let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet("m");
        console.log("[GOMCurrentPage] unitsConversionSet_DepthOrHeight: ", unitsConversionSet_DepthOrHeight);
        let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight = (value)=>value;
        let ucf_Speed = (value)=>value;
        let ucf_Direction = (value)=>value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }
        const updateRightCharts = (timeRange)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $aead4e3e868899f7$export$68bd6571e530c39f), {
                liveDataListeners: this.listeners,
                GOMAveragesListeners: this.GOMAveragesListeners,
                station: this.station,
                timeRange: timeRange,
                plots: this.plotsToShow,
                speedUnits: currentSpeedUnits,
                unitsStrDepthOrHeight: unitsStrDepthOrHeight,
                ucf_DepthOrHeight: ucf_DepthOrHeight,
                speedUnitsStr: speedUnitsStr,
                ucf_Speed: ucf_Speed
            }), this.rightPanelAverages[0]);
        };
        updateRightCharts("Average3h");
        //// Render pageComponent (the React part)
        (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $13747905487d6d1e$export$28080c3709a4d4d9), {
            mainSite: this.mainSite,
            liveDataListeners: this.listeners,
            GOMAveragesListeners: this.GOMAveragesListeners,
            station: this.station,
            currentSpeedUnits: currentSpeedUnits,
            timeRangeChanged: (timeRange)=>{
                this.timeRange = timeRange;
                if (timeRange === "LatestValue") {
                    this.rightPanel.show();
                    // Hack to force charts to re-render such that they take their correct size
                    if ((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData) for (const l of listeners)l.liveDataChanged((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData, {
                        valueChanged: ()=>{}
                    });
                    this.rightPanelAverages.hide();
                    this.leftPanel.show();
                } else {
                    this.rightPanel.hide();
                    this.rightPanelAverages.show();
                    this.leftPanel.show();
                }
                updateRightCharts(timeRange);
            }
        }), this.leftPanel[0]);
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo(this.rightPanel);
        let currentBox = $('<div class="site-obs-current-charts" data-chart-type="vertical"></div>').appendTo(this.rightPanel).hide();
        let currentBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="horizontal"></div>').appendTo(this.rightPanel).hide();
        let pvdBox = $('<div class="site-obs-current-charts" data-chart-type="pvd"></div>').appendTo(this.rightPanel).hide();
        let polarBox = $('<div class="site-obs-current-charts" data-chart-type="polar"></div>').appendTo(this.rightPanel).hide();
        let hovmollerBoxVertical = $('<div class="site-obs-current-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(this.rightPanel).hide();
        let hovmollerBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="hovmoller-horizontal"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(this.rightPanel).hide();
        let showChart = (chartType, label)=>{
            /*spectrumBox.hide();
            polarSpectrumBox.hide();
            polarBox.hide();
            hovmoller01Box.hide();*/ $(".site-obs-current-charts").hide();
            $(`.site-obs-current-charts[data-chart-type="${chartType}"]`).show();
            $(".site-obs-current-chart-select-label").text(label);
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        chartSelectTabs.append("<span>Chart: </span>");
        let $buttonGroup = $('<div class="btn-group"></div>').appendTo(chartSelectTabs);
        $('<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><span class="site-obs-current-chart-select-label">Select chart..</span> <span class="caret"></span></button>').appendTo($buttonGroup);
        let tpul = $("<ul></ul>").addClass("dropdown-menu")// .append($('<span></span>').text("Chart: "))
        .appendTo($buttonGroup);
        this._dpc = new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 5, 0, 93, 100, currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean.Id, true);
        listeners.push(this._dpc);
        this._pvd = new (0, $afcc295e055250f2$export$269e444807daccc9)(this.mainSite, this, pvdBox, 5, 0, 93, 100, currentSpeedUnits);
        listeners.push(this._pvd);
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBox, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $7135656329687c33$export$861facf577d6ed7a).Depth));
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBoxHorizontal, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $7135656329687c33$export$861facf577d6ed7a).Horizontal));
        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    "#0000FF"
                ],
                [
                    0.33,
                    "#00FFFF"
                ],
                [
                    0.66,
                    "#FFFF00"
                ],
                [
                    1,
                    "#FF0000"
                ]
            ]
        };
        // Direction: Options specific to direction chart
        let hovmolOptionsDirection = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsDirection.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [
                    0.0,
                    "rgb(255, 0, 0)"
                ],
                [
                    0.25,
                    "rgb(160, 32, 240)"
                ],
                [
                    0.5,
                    "rgb(0, 0, 255)"
                ],
                [
                    0.75,
                    "rgb(252, 186, 3)"
                ],
                [
                    1.0,
                    "rgb(255, 0, 0)"
                ]
            ],
            tickPositions: [
                0,
                90,
                180,
                270,
                360
            ],
            startOnTick: true,
            endOnTick: true
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(//// mainSite
        this.mainSite, //// page
        this, //// $container
        hovmollerBoxVertical, //// top, left, height, width
        0, 0, 93, 100, //// specific chart options
        hovmolOptionsSpeed, hovmolOptionsDirection, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                console.warn("Current Hovmoller (Vertical) chart: no current profile sensor or param detected for this station.");
                callback([], false);
                return;
            }
            let sensor = this.currentProfileSensor;
            let parameter = this.currentProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info("Current Hovmoller (Vertical) - data fetch URI:", uri);
            $.ajax(uri + "", {
                cache: false,
                dataType: "json",
                type: "GET",
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let profile = JSON.parse(x[1]);
                                    let components = profile.Components.sort((a, b)=>b.Depth - a.Depth); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.Speed || isNaN(cp.Speed) || !isFinite(cp.Speed) || cp.Speed < 0 || cp.Speed > 10) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: ucf_DepthOrHeight(cp.Depth),
                                            val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
        (latestData, chart)=>{
            if (this.currentProfileParam !== null) {
                chart.updateChart();
                return; //: already dealt with.
            }
            let liveDataSetValue = null;
            if (latestData.Stations[this.station.Station.Id]) {
                if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "CurrentProfile")) {
                    liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["CurrentProfile"][0];
                    this.currentProfileSensor = liveDataSetValue.Sensor;
                    this.currentProfileParam = "CurrentProfile";
                }
            }
            chart.updateChart();
        });
        listeners.push(this._chartsHovmoller);
        if (hasHorizontal) {
            let hovmolOptionsSpeedHorizontal = {
                ...hovmolOptionsSpeed
            };
            hovmolOptionsSpeedHorizontal.yAxis = {
                ...hovmolOptionsSpeedHorizontal.yAxis,
                title: {
                    text: `Distance (${unitsStrDepthOrHeight})`
                },
                reversed: true
            };
            this._chartsHovmollerHorizontal = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBoxHorizontal, 0, 0, 93, 100, //// specific chart options
            hovmolOptionsSpeedHorizontal, hovmolOptionsDirection, //// getDataMethod
            (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
                let res = [];
                if (this.currentProfileHorizontalSensor == null || this.currentProfileHorizontalParam == null) {
                    console.warn("Current Hovmoller (Horizontal) chart: no current profile sensor or param detected for this station.");
                    callback([], false);
                    return;
                }
                let sensor = this.currentProfileHorizontalSensor;
                let parameter = this.currentProfileHorizontalParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info("Current Hovmoller (Horizontal) - data fetch URI:", uri);
                $.ajax(uri + "", {
                    cache: false,
                    dataType: "json",
                    type: "GET",
                    timeout: 30000,
                    success: (data, text, jqXHR)=>{
                        try {
                            if (Array.isArray(data.results[0].series[0].values)) {
                                for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                    let x = data.results[0].series[0].values[i];
                                    let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let profile = JSON.parse(x[1]);
                                        let components = profile.Components.sort((a, b)=>b.Distance ?? b.Depth - a.Distance ?? a.Depth);
                                        components.forEach((cp, cpi)=>{
                                            let val = extractProfileCmpValue(cp);
                                            if (!val || isNaN(val)) {
                                                console.log("val: ", val);
                                                return;
                                            }
                                            if (isSpeed) val = ucf_Speed(val);
                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: ucf_DepthOrHeight(cp.Distance ?? cp.Depth),
                                                val: val
                                            });
                                        });
                                    } else console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                }
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown)=>{
                        console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
            (latestData, chart)=>{
                if (this.currentProfileHorizontalParam !== null) return; //: already dealt with.
                let liveDataSetValue = null;
                if (latestData.Stations[this.station.Station.Id]) {
                    if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "HorizontalCurrentProfile")) {
                        liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["HorizontalCurrentProfile"][0];
                        this.currentProfileHorizontalSensor = liveDataSetValue.Sensor;
                        this.currentProfileHorizontalParam = "HorizontalCurrentProfile";
                    }
                }
                chart.updateChart();
            });
            listeners.push(this._chartsHovmollerHorizontal);
        }
        let tpulLiActiveClass = "active"; //: 'selected' prior to using drop-down
        let charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            // { key: 'horizontal', label: 'Horizontal Profile' },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Color Flood (Vertical)" : "Color Flood"
            }
        ];
        if (hasHorizontal) charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            {
                key: "horizontal",
                label: "Horizontal Profile"
            },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Color Flood (Vertical)" : "Color Flood"
            }
        ];
        for(var i = 0; i < charts.length; i++){
            let chart = charts[i];
            let $li = $(`<li class="dropdown-menu-item"></li>`);
            let $a = $(`<a href="">${chart.label}</a>`).appendTo($li);
            $a.on("click", (ev)=>{
                ev.preventDefault();
                tpul.children("li").removeClass(tpulLiActiveClass);
                $li.addClass(tpulLiActiveClass);
                showChart(chart.key, chart.label);
            });
            tpul.append($li);
        }
        // currentBox.show();
        setTimeout(()=>{
            //: somehow, if executed immediately, this would not display the correct box..
            tpul.children("li").first().find("a").trigger("click");
        }, 500);
        page.appendTo(container);
        //page resizes due to highcharts charts being drawn before the box size is fixed and
        //the chart subsequently not filling the available space
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
    }
}





class $49efe750b1982432$export$8ba89689dcbc989e {
    constructor(){
        this.regex = /(\d+)/;
        this.metarRegex = /^[\+-]?[A-Z]*$/;
        this.metarCodes = [
            "NIL",
            "",
            "",
            "",
            "HZ",
            "HZ",
            "",
            "",
            "",
            "",
            "BR",
            "SG",
            "VCTS",
            "",
            "",
            "",
            "",
            "",
            "SQ",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "BLSA",
            "BLSA",
            "BLSA",
            "FG",
            "BCFG",
            "FG",
            "FG",
            "FG",
            "FZFG",
            "",
            "",
            "",
            "",
            "UP",
            "UP",
            "+UP",
            "UP",
            "+UP",
            "UP",
            "+UP",
            "UP",
            "+UP",
            "",
            "DZ",
            "-DZ",
            "DZ",
            "+DZ",
            "-FZDZ",
            "FZDZ",
            "+FZDZ",
            "-RADZ",
            "+RADZ",
            "RADZ",
            "RA",
            "-RA",
            "RA",
            "+RA",
            "-FZRA",
            "FZRA",
            "+FZRA",
            "-RASN",
            "+RASN",
            "RASN",
            "SN",
            "-SN",
            "SN",
            "+SN",
            "-PL",
            "PL",
            "+PL",
            "SG",
            "IC",
            "GS",
            "SHUP",
            "-SHRA",
            "SHRA",
            "+SHRA",
            "+SHRA",
            "-SHSN",
            "SHSN",
            "+SHSN",
            "",
            "SHGR"
        ];
    }
    getShortName() {
        return "Present Weather";
    }
    getUnits() {
        return null;
    }
    getParameterGroupInfo() {
        return (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather;
    }
    getDescription() {
        return "Present Weather in METAR coding format.";
    }
    getId() {
        return null;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return false;
    }
    axisMin() {
        return null;
    }
    axisMax() {
        return null;
    }
    plotLines() {
        return false;
    }
    format(liveDataSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        };
        if ((0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather.Id in liveDataSetStation.GroupValues) {
            const wmo = liveDataSetStation.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather.Id][0];
            const paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[wmo.Parameter];
            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: wmo.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: wmo.Timestamp,
                Sensor: wmo.Sensor
            };
            const result = this.regex.exec(wmo.Value);
            if (result !== null && result.length > 0) {
                const pos = parseInt(result[1], 10);
                if (pos < this.metarCodes.length) valueObject.Value = this.metarCodes[pos];
            } else {
                const metarResult = this.metarRegex.exec(wmo.Value);
                if (metarResult !== null) valueObject.Value = wmo.Value;
            }
        }
        return valueObject;
    }
}







class $607187fbef2f1b3a$export$6a6a284d6db23627 {
    constructor(mainSite, page, container, top, left, height, width){
        this.mainSite = mainSite;
        this.stationId = page.station.Station.Id;
        var box = $('<div class="midi_SiteObservations_chart_container"></div>').css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        container.append(box);
        this.chartContainer = $('<div></div>').css('height', '100%').appendTo(box);
        this.timeZoneString = this.mainSite.getTimeZoneString();
        this.drawChart();
        this.updateChart();
    }
    liveDataChanged(latestData) {
        this.updateChart();
    }
    drawChart() {
        var yAxisOptions = [];
        yAxisOptions.push({
            title: {
                text: `Height (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Id)})`
            },
            min: 0,
            lineColor: '#666',
            //lineWidth: 1,
            gridLineColor: '#666',
            gridLineWidth: 0.5,
            gridLineDashStyle: 'longdash'
        }, {
            title: {
                text: `Visibility (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Id)})`
            },
            min: 0,
            opposite: true,
            lineColor: '#666',
            //lineWidth: 1,
            gridLineColor: '#666',
            gridLineWidth: 0.5,
            gridLineDashStyle: 'longdash'
        });
        this.chartContainer.highcharts({
            chart: {
                type: 'line',
                backgroundColor: '#FFF',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime',
                ordinal: false,
                lineWidth: 0,
                lineColor: '#666'
            },
            yAxis: yAxisOptions,
            legend: {
                enabled: true
            },
            plotOptions: {
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    }
                }
            },
            credits: {
                enabled: false
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + this.timeZoneString,
                valueDecimals: 0
            }
        });
        this.chart = this.chartContainer.highcharts();
        this.chart.showLoading('Getting data...');
    }
    updateChart() {
        if (!this.mainSite.liveDataManager.latestData) return;
        var seriesOptions = [];
        var instCloudGroupIds = [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Id,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudBaseHeight_ft_Inst.Id,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudBaseHeight_ft_Inst.Id
        ];
        var toMoment = moment.utc();
        var fromMoment = moment.utc().subtract(3, 'h'); // 2 hours ago
        var anyData = false;
        instCloudGroupIds.forEach((paramGroupId)=>{
            (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, paramGroupId, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                if (err) {
                    //alert('Error getting data: ' + err);
                    console.warn('Error getting data (CloudChart - instCloudGroupIds)', err);
                    this.chart.showLoading('Error getting data' + (typeof err == 'string' ? `: ${err}` : ''));
                    return;
                }
                anyData = anyData || data.Data !== null;
                var showInLegend = data.ParameterId == (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Id;
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Id);
                if (data.Data !== null) {
                    if (unitsConversionSet) data.Data = data.Data.map((x)=>{
                        if (Array.isArray(x) && x.length == 2) return [
                            x[0],
                            unitsConversionSet.convertValue(x[1])
                        ];
                        return x;
                    });
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                seriesOptions.push({
                    id: paramGroupId,
                    name: `Instantaneous Cloud (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst.Id)})`,
                    data: data.Data,
                    lineWidth: 0,
                    marker: {
                        enabled: true,
                        radius: 2,
                        symbol: 'circle'
                    },
                    yAxis: 0,
                    color: '#666',
                    showInLegend: showInLegend
                });
                if (seriesOptions.length == 4) {
                    if (anyData) this.replaceChartSeries(seriesOptions);
                    else this.chart.showLoading('Data not available');
                }
            });
        });
        (0, $fd959835eca46177$export$7a53cc19acfc9f90)(this.stationId, "Visibility_m", fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
            if (err) {
                // alert('Error getting data: ' + err);
                console.warn('Error getting data (CloudChart - visibility)', err);
                this.chart.showLoading('Error getting data' + (typeof err == 'string' ? `: ${err}` : ''));
                return;
            }
            anyData = anyData || data.Data !== null;
            let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Id);
            if (data.Data !== null) {
                /*data.Data = data.Data.map(x => {
                    if (Array.isArray(x) && x.length == 2) {
                        return [ x[0], MainSite.getUnitConverter().convert(x[1], ParameterGroupInfoSet.Visibility_m.Units, ParameterGroupInfoSet.Visibility_m) ];
                    }

                    return x;
                });
                */ if (unitsConversionSet) data.Data = data.Data.map((x)=>{
                    if (Array.isArray(x) && x.length == 2) return [
                        x[0],
                        unitsConversionSet.convertValue(x[1])
                    ];
                    return x;
                });
                data.Data.unshift([
                    fromMoment.valueOf(),
                    null
                ]);
                data.Data.push([
                    toMoment.valueOf(),
                    null
                ]);
            }
            seriesOptions.push({
                id: (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Id,
                name: `Visiblity (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m.Id)})`,
                data: data.Data,
                lineWidth: 3,
                marker: {
                    enabled: false
                },
                yAxis: 1,
                color: '#FF0000',
                tooltip: {
                    valueDecimals: unitsConversionSet && unitsConversionSet.convertedUnits == 'mi' ? 3 : 0
                }
            });
            if (seriesOptions.length == 4) {
                if (anyData) this.replaceChartSeries(seriesOptions);
                else this.chart.showLoading('Data not available');
            }
        });
    }
    replaceChartSeries(seriesOptions) {
        this.chart.hideLoading();
        if (this.chart.series.length < 1) seriesOptions.forEach((series)=>{
            this.chart.addSeries(series);
        });
        else seriesOptions.forEach((series)=>{
            var cs = this.chart.get(series.id);
            cs.setData(series.data);
        });
        this.chart.reflow();
    }
}



class $f6f4484e30910318$export$517de9992f3047ca {
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'clouds';
        this.label = 'Clouds';
    }
    notifyResize() {}
    show(station) {
        let sensorCount = 0;
        for(let sensorId in station.Sensors){
            sensorCount++;
            const sensor = station.Sensors[sensorId];
            for(let paramId in sensor.Parameters){
                if (paramId.indexOf('Cloud') != -1) return true;
            }
        }
        return false;
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '47em').css('width', '16em').css('left', '48em').appendTo(page);
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', '47em').css('left', '0em').css('width', '46em').appendTo(page);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudBaseHeight_ft_Inst), 0, 0, 14, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudBaseHeight_ft_Inst), 15, 0, 14, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft_Inst), 30, 0, 14, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m), 45, 0, 13, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $49efe750b1982432$export$8ba89689dcbc989e)(), 59, 0, 13, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).RainfallIntensity_mmphour), 73, 0, 13, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).SolarRadiation_mWpcm2), 87, 0, 13, 100, this.ctx));
        var cloudContainer = $('<div></div>').css('position', 'absolute').css('height', '45%').css('top', '55%').css('width', '100%').appendTo(rightPanel);
        listeners.push(new (0, $607187fbef2f1b3a$export$6a6a284d6db23627)(this.mainSite, this, rightPanel, 0, 0, 54, 100));
        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 3</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 44%;">Layer 2</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 72%;">Layer 1</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $(`<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft.Id)})</div>`).appendTo(cloudContainer);
        var cloudDataContainer = $('<div></div').css('position', 'absolute').css('top', '16%').css('left', '24%').css('height', '84%').css('width', '76%').appendTo(cloudContainer);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudCover), 0, 0, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudCover), 33, 0, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover), 66, 0, 34, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudBaseHeight_ft), 0, 50, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudBaseHeight_ft), 33, 50, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft), 66, 50, 34, 50, this.ctx, false));
        page.appendTo(container);
    }
}












class $8bcb687a2d05d369$export$739b93f773f2f77b {
    /**
     * Create an instance of a MiniChart, initially intended for use within SiteObservation pages
     * @param mainSite The instance of the mainSite
     * @param page The instance of the parent page
     * @param title A title, shown in loading messages or errors/warnings.
     * @param dataSets The sets of data to retrieve from latest LiveDataSet and also getHistoricData().
     * @param $container The target container
     * @param top
     * @param left
     * @param height
     * @param width
     */ constructor(mainSite, page, title, $container, dataSets, yAxisOptions){
        this.mainSite = mainSite;
        this.page = page;
        this.title = title;
        this.$container = $container;
        this.dataSets = dataSets;
        this.yAxisOptions = yAxisOptions;
        this.errors = [];
        this.rangeDays = 3;
        this.possibleRangeDays = [
            3,
            5,
            7
        ];
        this.timeZoneString = this.mainSite.getTimeZoneString();
        this.$container.empty();
        this.$wrapper = $('<div class="minichart-wrapper" style="position: relative; width: 100%; height: 100%; z-index: 100; display: flex; flex-direction: column;">').appendTo(this.$container);
        //this.$wrapper.css({ border: '1px dotted blue' });
        this.$wrapper.data('minichart', this);
        this.$toolbar = $(`<div class="minichart-toolbar" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;">`).appendTo(this.$wrapper);
        this.$loading = $(`<div class="text-muted"><i class="fa fa-fw fa-refresh fa-spin"></i> <em>${this.title} loading...</em></div>`).appendTo($('<div>').appendTo(this.$toolbar)); //: NB: wrapped in div to ensure flex works.
        let $btnBar = $(`<div class="btn-group btn-group-sm">`).appendTo(this.$toolbar);
        this.possibleRangeDays.forEach((days)=>{
            let $btn = $(`<button type="button" class="btn btn-default minichart-setdays" data-days="${days}">${days} days</button>`).appendTo($btnBar);
            if (days == this.rangeDays) $btn.addClass('active');
            $btn.on('click', (e)=>{
                e.preventDefault();
                this.setRangeDays(days);
                //: syn any other visible chart:
                let $others = $(`.minichart-wrapper:visible`).not($btn.closest('.minichart-wrapper'));
                if ($others.length > 0) $others.each((i, el)=>{
                    let _mc = $(el).data('minichart');
                    _mc.setRangeDays(days);
                });
            });
        });
        this.$chartContainer = $(`<div class="minichart-chart-container" style="flex-grow: 1;">`).appendTo(this.$wrapper); //  background-color: rgba(0,0,255,0.05);
        this.$chartContainer.highcharts({
            chart: {
                type: 'line',
                backgroundColor: '#FFF',
                marginTop: 30,
                zoomType: 'x'
            },
            exporting: {
                enabled: true
            },
            title: {
                text: '',
                align: 'left'
            },
            xAxis: {
                type: 'datetime',
                ordinal: false,
                lineWidth: 0,
                lineColor: '#666'
            },
            yAxis: this.yAxisOptions,
            legend: {
                enabled: true
            },
            plotOptions: {
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    },
                    showInNavigator: true
                },
                line: {
                    dataGrouping: {
                        approximation: "high"
                    }
                }
            },
            rangeSelector: {
                enabled: false,
                selected: 1
            },
            scrollbar: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + this.timeZoneString,
                valueDecimals: 1
            }
        });
        this.chart = this.$chartContainer.highcharts();
        this.loadingShow('Awaiting data...');
        this.updateChart((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData);
    }
    setRangeDays(days) {
        if (this.possibleRangeDays.indexOf(days) < 0) return;
        this.rangeDays = days;
        this.$toolbar.find('.btn.minichart-setdays.active').removeClass('active');
        this.$toolbar.find(`.btn.minichart-setdays[data-days="${days}"]`).addClass('active');
        this.updateChart((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData);
    }
    liveDataChanged(latestData) {
        this.updateChart(latestData);
    }
    loadingShow(message = 'Getting data...') {
        this.chart.showLoading(message);
        this.$loading.show();
    }
    loadingHide() {
        this.chart.hideLoading();
        this.$loading.hide();
    }
    replaceChartSeries(seriesOptions) {
        // console.info(`MiniChart.replaceChartSeries..`, { seriesOptions: seriesOptions, chartSeries: $.extend(true, {}, this.chart.series) }); // , chartSeries: $.extend(true, {}, this.chart.series)
        // this.chart.hideLoading();
        if (this.chart.series.length < 1) for(var sensorId in seriesOptions)seriesOptions[sensorId].forEach((series)=>{
            this.chart.addSeries(series);
        });
        else for(var sensorId in seriesOptions)seriesOptions[sensorId].forEach((series)=>{
            var cs = this.chart.get(series.id);
            cs.setData(series.data);
        });
        this.loadingHide();
        this.chart.reflow();
    }
    updateChart(latestData) {
        if (!latestData) // console.info(`MiniChart.updateChart... IGNORING AS NO LATEST DATA. `, { latestData: latestData });
        return;
        this.loadingShow();
        this.errors = [];
        let seriesOptions = {};
        let toMoment = moment.utc();
        let fromMoment = moment.utc().subtract(this.rangeDays, 'd');
        let anyData = false;
        /*for (let i = 0; i <= this.dataSets.length - 1; i++) {
            let ds: MiniChartDataSet = this.dataSets[i];
            console.info('debug', { i: i, ds: ds });
        }*/ //: a bit ugly, but using an interval to ensure we have received data..
        let countReceivedDataResponses = 0;
        let countReceivedDataResponsesWithData = 0;
        let interval = setInterval(()=>{
            if (countReceivedDataResponses == this.dataSets.length) {
                clearInterval(interval);
                interval = null;
                this.replaceChartSeries(seriesOptions);
                if (countReceivedDataResponsesWithData == 0) this.chart.showLoading('Data not available');
            }
        }, 250);
        for(let i = 0; i <= this.dataSets.length - 1; i++){
            let ds = this.dataSets[i];
            let _label = `${ds.sensorId}.${ds.parameterId}` + (ds.variant ? `.${ds.variant}` : '');
            // getHistoricData('P', 'GOM_Vito', 'AWOS', 'WindSpeed_kts', null, moment.utc().subtract(3, 'd').valueOf(), moment.utc().valueOf(), () => { }, 0)
            // getHistoricData('P', 'GOM_Vito', 'AWOS', 'WindDirection_deg', null, moment.utc().subtract(3, 'd').valueOf(), moment.utc().valueOf(), () => { }, 0)
            // console.info(`MiniChart.updateChart... GETTING DATA: `, {  ds: ds, i: i, label: _label, range: [fromMoment.valueOf(), toMoment.valueOf()] });
            (0, $fd959835eca46177$export$9bf04fc316538454)('P', ds.stationId, ds.sensorId, ds.parameterId, ds.variant ?? null, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                countReceivedDataResponses++; //: here so even if response error..
                // console.info(`MiniChart.updateChart... DATA RESPONSE: `, { ds: ds, i: i, label: _label, range: [fromMoment.valueOf(), toMoment.valueOf()], err: err, data: data });
                if (err) {
                    // alert('Error getting data: ' + err);
                    this.errors.push(`Error getting data for "${_label}"!`);
                    console.error(`MiniChart.updateChart - Error getting data for "${_label}"!`, {
                        err: err,
                        i: i,
                        ds: ds,
                        range: [
                            fromMoment.valueOf(),
                            toMoment.valueOf()
                        ]
                    });
                    return;
                }
                anyData = anyData || data.Data !== null;
                if (Array.isArray(data.Data) && data.Data.length > 0) countReceivedDataResponsesWithData++;
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(ds.units, ds.parameterId);
                if (unitsConversionSet) {
                    data.Data = data.Data.map((x)=>{
                        if (Array.isArray(x) && x.length == 2) return [
                            x[0],
                            unitsConversionSet.convertValue(x[1])
                        ];
                        return x;
                    });
                    if (ds.units !== unitsConversionSet.convertedUnits) _label += ` (${unitsConversionSet.convertedUnits})`;
                }
                if (data.Data !== null) {
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                seriesOptions[ds.sensorId] = seriesOptions[ds.sensorId] || [];
                let _seriesOptions = {
                    id: ds.parameterId,
                    name: _label,
                    data: data.Data,
                    yAxis: ds.yAxisIndex
                };
                if (ds.plotLine) {
                    _seriesOptions.marker = {
                        enabled: false
                    };
                    _seriesOptions.lineWidth = 1;
                } else {
                    _seriesOptions.marker = {
                        enabled: true,
                        radius: 2
                    };
                    _seriesOptions.lineWidth = 0;
                }
                seriesOptions[ds.sensorId].push(_seriesOptions);
            }, 0);
        }
    }
}





class $cfc778b093ef38e6$export$c2a25abbb6f13dfd {
    notifyResize() {}
    show(station) {
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
        const allCurrents = Object.keys(station.Sensors).every((x)=>x.indexOf("GCOOS") !== -1 || x.indexOf("Current") !== -1 || x.indexOf("ADCP") !== -1 || x.indexOf("Forecast") !== -1);
        if (allCurrents) return false;
        return station.Station.Region == 'GOM';
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'gomdashboard';
        this.label = 'Dashboard';
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
    }
    getStationSchema() {
        return this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id];
    }
    stationHasSensor(sensorId) {
        return sensorId in this.getStationSchema().Sensors;
    }
    stationHasParameter(sensorId, paramId) {
        return sensorId in this.getStationSchema().Sensors && paramId in this.getStationSchema().Sensors[sensorId].Parameters;
    }
    stationGetFirstAvailableParam(sensorId, params, searchSlashesReplaced = true, returnFirstRequestedAsDefault = true) {
        //: example on GOM_Vito: Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[3].pages[1].stationGetFirstAvailableParam('WM1', ['Hs_m', 'HsT/m', 'Hs/m_30min', 'HsT/m_30min'])
        if (params.length == 0) {
            console.warn('Unable to get first available param as list os params to search provided is empty!');
            return null;
        }
        let out = null;
        if (this.stationHasSensor(sensorId)) {
            let paramsAvailable = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort();
            let paramsAvailableReplaced = paramsAvailable.map((x)=>x.replace(/\//g, '_'));
            for(let i = 0; i <= params.length; i++){
                let _param = params[i];
                if (out == null && paramsAvailable.indexOf(_param) >= 0) return _param;
                if (out == null && searchSlashesReplaced && paramsAvailableReplaced.indexOf(_param) >= 0) return paramsAvailable[paramsAvailableReplaced.indexOf(_param)];
            }
        }
        if (out == null && returnFirstRequestedAsDefault) return params[0];
        return out;
    }
    /**
     * Get the parameter from schema, having checked for keys with their slashes replaced by underscores (as ParameterGroupInfo usually uses all underscores!).
     * @param sensorId
     * @param paramId
     * @param nullOnNotFound
     */ stationGetParameterId(sensorId, paramId, nullOnNotFound = false) {
        //: example on GOM_Vito: Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[3].pages[1].stationGetParameterId('AWOS', 'WindDirection_deg')
        //: Object.keys(Icon.Midi.WebApplication.FrontEnd.MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations['GOM_Vito'].Sensors['AWOS'].Parameters).sort().map(x => x.replace(/\//g, '_')).indexOf('WindDirection_deg');
        if (!this.stationHasParameter(sensorId, paramId) && this.stationHasSensor(sensorId)) {
            let params = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort();
            let paramsReplaced = params.map((x)=>x.replace(/\//g, '_'));
            if (paramsReplaced.indexOf(paramId) >= 0) return params[paramsReplaced.indexOf(paramId)];
        }
        if (!this.stationHasParameter(sensorId, paramId) && nullOnNotFound) return null;
        return paramId;
    }
    getSensorLowestBinParam(sensorId, paramIdPrefix) {
        if (this.stationHasSensor(sensorId)) {
            let params = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort().filter((x)=>x.substring(0, paramIdPrefix.length) == paramIdPrefix);
            // console.info('getSensorLowestBinParam', sensorId, paramIdPrefix, params);
            // Object.keys(Icon.Midi.WebApplication.FrontEnd.MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations['GOM_Vito'].Sensors['LiDAR'].Parameters).sort().filter(x => x.substring(0, 'WindDirection_Bin'.length) == 'WindDirection_Bin');
            if (params.length >= 1) return params[0];
        }
        return null;
    }
    getParamDefs(sensorId, paramId) {
        let defs = null;
        if (this.stationHasParameter(sensorId, paramId)) defs = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id].Sensors[sensorId].Parameters[paramId].Variants[0].ParameterDefinition;
        if ((!defs || defs.Default) && paramId in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) defs = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[paramId];
        return defs;
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        /*
            * Quick and dirty fix to detect if current speed is shown as kts rather than mps.
            * It would be much better to allow the DefaultGroupFormatter to choose the group from
            * multiple options based on what is available.
            */ let currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps;
        let hasHorizontal = false;
        for(const sensorId in station.Sensors){
            const sensor = station.Sensors[sensorId];
            /*if (Object.keys(sensor.Parameters).some(pid => pid == "CurrentProfile") && !this.currentProfileParam) {
                this.currentProfileSensor = sensorId;
                this.currentProfileParam = "CurrentProfile";
                // break;
            }*/ if (Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile/kts")) currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).kts;
            if (Object.keys(sensor.Parameters).some((pid)=>pid.indexOf("HorizontalCurrentProfile") === 0)) hasHorizontal = true;
        }
        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? 'm/s' : 'kts';
        var unitsStrDepthOrHeight = 'm';
        let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet('m');
        let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight = (value)=>value;
        let ucf_Speed = (value)=>value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        let panelsHeightEm = 47;
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', `${panelsHeightEm}em`).css('width', '12em').appendTo(page);
        var centrePanel = $('<div></div>').css('position', 'absolute').css('height', `${panelsHeightEm}em`).css('left', '13em').css('width', '25em') // 12 + 1 + 12
        .appendTo(page);
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', `${panelsHeightEm}em`).css('left', '39em').css('width', '25em').appendTo(page);
        //: common value box settings:
        let vbHeight = 13;
        let vbSepVertical = 1;
        let vbFontSizeEm = 1.8;
        let vbFontSizeTitle = 0.75;
        let colCurrentTop = 0;
        //: left panel:
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        //: center panel:
        colCurrentTop = 0;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).RelativeHumidity_pc), colCurrentTop, 0, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar), colCurrentTop, 51, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        //: determine which sensors/params to use:
        let getPairFromSchema = (sensorId, parameterId, ...params)=>{
            for(let i = 0; i + 1 < params.length; i += 2){
                const defaultSensorId = params[i];
                const defaultParamId = params[i + 1];
                /// this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id].Sensors
                if (!this.stationHasParameter(sensorId, parameterId) && defaultSensorId && defaultParamId && this.stationHasParameter(defaultSensorId, defaultParamId)) return {
                    sensor: defaultSensorId,
                    param: defaultParamId
                };
            }
            //: always return something (so here the main element requested even if not necessarily available, seen as the default is nto available):
            return {
                sensor: sensorId,
                param: parameterId
            };
        };
        let miniChartsSensors = {
            windSpd: getPairFromSchema('AWOS', this.stationGetParameterId('AWOS', (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts.Id), 'Wind 1', "WindSpeed/kts_8min_Mean", 'LiDAR', this.getSensorLowestBinParam('LiDAR', 'WindSpeed_Bin')),
            windDir: getPairFromSchema('AWOS', this.stationGetParameterId('AWOS', (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg.Id), 'Wind 1', "WindDirection/deg_8min_Mean", 'LiDAR', this.getSensorLowestBinParam('LiDAR', 'WindDirection_Bin')),
            gustSpd: getPairFromSchema('AWOS', this.stationGetParameterId('AWOS', (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts.Id), 'Wind 1', "GustSpeed/kts_8min"),
            waveHs: getPairFromSchema('WM1', this.stationGetFirstAvailableParam('WM1', [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m.Id,
                'HsT/m',
                'Hs/m_30min',
                'HsT/m_30min'
            ]), 'Wave', 'Hs/m_20min'),
            waveHmax: getPairFromSchema('WM1', this.stationGetFirstAvailableParam('WM1', [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m.Id,
                'HmaxT/m',
                'Hmax/m_30min',
                'HmaxT/m_30min'
            ])),
            waveTp: getPairFromSchema('WM1', this.stationGetFirstAvailableParam('WM1', [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s.Id,
                'Tp/s_30min'
            ]), 'Wave', 'Tp/s_20min')
        };
        // console.info('ShellSiteObs Page - miniChartsSensors:', miniChartsSensors);
        let $containerChartWind = $('<div>').css({
            position: 'absolute',
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${3 * vbHeight + 2 * vbSepVertical}%`,
            width: '100%'
        }).appendTo(centrePanel);
        $containerChartWind.append('<em class="text-muted">Wind chart loading...</em>');
        $containerChartWind.css({
            fontSize: '0.85em'
        }); //: , border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)'
        let minichartDataWind = [
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.windSpd.sensor,
                parameterId: miniChartsSensors.windSpd.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.windSpd.sensor, miniChartsSensors.windSpd.param),
                units: 'kts',
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.windDir.sensor,
                parameterId: miniChartsSensors.windDir.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.windDir.sensor, miniChartsSensors.windDir.param),
                units: 'deg',
                plotLine: false,
                yAxisIndex: 1
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.gustSpd.sensor,
                parameterId: miniChartsSensors.gustSpd.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.gustSpd.sensor, miniChartsSensors.gustSpd.param),
                units: 'kts',
                plotLine: true,
                yAxisIndex: 0
            }
        ];
        let yAxisOptionsWind = [
            {
                title: {
                    text: 'Speed (kts)'
                },
                opposite: false
            },
            {
                title: {
                    text: "Direction (\xb0T)"
                },
                min: 0,
                max: 360,
                opposite: true
            }
        ];
        let minichartWind = new (0, $8bcb687a2d05d369$export$739b93f773f2f77b)(this.mainSite, this, 'Wind Chart', $containerChartWind, minichartDataWind, yAxisOptionsWind);
        listeners.push(minichartWind);
        colCurrentTop += 3 * vbHeight + 2 * vbSepVertical + vbSepVertical;
        let $containerChartWave = $('<div>').css({
            position: 'absolute',
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${3 * vbHeight + 2 * vbSepVertical}%`,
            width: '100%'
        }).appendTo(centrePanel);
        $containerChartWave.append('<em class="text-muted">Wave chart loading...</em>');
        $containerChartWave.css({
            fontSize: '0.85em'
        }); //: , border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)'
        let minichartDataWave = [
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveHs.sensor,
                parameterId: miniChartsSensors.waveHs.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveHs.sensor, miniChartsSensors.waveHs.param),
                units: 'm',
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveHmax.sensor,
                parameterId: miniChartsSensors.waveHmax.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveHmax.sensor, miniChartsSensors.waveHmax.param),
                units: 'm',
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveTp.sensor,
                parameterId: miniChartsSensors.waveTp.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveTp.sensor, miniChartsSensors.waveTp.param),
                units: 's',
                plotLine: false,
                yAxisIndex: 1
            }
        ];
        let yAxisOptionsWave = [
            {
                title: {
                    text: `Wave Height (${unitsStrDepthOrHeight})`
                }
            },
            {
                title: {
                    text: 'Wave Period (s)'
                },
                opposite: true
            }
        ];
        let minichartWave = new (0, $8bcb687a2d05d369$export$739b93f773f2f77b)(this.mainSite, this, 'Wave Chart', $containerChartWave, minichartDataWave, yAxisOptionsWave);
        listeners.push(minichartWave);
        //: right panel:
        colCurrentTop = 0;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean), colCurrentTop, 0, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean), colCurrentTop, 51, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        let $containerChartProfiles = $('<div>').css({
            position: 'absolute',
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${100 - colCurrentTop}%`,
            width: '100%'
        }).appendTo(rightPanel);
        // $containerChartProfiles.css({ border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)' });
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo($containerChartProfiles);
        chartSelectTabs.css({
            fontSize: '0.85em'
        });
        let currentBox = $('<div class="site-obs-current-charts" data-chart-type="vertical"></div>').appendTo($containerChartProfiles).hide();
        let currentBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="horizontal"></div>').appendTo($containerChartProfiles).hide();
        let pvdBox = $('<div class="site-obs-current-charts" data-chart-type="pvd"></div>').appendTo($containerChartProfiles).hide();
        let polarBox = $('<div class="site-obs-current-charts" data-chart-type="polar"></div>').appendTo($containerChartProfiles).hide();
        let hovmollerBox = $('<div class="site-obs-current-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo($containerChartProfiles).hide();
        let hovmollerBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="hovmoller-horizontal"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo($containerChartProfiles).hide();
        let showChart = (chartType, label)=>{
            $containerChartProfiles.find('.site-obs-current-charts').hide();
            $containerChartProfiles.find(`.site-obs-current-charts[data-chart-type="${chartType}"]`).show();
            $containerChartProfiles.find('.site-obs-current-chart-select-label').text(label);
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        chartSelectTabs.append('<span>Chart: </span>');
        let $buttonGroup = $('<div class="btn-group btn-group-sm"></div>').appendTo(chartSelectTabs);
        $('<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><span class="site-obs-current-chart-select-label">Select chart..</span> <span class="caret"></span></button>').appendTo($buttonGroup);
        let tpul = $('<ul></ul>').addClass('dropdown-menu')// .append($('<span></span>').text("Chart: "))
        .appendTo($buttonGroup);
        this._dpc = new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 5, 0, 93, 100, currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean.Id, true);
        listeners.push(this._dpc);
        this._pvd = new (0, $afcc295e055250f2$export$269e444807daccc9)(this.mainSite, this, pvdBox, 5, 0, 93, 100, currentSpeedUnits);
        listeners.push(this._pvd);
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBox, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $9616a178b649c555$export$861facf577d6ed7a).Depth));
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBoxHorizontal, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $9616a178b649c555$export$861facf577d6ed7a).Horizontal));
        let hovmolOptions = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptions.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptions.yAxis = {
            ...hovmolOptions.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    '#0000FF'
                ],
                [
                    0.33,
                    '#00FFFF'
                ],
                [
                    0.66,
                    '#FFFF00'
                ],
                [
                    1,
                    '#FF0000'
                ] // Red
            ]
        };
        // Direction: Options specific to direction chart
        let hovmolOptionsDirection = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [
                    0.0,
                    'rgb(255, 0, 0)'
                ],
                [
                    0.25,
                    'rgb(160, 32, 240)'
                ],
                [
                    0.5,
                    'rgb(0, 0, 255)'
                ],
                [
                    0.75,
                    'rgb(252, 186, 3)'
                ],
                [
                    1.0,
                    'rgb(255, 0, 0)'
                ]
            ],
            //tickInterval: 180,
            tickPositions: [
                0,
                90,
                180,
                270,
                360
            ],
            startOnTick: true,
            endOnTick: true
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBox, 0, 0, 93, 100, //// specific chart options
        hovmolOptionsSpeed, hovmolOptionsDirection, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                console.warn('Current Hovmoller (Vertical) chart: no current profile sensor or param detected for this station.');
                callback([], false);
                return;
            }
            let sensor = this.currentProfileSensor;
            let parameter = this.currentProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info('Current Hovmoller (Vertical) - data fetch URI:', uri);
            $.ajax(uri + '', {
                cache: false,
                dataType: 'json',
                type: 'GET',
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let profile = JSON.parse(x[1]);
                                    let components = profile.Components.sort((a, b)=>b.Depth - a.Depth); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.Speed || isNaN(cp.Speed)) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: ucf_DepthOrHeight(cp.Depth),
                                            val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
        (latestData, chart)=>{
            if (this.currentProfileParam !== null) {
                chart.updateChart();
                return; //: already dealt with.
            }
            let liveDataSetValue = null;
            if (latestData.Stations[this.station.Station.Id]) {
                if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "CurrentProfile")) {
                    liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["CurrentProfile"][0];
                    this.currentProfileSensor = liveDataSetValue.Sensor;
                    this.currentProfileParam = "CurrentProfile";
                }
            }
            chart.updateChart();
        });
        listeners.push(this._chartsHovmoller);
        if (hasHorizontal) {
            let hovmolOptionsSpeedHorizontal = {
                ...hovmolOptionsSpeed
            };
            hovmolOptionsSpeedHorizontal.yAxis = {
                ...hovmolOptionsSpeedHorizontal.yAxis,
                title: {
                    text: `Distance (${unitsStrDepthOrHeight})`
                },
                reversed: true
            };
            this._chartsHovmollerHorizontal = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBoxHorizontal, 0, 0, 93, 100, //// specific chart options
            hovmolOptionsSpeedHorizontal, hovmolOptionsDirection, //// getDataMethod
            (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
                let res = [];
                /*if (!this.mainSite.liveDataManager.latestData) {
                        console.warn('Current Hovmoller chart: waiting for live data..');
                        callback([], true);
                        return;
                    }*/ if (chart.latestData == null) {
                    console.warn('Current Hovmoller (Horizontal) chart: waiting for first live data.');
                    callback([], false, 'Awaiting first Live Data...');
                    return;
                }
                if (this.currentProfileHorizontalSensor == null || this.currentProfileHorizontalParam == null) {
                    console.warn('Current Hovmoller (Horizontal) chart: no current profile sensor or param detected for this station.');
                    callback([], false);
                    return;
                }
                let sensor = this.currentProfileHorizontalSensor;
                let parameter = this.currentProfileHorizontalParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info('Current Hovmoller (Horizontal) - data fetch URI:', uri);
                $.ajax(uri + '', {
                    cache: false,
                    dataType: 'json',
                    type: 'GET',
                    timeout: 30000,
                    success: (data, text, jqXHR)=>{
                        try {
                            if (Array.isArray(data.results[0].series[0].values)) {
                                for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                    let x = data.results[0].series[0].values[i];
                                    let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let profile = JSON.parse(x[1]);
                                        let components = profile.Components.sort((a, b)=>b.Distance ?? b.Depth - a.Distance ?? a.Depth);
                                        components.forEach((cp, cpi)=>{
                                            if (!cp.Speed || isNaN(cp.Speed)) return;
                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: ucf_DepthOrHeight(cp.Distance ?? cp.Depth),
                                                val: ucf_Speed(cp.Speed)
                                            });
                                        });
                                    } else console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                }
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown)=>{
                        console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
            (latestData, chart)=>{
                if (this.currentProfileHorizontalParam !== null) return; //: already dealt with.
                let liveDataSetValue = null;
                if (latestData.Stations[this.station.Station.Id]) {
                    if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "HorizontalCurrentProfile")) {
                        liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["HorizontalCurrentProfile"][0];
                        this.currentProfileHorizontalSensor = liveDataSetValue.Sensor;
                        this.currentProfileHorizontalParam = "HorizontalCurrentProfile";
                    }
                }
                chart.updateChart();
            });
            listeners.push(this._chartsHovmollerHorizontal);
        }
        let tpulLiActiveClass = 'active'; //: 'selected' prior to using drop-down
        let charts = [
            {
                key: 'vertical',
                label: 'Vertical Profile'
            },
            // { key: 'horizontal', label: 'Horizontal Profile' },
            {
                key: 'pvd',
                label: 'PVD'
            },
            {
                key: 'polar',
                label: 'Polar'
            },
            {
                key: 'hovmoller',
                label: hasHorizontal ? 'Color Flood (Vertical)' : 'Color Flood'
            }
        ];
        if (hasHorizontal) charts = [
            {
                key: 'vertical',
                label: 'Vertical Profile'
            },
            {
                key: 'horizontal',
                label: 'Horizontal Profile'
            },
            {
                key: 'pvd',
                label: 'PVD'
            },
            {
                key: 'polar',
                label: 'Polar'
            },
            {
                key: 'hovmoller',
                label: hasHorizontal ? 'Color Flood (Vertical)' : 'Color Flood'
            }
        ];
        for(var i = 0; i < charts.length; i++){
            let chart = charts[i];
            let $li = $(`<li class="dropdown-menu-item"></li>`);
            let $a = $(`<a href="">${chart.label}</a>`).appendTo($li);
            $a.on('click', (ev)=>{
                ev.preventDefault();
                tpul.children('li').removeClass(tpulLiActiveClass);
                $li.addClass(tpulLiActiveClass);
                showChart(chart.key, chart.label);
            });
            tpul.append($li);
        }
        // currentBox.show();
        setTimeout(()=>{
            tpul.children('li').first().find('a').trigger('click');
        }, 500);
        page.appendTo(container);
        //page resizes due to highcharts charts being drawn before the box size is fixed and 
        //the chart subsequently not filling the available space
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
    }
}





class $c8ad0c2f85751db1$export$ab7b018719e111db {
    notifyResize() {}
    show(station) {
        let sensorCount = 0;
        for(let sensorId in station.Sensors){
            sensorCount++;
            const sensor = station.Sensors[sensorId];
            for(let paramId in sensor.Parameters){
                if (paramId.indexOf('Motion') != -1) return true;
            }
        }
        return false;
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'motion';
        this.label = 'Motion';
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('width', '20em').appendTo(page);
        var centrePanel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('left', '21em').css('width', '20em').appendTo(page);
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('left', '42em').css('width', '20em').appendTo(page);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Roll_Left_deg_Max), 0, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Roll_Right_deg_Max), 0, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Excursion_Distance_m_Max), 0, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).PitchBowUp_deg_Max), 25, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).PitchBowDown_deg_Max), 25, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Excursion_Bearing_deg), 25, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Heave_Rate_mps_Max), 50, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Heave_m_Max), 50, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Heave_Period_s_Mean), 50, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MMS), 75, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MSI), 75, 0, 24, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Inclination_deg_Max), 75, 0, 24, 100, this.ctx));
        page.appendTo(container);
    }
}








class $ea259be164fdbb12$export$bee37f76ad555f11 {
    constructor(helideck){
        this.helideck = helideck;
    }
    getShortName() {
        return this.helideck.Label;
    }
    getUnits() {
        return null;
    }
    getParameterGroupInfo() {
        return (0, $24b391ec3014929b$export$5d65fdcfff509e37).Helideck_Status;
    }
    getDescription() {
        return "Helideck status based on station-specific wind speed and direction rules.";
    }
    getId() {
        return null;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return true;
    }
    axisMin() {
        return null;
    }
    axisMax() {
        return null;
    }
    plotLines() {
        return true;
    }
    format(liveDataSetStation) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        };
        console.log(liveDataSetStation.GroupValues);
        if ((0, $24b391ec3014929b$export$5d65fdcfff509e37).Helideck_Status.Id in liveDataSetStation.GroupValues) {
            const values = liveDataSetStation.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).Helideck_Status.Id].filter((x)=>x.Sensor == this.helideck.Label);
            if (values.length != 1) return valueObject;
            var status = values[0];
            var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[status.Sensor].Parameters[status.Parameter].Variants[0].ParameterDefinition;
            if ((!paramDef || paramDef.Default) && status.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[status.Parameter];
            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: status.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: status.Timestamp,
                Sensor: status.Sensor
            };
            if (typeof status.Value == 'number' && (status.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || status.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) switch(status.Value){
                case 1:
                    valueObject.Value = "Open";
                    valueObject.WarningThreshold = (0, $3f0b9745f7124153$export$23811558a05557).OK;
                    break;
                case 2:
                    valueObject.Value = "Closed";
                    valueObject.WarningThreshold = (0, $3f0b9745f7124153$export$23811558a05557).Level3;
                    break;
                default:
                    valueObject.Value = "Unknown";
                    valueObject.WarningThreshold = (0, $3f0b9745f7124153$export$23811558a05557).Level1;
            }
        }
        return valueObject;
    }
}






class $788b86d465428156$export$b1844fa5f8667441 {
    constructor(parameterGroup, sensorId = null){
        this.parameterGroup = parameterGroup;
        this.sensorId = sensorId;
    }
    getShortName() {
        return this.parameterGroup.ShortName;
    }
    getUnits() {
        return this.parameterGroup.Units;
    }
    getParameterGroupInfo() {
        return this.parameterGroup;
    }
    getDescription() {
        return this.parameterGroup.Description;
    }
    getId() {
        return this.parameterGroup.Id;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return false;
    }
    axisMin() {
        return null;
    }
    axisMax() {
        return null;
    }
    plotLines() {
        return false;
    }
    getLiveDataSetValue(liveDataSetStation) {
        var value = null;
        if (liveDataSetStation.GroupValues && this.parameterGroup.Id in liveDataSetStation.GroupValues) {
            if (this.sensorId) {
                if (!liveDataSetStation.GroupValues[this.parameterGroup.Id].some((_value)=>{
                    if (_value.Sensor == this.sensorId) {
                        value = _value;
                        return true;
                    }
                    return false;
                })) // a sensor id has been specified, but the group value is not present for this sensor
                return null;
            } else value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
        }
        return value;
    }
    format(liveDataSetStation, warningRules) {
        // green = 0, red = 1, amber = 2, grey (default)
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        };
        const value = this.getLiveDataSetValue(liveDataSetStation);
        if (value == null) return valueObject;
        var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[value.Sensor].Parameters[value.Parameter].Variants[0].ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[value.Parameter];
        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        };
        if (value.ExpiryStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        if (value.Value === null || value.Value === 'NIL') // can be the case for cloud heights, etc
        valueObject.Value = '';
        else if (typeof value.Value == 'number' && this.parameterGroup.Format) {
            valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);
            if (warningRules) valueObject.WarningThreshold = (0, $8ed788ecc5d8a807$export$ba9136f38d1702aa)(warningRules, value.Value, this.parameterGroup, liveDataSetStation);
        } else valueObject.Value = value.Value.toString();
        return valueObject;
    }
}






class $251c350f64351c46$export$a488047d99dafc7d {
    constructor(){}
    getShortName() {
        return "Wind Var";
    }
    getUnits() {
        return null;
    }
    getParameterGroupInfo() {
        return (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Backed_deg;
    }
    getDescription() {
        return "Wind Variation in METAR coding format.";
    }
    getId() {
        return null;
    }
    getSensorId() {
        return undefined;
    }
    plottable() {
        return false;
    }
    axisMin() {
        return null;
    }
    axisMax() {
        return null;
    }
    plotLines() {
        return false;
    }
    format(liveDataSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Timestamp: null,
            Sensor: null
        };
        if ((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Backed_deg.Id in liveDataSetStation.GroupValues && (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Veered_deg.Id in liveDataSetStation.GroupValues) {
            var backed = liveDataSetStation.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Backed_deg.Id][0];
            var veered = liveDataSetStation.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Veered_deg.Id][0];
            var worstStatus = Math.max(backed.ExpiryStatus, veered.ExpiryStatus);
            var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id].Sensors[backed.Sensor].Parameters[backed.Parameter].Variants[0].ParameterDefinition;
            if ((!paramDef || paramDef.Default) && backed.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[backed.Parameter];
            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: worstStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: backed.Timestamp > veered.Timestamp ? backed.Timestamp : veered.Timestamp,
                Sensor: backed.Timestamp > veered.Timestamp ? backed.Sensor : veered.Sensor
            };
            if (typeof backed.Value == 'number' && typeof veered.Value == 'number' && (worstStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || worstStatus == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) valueObject.Value = sprintf('%03.0f', backed.Value) + 'V' + sprintf('%03.0f', veered.Value);
        }
        return valueObject;
    }
}








class $e617a3afc5270513$export$c00f7ef2bcd6885a extends (0, $bfbbca38eee2856d$export$3f0be2c6920005ae) {
    constructor(page, container, valueFormatter, ctx){
        super(page.mainSite), this.regexGreen = /^0/, this.regexRed = /^1/, this.regexAmber = /^2/, this.textGreen = "TEMPSC Available", this.textRed = "TEMPSC Not Available", this.textAmber = "TEMPSC Not Available", this.textGrey = "TEMPSC Status Unknown";
        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;
        this.wrap = $('<div></div>').addClass('midi_siteObsPage_LED_wrap').attr('title', "The TEMPSC LED shows red if: \n \u2022 wind speed (10-minute mean) is greater than 30 kts, and \n \u2022 wind direction (10-minute mean) is between 135 and 315 degrees (exclusive), and \n \u2022 maximum wave height is greater than 6 m.\n otherwise it shows green.").appendTo(container);
        this.led = $('<span>').addClass('midi_siteObsPage_LED').appendTo(this.wrap);
        this.text = $('<span>').addClass('midi_siteObsPage_LED_text').appendTo(this.wrap);
        if (page.mainSite.liveDataManager.latestData) this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
    }
    liveDataChanged(latestData, ctx) {
        var valueObject = this.valueFormatter.format(latestData.Stations[this.station.Id], this.warningGroup);
        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        // this.wrap.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')
        ctx.valueChanged(valueObject);
        const resRegexGreen = this.regexGreen.exec(valueObject.Value);
        const resRegexRed = this.regexRed.exec(valueObject.Value);
        const resRegexAmber = this.regexAmber.exec(valueObject.Value);
        if (resRegexGreen !== null && resRegexGreen.length > 0) {
            this.led.attr("data-colour", "green");
            this.text.text(this.textGreen);
        } else if (resRegexRed !== null && resRegexRed.length > 0) {
            this.led.attr("data-colour", "red");
            this.text.text(this.textRed);
        } else if (resRegexAmber !== null && resRegexAmber.length > 0) {
            this.led.attr("data-colour", "amber");
            this.text.text(this.textAmber);
        } else {
            this.led.attr("data-colour", "grey");
            this.text.text(this.textGrey);
        }
        if (valueObject.Status === null || valueObject.Status === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            // no valid data -> hide units and remove any colour coding
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.wrap.addClass('midi_siteObsPage_expiring');
            return;
        }
        if (valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) this.wrap.removeClass('midi_siteObsPage_expiring');
        else this.wrap.addClass('midi_siteObsPage_expiring');
        // by this point we will be showing some data
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}







class $230b365548c7ce86$export$8d94490d1ec4a850 {
    constructor(page, container, top, left, height, width, sensorId = null, is10m = false){
        this.is10m = is10m;
        this.compassLog = [];
        this.appliedCompassSectors = [];
        this.windSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts;
        this.gustSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts;
        this.windSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_1min;
        this.gustSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_1min;
        this.windSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10min;
        this.gustSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10min;
        this.stationId = page.station.Station.Id;
        this.page = page;
        this.container = container;
        this.sensorId = sensorId;
        if (this.is10m == true) {
            this.windSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m;
            this.gustSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m;
            this.windSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m_1min;
            this.gustSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m_1min;
            this.windSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m_10min;
            this.gustSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m_10min;
        }
        this.canvas = $('<div class="midi_SiteObservations_wind_compass_container"></div>').appendTo(this.container).css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        this.windCompassPaper = Raphael($('<div class="midi_SiteObservations_wind_compass"></div>').appendTo(this.canvas)[0], 50, 50); //arbitrary width and height just so it draws one first time. this will always be redrawn before we see it.
        this.canvasLabelsWrap = $('<div>').addClass("windcompass-sector-labels").prependTo(this.canvas);
        this.movingParts = this.windCompassPaper.set();
    // console.info("[WindCompass]", { _this: this, cont: container });
    }
    liveDataChanged(latestData) {
        this.redrawMovingParts(latestData);
        this.updateImageBitmapRotation(latestData);
    // console.info("[WindCompass] - liveDataChanged()...", { compassLog: this.compassLog });
    }
    drawCompassSectors(finalSensorId, origin) {
        this.compassLog = [
            "[WindCompass][sectors] - started (origin: " + origin + ", finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ")."
        ];
        let sectors = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].CompassSectors;
        if (sectors.length > 0) {
            this.canvasLabelsWrap.empty();
            this.appliedCompassSectors = [];
            this.compassLog.push("[WindCompass][sectors] - emptying labels wrap.");
            sectors.forEach((sector)=>{
                if (this.appliedCompassSectors.filter((x)=>x.Id === sector.Id).length > 0) {
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop ignored as we've already applied a compass sector with this GUID.");
                    return;
                }
                if (this.appliedCompassSectors.filter((x)=>x.StationId == sector.StationId && x.FromDegrees == sector.FromDegrees && x.ToDegrees == sector.ToDegrees && x.Label == sector.Label && x.Colour == sector.Colour).length > 0) {
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop ignored as we've already applied a compass sector with this matching parameters (except SensorId).");
                    return;
                }
                this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop started (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ").");
                //: does the sector apply here or not?
                let applySector = false;
                //: ORIGINAL labels condition:
                // (sector.SensorId !== null && sector.SensorId !== finalSensorId) || sector.Label == null
                //: ORIGINAL sector condition:
                // sector.SensorId !== null && sector.SensorId !== finalSensorId
                if (applySector === false && this.sensorId !== null && this.sensorId === sector.SensorId) {
                    applySector = true;
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (this<WindCompass>.sensorId === sector.SensorId).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                }
                if (applySector === false && finalSensorId !== null && finalSensorId === sector.SensorId) {
                    applySector = true;
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (finalSensorId === sector.SensorId).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                }
                if (applySector === false && sector.SensorId === null) {
                    if (this.appliedCompassSectors.filter((x)=>x.StationId == sector.StationId && x.FromDegrees == sector.FromDegrees && x.ToDegrees == sector.ToDegrees).length > 0) this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - APPLY IGNORED AS WE'VE ALREADY GOT THIS SECOTR (sector.SensorId is null - default apply to all sensors).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                    else {
                        applySector = true;
                        this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (sector.SensorId is null - default apply to all sensors).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                    }
                }
                //: check if this is a combined sensor:
                if (!applySector) try {
                    var sensor = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[finalSensorId];
                    if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.Combined) {
                        applySector = true;
                        this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (finalSensorId detected as a 'Combined Wind Sensor').  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                    }
                } catch (e) {
                    console.warn("Error while checking WindCompass for Combined Wind Sensor: ", e);
                }
                if (applySector === false) this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - DO NOT APPLY." + ` [sectorSensor: ${sector.SensorId}, finalSensorId: ${finalSensorId}, compassSensor: ${this.sensorId}]`);
                if (applySector === true) {
                    this.appliedCompassSectors.push(sector);
                    //: add labels:
                    if (sector.Label !== null && sector.Label.length > 0) {
                        let $lbl = $('<div>').addClass('windcompass-sector-label').attr("data-guid", sector.Id).html('' + sector.Label).css("fontSize", ".6em").appendTo(this.canvasLabelsWrap);
                        let $lblColour = $('<span>').addClass('windcompass-sector-label-colour').css({
                            "display": "inline-block",
                            "borderRadius": "100%",
                            "width": "8px",
                            "height": "8px",
                            "marginRight": "3px",
                            "backgroundColor": sector.Colour
                        }).prependTo($lbl);
                    }
                    //: add sectors to compass:
                    if (applySector) {
                        //starting position (i.e. middle of compass canvas)
                        var startX = this.width / 2;
                        var startY = this.height / 2;
                        var sectorRadius = this.radius / 1.4;
                        //: rx ry x-axis-rotation large-arc-flag sweep-flag x y
                        var diff = sector.FromDegrees > sector.ToDegrees ? 360 - sector.FromDegrees + sector.ToDegrees : sector.ToDegrees - sector.FromDegrees;
                        var largeArcFlag = diff > 180 ? 1 : 0;
                        var sectorPie = this.windCompassPaper.path('M' + this.polarToCartesian(startX, startY, 0, 0) + 'L' + this.polarToCartesian(startX, startY, sectorRadius, sector.FromDegrees) + 'A' + sectorRadius + ',' + sectorRadius + ',' + 0 + ',' + largeArcFlag + ',' + 1 + ',' + this.polarToCartesian(startX, startY, sectorRadius, sector.ToDegrees) + // + ',' + startY +
                        'Z').attr({
                            'stroke': 'transparent',
                            'fill': sector.Colour
                        });
                        this.movingParts.push(sectorPie);
                    }
                }
            });
        }
        this.compassLog.push("[WindCompass][sectors] - finished.");
    // console.info("[WindCompass][drawCompassSectors()]", this.compassLog, this);
    }
    drawCompass() {
        this.width = this.canvas.width();
        this.height = this.canvas.height();
        this.drawCompassSectors(this.sensorId, "drawCompass");
        var sectorLabelsHeight = 0;
        sectorLabelsHeight = this.canvasLabelsWrap.outerHeight();
        if (sectorLabelsHeight > 0) {
            sectorLabelsHeight += 5;
            this.height = this.height - sectorLabelsHeight;
            this.compassLog.push("[WindCompass][sectors] - adjusted compass height (this.height = " + this.height + ").");
        }
        this.windCompassPaper.clear();
        this.windCompassPaper.setSize(this.width, this.height);
        //sizes of wind compass components
        this.radius = Math.min(this.width, this.height) / 2;
        //draw directional labels
        var textPadding = this.width / 100 * 2.5;
        //draw platform image background
        const imgWidth = Math.min(this.width, this.height);
        this.platformBitmap = this.windCompassPaper.image(location.protocol + "//" + location.host + "/api/PlatformBitmaps/" + this.stationId, imgWidth === this.width ? 0 : this.width / 2 - this.height / 2, imgWidth === this.width ? this.height / 2 - this.width / 2 : 0, imgWidth === this.width ? this.width : this.height, imgWidth === this.width ? this.width : this.height);
        this.platformBitmapOverLayer = this.windCompassPaper.rect(imgWidth === this.width ? 0 : this.width / 2 - this.height / 2, imgWidth === this.width ? this.height / 2 - this.width / 2 : 0, imgWidth === this.width ? this.width : this.height, imgWidth === this.width ? this.width : this.height).attr({
            'fill': 'white',
            'opacity': 0.5,
            'stroke-width': 0
        });
        this.generateCompassText(this.width / 2, this.height / 2 - this.radius + textPadding, "N", 5);
        this.generateCompassText(this.width / 2, this.height / 2 + this.radius - textPadding, "S", 5);
        this.generateCompassText(this.width / 2 + this.radius - textPadding, this.height / 2, "E", 5);
        this.generateCompassText(this.width / 2 - this.radius + textPadding, this.height / 2, "W", 5);
        if (this.page.mainSite.liveDataManager.latestData) {
            this.redrawMovingParts(this.page.mainSite.liveDataManager.latestData);
            this.updateImageBitmapRotation(this.page.mainSite.liveDataManager.latestData);
        }
    }
    updateImageBitmapRotation(latestData) {
        const valueF = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Heading_deg);
        let headingDeg = valueF.format(latestData.Stations[this.stationId]).Value;
        if (this.platformBitmap && !isNaN(parseFloat(headingDeg))) {
            this.platformBitmap.transform('r' + valueF);
            this.platformBitmapOverLayer.transform('r' + valueF);
        }
    }
    redrawMovingParts(latestData) {
        this.movingParts.remove();
        this.movingParts = this.windCompassPaper.set();
        //values and formatters for parameters which are to be displayed on the wind compass
        var dirValFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg, this.sensorId);
        var dirObject = dirValFormatter.format(latestData.Stations[this.stationId]);
        var speedValFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.windSpeedGroup, this.sensorId);
        var speedObject = speedValFormatter.format(latestData.Stations[this.stationId]);
        var dirBackedValFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Backed_deg, this.sensorId);
        var backedObject = dirBackedValFormatter.format(latestData.Stations[this.stationId]);
        var dirVeeredValFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_Veered_deg, this.sensorId);
        var veeredObject = dirVeeredValFormatter.format(latestData.Stations[this.stationId]);
        //sizings
        var outerPadding = 0.2 * this.radius;
        var ringWidth = 0.1 * this.radius;
        var arrowSize = 0.24 * this.radius;
        var labelXPadding = 0.08 * this.radius;
        var labelHeight = 0.24 * this.radius;
        var labelFont = 'bold ' + 0.16 * this.radius + 'px verdana';
        //starting position (i.e. middle of compass canvas)
        var startX = this.width / 2;
        var startY = this.height / 2;
        // draw the sensor text
        var levelString = "";
        var sensorString = "";
        var sensorId = null;
        if (this.sensorId) // sensorId set in constructor
        sensorId = this.sensorId;
        else if ((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSelectedSensorId.Id in latestData.Stations[this.stationId].GroupValues) {
            // we can infer that it is a multiple sensor site
            let sourceIndex = latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSelectedSensorId.Id][0].Value;
            //: lookup site sensors for matching SensorDefinition.SourceIndex, to use appropropriate sensor & definitions:
            for(let _matchingIndexSensorId in (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors){
                let _sensor = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[_matchingIndexSensorId];
                if (_sensor.SensorDefinition && _sensor.SensorDefinition.SourceIndex) {
                    if (_sensor.SensorDefinition.SourceIndex == sourceIndex.toString()) sensorId = _matchingIndexSensorId;
                }
            }
        } else if (latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg.Id]) // it is a single sensor site
        sensorId = latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg.Id][0].Sensor;
        else return;
        var sensor = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[sensorId];
        // add possible CompassSectors for this station/params:
        this.drawCompassSectors(sensorId, "redrawMovingParts()");
        if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.DisplayName) sensorString = sensor.SensorDefinition.DisplayName;
        else sensorString = sensorId;
        if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.Level && !this.is10m) levelString = "@ " + sensor.SensorDefinition.Level;
        var levelText = this.generateCompassText(startX, startY + this.height / 12, levelString, 5);
        this.movingParts.push(levelText);
        var sensorText = this.generateCompassText(startX, startY - this.height / 12, sensorString, 5);
        this.movingParts.push(sensorText);
        //compassArcs
        if (backedObject.Status !== null && backedObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired && veeredObject.Status !== null && veeredObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            var difference = parseFloat(veeredObject.Value) - parseFloat(backedObject.Value);
            if (difference < 0) difference += 360;
            //tells us whether we are dealing with a large-arc (svg arcs)
            var arcFlag = 0;
            if (difference <= 180) arcFlag = 1;
            var mainCompassArc = this.windCompassPaper.path('M' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(backedObject.Value)) + 'A' + this.radius / 1.3 + ',' + this.radius / 1.3 + ',' + 0 + ',' + arcFlag + ',' + 0 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(veeredObject.Value)) + ',' + startY).attr({
                'stroke-width': ringWidth,
                'stroke': '#8d8d8d'
            });
            var variabilityCompassArc = this.windCompassPaper.path('M' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(backedObject.Value)) + 'A' + this.radius / 1.3 + ',' + this.radius / 1.3 + ',' + 0 + ',' + (1 - arcFlag) + ',' + 1 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(veeredObject.Value)) + ',' + startY).attr({
                'stroke-width': ringWidth,
                'stroke': '#fbce07' //shell-yellow
            });
            this.movingParts.push(mainCompassArc);
            this.movingParts.push(variabilityCompassArc);
        } else {
            var circle = this.windCompassPaper.circle(startX, startY, this.radius / 1.3).attr({
                'stroke-width': ringWidth,
                'stroke': '#8d8d8d'
            });
            this.movingParts.push(circle);
        }
        //compass markers
        for(var i = 0; i < 360; i += 10){
            var compassMarker = this.windCompassPaper.path('M' + this.polarToCartesian(startX, startY, this.radius / 1.2, i) + 'L' + this.polarToCartesian(startX, startY, this.radius / 1.4, i)).attr({
                'stroke': '#ffffff',
                'stroke-width': 2
            });
            this.movingParts.push(compassMarker); // need to be redrawn to go on top of ring?
        }
        //wind dir
        if (dirObject.Status !== null && dirObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            var direction = parseFloat(dirObject.Value);
            var arrow = this.windCompassPaper.path('M' + this.polarToCartesian(startX, startY, this.radius / 1.9, direction) + 'L' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction - 10) + //'L' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction + 10) +
            'A' + this.radius / 1.45 + ',' + this.radius / 1.45 + ',' + 20 + ',' + 0 + ',' + 1 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction + 10) + ',' + startY + 'Z').attr({
                'stroke': '#33CC33',
                'fill': '#33CC33'
            });
            this.movingParts.push(arrow);
        }
        var dirSpeedString = "";
        if (dirObject.Status !== null && dirObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            dirSpeedString += dirObject.Value + " \xb0T";
            if (speedObject.Status !== null && speedObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) //cope with multiple spaces between dir and speed
            dirSpeedString += "\u00a0\u00a0";
        }
        if (speedObject.Status !== null && speedObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) dirSpeedString += speedObject.Value + ' ' + (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.windSpeedGroup.Units, this.windSpeedGroup.Id);
        var dirSpeedText = this.generateCompassText(startX, startY, dirSpeedString, 6);
        this.movingParts.push(dirSpeedText);
    }
    generateCompassText(x, y, text, size = 7, bold = true) {
        var compassFontFamily = "Helvetica";
        var compassFontWeight = bold ? "bold" : "normal";
        var compassFontSize = this.width / 100 * size;
        var textElement = this.windCompassPaper.text(x, y, text).attr({
            "font-family": compassFontFamily,
            "font-weight": compassFontWeight,
            "font-size": compassFontSize,
            "fill": '#4d4d4d'
        });
        return textElement;
    }
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
        var x = centerX + radius * Math.cos(angleInRadians);
        var y = centerY + radius * Math.sin(angleInRadians);
        var xyString = x + "," + y;
        return xyString;
    }
}


class $7b073b47882e0060$export$d7a9e6ef755e50e3 {
    show(station) {
        if (station.Station.Region == 'GOM') return false; //: GOM region special: we show GomDashboard instead.
        let sensorCount = 0;
        for(let sensorId in station.Sensors)sensorCount++;
        return sensorCount != 0; // if no sensors we show the blank overview page
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'overview';
        this.label = 'Overview';
    }
    notifyResize() {
        this.windCompass.drawCompass();
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        if (this.mainSite.basicViewSelectorBool) this.renderBasic(container, listeners);
        else this.renderAdvanced(container, listeners);
    }
    renderAdvanced(container, listeners) {
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '28em').css('width', '34em').appendTo(page);
        let hasHeading = false;
        for(let sensorId in this.station.Sensors){
            const sensor = this.station.Sensors[sensorId];
            for(let paramId in sensor.Parameters)if (paramId.indexOf('Heading') != -1) hasHeading = true;
        }
        let hasHelidecks = this.station.Helidecks.length > 0 /* && !!(this.mainSite.hashData as any).hdstatus*/ ;
        let compassHeight = hasHeading && hasHelidecks ? 50 : hasHeading || hasHelidecks ? 75 : 100;
        listeners.push(this.windCompass = new (0, $230b365548c7ce86$export$8d94490d1ec4a850)(this, leftPanel, 0, 0, compassHeight, 62) // top, left, height, width, as %
        );
        if (hasHeading) listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Heading_deg), compassHeight + 1, 0, 24, 62, this.ctx));
        if (hasHelidecks) {
            let boxWidth = (62 - (this.station.Helidecks.length - 1)) / this.station.Helidecks.length;
            var sortedHeliDecks = this.station.Helidecks.sort((a, b)=>a.Label > b.Label ? 1 : -1);
            for(let i = 0; i < sortedHeliDecks.length; i++)listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $ea259be164fdbb12$export$bee37f76ad555f11)(sortedHeliDecks[i]), 76, i * (boxWidth + 1), 24, 30, this.ctx));
        }
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg), 0, 64, 24, 36, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $251c350f64351c46$export$a488047d99dafc7d)(), 25.33, 64, 24, 36, this.ctx, true, 2.1));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts), 50.67, 64, 24, 36, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts), 76, 64, 24, 36, this.ctx));
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', '28em').css('left', '35em').css('width', '29em').appendTo(page);
        var cloudContainer = $('<div></div>').css('position', 'absolute').css('height', '74%').css('width', '100%').appendTo(rightPanel);
        if (this.station.Station.Id == "NorthSea_Nelson") cloudContainer.css('height', '67%');
        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 3</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 44%;">Layer 2</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 72%;">Layer 1</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $(`<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft.Units, (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft.Id)})</div>`).appendTo(cloudContainer);
        var cloudDataContainer = $('<div></div').css('position', 'absolute').css('top', '16%').css('left', '24%').css('height', '84%').css('width', '76%').appendTo(cloudContainer);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudCover), 0, 0, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudCover), 33, 0, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover), 66, 0, 34, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Third_CloudBaseHeight_ft), 0, 50, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Second_CloudBaseHeight_ft), 33, 50, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft), 66, 50, 34, 50, this.ctx, false));
        // vis and weather go in right panel, below cloud container
        let _t = 76, _h = 24;
        if (this.station.Station.Id == "NorthSea_Nelson") {
            _t = 68;
            _h = 22;
        }
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m), _t, 0, _h, 40, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $49efe750b1982432$export$8ba89689dcbc989e)(), _t, 42, _h, 58, this.ctx));
        if (this.station.Station.Id == "NorthSea_Nelson") {
            //: TEMPSC led:
            var fieldWrapLED = $('<div></div>').css('position', 'absolute').css('top', '90%').css('left', '0').css('height', '10%').css('width', '100%').css('padding', '12px 10px 8px').appendTo(rightPanel);
            listeners.push(new (0, $e617a3afc5270513$export$c00f7ef2bcd6885a)(this, fieldWrapLED, new (0, $788b86d465428156$export$b1844fa5f8667441)((0, $24b391ec3014929b$export$5d65fdcfff509e37).TEMPSC_Status), this.ctx));
        }
        var bottomPanel = $('<div></div>').css('position', 'absolute').css('height', '19em').css('left', '0em').css('top', '29em').css('width', '64em').appendTo(page);
        if (this.station.Station.Id == "NorthSea_K14") {
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QFE_mbar_HelideckC, 'Pressure'), 0, 0, 36, 19.2, this.ctx, true));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QFE_mbar_HelideckP, 'Pressure (Helideck P)'), 0, 20.2, 36, 19.2, this.ctx, true));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC), 0, 40.4, 36, 19.2, this.ctx));
        } else {
            if (this.station.Station.Id === "Victory" || this.station.Station.Id === "OrmenLange" || this.station.Station.Id === "Nyhamna") listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WaterTemp_degC), 0, 0, 36, 19.2, this.ctx));
            else listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QFE_mbar), 0, 0, 36, 19.2, this.ctx));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC), 0, 20.2, 36, 19.2, this.ctx));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).RelativeHumidity_pc), 0, 40.4, 36, 19.2, this.ctx));
        }
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar), 39, 0, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).DewPoint_degC), 39, 20.2, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).RainfallIntensity_mmphour), 39, 40.4, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m), 0, 60.6, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s), 39, 60.6, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m), 0, 80.8, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tz_s), 39, 80.8, 36, 19.2, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).METAR), 78, 0, 20, 100, this.ctx, false, 1.1));
        page.appendTo(container);
    }
    renderBasic(container, listeners) {
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '32em').css('width', '34em').appendTo(page);
        listeners.push(this.windCompass = new (0, $230b365548c7ce86$export$8d94490d1ec4a850)(this, leftPanel, 0, 0, 100, 62) // top, left, height, width, as %
        );
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg), 0, 64, 32, 36, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts), 33.33, 64, 32, 36, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts), 66.67, 64, 32, 36, this.ctx));
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', '32em').css('left', '35em').css('width', '29em').appendTo(page);
        var cloudContainer = $('<div></div>').css('position', 'absolute').css('height', '74%').css('width', '100%').appendTo(rightPanel);
        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 1</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (ft)</div>').appendTo(cloudContainer);
        var cloudDataContainer = $('<div></div').css('position', 'absolute').css('top', '16%').css('left', '24%').css('height', '84%').css('width', '76%').appendTo(cloudContainer);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover), 0, 0, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, cloudDataContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft), 0, 50, 33, 50, this.ctx, false));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m), 33.33, 0, 32, 100, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $49efe750b1982432$export$8ba89689dcbc989e)(), 66.67, 0, 32, 100, this.ctx));
        var bottomPanel = $('<div></div>').css('position', 'absolute').css('height', '11em').css('left', '0em').css('top', '33em').css('width', '64em').appendTo(page);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QFE_mbar), 0, 0, 100, 24, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar), 0, 25.33, 100, 24, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC), 0, 50.67, 100, 24, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, bottomPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m), 0, 76, 100, 24, this.ctx));
        page.appendTo(container);
    }
}



var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");



class $2eddda48735b4d6b$export$f226cbd59d010ecc {
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'Penguins_Lifeboat';
        this.label = 'Lifeboats';
    }
    notifyResize() {}
    show(station) {
        return station.Station.Id === "NorthSea_Penguins";
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        const page = $('<div class="midi_SiteObservations_padded_page_content midi_siteObsPage_penguinsLifeboats"></div>').appendTo(container);
        (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).render(/*#__PURE__*/ (0, $1IdZj.jsx)($2eddda48735b4d6b$var$PageComponent, {
            latestData: this.mainSite.liveDataManager.latestData,
            listeners: listeners
        }), page[0]);
    }
}
const $2eddda48735b4d6b$var$getLatestDataValue = (latestData, groupId)=>{
    const values = latestData?.Stations["NorthSea_Penguins"]?.GroupValues[groupId]?.filter((x)=>x.Primary && (x.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || x.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) ?? [];
    return values.length ? values[0].Value : "";
};
const $2eddda48735b4d6b$var$getLatestDataValueNum = (latestData, groupId)=>{
    const values = latestData?.Stations["NorthSea_Penguins"]?.GroupValues[groupId]?.filter((x)=>x.Primary && (x.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || x.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) ?? [];
    return values.length ? parseFloat(values[0].Value) : NaN;
};
const $2eddda48735b4d6b$var$PageComponent = (props)=>{
    const [pitch, setPitch] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(NaN);
    const [roll, setRoll] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(NaN);
    const [incl, setIncl] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(NaN);
    const [hullStateAuto, setHullStateAuto] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(true);
    const [hullState, setHullState] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const hullStateError = "";
    const [highLifeboatAuto, setHighLifeboarAuto] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(true);
    const [highLifeboat, setHighLifeboat] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const highLifeboatError = hullState === "damaged" && highLifeboat === "" ? "Select high lifeboat" : "";
    const [hsStr, setHsStr] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const [hsAuto, setHsAuto] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(true);
    const hsMatch = /^\d+(\.\d*)?$/.test(hsStr);
    const hs = parseFloat(hsStr);
    const hsError = !hsMatch ? "Please enter a number" : hs < 0 || hs > 30 ? "Value outside valid range 0-30" : "";
    const [waveDirStr, setWaveDirStr] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("");
    const [waveDirAuto, setWaveDirAuto] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(true);
    const waveDirMatch = /^\d+(\.\d*)?$/.test(waveDirStr);
    const waveDir = parseFloat(waveDirStr);
    const waveDirError = !waveDirMatch ? "Please enter a number" : waveDir < 0 || waveDir > 360 ? "Value outside valid range 0-360" : "";
    const [latestData, setLatestData] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState(props.latestData);
    const liveDataChanged = (latestData)=>{
        setLatestData(latestData);
    };
    const listenerPushed = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        if (!listenerPushed.current) {
            listenerPushed.current = true;
            props.listeners.push({
                liveDataChanged: liveDataChanged
            });
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useEffect(()=>{
        // WISE group confirmed be email on 06/06/2024 that:
        // Positive roll = roll to starboard
        // Negative pitch = aft pointing down
        const rollLeft = $2eddda48735b4d6b$var$getLatestDataValueNum(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Roll_Left_deg_Max.Id);
        const rollRight = $2eddda48735b4d6b$var$getLatestDataValueNum(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Roll_Right_deg_Max.Id);
        const pitchUp = $2eddda48735b4d6b$var$getLatestDataValueNum(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).PitchBowDown_deg_Max.Id);
        const pitchDown = $2eddda48735b4d6b$var$getLatestDataValueNum(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).PitchBowUp_deg_Max.Id);
        let highLifeboat = "";
        if (!isNaN(rollLeft) && !isNaN(rollRight)) {
            const avgRoll = 0.5 * (rollLeft + rollRight);
            const rollToStarboard = avgRoll > 0;
            highLifeboat = rollToStarboard ? "l1" : "l2";
        }
        let hullState = "";
        if (!isNaN(rollLeft) && !isNaN(rollRight) && !isNaN(pitchUp) && !isNaN(pitchDown)) {
            const avgRoll = 0.5 * (rollLeft + rollRight);
            const avgPitch = 0.5 * (pitchUp + pitchDown);
            const incl = 180 / Math.PI * Math.acos(Math.cos(Math.PI / 180 * avgRoll) * Math.cos(Math.PI / 180 * avgPitch));
            setPitch(avgPitch);
            setRoll(avgRoll);
            setIncl(incl);
            hullState = incl > 4 ? "damaged" : "intact";
        }
        if (hullStateAuto) setHullState(hullState);
        if (highLifeboatAuto) setHighLifeboat(highLifeboat);
        if (hsAuto) setHsStr($2eddda48735b4d6b$var$getLatestDataValue(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m.Id));
        if (waveDirAuto) setWaveDirStr($2eddda48735b4d6b$var$getLatestDataValue(latestData, (0, $24b391ec3014929b$export$5d65fdcfff509e37).PeakWaveDirection_deg.Id));
        if (hullStateError || highLifeboatError || hsError || waveDirError) note = undefined;
    });
    let note = undefined;
    if (hullStateError || highLifeboatError || hsError || waveDirError) note = undefined;
    else {
        if (hullState === "intact" || hullState === "damaged" && highLifeboat === "") {
            if (hs > 7 && waveDir >= 37.5 && waveDir <= 262.5) {
                if (waveDir >= 37.5 && waveDir <= 150) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Use Lifeboat 1 as preference"
                });
                else if (waveDir > 150 && waveDir <= 262.5) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Use Lifeboat 2 as preference"
                });
            } else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                children: "Use either/both lifeboats"
            });
        } else if (hullState === "damaged" && (highLifeboat === "l1" || highLifeboat === "l2")) {
            if (highLifeboat === "l1") {
                if (hs > 3.5) {
                    if (hs > 8.5) {
                        if (waveDir >= 116 && waveDir <= 139 && hs > 16.5) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            children: "Use Lifeboat 1 as preference"
                        });
                        else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            children: "Use Lifeboat 2 as preference"
                        });
                    } else if (waveDir >= 94 && waveDir <= 161 || waveDir >= 251 && waveDir <= 274) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        children: "Use Lifeboat 1 as preference"
                    });
                    else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        children: "Use Lifeboat 2 as preference"
                    });
                } else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Use Lifeboat 2 as preference"
                });
            } else if (highLifeboat === "l2") {
                if (hs > 3.5) {
                    if (hs > 8.5) {
                        if (waveDir >= 206 && waveDir <= 229 && hs > 16.5) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            children: "Use Lifeboat 2 as preference"
                        });
                        else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            children: "Use Lifeboat 1 as preference"
                        });
                    } else if (waveDir >= 26 && waveDir <= 49 || waveDir >= 184 && waveDir <= 251) note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        children: "Use Lifeboat 2 as preference"
                    });
                    else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                        children: "Use Lifeboat 1 as preference"
                    });
                } else note = /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    children: "Use Lifeboat 1 as preference"
                });
            }
        }
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("table", {
                    className: "inputTable",
                    children: /*#__PURE__*/ (0, $1IdZj.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                        children: "Hull State"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                                type: "checkbox",
                                                checked: hullStateAuto,
                                                onChange: (e)=>setHullStateAuto(e.target.checked)
                                            }),
                                            " Auto"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsxs)("select", {
                                                value: hullState,
                                                disabled: hullStateAuto,
                                                onChange: (e)=>setHullState(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                        value: "intact",
                                                        children: "Intact - Inclination <= 4\xb0"
                                                    }),
                                                    /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                        value: "damaged",
                                                        children: "Damaged - Inglination > 4\xb0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                                                children: [
                                                    "WMS reports Roll = ",
                                                    roll.toFixed(1),
                                                    "\xb0, Pitch = ",
                                                    pitch.toFixed(1),
                                                    "\xb0, Incl = ",
                                                    incl.toFixed(1),
                                                    "\xb0"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        className: "warning",
                                        children: hullStateError
                                    })
                                ]
                            }),
                            hullState === "damaged" && /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                        children: "Which lifeboat is high?"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                                type: "checkbox",
                                                checked: highLifeboatAuto,
                                                onChange: (e)=>setHighLifeboarAuto(e.target.checked)
                                            }),
                                            " Auto"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("select", {
                                            value: highLifeboat,
                                            disabled: highLifeboatAuto,
                                            onChange: (e)=>setHighLifeboat(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                    hidden: true,
                                                    value: "",
                                                    children: "Select"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                    value: "l1",
                                                    children: "Lifeboat 1 WEST is high"
                                                }),
                                                /*#__PURE__*/ (0, $1IdZj.jsx)("option", {
                                                    value: "l2",
                                                    children: "Lifeboat 2 EAST is high"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        className: "warning",
                                        children: highLifeboatError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                        children: "Significant Wave Height (m)"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                                type: "checkbox",
                                                checked: hsAuto,
                                                onChange: (e)=>setHsAuto(e.target.checked)
                                            }),
                                            " Auto"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                            type: "text",
                                            disabled: hsAuto,
                                            value: hsStr,
                                            onChange: (e)=>setHsStr(e.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        className: "warning",
                                        children: hsError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                        children: "Wave Direction (\xb0 from True North)"
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                                type: "checkbox",
                                                checked: waveDirAuto,
                                                onChange: (e)=>setWaveDirAuto(e.target.checked)
                                            }),
                                            " Auto"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("input", {
                                            type: "text",
                                            disabled: waveDirAuto,
                                            value: waveDirStr,
                                            onChange: (e)=>setWaveDirStr(e.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                        className: "warning",
                                        children: waveDirError
                                    })
                                ]
                            })
                        ]
                    })
                }),
                note !== undefined && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "lifeboatStatus",
                    style: {
                        backgroundColor: "#e2efd9",
                        textAlign: "center"
                    },
                    children: note
                })
            ]
        })
    });
};


class $21491803b5ad198a$export$31eea0956932282a {
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'RIGS';
        this.label = 'RIGS';
    }
    notifyResize() {
        this.containerOverride.height($('body').height() - 60);
    }
    show(station) {
        return station.Station.Id === "Australia_Prelude";
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        this.containerOverride = $('<div style="padding-left: 26px; padding-right: 26px"></div>').appendTo('body');
        this.containerOverride.height($('body').height() - 60);
        $('<iframe style="height: 100%; width: 100%;" src="/public/RIGS/RIGS.html"  id="rigsFrame"></iframe>').appendTo(this.containerOverride);
    }
}


class $473e2d8a793f7d7c$export$bf09cc4465ad5e98 {
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'RIGS_Heading';
        this.label = 'Heading Forecast';
    }
    notifyResize() {
        this.containerOverride.height($('body').height() - 60);
    }
    show(station) {
        return station.Station.Id === "Australia_Prelude";
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        this.containerOverride = $('<div style="padding-left: 26px; padding-right: 26px"></div>').appendTo('body');
        this.containerOverride.height($('body').height() - 60);
        $('<iframe style="height: 100%; width: 100%;" src="/public/special/Prelude/HeadingForecast/HeadingForecast.html"  id="rigsFrame"></iframe>').appendTo(this.containerOverride);
    }
}







class $934c0f79a937e6dc$export$ade8cdfd0e9e645d extends (0, $bfbbca38eee2856d$export$3f0be2c6920005ae) {
    constructor(page, container, valueFormatter, ctx){
        super(page.mainSite);
        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;
        if (valueFormatter.plottable()) container.attr('title', 'Click for parameter popup').click((e)=>{
            this.renderPopup(e);
        });
        this.span = $('<span></span>').appendTo(container);
        if (page.mainSite.liveDataManager.latestData) this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
    }
    liveDataChanged(latestData, ctx) {
        var valueObject = this.valueFormatter.format(latestData.Stations[this.station.Id], this.warningGroup);
        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        this.span.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.');
        ctx.valueChanged(valueObject);
        this.span.text(valueObject.Value); // valueObject handles the formatting
        if (valueObject.Status === null || valueObject.Status === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            // no valid data -> hide units and remove any colour coding
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.span.addClass('midi_siteObsPage_expiring');
            return;
        }
        if (valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) this.span.removeClass('midi_siteObsPage_expiring');
        else this.span.addClass('midi_siteObsPage_expiring');
        // by this point we will be showing some data
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.span.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.span.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}


class $903655cded51f011$export$4bc7a197e343fa41 {
    notifyResize() {}
    show(station) {
        return station.Station.Id == "Malikai";
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'risers';
        this.label = 'Risers';
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        var page = $('<div></div>');
        let mainDiv = $('<div></div>').appendTo(page);
        let t1Container = $('<div style="display: inline-block; margin-right: 1em; margin-bottom: 1em; vertical-align: top; border: 1px solid #e6e6e6"></div>').appendTo(mainDiv);
        let t2Container = $('<div style="display: inline-block; margin-bottom: 1em; vertical-align: top; border: 1px solid #e6e6e6"></div>').appendTo(mainDiv);
        let t3Container = $('<div></div>').appendTo(page);
        this.renderRiserTable(t1Container, listeners, station);
        this.renderMotionParamsTable1(t2Container, listeners, station);
        this.renderMotionParamsTable2(t3Container, listeners, station);
        page.appendTo(container);
    }
    renderMotionParamsTable1(container, listeners, station) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>').appendTo(container);
        let tbody = $('<tbody></tbody>').appendTo(table);
        let thead = $('<thead></thead>').append($('<tr></tr>').append($('<th>Motion Parameters</th>')).append($('<th>MIS/MAS Reading</th>')))//.append($('<tr class="midi_tablePage_main_table_units"><th>&nbsp;</th><th></th></tr>'))
        .appendTo(table);
        let pgis = [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Vessel_Latitude_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Vessel_Longitude_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Heading_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Pitch_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Roll_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).SurgeAcceleration_mps2,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).SwayAcceleration_mps2,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Heave_m
        ];
        pgis.forEach((pgi, i)=>{
            let row = $('<tr></tr>').appendTo(tbody);
            row.append($('<th></th>').text(pgi.ShortName + " (" + pgi.Units + ")"));
            let cell = $('<td></td>').appendTo(row);
            listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(pgi), this.ctx));
            tbody.append(row);
        });
    }
    renderMotionParamsTable2(container, listeners, station) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>').appendTo(container);
        let thr = $('<tr></tr>').appendTo($('<thead></thead>').appendTo(table)).append($('<th>Motion Parameters</th>'));
        let tbr = $('<tr></tr>').appendTo($('<tbody></tbody>').appendTo(table)).append($('<th>MIS/MAS Reading</th>'));
        thr.append($('<th></th>').text("North Draft (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m.Units + ")"));
        let cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m, "Air Gap North"), this.ctx));
        thr.append($('<th></th>').text("East Draft (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m, "Air Gap East"), this.ctx));
        thr.append($('<th></th>').text("South Draft (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m, "Air Gap South"), this.ctx));
        thr.append($('<th></th>').text("West Draft (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Draft_m, "Air Gap West"), this.ctx));
        thr.append($('<th></th>').text((0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationEW_deg.ShortName + " (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationEW_deg.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationEW_deg), this.ctx));
        thr.append($('<th></th>').text((0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationNS_deg.ShortName + " (" + (0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationNS_deg.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).InclinationNS_deg), this.ctx));
    }
    renderRiserTable(container, listeners, station) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>').appendTo(container);
        let tbody = $('<tbody></tbody>').appendTo(table);
        let thead = $('<thead></thead>').appendTo(table);
        let pgis = [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).RiserTension_kN,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).RiserTensionerPressure1_psi,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).RiserTensionerPressure2_psi,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).RiserTensionerPressure3_psi,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).RiserTensionerPressure4_psi
        ];
        let mainHead = $('<tr class="midi_tablePage_main_table_header"></tr>').append($('<th>Sensor</th>')).appendTo(thead);
        let unitsHead = $('<tr class="midi_tablePage_main_table_units"></tr>').append($('<th></th>')).appendTo(thead);
        pgis.forEach((pgi)=>{
            mainHead.append($('<th></th>').text(pgi.ShortName));
            unitsHead.append($('<th></th>').text(pgi.Units));
        });
        //hard code order for Malikai
        let sensorIds = [
            "Riser 15",
            "Riser 22",
            "Riser 13",
            "Riser 20",
            "Riser 7",
            "Riser 4",
            "Riser 24",
            "Riser 12",
            "Riser 23",
            "Riser 21",
            "Riser 16",
            "Riser 3",
            "Riser 6",
            "Riser 8",
            "Riser 11",
            "Riser 18",
            "Riser 19"
        ];
        sensorIds.forEach((sensorId)=>{
            let row = $('<tr></tr>');
            if (sensorId.indexOf("Riser ") !== -1) {
                row.append($('<th></th>').text(sensorId));
                pgis.forEach((pgi, i)=>{
                    let cell = $('<td></td>').appendTo(row);
                    listeners.push(new (0, $934c0f79a937e6dc$export$ade8cdfd0e9e645d)(this, cell, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(pgi, sensorId), this.ctx));
                    tbody.append(row);
                });
            }
        });
    }
}













class $9fd163093c59f270$export$64fb232f890f656 {
    notifyResize() {}
    show(station) {
        // return station.Station.Region == 'GOM';
        return station.Station.Id == "Australia_Prelude";
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = "rtcpdashboard";
        this.label = "RTCP Buoy";
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        this.currentProfileHorizontalSensor = null;
        this.currentProfileHorizontalParam = null;
    }
    getStationSchema() {
        return this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id];
    }
    stationHasSensor(sensorId) {
        return sensorId in this.getStationSchema().Sensors;
    }
    stationHasParameter(sensorId, paramId) {
        return sensorId in this.getStationSchema().Sensors && paramId in this.getStationSchema().Sensors[sensorId].Parameters;
    }
    stationGetFirstAvailableParam(sensorId, params, searchSlashesReplaced = true, returnFirstRequestedAsDefault = true) {
        //: example on GOM_Vito: Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[3].pages[1].stationGetFirstAvailableParam('WM1', ['Hs_m', 'HsT/m', 'Hs/m_30min', 'HsT/m_30min'])
        if (params.length == 0) {
            console.warn("Unable to get first available param as list os params to search provided is empty!");
            return null;
        }
        let out = null;
        if (this.stationHasSensor(sensorId)) {
            let paramsAvailable = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort();
            let paramsAvailableReplaced = paramsAvailable.map((x)=>x.replace(/\//g, "_"));
            for(let i = 0; i <= params.length; i++){
                let _param = params[i];
                if (out == null && paramsAvailable.indexOf(_param) >= 0) return _param;
                if (out == null && searchSlashesReplaced && paramsAvailableReplaced.indexOf(_param) >= 0) return paramsAvailable[paramsAvailableReplaced.indexOf(_param)];
            }
        }
        if (out == null && returnFirstRequestedAsDefault) return params[0];
        return out;
    }
    /**
     * Get the parameter from schema, having checked for keys with their slashes replaced by underscores (as ParameterGroupInfo usually uses all underscores!).
     * @param sensorId
     * @param paramId
     * @param nullOnNotFound
     */ stationGetParameterId(sensorId, paramId, nullOnNotFound = false) {
        //: example on GOM_Vito: Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[3].pages[1].stationGetParameterId('AWOS', 'WindDirection_deg')
        //: Object.keys(Icon.Midi.WebApplication.FrontEnd.MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations['GOM_Vito'].Sensors['AWOS'].Parameters).sort().map(x => x.replace(/\//g, '_')).indexOf('WindDirection_deg');
        if (!this.stationHasParameter(sensorId, paramId) && this.stationHasSensor(sensorId)) {
            let params = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort();
            let paramsReplaced = params.map((x)=>x.replace(/\//g, "_"));
            if (paramsReplaced.indexOf(paramId) >= 0) return params[paramsReplaced.indexOf(paramId)];
        }
        if (!this.stationHasParameter(sensorId, paramId) && nullOnNotFound) return null;
        return paramId;
    }
    getSensorLowestBinParam(sensorId, paramIdPrefix) {
        if (this.stationHasSensor(sensorId)) {
            let params = Object.keys(this.getStationSchema().Sensors[sensorId].Parameters).sort().filter((x)=>x.substring(0, paramIdPrefix.length) == paramIdPrefix);
            // console.info('getSensorLowestBinParam', sensorId, paramIdPrefix, params);
            // Object.keys(Icon.Midi.WebApplication.FrontEnd.MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations['GOM_Vito'].Sensors['LiDAR'].Parameters).sort().filter(x => x.substring(0, 'WindDirection_Bin'.length) == 'WindDirection_Bin');
            if (params.length >= 1) return params[0];
        }
        return null;
    }
    getParamDefs(sensorId, paramId) {
        let defs = null;
        if (this.stationHasParameter(sensorId, paramId)) defs = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id].Sensors[sensorId].Parameters[paramId].Variants[0].ParameterDefinition;
        if ((!defs || defs.Default) && paramId in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) defs = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[paramId];
        return defs;
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        /*
         * Quick and dirty fix to detect if current speed is shown as kts rather than mps.
         * It would be much better to allow the DefaultGroupFormatter to choose the group from
         * multiple options based on what is available.
         */ let currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps;
        let hasHorizontal = false;
        for(const sensorId in station.Sensors){
            const sensor = station.Sensors[sensorId];
            /*if (Object.keys(sensor.Parameters).some(pid => pid == "CurrentProfile") && !this.currentProfileParam) {
                this.currentProfileSensor = sensorId;
                this.currentProfileParam = "CurrentProfile";
                // break;
            }*/ if (Object.keys(sensor.Parameters).some((pid)=>pid == "CurrentProfile/kts")) currentSpeedUnits = (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).kts;
            if (Object.keys(sensor.Parameters).some((pid)=>pid.indexOf("HorizontalCurrentProfile") === 0)) hasHorizontal = true;
        }
        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? "m/s" : "kts";
        var unitsStrDepthOrHeight = "m";
        let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet("m");
        let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight = (value)=>value;
        let ucf_Speed = (value)=>value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        let panelsHeightEm = 47;
        var leftPanel = $("<div></div>").css("position", "absolute").css("height", `${panelsHeightEm}em`).css("width", "12em").appendTo(page);
        var centrePanel = $("<div></div>").css("position", "absolute").css("height", `${panelsHeightEm}em`).css("left", "13em").css("width", "25em") // 12 + 1 + 12
        .appendTo(page);
        var rightPanel = $("<div></div>").css("position", "absolute").css("height", `${panelsHeightEm}em`).css("left", "39em").css("width", "25em").appendTo(page);
        //: common value box settings:
        let vbHeight = 13;
        let vbSepVertical = 1;
        let vbFontSizeEm = 1.8;
        let vbFontSizeTitle = 0.75;
        let colCurrentTop = 0;
        //: left panel:
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC, "RTCP/Met"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts, "RTCP/Met"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg, "RTCP/Met"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts, "RTCP/Met"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m, "RTCP/Waves"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m, "RTCP/Waves"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s, "RTCP/Waves"), colCurrentTop, 0, vbHeight, 100, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        //: center panel:
        colCurrentTop = 0;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).RelativeHumidity_pc, "RTCP/Met"), colCurrentTop, 0, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, centrePanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar, "RTCP/Met"), colCurrentTop, 51, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        //: determine which sensors/params to use:
        let getPairFromSchema = (sensorId, parameterId, ...params)=>{
            for(let i = 0; i + 1 < params.length; i += 2){
                const defaultSensorId = params[i];
                const defaultParamId = params[i + 1];
                /// this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id].Sensors
                if (!this.stationHasParameter(sensorId, parameterId) && defaultSensorId && defaultParamId && this.stationHasParameter(defaultSensorId, defaultParamId)) return {
                    sensor: defaultSensorId,
                    param: defaultParamId
                };
            }
            //: always return something (so here the main element requested even if not necessarily available, seen as the default is nto available):
            return {
                sensor: sensorId,
                param: parameterId
            };
        };
        let miniChartsSensors = {
            windSpd: {
                sensor: "RTCP/Met",
                param: "WindSpd1"
            },
            windDir: {
                sensor: "RTCP/Met",
                param: "WindDirn1"
            },
            gustSpd: {
                sensor: "RTCP/Met",
                param: "GustSpd1"
            },
            waveHs: {
                sensor: "RTCP/Waves",
                param: "Hs_m"
            },
            waveHmax: {
                sensor: "RTCP/Waves",
                param: "HmaxT_m"
            },
            waveTp: {
                sensor: "RTCP/Waves",
                param: "Tp_s"
            }
        };
        // console.info('ShellSiteObs Page - miniChartsSensors:', miniChartsSensors);
        let $containerChartWind = $("<div>").css({
            position: "absolute",
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${3 * vbHeight + 2 * vbSepVertical}%`,
            width: "100%"
        }).appendTo(centrePanel);
        $containerChartWind.append('<em class="text-muted">Wind chart loading...</em>');
        $containerChartWind.css({
            fontSize: "0.85em"
        }); //: , border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)'
        let minichartDataWind = [
            //: TODO: use appropriate sensor based on available data in ParameterSchema..
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.windSpd.sensor,
                parameterId: miniChartsSensors.windSpd.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.windSpd.sensor, miniChartsSensors.windSpd.param),
                units: "kts",
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.windDir.sensor,
                parameterId: miniChartsSensors.windDir.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.windDir.sensor, miniChartsSensors.windDir.param),
                units: "deg",
                plotLine: false,
                yAxisIndex: 1
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.gustSpd.sensor,
                parameterId: miniChartsSensors.gustSpd.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.gustSpd.sensor, miniChartsSensors.gustSpd.param),
                units: "kts",
                plotLine: true,
                yAxisIndex: 0
            }
        ];
        let yAxisOptionsWind = [
            {
                title: {
                    text: "Speed (kts)"
                },
                opposite: false
            },
            {
                title: {
                    text: "Direction (\xb0T)"
                },
                min: 0,
                max: 360,
                opposite: true
            }
        ];
        let minichartWind = new (0, $8bcb687a2d05d369$export$739b93f773f2f77b)(this.mainSite, this, "Wind Chart", $containerChartWind, minichartDataWind, yAxisOptionsWind);
        listeners.push(minichartWind);
        colCurrentTop += 3 * vbHeight + 2 * vbSepVertical + vbSepVertical;
        let $containerChartWave = $("<div>").css({
            position: "absolute",
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${3 * vbHeight + 2 * vbSepVertical}%`,
            width: "100%"
        }).appendTo(centrePanel);
        $containerChartWave.append('<em class="text-muted">Wave chart loading...</em>');
        $containerChartWave.css({
            fontSize: "0.85em"
        }); //: , border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)'
        let minichartDataWave = [
            //: TODO: use appropriate sensor based on available data in ParameterSchema..
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveHs.sensor,
                parameterId: miniChartsSensors.waveHs.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveHs.sensor, miniChartsSensors.waveHs.param),
                units: "m",
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveHmax.sensor,
                parameterId: miniChartsSensors.waveHmax.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveHmax.sensor, miniChartsSensors.waveHmax.param),
                units: "m",
                plotLine: true,
                yAxisIndex: 0
            },
            {
                stationId: this.station.Station.Id,
                sensorId: miniChartsSensors.waveTp.sensor,
                parameterId: miniChartsSensors.waveTp.param,
                // parameterDefs: this.getParamDefs(miniChartsSensors.waveTp.sensor, miniChartsSensors.waveTp.param),
                units: "s",
                plotLine: false,
                yAxisIndex: 1
            }
        ];
        let yAxisOptionsWave = [
            {
                title: {
                    text: `Wave Height (${unitsStrDepthOrHeight})`
                }
            },
            {
                title: {
                    text: "Wave Period (s)"
                },
                opposite: true
            }
        ];
        let minichartWave = new (0, $8bcb687a2d05d369$export$739b93f773f2f77b)(this.mainSite, this, "Wave Chart", $containerChartWave, minichartDataWave, yAxisOptionsWave);
        listeners.push(minichartWave);
        //: right panel:
        colCurrentTop = 0;
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean, "RTCP/Currents"), colCurrentTop, 0, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean, "RTCP/Currents"), colCurrentTop, 51, vbHeight, 49, this.ctx, true, vbFontSizeEm, vbFontSizeTitle));
        colCurrentTop += vbHeight + vbSepVertical;
        let $containerChartProfiles = $("<div>").css({
            position: "absolute",
            top: `${colCurrentTop}%`,
            left: 0,
            height: `${100 - colCurrentTop}%`,
            width: "100%"
        }).appendTo(rightPanel);
        // $containerChartProfiles.css({ border: '1px dashed orange', backgroundColor: 'rgba(0,0,255,.1)' });
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo($containerChartProfiles);
        chartSelectTabs.css({
            fontSize: "0.85em"
        });
        let currentBox = $('<div class="site-obs-current-charts" data-chart-type="vertical"></div>').appendTo($containerChartProfiles).hide();
        let currentBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="horizontal"></div>').appendTo($containerChartProfiles).hide();
        let pvdBox = $('<div class="site-obs-current-charts" data-chart-type="pvd"></div>').appendTo($containerChartProfiles).hide();
        let polarBox = $('<div class="site-obs-current-charts" data-chart-type="polar"></div>').appendTo($containerChartProfiles).hide();
        let hovmollerBox = $('<div class="site-obs-current-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Hovm\xf6ller chart...</em></div>').appendTo($containerChartProfiles).hide();
        let hovmollerBoxHorizontal = $('<div class="site-obs-current-charts" data-chart-type="hovmoller-horizontal"><em class="text-muted">Loading Hovm\xf6ller chart...</em></div>').appendTo($containerChartProfiles).hide();
        let showChart = (chartType, label)=>{
            $containerChartProfiles.find(".site-obs-current-charts").hide();
            $containerChartProfiles.find(`.site-obs-current-charts[data-chart-type="${chartType}"]`).show();
            $containerChartProfiles.find(".site-obs-current-chart-select-label").text(label);
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        chartSelectTabs.append("<span>Chart: </span>");
        let $buttonGroup = $('<div class="btn-group btn-group-sm"></div>').appendTo(chartSelectTabs);
        $('<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><span class="site-obs-current-chart-select-label">Select chart..</span> <span class="caret"></span></button>').appendTo($buttonGroup);
        let tpul = $("<ul></ul>").addClass("dropdown-menu")// .append($('<span></span>').text("Chart: "))
        .appendTo($buttonGroup);
        this._dpc = new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 5, 0, 93, 100, currentSpeedUnits == (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean.Id : (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_kts_Mean.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean.Id, true);
        listeners.push(this._dpc);
        this._pvd = new (0, $afcc295e055250f2$export$269e444807daccc9)(this.mainSite, this, pvdBox, 5, 0, 93, 100, currentSpeedUnits, "RTCP/Currents");
        listeners.push(this._pvd);
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBox, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $9616a178b649c555$export$861facf577d6ed7a).Depth, "RTCP/Met"));
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBoxHorizontal, 5, 0, 93, 100, currentSpeedUnits, "Current", (0, $9616a178b649c555$export$861facf577d6ed7a).Horizontal, "RTCP/Met"));
        let hovmolOptions = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptions.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptions.yAxis = {
            ...hovmolOptions.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    "#0000FF"
                ],
                [
                    0.33,
                    "#00FFFF"
                ],
                [
                    0.66,
                    "#FFFF00"
                ],
                [
                    1,
                    "#FF0000"
                ]
            ]
        };
        // Direction: Options specific to direction chart
        let hovmolOptionsDirection = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Depth (${unitsStrDepthOrHeight})`
            },
            reversed: true
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [
                    0.0,
                    "rgb(255, 0, 0)"
                ],
                [
                    0.25,
                    "rgb(160, 32, 240)"
                ],
                [
                    0.5,
                    "rgb(0, 0, 255)"
                ],
                [
                    0.75,
                    "rgb(252, 186, 3)"
                ],
                [
                    1.0,
                    "rgb(255, 0, 0)"
                ]
            ],
            //tickInterval: 180,
            tickPositions: [
                0,
                90,
                180,
                270,
                360
            ],
            startOnTick: true,
            endOnTick: true
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBox, 0, 0, 93, 100, //// specific chart options
        hovmolOptionsSpeed, hovmolOptionsDirection, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                console.warn("Current Hovmoller (Vertical) chart: no current profile sensor or param detected for this station.");
                callback([], false);
                return;
            }
            let sensor = this.currentProfileSensor;
            let parameter = this.currentProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info("Current Hovmoller (Vertical) - data fetch URI:", uri);
            $.ajax(uri + "", {
                cache: false,
                dataType: "json",
                type: "GET",
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let profile = JSON.parse(x[1]);
                                    let components = profile.Components.sort((a, b)=>b.Depth - a.Depth); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.Speed || isNaN(cp.Speed)) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: ucf_DepthOrHeight(cp.Depth),
                                            val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.currentProfileParam + " Profile Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
        (latestData, chart)=>{
            if (this.currentProfileParam !== null) {
                chart.updateChart();
                return; //: already dealt with.
            }
            let liveDataSetValue = null;
            if (latestData.Stations[this.station.Station.Id]) {
                if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "CurrentProfile")) {
                    liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["CurrentProfile"][0];
                    this.currentProfileSensor = liveDataSetValue.Sensor;
                    this.currentProfileParam = "CurrentProfile";
                }
            }
            chart.updateChart();
        });
        listeners.push(this._chartsHovmoller);
        if (hasHorizontal) {
            let hovmolOptionsSpeedHorizontal = {
                ...hovmolOptionsSpeed
            };
            hovmolOptionsSpeedHorizontal.yAxis = {
                ...hovmolOptionsSpeedHorizontal.yAxis,
                title: {
                    text: `Distance (${unitsStrDepthOrHeight})`
                },
                reversed: true
            };
            this._chartsHovmollerHorizontal = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBoxHorizontal, 0, 0, 93, 100, //// specific chart options
            hovmolOptionsSpeedHorizontal, hovmolOptionsDirection, //// getDataMethod
            (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
                let res = [];
                /*if (!this.mainSite.liveDataManager.latestData) {
                        console.warn('Current Hovmoller chart: waiting for live data..');
                        callback([], true);
                        return;
                    }*/ if (chart.latestData == null) {
                    console.warn("Current Hovmoller (Horizontal) chart: waiting for first live data.");
                    callback([], false, "Awaiting first Live Data...");
                    return;
                }
                if (this.currentProfileHorizontalSensor == null || this.currentProfileHorizontalParam == null) {
                    console.warn("Current Hovmoller (Horizontal) chart: no current profile sensor or param detected for this station.");
                    callback([], false);
                    return;
                }
                let sensor = this.currentProfileHorizontalSensor;
                let parameter = this.currentProfileHorizontalParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info("Current Hovmoller (Horizontal) - data fetch URI:", uri);
                $.ajax(uri + "", {
                    cache: false,
                    dataType: "json",
                    type: "GET",
                    timeout: 30000,
                    success: (data, text, jqXHR)=>{
                        try {
                            if (Array.isArray(data.results[0].series[0].values)) {
                                for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                    let x = data.results[0].series[0].values[i];
                                    let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let profile = JSON.parse(x[1]);
                                        let components = profile.Components.sort((a, b)=>b.Distance ?? b.Depth - a.Distance ?? a.Depth);
                                        components.forEach((cp, cpi)=>{
                                            if (!cp.Speed || isNaN(cp.Speed)) return;
                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: ucf_DepthOrHeight(cp.Distance ?? cp.Depth),
                                                val: ucf_Speed(cp.Speed)
                                            });
                                        });
                                    } else console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                }
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown)=>{
                        console.warn("Unable to parse " + this.currentProfileHorizontalParam + " Profile Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            }, // to help data fetching methods use livedata if necessary (e.g. to determine sensors/params IDs..)
            (latestData, chart)=>{
                if (this.currentProfileHorizontalParam !== null) return; //: already dealt with.
                let liveDataSetValue = null;
                if (latestData.Stations[this.station.Station.Id]) {
                    if (Object.keys(latestData.Stations[this.station.Station.Id].GroupValues).some((pid)=>pid == "HorizontalCurrentProfile")) {
                        liveDataSetValue = latestData.Stations[this.station.Station.Id].GroupValues["HorizontalCurrentProfile"][0];
                        this.currentProfileHorizontalSensor = liveDataSetValue.Sensor;
                        this.currentProfileHorizontalParam = "HorizontalCurrentProfile";
                    }
                }
                chart.updateChart();
            });
            listeners.push(this._chartsHovmollerHorizontal);
        }
        let tpulLiActiveClass = "active"; //: 'selected' prior to using drop-down
        let charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            // { key: 'horizontal', label: 'Horizontal Profile' },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Hovm\xf6ller (Vertical)" : "Hovm\xf6ller"
            }
        ];
        if (hasHorizontal) charts = [
            {
                key: "vertical",
                label: "Vertical Profile"
            },
            {
                key: "horizontal",
                label: "Horizontal Profile"
            },
            {
                key: "pvd",
                label: "PVD"
            },
            {
                key: "polar",
                label: "Polar"
            },
            {
                key: "hovmoller",
                label: hasHorizontal ? "Hovm\xf6ller (Vertical)" : "Hovm\xf6ller"
            },
            {
                key: "hovmoller-horizontal",
                label: "Hovm\xf6ller (Horizontal)"
            }
        ];
        for(var i = 0; i < charts.length; i++){
            let chart = charts[i];
            let $li = $(`<li class="dropdown-menu-item"></li>`);
            let $a = $(`<a href="">${chart.label}</a>`).appendTo($li);
            $a.on("click", (ev)=>{
                ev.preventDefault();
                tpul.children("li").removeClass(tpulLiActiveClass);
                $li.addClass(tpulLiActiveClass);
                showChart(chart.key, chart.label);
            });
            tpul.append($li);
        }
        // currentBox.show();
        setTimeout(()=>{
            //: somehow, if executed immediately, this would not display the correct box..
            tpul.children("li").first().find("a").trigger("click");
        }, 500);
        page.appendTo(container);
        //page resizes due to highcharts charts being drawn before the box size is fixed and
        //the chart subsequently not filling the available space
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
    }
}




class $c15ea82cc17fe297$export$1f2f05723a7bdc27 extends (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4) {
    constructor(parameterGroup, sensorId = null, valueLimit){
        super(parameterGroup, sensorId), this.valueLimit = valueLimit;
    }
    format(liveDataSetStation, warningRules) {
        var valueObject = super.format(liveDataSetStation);
        // a bit of work will be duplicated in the call below but it's clean code
        const value = super.getLiveDataSetValue(liveDataSetStation);
        if (value !== null && typeof value.Value == 'number' && this.valueLimit != null && value.Value > this.valueLimit) valueObject.WarningThreshold = (0, $3f0b9745f7124153$export$23811558a05557).Level3;
        return valueObject;
    }
}









class $253714948e9c9b4f$export$81f55825d4ef8131 {
    constructor(page, container, top, left, height, width){
        this.stationId = page.station.Station.Id;
        var box = $('<div class="midi_SiteObservations_chart_container"></div>').css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        container.append(box);
        this.chart = $('<div></div>').css('height', '100%').appendTo(box);
        if (page.mainSite.liveDataManager.latestData) this.redrawChart(page.mainSite.liveDataManager.latestData);
    }
    liveDataChanged(latestData) {
        this.redrawChart(latestData);
    }
    redrawChart(latestData) {
        this.chart.empty();
        var spectrum = null;
        if (latestData.Stations[this.stationId] && latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WaveSpectrum.Id]) {
            var val = latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WaveSpectrum.Id][0];
            if (val.ExpiryStatus === null || val.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
                this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
                return;
            }
            spectrum = val.Value;
        } else {
            this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
            return;
        }
        const periods = [];
        let totalDensity = 0;
        const numberOfDirBins = 16;
        const maxPeriod = 16;
        for(let p = 0; p < maxPeriod; p = p + 2){
            const single = p >= 2 && p < 6;
            const from = p;
            const to = single ? p + 1 : p + 2;
            const data = [];
            while(data.length < numberOfDirBins)data.push(0);
            periods.push({
                name: from + '-' + to + 's',
                data: data,
                from: from,
                to: to
            });
            if (single) p--;
        }
        const data = [];
        while(data.length < numberOfDirBins)data.push(0);
        periods.push({
            name: '>' + maxPeriod + 's',
            data: data,
            from: maxPeriod,
            to: null
        });
        spectrum.Components.sort((x, y)=>y.CentralFrequency - x.CentralFrequency).forEach((component)=>{
            const period = Math.min(maxPeriod, 1 / component.CentralFrequency);
            const bin = periods.filter((p)=>period >= p.from && (p.to == null || period < p.to))[0];
            const dirBinIndex = Math.floor((component.Direction + 180 / numberOfDirBins) % 360 / 360 * numberOfDirBins);
            bin.data[dirBinIndex] += component.SpectralDensity;
            totalDensity += component.SpectralDensity;
        });
        for(var i = 0; i < periods.length; i++){
            if (periods[i].data.reduce((a, b)=>a + b, 0) == 0) {
                periods.splice(i);
                i -= 1;
                continue;
            }
            periods[i].data.forEach((x, j)=>{
                periods[i].data[j] = x * 100 / totalDensity;
            });
        }
        this.chart.highcharts({
            series: periods,
            chart: {
                polar: true,
                type: 'column',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            colors: [
                '#ff0000',
                '#ff6600',
                '#ffff00',
                '#65ff00',
                '#00ffd8',
                '#0099ff',
                '#0800ff',
                '#6100ff',
                '#e100ff',
                '#ff63c6',
                '#fad6ff'
            ],
            title: {
                text: ''
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                y: 100,
                layout: 'vertical'
            },
            xAxis: {
                tickmarkPlacement: 'on',
                tickInterval: 22.5,
                min: 0,
                max: 360
            },
            yAxis: {
                min: 0,
                endOnTick: false,
                showLastLabel: true,
                title: {
                    text: '% of total energy',
                    style: {
                        'color': '#000'
                    }
                },
                labels: {
                    formatter: function() {
                        return this.value + '%';
                    }
                },
                reversedStacks: false
            },
            tooltip: {
                enabled: false
            },
            pane: {
                size: '75%',
                startAngle: 0,
                endAngle: 360
            },
            plotOptions: {
                series: {
                    animation: false,
                    stacking: 'normal',
                    groupPadding: 0,
                    pointPlacement: 'on',
                    pointStart: 0,
                    pointInterval: 22.5,
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            credits: {
                enabled: false
            }
        });
    }
}





class $52d6bce86430fe5d$export$4f523ffcb6a30798 {
    constructor(page, container, top, left, height, width){
        this.stationId = page.station.Station.Id;
        var box = $('<div class="midi_SiteObservations_chart_container"></div>').css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        container.append(box);
        this.chart = $('<div></div>').css('height', '100%').appendTo(box);
        if (page.mainSite.liveDataManager.latestData) this.redrawChart(page.mainSite.liveDataManager.latestData);
    }
    liveDataChanged(latestData) {
        this.redrawChart(latestData);
    }
    redrawChart(latestData) {
        this.chart.empty();
        var spectrum = null;
        if (latestData.Stations[this.stationId] && latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WaveSpectrum.Id]) {
            var val = latestData.Stations[this.stationId].GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).WaveSpectrum.Id][0];
            if (val.ExpiryStatus === null || val.ExpiryStatus === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
                this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
                return;
            }
            spectrum = val.Value;
        } else {
            this.chart.append($('<div class="midi_SiteObservations_chart_no_data">Wave Spectrum not available</div>'));
            return;
        }
        var minFreq;
        var maxFreq;
        var seriesOptions = [];
        var direction = false;
        spectrum.Components.forEach((component)=>{
            var lowerBound = component.CentralFrequency - 0.5 * component.Width;
            var upperBound = component.CentralFrequency + 0.5 * component.Width;
            if (minFreq == null || maxFreq == null) {
                minFreq = lowerBound;
                maxFreq = upperBound;
            } else {
                minFreq = Math.min(minFreq, lowerBound);
                maxFreq = Math.max(maxFreq, upperBound);
            }
            seriesOptions.push({
                name: component.CentralFrequency + 'Hz',
                data: [
                    [
                        lowerBound,
                        0
                    ],
                    [
                        lowerBound,
                        component.SpectralDensity
                    ],
                    [
                        upperBound,
                        component.SpectralDensity
                    ],
                    [
                        upperBound,
                        0
                    ]
                ],
                color: '#6BF',
                lineColor: '#FFF',
                lineWidth: 1,
                yAxis: 0 // always the spectral density axis
            });
            if (component.Direction) {
                direction = true;
                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Direction',
                    data: [
                        [
                            component.CentralFrequency,
                            component.Direction
                        ],
                        [
                            component.CentralFrequency,
                            component.Direction
                        ]
                    ],
                    color: '#f00',
                    marker: {
                        enabled: true,
                        symbol: 'square'
                    },
                    yAxis: 1 // always the direction axis
                });
            }
            if (component.Spread && component.Direction) {
                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Spread Max',
                    data: [
                        [
                            component.CentralFrequency,
                            (component.Direction + 0.5 * component.Spread + 360) % 360
                        ],
                        [
                            component.CentralFrequency,
                            (component.Direction + 0.5 * component.Spread + 360) % 360
                        ]
                    ],
                    color: '#f88',
                    marker: {
                        enabled: true,
                        symbol: 'triangle-down',
                        radius: 5
                    },
                    yAxis: 1 // always the direction axis
                });
                seriesOptions.push({
                    name: component.CentralFrequency + 'Hz - Spread Min',
                    data: [
                        [
                            component.CentralFrequency,
                            (component.Direction - 0.5 * component.Spread + 360) % 360
                        ],
                        [
                            component.CentralFrequency,
                            (component.Direction - 0.5 * component.Spread + 360) % 360
                        ]
                    ],
                    color: '#f88',
                    marker: {
                        enabled: true,
                        symbol: 'triangle',
                        radius: 5
                    },
                    yAxis: 1 // always the direction axis
                });
            }
        });
        var yAxisOptions = [];
        yAxisOptions.push({
            min: 0,
            title: {
                text: 'Spectral Density (m^2 / Hz)'
            }
        });
        if (direction) yAxisOptions.push({
            min: 0,
            max: 360,
            title: {
                text: 'Direction (degs)'
            },
            opposite: true,
            tickInterval: 90,
            minTickInterval: 90
        });
        this.chart.highcharts({
            chart: {
                type: 'area',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                min: minFreq,
                max: maxFreq + 0.05 - (maxFreq + 0.05) % 0.05,
                title: {
                    text: 'Frequency (Hz)'
                },
                dateTimeLabelFormats: {
                    month: '%b'
                }
            },
            yAxis: yAxisOptions,
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                area: {
                    lineColor: '#036',
                    lineWidth: 1
                },
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: seriesOptions,
            credits: {
                enabled: false
            }
        });
    }
}


class $989bc1d7921dc690$export$3f008f9f514cfb66 {
    show(station) {
        const pages = [];
        // Go through all sensorIds
        for(let sensorId in station.Sensors){
            // if not useLiveData or forecast, skip
            if (!station.Sensors[sensorId].UseLiveData || sensorId.toLowerCase().includes('forecast')) continue;
            const sensor = station.Sensors[sensorId];
            if (sensorId.includes("orecast")) continue;
            // Check if the sensorId has any wave Hs (wave) parameters. If so, generate a Waves-pages for this sensorId
            for(let paramId in sensor.Parameters)if (paramId.indexOf('HsT/') != -1 || paramId.indexOf('Hs/') != -1) {
                const label = station.Sensors[sensorId].SensorDefinition?.DisplayName ?? sensorId;
                pages.push(new $989bc1d7921dc690$export$3f008f9f514cfb66(this.mainSite, this.ctx, sensorId, label));
                break;
            }
        }
        if (pages.length == 1) return true;
        else if (pages.length > 1) return pages;
        return false;
    }
    notifyResize() {}
    constructor(mainSite, ctx, sensorId, label){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.sensorId = sensorId;
        this.EXCURSION_PARAM_ID = 'Buoy_Excursion/m';
        this.LATITUDE_PARAM_ID = 'Buoy_Latitude/deg';
        this.id = 'waves';
        this.label = 'Waves';
        this.currentProfileSensor = null;
        this.currentProfileParam = null;
        // if sensorId is not set to null, update label and id to distinguish the pages
        if (this.sensorId !== null) {
            this.label += ` (${label})`;
            this.id += `${this.sensorId}`;
        }
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        if (this.mainSite.basicViewSelectorBool) this.renderBasic(container, listeners);
        else this.renderAdvanced(container, listeners);
    }
    renderAdvanced(container, listeners) {
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('width', '31em').appendTo(page);
        var rightPanel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('left', '33em').css('width', '31em').appendTo(page);
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo(rightPanel);
        let spectrumBox = $('<div class="site-obs-waves-charts" data-chart-type="spectrum"></div>').appendTo(rightPanel).hide();
        let polarSpectrumBox = $('<div class="site-obs-waves-charts" data-chart-type="polar-spectrum"></div>').appendTo(rightPanel).hide();
        let polarBox = $('<div class="site-obs-waves-charts" data-chart-type="polar"></div>').appendTo(rightPanel).hide();
        let hovmollerBox = $('<div class="site-obs-waves-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Hovm\xf6ller chart...</em></div>').appendTo(rightPanel).hide();
        let showChart = (chartType)=>{
            /*spectrumBox.hide();
            polarSpectrumBox.hide();
            polarBox.hide();
            hovmoller01Box.hide();*/ $('.site-obs-waves-charts').hide();
            $(`.site-obs-waves-charts[data-chart-type="${chartType}"]`).show();
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        if (this.station.Station.Id == 'Gibraltar_GasnorBuoy') {
            listeners.push(new (0, $52d6bce86430fe5d$export$4f523ffcb6a30798)(this, spectrumBox, 5, 0, 55, 100));
            listeners.push(new (0, $253714948e9c9b4f$export$81f55825d4ef8131)(this, polarSpectrumBox, 5, 0, 58, 100));
            listeners.push(new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 4, 0, 58, 100, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeanWaveDirection_deg.Id, true, this.sensorId));
        } else {
            listeners.push(new (0, $52d6bce86430fe5d$export$4f523ffcb6a30798)(this, spectrumBox, 5, 0, 55, 98));
            listeners.push(new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 4, 0, 58, 100, (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeanWaveDirection_deg.Id, true, this.sensorId));
        }
        if (this.sensorId == null) // search through available sensors and use the first one that had a "WaveSpectrum" or "WaveSpectrum/30min" parameter
        for(const sensorId in this.station.Sensors){
            const sensor = this.station.Sensors[sensorId];
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "WaveSpectrum")) {
                this.currentProfileSensor = sensorId;
                this.currentProfileParam = "WaveSpectrum";
                break;
            }
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "WaveSpectrum/30min")) {
                this.currentProfileSensor = sensorId;
                this.currentProfileParam = "WaveSpectrum_30min";
                break;
            }
        }
        else {
            // use the specified sensor
            const sensor = this.station.Sensors[this.sensorId];
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "WaveSpectrum")) this.currentProfileParam = "WaveSpectrum";
            if (Object.keys(sensor.Parameters).some((pid)=>pid == "WaveSpectrum/30min")) this.currentProfileParam = "WaveSpectrum_30min";
        }
        let hovmolOptions = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptions.tooltip = {
            headerFormat: "Spectral Density (m\xb2 / Hz)<br/>",
            pointFormat: '{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.2f} Hz</em>): <b>{point.value:.4f}</b>' //: https://api.highcharts.com/class-reference/Highcharts.Time#dateFormat
        };
        hovmolOptions.yAxis = {
            ...hovmolOptions.yAxis,
            title: {
                text: 'Frequency (Hz)'
            },
            reversed: false
        };
        hovmolOptions.colorAxis = {
            ...hovmolOptions.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    '#0000FF'
                ],
                [
                    0.33,
                    '#00FFFF'
                ],
                [
                    0.66,
                    '#FFFF00'
                ],
                [
                    1,
                    '#FF0000'
                ] // Red
            ]
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBox, 0, 0, 93, 100, //// specific chart options
        hovmolOptions, undefined, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            /*if (!this.mainSite.liveDataManager.latestData) {
                    console.warn('Current Hovmoller chart: waiting for live data..');
                    callback([], true);
                    return;
                }*/ if (this.currentProfileSensor == null || this.currentProfileParam == null) {
                console.warn('Wave Hovmoller chart: no wave spectrum sensor or param detected for this station.');
                callback([], false);
                return;
            }
            let sensor = this.currentProfileSensor;
            let parameter = this.currentProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${encodeURIComponent(sensor)}/${encodeURIComponent(parameter)}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info('Wave Hovmoller - data fetch URI:', uri);
            $.ajax(uri + '', {
                cache: false,
                dataType: 'json',
                type: 'GET',
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        console.info("Wave obs - Hovm\xf6ller chart data (RAW)", data);
                        // throw new Error('dev interrupt');
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let spectrum = JSON.parse(x[1]);
                                    let components = spectrum.Components.sort((a, b)=>b.CentralFrequency - a.CentralFrequency); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.SpectralDensity || isNaN(cp.SpectralDensity)) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: cp.CentralFrequency,
                                            val: cp.SpectralDensity
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            console.info("Wave obs - Hovm\xf6ller chart data", res);
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.currentProfileParam + " Spectrum Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        }, undefined, "Period (s)");
        listeners.push(this._chartsHovmoller);
        let tpul = $('<ul></ul>').append($('<span></span>').text("Chart: ")).appendTo(chartSelectTabs);
        tpul.append($('<li></li>').text("Spectrum").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            /*polarBox.hide();
                polarSpectrumBox.hide();
                spectrumBox.show();
                MainSite.instance.dispatchResize();*/ showChart('spectrum');
        }));
        if (this.station.Station.Id == 'Gibraltar_GasnorBuoy') tpul.append($('<li></li>').text("Polar Spectrum").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            /*spectrumBox.hide();
                    polarBox.hide();
                    polarSpectrumBox.show();
                    MainSite.instance.dispatchResize();*/ showChart('polar-spectrum');
        }));
        tpul.append($('<li></li>').text("Polar").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            /*spectrumBox.hide();
                polarSpectrumBox.hide();
                polarBox.show();
                MainSite.instance.dispatchResize();*/ showChart('polar');
        }));
        tpul.append($('<li></li>').text("Hovm\xf6ller").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            showChart('hovmoller');
        }));
        setTimeout(()=>{
            tpul.children('li').eq(1).trigger('click');
        }, 500);
        const buoySensorIds = [];
        for(let sensorId in this.station.Sensors){
            if (this.sensorId && sensorId !== this.sensorId) continue;
            const sensor = this.station.Sensors[sensorId];
            if (this.LATITUDE_PARAM_ID in sensor.Parameters) buoySensorIds.push(sensorId);
        }
        if (buoySensorIds.length > 0) {
            // for now this will just support a single buoy per station
            leftPanel.append($('<div class="midi_SiteObservations_dummy_header">Buoy Location</div>'));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Latitude_deg, this.sensorId), 5, 0, 6, 48, this.ctx, false, 1.5));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Longitude_deg, this.sensorId), 12, 0, 6, 48, this.ctx, false, 1.5));
            // build the buoy excursion panel
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter((x)=>x.StationId == this.station.Station.Id && x.SensorId == buoySensorIds[0] && x.ParameterId == this.EXCURSION_PARAM_ID);
            const excursionLimit = alerts.length == 0 ? null : alerts[0].MaxValue;
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $c15ea82cc17fe297$export$1f2f05723a7bdc27)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Excursion_m, buoySensorIds[0], excursionLimit), 0, 52, 18, 48, this.ctx));
        } else {
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_SeaElevation_m_Mean, this.sensorId), 0, 0, 18, 48, this.ctx));
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_SeaElevation_m_Max, this.sensorId), 0, 52, 18, 48, this.ctx));
        }
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m, this.sensorId), 20, 0, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m, this.sensorId), 20, 52, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Cmax_m, this.sensorId), 40, 0, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Cass_m, this.sensorId), 40, 52, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tz_s, this.sensorId), 60, 0, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).T2_s, this.sensorId), 60, 52, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s, this.sensorId), 80, 0, 18, 48, this.ctx));
        if (this.station.Station.Id === "NorthSea_HaeweneBrim" && this.sensorId == "SPOT-32515C") listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WaterTemp_degC, this.sensorId), 80, 52, 18, 48, this.ctx));
        else listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirGap_m, this.sensorId), 80, 52, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MeanWaveDirection_deg, this.sensorId), 60, 0, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).PeakWaveDirection_deg, this.sensorId), 60, 52, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MeanSpreading_deg, this.sensorId), 80, 0, 18, 48, this.ctx));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, rightPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).PeakSpreading_deg, this.sensorId), 80, 52, 18, 48, this.ctx));
        page.appendTo(container);
    }
    renderBasic(container, listeners) {
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var panel = $('<div></div>').css('position', 'absolute').css('height', '48em').css('width', '64em').appendTo(page);
        const buoySensorIds = [];
        for(let sensorId in this.station.Sensors){
            const sensor = this.station.Sensors[sensorId];
            if (this.LATITUDE_PARAM_ID in sensor.Parameters) buoySensorIds.push(sensorId);
        }
        if (buoySensorIds.length > 0) {
            // build the buoy excursion panel
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter((x)=>x.StationId == this.station.Station.Id && x.SensorId == buoySensorIds[0] && x.ParameterId == this.EXCURSION_PARAM_ID);
            const excursionLimit = alerts.length == 0 ? null : alerts[0].MaxValue;
            listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $c15ea82cc17fe297$export$1f2f05723a7bdc27)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Excursion_m, null, excursionLimit), 66.67, 0, 32, 48, this.ctx, true, 5));
        } else listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_SeaElevation_m_Mean), 66.67, 0, 32, 48, this.ctx, true, 5));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m), 0, 0, 32, 48, this.ctx, true, 5));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m), 0, 52, 32, 48, this.ctx, true, 5));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Tz_s), 33.33, 0, 32, 48, this.ctx, true, 5));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, panel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).MeanWaveDirection_deg), 33.33, 52, 32, 48, this.ctx, true, 5));
        page.appendTo(container);
    }
}










class $77f7a2c3c99b9671$export$f4c324a483e1bb34 {
    constructor(mainSite, page, sensorIds, container, top, left, height, width){
        this.mainSite = mainSite;
        this.page = page;
        this.stationId = page.station.Station.Id;
        this.sensorIds = sensorIds;
        var box = $('<div class="midi_SiteObservations_chart_container"></div>').css('position', 'absolute').css('top', top + '%').css('left', left + '%').css('height', height + '%').css('width', width + '%');
        container.append(box);
        this.chartContainer = $('<div></div>').css('height', '100%').appendTo(box);
        this.timeZoneString = this.mainSite.getTimeZoneString();
        this.drawChart();
        this.updateChart((0, $52db63ea8facb471$export$1a86835baa79d770).instance.liveDataManager.latestData);
    }
    liveDataChanged(latestData) {
        this.updateChart(latestData);
    }
    drawChart() {
        var yAxisOptions = [];
        yAxisOptions.push({
            title: {
                text: 'Speed (kts)'
            },
            min: 0,
            lineColor: '#666',
            //lineWidth: 1,
            gridLineColor: '#666',
            gridLineWidth: 0.5,
            gridLineDashStyle: 'solid'
        }, {
            title: {
                text: "Direction (\xb0T)"
            },
            min: 0,
            max: 360,
            opposite: true,
            lineColor: '#666',
            //lineWidth: 1,
            gridLineColor: '#666',
            gridLineWidth: 0.5,
            gridLineDashStyle: 'longdash',
            tickInterval: 90,
            minTickInterval: 90,
            alignTicks: false
        });
        this.chartContainer.highcharts({
            chart: {
                type: 'line',
                backgroundColor: '#FFF',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime',
                ordinal: false,
                lineWidth: 0,
                lineColor: '#666'
            },
            yAxis: yAxisOptions,
            legend: {
                enabled: true
            },
            plotOptions: {
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    }
                }
            },
            credits: {
                enabled: false
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + this.timeZoneString,
                valueDecimals: 0
            }
        });
        this.chart = this.chartContainer.highcharts();
        this.chart.showLoading('Getting data...');
    }
    static getSeriesColor(index, lighten = false) {
        // only need to support four
        switch(index){
            case 0:
                if (lighten) return 'rgba(255, 60, 60, 0.8)';
                return 'rgba(255, 0, 0, 0.8)';
            case 1:
                if (lighten) return 'rgba(40, 60, 255, 0.8)';
                return 'rgba(0, 0, 255, 0.8)';
            case 2:
                if (lighten) return 'rgba(60, 255, 60, 0.8)';
                return 'rgba(0, 255, 0, 0.8)';
            default:
                if (lighten) return 'rgba(127, 60, 255, 0.8)';
                return 'rgba(127, 0, 255, 0.8)';
        }
    }
    updateChart(latestData) {
        if (!latestData) return;
        var seriesOptions = {};
        var toMoment = moment.utc();
        var fromMoment = moment.utc().subtract(3, 'h'); // 2 hours ago
        var anyData = false;
        var maxParamCount = 3 * this.sensorIds.length;
        var accountedParamCount = 0;
        this.sensorIds.forEach((sensorId, index)=>{
            seriesOptions[sensorId] = [];
            // find the correct parameter for this sensor ID
            var windSpeedParam = null;
            ///[ParameterGroupInfoSet.WindSpeed_kts_10min.Id, ParameterGroupInfoSet.WindSpeed_kts_1min.Id].some(id => {
            [
                this.page.windSpeedGroup10min.Id,
                this.page.windSpeedGroup1min.Id
            ].some((id)=>{
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some((value)=>{
                        if (value.Sensor == sensorId) {
                            windSpeedParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });
                    return true;
                }
            });
            var gustSpeedParam = null;
            ///[ParameterGroupInfoSet.GustSpeed_kts_10min.Id, ParameterGroupInfoSet.GustSpeed_kts_1min.Id].some(id => {
            [
                this.page.gustSpeedGroup10min.Id,
                this.page.gustSpeedGroup1min.Id
            ].some((id)=>{
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some((value)=>{
                        if (value.Sensor == sensorId) {
                            gustSpeedParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });
                    return true;
                }
            });
            var windDirParam = null;
            [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg_10min.Id,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg_1min.Id
            ].some((id)=>{
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some((value)=>{
                        if (value.Sensor == sensorId) {
                            windDirParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });
                    return true;
                }
            });
            if (windSpeedParam) (0, $fd959835eca46177$export$9bf04fc316538454)('P', this.stationId, sensorId, windSpeedParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                if (err) {
                    console.warn('Wind Chart - Error getting data: ', err);
                    this.chart.showLoading('Error getting data...');
                    return;
                }
                anyData = anyData || data.Data !== null;
                if (data.Data !== null) {
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                seriesOptions[sensorId].push({
                    ///id: ParameterGroupInfoSet.WindSpeed_kts.Id,
                    id: this.page.windSpeedGroup.Id,
                    color: $77f7a2c3c99b9671$export$f4c324a483e1bb34.getSeriesColor(index, true),
                    name: "Speed (kts) - " + sensorId,
                    data: data.Data,
                    dashStyle: 'dot',
                    zIndex: index == 0 ? 2 : 1,
                    lineWidth: 1,
                    marker: {
                        enabled: false
                    },
                    yAxis: 0
                });
                accountedParamCount++;
                if (accountedParamCount == maxParamCount) {
                    if (anyData) this.replaceChartSeries(seriesOptions);
                    else this.chart.showLoading('Data not available');
                }
            }, 0);
            else accountedParamCount++;
            if (gustSpeedParam) (0, $fd959835eca46177$export$9bf04fc316538454)('P', this.stationId, sensorId, gustSpeedParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                if (err) {
                    console.warn('Wind Chart - Error getting data: ', err);
                    this.chart.showLoading('Error getting data...');
                    return;
                }
                anyData = anyData || data.Data !== null;
                if (data.Data !== null) {
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                seriesOptions[sensorId].push({
                    ///id: ParameterGroupInfoSet.GustSpeed_kts.Id,
                    id: this.page.gustSpeedGroup.Id,
                    color: $77f7a2c3c99b9671$export$f4c324a483e1bb34.getSeriesColor(index),
                    name: "Gust (kts) - " + sensorId,
                    data: data.Data,
                    zIndex: index == 0 ? 2 : 1,
                    lineWidth: 1,
                    marker: {
                        enabled: false
                    },
                    yAxis: 0
                });
                accountedParamCount++;
                if (accountedParamCount == maxParamCount) {
                    if (anyData) this.replaceChartSeries(seriesOptions);
                    else this.chart.showLoading('Data not available');
                }
            }, 0);
            else accountedParamCount++;
            if (windDirParam) (0, $fd959835eca46177$export$9bf04fc316538454)('P', this.stationId, sensorId, windDirParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err, data)=>{
                if (err) {
                    console.warn('Wind Chart - Error getting data: ', err);
                    this.chart.showLoading('Error getting data...');
                    return;
                }
                anyData = anyData || data.Data !== null;
                if (data.Data !== null) {
                    data.Data.unshift([
                        fromMoment.valueOf(),
                        null
                    ]);
                    data.Data.push([
                        toMoment.valueOf(),
                        null
                    ]);
                }
                seriesOptions[sensorId].push({
                    id: (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg.Id,
                    color: $77f7a2c3c99b9671$export$f4c324a483e1bb34.getSeriesColor(index),
                    name: "Dir (kts) - " + sensorId,
                    data: data.Data,
                    lineWidth: 0,
                    zIndex: index == 0 ? 2 : 1,
                    marker: {
                        enabled: true,
                        radius: 2,
                        symbol: 'diamond'
                    },
                    yAxis: 1
                });
                accountedParamCount++;
                if (accountedParamCount == maxParamCount) {
                    if (anyData) this.replaceChartSeries(seriesOptions);
                    else this.chart.showLoading('Data not available');
                }
            }, 0);
            else accountedParamCount++;
        });
    }
    replaceChartSeries(seriesOptions) {
        this.chart.hideLoading();
        if (this.chart.series.length < 1) for(var sensorId in seriesOptions)seriesOptions[sensorId].forEach((series)=>{
            this.chart.addSeries(series);
        });
        else for(var sensorId in seriesOptions)seriesOptions[sensorId].forEach((series)=>{
            var cs = this.chart.get(series.id);
            cs.setData(series.data);
        });
        this.chart.reflow();
    }
}



class $fbcc2746e7715d0d$export$de16a60c2b9aa29e {
    isValidSensorId(sensorId, station) {
        // Leave out forecasts
        if (sensorId.includes("orecast")) return false;
        const sensor = station.Sensors[sensorId];
        if (!sensor.UseLiveData) return false;
        for(let paramId in sensor.Parameters)// if either a WindSpeed or WindDirection parameter is present, we consider it to be a wind sensor
        if (paramId.indexOf("WindSpeed") > -1 || paramId.indexOf("WindDirection") > -1) {
            // Check if the non-10m version is valid
            if (paramId.indexOf('Wind') != -1 && paramId.indexOf('_10m_') == -1 && this.is10m != true) return true;
            // Check if the 10m version is valid
            if (paramId.indexOf('Wind') != -1 && paramId.indexOf('_10m_') != -1 && this.is10m == true) return true;
        }
        return false;
    }
    show(station) {
        this.validSensorIds = [];
        // Show this page if: station has any windSensors (which are not forecasts)
        for(let sensorId in station.Sensors)if (this.isValidSensorId(sensorId, station)) this.validSensorIds.push(sensorId);
        if (this.validSensorIds.length > 0) return true;
        else return false;
    }
    constructor(mainSite, ctx, is10m = false){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.is10m = is10m;
        this.id = 'wind';
        this.label = 'Wind';
        this.polarCharts = [];
        this.windSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts;
        this.gustSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts;
        this.windSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_1min;
        this.gustSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_1min;
        this.windSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10min;
        this.gustSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10min;
        this.windCompasses = [];
        if (this.is10m == true) {
            this.label += ' (10m)';
            this.id += '10m';
            this.windSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m;
            this.gustSpeedGroup = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m;
            this.windSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m_1min;
            this.gustSpeedGroup1min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m_1min;
            this.windSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts_10m_10min;
            this.gustSpeedGroup10min = (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts_10m_10min;
        }
    }
    notifyResize() {
        this.windCompasses.forEach((compass)=>compass.drawCompass());
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo(page);
        var windSensors = [];
        var combinedWindSensor = null;
        for (var sensorId of this.validSensorIds){
            var sensor = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[station.Station.Id].Sensors[sensorId];
            if (sensor.SensorDefinition && sensor.SensorDefinition.Combined) combinedWindSensor = sensorId;
            else windSensors.push(sensorId);
        }
        windSensors.sort(); // sort alphabetically.
        if (combinedWindSensor) windSensors.unshift(combinedWindSensor);
        if (windSensors.length <= 4) {
            let tpul = $('<ul></ul>').append($('<span></span>').text("Chart type: ")).appendTo(chartSelectTabs);
            var topPanel = $('<div></div>').css('position', 'absolute').css('height', '25em').css('width', '64em').appendTo(page);
            //adding the time selector
            let allowedTimePeriods = [
                24,
                168,
                720
            ];
            let timePeriodSelector = $('<div class="current_chart_selector"></div>').css('margin-top', '30px').append($('<span></span>').text("Time period: ")).appendTo(topPanel);
            let timeSelector = $('<ul></ul>').appendTo(timePeriodSelector);
            allowedTimePeriods.forEach((a)=>{
                timeSelector.append($('<li></li>').text((0, $976af8e0bfbb0494$export$418e8f8fe20901f6).formatHoursToDays(a)).attr('hours', a).click((ev)=>{
                    timeSelector.children('li').removeClass('selected');
                    $(ev.target).addClass("selected");
                    this.selectedHours = parseInt($(ev.target).attr('hours'));
                    //update all charts for each sensor
                    for (var pch of this.polarCharts){
                        pch.setSelectedHours(this.selectedHours);
                        pch.updateChart(this.selectedHours, true);
                    }
                }));
            });
            let compassBox = $('<div></div>').appendTo(topPanel);
            let polarBox = $('<div></div>').appendTo(topPanel);
            tpul.append($('<li></li>').text("Compass").click((ev)=>{
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                polarBox.hide();
                timePeriodSelector.hide();
                compassBox.show();
                (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
            }));
            tpul.append($('<li></li>').text("Polar").click((ev)=>{
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                compassBox.hide();
                timePeriodSelector.show();
                timeSelector.children('li').first().click();
                polarBox.show();
                (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
            }));
            tpul.children('li').first().click();
            const chartWidth = 25;
            const padding = (100 - chartWidth * windSensors.length) / (windSensors.length + 1);
            // adaptive compass tab & polar tab filled with charts
            console.info('Wind Tab - windSensors: ', windSensors, this);
            windSensors.forEach((sensorId, index)=>{
                const left = (chartWidth + padding) * index + padding;
                this.renderCompassSensor(sensorId, listeners, compassBox, left, chartWidth);
                const pch = new (0, $976af8e0bfbb0494$export$418e8f8fe20901f6)(this.mainSite, this, polarBox, 15, left, 95, chartWidth, this.windSpeedGroup.Id, (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg.Id, false, sensorId);
                this.polarCharts.push(pch);
                listeners.push(pch);
            });
            // bottom-chart
            var bottomPanel = $('<div></div>').css('position', 'absolute').css('bottom', 0).css('height', '21em').css('width', '64em').appendTo(page);
            listeners.push(new (0, $77f7a2c3c99b9671$export$f4c324a483e1bb34)(this.mainSite, this, windSensors, bottomPanel, 0, 0, 100, 100));
        } else {
            // table view only
            var leftPanel = $('<div></div>').css('position', 'absolute').css('height', '95%').css('width', '100%').appendTo(page);
            $('<div class="midi_SiteObservations_wind_sensor_table_header"></div>').appendTo(leftPanel);
            var height = 94 / windSensors.length;
            $('<div class="midi_SiteObservations_wind_sensor_table_header midi_SiteObservations_wind_sensor_table_header_top_row" style="top: 0%; left: 31%;">Dir (10 min)</div>').appendTo(leftPanel);
            $('<div class="midi_SiteObservations_wind_sensor_table_header midi_SiteObservations_wind_sensor_table_header_top_row" style="top: 0%; left: 54%;">Spd (10 min)</div>').appendTo(leftPanel);
            $('<div class="midi_SiteObservations_wind_sensor_table_header midi_SiteObservations_wind_sensor_table_header_top_row" style="top: 0%; left: 77%;">Gust (10 min)</div>').appendTo(leftPanel);
            windSensors.forEach((sensorId, index)=>{
                var levelText = "";
                var sensor = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[this.station.Station.Id].Sensors[sensorId];
                if (sensor.SensorDefinition && sensor.SensorDefinition.Level) levelText = '@ ' + sensor.SensorDefinition.Level;
                var top = 6 + height * index;
                $('<div class="midi_SiteObservations_wind_sensor_table_header midi_SiteObservations_wind_sensor_table_header_param"></div>').append($('<div>').text(sensorId).append('<br />').append($('<span>').text(levelText))).css('height', height + '%').css('top', top + '%').appendTo(leftPanel);
                listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg_10min, sensorId), top, 31, height, 23, this.ctx, false, 2));
                listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.windSpeedGroup10min, sensorId), top, 54, height, 23, this.ctx, false, 2));
                listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, leftPanel, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.gustSpeedGroup10min, sensorId), top, 77, height, 23, this.ctx, false, 2));
            });
        }
        page.appendTo(container);
    }
    renderCompassSensor(sensorId, listeners, topPanel, left, width) {
        // compass
        var windCompass = new (0, $230b365548c7ce86$export$8d94490d1ec4a850)(this, topPanel, 0, left, 53, width, sensorId, this.is10m);
        listeners.push(windCompass);
        this.windCompasses.push(windCompass);
        // boxes
        var boxesContainer = $('<div></div>').css('position', 'absolute').css('height', '45%').css('width', width + '%').css('left', left + '%').css('bottom', '0').appendTo(topPanel);
        $('<div class="midi_SiteObservations_wind_sensor_header"></div>').appendTo(boxesContainer);
        $('<div class="midi_SiteObservations_wind_sensor_header midi_SiteObservations_wind_sensor_header_param" style="top: 13%;">Dir<br /><span>\xb0T</span></div>').appendTo(boxesContainer);
        $(`<div class="midi_SiteObservations_wind_sensor_header midi_SiteObservations_wind_sensor_header_param" style="top: 42%;">Spd<br /><span>${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.windSpeedGroup10min.Units, this.windSpeedGroup10min.Id)}</span></div>`).appendTo(boxesContainer);
        $(`<div class="midi_SiteObservations_wind_sensor_header midi_SiteObservations_wind_sensor_header_param" style="top: 71%;">Gust<br /><span>${(0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(this.gustSpeedGroup.Units, this.gustSpeedGroup.Id)}</span></div>`).appendTo(boxesContainer);
        $('<div class="midi_SiteObservations_wind_sensor_header midi_SiteObservations_wind_sensor_header_top_row" style="top: 0%; left: 24%;">1 min</div>').appendTo(boxesContainer);
        $('<div class="midi_SiteObservations_wind_sensor_header midi_SiteObservations_wind_sensor_header_top_row" style="top: 0%; left: 62%;">10 min</div>').appendTo(boxesContainer);
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg_1min, sensorId), 13, 24, 29, 38, this.ctx, false, 2));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.windSpeedGroup1min, sensorId), 42, 24, 29, 38, this.ctx, false, 2));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.gustSpeedGroup1min, sensorId), 71, 24, 29, 38, this.ctx, false, 2));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg_10min, sensorId), 13, 62, 29, 38, this.ctx, false, 2));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.windSpeedGroup10min, sensorId), 42, 62, 29, 38, this.ctx, false, 2));
        listeners.push(new (0, $92d61d72cc040b2d$export$dd3ff450a300a06e)(this, boxesContainer, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.gustSpeedGroup10min, sensorId), 71, 62, 29, 38, this.ctx, false, 2));
    }
}






class $a452c408be3441c9$export$76d9abc56c943850 {
    notifyResize() {}
    show(station) {
        this.windProfileSensor = null;
        this.windProfileParam = null;
        for(let sensorId in station.Sensors){
            const sensor = station.Sensors[sensorId];
            for(let paramId in sensor.Parameters)if (paramId.indexOf('WindProfile_mps') != -1) {
                this.windProfileSensor = sensorId;
                this.windProfileParam = paramId;
                return true;
            }
        }
        return false;
    }
    constructor(mainSite, ctx){
        this.mainSite = mainSite;
        this.ctx = ctx;
        this.id = 'wind_profile';
        this.label = 'Wind Profile';
        this.windProfileSensor = null;
        this.windProfileParam = null;
    }
    render(container, listeners, station, warningGroup) {
        this.station = station;
        this.warningGroup = warningGroup;
        let showChart = (chartType)=>{
            $('.site-obs-windprofile-charts').hide();
            $(`.site-obs-windprofile-charts[data-chart-type="${chartType}"]`).show();
            (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        };
        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');
        var rightPanel = $('<div style="position: relative; width: 100%; height: 100%;"></div>').appendTo(page);
        let chartSelectTabs = $('<div class="current_chart_selector"></div>').appendTo(rightPanel);
        let tpul = $('<ul></ul>').append($('<span></span>').text("Chart: ")).appendTo(chartSelectTabs);
        tpul.append($('<li></li>').addClass('selected').text("Wind Profile").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            showChart('wind-profile');
        }));
        tpul.append($('<li></li>').text("Color Flood").click((ev)=>{
            tpul.children('li').removeClass('selected');
            $(ev.target).addClass("selected");
            showChart('hovmoller');
        }));
        let currentBox = $('<div class="site-obs-windprofile-charts" data-chart-type="wind-profile"></div>').appendTo(rightPanel);
        let hovmollerBox = $('<div class="site-obs-windprofile-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(rightPanel).hide();
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
        listeners.push(new (0, $9616a178b649c555$export$7a7236f9a7498ef8)(this, currentBox, 5, 0, 95, 100, (0, $29e97a05b53d587e$export$d95ff4a11a6fe4f9).mps, "Wind", (0, $9616a178b649c555$export$861facf577d6ed7a).Height));
        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = 'm/s';
        var unitsStrDepthOrHeight = 'm';
        let unitsConversionSet_DepthOrHeight = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet('m');
        let unitsConversionSet_Speed = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight = (value)=>value;
        let ucf_Speed = (value)=>value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }
        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Height (${unitsStrDepthOrHeight})`
            }
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [
                    0,
                    '#0000FF'
                ],
                [
                    0.33,
                    '#00FFFF'
                ],
                [
                    0.66,
                    '#FFFF00'
                ],
                [
                    1,
                    '#FF0000'
                ] // Red
            ]
        };
        // Direction: Options specific to direction chart
        let hovmolOptionsDirection = (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c).chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Height (${unitsStrDepthOrHeight})`
            }
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [
                    0.0,
                    'rgb(255, 0, 0)'
                ],
                [
                    0.25,
                    'rgb(160, 32, 240)'
                ],
                [
                    0.5,
                    'rgb(0, 0, 255)'
                ],
                [
                    0.75,
                    'rgb(252, 186, 3)'
                ],
                [
                    1.0,
                    'rgb(255, 0, 0)'
                ]
            ],
            //tickInterval: 180,
            tickPositions: [
                0,
                90,
                180,
                270,
                360
            ],
            startOnTick: true,
            endOnTick: true
        };
        this._chartsHovmoller = new (0, $820c3ae16a934ae3$export$1df338bf50bb9e2c)(this.mainSite, this, hovmollerBox, 0, 0, 93, 100, //// specific chart options
        hovmolOptionsSpeed, hovmolOptionsDirection, //// getDataMethod
        (tsFrom, tsTo, isSpeed, extractProfileCmpValue, chart, callback)=>{
            let res = [];
            /*if (!this.mainSite.liveDataManager.latestData) {
                    console.warn('Current Hovmoller chart: waiting for live data..');
                    callback([], true);
                    return;
                }*/ if (this.windProfileSensor == null || this.windProfileParam == null) {
                console.warn('Wind Hovmoller chart: no wind profile sensor or param detected for this station.');
                callback([], false);
                return;
            }
            let sensor = this.windProfileSensor;
            let parameter = this.windProfileParam;
            let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${sensor}/${parameter}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
            console.info('Wind Hovmoller - data fetch URI:', uri);
            $.ajax(uri + '', {
                cache: false,
                dataType: 'json',
                type: 'GET',
                timeout: 30000,
                success: (data, text, jqXHR)=>{
                    try {
                        console.info('Wind obs - Color Flood chart data (RAW)', data);
                        if (Array.isArray(data.results[0].series[0].values)) {
                            for(let i = 0; i < data.results[0].series[0].values.length; i++){
                                let x = data.results[0].series[0].values[i];
                                let m = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                if (m && m.isValid()) {
                                    let profile = JSON.parse(x[1]);
                                    let components = profile.Components.sort((a, b)=>b.Height - a.Height); //: TODO: check sorting!!
                                    components.forEach((cp, cpi)=>{
                                        if (!cp.Speed || isNaN(cp.Speed)) return;
                                        res.push({
                                            timestamp: m.valueOf(),
                                            y: ucf_DepthOrHeight(cp.Height),
                                            val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction
                                        });
                                    });
                                } else console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                            }
                            console.info('Current obs - Color Flood chart data', res);
                            callback(res, false);
                        }
                    } catch (err) {
                        console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: ", err);
                        callback([], true);
                    }
                },
                error: (jqXHR, textStatus, errorThrown)=>{
                    console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: ", errorThrown);
                    callback([], true);
                }
            });
        });
        listeners.push(this._chartsHovmoller);
        page.appendTo(container);
        (0, $52db63ea8facb471$export$1a86835baa79d770).instance.dispatchResize();
    }
}


class $6feb48abab9d78f7$export$432915b0d85cff8d {
    static getLandingPageId(station) {
        if (station.Region == 'GOM') return "gomdashboard";
        return "overview";
    }
    constructor(mainSite){
        this.mainSite = mainSite;
        this.pageParams = [];
        this.id = 'siteObs';
        this.container = null;
        this.latestTimestamp = null;
        this.stationSchema = null;
        this.navBar = null;
        this.listeners = [];
        this.GOMAverageslisteners = [];
        this.timestampContainer = $('<span></span>').text("Waiting for data...");
        // console.log('this.stationSchema.Station.Id: ', this.stationSchema.Station.Id)
        // console.log('mainSite.staticDataManager.Schema.ParameterSchema.Stations: ', mainSite.staticDataManager.Schema.ParameterSchema.Stations)
        console.log('mainSite: ', mainSite);
        // console.log('mainSite.staticDataManager: ', mainSite.staticDataManager.Schema)
        console.log();
        //const [dataContext, setDataContext] = React.useState<any>({
        //    "station": this.station,
        //    "warningGroup": this.warningGroup,
        //    "mainSite": this.mainSite
        //})
        this.pages = [
            new (0, $7b073b47882e0060$export$d7a9e6ef755e50e3)(mainSite, this),
            new (0, $cfc778b093ef38e6$export$c2a25abbb6f13dfd)(mainSite, this),
            new (0, $f6f4484e30910318$export$517de9992f3047ca)(mainSite, this),
            new (0, $989bc1d7921dc690$export$3f008f9f514cfb66)(mainSite, this, null, null),
            new (0, $29e97a05b53d587e$export$856f0d8f68e923ca)(mainSite, this, null, null),
            //new GOMCurrent(mainSite, this, null, null),
            new (0, $ae8320e57e7409f2$export$65c1f044ef715ed6)(mainSite, this, null, null),
            new (0, $c8ad0c2f85751db1$export$ab7b018719e111db)(mainSite, this),
            new (0, $fbcc2746e7715d0d$export$de16a60c2b9aa29e)(mainSite, this, false),
            new (0, $fbcc2746e7715d0d$export$de16a60c2b9aa29e)(mainSite, this, true),
            new (0, $a452c408be3441c9$export$76d9abc56c943850)(mainSite, this),
            new (0, $9fd163093c59f270$export$64fb232f890f656)(mainSite, this),
            new (0, $903655cded51f011$export$4bc7a197e343fa41)(mainSite, this),
            new (0, $21491803b5ad198a$export$31eea0956932282a)(mainSite, this),
            new (0, $473e2d8a793f7d7c$export$bf09cc4465ad5e98)(mainSite, this),
            new (0, $2eddda48735b4d6b$export$f226cbd59d010ecc)(mainSite, this)
        ];
    }
    initialize() {
        this.mainSite.liveDataManager.addListener(this);
        this.mainSite.GOMAveragesManager.addListener(this);
        $(window).resize(()=>{
            this.resizeWindow();
        });
    }
    liveDataChanged(latestData) {
        this.listeners.forEach((listener)=>{
            listener.liveDataChanged(latestData, this);
        });
    }
    GOMAveragesChanged(latestData) {
        this.GOMAverageslisteners.forEach((listener)=>{
            listener.GOMAveragesChanged(latestData);
        });
    }
    resizeWindow() {
        // always 64 em across and 48 down, 4:3 aspect ratio
        if (this.container) {
            var width_limited_px = 16 * this.container.width() / 1024;
            var height_limited_px = 16 * (window.innerHeight - 104) / 768; // adjustment for top bar
            $('.midi_SiteObservations_padded_page_content').css('font-size', Math.min(height_limited_px, width_limited_px) + 'px');
            if (this.page) this.page.notifyResize();
        }
    }
    handleHashChange(hashData) {
        this.latestTimestamp = null;
        if (this.navBar) {
            this.container.remove();
            if (this.page.containerOverride) this.page.containerOverride.remove();
            this.page = null;
            this.navBar = null;
        }
        //console.log("[SiteObservations] hashData.Page: ", hashData.Page)
        //console.log("[SiteObservations] hashData.Page === this.id: ", hashData.Page === this.id)
        if (hashData.Page === this.id) {
            this.container = $('<div class="container"></div>').appendTo('body');
            this.navBar = $('<ul class="midi_SiteObservations_nav nav nav-pills"></ul>');
            this.navBar.append($('<li></li>').append($('<a class="midi_SiteObservations_nav_timestamp"></a>').append(this.timestampContainer)));
            this.listeners = [];
            this.GOMAverageslisteners = [];
            this.stationSchema = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.mainSite.hashData.PageSpecificData.Station];
            const filteredPages = [];
            for (const page of this.pages){
                const showResult = page.show(this.stationSchema);
                if (Array.isArray(showResult)) // If page.show() returns an array then this will be a station-specific page set
                filteredPages.push(...showResult);
                else if (showResult) // Otherwise page.show() just returns a boolean which defines whether to show the page
                filteredPages.push(page);
            }
            if (filteredPages.length == 0) filteredPages.push(this.pages[0]);
            if (!filteredPages.some((x)=>x.id == hashData.PageSpecificData.Tab)) // if the hash data points to no page or an invalid page, then use the first
            hashData.PageSpecificData.Tab = filteredPages[0].id;
            filteredPages.forEach((page)=>{
                ((page)=>{
                    var link = $('<a href="#"></a>').text(page.label).click((e)=>{
                        this.latestTimestamp = null;
                        hashData.PageSpecificData.Tab = page.id;
                        $(e.target).attr('href', this.mainSite.hashDataManager.encode(hashData));
                    });
                    if (page.id == hashData.PageSpecificData.Tab) link.addClass('selected');
                    this.navBar.append($('<li></li>').append(link));
                })(page);
                //console.log("[SiteObservations] page.id: ", page.id)
                //console.log("[SiteObservations] page.id == hashData.PageSpecificData.Tab: ", page.id == hashData.PageSpecificData.Tab)
                if (page.id == hashData.PageSpecificData.Tab) {
                    this.navBar.appendTo(this.container);
                    //console.log("[SiteObservations] typeof page.render: ", typeof page.render)
                    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules, this.GOMAverageslisteners);
                    //try {
                    //    console.log("[SiteObservations] render a")
                    //    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules, this.GOMAverageslisteners);
                    //} catch {
                    //    console.log("[SiteObservations] render b")
                    //    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules);
                    //}
                    this.page = page;
                    this.container.focus();
                }
            });
            if (!this.page) {
                alert('Error loading page: Invalid Station or Tab');
                this.mainSite.changePage('map');
            }
            this.resizeWindow();
            $(window).resize();
            return true;
        } else return false;
    }
    valueChanged(vo) {
        let timestamp = vo.Timestamp;
        let hasChanged = false;
        if (!this.latestTimestamp) {
            this.latestTimestamp = timestamp;
            hasChanged = true;
        } else if (timestamp > this.latestTimestamp) {
            this.latestTimestamp = timestamp;
            hasChanged = true;
        }
        if (hasChanged) {
            if (this.latestTimestamp) this.timestampContainer.text(this.mainSite.getDisplayTime(this.latestTimestamp, this.stationSchema.Station.TimeZone));
            else this.timestampContainer.text("Waiting for data...");
        }
    }
}








class $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1 extends (0, $bfbbca38eee2856d$export$3f0be2c6920005ae) {
    constructor(mainSite, container, valueFormatter, liveDataStation, warningRules, openPopups){
        super(mainSite), this.mainSite = mainSite;
        this.station = liveDataStation.Station;
        this.valueFormatter = valueFormatter;
        var valueObject = valueFormatter.format(liveDataStation, warningRules);
        var cell = $('<td></td>').appendTo(container).attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.').click((e)=>{
            this.renderPopup(e, openPopups);
        });
        cell.append($('<div class="midi_mapPage_popup_table_group_name"></div>').append(valueFormatter.getShortName()));
        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        cell.append($('<div class="midi_mapPage_popup_table_group_value"></div>').append(valueObject.Value));
        if (valueObject.Status === null || valueObject.Status === (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) {
            cell.css('font-size', '0.8em');
            return;
        }
        if (valueObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) cell.addClass('midi_siteObsPage_expiring');
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) cell.addClass('midi_siteObsPage_exceeded_threshold_3');
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) cell.addClass('midi_siteObsPage_exceeded_threshold_2');
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) cell.addClass('midi_siteObsPage_exceeded_threshold_1');
        var unitsString = '';
        if (valueFormatter.getUnits()) unitsString = valueFormatter.getUnits();
        if (valueObject.ParameterDefinition && valueObject.ParameterDefinition.Suffix) {
            var suffixString = valueObject.ParameterDefinition.Suffix;
            if (unitsString != '') suffixString += ', ';
            unitsString = suffixString + unitsString;
        }
        cell.append($('<div class="midi_mapPage_popup_table_group_units"></div>').append(unitsString));
    }
}


class $ea7b1f13ba3fabef$export$c6b5894e5fbdc000 {
    //private popupTitle: JQuery;
    constructor(mainSite, stationId, pixel, latestData, openPopups){
        this.mainSite = mainSite;
        this.openPopups = openPopups;
        this.mouseIn = false;
        // builds an empty popup, and puts it in the right place. NOTE this doesn't actually appear to affect the position of the popup as, at the time
        // of rendering, the popup is empty (and so outerHeight is 0).
        this.stationId = stationId;
        //this.openPopups = [];
        var warningGroup = this.mainSite.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.mainSite.hashData.WarningGroup];
        if (typeof warningGroup !== 'undefined') this.warningGroup = warningGroup;
        var mouseX = pixel[0];
        var mouseY = pixel[1];
        this.popup = $('<div class="midi_mapPage_popup_info"></div>').appendTo('body');
        this.popup.mouseleave(()=>{
            this.mouseIn = false;
        });
        this.popup.mouseenter(()=>{
            this.mouseIn = true;
        });
        this.refreshData(latestData);
        if (mouseY + this.popup.outerHeight(true) >= $(window).height() && mouseX + this.popup.outerWidth(true) >= $(window).width()) this.popup.css({
            "top": mouseY - this.popup.outerHeight(true),
            "left": mouseX - this.popup.outerWidth(true)
        });
        else if (mouseY + this.popup.outerHeight(true) >= $(window).height()) this.popup.css({
            "top": mouseY - this.popup.outerHeight(true),
            "left": mouseX
        });
        else if (mouseX + this.popup.outerWidth(true) >= $(window).width()) this.popup.css({
            "top": mouseY,
            "left": mouseX - this.popup.outerWidth(true)
        });
        else this.popup.css({
            "top": mouseY,
            "left": mouseX
        });
    }
    getParameterGroupValue(station, parameterGroup) {
        var val = station.GroupValues[parameterGroup.Id][0];
        if (typeof val == "undefined") return null;
        return val.Value;
    }
    refreshData(latestData) {
        // redraws the data part of the popup
        if (this.popupData) this.popupData.remove();
        var station = latestData.Stations[this.stationId];
        this.popupData = $('<div></div>');
        $('<div class="midi_mapPage_popup_header"><span>' + station.Station.Label + '</span> - Latest Observations</div>').appendTo(this.popupData);
        this.table = $('<table class="midi_mapPage_popup_table"></table>').appendTo(this.popupData);
        var topRow = $('<tr></tr>').appendTo(this.table);
        var dirBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, topRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg), station, this.mainSite.selectedWarningRules, this.openPopups);
        var speedBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, topRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts), station, this.mainSite.selectedWarningRules, this.openPopups);
        var gustBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, topRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts), station, this.mainSite.selectedWarningRules, this.openPopups);
        var middleTopRow = $('<tr></tr>').appendTo(this.table);
        var tempBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleTopRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC), station, this.mainSite.selectedWarningRules, this.openPopups);
        var dpBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleTopRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).DewPoint_degC), station, this.mainSite.selectedWarningRules, this.openPopups);
        var qnhBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleTopRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar), station, this.mainSite.selectedWarningRules, this.openPopups);
        var middleBottomRow = $('<tr></tr>').appendTo(this.table);
        var visBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleBottomRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m), station, this.mainSite.selectedWarningRules, this.openPopups);
        var cldAmtBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleBottomRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover), station, this.mainSite.selectedWarningRules, this.openPopups);
        var cldHtBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, middleBottomRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft), station, this.mainSite.selectedWarningRules, this.openPopups);
        var bottomRow = $('<tr></tr>').appendTo(this.table);
        var presentWeatherBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, bottomRow, new (0, $49efe750b1982432$export$8ba89689dcbc989e)(), station, this.mainSite.selectedWarningRules, this.openPopups);
        var hsBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, bottomRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m), station, this.mainSite.selectedWarningRules, this.openPopups);
        var tzBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, bottomRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.mainSite.selectedRegion.Id == "GOM" ? (0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s : (0, $24b391ec3014929b$export$5d65fdcfff509e37).T2_s), station, this.mainSite.selectedWarningRules, this.openPopups);
        var fifthRow = $('<tr></tr>').appendTo(this.table);
        var currentSpeedBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, fifthRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean), station, this.mainSite.selectedWarningRules, this.openPopups);
        var currentDirectionBox = new (0, $0bcc74251a76fdb3$export$6f6ac929ed8cd0a1)(this.mainSite, fifthRow, new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean), station, this.mainSite.selectedWarningRules, this.openPopups);
        this.popupData.appendTo(this.popup);
    }
    remove() {
        this.popup.remove();
    }
}


class $5fa05bf4f86fed5f$export$213b832c8898a3e1 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'map';
        this.container = null;
        this.dropdownContainer = null;
        this.dropdownContainerSelectVal = null;
        this.dropdownContainerSelectValSpan = null;
        this.layerMenuContainer = null;
        this.layerMenuContainerLayerItem = null;
        this.layerMenuContainerLayerItemSpan = null;
        this.removeExtraPlatformLabels = true;
        this.sensorNameParamGroupArray = [];
        this.parameterGroup = null;
        this.lastMousePixel = null;
        this.mouseOverFeature = false;
    }
    initialize() {
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);
        this.mainSite.liveDataManager.addListener(this);
        this.openPopups = [];
        $('<a></a>').attr('href', '#').click(()=>{
            this.mainSite.changePage(this.id);
            return false;
        }).text('Map').appendTo(this.navBarLink);
    }
    handleHashChange(hashData) {
        if (hashData.Page === undefined || hashData.Page === '' || hashData.Page === this.id) {
            this.navBarLink.addClass('active');
            if (!this.map) this.renderMap();
            if (hashData.Region !== this.currentRegionId) {
                this.container.remove();
                this.renderMap();
                this.jumpToRegion(hashData.Region);
                this.currentRegionId = hashData.Region;
            }
            return true;
        } else {
            this.navBarLink.removeClass('active');
            if (this.map) {
                this.hide();
                this.currentRegionId = null;
            }
            this.openPopups = [];
            return false;
        }
    }
    static{
        this.epgs4326 = new OpenLayers.Projection("EPSG:4326");
    }
    renderMap() {
        this.container = $('<div id="midi_mapPage_map"></div>').appendTo('body');
        if ($.isEmptyObject(this.mainSite.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MapPage.renderMap() - no Regions available!');
            this.container.html('<div class="alert alert-danger" style="margin: 80px;">Your Account on this site does not seem to have any Permissions set or access to any Regions.</div>');
            return;
        }
        //// Station Labels menu
        this.dropdownContainer = $('<div id="midi_mapPage_dropdown_container"></div>').appendTo(this.container);
        $('<div id="midi_mapPage_dropdown_text">Station Labels: </div>').appendTo(this.dropdownContainer);
        this.paramGroupInfos = [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).T2_s,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean
        ];
        this.buildLabelSelector();
        //// MAP
        this.map = new OpenLayers.Map({
            //maxExtent: new OpenLayers.Bounds(-20037508.34, -20037508.34, 20037508.34, 20037508.34),
            div: this.container[0],
            controls: [
                new OpenLayers.Control.Navigation(),
                new OpenLayers.Control.Zoom(),
                new OpenLayers.Control.ScaleLine({
                    className: 'olControlScaleLine'
                }),
                new OpenLayers.Control.Attribution({
                    className: 'olControlAttribution'
                })
            ],
            // optional
            maxResolution: 6957.46817458,
            maxExtent: new OpenLayers.Bounds(-10909310.0977, 2037548.54475, -9128198.24505, 3503549.8435),
            //
            projection: new OpenLayers.Projection("EPSG:900913"),
            numZoomLevels: 22
        });
        var bm = new OpenLayers.Layer.XYZ("ESRI", 'https://tile.openstreetmap.org/${z}/${x}/${y}.png', {
            sphericalMercator: true,
            projection: "EPSG:900913",
            numZoomLevels: 10,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
            wrapDateLine: true
        });
        this.map.addLayer(bm);
        //// Drifter and front layers for selectedRegion.Id = GOM
        if (this.mainSite.selectedRegion.Id == "GOM") this.addGOMLayers();
        //// Styling
        var style = new OpenLayers.Style({
            cursor: 'pointer',
            strokeWidth: 1,
            pointRadius: 4,
            fillColor: "white",
            labelAlign: 'l',
            labelXOffset: 8,
            labelYOffset: -5,
            strokeColor: "#333333"
        });
        var ruleBig = new OpenLayers.Rule({
            symbolizer: {
                cursor: 'pointer',
                label: '${name}',
                labelSelect: true,
                fontColor: "#3b3b3b",
                fontSize: "12"
            },
            maxScaleDenominator: 8000000
        });
        var ruleSmall = new OpenLayers.Rule({
            symbolizer: {
                labelSelect: true
            },
            minScaleDenominator: 8000000
        });
        var ruleWarningDataRed = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FF0000",
                strokeColor: "#333333"
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "warningLevel",
                value: "Red"
            })
        });
        var ruleWarningDataAmber = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FF8833",
                strokeColor: "#333333"
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "warningLevel",
                value: "Amber"
            })
        });
        var ruleWarningDataYellow = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FFD800",
                strokeColor: "#333333"
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "warningLevel",
                value: "Yellow"
            })
        });
        var ruleAlignRight = new OpenLayers.Rule({
            symbolizer: {
                labelAlign: 'r',
                labelXOffset: -8
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "labelAlign",
                value: "Right"
            })
        });
        let ruleShellAsset = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#fbce07"
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "shellAsset",
                value: "yes"
            })
        });
        style.addRules([
            ruleBig,
            ruleSmall,
            ruleShellAsset,
            ruleWarningDataRed,
            ruleWarningDataAmber,
            ruleWarningDataYellow,
            ruleAlignRight
        ]);
        this.platformsLayer = new OpenLayers.Layer.Vector('Platforms', {
            styleMap: new OpenLayers.StyleMap(style)
        });
        this.map.addLayer(this.platformsLayer);
        this.createPlatformMarkers();
        this.map.events.register("mousemove", this.map, (e)=>{
            this.lastMousePixel = e.xy;
        });
        this.createHoverControl();
        this.createClickControl();
    }
    buildLabelSelector() {
        if (this.dropdownContainerSelectVal) {
            this.dropdownContainerSelectVal.remove();
            this.dropdownContainerSelectVal = null;
        }
        //this.dropdownContainerSelectValContainer = $('<div id="midi_mapPage_dropdown_select"></div>').appendTo(this.dropdownContainer);
        this.dropdownContainerSelectVal = $('<div class="dropdown" id="midi_mapPage_dropdown_select"></div>').appendTo(this.dropdownContainer);
        this.dropdownContainerSelectValSpan = $('<span>Station Name</span>');
        $('<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false" href="#"><span class="caret"></span></a>').prepend(this.dropdownContainerSelectValSpan).appendTo(this.dropdownContainerSelectVal).dropdown();
        var dd = $('<ul class="dropdown-menu midi_mapPage_dropdown_menu" role="menu"></ul>').appendTo(this.dropdownContainerSelectVal);
        $('<a href="#"> Station Name </a>').click((e)=>{
            this.dropdownContainerSelectValSpan.text('Station Name');
            this.dropdownContainerSelectVal.removeClass('open');
            this.removeExtraPlatformLabels = true;
            this.createPlatformMarkers();
            return false;
        }).appendTo($('<li></li>').appendTo(dd));
        this.paramGroupInfos.forEach((paramGroupInfo)=>{
            if (this.parameterGroup && this.parameterGroup.Id == paramGroupInfo.Id) this.dropdownContainerSelectValSpan.text(paramGroupInfo.ShortName);
            $('<li><a href="#">' + paramGroupInfo.ShortName + '</a></li>').click((e)=>{
                this.dropdownContainerSelectValSpan.text(paramGroupInfo.ShortName);
                this.parameterGroup = paramGroupInfo;
                this.dropdownContainerSelectVal.removeClass('open');
                this.removeExtraPlatformLabels = false;
                this.createPlatformMarkers();
                return false;
            }).appendTo(dd);
        });
    }
    addGOMLayers() {
        this.layerMenuContainer = $('<div id="midi_mapPage_layerMenu_container"></div>').appendTo(this.container);
        // define layers of interest
        // see demos here: https://services.woodsholegroup.com/shell/demo/
        const layers = {
            // "Drifters" are freely-floating drifting buoys that are deployed in the ocean to measure currents.
            "Drifter Layers": [
                {
                    "id": "drifter_tracks_24h-today_minus01",
                    "label": "-1 day"
                },
                {
                    "id": "drifter_tracks_96h-today_minus04",
                    "label": "-4 days"
                }
            ],
            // "Fronts" are...
            "Front Layers": [
                {
                    "id": "fronts_gomex-today_minus00",
                    "label": "Today"
                },
                {
                    "id": "fronts_gomex-today_minus01",
                    "label": "-1 day"
                },
                {
                    "id": "fronts_gomex-today_minus02",
                    "label": "-2 days"
                },
                {
                    "id": "fronts_gomex-1wk_progression",
                    "label": "1 week progression"
                }
            ]
        };
        // for all layerTypes
        for (const [layerType, _layers] of Object.entries(layers)){
            $(`<div class="midi_mapPage_layerMenu_layerTypeLabel" id="${layerType}">${layerType}: </div>`).appendTo(this.layerMenuContainer);
            _layers.forEach((layerSpecs, index)=>{
                //// add layer to map
                const layer = new OpenLayers.Layer.WMS(`WMS ${layerSpecs.id}`, "/api/WoodsHoleWmsProxy?", {
                    layers: layerSpecs.id,
                    format: "image/png",
                    srs: "EPSG:900913",
                    exceptions: "application/vnd.ogc.se_inimage",
                    transparent: true,
                    token: "Basic " + window.btoa('shell:SleepingBear$56')
                }, {
                    singleTile: true,
                    ratio: 1,
                    isBaseLayer: false
                });
                //const isVisible = layerName == "fronts_gomex-today_minus00" || layerName == "drifter_tracks_24h-today_minus01";
                const isVisible = layerSpecs.id == "drifter_tracks_24h-today_minus01";
                layer.setVisibility(isVisible);
                this.map.addLayer(layer);
                //// add layer to menu
                this.layerMenuContainerLayerItem = $('<div class="midi_mapPage_layerMenu_layerItem"></div>').appendTo(this.layerMenuContainer);
                // Checkbox and label
                const layerCheckbox = $(`<input type="checkbox" ${isVisible ? "checked" : ""} id="${layerSpecs.id}" class="midi_mapPage_layerMenu_checkbox">`);
                const layerLabel = $(`<label for="${layerSpecs.id}" class="midi_mapPage_layerMenu_layerLabel" >${layerSpecs.label}</label>`);
                this.layerMenuContainerLayerItem.append(layerCheckbox);
                this.layerMenuContainerLayerItem.append(layerLabel);
                // on change, do...
                layerCheckbox.change(function() {
                    layer.setVisibility(this.checked);
                });
            });
        }
    }
    hide() {
        if (this.popup) {
            this.popup.remove();
            this.popup = null;
        }
        this.map.destroy();
        this.container.remove();
        this.container = null;
        this.map = null;
    }
    createHoverControl() {
        this.container.mouseenter(()=>{
            if (this.popup) {
                if (!this.popup.mouseIn && !this.mouseOverFeature) {
                    this.popup.remove();
                    this.popup = null;
                }
            }
        });
        this.hoverControl = new OpenLayers.Control.SelectFeature(this.platformsLayer, {
            hover: true,
            highlightOnly: true,
            eventListeners: {
                featurehighlighted: (e)=>{
                    this.mouseOverFeature = true;
                    if (this.popup) {
                        this.popup.remove();
                        this.popup = null;
                    }
                    this.showPopUp(this.lastMousePixel, e.feature.id);
                },
                featureunhighlighted: ()=>{
                    this.mouseOverFeature = false;
                    setTimeout(()=>{
                        this.maybeRemovePopUp();
                    }, 2000);
                }
            }
        });
        this.map.addControl(this.hoverControl);
        this.hoverControl.activate();
    }
    maybeRemovePopUp() {
        if (this.popup) {
            if (!this.popup.mouseIn && !this.mouseOverFeature) {
                this.popup.remove();
                this.popup = null;
            }
        }
    }
    createClickControl() {
        var clickControl = new OpenLayers.Control.SelectFeature(this.platformsLayer, {
            onBeforeSelect: (feature)=>{
                var hashData = this.mainSite.hashDataManager.decode(window.location.hash);
                hashData.Page = "siteObs";
                hashData.PageSpecificData = {
                    Tab: (0, $6feb48abab9d78f7$export$432915b0d85cff8d).getLandingPageId(feature.attributes.id),
                    Station: feature.attributes.id
                };
                window.location.hash = this.mainSite.hashDataManager.encode(hashData);
            }
        });
        this.map.addControl(clickControl);
        clickControl.activate();
    }
    liveDataChanged(latestData) {
        if (this.map) this.createPlatformMarkers();
        if (this.popup) this.popup.refreshData(latestData);
    }
    createPlatformMarkers() {
        if (!this.mainSite.liveDataManager.latestData) return;
        var mapProjection = this.map.getProjectionObject();
        var labelAlignLeft = true;
        for(var stationId in this.mainSite.liveDataManager.latestData.Stations){
            var station = this.mainSite.liveDataManager.latestData.Stations[stationId];
            // set station label here depending on what is on drop down
            var stationLabel = station.Station.ShortLabel ?? station.Station.Label;
            if (this.parameterGroup && !this.removeExtraPlatformLabels) {
                var valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(this.parameterGroup);
                var valueObject = valueFormatter.format(station);
                stationLabel += (stationLabel.trim() !== "" ? "\n" : "") + valueObject.Value;
                if (this.parameterGroup.Units && (valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring)) stationLabel += " " + this.parameterGroup.Units;
            }
            //: If LiveData contains single, valid latest Buoy Lat/Lon, then update position on map:
            let markerLon = station.Station.Longitude;
            let markerLat = station.Station.Latitude;
            try {
                const lonValue = station.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Longitude_deg.Id];
                const latValue = station.GroupValues[(0, $24b391ec3014929b$export$5d65fdcfff509e37).Buoy_Latitude_deg.Id];
                //console.info('MapPage.createPlatformMarkers().. buoy autoupdate?', { station: station.Station.Id, markerLon: markerLon, markerLat: markerLat, buoyPosValueFormatterLon: buoyPosValueFormatterLon, buoyPosValueObjectLon: buoyPosValueObjectLon, buoyPosValueFormatterLat: buoyPosValueFormatterLat, buoyPosValueObjectLat: buoyPosValueObjectLat });
                if (lonValue && lonValue.length && !isNaN(parseFloat(lonValue[0].Value)) && latValue && latValue.length && !isNaN(parseFloat(latValue[0].Value))) {
                    markerLon = parseFloat(lonValue[0].Value);
                    markerLat = parseFloat(latValue[0].Value);
                // let move = !(markerLon == station.Station.Longitude && markerLat == station.Station.Latitude);
                // console.info('MapPage.createPlatformMarkers().. buoy autoupdate?', { station: station.Station, move: move, markerLon: markerLon, markerLat: markerLat, buoyLon: [buoyPosValueObjectLon.Value, buoyPosValueObjectLon.Status], buoyPosValueObjectLat: [buoyPosValueObjectLat.Value, buoyPosValueObjectLat.Status] });
                }
            } catch (err) {
                console.warn('Error while trying to auto-update marker position:', {
                    error: err,
                    station: station
                });
            }
            var feature = this.platformsLayer.getFeatureById(station.Station.Id);
            if (feature) this.platformsLayer.removeFeatures([
                feature
            ]);
            // Feature does not yet exist, create it
            var attributes = {
                name: stationLabel,
                id: station.Station.Id,
                warningLevel: this.determineFeatureWarningLevel(station.Station.Id),
                shellAsset: station.Station.ShellAsset ? 'yes' : 'no' //: using strings as not sure OpenLayers.Rule can handle booleans!
            };
            var point = new OpenLayers.Geometry.Point(markerLon, markerLat).transform($5fa05bf4f86fed5f$export$213b832c8898a3e1.epgs4326, mapProjection);
            var newFeature = new OpenLayers.Feature.Vector(point, attributes);
            newFeature.id = station.Station.Id;
            if (labelAlignLeft) {
                newFeature.attributes.labelAlign = 'Left';
                labelAlignLeft = false;
            } else {
                newFeature.attributes.labelAlign = 'Right';
                labelAlignLeft = true;
            }
            this.platformsLayer.addFeatures([
                newFeature
            ]);
        }
        // Remove features that are no longer in the live data
        this.platformsLayer.features.forEach((oldFeature)=>{
            if (!(oldFeature.id in this.mainSite.liveDataManager.latestData.Stations)) this.platformsLayer.removeFeatures([
                oldFeature
            ]);
        });
    }
    determineFeatureWarningLevel(featureId) {
        var warningLevelRed = false;
        var warningLevelAmber = false;
        var warningLevelYellow = false;
        this.paramGroupInfos.forEach((paramGroupInfo)=>{
            var valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(paramGroupInfo);
            var valueObject = valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[featureId]);
            if (valueObject.Status === null || valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) return;
            if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) warningLevelRed = true;
            else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) warningLevelAmber = true;
            else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) warningLevelYellow = true;
        });
        var warningLevel;
        if (warningLevelRed) warningLevel = 'Red';
        else if (warningLevelAmber) warningLevel = 'Amber';
        else if (warningLevelYellow) warningLevel = 'Yellow';
        else warningLevel = 'None';
        return warningLevel;
    }
    jumpToRegion(regionId) {
        var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[regionId];
        if (region) {
            var position = new OpenLayers.LonLat(region.Longitude, region.Latitude).transform($5fa05bf4f86fed5f$export$213b832c8898a3e1.epgs4326, this.map.getProjectionObject());
            this.map.setCenter(position, region.ZoomLevel);
        } else console.warn('MapPage.jumpToRegion() ERROR: unable to jump to region.', {
            region: region
        });
    }
    showPopUp(pixel, stationId) {
        this.popup = new (0, $ea7b1f13ba3fabef$export$c6b5894e5fbdc000)(this.mainSite, stationId, [
            pixel.x,
            pixel.y
        ], this.mainSite.liveDataManager.latestData, this.openPopups);
    }
}


// Manages periodic fetching and distribution of GOM averages data to registered listeners.
// Uses a polling mechanism with configurable intervals to keep data fresh.
var $7a20a4f7c9342987$var$BASE_URL = '/api/LiveData/GOMAverages';
function $7a20a4f7c9342987$export$a450f245f1d2889c(callback) {
    $.ajax($7a20a4f7c9342987$var$BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}


class $4acb3cf7b4b3d043$export$dbda8fa3766d94fa {
    // Registers a new listener to receive GOM averages updates
    addListener(listener) {
        this.listeners.push(listener);
    }
    // Starts the periodic data refresh cycle
    start() {
        this.cancelled = false;
        this.refresh(true);
    }
    // Stops the periodic data refresh cycle
    stop() {
        this.cancelled = true;
    }
    // Refreshes GOM averages data and notifies registered listeners
    refresh(repeat = false) {
        (0, $7a20a4f7c9342987$export$a450f245f1d2889c)((err, data)=>{
            if (this.cancelled) return;
            if (data !== null) this.latestData = data;
            // Notify all listeners of the data change
            this.listeners.forEach((listener)=>{
                try {
                    listener.GOMAveragesChanged(this.latestData);
                } catch (error) {}
            });
            // Schedule next refresh if requested and not already pending
            if (repeat && !this.timeoutWaiting) {
                window.setTimeout(()=>{
                    this.timeoutWaiting = false;
                    this.refresh(true);
                }, this.interval);
                this.timeoutWaiting = true;
            }
        });
    }
    constructor(){
        // Interval in ms between data refreshes (30 s)
        this.interval = 30000;
        // Stores the most recently received GOM averages data
        this.latestData = null;
        // List of registered listeners that receive updates when data changes
        this.listeners = [];
        // Tracks whether we're waiting for a timeout to complete
        this.timeoutWaiting = false;
    }
}


class $a1e5cb2ae53999f6$export$ef8da11641c635de {
    constructor(){
        this.navBar = $('<nav class="navbar navbar-default navbar-fixed-top"></nav>');
        this.container = $(`
            <div class="container">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                </button>
                <a class="navbar-brand" href="#"><img alt="Brand" class="midi_common_navbar-shell" src="images/shell.png"/></a>
                <a class="navbar-brand midi_common_main-title" href="#">` + branding.siteName + `</a>
            </div>
            </div>`).appendTo(this.navBar);
        this.collapse = $('<div id="navbar" class="collapse navbar-collapse"></div>').appendTo(this.container);
        this.navLinksLeft = $('<ul class="nav navbar-nav"></ul>').appendTo(this.collapse);
        this.navLinksRight = $('<ul class="nav navbar-nav navbar-right"></ul>').appendTo(this.collapse);
        this.navLinksCustom = $('<ul class="nav navbar-nav navbar-right"></ul>').appendTo(this.collapse);
    }
}





var $f1e9408cace300d7$var$BASE_URL = '/api/Session';
function $f1e9408cace300d7$export$e5432d4c8eb97ea7(callback) {
    $.ajax($f1e9408cace300d7$var$BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $f1e9408cace300d7$export$596d806903d1f59e(email, password, callback) {
    $.ajax($f1e9408cace300d7$var$BASE_URL + '', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Password": password
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}



var $1d3f08d9fba35da9$var$BASE_URL = '/api/GroupPermissions';
var $1d3f08d9fba35da9$export$f1866bc975e81efa = /*#__PURE__*/ function(GroupPermissionType) {
    GroupPermissionType[GroupPermissionType["View"] = 0] = "View";
    GroupPermissionType[GroupPermissionType["ViewAndDownload"] = 1] = "ViewAndDownload";
    return GroupPermissionType;
}({});
function $1d3f08d9fba35da9$export$9eeae14280545765(callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/TreeData', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 180000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $1d3f08d9fba35da9$export$65f9a167a0da0b67(userId, callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/GroupsForUser?userId=' + encodeURIComponent(userId), {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $1d3f08d9fba35da9$export$ef8a0c6d176bcc6e(callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/AssociateUsersWithPermissionGroups/', {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $1d3f08d9fba35da9$export$4fa96983e3cd2c77(callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/Groups', {
        cache: false,
        type: 'GET',
        dataType: 'json',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $1d3f08d9fba35da9$export$627f0b405efe8116(request, callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/Groups', {
        cache: false,
        type: 'POST',
        data: request,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $1d3f08d9fba35da9$export$dfdd85ba08a73da6(request, callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/Groups/' + request.GroupId, {
        cache: false,
        type: 'PUT',
        data: request,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $1d3f08d9fba35da9$export$9f6e53a56fd7acf5(groupId, callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/Groups/' + groupId, {
        cache: false,
        type: 'DELETE',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $1d3f08d9fba35da9$export$67b175837b7a13be(request, callback) {
    $.ajax($1d3f08d9fba35da9$var$BASE_URL + '/UserAssignments/' + request.UserId, {
        cache: false,
        type: 'PUT',
        data: request,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}


var $7acf961adcfe76a4$var$BASE_URL = '/api/StationFiles';
function $7acf961adcfe76a4$export$bf27b8ba537d71a(callback) {
    $.ajax($7acf961adcfe76a4$var$BASE_URL + '/ListForecastPDFs', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}


class $98dff5d8a5ad4885$export$5ad692d53399ec36 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'forecastsPDFs';
        this.$container = null;
        this.activeRegionId = null;
        this.renderToken = 0;
    }
    initialize() {
        /*if (this.mainSite.currentUser.Region !== "Australia"
            && !this.mainSite.currentUser.Permissions.Administrator
            && !this.mainSite.currentUser.Permissions.GlobalAdministrator
            && branding.siteName !== "METNET SCiN") {
            return;
        }*/ this.mainSite.liveDataManager.addListener(this);
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);
        $('<a></a>').attr('href', '#').click(()=>{
            this.mainSite.changePage(this.id);
            return false;
        }).text('Forecasts').appendTo(this.navBarLink);
    }
    handleHashChange(hashData) {
        // Keep region strictly hash-driven for page-state consistency.
        this.activeRegionId = hashData.Region;
        if (hashData.Page === this.id) {
            if (this.navBarLink) this.navBarLink.addClass('active');
            if (!this.$container) this.$container = $('<div class="page-container container-fluid"></div>').appendTo('body');
            else {
                // Remove previous handler before rerender to avoid stacked listeners.
                $(window).off(`resize.${this.id}`);
                this.$container.empty();
            }
            this.renderPage();
            return true;
        } else {
            if (this.navBarLink) this.navBarLink.removeClass('active');
            if (this.$container) {
                // Invalidate any in-flight async list fetches for this page instance.
                this.renderToken++;
                $(window).off(`resize.${this.id}`);
                this.$container.remove();
                this.$container = null;
            }
            return false;
        }
    }
    liveDataChanged(latestData) {
    // this.updateTable();
    }
    adjustSizes() {
        if (this.$colRight.length == 1 && this.$colRight.is(':visible')) {
            let height = $(window).height() - this.$colRight.offset().top - 10;
            // this.$colLeft.height(height);
            this.$colRight.height(height);
        }
    }
    renderPage() {
        // Snapshot current render generation; callbacks must match to update UI.
        const token = ++this.renderToken;
        let $row = $('<div class="row"></div>').appendTo(this.$container);
        this.$colLeft = $('<div class="col-md-4 col-lg-3 no-select"></div>').appendTo($row);
        this.$colRight = $('<div class="col-md-8 col-lg-9 hidden-sm"><em class="text-muted">Loading...</em></div>').appendTo($row);
        this.adjustSizes();
        // Keep exactly one resize handler bound for this page.
        $(window).off(`resize.${this.id}`).on(`resize.${this.id}`, (e)=>{
            this.adjustSizes();
        });
        let $list = $('<div>').appendTo(this.$colLeft);
        this.renderList($list, token);
    }
    renderList($target, token) {
        $target.empty();
        // Snapshot region once so async callback does not read mutable state.
        const selectedRegionId = this.activeRegionId;
        $target.append(`<div class="alert alert-info"><i class="fa fa-lg fa-refresh"></i> Retrieving list of Forecasts...</div>`);
        let $ul;
        (0, $7acf961adcfe76a4$export$bf27b8ba537d71a)((err, list)=>{
            // Ignore responses from older renders or after page teardown.
            if (token !== this.renderToken || !this.$container) return;
            if (err) {
                $target.empty();
                $target.append(`<div class="alert alert-danger">Error while retrieving the list of forecasts from the server: ${err}</div>`);
            } else {
                const filteredSpecial = this.filterFilesBySelectedRegion(list.Special, selectedRegionId);
                const filteredRegular = this.filterFilesBySelectedRegion(list.Regular, selectedRegionId);
                $target.empty();
                $(`<h4 style="margin-top: 0;">Special Forecasts</h4>`).appendTo($target);
                if (filteredSpecial.length == 0) $target.append(`<div class="alert alert-info">No Forecasts available.</div>`);
                else {
                    $ul = this.renderListWrap().appendTo($target);
                    filteredSpecial.forEach((file)=>this.renderListItem($ul, file));
                }
                $(`<h4>Other Forecasts</h4>`).appendTo($target);
                if (filteredRegular.length == 0) $target.append(`<div class="alert alert-info">No Forecasts available.</div>`);
                else {
                    $ul = this.renderListWrap().appendTo($target);
                    filteredRegular.forEach((file)=>this.renderListItem($ul, file));
                }
                this.$colRight.html(`<em class="text-muted">Click on an item on the left to load a Forecast PDF.</em>`);
                $target.find('a.list-group-item').eq(0).trigger('click');
            }
        });
    }
    filterFilesBySelectedRegion(files, selectedRegionId) {
        // Intentionally return no files when region is missing/invalid.
        if (!selectedRegionId) return [];
        const regionKey = selectedRegionId.toLowerCase();
        return files.filter((file)=>{
            const stationRegion = this.mainSite.staticDataManager.Schema?.ParameterSchema?.Stations[file.StationId]?.Station?.Region;
            // Exclude files that cannot be mapped to a known station region.
            if (!stationRegion) return false;
            return stationRegion.toLowerCase() === regionKey;
        });
    }
    renderListWrap() {
        return $('<ul class="list-group"></ul>');
    }
    renderListItem($target, file) {
        let $link = $('<a class="list-group-item branded"></a>').attr('href', file.Link).on('click', (e)=>{
            e.preventDefault();
            $target.closest('.page-container').find('.list-group-item.active').removeClass('active');
            $link.addClass('active');
            this.$colRight.empty();
            this.$colRight.html(`<iframe src="${file.Link}" style="border:0; height: 100%; width: 100%; background-color: #eee;">Loading...</iframe>`);
        });
        $(`<span>${file.Name}</span>`).appendTo($link);
        $(`<br>`).appendTo($link);
        let lm = "";
        try {
            let m = moment(file.LastModified);
            lm = this.mainSite.getDisplayTime(file.LastModified, this.mainSite.staticDataManager.Schema?.ParameterSchema?.Stations[file.StationId]?.Station?.TimeZone ?? "UTC");
        } catch (err) {
            lm = "Unable to parse Last Modified.";
        }
        $(`<span class="op-70">${lm}</span>`).appendTo($link);
        $link.appendTo($target);
    }
}



var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");


var $8NFma = parcelRequire("8NFma");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");




var $1IdZj = parcelRequire("1IdZj");




function $50a3f76ce952b467$export$88cd687c39c2c5(props) {
    // Assume that the timestamp of the first element in the parameterGroupBlock is valid for all elements.
    // This _should_ be the case. 
    const parameterGroup = props.parameterGroupBlock[0];
    let valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37)[parameterGroup.Id]);
    // TODO: Check what's up with this and implement for TableValueCell as well.
    if (parameterGroup.Id === (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather.Id) valueFormatter = new (0, $49efe750b1982432$export$8ba89689dcbc989e)();
    let valueObject = valueFormatter.format(props.mainSite.liveDataManager.latestData.Stations[props.station.Id], props.mainSite.selectedWarningRules);
    let mostRecentTimestamp = valueObject.Timestamp;
    const timeNow = moment().utc().valueOf();
    const timeSinceLastData = mostRecentTimestamp ? (timeNow - mostRecentTimestamp) / 1000 / 60 / 60 : mostRecentTimestamp; // [ms] to [h]
    // TODO: SHOULD NOT BE HARD-CODED. Should come from the data. When provided.
    const isTimestampValid = mostRecentTimestamp ? timeSinceLastData < 24 : null;
    let displayedTime;
    // TODO: does null correspond to expired??
    //if (mostRecentTimestamp != null && isTimestampValid) {
    if (isTimestampValid) switch(props.mainSite.displayTimeType){
        case (0, $52db63ea8facb471$export$3e8712ab6ec35620).UTC:
            displayedTime = moment.utc(mostRecentTimestamp).format("HH:mm").toString();
            break;
        case (0, $52db63ea8facb471$export$3e8712ab6ec35620).PcTime:
            displayedTime = moment(moment.utc(mostRecentTimestamp)).tz(moment.tz.guess()).format("HH:mm");
            break;
        case (0, $52db63ea8facb471$export$3e8712ab6ec35620).StationRegionTime:
            displayedTime = moment(moment.utc(mostRecentTimestamp)).tz(props.station.TimeZone).format("HH:mm");
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
        className: "midi_tablePage_main_table_obstime midi_tablePage_main_table_body_small",
        children: [
            displayedTime,
            mostRecentTimestamp && /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                //className="timestamp_color_code"
                //title={`mostRecentTimestamp = ${mostRecentTimestamp}`}
                style: {
                    height: "0.7em",
                    width: "0.7em",
                    borderRadius: "0.35em",
                    // Use shell-yellow? #fbce07
                    backgroundColor: timeSinceLastData < 3 ? "green" : timeSinceLastData < 12 ? "yellow" : "red",
                    display: "inline-block",
                    marginLeft: displayedTime ? "5px" : "40px"
                }
            })
        ]
    });
}



var $1IdZj = parcelRequire("1IdZj");






class $cc35dadff1ab6efb$export$f40d122bee840c8d extends (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4) {
    constructor(parameterGroup, timeRange){
        super(parameterGroup), this.parameterGroup = parameterGroup, this.timeRange = timeRange;
    }
    getGOMAveragesSetValue(GOMAveragesSetStation) {
        var value = null;
        //console.log('')
        //console.log('liveDataSetStation.GroupValues:', liveDataSetStation.GroupValues)
        //console.log('this.parameterGroup.Id', this.parameterGroup.Id)
        //console.log('liveDataSetStation.GroupValues', liveDataSetStation.GroupValues)
        //console.log('this.sensorId', this.sensorId)
        //console.log('')
        //if (GOMAveragesSetStation.GroupAverages && this.parameterGroup.Id in GOMAveragesSetStation.GroupAverages) {
        //    value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
        //}
        const groupAverage = GOMAveragesSetStation.GroupAverages.filter((groupAverage)=>groupAverage.ParameterGroup == this.parameterGroup.Id)[0];
        // Filthy work-around because averaged values are not in the same format as latestValue
        if (groupAverage) value = {
            ...groupAverage.LatestValue,
            Value: groupAverage[this.timeRange]
        };
        return value;
    }
    //public format(
    formatGOMAverages(GOMAveragesSetStation, warningRules) {
        // the default if parameter has never existed
        var valueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        };
        const value = this.getGOMAveragesSetValue(GOMAveragesSetStation);
        if (value == null) return valueObject;
        // TODO: Does this make sense for groupAverages?
        //if (!MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[GOMAveragesSetStation.Station.Id].Sensors[value.Sensor]) {
        //    return valueObject;
        //}
        var paramDef = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[GOMAveragesSetStation.Station.Id].Sensors[value.Sensor].Parameters[value.Parameter].Variants[0].ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) paramDef = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[value.Parameter];
        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        };
        // Ignore (value.ExpiryStatus == Status.Expired) for averages
        if (value.Value === null) return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        // console.info(`DefaultGroupFormatter.getConversionSet...`, this.parameterGroup.Units, this.parameterGroup);
        let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(this.parameterGroup.Units, this.parameterGroup.Id);
        // TODO: Check with Ben that value.Value === null corresponds to expired.
        //if (value.Value === null || value.Value === 'NIL') {
        //    // can be the case for cloud heights, etc
        //    valueObject.Value = '';
        //} else
        if (typeof value.Value == 'number' && this.parameterGroup.Format) {
            // valueObject.Value = sprintf(this.parameterGroup.Format, MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup));
            if (unitsConversionSet) {
                if (this.parameterGroup == (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m) valueObject.Value = sprintf('%.2f', unitsConversionSet.convertValue(value.Value));
                else valueObject.Value = sprintf(this.parameterGroup.Format, unitsConversionSet.convertValue(value.Value));
            } else valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);
        } else valueObject.Value = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup.Id).toString();
        return valueObject;
    }
}





function $ab638865932079ea$export$c91b503c02a6091d(props) {
    let valueFormatter;
    let valueObject;
    if (!props.timeRange || props.timeRange == "LatestValue") {
        // If no timeRange is defined, use latestData from liveDataManager
        valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)((0, $24b391ec3014929b$export$5d65fdcfff509e37)[props.parameterGroupId], undefined);
        valueObject = valueFormatter.format(props.mainSite.liveDataManager.latestData.Stations[props.station.Id], props.mainSite.selectedWarningRules);
    } else {
        // If a timeRange is defined, use latestData from GOMAveragesManager
        valueFormatter = new (0, $cc35dadff1ab6efb$export$f40d122bee840c8d)((0, $24b391ec3014929b$export$5d65fdcfff509e37)[props.parameterGroupId], props.timeRange);
        valueObject = valueFormatter.formatGOMAverages(props.mainSite.GOMAveragesManager.latestData.Stations.filter((station)=>station.Station.Id == props.station.Id)[0], props.mainSite.selectedWarningRules);
    }
    const getCssClasses = ()=>{
        let cssClasses = '';
        if (valueObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) cssClasses += ' midi_siteObsPage_expiring';
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) cssClasses += ' midi_siteObsPage_exceeded_threshold_3';
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) cssClasses += ' midi_siteObsPage_exceeded_threshold_2';
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) cssClasses += ' midi_siteObsPage_exceeded_threshold_1';
        return cssClasses;
    };
    return /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
        title: `Timestamp: ${moment(moment.utc(valueObject.Timestamp)).tz(props.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm")}. Click for parameter popup.`,
        className: getCssClasses(),
        style: {
            fontSize: valueObject.Status === null || valueObject.Value == "///" ? "0.8em" : null
        },
        onClick: (e)=>{
            const parameterPopup = new (0, $bfbbca38eee2856d$export$3f0be2c6920005ae)(props.mainSite, props.station, valueFormatter);
            parameterPopup.renderPopup(e);
        },
        children: valueObject.Value
    });
}


function $226c4f3b6d68f5e4$export$54ec01a60f47d33d(props) {
    //const [dataType, setDataType] = React.useState
    //// The parameters of the table are organised in blocks
    const parameterGroupBlocks = {
        "Surface current": [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Surface_mps_Mean,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Surface_deg_Mean
        ],
        "Peak current": [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentSpeed_Peak_mps_Mean,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Total_CurrentDirection_Peak_deg_Mean,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).MeasurementDepth_Total_Current_Peak_deg_Mean
        ],
        "Wind": [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg
        ],
        "Wave": [
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hmax_m,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s,
            (0, $24b391ec3014929b$export$5d65fdcfff509e37).PeakWaveDirection_deg
        ]
    };
    //// Get unitsConverter
    // Not sure why we need this rather than just taking the units from the ParameterGroupInfoSets.
    // But this is how it is done on the TablePage.ts
    const unitsConverter = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter();
    //// Sort station Ids and labels
    const stationIds = props.data.Stations.map((station)=>station.Station.Id);
    const stationLabels = stationIds.map((stationId)=>props.data.Stations.filter((station)=>station.Station.Id == stationId)[0].Station.Label);
    const stationLabelsSorted = stationLabels.sort();
    let stationIdsSorted = [];
    for (const stationLabel of stationLabelsSorted)for (const stationId of stationIds){
        // Get corresponding Label
        const correspondingStationlabel = props.data.Stations.filter((station)=>station.Station.Id == stationId)[0].Station.Label;
        if (correspondingStationlabel == stationLabel) stationIdsSorted = [
            ...stationIdsSorted,
            stationId
        ];
    }
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsxs)("table", {
            className: "table table-striped table-hover midi_tablePage_main_table midi_common_table GOM_table",
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsxs)("thead", {
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            className: "midi_tablePage_main_table_header",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    children: "Station"
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                    children: "Lat, Lon"
                                }),
                                Object.entries(parameterGroupBlocks).map(([label, parameterGroupBlock], idx)=>{
                                    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                                children: "Latest Obs. Time"
                                            }),
                                            parameterGroupBlock.map((parameterGroup)=>{
                                                // For each parameterGroup in the parameterGroupBlock, insert cell with name.
                                                return /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                                    title: parameterGroup.Description,
                                                    children: parameterGroup.ShortName
                                                }, parameterGroup.Id);
                                            })
                                        ]
                                    }, idx);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            className: "midi_tablePage_main_table_units",
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {}),
                                /*#__PURE__*/ (0, $1IdZj.jsx)("th", {}),
                                Object.entries(parameterGroupBlocks).map(([label, parameterGroupBlock], idx)=>{
                                    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                                children: props.mainSite.getTimeZoneString()
                                            }),
                                            parameterGroupBlock.map((parameterGroup)=>{
                                                // For each parameterGroup in the parameterGroupBlock, insert cell with value.
                                                return /*#__PURE__*/ (0, $1IdZj.jsx)("th", {
                                                    children: unitsConverter.getConvertedUnits(parameterGroup.Units, parameterGroup.Id)
                                                }, parameterGroup.Id);
                                            })
                                        ]
                                    }, idx);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                    className: "midi_tablePage_main_table_body",
                    children: stationIdsSorted.map((stationId)=>{
                        //Object.entries(parameterGroupBlocks).map(([label, parameterGroupBlock], idx) => {
                        //    console.log(`[LOG: ${stationId}] idx: `, idx);
                        //    console.log(`[LOG: ${stationId}] label: `, label);
                        //    console.log(`[LOG: ${stationId}] parameterGroupBlock: `, parameterGroupBlock);
                        //})
                        const stationOi = props.data.Stations.filter((station)=>station.Station.Id == stationId)[0].Station;
                        return /*#__PURE__*/ (0, $1IdZj.jsxs)("tr", {
                            "data-siteid": stationId,
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                    className: "midi_tablePage_main_table_body_small",
                                    title: `Click for ${stationOi.Label} station overview page.`,
                                    onClick: (e)=>{
                                        props.mainSite.changePage('siteObs', {
                                            Station: stationId,
                                            Tab: (0, $6feb48abab9d78f7$export$432915b0d85cff8d).getLandingPageId(stationOi)
                                        });
                                    },
                                    children: stationOi.Label
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsxs)("td", {
                                    className: "midi_tablePage_main_table_body_small GOM_table_coordinates",
                                    children: [
                                        stationOi.Latitude.toFixed(2),
                                        ", ",
                                        stationOi.Longitude.toFixed(2)
                                    ]
                                }),
                                Object.entries(parameterGroupBlocks).map(([label, parameterGroupBlock], idx)=>{
                                    return(// Add timestamp for parameterGroupBlock
                                    /*#__PURE__*/ (0, $1IdZj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                        children: [
                                            props.mainSite.liveDataManager.latestData ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $50a3f76ce952b467$export$88cd687c39c2c5), {
                                                mainSite: props.mainSite,
                                                station: stationOi,
                                                parameterGroupBlock: parameterGroupBlock
                                            }, `time-${idx}`) : /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {}),
                                            parameterGroupBlock.map((parameterGroup)=>{
                                                // For each parameterGroup in the parameterGroupBlock, insert cell with value.
                                                return props.mainSite.liveDataManager.latestData ? /*#__PURE__*/ (0, $1IdZj.jsx)((0, $ab638865932079ea$export$c91b503c02a6091d), {
                                                    mainSite: props.mainSite,
                                                    station: stationOi,
                                                    parameterGroupId: parameterGroup.Id,
                                                    timeRange: props.timeRange
                                                }, parameterGroup.Id) : /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {});
                                            })
                                        ]
                                    }, idx));
                                })
                            ]
                        }, stationId);
                    })
                })
            ]
        })
    });
}



var $1IdZj = parcelRequire("1IdZj");

const $fa9088839b28a69a$var$Item = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
        sx: {
            p: 1,
            ml: 0.5,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1
        },
        children: children
    });
};
function $fa9088839b28a69a$export$c8036531627f54a6(props) {
    return /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flexDirection: 'row',
            bgcolor: 'background.paper',
            borderRadius: 1
        },
        children: [
            /*#__PURE__*/ (0, $1IdZj.jsx)($fa9088839b28a69a$var$Item, {
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    title: "Latest data was available <3 hours ago.",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            style: {
                                height: "1rem",
                                width: "1rem",
                                borderRadius: "0.5rem",
                                backgroundColor: "green",
                                display: "inline-block",
                                marginRight: "10px"
                            }
                        }),
                        "<3 hours"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($fa9088839b28a69a$var$Item, {
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    title: "Latest data was available 3-12 hours ago.",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            style: {
                                height: "1rem",
                                width: "1rem",
                                borderRadius: "0.5rem",
                                backgroundColor: "yellow",
                                display: "inline-block",
                                marginRight: "10px"
                            }
                        }),
                        "3-12 hours"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1IdZj.jsx)($fa9088839b28a69a$var$Item, {
                children: /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
                    title: "Latest data was available >12 hours ago.",
                    children: [
                        /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            style: {
                                height: "1rem",
                                width: "1rem",
                                borderRadius: "0.5rem",
                                backgroundColor: "red",
                                display: "inline-block",
                                marginRight: "10px"
                            }
                        }),
                        ">12 hours"
                    ]
                })
            })
        ]
    });
}



function $424eae88c96eaa8b$export$ccff7b085fc318eb(props) {
    //: READ: https://mui.com/material-ui/react-css-baseline/#scoping-on-children
    //: SEE: https://mui.com/material-ui/react-tabs/#vertical-tabs
    const [timeRange, setTimeRange] = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).useState("LatestValue");
    const theme = (0, $aef7542ad817395e$export$2e2bcd8739ae039)({
        typography: {
            fontSize: 20
        }
    });
    return /*#__PURE__*/ (0, $1IdZj.jsx)((0, $1IdZj.Fragment), {
        children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).StrictMode, {
            children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $89db59c316d64b9f$export$2e2bcd8739ae039), {
                theme: theme,
                children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $a86f219d010e43e7$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                        className: "container",
                        sx: {
                            bgcolor: 'background.paper',
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: !props.mainSite.liveDataManager.latestData || !props.mainSite.GOMAveragesManager.latestData ? /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0, $1IdZj.jsx)("table", {
                                className: "table table-striped table-hover midi_tablePage_main_table midi_common_table",
                                children: /*#__PURE__*/ (0, $1IdZj.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $1IdZj.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $1IdZj.jsxs)("span", {
                                                className: "text-muted",
                                                children: [
                                                    /*#__PURE__*/ (0, $1IdZj.jsx)("i", {
                                                        className: "fa fa-spin fa-refresh"
                                                    }),
                                                    "Loading table..."
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $1IdZj.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $1IdZj.jsxs)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                                    sx: {
                                        bgcolor: 'background.paper',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        mb: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $4e8fcc1b86169fc2$export$d880734c77061ef3), {
                                            timeRange: timeRange,
                                            setTimeRange: setTimeRange
                                        }),
                                        /*#__PURE__*/ (0, $1IdZj.jsx)((0, $fa9088839b28a69a$export$c8036531627f54a6), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $1IdZj.jsx)((0, $5498c20b15dd5ce1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $1IdZj.jsx)((0, $226c4f3b6d68f5e4$export$54ec01a60f47d33d), {
                                        mainSite: props.mainSite,
                                        data: props.data,
                                        timeRange: timeRange
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}



class $98a6c938873fa897$export$529d77624eeace21 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'GOMTable';
        this.container = null;
        this.$div = null;
    }
    GOMAveragesChanged(latestData) {
        if (!this.$div) return;
        else //// Update existing component instance
        //if (this.GOMTablePageComponentInstance) {
        //    this.GOMTablePageComponentInstance.updateProps({
        //        mainSite: this.mainSite,
        //        data: latestDataOi
        //    });
        //}
        // Recreate and re-render the whole shebang
        // TODO: Don't do this
        $1c0f1e610963dfb8$exports.render($8NFma.createElement((0, $424eae88c96eaa8b$export$ccff7b085fc318eb), {
            mainSite: this.mainSite,
            data: latestData
        }), this.$div[0]);
    }
    initialize() {
        //this.mainSite.liveDataManager.addListener(this);
        this.mainSite.GOMAveragesManager.addListener(this);
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);
        $('<a></a>').attr('href', '#').click(()=>{
            this.mainSite.changePage(this.id);
            return false;
        }).text('Table').appendTo(this.navBarLink);
    }
    handleHashChange(hashData) {
        console.log('this.mainSite: ', this.mainSite);
        console.log('this.mainSite.liveDataManager: ', this.mainSite.liveDataManager);
        console.log('this.mainSite.liveDataManager.latestData: ', this.mainSite.liveDataManager.latestData);
        //: TODO: this is initial auth check, but it will need to be improved/adapted in future!
        if (this.mainSite.selectedRegion.Id != "GOM") this.navBarLink.hide(); //: ugly, should be improved!
        else this.navBarLink.show();
        if (hashData.Page === this.id && this.mainSite.selectedRegion.Id == "GOM") {
            this.navBarLink.addClass('active');
            if (!this.container) {
                this.container = $('<div class="container-fluid" liveData-wrapper-for="GOMTablePage"></div>').appendTo('body');
                this.$div = $('<div class="col-sm-12">').appendTo($('<div class="row">').appendTo(this.container));
                // Not working
                //const root = ReactDOM.createRoot
                //this.GOMTablePageComponent = ReactDOM.render(
                // Render pageComponent
                $1c0f1e610963dfb8$exports.render($8NFma.createElement((0, $424eae88c96eaa8b$export$ccff7b085fc318eb), {
                    mainSite: this.mainSite,
                    data: this.mainSite.GOMAveragesManager.latestData?.Stations ? this.mainSite.GOMAveragesManager.latestData : null
                }), this.$div[0]);
            //// Create initial component instance
            //ReactDOM.render(
            //    React.createElement(
            //        GOMTable.GOMTablePageComponent,
            //        {
            //            ref: (instance) => {
            //                this.GOMTablePageComponentInstance = instance;
            //            },
            //            mainSite: this.mainSite,
            //            data: null
            //        }
            //    ),
            //    this.$div[0]
            //);
            }
            return true;
        } else {
            this.navBarLink.removeClass('active');
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
}






class $1e8c4ce7e96d9cf3$export$274089655af97035 {
    constructor(d, refresh, parentPage){
        this.modal = null;
        this.modalSaveButton = null;
        this.rightRuleSelectorPanel = null;
        this.viewAndDownloadRadio = null;
        this.groupNameInput = null;
        this.tree = null;
        this.allTreeNodes = [];
        this.filterInput = null;
        this.preselectedNodes = [];
        this.preselectedNodeToRemove = null;
        this.groupName = "";
        this.permissionType = (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).View;
        this.treeData = d;
        this.refresh = refresh;
        this.parentPage = parentPage;
        this.groupName = "";
        this.permissionType = (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).View;
    }
    setupPermissionTree(parent) {
        let $table = $('<table>').addClass('table table-hover midi_common_table').appendTo(parent);
        $table.append('<colgroup><col width="*"></col><col width="90px"></col><col width="50px"></col></colgroup>');
        $table.append('<thead><tr><th><div class="midi_manageGroupPermissions_table_header_container"><span>Available Permissions</span><div class="midi_manageGroupPermissions_table_header_line"/></div></th></tr></thead>');
        $table.append('<tbody></tbody>');
        let treeOpts = {
            extensions: [
                "table",
                "filter"
            ],
            checkbox: false,
            table: {
                indentation: 20,
                nodeColumnIdx: 0,
                checkboxColumnIdx: -1 // render the checkboxes into the 1st column
            },
            filter: {
                autoApply: false,
                autoExpand: true,
                counter: false,
                fuzzy: true,
                hideExpanders: true,
                highlight: true,
                mode: 'hide'
            },
            source: this.treeData,
            clickFolderMode: 4,
            click: (event, data)=>{
                if (data.targetType == "expander") {
                    console.info("NODE CLICK - EXPANDER (IGNORED)", {
                        event: event,
                        data: data
                    });
                    return true; //: otherwise expansion of folders may be prevents further down.
                } else //disbaled/previously selected nodes cannot be selected again   
                if (!this.isDisabled(data.node.data)) {
                    var oldSelected = this.selectedFancyTreeNode;
                    this.selectedFancyTreeNode = data.node;
                    if (oldSelected) this.reRenderNode(oldSelected); // to remove highlight from previously selected nodes
                    this.expandNode(data.node, true);
                }
                return false;
            },
            renderTitle: (event, data)=>{
                this.allTreeNodes.push(data.node);
                let tnd = data.node.data;
                let selectedTND = this.selectedFancyTreeNode ? this.selectedFancyTreeNode.data : null;
                var className = this.selectedFancyTreeNode && this.checkIfSelfOrChild(tnd, selectedTND) ? "fancytree-title midi_manageGroupPermissions_modal_selected_fancytree_item" : this.isDisabled(tnd) ? "fancytree-title-disabled" : "fancytree-title";
                if (tnd.NodeType == "Region") return `<span class="` + className + `"><i class="fa fa-fw fa-lg ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('region')}"></i> <strong>${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)}</strong></span>`;
                else if (tnd.NodeType == "Station") return `<span class="` + className + `" title="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)}"><i class="fa fa-fw fa-lg  ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('station')}"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.StationLabel)}</span>`;
                else return `<span class="` + className + `" title="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)} / ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.StationLabel)}"><i class="fa fa-fw  ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('sensor')}"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.SensorLabel)}</span>`;
            }
        };
        $table.fancytree(treeOpts);
        this.tree = $table.fancytree('getTree');
    }
    checkIfSelfOrChild(tnd, n) {
        switch(n.NodeType){
            case "Region":
                return n.RegionId === tnd.RegionId;
            case "Station":
                return n.RegionId === tnd.RegionId && n.StationId === tnd.StationId;
            case "Sensor":
                return n.RegionId === tnd.RegionId && n.StationId === tnd.StationId && n.SensorId === tnd.SensorId;
        }
    }
    isDisabled(tnd) {
        var disabled = false;
        this.preselectedNodes.forEach((psn)=>{
            let n = psn.data;
            if (this.checkIfSelfOrChild(tnd, n)) disabled = true;
        });
        return disabled;
    }
    reRenderNode(node) {
        node.renderTitle();
        if (node.hasChildren()) node.children.forEach((ch)=>{
            this.reRenderNode(ch);
        });
    }
    expandNode(node, expand) {
        node.setExpanded(expand);
        node.renderTitle();
        if (node.hasChildren()) node.children.forEach((ch)=>{
            this.expandNode(ch, expand);
        });
    }
    gelAllTreeNodes(root) {
        this.allTreeNodes.push(root);
        if (root.hasChildren()) root.children.forEach((ch)=>{
            this.gelAllTreeNodes(ch);
        });
    }
    renderModal(pg) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
            this.selectedFancyTreeNode = null;
            this.preselectedNodeToRemove = null;
            this.preselectedNodes = [];
            this.groupName = "";
        }
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (!pg) $('<h4 class="modal-title">Create Group Permision</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit Group Permission</h4>').appendTo(modalHeaderContent);
        //MODAL BODY
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        //Group Name
        var groupNameContainer = $('<div class="input-group midi_manageGroupPermissions_input_container"> </div>').appendTo(this.modalBodyContent);
        $('<div>Group Name:</div>').appendTo(groupNameContainer);
        this.groupNameInput = $('<input id="midi_ManageGroupPermissions-name-input" class="form-control" type="text" placeholder="Enter a name for this group" />').on('keyup input', (e)=>{
            this.groupName = this.groupNameInput.val();
        }).appendTo(groupNameContainer);
        //Permission Type
        var typeSelectionContainer = $('<div class="input-group midi_manageGroupPermissions_input_container">Permission Type: </div>').appendTo(this.modalBodyContent);
        var viewDataRadioContainer = $('<label class="midi_manageGroupPermissions_input_container_checkbox_label"> </label>').appendTo(typeSelectionContainer);
        var viewDataRadio = $('<input name="group_permission_type" id="view_gp" type="radio" value="0">').click(()=>{
            this.permissionType = (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).View;
        }).appendTo(viewDataRadioContainer);
        $('<strong>View Data</strong>').appendTo(viewDataRadioContainer);
        viewDataRadioContainer.click();
        var viewAndDownloadDataRadioContainer = $('<label class="midi_manageGroupPermissions_input_container_checkbox_label"></label>').appendTo(typeSelectionContainer);
        this.viewAndDownloadRadio = $('<input name="group_permission_type" id="view_and_download_gp" type="radio" value="1">').click(()=>{
            this.permissionType = (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).ViewAndDownload;
        }).appendTo(viewAndDownloadDataRadioContainer);
        $('<strong>View & Download Data</strong>').appendTo(viewAndDownloadDataRadioContainer);
        //Rule Selector
        var filterRow = $('<div class="midi_manageGroupPermissions_modal_filter_container"></div>').appendTo(this.modalBodyContent);
        var ruleSelectorPanelsContainer = $('<div class="input-group midi_manageGroupPermissions_panels_container"> </div>').appendTo(this.modalBodyContent);
        var leftRuleSelectorPanel = $('<div class="midi_manageGroupPermissions_rule_selector_panel"></div>').appendTo(ruleSelectorPanelsContainer);
        this.setupPermissionTree(leftRuleSelectorPanel);
        //add filter
        $('<span class="input-group-addon"><i class="fa fa-fw fa-filter"></i></span>').appendTo(filterRow);
        this.filterInput = $('<input type="search" placeholder="Filter..." />').addClass('form-control').appendTo(filterRow);
        $('<button>').appendTo($('<span class="input-group-btn"></span>').appendTo(filterRow)).addClass('btn btn-default').html('<i class="fa fa-fw fa-times"></i> <span class="sr-only">Clear filter</span>').on("click", (e)=>{
            $(e.target).blur();
            this.filterInput.val('');
            this.treeApplyFilters();
        });
        this.filterInput.on("keyup", (e)=>{
            this.treeApplyFilters();
        });
        var moveButtonsContainer = $('<div class="midi_manageGroupPermissions_move_buttons_container"></div>').appendTo(ruleSelectorPanelsContainer);
        this.rightRuleSelectorPanel = $('<div class="midi_manageGroupPermissions_rule_selector_panel"></div>').appendTo(ruleSelectorPanelsContainer);
        //move right button (add to rules list)
        $('<button class="btn btn-default"><i class="fa fa-lg fa-chevron-right"></i></button>').click(()=>{
            if (this.selectedFancyTreeNode) {
                var old = this.selectedFancyTreeNode;
                this.preselectedNodes.push(this.selectedFancyTreeNode);
                this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);
                this.selectedFancyTreeNode = null;
                this.reRenderNode(old);
            }
        }).appendTo(moveButtonsContainer);
        //move left button (remove from rules list)
        $('<button class="btn btn-default"><i class="fa fa-lg fa-chevron-left"></i></button>').click(()=>{
            var indexToRem = null;
            if (this.preselectedNodeToRemove) {
                this.preselectedNodes.forEach((psn, i)=>{
                    var tnd = psn.data;
                    var toRem = this.preselectedNodeToRemove.data;
                    if (tnd.RegionId === toRem.RegionId && tnd.StationId === toRem.StationId && tnd.SensorId === toRem.SensorId) indexToRem = i;
                });
                this.preselectedNodes.splice(indexToRem, 1);
                this.reRenderNode(this.preselectedNodeToRemove);
                this.preselectedNodeToRemove = null;
                this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);
            }
        }).appendTo(moveButtonsContainer);
        //FOOTER
        var footerClass = pg ? "modal-footer create_edit_pg_footer" : "modal-footer";
        var modalFooterContent = $('<div class="' + footerClass + '"></div>').appendTo(modalContent);
        if (pg) {
            //set up DELETE button
            $('<button type="button" class="btn btn-danger pg_delete_button"> Delete Group</button>').click(()=>{
                this.modalBodyContent.hide();
                modalFooterContent.hide();
                this.deleteModalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
                $('<p>Are you sure about deleting permission group: <strong>' + pg.GroupName + '</strong>?</p>').appendTo(this.deleteModalBodyContent);
                $('<p>All users associated with this group will loose those permissions within this group.</p>').appendTo(this.deleteModalBodyContent);
                var deleteFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
                $('<button type="button" class="btn btn-default" > Cancel </button>').click(()=>{
                    this.deleteModalBodyContent.remove();
                    deleteFooterContent.remove();
                    this.modalBodyContent.show();
                    modalFooterContent.show();
                }).appendTo(deleteFooterContent);
                $('<button type="button" class="btn btn-danger pg_delete_button"> Delete </button>').click(()=>{
                    this.deletePermissionGroup(pg.GroupId);
                }).appendTo(deleteFooterContent);
            }).appendTo(modalFooterContent);
            $('<div class="create_edit_pg_footer_buttons_separator"></div>').appendTo(modalFooterContent);
        }
        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Cancel </button>').appendTo(modalFooterContent);
        //save button
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Save</button>').appendTo(modalFooterContent).click(()=>{
            if (this.groupName !== "" && this.preselectedNodes.length > 0) {
                var rules = [];
                this.preselectedNodes.forEach((psn)=>{
                    var tnd = psn.data;
                    rules.push({
                        RegionId: tnd.RegionId,
                        StationId: tnd.StationId,
                        SensorId: tnd.SensorId
                    });
                });
                var req = {
                    GroupName: this.groupName,
                    GroupPermissionType: this.permissionType,
                    GroupRules: rules
                };
                if (pg) req.GroupId = pg.GroupId;
                this.createEditPermissionGroup(req);
            } else {
                var alertText = this.groupName == "" ? "Group Name cannot be empty. Please enter a name and try again." : "Group Permission must contain at least 1 rule. Please add one and try again.";
                alert(alertText);
            }
        });
        //set initial data in case of Edit action
        this.initModalData(pg);
        this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);
        this.modal.modal('show');
    }
    initModalData(pg) {
        if (pg !== null) {
            this.groupName = pg.GroupName;
            this.groupNameInput.val(pg.GroupName);
            if (pg.GroupPermissionType === (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).ViewAndDownload) this.viewAndDownloadRadio.click();
            pg.GroupRules.forEach((rule)=>{
                var node = null;
                this.allTreeNodes = [];
                this.gelAllTreeNodes(this.tree.rootNode);
                this.allTreeNodes.forEach((n)=>{
                    var tnd = n.data;
                    if (tnd.RegionId === rule.RegionId && tnd.StationId === rule.StationId && tnd.SensorId === rule.SensorId) node = n;
                });
                if (node) {
                    this.preselectedNodes.push(node);
                    this.reRenderNode(node);
                }
            });
        }
    }
    updatePreSelectedNodePanel(panel) {
        panel.empty();
        var header = $('<div class="midi_manageGroupPermissions_table_header_container"></div>').appendTo(panel);
        $('<span><strong>Selected Permissions</strong></span>').appendTo(header);
        $('<div class="midi_manageGroupPermissions_table_header_line"></div>').appendTo(header);
        var ruleList = $('<ul id="midi_manageGroupPermissions_modal_preselected_nodes_list"></ul>').appendTo(panel);
        this.preselectedNodes.forEach((psn)=>{
            var listItem = $('<li></li>').append(this.getRuleLabelForNode(psn)).appendTo(ruleList);
            listItem.click(()=>{
                this.updatePreSelectedList();
                this.preselectedNodeToRemove = psn;
                listItem.addClass('midi_manageGroupPermissions_modal_preselected_nodes_list_item_selected');
            });
        });
    }
    updatePreSelectedList() {
        $('#midi_manageGroupPermissions_modal_preselected_nodes_list li').each(function() {
            $(this).removeClass('midi_manageGroupPermissions_modal_preselected_nodes_list_item_selected');
        });
    }
    getRuleLabelForNode(node) {
        let tnd = node.data;
        switch(tnd.NodeType){
            case "Region":
                return $("<span>All data in region <strong>" + tnd.RegionLabel + "</strong></span>");
            case "Station":
                return $("<span>All data for station <strong>" + tnd.StationLabel + "</strong></span>");
            case "Sensor":
                return $("<span><strong>" + tnd.RegionLabel + "</strong> / <strong>" + tnd.StationLabel + "</strong> / <strong>" + tnd.SensorLabel + "</strong></span>");
        }
    }
    treeApplyFilters() {
        let val = (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString($(this.filterInput).val()).toLowerCase();
        this.tree.filterNodes((node)=>{
            let tnd = node.data;
            if (node.title.toLowerCase().indexOf(val) >= 0 || tnd.RegionLabel.toLowerCase().indexOf(val) >= 0 || tnd.StationLabel && tnd.StationLabel.toLowerCase().indexOf(val) >= 0 || tnd.SensorLabel && tnd.SensorLabel.toLowerCase().indexOf(val) >= 0) return true;
            return false;
        });
    }
    createEditPermissionGroup(pg) {
        if (pg.GroupId) (0, $1d3f08d9fba35da9$export$dfdd85ba08a73da6)(pg, (err)=>{
            if (err) {
                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                return;
            }
            this.modal.modal('hide');
            this.refresh(this.parentPage);
        });
        else (0, $1d3f08d9fba35da9$export$627f0b405efe8116)(pg, (err)=>{
            if (err) {
                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                return;
            }
            this.modal.modal('hide');
            this.refresh(this.parentPage);
        });
    }
    deletePermissionGroup(groupId) {
        (0, $1d3f08d9fba35da9$export$9f6e53a56fd7acf5)(groupId, (err)=>{
            if (err) {
                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Deleting Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                return;
            }
            this.modal.modal('hide');
            this.refresh(this.parentPage);
        });
    }
}


class $601490302ecedb8f$export$e5a161874de28443 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'managePermissionGroups';
        this.container = null;
        this.loadingContainer = null;
        this.createEditGPModal = null;
        this.table = null;
        this.tableBody = null;
        this.tableHead = null;
        this.tableHeadRow = null;
        this.groupPermissions = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.refresh(this);
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    refresh(self) {
        if (self.container) {
            self.container.remove();
            self.container = null;
        }
        self.container = $('<div class="container"></div>').appendTo('body');
        self.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(self.container);
        /*API.GroupPermissions.AssociateUsersWithPermissionGroups((err: any, data: any) => {

        });*/ (0, $1d3f08d9fba35da9$export$4fa96983e3cd2c77)((err, data)=>{
            if (!err) {
                self.groupPermissions = data.sort((a, b)=>a.GroupName.toLowerCase() < b.GroupName.toLowerCase() ? -1 : a.GroupName.toLowerCase() > b.GroupName.toLowerCase() ? 1 : 0);
                (0, $1d3f08d9fba35da9$export$9eeae14280545765)((err, data)=>{
                    if (err) self.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Unable to get list of data from server: ' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(err.Message));
                    self.loadingContainer.hide();
                    self.createEditGPModal = new (0, $1e8c4ce7e96d9cf3$export$274089655af97035)(data, self.refresh, self);
                    self.render();
                });
            } else self.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Unable to get list of data from server: ' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(err.Message));
        });
    }
    render() {
        $('<h1 class="midi_manageGroupPermissions_title">MANAGE GROUP PERMISSIONS</h1>').appendTo(this.container);
        $('<button type="button" class="btn btn-success midi_manageGroupPermissions_createButton">New Group Permission</button>').appendTo($('<div></div>').css('margin-top', '30px').appendTo(this.container)).click(()=>{
            this.createEditGPModal.renderModal(null);
        });
        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Group Name</th> <th>Permission</th>').appendTo(this.tableHeadRow);
        var noneFound = $('<span class="empty-message">No group permissions were added yet.</span>');
        noneFound.appendTo(this.container);
        if (this.groupPermissions.length == 0) noneFound.show();
        else {
            noneFound.hide();
            this.groupPermissions.forEach((gp)=>{
                var tr = $('<tr></tr>').appendTo(this.tableBody);
                $('<td>' + gp.GroupName + '</td>').appendTo(tr);
                $('<td>' + $601490302ecedb8f$export$e5a161874de28443.getGroupPermissionTypeName(gp.GroupPermissionType) + '</td>').appendTo(tr);
                tr.click(()=>{
                    this.createEditGPModal.renderModal(gp);
                });
            });
        }
    }
    static getGroupPermissionTypeName(gpt) {
        return gpt == (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).View ? "View" : "View and Download";
    }
}






class $13b4e59235a6ba75$export$fe13e5b1221a1782 {
    constructor(stationId, sensorId, parameterId, plottingPage, parameterTree, parameterTreeNode){
        this.stationId = stationId;
        this.sensorId = sensorId;
        this.parameterId = parameterId;
        this.plottingPage = plottingPage;
        this.parameterTree = parameterTree;
        this.parameterTreeNode = parameterTreeNode;
        this.modal = null;
        this.modalBody = null;
        this.contentContainer = null;
        this.fallbackVariantStr = '6h';
        this.issues = [];
        this.continueButton = null;
    }
    show() {
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));
        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        $('<h4 class="modal-title"></h4>').text("Add Forecast Issue").appendTo(modalHeader);
        this.modalBody = $('<div class="modal-body" id="midi_PlottingPage_modal_add_issue_body"></div>').appendTo(modalContent);
        this.contentContainer = $('<div></div>').appendTo(this.modalBody);
        //download last 5 days issue times
        this.getLastXDaysIssues(moment.tz((0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName()), 5);
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').click(()=>{
            this.issues = [];
        }).appendTo(modalFooter);
        this.continueButton = $('<button type="button" class="btn btn-success disabled">Add Issue</button>').appendTo(modalFooter).click(()=>{
            if (this.issues.length === 0) return;
            this.issues.forEach((issue)=>{
                this.addIssue(issue);
            });
            this.modal.modal('hide');
        });
        $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').appendTo(modalFooter);
        this.modal.on("shown.bs.modal", (e)=>{
            this.plottingPage.pageUnblock();
        });
        this.modal.modal('show');
    }
    getLastXDaysIssues(selectedDate, numberOfDays, overrideVariant) {
        this.contentContainer.empty();
        $('<div>').addClass('AddIssueDialog--Spinner text-muted').appendTo(this.contentContainer).append($('<div>').html('<i class="fa fa-spin fa-refresh"></i> <span>Loading issue times</span>'));
        let momentTo = selectedDate.startOf('day').add(1, 'd');
        let momentFrom = moment(momentTo).subtract(numberOfDays, 'days');
        // Use the override if provided, otherwise find the base variant
        let baseVariantStr = overrideVariant || this.findBaseVariant();
        if (baseVariantStr === null) // Fallback to '0h' if no variant could be determined
        baseVariantStr = '0h';
        (0, $fd959835eca46177$export$9bf04fc316538454)('P', this.stationId, this.sensorId, this.parameterId, baseVariantStr, momentFrom.valueOf(), momentTo.valueOf(), (err, data)=>{
            // Fallback: If the 0h variant exists but has no data in the queried time range; try the fallbackVariantStr instead.
            if (!err && data.Data.length === 0) {
                this.getLastXDaysIssues(selectedDate, numberOfDays, this.fallbackVariantStr);
                return; // Stop processing this empty response
            }
            this.contentContainer.empty();
            if (err) {
                this.contentContainer.append($('<span>Error getting data: ' + JSON.stringify(err) + '</span>'));
                return;
            }
            let allowedTs = data.Data.map((pair)=>{
                let issueHours = parseFloat(baseVariantStr.replace(/h/g, ""));
                let adjustedTs = pair[0] - issueHours * 3600000;
                return {
                    issueTime: adjustedTs,
                    mom: moment.tz(adjustedTs, (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName())
                };
            });
            let rows = [];
            allowedTs.forEach((ts)=>{
                this.populateTsRows(ts, rows, baseVariantStr);
            });
            let datepicker = $('<input class="input-sm form-control" placeholder="Issue Date" type="text" id="midi_AddIssueDialog_date_picker" aria-describedby="basic-addon2"></input>').css("width", "130px").css("margin-right", "10px").css("display", "inline-block").datepicker({
                format: "yyyy-mm-dd",
                maxDate: moment.tz((0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName()).format("YYYY-MM-DD")
            });
            if (rows.length === 0) {
                datepicker.on('changeDate', ()=>{
                    //Get the list of issue times using the 0h variant
                    //let's not clear the selected issues here, even if the date changes and it won't be displayed any longer
                    let selectedDate = moment.tz(datepicker.val(), 'YYYY-MM-DD', (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName());
                    datepicker.datepicker('hide');
                    this.getLastXDaysIssues(selectedDate, 5); // Initial call will use findBaseVariant()
                }).appendTo(this.contentContainer);
                $('<div></div>').css("display", "inline-block").text("No issue times for selected date").appendTo(this.contentContainer);
                return;
            }
            rows.sort((a, b)=>{
                return new Date(b.dateStr).getTime() - new Date(a.dateStr).getTime();
            });
            for(let i = 0; i < rows.length; i++){
                if (i === 0) {
                    datepicker.on('changeDate', ()=>{
                        //Get the list of issue times using the 0h variant
                        if (datepicker.val() !== rows[i].dateStr) {
                            //let's not clear the selected issues here, even if the date changes and it won't be displayed any longer
                            let selectedDate = moment.tz(datepicker.val(), 'YYYY-MM-DD', (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName());
                            datepicker.datepicker('hide');
                            this.getLastXDaysIssues(selectedDate, 5);
                        }
                    }).prependTo(rows[i].rowContent);
                    datepicker.datepicker('setDate', rows[i].dateStr);
                } else rows[i].rowContent.prepend($('<div></div>').css("width", "130px").css("margin-left", "10px").css("display", "inline-block").text(rows[i].dateStr));
                this.contentContainer.append(rows[i].rowContent);
            }
        }, -1);
    }
    populateTsRows(ts, rows, baseVariant) {
        let dateStr = ts.mom.format("YYYY-MM-DD");
        let row_ = rows.filter((x)=>x.dateStr === dateStr);
        if (row_.length === 0) rows.push({
            dateStr: dateStr,
            rowContent: $('<div></div>').css("margin-bottom", "3px")
        });
        let row = rows.filter((x)=>x.dateStr === dateStr)[0];
        $('<div class="btn btn-default midi_add-issue-ts" id="' + ts.issueTime + '"></div>').text(ts.mom.format("HH:mm") + " " + (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneString()).click(()=>{
            let filtIssues = this.issues.filter((x)=>x.issueTime === ts.issueTime);
            $('.midi_add-issue-ts').removeClass("selected");
            if (filtIssues.length === 0) {
                $('#' + ts.issueTime).append($('<i class="fa fa-spin fa-refresh" id="spinner_' + ts.issueTime + '"></i>').css("margin-left", "0.2em"));
                $('.midi_add-issue-ts').addClass("disabled");
                this.continueButton.addClass("disabled");
                this.getIssue(ts.issueTime, baseVariant, this.updateContinueButton.bind(this));
            } else {
                let idx = this.issues.indexOf(filtIssues[0]);
                this.issues.splice(idx, 1);
                this.updateContinueButton();
            }
            this.issues.forEach((issue)=>{
                $('#' + issue.issueTime).addClass("selected");
            });
        }).appendTo(row.rowContent);
    }
    updateContinueButton() {
        if (this.issues.length > 1) this.continueButton.text("Add Issues");
        else this.continueButton.text("Add Issue");
        if (this.issues.length === 0) this.continueButton.addClass("disabled");
        else this.continueButton.removeClass("disabled");
    }
    addIssue(issue) {
        let chartData = [];
        issue.issue.Rows.forEach((row)=>{
            let val = row.Value !== null && row.Value !== "" ? parseFloat(row.Value) : null;
            if (val !== null) chartData.push([
                row.Timestamp_ms,
                val
            ]);
        });
        chartData.sort((a, b)=>{
            return a[0] - b[0];
        });
        //TODO: address Highcharts error 15 data not sorted with consideration of the below
        //It looks like chartData.sort is working properly
        //There is a weird behaviour here that I spent a lot of time getting stuck over, convinced that
        //the sort wasn't working properly. Have left the logs here just in case we run into this issue again somewhere.
        //Highcharts (on line below, addOrUpdateChartSeries) modifies the chartData array to add an element at the start
        //and an element at the end. So console.log(chartData) actually gives us an array that is n+2 of the correct
        //array length. E.g. console.log(chartData) shows an array of length 74 but on the line below
        //console.log("chartData length: " + chartData.length) shows 72.
        //This is interesting because we can't then rely on the integrity of chartData AFTER the Highcharts render,
        //because Highcharts might have changed it!
        //console.log(chartData);
        //console.log("chartData length: " + chartData.length);
        var parameterDefinition = this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[this.sensorId].Parameters[this.parameterId].Variants[0].ParameterDefinition;
        if (!parameterDefinition || parameterDefinition.Default) parameterDefinition = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[this.parameterId];
        let d = {
            Store: 'P',
            StationId: this.stationId,
            SensorId: this.sensorId,
            ParameterId: this.parameterId,
            Data: chartData,
            ParameterDefinition: parameterDefinition ? parameterDefinition : null,
            VariantId: "Issue: " + moment.tz(issue.issue.RequestedIssueTime, (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName()).format("YYYY-MM-DD HH:mm").toString() + ' ' + (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneString()
        };
        // Get unit conversion
        let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(parameterDefinition?.Units ?? '', this.parameterId);
        // Apply unit conversion
        if (unitsConversionSet) d.Data = d.Data.map((x)=>{
            if (Array.isArray(x) && x.length == 2) return [
                x[0],
                unitsConversionSet.convertValue(x[1])
            ];
            return x;
        });
        if (this.plottingPage.plotData.length === 0) //zoom to data extent if no other data series
        this.plottingPage.setDateRange(moment.utc(chartData[0][0]), moment.utc(chartData[chartData.length - 1][0]));
        this.plottingPage.addOrUpdateChartSeries(d);
        let paramNode = this.findParamNode();
        if (paramNode) paramNode.addChildren(this.getNewNode(issue.issue.RequestedIssueTime, d), 0); //Add at the top
    }
    getIssue(issueTime, baseVariant, then) {
        (0, $fd959835eca46177$export$644e9f91c0b5bf9)((err, resp)=>{
            $('.midi_add-issue-ts').removeClass("disabled");
            $('#spinner_' + issueTime).remove();
            if (err) {
                alert("Error getting issue: " + JSON.stringify(err));
                this.continueButton.addClass("disabled");
                return;
            }
            $('#' + issueTime).addClass('selected');
            this.continueButton.removeClass('disabled');
            this.issues.push({
                issueTime: issueTime,
                issue: resp
            });
            then();
        }, 'P', this.stationId, this.sensorId, this.parameterId, issueTime, baseVariant);
    }
    findBaseVariant() {
        let paramNode = this.findParamNode();
        if (paramNode === null) return null;
        let variants = paramNode.children;
        if (variants.length === 0) {
            console.log("Variants not found! station: " + this.stationId + ", sensor: " + this.sensorId + ", param: " + this.parameterId);
            return null;
        }
        let variantNames = variants.map((x)=>x.title).filter((x)=>x !== "Latest" && x.indexOf("Issue") === -1).map((x)=>({
                s: x,
                f: parseFloat(x.replace(/h/g, ""))
            })).sort((a, b)=>{
            return a.f - b.f;
        });
        let lowestVariant = variantNames[0];
        if (lowestVariant.f !== 0) {
            //if we dont have 0 then check for the fallbackVariantStr
            if (variantNames.some((x)=>x.s === this.fallbackVariantStr)) return this.fallbackVariantStr;
        }
        return lowestVariant.s;
    }
    findParamNode() {
        this.parameterTreeNode.setExpanded();
        return this.parameterTreeNode;
    }
    removeNode(key, d) {
        let node = this.findParamNode();
        let childNode = this.parameterTree.fancyTree.rootNode.findFirst((node)=>{
            return node.key === key;
        });
        node.removeChild(childNode);
        this.plottingPage.removeChartSeries(d);
    }
    getNewNode(ts, d) {
        let key = this.stationId + "|" + this.sensorId + "|" + this.parameterId + "|" + "issue_" + ts;
        return {
            key: key,
            title: "Issue: " + moment.tz(ts, (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneName()).format("YYYY-MM-DD HH:mm").toString() + ' ' + (0, $52db63ea8facb471$export$1a86835baa79d770).instance.getTimeZoneString(),
            selected: true,
            icon: '/images/icons/lineChartIcon.png',
            data: {
                hideData: ()=>{
                    //remove node and remove line from chart
                    this.removeNode(key, d);
                },
                showData: ()=>{
                    //just need to implement for chart refresh and when change dates
                    //but we don't need to download again - just filter data based on selected dates
                    let filteredData = [];
                    let mm = this.plottingPage.getCurrentMoments();
                    d.Data.forEach((d)=>{
                        if (d[0] >= mm.from.valueOf() && d[0] <= mm.to.valueOf()) filteredData.push(d);
                    });
                    let updatedData = {
                        ...d
                    };
                    updatedData.Data = filteredData;
                    this.plottingPage.addOrUpdateChartSeries(updatedData);
                },
                refreshData: ()=>{
                //blank implementation - there will not be any updated data for this series
                }
            }
        };
    }
    hide() {
        if (this.modal) this.modal.remove();
    }
}


/** Flag used in generating Tree nodes, indicating whether SensorId's should be split (if they contain slashes) or not. */ const $ffe68a39831e5f47$var$SPLIT_SENSOR_IDS = true;
/** Character used for splitting SensorId's when we want to generate multiple levels of sensor folders. */ const $ffe68a39831e5f47$var$SPLIT_SENSOR_CHAR = '/';
class $ffe68a39831e5f47$export$2807c05196840aa6 {
    constructor(parameterSchemaStation, parameterSchema = null, $container, plottingPage){
        this.parameterSchemaStation = parameterSchemaStation;
        this.plottingPage = plottingPage;
        this.preventStatusBarUpdates = false;
        this.tree = $('<div class="midi_PlottingPage_download_panel_tree_container"></div>').appendTo($container);
        this.fancyTree = $('<div id="tree" class="midi_PlottingPage_download_panel_tree"></div>').appendTo(this.tree).fancytree({
            checkbox: true,
            selectMode: 3,
            icons: false,
            click: (event, data)=>{
                if (!data.node.folder) {
                    data.node.toggleSelected();
                    return false;
                }
                return true;
            },
            select: (event, data)=>{
                if (!this.preventStatusBarUpdates) this.updateStatusBar();
            },
            source: this.getTreeNodes(parameterSchemaStation, parameterSchema),
            clickFolderMode: 3
        }).fancytree('getTree');
        let $toolbarWrapper = $('<div class="tree-toolbar-wrapper"></div>').appendTo($container);
        this.$statusBar = $('<div class="small text-muted"></div>').css({
            fontStyle: 'italic'
        }).appendTo($toolbarWrapper);
        let $toolbar = $('<div class="btn-toolbar btn-toolbar-sm"></div>').appendTo($toolbarWrapper);
        this.$btnMatchPlotTree = $('<button class="btn-link">Select same as plot (data with download permission)</button>').appendTo($toolbar);
        this.$btnAllSelect = $('<button class="btn-link hidden">Select all</button>').appendTo($toolbar);
        this.$btnAllClear = $('<button class="btn-link">Unselect all</button>').appendTo($toolbar);
        if (this.parameterSchemaStation) {
            //this.selectAllTreeNodes();
            this.fancyTree.getRootNode().children[0].setExpanded(true, {
                noAnimation: true
            });
            this.updateStatusBar(); //: NB: not needed here IF we use this.selectAllTreeNodes()...
        } else //this.updateStatusBar();
        this.selectMatchPlotSelection();
        this.$btnAllClear.on("click", (e)=>{
            e.preventDefault();
            this.deselectAllTreeNodes();
        });
        this.$btnAllSelect.on("click", (e)=>{
            e.preventDefault();
            this.selectAllTreeNodes();
        });
        this.$btnMatchPlotTree.on("click", (e)=>{
            e.preventDefault();
            this.selectMatchPlotSelection();
        });
    }
    getTreeNodes(parameterSchemaStation, parameterSchema = null) {
        var children = [];
        if (parameterSchemaStation !== null) children.push(new $ffe68a39831e5f47$var$StationNodeData(parameterSchemaStation));
        if (parameterSchemaStation == null && parameterSchema !== null) {
            var stationIds = [];
            for(let stationId in parameterSchema.Stations)if (parameterSchema.Stations[stationId].Station.Region == this.plottingPage.mainSite.hashData.Region) stationIds.push(stationId);
            stationIds.sort();
            stationIds.forEach((stationId)=>{
                children.push(new $ffe68a39831e5f47$var$StationNodeData(parameterSchema.Stations[stationId]));
            });
        }
        //hide checkbox for nodes that the user has no download permission for
        children.forEach((node)=>{
            let nrOfChildren = node.children.length;
            let hiddenChildren = 0;
            node.children.forEach((sensorNode)=>{
                if (!this.plottingPage.checkIfUserCanDownloadSensorData(node.station.Station.Id, sensorNode.sensorId)) {
                    sensorNode.hideCheckbox = true;
                    sensorNode.unselectable = true;
                    hiddenChildren += 1;
                    sensorNode.children.forEach((param)=>{
                        param.hideCheckbox = true;
                        param.unselectable = true;
                        param.children.forEach((variant)=>{
                            variant.hideCheckbox = true;
                            variant.unselectable = true;
                        });
                    });
                }
            });
            if (hiddenChildren == nrOfChildren) {
                node.hideCheckbox = true;
                node.unselectable = true;
            }
        });
        return children;
    }
    updateStatusBar() {
        if (this.preventStatusBarUpdates) return;
        $(".midi_PlottingPage_warningBox").remove(); //: just in case some error/warning has been added to the popup (i.e. max number of params..)
        if (this.$statusBar) {
            this.$statusBar.text(`counting...`);
            let paramNodes = [];
            let allSelectedNodes = this.fancyTree.getSelectedNodes();
            allSelectedNodes.forEach((node)=>{
                if (!node.isFolder()) paramNodes.push(node);
            });
            let checkedCount = paramNodes.length; // NB: this is inaccurate, as it would count all parents too, when really we only want the last level (parameters) !!
            this.$statusBar.text(`${checkedCount} parameter(s) selected`);
        }
    }
    deselectAllTreeNodes() {
        this.preventStatusBarUpdates = true;
        this.fancyTree.getSelectedNodes().forEach((n)=>{
            n.setSelected(false);
            n.visitParents((p)=>{
                p.setExpanded(false, {
                    noAnimation: true
                });
            });
        });
        if (this.parameterSchemaStation !== null) this.fancyTree.getRootNode().children[0].setExpanded(true, {
            noAnimation: true
        });
        this.preventStatusBarUpdates = false;
        this.updateStatusBar();
    }
    selectAllTreeNodes() {
        this.preventStatusBarUpdates = true;
        this.fancyTree.visit((node)=>{
            node.setSelected(true);
            if (node.hasChildren() !== false && node.isExpanded() !== true) node.setExpanded(true, {
                noAnimation: true
            });
        });
        this.preventStatusBarUpdates = false;
        this.updateStatusBar();
    }
    selectMatchPlotSelection() {
        this.preventStatusBarUpdates = true;
        this.fancyTree.getSelectedNodes().forEach((n)=>{
            n.setSelected(false);
            n.visitParents((p)=>{
                p.setExpanded(false, {
                    noAnimation: true
                });
            });
        });
        let plotTreeSelectedNodes = this.plottingPage.parameterTree.fancyTree.getSelectedNodes();
        plotTreeSelectedNodes.forEach((node)=>{
            let key = '';
            try {
                key = node.key; //: NB: this used to be 'compiled' here from node.data, but not consistent, so have now setup .key on nodes in plot page ParameterTree, which should match the keys setup on nodes for this download dialog tree..
            } catch (err) {
                console.warn("[ERROR][selectMatchPlotSelection()..] While guessing key from plot tree selected nodes..", {
                    error: err,
                    plotTreeNode: node,
                    key: key
                });
            }
            if (key !== '') {
                let match = this.fancyTree.getNodeByKey(key);
                // console.info("selectMatchPlotSelection(), KEY = ", key, { node: node, match: match, matchIsFolder: match && match.isFolder() });
                if (match && match.isFolder() == false) {
                    match.setSelected(true);
                    match.visitParents((p)=>{
                        p.setExpanded(true, {
                            noAnimation: true
                        });
                    });
                }
            }
        });
        this.preventStatusBarUpdates = false;
        this.updateStatusBar();
    }
}
class $ffe68a39831e5f47$var$StationNodeData {
    constructor(station){
        this.station = station;
        this.NODE_TYPE = 'station';
        this.hideCheckbox = false;
        this.unselectable = true;
        this.folder = true;
        this.selected = false;
        this.expanded = false;
        this.children = [];
        this.buildSensorPath = (_chunk, chunks = null, chunkIndex = null)=>{
            let _key = `${this.key}|`;
            if (chunks && chunks.slice(0, chunkIndex).length > 0) _key += `${chunks.slice(0, chunkIndex).join($ffe68a39831e5f47$var$SPLIT_SENSOR_CHAR)}${$ffe68a39831e5f47$var$SPLIT_SENSOR_CHAR}`;
            _key += _chunk;
            return _key;
        };
        this.title = station.Station.Label;
        this.key = `${station.Station.Id}`;
        var sensorIds = [];
        for(var sensorId in station.Sensors)sensorIds.push(sensorId);
        sensorIds.sort();
        sensorIds.forEach((sensorId)=>{
            ///this.children.push(new SensorNodeData(this, sensorId, station.Sensors[sensorId]));
            let sensorNode = new $ffe68a39831e5f47$var$SensorNodeData(this, sensorId, station.Sensors[sensorId]);
            if (sensorNode.needsPushingToStationChildren) this.children.push(sensorNode);
        });
        this._self = this;
    }
    /**
     * Helper to read/search a flattened array of sensor nodes for this station (helpful mainly for regrouping if that option is enabled).
     * @param pathsOnly
     * @returns
     */ flattenSensorNodesRecursive(pathsOnly = false) {
        let res = [];
        this.children.forEach((x)=>{
            res.push(pathsOnly ? x.path : x);
            x.flattenChildSensorNodesRecursive(pathsOnly, res);
        });
        return res;
    }
    /**
     * Helper to get the node to which a sensor & params need adding. Idea is to use this to add parameters to the final node given as a result. Warning: this may return
     * the station node rather than a parameter node (as it's the root node for this action), but this is very unlikely to be the case in reality, unless autoAdd is not true.
     * 
     * @param chunks The chunks (or leaves) of the sensor ID, this should be at the very last one string corresponding to a sensor ID if it is not meant to be a tree of sensors.
     * @param autoAdd Automatically add the relevant nodes? This should normally always be true.
     * @param srcSensorId The source sensorId that triggered this call. If null, it will be built from chunks.
     * @param srcSensor The source sensor parameters that triggered this call. If null, a blank dummy API.ParameterSchemaSensor will be generated.
     * @returns The node to add sensor parameters to normally.
     */ getSensorNodeRecursively(chunks, autoAdd = true, srcSensorId = null, srcSensor = null) {
        let debug = false;
        if (debug) console.info('StationNodeData.getSensorNodeRecursively()', {
            chunks: chunks,
            srcSensor: srcSensor
        }); // , srcSensorId: srcSensorId
        let finalNode = null;
        let addTo = this; //: progressively change this to each parent leaf when looping through chunks.. staring with station node to start with.
        chunks.forEach((chunk, i)=>{
            let flat = this.flattenSensorNodesRecursive(false);
            let path = this.buildSensorPath(chunk, chunks, i);
            let incrementalChunks = chunks.slice(0, i + 1);
            let match = flat.filter((x)=>x.path == path);
            if (debug) console.info('StationNodeData.getSensorNodeRecursively() - CHUNKS LOOP', {
                chunk: chunk,
                i: i,
                path: path,
                match: match,
                incrementalChunks: incrementalChunks
            });
            if (match.length == 1) {
                finalNode = match[0];
                addTo = match[0];
            } else if (match.length == 0) {
                if (autoAdd) {
                    let _srcSensor = {
                        Parameters: {},
                        SensorDefinition: {
                            DisplayName: chunk,
                            Combined: false,
                            Level: null,
                            SourceIndex: null,
                            Hidden: false
                        },
                        UseLiveData: true
                    };
                    if (i == chunks.length - 1) {
                        if (srcSensor !== null) _srcSensor = srcSensor;
                    }
                    let sensorNode = new $ffe68a39831e5f47$var$SensorNodeData(this, srcSensorId, _srcSensor, this.buildSensorPath(incrementalChunks.join($ffe68a39831e5f47$var$SPLIT_SENSOR_CHAR)), chunk, false, false);
                    if (debug) console.info('StationNodeData.getSensorNodeRecursively() - CHUNKS LOOP - new SensorNodeData()', {
                        sensorNode: sensorNode
                    });
                    addTo.children.push(sensorNode);
                    addTo = sensorNode;
                    finalNode = sensorNode;
                } else console.warn(`StationNodeData.getSensorNodeRecursively() - ${match.length} matches found for path '${path}', and autoAdd param is false...`);
            } else {
                console.warn(`StationNodeData.getSensorNodeRecursively() - ${match.length} matches found for path '${path}', when 1 or 0 expected. We're going to use the first result by default, but this may not be the wanted behaviour, in which case sensor IDs need to be checked.`);
                finalNode = match[0];
                addTo = match[0];
            }
        });
        if (debug) console.info('StationNodeData.getSensorNodeRecursively() - FINAL NODE', {
            finalNode: finalNode,
            chunks: chunks
        });
        return finalNode;
    }
}
class $ffe68a39831e5f47$var$SensorNodeData {
    constructor(stationNode, sensorId, sensor, path = null, label = null, allowHandlingParents = true, addParams = true){
        this.stationNode = stationNode;
        this.sensorId = sensorId;
        this.sensor = sensor;
        this.path = path;
        this.label = label;
        this.NODE_TYPE = 'sensor';
        this.hideCheckbox = false;
        this.unselectable = false;
        this.folder = true;
        this.selected = false;
        this.expanded = false;
        this.isSplitSensor = false;
        this.needsPushingToStationChildren = true;
        this.children = [];
        this.title = sensor.SensorDefinition && sensor.SensorDefinition.DisplayName ? sensor.SensorDefinition.DisplayName : sensorId;
        if (this.label) this.title = this.label;
        this.key = `${stationNode.key}|${sensorId}`;
        if (path == null) this.path = stationNode.buildSensorPath(sensorId); //: this should maybe be built on either split display name or 
        let addParamsTo = this;
        let sensorPathFinal = sensorId;
        if (sensor.SensorDefinition && sensor.SensorDefinition.DisplayName) sensorPathFinal = sensor.SensorDefinition.DisplayName; //: initially, we can set paths in sensor DisplayName - if this is not working then a new DB column may need to be added.
        let splitSensorId = sensorPathFinal.split($ffe68a39831e5f47$var$SPLIT_SENSOR_CHAR); //: TODO HERE: change this to use the database param we want to split (DisplayName ? or other if we feel using the display name for this as a temporary solution works..)
        //: emulate/test nested sensors for Prelude:
        /*
        if (stationNode.key == 'Australia_Prelude' && sensorId.substring(0, 'Forecast '.length) == 'Forecast ') {
            splitSensorId = sensorId.split(' ');
        }
        if (stationNode.key == 'Australia_Prelude' && sensorId == 'Forecast_30min') {
            splitSensorId = sensorId.split('_');
        }
        if (stationNode.key == 'Australia_Prelude' && sensorId == 'Forecast') {
            console.info('Australia_Prelude.Forecast  EMULATED TO  Forecast/Main/Tests...');
            splitSensorId = ['Forecast', 'Main', 'Tests'];
            // sensorId = 'Forecast/Main/Tests';
        }
        */ if ($ffe68a39831e5f47$var$SPLIT_SENSOR_IDS && allowHandlingParents) addParamsTo = stationNode.getSensorNodeRecursively(splitSensorId, true, sensorId, sensor) ?? this;
        if (!addParams) // console.warn('SensorNodeData DO NOT ADD PARAMS set.', sensorId, this.key, this.path, addParamsTo);
        return;
        var parameterIds = [];
        for(var parameterId in sensor.Parameters)parameterIds.push(parameterId);
        parameterIds.sort();
        parameterIds.forEach((parameterId)=>{
            addParamsTo.children.push(new $ffe68a39831e5f47$var$ParameterNodeData(addParamsTo, parameterId, sensor.Parameters[parameterId]));
        });
    }
    flattenChildSensorNodesRecursive(keysOnly = false, addTo = []) {
        this.children.forEach((x)=>{
            if (x.NODE_TYPE == 'sensor') {
                addTo.push(keysOnly ? x.key : x);
                x.flattenChildSensorNodesRecursive(keysOnly, addTo);
            }
        });
    }
}
class $ffe68a39831e5f47$var$ParameterNodeData {
    constructor(sensorNode, parameterId, parameterInfo){
        this.sensorNode = sensorNode;
        this.parameterId = parameterId;
        this.parameterInfo = parameterInfo;
        this.NODE_TYPE = 'parameter';
        this.hideCheckbox = false;
        this.unselectable = false;
        this.folder = false;
        this.selected = false;
        this.children = [];
        this.title = parameterInfo.Variants.length && parameterInfo.Variants[0].ParameterDefinition && parameterInfo.Variants[0].ParameterDefinition.DisplayName ? parameterInfo.Variants[0].ParameterDefinition.DisplayName : parameterId;
        // this.folder = parameterInfo.Variants.length != 0; //: not entirely accurate, as we only add variants if the .Variant key is not null..
        this.key = `${sensorNode.key}|${parameterId}`;
        var variantNames = [];
        for (var v of parameterInfo.Variants){
            if (v.Variant != null) variantNames.push(v.Variant);
            else if (v.Variant == null && parameterInfo.Variants.length > 1) variantNames.push(v.Variant);
        }
        variantNames.sort((a, b)=>{
            let av = parseFloat(a);
            let bv = parseFloat(b);
            if (!isNaN(av) && !isNaN(bv)) return av - bv;
            else if (isNaN(av)) return -1;
            else if (isNaN(bv)) return 1;
            else return a.localeCompare(b);
        });
        variantNames.forEach((variantName)=>{
            this.children.push(new $ffe68a39831e5f47$var$VariantNodeData(sensorNode, variantName, parameterId, parameterInfo));
        });
        if (variantNames.length > 0) this.folder = true;
    }
}
class $ffe68a39831e5f47$var$VariantNodeData {
    constructor(sensorNode, variantName, parameterId, parameterInfo){
        this.sensorNode = sensorNode;
        this.variantName = variantName;
        this.parameterId = parameterId;
        this.parameterInfo = parameterInfo;
        this.NODE_TYPE = 'variant';
        this.hideCheckbox = false;
        this.unselectable = false;
        this.folder = false;
        this.selected = false;
        this.title = variantName === null ? "Latest" : variantName;
        this.key = `${sensorNode.key}|${parameterId}|${variantName}`; //: NB: "null" added if we receive variantName===null, which is necessary for handling matches with plot page tree selections and also downloads instructions sent to server.
    }
}


class $6af33996902e4a66$export$23a0a2b4bb5a9051 {
    constructor(parameterSchemaStation, plottingPage){
        this.parameterSchemaStation = parameterSchemaStation;
        this.plottingPage = plottingPage;
        this.modal = null;
        this.momentFormatDebug = "YYYY-MM-DD HH:mm:ss ZZ (X)";
        this.maxParamsAllowed = 50;
    }
    getMoments(fromYMD, toYMD) {
        let offset = this.plottingPage.mainSite.getTimeZoneStringFormat('ZZ');
        let format = "YYYY-MM-DD HH:mm:ssZ";
        let f = moment.parseZone(fromYMD + " 00:00:00" + offset, format);
        let t = moment.parseZone(toYMD + " 23:59:00" + offset, format);
        return {
            from: f,
            to: t,
            debug: {
                f: f.format(this.momentFormatDebug),
                t: t.format(this.momentFormatDebug)
            }
        };
    }
    show(defaultFrom, defaultTo) {
        let mm = this.getMoments(defaultFrom.format("YYYY-MM-DD"), defaultTo.format("YYYY-MM-DD"));
        this.from = mm.from;
        this.to = mm.to;
        //console.info("DATERANGE [show]", { aa: mm, args: { f: defaultFrom, t: defaultTo }, from: this.from, from_fmt: this.from.format(this.momentFormatDebug), to: this.to, to_fmt: this.to.format(this.momentFormatDebug) });
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));
        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        let titleStr = "Download Data";
        if (this.parameterSchemaStation) titleStr += `: ${this.parameterSchemaStation.Station.Label}`;
        $('<h4 class="modal-title"></h4>').text(titleStr).appendTo(modalHeader);
        var modalBody = $('<div class="modal-body" id="midi_PlottingPage_modal_download_body"></div>').appendTo(modalContent);
        var timeZoneString = this.plottingPage.mainSite.getTimeZoneString();
        var form = $('<form class="form-horizontal"></form>').appendTo(modalBody);
        let $row = null;
        $row = $('<div>').addClass('form-group').appendTo(form);
        $('<label class="col-sm-2 control-label">Date&nbsp;Range</label>').appendTo($row);
        var dateRangePicker = $('<div id="midi_PlottingPage_download_modal_date_container" class="input-daterange input-group"><input class="input-sm form-control" type="text" id="midi_PlottingPage_download_date_picker_from" name="start"><span class="input-group-addon">to</span><input class="input-sm form-control" type="text" id="midi_PlottingPage_download_date_picker_to" name="end"></div>').appendTo($('<div class="col-sm-6"></div>').appendTo($row)).datepicker({
            // format: "yyyy-mm-dd  " + timeZoneString,
            format: "yyyy-mm-dd" // ,
        }).on('changeDate', (e)=>{
            let ymdFrom = dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val().substr(0, 10);
            let ymdTo = dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val().substr(0, 10);
            let mm = this.getMoments(ymdFrom, ymdTo);
            this.from = mm.from;
            this.to = mm.to;
            /*
                let f2: moment.Moment = moment.utc(dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val(), 'YYYY-MM-DD');
                let t2: moment.Moment = moment.utc(dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val(), 'YYYY-MM-DD').endOf('day').startOf('minute');

                console.info("DATERANGE [change]", { aa: mm, from: this.from, from_fmt: this.from.format(this.momentFormatDebug), to: this.to, to_fmt: this.to.format(this.momentFormatDebug), from_val: dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').val(), to_val: dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').val(), utc_from: f2, utc_from_fmt: f2.format(this.momentFormatDebug), utc_to: t2, utc_to_fmt: t2.format(this.momentFormatDebug) });
                */ //: auto-hide datepicker & move onto 'to' field if appropriate
            $(e.target).blur();
            $(e.target).datepicker('hide');
            if (e.target.id == "midi_PlottingPage_download_date_picker_from") dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').focus();
        });
        let $tzSelect = $("<select>").addClass('form-control input-sm');
        $tzSelect.appendTo($('<div>').addClass('col-sm-4').appendTo($row));
        let tzOpts = this.plottingPage.mainSite.getAllAvailableTimeZones();
        let $opt = null;
        tzOpts.forEach((tzd)=>{
            $opt = $('<option>').attr('value', tzd.timeZoneName).text(tzd.label).data('tzOffsetMinutes', tzd.offsetMinutes).data('tzd', tzd);
            $tzSelect.append($opt);
        });
        $tzSelect.val(this.plottingPage.mainSite.getTimeZoneName());
        var dataFormatContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Format</label></div>').appendTo(form);
        var csvDownloadToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataFormatContainer);
        var csvToggle = $('<input type="radio" name= "download_format" checked />').appendTo(csvDownloadToggleContainer);
        $($.parseHTML(' CSV')).appendTo(csvDownloadToggleContainer);
        var dlpDownloadToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataFormatContainer);
        var dlpToggle = $('<input type="radio" name= "download_format" />').appendTo(dlpDownloadToggleContainer);
        $($.parseHTML(' DLP')).appendTo(dlpDownloadToggleContainer);
        csvToggle.prop('checked', true);
        var dataIntervalContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Interval</label></div>').appendTo(form);
        var oneMinIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var oneMinInterval = $('<input type="radio" name= "download_interval" />').appendTo(oneMinIntervalToggleContainer);
        $($.parseHTML(' 1 Min.')).appendTo(oneMinIntervalToggleContainer);
        var tenMinIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var tenMinInterval = $('<input type="radio" name= "download_interval" checked />').appendTo(tenMinIntervalToggleContainer);
        $($.parseHTML(' 10 Min.')).appendTo(tenMinIntervalToggleContainer);
        var oneHourIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var oneHourInterval = $('<input type="radio" name= "download_interval" />').appendTo(oneHourIntervalToggleContainer);
        $($.parseHTML(' 1 Hour')).appendTo(oneHourIntervalToggleContainer);
        var allDataIntervalToggleContainer = $('<div class= "col-sm-2 midi_PlottingPage_download_toggle" > </div>').appendTo(dataIntervalContainer);
        var allDataInterval = $('<input type="radio" name= "download_interval" />').appendTo(allDataIntervalToggleContainer);
        $($.parseHTML(' All Data')).appendTo(allDataIntervalToggleContainer);
        dateRangePicker.find('#midi_PlottingPage_download_date_picker_from').datepicker('update', mm.from.format("YYYY-MM-DD"));
        dateRangePicker.find('#midi_PlottingPage_download_date_picker_to').datepicker('update', mm.to.format("YYYY-MM-DD"));
        dateRangePicker.datepicker('updateDates');
        var dataParameterContainer = $('<div class="form-group"><label class="col-sm-2 control-label">Parameters</label></div>').appendTo(form);
        var dataParameterTreeContainer = $('<div class="col-sm-10"></div>').appendTo(dataParameterContainer);
        this.downloadTree = new (0, $ffe68a39831e5f47$export$2807c05196840aa6)(this.parameterSchemaStation, this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema, dataParameterTreeContainer, this.plottingPage);
        // this.downloadTree.tree.appendTo(dataParameterTreeContainer);
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooter);
        $('<button type="button" class="btn btn-success">Download</button>').appendTo(modalFooter).click(()=>{
            $(".midi_PlottingPage_warningBox").remove();
            var downloadFormat = "";
            if (csvToggle.is(':checked')) downloadFormat = "csv";
            if (dlpToggle.is(':checked')) downloadFormat = "dlp";
            var downloadInterval = 0; // default to all data
            if (oneMinInterval.is(':checked')) downloadInterval = 1;
            if (tenMinInterval.is(':checked')) downloadInterval = 10;
            if (oneHourInterval.is(':checked')) downloadInterval = 60;
            $(".midi_PlottingPage_download_inputs").remove();
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.from.valueOf() + '" name="From">').appendTo(modalForm);
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.to.valueOf() + '" name="To">').appendTo(modalForm);
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadFormat + '" name="Format">').appendTo(modalForm);
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadInterval + '" name="Interval">').appendTo(modalForm);
            // $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.plottingPage.mainSite.getTimeZoneUtcOffset().toString() + '" name="TzDiffMinutes">').appendTo(modalForm);
            // $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.plottingPage.mainSite.getTimeZoneName() + '" name="TzName">').appendTo(modalForm);
            let $tzOpt = $tzSelect.find(`option[value="${$tzSelect.val()}"]`);
            if (!$tzOpt || $tzOpt.length == 0) {
                $('<div class="alert alert-danger midi_PlottingPage_warningBox">Unable to get the timezone option. Please try another timezone or refresh the page.</div>').appendTo(form);
                return;
            }
            let tzd = $tzOpt.data('tzd');
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + tzd.offsetMinutes + '" name="TzDiffMinutes">').appendTo(modalForm);
            $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + tzd.timeZoneName + '" name="TzName">').appendTo(modalForm);
            // console.info("FORM TZ DATA:", { $opt: $opt, tzd: tzd, val: $tzSelect.val() }); // return;
            var selectedNodes = this.downloadTree.fancyTree.getSelectedNodes();
            if (selectedNodes.filter((x)=>x.data.sensorNode).length > this.maxParamsAllowed) {
                $(`<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select a maximum of ${this.maxParamsAllowed} parameters.</div>`).appendTo(form);
                return;
            }
            var anyInputs = false;
            let inputsCount = 0;
            selectedNodes.forEach((selectedNode)=>{
                if (selectedNode.data.sensorNode) {
                    anyInputs = true;
                    inputsCount++;
                    $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.parameterInfo.Store + '" name="StoreCols[]">').appendTo(modalForm);
                    $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.sensorNode.stationNode.station.Station.Id + '" name="SiteCols[]">').appendTo(modalForm);
                    $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.sensorNode.sensorId + '" name="SensorCols[]">').appendTo(modalForm);
                    $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + selectedNode.data.parameterId + '" name="ParameterCols[]">').appendTo(modalForm);
                    $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + (selectedNode.data.variantName === null ? 'undefined' : selectedNode.data.variantName) + '" name="VariantCols[]">').appendTo(modalForm); //: NB: the server does not understand variant "null", but does interpret variant "undefined".
                }
            });
            if (anyInputs) {
                if (inputsCount > this.maxParamsAllowed) $(`<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select a maximum of ${this.maxParamsAllowed} parameters.</div>`).appendTo(form);
                else {
                    modalForm.submit();
                    modalForm.empty;
                    this.modal.modal('hide');
                }
            } else $('<div class="alert alert-danger midi_PlottingPage_warningBox">Error downloading data: Please select at least one parameter</div>').appendTo(form);
        });
        var modalForm = $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').appendTo(modalFooter);
        this.modal.on("shown.bs.modal", (e)=>{
            this.plottingPage.pageUnblock();
        });
        this.modal.modal('show');
    }
    hide() {
        if (this.modal) this.modal.remove();
    }
}



/**
 * A class for handling User Client Config. Note that the conf is readonly, so this class should be a
 * variable that gets replaced, rather than modified. Although this idea may not work for editing confs.. so TBC!!
 */ class $6a744cf7ffecae4a$var$ParameterSetConf {
    constructor(conf, mainSite){
        this.conf = conf;
        this.mainSite = mainSite;
    }
    static parseFromJson(json, mainSite) {
        let parsed;
        if (typeof json == 'string') parsed = JSON.parse(json);
        else parsed = null;
        let conf = $6a744cf7ffecae4a$var$ParameterSetConf.autoUpgradeUserClientConf(parsed, mainSite);
        // console.info('ParameterSetConf.parseFromJson()', { json: json, parsed: parsed, conf: conf });
        return new $6a744cf7ffecae4a$var$ParameterSetConf(conf, mainSite);
    }
    //: ideas: create methods .save() to store config to database, .deleteParamSet() to remove single param set, and also maybe methods to fetch latest config from server?
    /**
     * Helper method to reduce/flatten plot conf values that erroneously got stored in varying levels of string arrays.
     * NB: before this method was created, the existing data was manually verified and any user's ClientConfiguration
     * containing "__plot_confs" keys were checked - any values in string arrays are the same as the first array entry
     * if there are cases where multiple confs JSON strings got stored against a single axisId key...
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat#reduce_concat_isarray_recursivity
     * @param arr
     * @param d
     */ static flatDeep(arr, d = 1) {
        return d > 0 ? arr.reduce((acc, val)=>acc.concat(Array.isArray(val) ? this.flatDeep(val, d - 1) : val), []) : arr.slice();
    }
    /**
     * Helper to try getting station details (mostly need stationId) from v1 & v2 confs 'siteId', as they used to
     * be built from the ParameterTree node label, which usually used the station label rather than ID, but from
     * third version of user client conf format (as of 2023-03), the parameter sets consistently used the actual
     * stationId from nodes rather than the label.
     * @param label
     * @param mainSite
     * @returns
     */ static matchLegacyStationLabel(label, mainSite) {
        if (label in mainSite.staticDataManager.Schema.ParameterSchema.Stations) return mainSite.staticDataManager.Schema.ParameterSchema.Stations[label].Station;
        for(let stationId in mainSite.staticDataManager.Schema.ParameterSchema.Stations){
            let _station = mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station;
            if (_station.Label == label) return _station;
        }
        return null;
    }
    /**
     * Similar to `.matchLegacyStationLabel()` but to match the sensor label to sensorId. This will not work anymore if
     * sensors' DisplayName get changed to allow nested sensors in the tree. This however returns a string corresponding
     * to the sensorId (as API.ParameterSchemaSensor does not provide the sensorId!) or null if not matched.
     * @param stationId
     * @param label
     * @param mainSite
     * @returns
     */ static matchLegacySensorLabel(stationId, label, mainSite) {
        if (!(stationId in mainSite.staticDataManager.Schema.ParameterSchema.Stations)) return null;
        let _sensors = mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId].Sensors;
        if (label in _sensors) return label;
        for(let sensorId in _sensors){
            if (_sensors[sensorId].SensorDefinition && _sensors[sensorId].SensorDefinition.DisplayName == label) //console.info('%cV2 matched sensor label', 'color: limegreen; font-style:italic', { label: label, sensorId: sensorId, stationId: stationId });
            return sensorId;
        }
        return null;
    }
    static confUpgradeFromV1(conf, mainSite) {
        let newConf = {
            savedParameterSets: []
        };
        try {
            for(let paramSetId in conf.savedParameterSets){
                let newParamSet = {
                    paramSetId: paramSetId,
                    ////paramSetsBySite: {}, // tmp.savedParameterSets[paramSetId],
                    plotConfigurations: {},
                    selectedParameters: []
                };
                for(let siteLabel in conf.savedParameterSets[paramSetId]){
                    if (siteLabel == "__plot_confs") //: handle plot confs. This is a little bit messy, but the code that previously managed/stored plot configurations ended up storing
                    //: them as either string or string arrays, with sometimes multiple levels of arrays. See ParameterSetList.flatDeep() for information
                    //: on how old data is read to be converted to v2.
                    for(let axisIdAliasSensorId in conf.savedParameterSets[paramSetId][siteLabel]){
                        let _conf = conf.savedParameterSets[paramSetId][siteLabel][axisIdAliasSensorId];
                        let _confStr;
                        let _confObj; // API.SavedParameterSetV2PlotConfiguration;
                        if (Array.isArray(_conf)) _confStr = $6a744cf7ffecae4a$var$ParameterSetConf.flatDeep(_conf, Infinity)[0];
                        if (typeof _conf == "string") _confStr = _conf;
                        _confObj = JSON.parse(_confStr); // API.SavedParameterSetV2PlotConfiguration;
                        newParamSet.plotConfigurations[axisIdAliasSensorId] = _confObj;
                    }
                    else //newParamSet.paramSetsBySite[siteLabel] = conf.savedParameterSets[paramSetId][siteLabel]; //: ignoring this as it's for older v2..
                    for(let sensorId in conf.savedParameterSets[paramSetId][siteLabel]){
                        let parameters = conf.savedParameterSets[paramSetId][siteLabel][sensorId];
                        if (Array.isArray(parameters)) parameters.forEach((parameterId)=>{
                            let stationId = $6a744cf7ffecae4a$var$ParameterSetConf.matchLegacyStationLabel(siteLabel, mainSite)?.Id ?? siteLabel;
                            let selectedParam = {
                                isLegacy: true,
                                stationId: stationId,
                                sensorId: $6a744cf7ffecae4a$var$ParameterSetConf.matchLegacySensorLabel(stationId, sensorId, mainSite) ?? sensorId,
                                parameterId: parameterId,
                                variant: null //: variants weren't properly supported in v1!
                            };
                            newParamSet.selectedParameters.push(selectedParam);
                        });
                        else console.warn(`ParamSets Legacy Convert ERROR: unable to convert v1 selected parameter as data is not in exected format (received ${typeof parameters}, when we expected 'string[]')`, {
                            parameters: parameters,
                            paramSetId: paramSetId,
                            siteLabel: siteLabel,
                            sensorId: sensorId,
                            legacyConf: conf
                        });
                    }
                }
                newConf.savedParameterSets.push(newParamSet);
            }
            return newConf;
        } catch (err) {
            console.warn("Error while parsing old API.ClientConfiguration..", {
                confReceived: conf,
                newConf: newConf,
                err: err
            });
        }
    }
    static confUpgradeFromV2(conf, mainSite) {
        let newConf = {
            savedParameterSets: []
        };
        if (conf == null) return newConf;
        try {
            if (!Array.isArray(conf.savedParameterSets)) throw new Error('Invalid format of received conf.savedParameterSets !');
            conf.savedParameterSets.forEach((paramSetV2)=>{
                let newParamSet = {
                    paramSetId: paramSetV2.paramSetId,
                    plotConfigurations: paramSetV2.plotConfigurations,
                    selectedParameters: []
                };
                for(let siteLabel in paramSetV2.paramSetsBySite){
                    let _site = paramSetV2.paramSetsBySite[siteLabel];
                    for(let sensorId in _site){
                        let _params = _site[sensorId];
                        let _stationId = $6a744cf7ffecae4a$var$ParameterSetConf.matchLegacyStationLabel(siteLabel, mainSite)?.Id ?? siteLabel;
                        let _sensorId = $6a744cf7ffecae4a$var$ParameterSetConf.matchLegacySensorLabel(_stationId, sensorId, mainSite); // ?? sensorId;
                        if (!_sensorId) {
                            _sensorId = sensorId;
                            console.warn('ParamSets v2 - unmatched sensor label:', sensorId, {
                                stationId: _stationId,
                                siteLabel: siteLabel,
                                _site: _site,
                                _station: $6a744cf7ffecae4a$var$ParameterSetConf.matchLegacyStationLabel(siteLabel, mainSite),
                                sensorsList: mainSite.staticDataManager.Schema.ParameterSchema.Stations[_stationId]?.Sensors
                            });
                        }
                        _params.forEach((_param)=>{
                            if (typeof _param == 'string') {
                                let selectedParam = {
                                    isLegacy: true,
                                    stationId: _stationId,
                                    sensorId: _sensorId,
                                    parameterId: _param,
                                    variant: null
                                };
                                newParamSet.selectedParameters.push(selectedParam);
                            } else if (Array.isArray(_param)) _param.forEach((_variant)=>{
                                let selectedParam = {
                                    isLegacy: true,
                                    stationId: _stationId,
                                    sensorId: _sensorId,
                                    parameterId: _param,
                                    variant: _variant
                                };
                                newParamSet.selectedParameters.push(selectedParam);
                            });
                        });
                    }
                }
                newConf.savedParameterSets.push(newParamSet);
            });
            // console.info('ParameterSetConf.confUpgradeFromV2()', { conf: conf, newConf: newConf });
            return newConf;
        } catch (err) {
            console.warn("Error while parsing old API.ClientConfigurationV2..", {
                confReceived: conf,
                newConf: newConf,
                err: err
            });
        }
    }
    static autoUpgradeUserClientConf(conf, mainSite) {
        if (conf == null) {
            let _new = {
                savedParameterSets: []
            };
            return _new;
        }
        if ($.isPlainObject(conf.savedParameterSets) && !Array.isArray(conf.savedParameterSets)) return $6a744cf7ffecae4a$var$ParameterSetConf.confUpgradeFromV1(conf, mainSite);
        if (Array.isArray(conf.savedParameterSets)) {
            let v2ParamSetsBySites = conf.savedParameterSets.filter((set)=>$.isPlainObject(set.paramSetsBySite) && Object.keys(set.paramSetsBySite).length > 0);
            if (v2ParamSetsBySites.length > 0) return $6a744cf7ffecae4a$var$ParameterSetConf.confUpgradeFromV2(conf, mainSite);
        }
        if (Array.isArray(conf.savedParameterSets)) {
            let v3ParamSetsBySites = conf.savedParameterSets.filter((set)=>'selectedParameters' in set && Array.isArray(set.selectedParameters));
            if (v3ParamSetsBySites.length > 0) return conf;
        }
    }
}
class $6a744cf7ffecae4a$export$51ba4ecd5810c2ba {
    constructor(mainSite, parameterTree, $container, plottingPage){
        this.mainSite = mainSite;
        this.parameterTree = parameterTree;
        this.$container = $container;
        this.plottingPage = plottingPage;
        this.loadedParamSetName = "";
        let paramsTitleContainer = $('<div class="midi_PlottingPage_series_panel_sideContainer_parametersTitle clearfix flex-col-item--no-grow"></div>').css("paddingTop", "0").appendTo($container);
        $('<h5></h5>').text("Parameter Sets").appendTo(paramsTitleContainer);
        this.$btnSaveOrder = $('<div class="btn btn-default"><i class="fa fa-floppy-o"></i>&nbsp;Save Order</div>').attr("disabled", "disabled").hide().on("click", (e)=>{
            this.saveParamSetsOrder(mainSite);
            this.$btnSaveOrder.blur().attr("disabled", "disabled").hide();
        }).appendTo(paramsTitleContainer);
        this.innerJQuery = $('<div class="midi_PlottingPage_series_panel_sideContainer_box midi_PlottingPage_series_panel_sideContainer_parameterSets overflow-auto flex-col-item--grow"></div>').appendTo(this.$container);
        this.saveModal = $('<div class="modal fade"></div>').appendTo('body');
        let modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.saveModal));
        let modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        $('<h4 class="modal-title"></h4>').text('Save parameter set').appendTo(modalHeader);
        let modalBody = $('<div class="modal-body" id="midi_PlottingPage_modal_saveParamSet_body"></div>').appendTo(modalContent);
        let gotSomeParamSets = false;
        if (mainSite.currentUser.ClientConfiguration) {
            //check that we have parameter sets that we are also displaying sites in the tree for (i.e. parameter sets
            //that are relevant for the current region)
            let clientConfig = this.getUserClientConfig(mainSite);
            // console.info('paramsetslist - clientConfig in constructor', { json: mainSite.currentUser.ClientConfiguration, parsed: clientConfig });
            if (clientConfig && Array.isArray(clientConfig.savedParameterSets)) clientConfig.savedParameterSets.forEach((ps)=>{
                if (!gotSomeParamSets && ps.selectedParameters.length > 0) gotSomeParamSets = true;
            /*for (let siteLabel in ps.paramSetsBySite) {
                        let siteNode = this.parameterTree.fancyTree.rootNode.findFirst(siteLabel);
                        if (siteNode) {
                            gotSomeParamSets = true;
                        }
                    }*/ });
        }
        if (gotSomeParamSets) $('<p></p>').text("Click on an existing parameter set to overwrite it or enter a new parameter set name in the box below.").appendTo(modalBody);
        else $('<p></p>').text("Please enter a name for this parameter set in the box below.").appendTo(modalBody);
        this.saveModalListContent = $('<ul></ul>').appendTo(modalBody);
        if (!gotSomeParamSets) this.saveModalListContent.hide();
        else this.saveModalListContent.show();
        this.paramsetLabel = $('<input class="form-control" type="text">').appendTo(modalBody);
        this.saveModalValidationAlert = $('<div class="alert alert-danger"></div>').text("You must enter a name for the parameter set").appendTo(modalBody).hide();
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').click(()=>{
            this.saveModal.modal('hide');
        }).appendTo(modalFooter);
        $('<button type="button" class="btn btn-success">Save</button>').appendTo(modalFooter).click(()=>{
            let setName = this.validate();
            //TODO: get the error colouring to work on the input
            if (setName === null) {
                this.paramsetLabel.addClass("has-error");
                this.saveModalValidationAlert.show();
                return;
            }
            this.paramsetLabel.removeClass("has-error");
            this.saveModalValidationAlert.hide();
            let newParamSet = {
                paramSetId: setName,
                selectedParameters: this.getUISelectedParams(),
                plotConfigurations: this.plottingPage.customLimitsByAxisLabel
            };
            let newConf = this.getUserClientConfig(mainSite);
            if (!newConf) newConf = {
                savedParameterSets: []
            };
            let psi = null;
            if (newConf) {
                psi = this.clientConfigParamSetFindIndex(setName, newConf);
                if (psi >= 0) newConf.savedParameterSets[psi] = newParamSet;
                else newConf.savedParameterSets.push(newParamSet);
            }
            this.tryUpdateClientConfiguration(mainSite.currentUser.Id, JSON.stringify(newConf), this.paramsetLabel.val());
        });
        this.deleteModal = $('<div class="modal fade"></div>').appendTo('body');
        modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.deleteModal));
        modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        $('<h4 class="modal-title"></h4>').text('Delete parameter set').appendTo(modalHeader);
        this.deleteModalBody = $('<div class="modal-body"></div>').appendTo(modalContent);
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').click(()=>{
            this.deleteKey = null;
            this.deleteModal.modal('hide');
        }).appendTo(modalFooter);
        $('<button type="button" class="btn btn-danger">Delete</button>').appendTo(modalFooter).click(()=>{
            let conf = this.getUserClientConfig(mainSite);
            if (!conf) conf = {
                savedParameterSets: []
            };
            let psi = null;
            if (conf) {
                psi = this.clientConfigParamSetFindIndex(this.deleteKey, conf);
                if (psi >= 0) conf.savedParameterSets.splice(psi, 1);
            }
            this.tryUpdateClientConfiguration(mainSite.currentUser.Id, JSON.stringify(conf), null);
        });
        this.rebuildLists(this.getUserClientConfig(mainSite));
    }
    tryUpdateClientConfiguration(email, clientConfiguration, autoSelectParamSetId) {
        (0, $4b7cacdb38b8b78b$export$566de75f74361f11)(email, clientConfiguration, (err, data)=>{
            if (err) {
                this.saveModalValidationAlert.text('Error updating client configuration: ' + err.Message).show();
                return;
            }
            this.saveModal.modal('hide');
            this.deleteModal.modal('hide');
            this.mainSite.currentUser.ClientConfiguration = data;
            this.rebuildLists(this.getUserClientConfig(this.mainSite));
            if (autoSelectParamSetId) this.innerJQuery.find('ul').find('li:contains("' + autoSelectParamSetId + '")').click();
        });
    }
    validate() {
        let setName = this.paramsetLabel.val().trim();
        return setName !== "" && setName !== null ? setName : null;
    }
    rebuildLists(clientConfig) {
        this.innerJQuery.empty();
        this.saveModalListContent.empty();
        let noneli = $('<li></li>').click(()=>{
            this.deselectAllTreeNodes();
            this.paramsetLabel.val("");
            this.$paramSetsUL.find($(".selected")).removeClass("selected");
            noneli.addClass("selected");
            this.loadedParamSetName = "";
            this.loadedParamSetValues = null;
            this.plottingPage.resetCustomLimits();
        }).addClass("selected no-drag").append($('<span></span>').text("None"));
        if (this.$paramSetsUL) this.$paramSetsUL.remove();
        this.$paramSetsUL = $('<ul></ul>').append(noneli).appendTo(this.innerJQuery);
        let currentParamsets;
        if (clientConfig && Array.isArray(clientConfig.savedParameterSets)) {
            currentParamsets = clientConfig.savedParameterSets;
            // console.info('paramsets list - current config', clientConfig);
            currentParamsets.forEach((paramSet, i)=>{
                let key = paramSet.paramSetId;
                let shouldIncludeInList = false;
                /*for (let siteId in paramSet.paramSetsBySite) {
                    let siteNode = this.parameterTree.fancyTree.rootNode.findFirst(siteId);
                    if (siteNode) {
                        shouldIncludeInList = true;
                    }
                }*/ let paramSetSiteIds = paramSet.selectedParameters.map((_param)=>_param.stationId);
                // console.info('paramset list of site IDS in user param sets:', paramSetSiteIds);
                let treeNodes = this.parameterTree.flattenSensorNodesRecursive(null, false);
                paramSetSiteIds.forEach((_siteId)=>{
                    if (!shouldIncludeInList) {
                        let _filter = treeNodes.filter((x)=>x.stationId == _siteId || x.NODE_TYPE == 'station' && x.title == _siteId);
                        if (_filter.length > 0) shouldIncludeInList = true;
                    }
                });
                if (!shouldIncludeInList) return;
                let li = $('<li></li>').addClass("param-sets-item") //NB: this is used to retrieve order of items, so make sure that if you change this, it gets changed in the order retrieving function too!
                .data("paramSetKey", key).data("paramSetData", paramSet).append($('<span></span>').text(key)).append($('<i class="fa fa-trash-o"></i>').click((e)=>{
                    this.deleteKey = key;
                    this.deleteModalBody.empty();
                    this.deleteModalBody.append($('<p></p>').text("Are you sure you would like to delete the parameter set ").append($('<strong></strong>').text(key)).append($('<span></span>').text("?")));
                    this.deleteModal.modal('show');
                    e.stopPropagation();
                })).appendTo(this.$paramSetsUL).click(()=>{
                    this.deselectAllTreeNodes();
                    /*for (let siteId in paramSet.paramSetsBySite) {
                            let siteNode = this.parameterTree.fancyTree.rootNode.findFirst(siteId);
                            if (siteNode) {
                                siteNode.setExpanded();
                                for (let sensorId in paramSet.paramSetsBySite[siteId]) {
                                    let sensorNode = siteNode.findFirst((node) => {
                                        return node.title === sensorId;
                                    });
                                    if (sensorNode) {
                                        sensorNode.setExpanded();
                                        paramSet.paramSetsBySite[siteId][sensorId].forEach((param) => {
                                            let paramNode = sensorNode.findFirst(param);
                                            if (paramNode) {
                                                paramNode.setSelected();
                                            }
                                        });
                                    }
                                }
                            }
                            this.$paramSetsUL.find($(".selected")).removeClass("selected");
                            li.addClass("selected");

                            this.loadedParamSetName = key;
                            this.loadedParamSetValues = paramSet;
                            /// this.plottingPage.resetCustomLimits("__plot_confs" in this.loadedParamSetValues ? this.loadedParamSetValues['__plot_confs'] : null);
                            this.plottingPage.resetCustomLimits(paramSet.plotConfigurations);
                        }*/ paramSet.selectedParameters.forEach((param)=>{
                        let key = `${param.stationId}|${param.sensorId}|${param.parameterId}`;
                        if (param.variant) key += `|${param.variant}`;
                        let node = this.parameterTree.fancyTree.getNodeByKey(key);
                        if (node) {
                            node.setSelected();
                            node.setActive();
                            node.setFocus();
                        } else console.warn(`Unable to locate tree node for Parameter Set '${paramSet.paramSetId}' and selected parameter key: '${key}'.`, {
                            key: key,
                            param: param,
                            set: paramSet,
                            clientConfig: clientConfig
                        });
                    });
                    this.$paramSetsUL.find($(".selected")).removeClass("selected");
                    li.addClass("selected");
                    this.loadedParamSetName = key;
                    this.loadedParamSetValues = paramSet;
                    /// this.plottingPage.resetCustomLimits("__plot_confs" in this.loadedParamSetValues ? this.loadedParamSetValues['__plot_confs'] : null);
                    this.plottingPage.resetCustomLimits(paramSet.plotConfigurations);
                    this.paramsetLabel.val(key);
                });
                let modalLi = $('<li></li>').append($('<span></span>').text(key)).appendTo(this.saveModalListContent).click(()=>{
                    this.paramsetLabel.val(key);
                });
            });
        }
        if (currentParamsets) {
            this.$paramSetsUL.sortable({
                cancel: ".no-drag",
                placeholder: "param-set-drag-placeholder selected",
                forcePlaceholderSize: true,
                axis: "y",
                containment: "parent",
                opacity: 0.35,
                update: (e, ui)=>{
                    this.$btnSaveOrder.removeAttr("disabled").show();
                }
            });
            this.$container.css({
                display: ''
            }); //: NB: not using .show() as it would set "display: 'block'" which prevents the flew display to work properly!
            this.plottingPage.$panelRightTop.css({
                display: ''
            }); //: NB: not using .show() as it would set "display: 'block'" which prevents the flew display to work properly!
            this.plottingPage.$panelRightTop.next('.plot-page--splitter').css({
                display: ''
            });
        } else {
            this.$container.hide();
            this.plottingPage.$panelRightTop.hide();
            this.plottingPage.$panelRightTop.next('.plot-page--splitter').hide();
        }
    }
    deselectAllTreeNodes() {
        this.parameterTree.fancyTree.getSelectedNodes().forEach((n)=>{
            n.setSelected(false);
            n.visitParents((p)=>{
                p.setExpanded(false, {
                    noAnimation: true
                });
            });
        });
    }
    getUISelectedParams() {
        let result = [];
        this.parameterTree.fancyTree.getSelectedNodes().forEach((node)=>{
            try {
                let selected = {
                    stationId: node.data.stationId,
                    sensorId: node.data.sensorId,
                    parameterId: node.data.parameterId,
                    variant: node.data.NODE_TYPE == 'variant' ? node.data.variantId ?? 'null' : null //: NB: need string 'null' to use in the tree nodes keys search!
                };
                result.push(selected);
            } catch (err) {
                console.warn('Param Sets List: ERROR while trying to retrieve list of selected parameters from UI.', err);
            }
        });
        return result;
    }
    getSaveButton() {
        return $('<div class="btn btn-default"><i class="fa fa-floppy-o"></i>&nbsp;Save Set</div>').click(()=>{
            let _selected = this.getUISelectedParams();
            if (_selected.length == 0) {
                alert("Please select parameters");
                return;
            }
            this.saveModal.modal('show');
        });
    }
    getLoadedParamSetName() {
        return this.loadedParamSetName;
    }
    getLoadedParamSetValues() {
        return this.loadedParamSetValues;
    }
    getListElement() {
        return this.innerJQuery;
    }
    /**
     * This method will retrieve the user's client config string loaded in the MainsSite instance, and pass it to parseUserClientConf to return
     * appropriate object. This is a synchronous version that can only work with loaded objects in instance.
     * @param mainSite The instance of the MainSite (required for this synchronous version)
     */ getUserClientConfig(mainSite) {
        return $6a744cf7ffecae4a$var$ParameterSetConf.parseFromJson(mainSite.currentUser.ClientConfiguration, mainSite).conf;
    }
    /**
     * A helper function to find a Client Configuration Parameter Set (v2) by its ID. Returns
     * the full Param Set if matched, otherwise null.
     * @param paramSetId The ID for the set we're looking for
     * @param config The ClientConfiguration, parsed. If null, and we've got an instance of this.mainSite, then this method will fetch the client config automatically.
     */ clientConfigParamSetFind(paramSetId, config = null) {
        if (config == null && this.mainSite) config = this.getUserClientConfig(this.mainSite);
        if (config !== null) {
            let filter = config.savedParameterSets.filter((ps)=>ps.paramSetId == paramSetId);
            if (filter.length == 1) return filter[0];
            else return null;
        }
        return null;
    }
    /**
     * Utilty method to get the index position of a given Param Set by its ID (for replacement/deletion for example). If not found, returns -1.
     * @param paramSetId
     * @param config
     * @param enforceSingleMatch If set to TRUE and we find more than 1 matching paramSetId, then an error is raised.
     */ clientConfigParamSetFindIndex(paramSetId, config = null, enforceSingleMatch = true) {
        if (config == null && this.mainSite) config = this.getUserClientConfig(this.mainSite);
        let psIndex = -1; //: NB: this only gets the FIRST match. If for some weird reason there should be conflictive ParamSets with same ID (maybe other region?) then this could become inprecise.
        let psMatchCount = 0;
        if (config !== null) config.savedParameterSets.forEach((ps, i)=>{
            if (ps.paramSetId == paramSetId) {
                psIndex = i;
                psMatchCount++;
            }
        });
        if (enforceSingleMatch && psMatchCount > 1) throw new Error(`There are ${psMatchCount} Parameter Sets matching ID '${paramSetId}', when only 1 is allowed.`);
        return psIndex;
    }
    /**
     * This method will remove the specified Parameter Set by its ID, and return an Array of Parameter Sets excluding the one removed.
     * NB: this only returns a modified array, and does not affect any variables or properties of the current instances!
     * @param paramSetId
     * @param config
     */ clientConfigParamSetRemove(paramSetId, config = null) {
        let result = [];
        if (config == null && this.mainSite) config = this.getUserClientConfig(this.mainSite);
        if (config !== null) {
            let psIndex = this.clientConfigParamSetFindIndex(paramSetId, config);
            if (psIndex >= 0) config.savedParameterSets.splice(psIndex, 1);
            return config.savedParameterSets;
        }
        return result;
    }
    /**
     * Retrieve the order from the UI list of paramSets, and build a new Client Configuration to send to database for update.
     * @param mainSite
     */ saveParamSetsOrder(mainSite) {
        let clientConf = this.getUserClientConfig(mainSite);
        let _log = [];
        let paramSetIdsOrdered = [];
        if (this.$paramSetsUL) {
            this.$paramSetsUL.find("li.param-sets-item").each((i, li)=>{
                paramSetIdsOrdered.push($(li).data("paramSetKey"));
            });
            _log.push(`Retrieved order of paramsets defined by user.. ${paramSetIdsOrdered.join(',')}`);
        }
        let newConf = {
            savedParameterSets: []
        };
        //: first loop through ordered list, then loop over existing conf to add key/conf combinations not listed in UI (perhaps due to region or other reason..)
        paramSetIdsOrdered.forEach((paramSetId, i)=>{
            let ps = this.clientConfigParamSetFind(paramSetId, clientConf);
            if (ps) {
                newConf.savedParameterSets.push(ps);
                _log.push(`Add ps (ordered): ${ps.paramSetId}`);
            } else _log.push(`PS not found (ordered): ${paramSetId}`);
        });
        clientConf.savedParameterSets.forEach((ps, i)=>{
            if (this.clientConfigParamSetFind(ps.paramSetId, newConf) == null) newConf.savedParameterSets.push(ps);
        });
        let paramSetIdsOrderedPostUpdate = [];
        newConf.savedParameterSets.forEach((ps, i)=>{
            paramSetIdsOrderedPostUpdate.push(ps.paramSetId);
        });
        // console.warn("UPDATE CLIENT CONFIG...", { log: _log, user: mainSite.currentUser.Id, paramSetIdsOrdered: paramSetIdsOrdered, paramSetIdsOrderedPostUpdate: paramSetIdsOrderedPostUpdate, conf_original: clientConf, conf_original_str: JSON.stringify(clientConf), conf_new: newConf, conf_new_str: JSON.stringify(newConf), _this: this });
        this.tryUpdateClientConfiguration(mainSite.currentUser.Id, JSON.stringify(newConf), this.paramsetLabel.val());
    }
}



class $854cd3fd8e7b222e$export$f4e1a5f975831d0e {
    show() {
        var modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(modal));
        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);
        $('<h4 class="modal-title"></h4>').text('Data Download Permission').appendTo(modalHeader);
        var modalBody = $('<div class="modal-body"></div>').appendTo(modalContent).append($('<p></p>').text("You do not have data download permission. Please contact your administrator to request permission to download data."));
        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">OK</button>').appendTo(modalFooter);
        modal.modal('show');
    }
}





class $07d3a461255bc5cf$export$c7824c77bb77cb04 {
    constructor(mainSite, plottingPage, store, stationId, sensorId, parameterId, variantId){
        this.mainSite = mainSite;
        this.plottingPage = plottingPage;
        this.store = store;
        this.stationId = stationId;
        this.sensorId = sensorId;
        this.parameterId = parameterId;
        this.variantId = variantId;
        this.activeJqXHR = null;
        this.currentData = null;
        this.currentResolution = -1;
        this.icon = null;
        this.showData = (renderTitle)=>{
            if (this.activeJqXHR) {
                this.activeJqXHR.abort();
                this.activeJqXHR = null;
            }
            let mm = this.plottingPage.getCurrentMoments();
            var from = mm.from;
            var to = mm.to;
            var jqXHR = this.activeJqXHR = (0, $fd959835eca46177$export$9bf04fc316538454)(this.store, this.stationId, this.sensorId, this.parameterId, this.variantId, from.valueOf(), to.valueOf(), (err, data)=>{
                if (jqXHR == this.activeJqXHR) {
                    // This callback may occur indicating an abort after a new AJAX request has
                    // started
                    this.activeJqXHR = null;
                    this.setLoadingIcon(false, renderTitle);
                }
                if (err) {
                    if (!err.Aborted) alert('Error getting data: ' + err.Message);
                    return;
                }
                if (!data.VariantId && this.variantId != null) data.VariantId = this.variantId;
                if (!data.ParameterDefinition) {
                    var parameterDefinition = this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[this.sensorId].Parameters[this.parameterId].Variants.filter((v)=>v.Variant == this.variantId)[0].ParameterDefinition;
                    if (!parameterDefinition || parameterDefinition.Default) parameterDefinition = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[this.parameterId];
                    if (parameterDefinition) data.ParameterDefinition = parameterDefinition;
                }
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(data.ParameterDefinition?.Units ?? '', this.parameterId);
                // console.info('ParameterNodeDownloadHandler.showData - unitsConversionSet', unitsConversionSet, data);
                if (unitsConversionSet) data.Data = data.Data.map((x)=>{
                    if (Array.isArray(x) && x.length == 2) return [
                        x[0],
                        unitsConversionSet.convertValue(x[1])
                    ];
                    return x;
                });
                this.currentData = data;
                this.currentResolution = data.Resolution;
                this.plottingPage.addOrUpdateChartSeries(data);
            }, this.plottingPage.desiredResolution);
            this.setLoadingIcon(true, renderTitle);
        };
        /**
     * Refresh the data for this node (added while implementing auto-refresh feature of plot page).
     * @param tsFrom UTC timestamp from
     * @param tsTo UTC timestamp until
     * @param resolution The resolution of current data for sake of consistancy
     */ this.refreshData = (tsFrom, tsTo, resolution = null, renderTitle)=>{
            if (this.activeJqXHR) {
                console.info(`[ParameterNodeDownloadHandler] Not performing refresh on server as a current AJAX operation is still ongoing.`);
                return; //: just cancel this operation, to let the current ongoing AJAX call complete.
            }
            if (resolution == null) resolution = this.currentResolution;
            var jqXHR = this.activeJqXHR = (0, $fd959835eca46177$export$9bf04fc316538454)(this.store, this.stationId, this.sensorId, this.parameterId, this.variantId, tsFrom, tsTo, (err, data)=>{
                if (jqXHR == this.activeJqXHR) {
                    // This callback may occur indicating an abort after a new AJAX request has
                    // started
                    this.activeJqXHR = null;
                    this.setLoadingIcon(false, renderTitle);
                }
                if (err) {
                    if (!err.Aborted) // alert('Error getting data: ' + err.Message);
                    console.warn(`[ParameterNodeDownloadHandler] Error getting data: ${err.Message}`);
                    return;
                }
                if (!data.VariantId && this.variantId != null) data.VariantId = this.variantId;
                if (!data.ParameterDefinition) {
                    var parameterDefinition = this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[this.sensorId].Parameters[this.parameterId].Variants.filter((v)=>v.Variant == this.variantId)[0].ParameterDefinition;
                    if (!parameterDefinition || parameterDefinition.Default) parameterDefinition = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[this.parameterId];
                    if (parameterDefinition) data.ParameterDefinition = parameterDefinition;
                }
                let unitsConversionSet = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConversionSet(data.ParameterDefinition?.Units ?? '', this.parameterId);
                // console.info('ParameterNodeDownloadHandler.refreshData - unitsConversionSet', unitsConversionSet, data);
                if (unitsConversionSet) data.Data = data.Data.map((x)=>{
                    if (Array.isArray(x) && x.length == 2) return [
                        x[0],
                        unitsConversionSet.convertValue(x[1])
                    ];
                    return x;
                });
                //: merge data rather than replace:
                let old = this.currentData;
                ///this.currentData.Data = [].concat([], this.currentData.Data, data.Data);
                this.currentData.Data = this.plottingPage.dataPointsConcat(this.currentData.Data, data.Data);
                this.currentData.TimestampFirst = Math.min(old.TimestampFirst, data.TimestampFirst);
                this.currentData.TimestampLast = Math.max(old.TimestampLast, data.TimestampLast);
                // console.info(`[ParameterNodeDownloadHandler] New data: `, { old: old, currentData: this.currentData, data: data });
                this.plottingPage.addOrUpdateChartSeries(data, true);
            }, resolution);
            this.setLoadingIcon(true, renderTitle);
        };
        this.hideData = (renderTitle)=>{
            if (this.activeJqXHR) {
                this.activeJqXHR.abort();
                this.activeJqXHR = null;
                this.setLoadingIcon(false, renderTitle);
            }
            if (this.currentData) {
                this.plottingPage.removeChartSeries(this.currentData);
                this.currentData = null;
            }
        };
        this.setLoadingIcon = (loading, renderTitle)=>{
            renderTitle(loading ? '/images/icons/treeLoadingSpinner.gif' : '/images/icons/lineChartIcon.png');
        };
    }
}


/** Flag used in generating Tree nodes, indicating whether SensorId's should be split (if they contain slashes) or not. */ const $540f2b2f5fcbfde1$var$SPLIT_SENSOR_IDS = true;
/** Character used for splitting SensorId's when we want to generate multiple levels of sensor folders. */ const $540f2b2f5fcbfde1$var$SPLIT_SENSOR_CHAR = '/';
class $540f2b2f5fcbfde1$export$9a48e0793a1eb1f8 {
    constructor(mainSite, plottingPage){
        this.mainSite = mainSite;
        this.plottingPage = plottingPage;
        this.currentStationNodes = [];
        //chart must be resized after the first parameter is selected
        this.initialResize = false;
        this.tree = $('<div class="midi_PlottingPage_series_panel_sideContainer_box overflow-auto flex-col-item--grow"></div>');
        this.currentStationNodes = this.getTreeNodes(); //: needed for object searches!
        var fancyTreeElement = $('<div id="tree" class="midi_PlottingPage_series_panel_tree"></div>').appendTo(this.tree).fancytree({
            checkbox: true,
            autoScroll: true,
            renderNode: (event, data)=>{
                // $(data.node.span).attr('title', `key=${data.node.key || '--NO-KEY--'} - PATH=${data.node.data.path ?? '--NO-PATH--'} - sensorId=${data.node.data.sensorId ?? '--no-sensorId--'}`); //TODO: remove - this is for debug only!
                $(data.node.span).attr('data-node-key', data.node.key);
                $(data.node.span).attr('data-node-path', data.node.data.path ?? '--NO-PATH--');
                $(data.node.span).attr('data-node-sensor', data.node.data.sensorId ?? '--no-sensorId--');
                $(data.node.span).attr('data-node-type', data.node.data.NODE_TYPE);
                this.renderNodeOverride(data.node);
            },
            source: this.currentStationNodes,
            select: (event, data)=>{
                this.nodeClicked(data.node); // for csv download will need to do nothing
            },
            click: (event, data)=>{
                // console.info('tree click', data);
                if (!data.node.folder) {
                    data.node.toggleSelected();
                    return false;
                }
                return true;
            },
            clickFolderMode: 3,
            extensions: [
                "filter"
            ],
            filter: {
                autoApply: false,
                autoExpand: true,
                counter: false,
                fuzzy: true,
                hideExpanders: true,
                highlight: true,
                mode: 'hide',
                nodata: true
            }
        });
        this.fancyTree = fancyTreeElement.fancytree('getTree');
        this.setupNodes(this.fancyTree.rootNode); // will need to modify not to download anything/remove the click
        this.tree.resize(()=>{
            plottingPage.resizeChart();
        });
    }
    renderNodeOverride(node) {
        //add buttons etc that we might need on specific nodes
        //forecast issue time download btn
        if (node.children) {
            let nodeSpan = $(node.span);
            let nodeHasGrandkids = false;
            for(let i = 0; i < node.children.length; i++)if (node.children[i].children) {
                nodeHasGrandkids = true;
                break;
            }
            let parts = node.key.split("|");
            if (!nodeHasGrandkids && node.key.indexOf("Forecast") !== -1 && //must be a forecast
            parts.length === 3 && //need to have station, sensor and parameter IDs
            nodeSpan.find(".midi_plotting_tree_inline_btn").length === 0) $('<div class="midi_plotting_tree_inline_btn">Add Issue</div>').click((e)=>{
                e.stopPropagation();
                try {
                    parts[1] = node.data.sensorNode.sensorId;
                } catch (err) {
                    console.warn(`[ADD ISSUE][ERROR] Unable to replace tree  key sensor id with actual sensor id.`, {
                        error: err,
                        parts: parts,
                        node: node
                    });
                }
                this.plottingPage.addIssue(parts[0], parts[1], parts[2], node);
                return false;
            }).appendTo(nodeSpan);
            if (node.data.VariantId) nodeSpan.append("<span>" + node.data.VariantId + "</span>");
        }
    }
    setupTreeToolbar($destination) {
        var $wrap = $('<div id="plot-params-tree--toolbar"></div>').css('marginTop', 12);
        var $ig = $('<div class="input-group input-group-sm"></div>');
        this.$treeFilterInput = $('<input type="text" placeholder="Filter..." class="form-control">').appendTo($ig);
        this.$treeFilterClearBtn = $('<button class="btn btn-default"><i class="fa fa-lg fa-times"></i></button>').appendTo($('<span class="input-group-btn"></span>').appendTo($ig));
        $ig.appendTo($wrap);
        $wrap.appendTo($destination);
        var _this = this;
        this.$treeFilterClearBtn.on("click", function(e) {
            _this.$treeFilterInput.val('');
            _this.fancyTree.clearFilter();
        });
        this.$treeFilterInput.on("keyup", function(e) {
            try {
                if ($(this).val().replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '') == "") {
                    _this.fancyTree.clearFilter();
                    return;
                }
                _this.fancyTree.filterNodes($(this).val());
            } catch (err) {
                console.warn("ParameterTree filter error: ", err);
            }
        });
    }
    setupNodes(node) {
        if (node.getLevel() == 1) {
            var rootNodeImg = $(node.li).find('img');
            rootNodeImg.click(()=>{
                var parameterSchemaStation = node.data.station;
                if (this.plottingPage.checkIfUserCanDownloadStationData(parameterSchemaStation.Station.Id)) //permission
                this.plottingPage.downloadData(node.data.station);
                else new (0, $854cd3fd8e7b222e$export$f4e1a5f975831d0e)().show();
                return false;
            }).addClass('midi_PlottingPage_ParameterTree_downloadLink');
        }
        if (node.children) node.children.forEach((child)=>{
            this.setupNodes(child);
        });
    }
    getTreeNodes() {
        // Get staionsIds of the selected region
        const stationIds = Object.keys(this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations).filter((stationId)=>this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station.Region === this.plottingPage.mainSite.hashData.Region);
        // Get the corresponding stationLabels
        const stationLabels = stationIds.map((stationId)=>this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station.Label);
        // Sort the stationLabels alphabetically
        const stationLabelsSorted = [
            ...stationLabels
        ].sort();
        //// Apply the order from alphabetically sorted stationLabels to the stationIds
        let stationIdsSorted = [];
        for (const stationLabel of stationLabelsSorted){
            for (const stationId of stationIds)if (this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station.Label == stationLabel) stationIdsSorted = [
                ...stationIdsSorted,
                stationId
            ];
        }
        var children = [];
        stationIdsSorted.forEach((stationId)=>{
            children.push(new $540f2b2f5fcbfde1$var$StationNodeData(this.mainSite, this.plottingPage, stationId, this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[stationId]));
        });
        return children;
    }
    replacementForRenderTitle(node, icon) {
        node.data.icon = icon;
        node.renderTitle();
    }
    nodeClicked(node) {
        var downloadHandler = node.data;
        console.log("[nodeClicked()] downloadHandler: ", downloadHandler);
        if (!downloadHandler) return;
        try {
            if (node.isSelected()) {
                downloadHandler.showData((icon)=>{
                    this.replacementForRenderTitle(node, icon);
                });
                if (!this.initialResize) {
                    this.plottingPage.resizeChart();
                    this.initialResize = true;
                }
            } else downloadHandler.hideData((icon)=>{
                this.replacementForRenderTitle(node, icon);
            });
        } catch (err) {
            console.warn("[ERROR][nodeClicked()]:", err);
        }
    }
    getDownloadHandler(node) {
        var downloadHandler = node.data;
        if (!downloadHandler) return null;
        return downloadHandler;
    }
    updateAll() {
        this.plottingPage.delayUpdate = true;
        this.fancyTree.getSelectedNodes().forEach((node)=>{
            this.nodeClicked(node);
        });
    }
    getLatestDataAll(tsFrom, tsTo, resolution) {
        this.plottingPage.delayUpdate = true;
        let nodes = this.fancyTree.getSelectedNodes();
        nodes.forEach((node, i)=>{
            if (i == nodes.length - 1) this.plottingPage.delayUpdate = false;
            let dh = this.getDownloadHandler(node);
            if (dh) dh.refreshData(tsFrom, tsTo, resolution, (icon)=>{
                this.replacementForRenderTitle(node, icon);
            });
        });
    }
    /**
     * Helper to read/search a flattened array of sensor nodes for a station or all stations (used in ParameterSetList for example)
     * 
     * @param stationNode
     * @param keysOnly
     * @returns
     * @example ```
     *      let p = Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[2];
     *      let prelude = p.parameterTree.fancyTree.rootNode.children[6].data.node; //: if selected region is Australia
     *      p.parameterTree.flattenSensorNodesRecursive(prelude.data._self, true);
     * ```
     */ flattenSensorNodesRecursive(stationNode, keysOnly = false) {
        if (stationNode) return stationNode.flattenSensorNodesRecursive(keysOnly);
        else {
            let all = [];
            this.currentStationNodes.forEach((x)=>{
                all = all.concat(this.flattenSensorNodesRecursive(x._self, keysOnly));
            });
            return all;
        }
    }
}
class $540f2b2f5fcbfde1$var$StationNodeData {
    constructor(mainSite, plottingPage, stationId, station){
        this.mainSite = mainSite;
        this.plottingPage = plottingPage;
        this.stationId = stationId;
        this.station = station;
        this.NODE_TYPE = 'station';
        this.icon = '/images/icons/download.png';
        this.hideCheckbox = true;
        this.folder = true;
        this.children = [];
        this.buildSensorPath = (_chunk, chunks = null, chunkIndex = null)=>{
            let _key = `${this.key}|`;
            if (chunks && chunks.slice(0, chunkIndex).length > 0) _key += `${chunks.slice(0, chunkIndex).join($540f2b2f5fcbfde1$var$SPLIT_SENSOR_CHAR)}${$540f2b2f5fcbfde1$var$SPLIT_SENSOR_CHAR}`;
            _key += _chunk;
            return _key;
        };
        this.title = station.Station.Label;
        this.key = `${station.Station.Id}`;
        var sensorIds = [];
        for(var sensorId in station.Sensors)sensorIds.push(sensorId);
        sensorIds.sort();
        sensorIds.forEach((sensorId)=>{
            let sensorNode = new $540f2b2f5fcbfde1$var$SensorNodeData(this.mainSite, this, sensorId, station.Sensors[sensorId]);
        //: NB: SensorNodeData now automatically adds necessary nodes to the tree.
        });
        this._self = this;
    }
    /**
     * Helper to read/search a flattened array of sensor nodes for this station (helpful mainly for regrouping if that option is enabled).
     * @param pathsOnly
     * @returns
     */ flattenSensorNodesRecursive(pathsOnly = false) {
        let res = [];
        this.children.forEach((x)=>{
            res.push(pathsOnly ? x.path : x);
            x.flattenChildSensorNodesRecursive(pathsOnly, res);
        });
        return res;
    }
    /**
     * Helper to get the node to which a sensor & params need adding. Idea is to use this to add parameters to the final node given as a result. Warning: this may return
     * the station node rather than a parameter node (as it's the root node for this action), but this is very unlikely to be the case in reality, unless autoAdd is not true.
     * 
     * @param chunks The chunks (or leaves) of the sensor ID, this should be at the very last one string corresponding to a sensor ID if it is not meant to be a tree of sensors.
     * @param autoAdd Automatically add the relevant nodes? This should normally always be true.
     * @param srcSensorId The source sensorId that triggered this call. If null, it will be built from chunks.
     * @param srcSensor The source sensor parameters that triggered this call. If null, a blank dummy ParameterSchemaSensor will be generated.
     * @returns The node to add sensor parameters to normally.
     */ getSensorNodeRecursively(chunks, autoAdd = true, srcSensorId = null, srcSensor = null) {
        let debug = false;
        if (debug) console.info('StationNodeData.getSensorNodeRecursively()', {
            chunks: chunks,
            srcSensor: srcSensor
        }); // , srcSensorId: srcSensorId
        let finalNode = null;
        let addTo = this; //: progressively change this to each parent leaf when looping through chunks.. staring with station node to start with.
        chunks.forEach((chunk, i)=>{
            let flat = this.flattenSensorNodesRecursive(false);
            let path = this.buildSensorPath(chunk, chunks, i);
            let incrementalChunks = chunks.slice(0, i + 1);
            let match = flat.filter((x)=>x.path == path);
            if (debug) console.info('StationNodeData.getSensorNodeRecursively() - CHUNKS LOOP', {
                chunk: chunk,
                i: i,
                path: path,
                match: match,
                incrementalChunks: incrementalChunks
            });
            if (match.length == 1) {
                finalNode = match[0];
                addTo = match[0];
            } else if (match.length == 0) {
                if (autoAdd) {
                    let _srcSensor = {
                        Parameters: {},
                        SensorDefinition: {
                            DisplayName: chunk,
                            Combined: false,
                            Level: null,
                            SourceIndex: null,
                            Hidden: false
                        },
                        UseLiveData: true
                    };
                    if (i == chunks.length - 1) {
                        if (srcSensor !== null) _srcSensor = srcSensor;
                    }
                    let sensorNode = new $540f2b2f5fcbfde1$var$SensorNodeData(this.mainSite, this, srcSensorId, _srcSensor, this.buildSensorPath(incrementalChunks.join($540f2b2f5fcbfde1$var$SPLIT_SENSOR_CHAR)), chunk, false, false);
                    if (debug) console.info('StationNodeData.getSensorNodeRecursively() - CHUNKS LOOP - new SensorNodeData()', {
                        sensorNode: sensorNode
                    });
                    addTo.children.push(sensorNode);
                    addTo = sensorNode;
                    finalNode = sensorNode;
                } else console.warn(`StationNodeData.getSensorNodeRecursively() - ${match.length} matches found for path '${path}', and autoAdd param is false...`);
            } else {
                console.warn(`StationNodeData.getSensorNodeRecursively() - ${match.length} matches found for path '${path}', when 1 or 0 expected. We're going to use the first result by default, but this may not be the wanted behaviour, in which case sensor IDs need to be checked.`);
                finalNode = match[0];
                addTo = match[0];
            }
        });
        if (debug) console.info('StationNodeData.getSensorNodeRecursively() - FINAL NODE', {
            finalNode: finalNode,
            chunks: chunks
        });
        return finalNode;
    }
}
class $540f2b2f5fcbfde1$var$SensorNodeData {
    constructor(mainSite, stationNode, sensorId, sensor, path = null, label = null, allowHandlingParents = true, addParams = true){
        this.mainSite = mainSite;
        this.stationNode = stationNode;
        this.sensorId = sensorId;
        this.sensor = sensor;
        this.path = path;
        this.label = label;
        this.NODE_TYPE = 'sensor';
        this.hideCheckbox = true;
        this.folder = true;
        this.icon = '/images/icons/sensor.png';
        this.isSplitSensor = false;
        this.needsPushingToStationChildren = true;
        this.children = [];
        this.title = sensor.SensorDefinition && sensor.SensorDefinition.DisplayName ? sensor.SensorDefinition.DisplayName : sensorId;
        if (this.label) this.title = this.label;
        this.key = `${stationNode.key}|${sensorId}`;
        this.stationId = stationNode.stationId;
        if (path == null) this.path = stationNode.buildSensorPath(sensorId); //: this should maybe be built on either split display name or 
        let addParamsTo = this;
        let sensorPathFinal = sensorId;
        if (sensor.SensorDefinition && sensor.SensorDefinition.DisplayName) sensorPathFinal = sensor.SensorDefinition.DisplayName; //: initially, we can set paths in sensor DisplayName - if this is not working then a new DB column may need to be added.
        let splitSensorId = sensorPathFinal.split($540f2b2f5fcbfde1$var$SPLIT_SENSOR_CHAR); //: TODO HERE: change this to use the database param we want to split (DisplayName ? or other if we feel using the display name for this as a temporary solution works..)
        //: emulate/test nested sensors for Prelude:
        /*
        if (stationNode.key == 'Australia_Prelude' && sensorId.substring(0, 'Forecast '.length) == 'Forecast ') {
            splitSensorId = sensorId.split(' ');
        }
        if (stationNode.key == 'Australia_Prelude' && sensorId == 'Forecast_30min') {
            splitSensorId = sensorId.split('_');
        }
        if (stationNode.key == 'Australia_Prelude' && sensorId == 'Forecast') {
            console.info('Australia_Prelude.Forecast  EMULATED TO  Forecast/Main/Tests...');
            splitSensorId = ['Forecast', 'Main', 'Tests'];
            // sensorId = 'Forecast/Main/Tests';
        }
        */ if ($540f2b2f5fcbfde1$var$SPLIT_SENSOR_IDS && allowHandlingParents) addParamsTo = stationNode.getSensorNodeRecursively(splitSensorId, true, sensorId, sensor) ?? this;
        if (!addParams) // console.warn('SensorNodeData DO NOT ADD PARAMS set.', sensorId, this.key, this.path, addParamsTo);
        return;
        var parameters = [];
        for(var parameterId in sensor.Parameters){
            var parameterInfo = sensor.Parameters[parameterId];
            parameterInfo.Id = parameterId;
            if (!parameterInfo.Variants.some((v)=>{
                var parameterDefinition = v.ParameterDefinition;
                if (!parameterDefinition || parameterDefinition.Default) parameterDefinition = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[parameterId];
                return !parameterDefinition || parameterDefinition.AllowPlot;
            })) continue;
            parameters.push(sensor.Parameters[parameterId]);
        }
        parameters.sort((a, b)=>a.Id.localeCompare(b.Id));
        parameters.forEach((parameter)=>{
            addParamsTo.children.push(new $540f2b2f5fcbfde1$var$ParameterNodeData(this.mainSite, addParamsTo, parameter));
        });
    }
    flattenChildSensorNodesRecursive(pathsOnly = false, addTo = []) {
        this.children.forEach((x)=>{
            if (x.NODE_TYPE == 'sensor') {
                addTo.push(pathsOnly ? x.path : x);
                x.flattenChildSensorNodesRecursive(pathsOnly, addTo);
            }
        });
    }
}
class $540f2b2f5fcbfde1$var$ParameterNodeData {
    constructor(mainSite, sensorNode, parameter){
        this.mainSite = mainSite;
        this.sensorNode = sensorNode;
        this.parameter = parameter;
        this.NODE_TYPE = 'parameter';
        this.title = parameter.Variants.length && parameter.Variants[0].ParameterDefinition && parameter.Variants[0].ParameterDefinition.DisplayName ? parameter.Variants[0].ParameterDefinition.DisplayName : parameter.Id;
        this.key = `${sensorNode.key}|${parameter.Id}`;
        this.stationId = sensorNode.stationId;
        if (parameter.Variants.length == 1 && parameter.Variants[0].Variant === null) {
            this.data = new (0, $07d3a461255bc5cf$export$c7824c77bb77cb04)(this.mainSite, sensorNode.stationNode.plottingPage, parameter.Store, this.sensorNode.stationNode.stationId, this.sensorNode.sensorId, parameter.Id, null);
            this.icon = '/images/icons/lineChartIcon.png';
            this.folder = false;
            this.hideCheckbox = false;
            this.children = null;
        } else {
            this.data = null;
            this.icon = '/images/icons/sensor.png';
            this.folder = true;
            this.hideCheckbox = true;
            this.children = parameter.Variants.filter((v)=>{
                var parameterDefinition = v.ParameterDefinition;
                if (!parameterDefinition || parameterDefinition.Default) parameterDefinition = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[parameter.Id];
                return !parameterDefinition || parameterDefinition.AllowPlot;
            }).sort((a, b)=>{
                let av = parseFloat(a.Variant);
                let bv = parseFloat(b.Variant);
                if (!isNaN(av) && !isNaN(bv)) return av - bv;
                else if (isNaN(av)) return -1;
                else if (isNaN(bv)) return 1;
                else return a.Variant.localeCompare(b.Variant);
            }).map((v)=>new $540f2b2f5fcbfde1$export$8742a6fb24840d1e(mainSite, this, v));
        }
    }
}
class $540f2b2f5fcbfde1$export$8742a6fb24840d1e {
    constructor(mainSite, parentNode, variant){
        this.mainSite = mainSite;
        this.parentNode = parentNode;
        this.variant = variant;
        this.NODE_TYPE = 'variant';
        this.icon = '/images/icons/lineChartIcon.png';
        this.stationId = parentNode.stationId;
        this.title = variant.Variant === null ? "Latest" : variant.Variant;
        this.key = `${parentNode.sensorNode.key}|${parentNode.parameter.Id}|${variant.Variant}`; //: NB: "null" added if we receive variantName===null, which is necessary for handling matches with plot page tree selections and also downloads instructions sent to server.
        this.data = new (0, $07d3a461255bc5cf$export$c7824c77bb77cb04)(this.mainSite, parentNode.sensorNode.stationNode.plottingPage, parentNode.parameter.Store, parentNode.sensorNode.stationNode.stationId, parentNode.sensorNode.sensorId, parentNode.parameter.Id, variant.Variant);
    }
}



class $1ccdd46c8160eb50$export$e3d5fab60ca34025 {
    constructor(mainSite, plottingPage){
        this.mainSite = mainSite;
        this.plottingPage = plottingPage;
        this.multipleSitesSelected = false;
        this.nav = $('<nav class="navbar navbar-default midi_PlottingPage_secondaryNav"></nav>');
        var navbarContainer = $('<div class="container-fluid"></div>').appendTo(this.nav);
        $(`<div class= "navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#plottingNavBar" aria-expanded="false">
                <span class= "sr-only">Toggle navigation</span>
                <span class="icon-bar"> </span>
                <span class="icon-bar"> </span>
                <span class="icon-bar"> </span>
                </button>
                </div>`).appendTo(navbarContainer);
        var plottingNavBarCollapse = $('<div class="collapse navbar-collapse" id="plottingNavBar"></div>').appendTo(navbarContainer);
        var plottingNavBarList = $('<ul class="nav navbar-nav midi_PlottingPage_navBar_list"></ul>').appendTo(plottingNavBarCollapse);
        $('<li class="midi_PlottingPage_navBar_listItem"><a>24 Hours</a></li>').click((e)=>{
            this.setDateWithButtons(1);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);
        $('<li class="midi_PlottingPage_navBar_listItem"><a>7 Days</a></li>').click((e)=>{
            this.setDateWithButtons(7);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);
        $('<li class="midi_PlottingPage_navBar_listItem"><a>14 Days</a></li>').click((e)=>{
            this.setDateWithButtons(14);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);
        this.button30 = $('<li class="midi_PlottingPage_navBar_listItem"><a>30 Days</a></li>').click((e)=>{
            this.setDateWithButtons(30);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);
        $('<li class="midi_PlottingPage_navBar_listItem"><a>90 Days</a></li>').click((e)=>{
            this.setDateWithButtons(90);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);
        var plottingNabBarForm = $('<form class="navbar-form navbar-left"></form>').appendTo(plottingNavBarCollapse);
        var timeZoneString = this.mainSite.getTimeZoneString();
        this.dateRangePicker = $('<div class="input-daterange input-group"><input class="input-sm form-control" type="text" id="midi_PlottingPage_date_picker_from" name="start"><span class="input-group-addon">to</span><input class="input-sm form-control" type="text" id="midi_PlottingPage_date_picker_to" name="end"></div>').appendTo(plottingNabBarForm).datepicker({
            format: "yyyy-mm-dd  " + timeZoneString,
            language: 'en-GB'
        }).on('changeDate', (e)=>{
            this.from = moment.utc(this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val(), 'YYYY-MM-DD');
            this.to = moment.utc(this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val(), 'YYYY-MM-DD').endOf('day').startOf('minute');
            let ymdFrom = this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val().substr(0, 10);
            let ymdTo = this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val().substr(0, 10);
            let mm = this.plottingPage.getMomentsRange(ymdFrom, ymdTo);
            this.from = mm.from;
            this.to = mm.to;
            if (this.plottingPage._debug) console.info(`%c[PLOT TOOLBAR]`, 'font-weight: bold; color: blue', ` DATEPICKERS CHANGE EVENT... THEN plottingPage.setDateRange(..)`, {
                e: e,
                from: this.from,
                to: this.to,
                inputs: {
                    f: this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val(),
                    t: this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val(),
                    ymdF: ymdFrom,
                    ymdT: ymdTo,
                    mm: mm
                }
            });
            //: auto-hide datepicker & move onto 'to' field if appropriate
            $(e.target).blur();
            $(e.target).datepicker('hide');
            if (e.target.id == "midi_PlottingPage_date_picker_from") this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').focus();
            this.plottingPage.setDateRange(this.from, this.to);
        });
        var groupingSelectorContainer = $('<div id = "midi_PlottingPage_groupingSelector_container">Grouping:</div>').appendTo(plottingNavBarCollapse);
        this.groupingSelector = $('<select id="midi_PlottingPage_groupingSelector"></select>').appendTo(groupingSelectorContainer);
        $('<option value="high">High</option>').appendTo(this.groupingSelector);
        $('<option value="average">Avg.</option>').appendTo(this.groupingSelector);
        $('<option value="low">Low</option>').appendTo(this.groupingSelector);
        this.groupingSelector.change(()=>{
            this.plottingPage.setGrouping($("#midi_PlottingPage_groupingSelector").val());
        });
        var dataFunctionSelectorContainer = $('<div id = "midi_PlottingPage_dataFunctionSelector_container">Function:</div>').appendTo(plottingNavBarCollapse);
        this.dataFunctionSelector = $('<select id="midi_PlottingPage_dataFunctionSelector"></select>').appendTo(dataFunctionSelectorContainer);
        $('<option value="none">None</option>').appendTo(this.dataFunctionSelector);
        $('<option value="roc">RoC</option>').appendTo(this.dataFunctionSelector);
        this.dataFunctionSelector.change(()=>{
            this.plottingPage.setDataFunction(this.dataFunctionSelector.val());
        });
        // Resolution Selector
        /*var resolutionSelectorContainer = $('<div id = "midi_PlottingPage_resolutionSelector_container">Resolution:</div>').appendTo(plottingNavBarCollapse);
        this.resolutionSelector = $('<select id="midi_PlottingPage_resolutionSelector"></select>').appendTo(resolutionSelectorContainer);
            
        $('<option value=0>Auto</option>').appendTo(this.resolutionSelector);
        $('<option value=-1>All data</option>').appendTo(this.resolutionSelector);
        $('<option value=1>1 min</option>').appendTo(this.resolutionSelector);
        $('<option value=10>10 min</option>').appendTo(this.resolutionSelector);
        $('<option value=60>60 min</option>').appendTo(this.resolutionSelector);
        $('<option value=1440>1 day</option>').appendTo(this.resolutionSelector);
        
        this.resolutionSelector.change(() => {
            this.plottingPage.setResolution(parseInt($("#midi_PlottingPage_resolutionSelector").val(),10));
        })*/ this.$refreshGroup = $('<div id = "midi_PlottingPage_RefreshSelector_container" class="midi_PlottingPage_Toolbar_SelectGroup"><span>Refresh:</span></div>').appendTo(plottingNavBarCollapse);
        this.$refreshSel = $('<select id="midi_PlottingPage_RefreshSelector" class="midi_PlottingPage_Toolbar_Select"></select>').appendTo(this.$refreshGroup);
        $('<option value="-1">None</option>').appendTo(this.$refreshSel);
        /*
        $('<option value="1">DEV: 1 second</option>').appendTo(this.$refreshSel);
        $('<option value="5">DEV: 5 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="10">DEV: 10 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="20">DEV: 20 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="60">DEV: 1 minute</option>').appendTo(this.$refreshSel);
        */ $('<option value="300">5 minutes</option>').appendTo(this.$refreshSel);
        this.$refreshSel.change((e)=>{
            this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));
        });
        this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));
        var downloadButtonGroup = $('<div class="btn-group midi_PlottingPage_navbar_button_container navbar-right" role="group" aria-label="...">').appendTo(plottingNavBarCollapse);
        this.downloadDataForm = $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').css({
            display: 'none'
        }).appendTo(plottingNavBarCollapse);
        this.pngButton = $('<button title="Download PNG of current plot" class="btn btn-sm navbar-btn btn-default">PNG</button>').appendTo(downloadButtonGroup).click(()=>{
            this.plottingPage.downloadPng();
        });
        var downloadPermission = this.plottingPage.checkIfUserCanDownloadRegionData(this.mainSite.selectedRegion.Id);
        // downloadALLButton
        this.downloadALLButton = $('<button title="Download Data" class="btn btn-sm navbar-btn btn-default"><i class="fa fa-fw fa-download"></i> DOWNLOAD</button>').appendTo(downloadButtonGroup).click(()=>{
            if (downloadPermission) this.plottingPage.downloadDataAllStations();
            else {
                new (0, $854cd3fd8e7b222e$export$f4e1a5f975831d0e)().show();
                return false;
            }
        });
        /*
        this.downloadCSVButton = $('<button title="Download CSV of current plot" class="btn btn-sm navbar-btn btn-default">CSV</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
                if (downloadPermission) {
                    this.downloadData('csv');
                }
                else {
                    new NoDownloadPermissionDialog().show();
                    return false;
                }
        });
        this.downloadDLPButton = $('<button title="Download DLP of current plot" class="btn btn-sm navbar-btn btn-default">DLP</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
                if (downloadPermission) {
                    if (this.multipleSitesSelected) {
                        new SimpleDialog('DLP disabled for mutliple sites', 'You have selected multiple sites, and DLP files cannot be created based on data from multiple sites. The CSV format is, however, still available.').show();
                    }
                    else {
                        this.downloadData('dlp');
                    }
                }
                else {
                    new NoDownloadPermissionDialog().show();
                    return false;
                }
        });
        */ var stacked = false;
        var stackedButton = $('<button id="midi_PlottingPage_stacked" title="Toggle Stacked Plots" class="btn btn-sm btn-default navbar-btn navbar-right">&nbsp;&nbsp;</button>').appendTo(plottingNavBarCollapse).click((e)=>{
            if (stacked) {
                this.plottingPage.setStacked(false);
                stackedButton.removeClass('stacked');
                stacked = false;
            } else {
                this.plottingPage.setStacked(true);
                stackedButton.addClass('stacked');
                stacked = true;
            }
        });
    }
    downloadData(format) {
        if (this.plottingPage._debug) console.info(`[PLOT TOOLBAR] downloadData(${format})...`, {
            format: format
        });
        var downloadInterval;
        let plot_mm = this.plottingPage.getCurrentMoments();
        this.from = plot_mm.from;
        this.to = plot_mm.to;
        var dateDurationDifferenceInDays = moment.duration(this.to.diff(this.from)).asDays();
        if (dateDurationDifferenceInDays <= 1) downloadInterval = 0;
        else if (dateDurationDifferenceInDays <= 31) downloadInterval = 10;
        else downloadInterval = 60;
        $(".midi_PlottingPage_download_inputs").remove();
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.from.valueOf() + '" name="From">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.to.valueOf() + '" name="To">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + format + '" name="Format">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadInterval + '" name="Interval">').appendTo(this.downloadDataForm);
        var anyInputs = false;
        this.plottingPage.plotData.forEach((data_)=>{
            if (data_) {
                anyInputs = true;
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.Store + '" name="StoreCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.StationId + '" name="SiteCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.SensorId + '" name="SensorCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.ParameterId + '" name="ParameterCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.VariantId + '" name="VariantCols[]">').appendTo(this.downloadDataForm);
            }
        });
        if (anyInputs) {
            this.downloadDataForm.submit();
            this.downloadDataForm.empty;
        }
    }
    toggleRefreshOption(enable = null) {
        if (enable === null) enable = this.$refreshSel.prop("disabled") ? true : false;
        let tto = {
            placement: "bottom"
        };
        if (enable) {
            this.$refreshSel.prop("disabled", false);
            this.$refreshGroup.removeClass("is-disabled");
            this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));
        //this.$refreshGroup.tooltip("destroy");
        //tto.title = "Select an auto-refresh rate.";
        //this.$refreshGroup.tooltip(tto);
        } else {
            this.$refreshSel.prop("disabled", true);
            this.$refreshGroup.addClass("is-disabled");
        //this.$refreshGroup.tooltip("destroy");
        //tto.title = "Auto-refresh only available for period ranges that include current and future dates.";
        //this.$refreshGroup.tooltip(tto);
        }
    }
    click30() {
        this.button30.children('a').click();
        if (this.plottingPage._debug) console.info(`[PLOT TOOLBAR] click30()...`);
    }
    plotDataChanged() {
        if (this.plottingPage._debug) console.info(`[PLOT TOOLBAR] plotDataChanged()...`);
        if (this.plottingPage.plotData.length < 1) {
            this.pngButton.attr('disabled', 'disabled');
            //this.downloadCSVButton.attr('disabled', 'disabled');
            //this.downloadDLPButton.attr('disabled', 'disabled');
            return;
        }
        this.pngButton.removeAttr('disabled');
        //this.downloadCSVButton.removeAttr('disabled');
        //this.downloadDLPButton.removeAttr('disabled');
        var firstStation = this.plottingPage.plotData[0].StationId;
        this.multipleSitesSelected = false;
        this.plottingPage.plotData.forEach((value)=>{
            if (value.StationId !== firstStation) // here we disable the download dlp button, as multiple stations selected
            //  this.downloadDLPButton.attr('disabled', 'disabled');
            this.multipleSitesSelected = true;
        });
        this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val())); //: trigger a reset of the auto-refresh interval..
    }
    setDateWithButtons(numberOfDays) {
        var to = moment.utc().tz(this.mainSite.getTimeZoneName()).endOf('day').startOf('minute'); // 23:59 UTC tonight
        var from = moment.utc().tz(this.mainSite.getTimeZoneName()).add(1, 'd').startOf('day').subtract(numberOfDays, 'd'); // 00:00 UTC 30 days ago
        if (this.plottingPage._debug) console.info(`[PLOT TOOLBAR] setDateWithButtons(${numberOfDays})... THEN: this.plottingPage.setDateRange()`, {
            from: from,
            to: to
        });
        this.plottingPage.setDateRange(from, to);
    }
    dateRangeChanged(from, to) {
        if (this.plottingPage._debug) console.info(`[PLOT TOOLBAR] dateRangeChanged(${from}, ${to})... THEN: UPDATE DATEPICKERS`, {
            from: from,
            to: to
        });
        $('.midi_PlottingPage_navBar_listItem').removeClass("active");
        ///this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').datepicker('update', new Date(from.valueOf() + from.toDate().getTimezoneOffset() * 60000));
        ///this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').datepicker('update', new Date(to.valueOf() + to.toDate().getTimezoneOffset() * 60000));
        this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').datepicker('update', from.format("YYYY-MM-DD"));
        this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').datepicker('update', to.format("YYYY-MM-DD"));
        this.dateRangePicker.datepicker('updateDates');
        this.toggleRefreshOption(this.plottingPage.checkRangeHasFuture());
    }
}





class $8719ba5ebf43272d$export$6584b4c55173b074 {
    constructor(_mainsite, _plotting_page, _chart, _axis, _axisIndex, _axisId, _custom_conf){
        this._mainsite = _mainsite;
        this._plotting_page = _plotting_page;
        this._chart = _chart;
        this._axis = _axis;
        this._axisIndex = _axisIndex;
        this._axisId = _axisId;
        this._custom_conf = _custom_conf;
        this._titleText = 'Message';
        this.modal = null;
        this.modalContent = null;
        this.modalHeader = null;
        this.modalCloseButton = null;
        this.modalHeaderText = null;
        this.modalBody = null;
        this.modalFooter = null;
        this.modalFooterDismissButton = null;
        this.inputMinVal = null;
        this.inputMaxVal = null;
        this.inputMinCheck = null;
        this.inputMaxCheck = null;
        this._titleText = "Set chart custom limits";
    }
    show() {
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        this.modalContent = $('<div class="modal-content"></div>').appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));
        this.modalHeader = $('<div class="modal-header"></div>').appendTo(this.modalContent);
        this.modalCloseButton = $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(this.modalHeader);
        this.modalHeaderText = $('<h4 class="modal-title"></h4>').appendTo(this.modalHeader);
        this.modalHeaderText.text(this._titleText);
        this.modalBody = $('<div class="modal-body"></div>').appendTo(this.modalContent);
        //: build form:
        let $form = $("<form>").addClass("form-horizontal").appendTo(this.modalBody);
        let $group = null;
        let $check_label = null;
        //: axis ID label:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Axis:").appendTo($group);
        $("<p>").addClass("form-control-static").text(this._axisId).appendTo($("<div class=\"col-sm-10\">").appendTo($group));
        let _current_extremes = this._axis.getExtremes();
        //: min:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Minimum:").appendTo($group);
        this.inputMinVal = $("<input type=\"text\" style=\"text-align:right;\" name=\"min\" placeholder=\"Minimum\">").addClass("input-sm form-control");
        this.inputMinVal.appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        this.inputMinCheck = $("<input type=\"checkbox\" name=\"min_check\">").appendTo($check_label);
        $check_label.append("<span>Auto</span> <em class=\"text-muted\" style=\"font-weight:normal\">" + Math.floor(_current_extremes.dataMin) + "</em>");
        this.inputMinCheck.on("change", ()=>{
            if (this.inputMinCheck.is(":checked")) this.inputMinVal.val(""); // .prop("disabled", true);
        });
        this.inputMinVal.on("change", ()=>{
            if (this.inputMinVal.val() == "" || isNaN(this.inputMinVal.val())) this.inputMinCheck.prop("checked", true).trigger("change");
            else this.inputMinCheck.prop("checked", false).trigger("change");
        });
        //: max:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Maximum:").appendTo($group);
        this.inputMaxVal = $("<input type=\"text\" style=\"text-align:right;\" name=\"max\" placeholder=\"Maximum\">").addClass("input-sm form-control");
        this.inputMaxVal.appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        this.inputMaxCheck = $("<input type=\"checkbox\" name=\"max_check\">").appendTo($check_label);
        $check_label.append("<span>Auto</span> <em class=\"text-muted\" style=\"font-weight:normal\">" + Math.ceil(_current_extremes.dataMax) + "</em>");
        this.inputMaxCheck.on("change", ()=>{
            if (this.inputMaxCheck.is(":checked")) this.inputMaxVal.val(""); //.prop("disabled", true);
        });
        this.inputMaxVal.on("change", ()=>{
            if (this.inputMaxVal.val() == "" || isNaN(this.inputMaxVal.val())) this.inputMaxCheck.prop("checked", true).trigger("change");
            else this.inputMaxCheck.prop("checked", false).trigger("change");
        });
        //: set values of inputs:
        this.inputMinCheck.prop("checked", true).trigger("change");
        this.inputMaxCheck.prop("checked", true).trigger("change");
        if (this._custom_conf !== null && "min" in this._custom_conf && this._custom_conf.min !== null) //this.inputMinCheck.prop("checked", false).trigger("change");
        this.inputMinVal.val(this._custom_conf.min.toString()).trigger("change");
        if (this._custom_conf !== null && "max" in this._custom_conf && this._custom_conf.max !== null) //this.inputMaxCheck.prop("checked", false).trigger("change");
        this.inputMaxVal.val(this._custom_conf.max.toString()).trigger("change");
        $("<div>").addClass("alert alert-info").html("<strong>Note:</strong> Clicking <strong>Update</strong> below will apply the limits to the displayed charts.<br><br>To save these limits in your custom configurations in your account, please click on <strong>Save Set</strong> underneath the list of Parameter Sets.").css("marginBottom", 0).appendTo(this.modalBody);
        //: footer & buttons:
        this.modalFooter = $('<div class="modal-footer"></div>').appendTo(this.modalContent);
        this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>').appendTo(this.modalFooter);
        $('<button type="button" class="btn btn-success">UPDATE</button>').prependTo(this.modalFooter).on("click", ()=>{
            this.save();
        });
        this.modal.modal('show');
    }
    save() {
        //: apply to charts (immediate, saving to ParamSets is done separately by using the "Save Set" button!):
        let new_custom_settings = {
            min: null,
            max: null
        };
        if (this.inputMinCheck.prop("checked") == false) new_custom_settings.min = parseFloat(this.inputMinVal.val());
        if (this.inputMaxCheck.prop("checked") == false) new_custom_settings.max = parseFloat(this.inputMaxVal.val());
        this._axis.update(new_custom_settings, true);
        let yAxis = this._chart.chart.yAxis[this._axisIndex];
        this._chart.applyAxisFeatures(yAxis, this._axisIndex, this._axisId);
        this._plotting_page.customLimitsByAxisLabel[this._axisId] = new_custom_settings; /// JSON.stringify(new_custom_settings);
        this._plotting_page.resetCustomLimits(this._plotting_page.customLimitsByAxisLabel); // this sets the limits in the plotting page instance, and they are retrieved at time of saving the ParamSets.
        this.modal.modal('hide');
    }
}


class $74e92b8d58ba172c$export$acaa6426d77a227e {
    constructor(mainSite, plottingPage){
        this.mainSite = mainSite;
        this.plottingPage = plottingPage;
        this.containerDiv = $('<div id="midi_PlottingPage_plot_scrolling_container"></div>');
        this.div = $('<div id="midi_PlottingPage_plot_container"></div>').appendTo(this.containerDiv);
    }
    static applyDataFunction(data, dataFunction) {
        // If ParameterDefinition was not provided, find the defaultDefinitions based on the ParameterId
        if (!data.ParameterDefinition) {
            let defaultDefinitions = null;
            if (data.ParameterId in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) defaultDefinitions = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[data.ParameterId];
            else {
                // check for different versions of the Id (necessary due to inconsistent ParameterId nomenclature)
                const ParameterId = data.ParameterId.replace("_", "/");
                if (ParameterId in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) defaultDefinitions = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[ParameterId];
                else {
                    const ParameterId = data.ParameterId.replace("/", "_");
                    if (ParameterId in (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters) defaultDefinitions = (0, $d9b7173911f93686$export$82033fbb642dfaa2).Parameters[ParameterId];
                }
            }
            if (!defaultDefinitions) // Direction parameters come in many forms e.g. due to varying lidar bin ranges.
            // Hence, this hack to make sure all directions are plotted as points.
            {
                if (data.ParameterId.toLowerCase().includes("dir") && data.ParameterId.toLowerCase().includes("deg")) defaultDefinitions = {
                    PlotLine: false,
                    Default: false
                };
            }
            data.ParameterDefinition = defaultDefinitions;
        }
        switch(dataFunction){
            case "roc":
                let r = {
                    ...data,
                    ParameterDefinition: {
                        ...data.ParameterDefinition,
                        AxisMin: null,
                        AxisMax: null,
                        Units: data.ParameterDefinition.Units !== null ? data.ParameterDefinition.Units + " / hour" : null,
                        AxisLabel: data.ParameterDefinition.AxisLabel !== null ? "RoC " + data.ParameterDefinition.AxisLabel : null
                    }
                };
                r.Data = [];
                let prev = null;
                for (let x of data.Data){
                    if (x[1] === null) continue;
                    if (prev !== null) {
                        // TODO: It would be better to identify directional parameters more
                        // precisely
                        let dir = data.ParameterDefinition !== null && data.ParameterDefinition.AxisMin === 0 && data.ParameterDefinition.AxisMax === 360;
                        let dthrs = (x[0] - prev[0]) / 3600000;
                        let dv = x[1] - prev[1];
                        if (dir) {
                            if (dv > 180) dv -= 360;
                            else if (dv < -180) dv += 360;
                        }
                        r.Data.push([
                            Math.floor((x[0] + prev[0]) / 2),
                            dv / dthrs
                        ]);
                    }
                    prev = x;
                }
                return r;
            default:
                return data;
        }
    }
    // Draws the plot, and populates data based on content of dataToPlot
    drawPlot(dataToPlot, stacked, from, to, groupingApproximation, dataFunction) {
        var timeZoneString = this.mainSite.getTimeZoneString();
        var usedAxisIds = [];
        this.seriesOptions = [];
        this.axisOptions = [];
        if (stacked) {
            var requiredHeight = dataToPlot.length * 300;
            var deficit = requiredHeight - this.div.height();
            var newBottom = Math.min(5, parseFloat(this.div.css('bottom')) - deficit);
            this.div.css('bottom', newBottom + 'px');
        } else this.div.css('bottom', '5px');
        dataToPlot.forEach((data)=>{
            if (data.Data === null) alert("Error getting data.");
            else {
                data.Data.unshift([
                    from.valueOf(),
                    null
                ]);
                data.Data.push([
                    to.valueOf(),
                    null
                ]);
            }
            data = $74e92b8d58ba172c$export$acaa6426d77a227e.applyDataFunction(data, dataFunction);
            if (stacked) this.addSeriesToStackedChart(data, dataToPlot, usedAxisIds);
            else this.addSeriesToChart(data, usedAxisIds);
        });
        var timeZone = this.mainSite.selectedRegion.TimeZone;
        let _Chart = this;
        this.div.highcharts('StockChart', {
            chart: {
                zoomType: 'x'
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false,
                scale: 1,
                sourceWidth: 1024,
                sourceHeight: stacked ? Math.max(requiredHeight, 768) : 768
            },
            legend: {
                enabled: true
            },
            rangeSelector: {
                enabled: false,
                selected: 1
            },
            plotOptions: {
                series: {
                    events: {
                        legendItemClick: function() {
                            return false;
                        }
                    }
                },
                line: {
                    animation: false,
                    dataGrouping: {
                        approximation: groupingApproximation
                    }
                }
            },
            xAxis: {
                title: {
                    text: timeZoneString
                },
                ordinal: false,
                events: {
                    afterSetExtremes: (e)=>{
                        this.afterSetExtremes(e);
                    }
                }
            },
            navigator: {
                adaptToUpdatedData: false,
                series: {
                    data: [
                        [
                            1425168000000,
                            null
                        ],
                        [
                            moment.utc().endOf('M').valueOf(),
                            null
                        ]
                    ]
                }
            },
            scrollbar: {
                liveRedraw: false,
                enabled: true
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + timeZoneString,
                valueDecimals: 2
            },
            yAxis: this.axisOptions,
            series: this.seriesOptions
        }, function(_highchart) {
            this.yAxis.forEach((axis, axisIndex)=>{
                let _currentAxisId = usedAxisIds[axisIndex];
                _Chart.applyAxisFeatures(axis, axisIndex, _currentAxisId);
            });
        });
        this.chart = this.div.highcharts();
        if (to.valueOf() < from.valueOf()) {
            this.chart.showLoading('From date must be earlier than To date');
            return;
        }
    }
    exportChart() {
        const labelFontSize = "14px";
        const titleFontSize = "16px";
        var exportingChartOptions = {
            navigator: {
                enabled: false
            },
            /*
            title: {
                text: "Shell " + branding.siteName + " Chart",
                style: {
                    "font-size": titleFontSize
                }
            },*/ subtitle: {
                text: "Downloaded by " + this.plottingPage.mainSite.currentUser.Id + " on " + new Date(moment.utc().valueOf() + moment.utc().toDate().getTimezoneOffset() * 60000).toDateString() + " UTC",
                align: "right",
                style: {
                    "font-size": labelFontSize
                }
            }
        };
        let customLimitsSubstr = " <span style=\"color: blue; text-decoration: underline;\">Custom Limits</span>";
        //retain existing axis options so as not to override any formatting (e.g. datetime)
        exportingChartOptions.xAxis = JSON.parse(JSON.stringify(this.chart.options.xAxis));
        console.log(JSON.stringify(exportingChartOptions));
        if (Array.isArray(exportingChartOptions.xAxis)) exportingChartOptions.xAxis.forEach((axis)=>{
            console.log(JSON.stringify(axis));
            axis.labels["rotation"] = -85;
            axis.labels.style = axis.labels.style || {};
            axis.labels.style.fontSize = labelFontSize;
            axis.title.style = axis.title.style || {};
            axis.title.style.fontSize = titleFontSize;
            if (axis.title.text.indexOf(customLimitsSubstr) !== -1) axis.title.text = axis.title.text.substring(0, axis.title.text.indexOf(customLimitsSubstr));
        });
        else {
            exportingChartOptions.xAxis.labels["rotation"] = -85;
            exportingChartOptions.xAxis.labels.style = exportingChartOptions.xAxis.labels.style || {};
            exportingChartOptions.xAxis.labels["style"]["font-size"] = labelFontSize;
            exportingChartOptions.xAxis.title.style = exportingChartOptions.xAxis.title.style || {};
            exportingChartOptions.xAxis.title.style.fontSize = titleFontSize;
            if (exportingChartOptions.xAxis.title.text.indexOf(customLimitsSubstr) !== -1) exportingChartOptions.xAxis.title.text = exportingChartOptions.xAxis.title.text.substring(0, exportingChartOptions.xAxis.title.text.indexOf(customLimitsSubstr));
        }
        //retain existing axis options so as not to override any formatting (e.g. datetime)
        exportingChartOptions.yAxis = JSON.parse(JSON.stringify(this.chart.options.yAxis));
        if (Array.isArray(exportingChartOptions.yAxis)) exportingChartOptions.yAxis.forEach((axis)=>{
            console.log(JSON.stringify(axis));
            axis.labels.style = axis.labels.style || {};
            axis.labels.style.fontSize = labelFontSize;
            axis.title.style = axis.title.style || {};
            axis.title.style.fontSize = titleFontSize;
            if (axis.title.text.indexOf(customLimitsSubstr) !== -1) axis.title.text = axis.title.text.substring(0, axis.title.text.indexOf(customLimitsSubstr));
        });
        else {
            exportingChartOptions.yAxis.labels.style = exportingChartOptions.yAxis.labels.style || {};
            exportingChartOptions.yAxis.labels["style"]["font-size"] = labelFontSize;
            exportingChartOptions.yAxis.title.style = exportingChartOptions.yAxis.title.style || {};
            exportingChartOptions.yAxis.title.style.fontSize = titleFontSize;
            if (exportingChartOptions.yAxis.title.text.indexOf(customLimitsSubstr) !== -1) exportingChartOptions.yAxis.title.text = exportingChartOptions.yAxis.title.text.substring(0, exportingChartOptions.yAxis.title.text.indexOf(customLimitsSubstr));
        }
        var exportingOptions = {
            filename: "Chart",
            width: 1024
        };
        this.chart.exportChart(exportingOptions, exportingChartOptions);
    }
    afterSetExtremes(e) {
        //var fromMom = moment.utc(e.min).startOf('minute');
        //var toMom = moment.utc(e.max).startOf('minute');
        var fromMomTz = moment.utc(e.min).tz(this.mainSite.getTimeZoneName()).startOf('minute');
        var toMomTz = moment.utc(e.max).tz(this.mainSite.getTimeZoneName()).startOf('minute');
        if (this.plottingPage._debug) console.info(`%c[PLOT CHART]`, 'color: orange; font-weight: bold; font-style: italic;', ` afterSetExtremes(${e})... THEN plottingPage.setDateRange()`, {
            e: e,
            fromMomTz: fromMomTz,
            toMomTz: toMomTz
        });
        this.plottingPage.setDateRange(fromMomTz, toMomTz, true);
    }
    getSeriesNameOrId(data, isStacked = false, type = "name") {
        if (type == "id") return $74e92b8d58ba172c$export$acaa6426d77a227e.getYAxisId(data);
        if (type == "name") {
            let paramLabel = data.ParameterId;
            if (data.ParameterDefinition) {
                ///paramLabel = data.ParameterDefinition.DisplayName ?? (data.ParameterDefinition.AxisLabel ?? data.ParameterId);
                paramLabel = data.ParameterDefinition.DisplayName ?? data.ParameterId;
                /*if (data.ParameterDefinition.Suffix) {
                    paramLabel += ` (${data.ParameterDefinition.Suffix})`;
                }*/ if (data.ParameterDefinition.Units) {
                    let convertedUnits = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(data.ParameterDefinition.Units, data.ParameterId);
                    if (convertedUnits !== data.ParameterDefinition.Units) paramLabel += ' (' + (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(data.ParameterDefinition.Units, data.ParameterId) + ')';
                }
            }
            let sensorLabel = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema?.ParameterSchema?.Stations?.[data.StationId]?.Sensors?.[data.SensorId]?.SensorDefinition?.DisplayName;
            if (!sensorLabel || sensorLabel.indexOf("/") !== -1) sensorLabel = data.SensorId;
            const stationLabel = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.staticDataManager.Schema.ParameterSchema.Stations[data.StationId].Station.Label;
            if (isStacked) return stationLabel + "." + sensorLabel + "." + paramLabel;
            else {
                let variantName = data.VariantId == undefined ? "" : " (" + data.VariantId + ")";
                return stationLabel + "." + sensorLabel + "." + paramLabel + variantName;
            }
        }
    }
    static getYAxisId(data) {
        /** Parameter ID as provided ("raw"). This is then modified to attempt grouping of parameters where they should share an axis (e.g. Total_CurrentDirection_BinXX_XXm_deg). */ let paramId = data.ParameterId;
        if (data.ParameterDefinition) {
            paramId = data.ParameterDefinition.AxisLabel;
            if (data.ParameterDefinition.Units) paramId += ' (' + (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter().getConvertedUnits(data.ParameterDefinition.Units, data.ParameterId) + ')';
        } else {
            //: try grouping currents/wind profile elements with bins & depths: (addresses User Story #857)
            var pattern = /(.*)_Bin(?:\d+)_(?:(?:\d+|\d+\.*\d+))m_(.*)/i; //  /(.*)_Bin(?:\d+)_(?:\d+)m_(.*)/i;
            if (pattern.test(paramId)) {
                let m = pattern.exec(paramId);
                paramId = m[1] + '_' + m[2];
            }
            //: Group param IDs containing '_10min', '_30min' variations, or '_Mean' suffix, or sensor height variations ('_10m_' etc).. These should really share same axes as well, as the paramter itself and axis range should be the same:
            paramId = paramId.replace("_Min", "");
            paramId = paramId.replace("_Max", "");
            paramId = paramId.replace("_Mean", "");
            paramId = paramId.replace(/_\d+min/, ""); //.replace("_10min", "");
            paramId = paramId.replace(/_\d+m$/, ""); //: sensor height variations (assumes it's at the end of the modified param id)
        }
        return paramId;
    }
    addSeriesToChart(data, usedAxisIds) {
        /**
        * Adds the series and axis to the chart. Chart does not need to be re-drawn.
        * Only adds an axis if required.
        */ this.chart.hideLoading();
        var axisId = $74e92b8d58ba172c$export$acaa6426d77a227e.getYAxisId(data);
        if (usedAxisIds.indexOf(axisId) < 0) {
            let _custom_conf = this.getCustomConf(axisId);
            let _min = data.ParameterDefinition && typeof data.ParameterDefinition.AxisMin !== "undefined" ? data.ParameterDefinition.AxisMin : null;
            let _max = data.ParameterDefinition && typeof data.ParameterDefinition.AxisMax !== "undefined" ? data.ParameterDefinition.AxisMax : null;
            if (typeof _custom_conf == "object" && _custom_conf !== null && "min" in _custom_conf && !isNaN(_custom_conf.min) && _custom_conf.min !== null) _min = _custom_conf.min;
            if (typeof _custom_conf == "object" && _custom_conf !== null && "max" in _custom_conf && !isNaN(_custom_conf.max) && _custom_conf.max !== null) _max = _custom_conf.max;
            this.axisOptions.push({
                title: {
                    text: axisId + " <span style=\"color: blue; text-decoration: underline;\">Custom Limits</span>",
                    useHtml: true
                },
                opposite: usedAxisIds.length % 2 == 1,
                min: _min,
                max: _max
            });
            usedAxisIds.push(axisId);
        }
        var variantName = data.VariantId == undefined ? "" : " (" + data.VariantId + ")";
        var options = {
            name: this.getSeriesNameOrId(data, false, "name"),
            id: this.getSeriesNameOrId(data, false, "id"),
            yAxis: usedAxisIds.indexOf(axisId) + 0,
            data: data.Data,
            lineWidth: (()=>{
                if (data.ParameterDefinition && !data.ParameterDefinition.PlotLine) return 0;
                return 1;
            })(),
            marker: {
                enabled: data.ParameterDefinition && !data.ParameterDefinition.PlotLine,
                radius: 3
            }
        };
        if (data.SensorId.indexOf("Forecast") == -1) {
            options.gapSize = 7200000; // 2 hours in miliseconds
            options.gapUnit = "value";
        }
        this.seriesOptions.push(options);
    }
    addSeriesToStackedChart(data, dataToPlot, usedAxisIds) {
        /**
        * Adds the series and axis to the chart. Chart needs to be re-drawn.
        * Axes are always added.
        * Need to account for the possibility of the ParameterDefinition not being set.
        */ this.chart.hideLoading();
        var height = String(100 / dataToPlot.length - 15 / dataToPlot.length) + "%";
        var top = String(100 / dataToPlot.length * usedAxisIds.length) + "%";
        var axisId = $74e92b8d58ba172c$export$acaa6426d77a227e.getYAxisId(data);
        // let _loadedParamSetName = this.plottingPage.parameterSetList.getLoadedParamSetName();
        let _loadedParamSetValues = this.plottingPage.parameterSetList.getLoadedParamSetValues();
        let _custom_conf = this.getCustomConf(axisId);
        let _min = data.ParameterDefinition && typeof data.ParameterDefinition.AxisMin !== "undefined" ? data.ParameterDefinition.AxisMin : null;
        let _max = data.ParameterDefinition && typeof data.ParameterDefinition.AxisMax !== "undefined" ? data.ParameterDefinition.AxisMax : null;
        if (typeof _custom_conf == "object" && _custom_conf !== null && "min" in _custom_conf && !isNaN(_custom_conf.min) && _custom_conf.min !== null) _min = _custom_conf.min;
        if (typeof _custom_conf == "object" && _custom_conf !== null && "max" in _custom_conf && !isNaN(_custom_conf.max) && _custom_conf.max !== null) _max = _custom_conf.max;
        //this.chart.addAxis({
        this.axisOptions.push({
            title: {
                text: axisId + " <span style=\"color: blue; text-decoration: underline;\">Custom Limits</span>",
                useHtml: true
            },
            height: height,
            top: top,
            offset: 0,
            opposite: false,
            min: _min,
            max: _max
        });
        usedAxisIds.push(axisId);
        //this.chart.addSeries({
        this.seriesOptions.push({
            name: this.getSeriesNameOrId(data, true, "name"),
            id: this.getSeriesNameOrId(data, true, "id"),
            yAxis: usedAxisIds.length - 1,
            data: data.Data,
            lineWidth: (()=>{
                if (data.ParameterDefinition && !data.ParameterDefinition.PlotLine) return 0;
                return 1;
            })(),
            marker: {
                enabled: data.ParameterDefinition && !data.ParameterDefinition.PlotLine,
                radius: 3
            }
        });
    }
    applyAxisFeatures(axis, axisIndex, _currentAxisId) {
        // console.info("AxisFeats", { axis: axis, axisIndex: axisIndex, currentAxisId: _currentAxisId });
        let _linkNode = axis.axisGroup.element;
        try {
            if (typeof axis.axisTitle !== "undefined" && typeof axis.axisTitle.element.children[1] !== "undefined") _linkNode = axis.axisTitle.element.children[1];
        } catch (err) {
            console.warn("AxisFeatures Error", {
                err: err,
                axis: axis,
                axisIndex: axisIndex,
                currentAxisId: _currentAxisId
            });
        }
        _linkNode.style.cursor = "pointer";
        let _Chart = this;
        _linkNode.onclick = function() {
            let _custom_conf = _Chart.getCustomConf(_currentAxisId);
            // console.info("axis click", { this: this, axis: axis, axisIndex: axisIndex, _Chart: _Chart, currentAxisId: _currentAxisId, _custom_conf: _custom_conf });
            new (0, $8719ba5ebf43272d$export$6584b4c55173b074)(this.mainSite, _Chart.plottingPage, _Chart, axis, axisIndex, _currentAxisId, _custom_conf).show();
        };
    }
    getCustomConf(axisId) {
        let _loadedParamSetValues = this.plottingPage.parameterSetList.getLoadedParamSetValues();
        // console.info("Chart.getCustomConf()", { axisId: axisId, loadedParamSetVals: _loadedParamSetValues });
        if (_loadedParamSetValues && _loadedParamSetValues.plotConfigurations && axisId in _loadedParamSetValues.plotConfigurations) return _loadedParamSetValues.plotConfigurations[axisId];
        else {
            if (this.plottingPage.customLimitsByAxisLabel && axisId in this.plottingPage.customLimitsByAxisLabel) return this.plottingPage.customLimitsByAxisLabel[axisId];
            return null;
        }
    }
}


class $b01a240ac09ad487$export$cdddf4d2bf535e26 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this._debug = false;
        this.id = 'plot';
        this.visible = false;
        this.delayUpdate = false;
        this.delayUpdateCounter = 0;
        this.desiredResolution = 0;
        this.customLimitsByAxisLabel = {};
        this.container = null;
        this.fromMoment = null;
        this.toMoment = null;
        this.groupingApproximation = "high";
        this.dataFunction = "none";
        this.momentFormatDebug = "YYYY-MM-DD HH:mm:ss ZZ (X)";
        this.refreshIntervalSeconds = -1;
        this.refreshIntervalElapsed = 0;
        this.refreshIntervalId = null;
        this.refreshDataMinutesBefore = 10;
        this.sideContainer = null;
        this.plotData = [];
        this.stacked = false;
        this.downloadDialog = null;
        this.addIssueDialog = null;
        this._pageBlockJquerySelector = "body";
        $(window).resize(()=>{
            if (this.container) {
                let widthOfSideBarBeforeWindowResize = $('.midi_PlottingPage_series_panel_sideContainer.ui-resizable').width();
                $('.midi_PlottingPage_series_panel_sideContainer.ui-resizable').css('left', $(window).width() - widthOfSideBarBeforeWindowResize - 10);
                this.resizeChart();
            }
        });
    }
    resetCustomLimits(limits = null) {
        this.customLimitsByAxisLabel = {};
        if (limits !== null && typeof limits !== "undefined") this.customLimitsByAxisLabel = limits;
    }
    initialize() {
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);
        $('<a></a>').attr('href', '#').click(()=>{
            this.mainSite.changePage(this.id);
            return false;
        }).text('Plot').appendTo(this.navBarLink);
    }
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            this.navBarLink.addClass('active');
            if (hashData.Region !== this.regionId) {
                this.regionId = this.mainSite.hashData.Region;
                this.hide();
                if (this.container) {
                    // all messy but required
                    this.pageUnblock();
                    this.container.remove();
                    this.container = null;
                    this.chart = null;
                    this.plotData = [];
                    this.fromMoment = null;
                    this.toMoment = null;
                }
            }
            if (!this.visible) this.render();
            return true;
        } else {
            this.navBarLink.removeClass('active');
            if (this.visible) this.hide();
            return false;
        }
    }
    render() {
        if ($.isEmptyObject(this.mainSite.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('PlottingPage.render() - no Regions available!');
            if (!this.container) {
                this.container = $('<div class="plot-page--main-wrap no-select"></div>');
                this.container.appendTo('body');
            }
            this.container.html('<div class="container"><div class="row"><div class="alert alert-danger" style="margin: 80px;">Your Account on this site does not seem to have any Permissions set or access to any Regions.</div></div></div>');
            return;
        }
        if (!this.container) {
            this.container = $('<div class="plot-page--main-wrap no-select"></div>'); //.appendTo('body');
            this.toolbar = new (0, $1ccdd46c8160eb50$export$e3d5fab60ca34025)(this.mainSite, this);
            this.toolbar.nav.appendTo(this.container);
            //: setup panels for resizable elements:
            this.$panelsWrap = $('<div class="plot-page--panels-wrap"></div>').appendTo(this.container);
            this.$panelLeft = $('<div class="plot-page--panels-left"></div>').appendTo(this.$panelsWrap);
            let $splitterVertical = $('<div class="plot-page--splitter splitter-vertical"></div>').appendTo(this.$panelsWrap);
            this.$panelRight = $('<div class="plot-page--panels-right"></div>').appendTo(this.$panelsWrap);
            this.$panelRightTop = $('<div class="plot-page--panels-right--top"></div>').appendTo(this.$panelRight);
            let $splitterHorizontal = $('<div class="plot-page--splitter splitter-horizontal"></div>').appendTo(this.$panelRight);
            this.$panelRightBottom = $('<div class="plot-page--panels-right--bottom"></div>').appendTo(this.$panelRight);
            //: apply resizable panels: (SEE: https://github.com/RickStrahl/jquery-resizable)
            this.$panelRight.resizableSafe({
                handleSelector: ".plot-page--splitter.splitter-vertical",
                resizeHeight: false,
                resizeWidthFrom: 'left',
                onDragStart: (e, $el, opt)=>{
                    $splitterVertical.addClass("resizing");
                },
                onDragEnd: (e, $el, opt)=>{
                    $splitterVertical.removeClass("resizing");
                    (0, $52db63ea8facb471$export$1a86835baa79d770).localStorageSet('plotSideBarWidth', this.$panelRight.width().toString());
                    this.resizeChart();
                }
            });
            this.$panelRightTop.resizableSafe({
                handleSelector: ".plot-page--splitter.splitter-horizontal",
                resizeWidth: false,
                onDragStart: (e, $el, opt)=>{
                    $splitterHorizontal.addClass("resizing");
                },
                onDragEnd: (e, $el, opt)=>{
                    $splitterHorizontal.removeClass("resizing");
                    (0, $52db63ea8facb471$export$1a86835baa79d770).localStorageSet('plotSideBarTopPanelHeight', this.$panelRightTop.height().toString());
                }
            });
            //: apply locally stored panel sizes if possible:
            let sideBarWidth = 280;
            let lsWidth = parseFloat((0, $52db63ea8facb471$export$1a86835baa79d770).localStorageGet('plotSideBarWidth', null));
            if (!isNaN(lsWidth)) {
                sideBarWidth = lsWidth;
                if (sideBarWidth > $(window).width() * 0.45 || sideBarWidth < 280) {
                    sideBarWidth = 280;
                    (0, $52db63ea8facb471$export$1a86835baa79d770).localStorageSet('plotSideBarWidth', null);
                }
            }
            this.$panelRight.width(sideBarWidth);
            let topPanelHeight = 180;
            let lsHeight = parseFloat((0, $52db63ea8facb471$export$1a86835baa79d770).localStorageGet('plotSideBarTopPanelHeight', null));
            if (!isNaN(lsHeight)) {
                topPanelHeight = lsHeight;
                this.$panelRightTop.height(topPanelHeight);
            }
            //: add other elements:
            let $chartBox = $('<div>').addClass('padded-box fill-space').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelLeft));
            let $paramTreeBox = $('<div>').addClass('padded-box fill-space flex-col-wrap').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelRightBottom));
            let $paramSetsBox = $('<div>').addClass('padded-box fill-space flex-col-wrap').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelRightTop));
            this.chart = new (0, $74e92b8d58ba172c$export$acaa6426d77a227e)(this.mainSite, this);
            this.chart.containerDiv.appendTo($chartBox);
            this.parameterTree = new (0, $540f2b2f5fcbfde1$export$9a48e0793a1eb1f8)(this.mainSite, this);
            this.parameterSetList = new (0, $6a744cf7ffecae4a$export$51ba4ecd5810c2ba)(this.mainSite, this.parameterTree, $paramSetsBox, this);
            let paramsTitleContainer = $('<div class="midi_PlottingPage_series_panel_sideContainer_parametersTitle flex-col-item--no-grow"></div>').appendTo($paramTreeBox);
            $('<h5></h5>').text("Parameters").appendTo(paramsTitleContainer);
            this.parameterSetList.getSaveButton().appendTo(paramsTitleContainer);
            this.parameterTree.setupTreeToolbar(paramsTitleContainer);
            this.parameterTree.tree.appendTo($paramTreeBox);
            this.toolbar.click30();
        }
        this.container.appendTo('body');
        this.visible = true;
        this.resizeChart();
    }
    hide() {
        if (this.visible) {
            this.pageUnblock();
            this.container.detach();
            if (this.downloadDialog) {
                this.downloadDialog.hide();
                this.downloadDialog = null;
            }
            this.visible = false;
        }
        this.refreshIntervalClear();
    }
    resizeChart() {
        this.updateChart();
    }
    updateChart() {
        this.chart.drawPlot(this.plotData, this.stacked, this.fromMoment, this.toMoment, this.groupingApproximation, this.dataFunction);
        this.toolbar.plotDataChanged();
    }
    setStacked(stacked) {
        this.stacked = stacked;
        this.updateChart();
    }
    setDateRange(from, to, ignoreTimezone = false) {
        var changed = false;
        let mm = null;
        if (ignoreTimezone) {
            //old (UTC) method or if we've got moments with provided times (i.e. on afterSetExtremes() on chart):
            if (!this.fromMoment || from && this.fromMoment.valueOf() != from.valueOf()) {
                this.fromMoment = from;
                changed = true;
            }
            if (!this.toMoment || to && this.toMoment.valueOf() != to.valueOf()) {
                this.toMoment = to;
                changed = true;
            }
        } else {
            let mm_format = "YYYY-MM-DD";
            mm = this.getMomentsRange(from.format(mm_format), to.format(mm_format));
            if (!this.fromMoment || mm.from && this.fromMoment.valueOf() != mm.from.valueOf()) {
                this.fromMoment = mm.from;
                changed = true;
            }
            if (!this.toMoment || mm.to && this.toMoment.valueOf() != mm.to.valueOf()) {
                this.toMoment = mm.to;
                changed = true;
            }
        }
        if (this._debug) console.info(`%c[PLOT PAGE]`, 'color: red; font-weight: bold', ` setDateRange(${from}, ${to})... THEN toolbar.dateRangeChanged() AND parameterTree.updateAll()`, {
            changed: changed,
            fromMoment: this.fromMoment,
            toMoment: this.toMoment,
            inputs: {
                f: from,
                t: to,
                mm: mm
            }
        });
        if (changed) {
            this.toolbar.dateRangeChanged(this.fromMoment, this.toMoment);
            this.parameterTree.updateAll();
        }
    }
    /**
     * Helper function to get from/to moments instances with appropriate timezone settings based on user's choices. NB: this will
     * always provide a starting moment at 00:00 and ending at 23:59, considering the user's timezone setting.
     * @param fromYMD String for FROM date, YYYY-MM-DD (default uses currently set fromMoment)
     * @param toYMD String for TO date, YYYY-MM-DD (default uses currently set toMoment)
     */ getMomentsRange(fromYMD, toYMD, fromHms = "00:00:00", toHms = "23:59:59") {
        let offset = this.mainSite.getTimeZoneStringFormat('ZZ');
        let format = "YYYY-MM-DD HH:mm:ssZ";
        if (!fromYMD) fromYMD = this.fromMoment.format("YYYY-MM-DD");
        if (!toYMD) toYMD = this.toMoment.format("YYYY-MM-DD");
        let f = moment.parseZone(`${fromYMD} ${fromHms}${offset}`, format);
        let t = moment.parseZone(`${toYMD} ${toHms}${offset}`, format);
        return {
            from: f,
            to: t,
            debug: {
                f: f.format(this.momentFormatDebug),
                t: t.format(this.momentFormatDebug)
            }
        };
    }
    /**
     * Helper to get the current moment, with considerations for user's timezone setting.
     */ getNowMoment() {
        return moment(moment.utc()).tz(this.mainSite.getTimeZoneName());
    }
    /**
     * Checks if currently set moments range contains future moments or not.
     */ checkRangeHasFuture() {
        try {
            let now = this.getNowMoment();
            if (this.fromMoment < now && this.toMoment > now) return true;
            else return false;
        } catch (err) {
            console.warn("Unable to check if range contains future. Details:", err);
            return false;
        }
    }
    /**
     * A helper function to retrieve the currently set from/to moments in this instance.
     */ getCurrentMoments() {
        return {
            from: this.fromMoment,
            to: this.toMoment,
            debug: {
                f: this.fromMoment.format(this.momentFormatDebug),
                t: this.toMoment.format(this.momentFormatDebug)
            }
        };
    }
    setResolution(resolution) {
        this.desiredResolution = resolution;
        this.parameterTree.updateAll();
    }
    setGrouping(groupingApproximation) {
        this.groupingApproximation = groupingApproximation;
        this.parameterTree.updateAll();
    }
    setDataFunction(dataFunction) {
        this.dataFunction = dataFunction;
        this.parameterTree.updateAll();
    }
    checkIfUserCanDownloadRegionData(regionId) {
        var hasPermission = false;
        this.mainSite.currentUserGroupPermissions.forEach((gp)=>{
            if (gp.GroupPermissionType == (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).ViewAndDownload && gp.GroupRules.filter((x)=>x.RegionId == regionId).length > 0) hasPermission = true;
        });
        return hasPermission;
    }
    checkIfUserCanDownloadStationData(stationId) {
        var hasPermission = false;
        var stationRegions = this.mainSite.getStationsByRegions();
        var regionId = null;
        stationRegions.forEach((sr)=>{
            if (sr.Stations.filter((x)=>x.Id == stationId).length > 0) regionId = sr.Region.Id;
        });
        this.mainSite.currentUserGroupPermissions.forEach((gp)=>{
            if (gp.GroupPermissionType == (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).ViewAndDownload) {
                if (gp.GroupRules.filter((x)=>x.StationId == stationId).length > 0) hasPermission = true;
                else if (gp.GroupRules.filter((x)=>x.StationId == null && x.RegionId == regionId).length > 0) //user has access to whole region
                hasPermission = true;
            }
        });
        return hasPermission;
    }
    checkIfUserCanDownloadSensorData(stationId, sensorId) {
        var hasPermission = false;
        var stationRegions = this.mainSite.getStationsByRegions();
        var regionId = null;
        stationRegions.forEach((sr)=>{
            if (sr.Stations.filter((x)=>x.Id == stationId).length > 0) regionId = sr.Region.Id;
        });
        this.mainSite.currentUserGroupPermissions.forEach((gp)=>{
            if (gp.GroupPermissionType == (0, $1d3f08d9fba35da9$export$f1866bc975e81efa).ViewAndDownload) {
                if (gp.GroupRules.filter((x)=>x.RegionId == regionId && x.StationId == null || x.RegionId == regionId && x.StationId == stationId && x.SensorId == null || x.RegionId == regionId && x.StationId == stationId && x.SensorId == sensorId).length > 0) hasPermission = true;
            }
        });
        return hasPermission;
    }
    setChartResolution(desiredResolution) {}
    /**
     * A helper function to concatenate data points for the chart, but removing duplicated points
     * from current data before adding new ones, to prevent duplication. Note that sorting is applied
     * to the final result before being returned, to prevent Highcharts Error #15 (expects sorted data).
     * NB: historically data was typed any[], tried to make it more accurate here...
     * @param currentData Data points expected to be in the form of array[timestamp, value]
     * @param newData Data points expected to be in the form of array[timestamp, value]
     * @returns [number, any][] Data points  expected to be in the form of array[timestamp, value], sorted by timestamp
     */ dataPointsConcat(currentData, newData) {
        let final = [];
        final = [].concat([], currentData); //: set to current data before modifying
        if (newData.length > 0) {
            newData.sort(this.dataPointsSort);
            let tsFirstNew = newData[0][0] || null;
            if (tsFirstNew && !isNaN(tsFirstNew)) {
                var tsFirstNewIndex = this.dataPointsGetTsIndex(final, tsFirstNew);
                if (tsFirstNewIndex > -1) final.splice(tsFirstNewIndex);
            }
            final = [].concat([], final, newData);
        }
        // console.info("[PLOT PAGE] dataPointsConcat()", { cur: currentData, new: newData, final: final, tsFirstNew: tsFirstNew, tsFirstNewIndex: tsFirstNewIndex });
        return final.sort(this.dataPointsSort);
    }
    /**
     * Function to sort the data points by timestamp, in ascending order
     * @param a
     * @param b
     */ dataPointsSort(a, b) {
        //: sorting may be performance consuming but necessary for Highcharts, otherwise we get error 15 (https://www.highcharts.com/errors/15/). Sorting may be necessary for points that are duplicated from received data.
        //: NB: here we assume that a & b are data points in form of array[timestamp, value]..
        let a2 = a[0]; // parseInt(a[0]);
        let b2 = b[0]; // parseInt(b[0]);
        if (a2 == b2 || isNaN(a2) || isNaN(b2)) return 0;
        if (a2 > b2) return 1;
        if (a2 < b2) return -1;
    }
    /**
     * Get the index of a data point in a given set for a specific timestamp
     * @param data The given set of points (in form of array[timestamp, value])
     * @param ts The timestamp to look for
     */ dataPointsGetTsIndex(data, ts) {
        var index = -1;
        data.forEach((x, i)=>{
            if (x[0] == ts) index = i;
        });
        return index;
    }
    addOrUpdateChartSeries(data, merge = false) {
        var index = this.getPlotDataIndex(data);
        if (index >= 0) {
            if (merge) {
                this.plotData[index].Data = this.dataPointsConcat(this.plotData[index].Data, data.Data);
                this.plotData[index].TimestampFirst = data.TimestampFirst;
                this.plotData[index].TimestampLast = data.TimestampLast;
            } else this.plotData[index] = data;
            this.delayUpdateCounter++;
            if (this.delayUpdateCounter >= this.plotData.length) {
                this.delayUpdate = false;
                this.delayUpdateCounter = 0;
            }
        } else {
            this.plotData.push(data);
            this.delayUpdate = false; // always force delay update to false if a node clicked
            this.delayUpdateCounter = 0;
        }
        if (!this.delayUpdate) this.updateChart();
    }
    removeChartSeries(data) {
        var index = this.getPlotDataIndex(data);
        if (index >= 0) {
            this.plotData.splice(index, 1);
            this.delayUpdate = false; // always force delay update to false if a node clicked
            this.delayUpdateCounter = 0;
            this.updateChart();
        }
    }
    getPlotDataIndex(data) {
        var index = -1;
        this.plotData.forEach((data_, i)=>{
            if (data.StationId == data_.StationId && data.ParameterId == data_.ParameterId && data.SensorId == data_.SensorId && data.VariantId == data_.VariantId) index = i;
        });
        return index;
    }
    addIssue(stationId, sensorId, parameterId, parameterTreeNode) {
        if (this.addIssueDialog) {
            this.addIssueDialog.hide();
            this.addIssueDialog = null;
        }
        this.pageBlock(`Loading Add Issue Popup`, true, (pp)=>{
            this.addIssueDialog = new (0, $13b4e59235a6ba75$export$fe13e5b1221a1782)(stationId, sensorId, parameterId, this, this.parameterTree, parameterTreeNode);
            this.addIssueDialog.show();
        });
    }
    downloadData(parameterSchemaStation) {
        if (this.downloadDialog) {
            this.downloadDialog.hide();
            this.downloadDialog = null;
        }
        this.pageBlock(`Loading Data Download Popup for ${parameterSchemaStation.Station.Label}...`, true, (pp)=>{
            this.downloadDialog = new (0, $6af33996902e4a66$export$23a0a2b4bb5a9051)(parameterSchemaStation, this);
            this.downloadDialog.show(this.fromMoment, this.toMoment);
        });
    }
    downloadDataAllStations() {
        if (this.downloadDialog) {
            this.downloadDialog.hide();
            this.downloadDialog = null;
        }
        this.pageBlock(`Loading Data Download Popup...`, true, (pp)=>{
            this.downloadDialog = new (0, $6af33996902e4a66$export$23a0a2b4bb5a9051)(null, this);
            this.downloadDialog.show(this.fromMoment, this.toMoment);
        });
    }
    downloadPng() {
        this.chart.exportChart();
    }
    refreshIntervalSetTo(seconds = -1) {
        //: DEV INFO: SET BELOW IN A WATCH LINE IN CHROME CONSOLE:
        //:    - pp = Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[2];
        //:    - pp.getCurrentMoments().debug
        //:    - ['refresh', pp.refreshIntervalId, pp.refreshIntervalElapsed, pp.refreshIntervalSeconds, pp.checkRangeHasFuture()]
        // console.info(`%c[PLOT PAGE INTERVAL] SetTo(${seconds})`, 'color: blue;');
        let min = 60; //: set this to 30 or 60! (1 was set for dev testing!)
        if (seconds >= 0 && seconds < min) console.error(`Plot Page: refresh interval less than ${min} seconds not permitted for performance reasons.`);
        this.refreshIntervalClear();
        if (seconds >= min) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalSeconds = seconds;
            this.refreshIntervalSetup();
        }
    }
    refreshIntervalRun() {
        this.refreshIntervalElapsed++;
        if (this.refreshIntervalElapsed >= this.refreshIntervalSeconds) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalFetchData();
        }
    }
    refreshIntervalSetup() {
        if (this._debug) console.info(`%c[PLOT PAGE INTERVAL] SETUP`, 'color: blue;');
        if (this.refreshIntervalId === null) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalId = setInterval(()=>{
                this.refreshIntervalRun();
            }, 1000);
        }
    }
    refreshIntervalClear() {
        if (this._debug) console.info(`%c[PLOT PAGE INTERVAL] CLEAR`, 'color: blue;');
        if (this.refreshIntervalId !== null) {
            this.refreshIntervalElapsed = 0;
            clearInterval(this.refreshIntervalId);
            this.refreshIntervalId = null;
        }
    }
    refreshIntervalFetchData() {
        if (this.checkRangeHasFuture()) {
            let latestPoints = {};
            let tsFrom = Infinity;
            let tsTo = 0;
            this.plotData.forEach((data)=>{
                let sn = this.chart.getSeriesNameOrId(data, this.stacked, "name");
                latestPoints[sn] = {
                    res: data.Resolution,
                    tsFirst: data.TimestampFirst,
                    tsLast: data.TimestampLast,
                    //tsFirst_str: moment(data.TimestampFirst).utc().tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug),
                    //tsLast_str: moment(data.TimestampLast).utc().tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug),
                    getFrom: moment(data.TimestampLast).utc().subtract(this.refreshDataMinutesBefore, "minutes").startOf('minute').valueOf(),
                    getTo: moment().utc().endOf('minute').valueOf()
                };
                if (!isNaN(latestPoints[sn].getFrom)) tsFrom = Math.min(tsFrom, latestPoints[sn].getFrom);
                if (!isNaN(latestPoints[sn].getTo)) tsTo = Math.max(tsTo, latestPoints[sn].getTo);
            });
            if (tsFrom == Infinity || tsTo == 0) console.warn(`%c[PLOT PAGE INTERVAL] Refresh ERROR`, 'color: red;', `The FROM or TO timestamps could not be resolved for safe API server call.`);
            else {
                if (this._debug) console.info("REFRESH FETCH DATA", {
                    latestPoints: latestPoints,
                    F: tsFrom,
                    T: tsTo
                });
                this.parameterTree.getLatestDataAll(tsFrom, tsTo, null); //: NB: using null for resolution so methods use the currently set resolution for each node.
            }
        } else if (this._debug) console.warn("[PLOT PAGE] Refresh interval will not get new data as moments range does not contain current & future moments.");
    }
    pageBlock(message = '', blockNavBar = true, callback) {
        let _msg = '';
        let progressBar = '<div class="progress" style="margin:0"><div class="progress-bar progress-bar-striped active" style="width: 100%"></div></div>';
        let css = {
            border: 'none',
            backgroundColor: 'transparent',
            color: '#fff'
        };
        let $msg = $('<div>');
        if (message.length > 0) {
            $msg.text(message); //: use this to escape content..
            _msg = progressBar + '<div style="margin-top: 5px;">' + $msg.html() + '</div>';
        } else _msg = progressBar;
        if (blockNavBar) $(".navbar.navbar-fixed-top").block({
            message: '',
            css: css
        });
        $(this._pageBlockJquerySelector).block({
            message: _msg,
            css: css,
            onBlock: ()=>{
                if (typeof callback == "function") callback(this);
            }
        });
    }
    pageUnblock() {
        $(".navbar.navbar-fixed-top").unblock();
        $(this._pageBlockJquerySelector).unblock();
    }
}




class $a61c85924a8d2ca1$export$47bc8c4da376913b {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'emailUsers';
        this.container = null;
        this.emailsContainer = null;
        this.userAccountSet = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.renderEmailUsersAfterUsersLoaded();
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    getUserData(callback) {
        (0, $4b7cacdb38b8b78b$export$925a4945a6cd0f3e)((err, data)=>{
            if (!err) this.userAccountSet = data;
            callback();
        });
    }
    renderEmailUsersAfterUsersLoaded() {
        this.getUserData(()=>{
            this.renderEmailUsers();
        });
    }
    renderEmailUsers() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container"></div>').appendTo('body');
        $('<h1>User Emails</h1>').appendTo(this.container);
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you have access to the email addresses of <strong>all users</strong> within the system.</p>').appendTo(this.container);
            $('<p class="midi_manageUsersPage_topParagraph">Copy the list below into your email address bar to send bulk emails to all users.</p>').appendTo(this.container);
        } else {
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you have access to the email addresses of <strong>users within your region</strong>.</p>').appendTo(this.container);
            $('<p class="midi_manageUsersPage_topParagraph">Copy the list below into your email address bar to send bulk emails to all users.</p>').appendTo(this.container);
        }
        this.emailsContainer = $('<textarea rows="8" cols="80" class="midi_EmailUsersPage_box"></textarea>').appendTo(this.container);
        var emailString = "";
        for(var userId in this.userAccountSet.UserAccounts)((user)=>{
            if (this.mainSite.currentUser.Permissions.GlobalAdministrator && user.EmailConfirmed && this.mainSite.currentUser.Id != user.Id) emailString += user.Id + '; ';
            else {
                if (this.mainSite.currentUser.Region != user.Region || !user.EmailConfirmed || this.mainSite.currentUser.Id == user.Id) return;
                emailString += user.Id + '; ';
            }
        })(this.userAccountSet.UserAccounts[userId]);
        if (emailString == "") emailString = "Once users have registered, their email addresses will be displayed here.";
        this.emailsContainer.text(emailString);
    }
}



var $dae7e779a0d50afe$var$BASE_URL = '/api/Alerts';
function $dae7e779a0d50afe$export$2b4a358acbf56374(req, callback) {
    $.ajax($dae7e779a0d50afe$var$BASE_URL + '/SetWaveBuoyExcursionAlarm', {
        cache: false,
        type: 'POST',
        data: req,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $dae7e779a0d50afe$export$bb18587c791cc170(stationId, sensorId, callback) {
    $.ajax($dae7e779a0d50afe$var$BASE_URL + '/DeleteWaveBuoyExcursionAlarm', {
        cache: false,
        type: 'POST',
        data: {
            "StationId": stationId,
            "SensorId": sensorId
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $dae7e779a0d50afe$export$4dddbe59d264921d(_alert, callback) {
    $.ajax($dae7e779a0d50afe$var$BASE_URL + '/SetParameterAlert', {
        cache: false,
        type: 'POST',
        data: _alert,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $dae7e779a0d50afe$export$d31c2575813e5515(_alert, callback) {
    $.ajax($dae7e779a0d50afe$var$BASE_URL + '/DeleteParameterAlert', {
        cache: false,
        type: 'POST',
        data: _alert,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}


class $242442f944181932$export$f258f7b590b5b095 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'manageAlerts';
        this.container = null;
        this.loadingContainer = null;
        this.modal = null;
        this.modalContent = null;
        this.emailRecipientInput = null;
        this.selectStationDropdown = null;
        this.targetLatitudeInput = null;
        this.targetLongitudeInput = null;
        this.maxExcursionInput = null;
        this.activeInput = null;
        this.table = null;
        this.tableBody = null;
        this.tableHead = null;
        this.tableHeadRow = null;
        this.WAVE_BUOY_PARAMETER_IDS = [
            'Buoy_Excursion/m',
            'Buoy_Latitude/deg',
            'Buoy_Longitude/deg'
        ];
        this.alertsListWaveBuoy = [];
        this.validationErrorText = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.refresh();
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    refresh() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container"></div>').appendTo('body');
        this.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(this.container);
        this.mainSite.staticDataManager.getStaticData((err)=>{
            if (err) this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Uable to get list of settings from server: ' + err);
            else this.loadingContainer.removeClass('alert-danger').addClass('alert-info').html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...');
            this.render();
        });
    }
    render() {
        $('<h1 class="midi_manageUsersPage_title">Manage Alerts</h1>').appendTo(this.container);
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you can  manage alerts across all regions.</p>').appendTo(this.container);
        else {
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you can manage alerts for sites within your region.</p>').appendTo(this.container);
        }
        $('<p class="text-muted"><i class="fa fa-lg fa-info-circle"></i> <em><strong>Wave Buoy Alerts</strong> allow to specify the maximum excursion permitted for a buoy\'s movements, whereas <strong>Parameter Alerts</strong> allow to set Min and Max limits on any other Parameter.</em></p>').appendTo(this.container);
        let $tblTitleBar = $('<div>').addClass('clearfix').appendTo(this.container);
        $tblTitleBar.css({
            marginTop: 30,
            marginBottom: 15
        });
        $('<h4 class="pull-left">Wave Buoy Alerts</h4>').appendTo($tblTitleBar);
        $('<button type="button" class="btn btn-success pull-right"><i class="fa fa-bell"></i> Add Wave Buoy Alert</button>').appendTo($tblTitleBar).click(()=>{
            this.renderModal(null);
        });
        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Station</th> <th>Sensor</th> <th>Target Latitude</th> <th>Target Longitude</th> <th>Max Excursion (m)</th> <th>Email Recipients</th> <th class="text-center">Active</th> <th></th> <th></th>').appendTo(this.tableHeadRow);
        this.mainSite.staticDataManager.Schema.WaveBuoyTargetLocations.forEach((wbtl)=>{
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter((x)=>x.StationId == wbtl.StationId && x.SensorId == wbtl.SensorId && this.WAVE_BUOY_PARAMETER_IDS.indexOf(x.ParameterId) >= 0);
            if (alerts.length != 1) return; // we should never get here!!!
            const alert1 = alerts[0];
            this.alertsListWaveBuoy.push(alert1);
            var tableCurrentRow = $('<tr></tr>').appendTo(this.tableBody);
            // add cells:
            $('<td></td>').text(this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[wbtl.StationId].Station.Label).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.SensorId).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.Latitude).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.Longitude).appendTo(tableCurrentRow);
            $('<td></td>').text(alert1.MaxValue).appendTo(tableCurrentRow);
            $('<td></td>').text(alert1.EmailRecipients.join(", ")).css({
                maxWidth: '40vw'
            }).appendTo(tableCurrentRow);
            $('<td></td>').html(alert1.Active ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times"></i>').addClass('text-center').appendTo(tableCurrentRow);
            var editButtonCell = $('<td class="edit_user_button_cell text-center"></td>').appendTo(tableCurrentRow);
            var deleteButtonCell = $('<td class="delete_user_button_cell text-center"></td>').appendTo(tableCurrentRow);
            $('<a class= "midi_common_link">Delete Alert</a>').click(()=>{
                this.renderDeleteModal(wbtl);
            }).appendTo(deleteButtonCell);
            $('<a class= "midi_common_link">Edit Alert</a>').click(()=>{
                this.renderModal(wbtl, alert1);
            }).appendTo(editButtonCell);
        });
        this.setNoRowsMessage(this.tableBody, 9, true);
        //: Other (non-wave buoy) alerts:
        $tblTitleBar = $('<div>').addClass('clearfix').appendTo(this.container);
        $tblTitleBar.css({
            marginTop: 60,
            marginBottom: 15
        });
        $('<h4 class="pull-left">Parameter Alerts</h4>').appendTo($tblTitleBar);
        $('<button type="button" class="btn btn-success pull-right"><i class="fa fa-bell"></i> Add Parameter Alert</button>').appendTo($tblTitleBar).click(()=>{
            this.renderModalParameterAlert(null);
        });
        let $table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        let $tableHead = $('<thead></thead>').appendTo($table);
        let $tableBody = $('<tbody></tbody>').appendTo($table);
        let $row = null;
        $row = $('<tr>');
        $('<th>Station</th> <th>Sensor</th> <th>Parameter</th> <th class="text-center">Min. Limit</th> <th class="text-center">Max. Limit</th> <th>Email Recipients</th> <th class="text-center">Active</th> <th></th> <th></th>').appendTo($row);
        $row.appendTo($tableHead);
        $tableHead.appendTo($table);
        $tableBody.appendTo($table);
        //: add second table data:
        this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.forEach((_alert)=>{
            if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(_alert.ParameterId) >= 0) return false; // do not add row as it's deemed to be a buoy specific one!
            let $currentRow = null;
            $currentRow = $('<tr>').appendTo($tableBody);
            $currentRow.data('alertData', _alert);
            // add cells:
            $('<td></td>').attr("data-field", "StationId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "SensorId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "ParameterId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "MinValue").addClass('text-center').appendTo($currentRow);
            $('<td></td>').attr("data-field", "MaxValue").addClass('text-center').appendTo($currentRow);
            $('<td></td>').attr("data-field", "EmailRecipients").appendTo($currentRow);
            $('<td></td>').attr("data-field", "Active").addClass('text-center').appendTo($currentRow);
            this.setRowValuesParameterAlert($currentRow, _alert);
            let editButtonCell = $('<td class="edit_user_button_cell"></td>').appendTo($currentRow);
            let deleteButtonCell = $('<td class="delete_user_button_cell"></td>').appendTo($currentRow);
            $('<a class= "midi_common_link">Delete Alert</a>').click(()=>{
                this.deleteParameterAlert(_alert, $currentRow);
            }).appendTo(deleteButtonCell);
            $('<a class= "midi_common_link">Edit Alert</a>').click(()=>{
                this.renderModalParameterAlert($currentRow);
            }).appendTo(editButtonCell);
        });
        this.setNoRowsMessage($tableBody, 9, false);
        this.container.find('[data-toggle="tooltip"]').tooltip();
        this.loadingContainer.hide();
    }
    renderModal(wbtl = null, alert1 = null) {
        const { Stations: Stations } = this.mainSite.staticDataManager.Schema.ParameterSchema;
        const addNew = wbtl == null;
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) $('<h4 class="modal-title">Add New Wave Buoy Alert</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit Wave Buoy Alert</h4>').appendTo(modalHeaderContent);
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        // the containers 
        const stationDropdownContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">Station & Sensor:</span>').appendTo(stationDropdownContainer);
        const emailRecipientContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<div style="margin-top: 5px;"><em>Separate email addresses by semi-colons</em></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(emailRecipientContainer);
        const targetLatitudeContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">Target Latitude:</span>').appendTo(targetLatitudeContainer);
        const targetLongitudeContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">Target Longitude:</span>').appendTo(targetLongitudeContainer);
        const maxExcursionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">Max Excursion (m):</span>').appendTo(maxExcursionContainer);
        const activeContainer = $('<div class="input-group midi_ManageUsersPage_input_container">De-activated (do not send emails):&nbsp;</div>').appendTo(this.modalBodyContent);
        // the inputs
        this.emailRecipientInput = $('<textarea class="form-control" placeholder="Email Recipients">').appendTo(emailRecipientContainer);
        this.targetLatitudeInput = $('<input class="form-control" placeholder="DD.ddd" type="number">').appendTo(targetLatitudeContainer);
        this.targetLongitudeInput = $('<input class="form-control" placeholder="DDD.ddd" type="number">').appendTo(targetLongitudeContainer);
        this.maxExcursionInput = $('<input class="form-control" placeholder="" type="number">').appendTo(maxExcursionContainer);
        this.activeInput = $('<input placeholder="" type="checkbox">').appendTo(activeContainer);
        if (addNew) {
            this.selectStationDropdown = $('<select class="form-control"></select>').appendTo(stationDropdownContainer);
            for(let stationId in Stations){
                const station = Stations[stationId];
                for(let sensorId in station.Sensors){
                    // don't allow add for an existing alert
                    if (this.mainSite.staticDataManager.Schema.WaveBuoyTargetLocations.some((x)=>x.StationId == stationId && x.SensorId == sensorId)) continue;
                    const sensor = station.Sensors[sensorId];
                    if ("Buoy_Latitude/deg" in sensor.Parameters) this.selectStationDropdown.append('<option value="' + stationId + "," + sensorId + '">' + station.Station.Label + " - " + sensorId + '</option>');
                }
            }
        } else {
            $('<input readonly type="text" class="form-control">').val(Stations[wbtl.StationId].Station.Label + " - " + wbtl.SensorId).appendTo(stationDropdownContainer);
            this.emailRecipientInput.val(alert1.EmailRecipients.join(";"));
            this.targetLatitudeInput.val(wbtl.Latitude.toString());
            this.targetLongitudeInput.val(wbtl.Longitude.toString());
            this.maxExcursionInput.val(alert1.MaxValue.toString());
            if (!alert1.Active) this.activeInput.attr('checked', 'checked');
        }
        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);
        $('<button type="button" class="btn btn-success">Submit</button>').appendTo(modalFooterContent).click(()=>{
            let stationId, sensorId = null;
            const errors = [];
            if (addNew) {
                const stationVal = this.selectStationDropdown.val();
                if (!stationVal) {
                    errors.push("Station and sensor must be chosen");
                    this.selectStationDropdown.addClass("midi_common_validation_warning");
                } else {
                    const split = stationVal.split(",");
                    stationId = split[0];
                    sensorId = split[1];
                }
            } else {
                stationId = wbtl.StationId;
                sensorId = wbtl.SensorId;
            }
            const emailRecipientsSplit = this.emailRecipientInput.val().split(";").map((x)=>x.trim());
            const latitude = parseFloat(this.targetLatitudeInput.val());
            const longitude = parseFloat(this.targetLongitudeInput.val());
            const excursion = parseFloat(this.maxExcursionInput.val());
            const req = {
                StationId: stationId,
                SensorId: sensorId,
                Active: !this.activeInput.is(':checked'),
                Latitude: latitude,
                Longitude: longitude,
                EmailRecipients: emailRecipientsSplit,
                MaxExcursion: excursion
            };
            // clear previous validation errors
            $('.midi_common_validation_warning', this.modalContent).removeClass('midi_common_validation_warning');
            if (isNaN(req.Latitude) || req.Latitude > 90 || req.Latitude < -90) {
                errors.push("Latitude must be valid");
                this.targetLatitudeInput.addClass("midi_common_validation_warning");
            }
            if (isNaN(req.Longitude) || req.Longitude > 180 || req.Longitude < -180) {
                errors.push("Longitude must be valid");
                this.targetLongitudeInput.addClass("midi_common_validation_warning");
            }
            if (isNaN(req.MaxExcursion) || req.MaxExcursion < 0) {
                errors.push("Excursion must be valid");
                this.maxExcursionInput.addClass("midi_common_validation_warning");
            }
            if (req.EmailRecipients.some((x)=>!this.validateEmailAddresses(x))) {
                errors.push("Enter valid email addresses separated by semi-colons");
                this.emailRecipientInput.addClass("midi_common_validation_warning");
            }
            this.resetErrorText(errors);
            if (errors.length > 0) return;
            (0, $dae7e779a0d50afe$export$2b4a358acbf56374)(req, (err)=>{
                if (err) {
                    errors.push("Server error: " + err.Message);
                    this.resetErrorText(errors);
                }
                this.modal.modal('hide');
                this.refresh();
            });
        });
        this.modal.modal('show');
    }
    renderDeleteModal(wbtl) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        this.modal = $('<div id="myModal" class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        $('<h4 class="modal-title">Confirm Delete</h4>').appendTo(modalHeaderContent);
        var modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        $('<p>Are you sure you want to delete this wave buoy alert from the system?<p>').appendTo(modalBodyContent);
        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>').appendTo(modalFooterContent);
        $('<button type="button" class="btn btn-success">Delete</button>').click(()=>{
            this.resetErrorText([]);
            (0, $dae7e779a0d50afe$export$bb18587c791cc170)(wbtl.StationId, wbtl.SensorId, (err)=>{
                if (err) this.resetErrorText([
                    "Server error: " + err.Message
                ]);
                this.modal.modal('hide');
                this.refresh();
            });
        }).appendTo(modalFooterContent);
        this.modal.modal('show');
    }
    setNoRowsMessage($tableBody, colsCount = 9, isWaveBuoy = true) {
        $tableBody.find('tr.no-rows-message-row').remove();
        if ($tableBody.find('tr:not(.no-rows-message-row)').length == 0) {
            let $row = $('<tr>').addClass('no-rows-message-row').appendTo($tableBody);
            let txt = isWaveBuoy ? 'There are no Wave Buoy Alerts yet.<br>Use the button above to add a new Wave Buoy Alert.' : 'There are no Parameter Alerts yet.<br>Use the button above to add a new Parameter Alert.';
            $(`<td colspan="${colsCount}" class="text-center text-muted"><div style="margin:40px 0;"><i class="fa fa-lg fa-info-circle"></i> ${txt}</div></td>`).appendTo($row);
        }
    }
    /**
     * "Normal" Parameter Alerts: set the contents of the cells in the table..
     * @param $row
     * @param _alert
     */ setRowValuesParameterAlert($row, _alert) {
        let names = this.getAlertNames(_alert);
        $row.find('td[data-field="StationId"]').text(names.station);
        $row.find('td[data-field="SensorId"]').text(names.sensor);
        $row.find('td[data-field="ParameterId"]').text(names.parameter);
        $row.find('td[data-field="MinValue"]').text(_alert.MinValue == null ? '' : _alert.MinValue);
        $row.find('td[data-field="MaxValue"]').text(_alert.MaxValue == null ? '' : _alert.MaxValue);
        $row.find('td[data-field="EmailRecipients"]').text(_alert.EmailRecipients.join(", "));
        $row.find('td[data-field="Active"]').html(_alert.Active ? '<i class="fa fa-fw fa-check"></i>' : '<i class="fa fa-fw fa-times"></i>');
    }
    renderModalParameterAlert(tableRow = null) {
        const _alert = tableRow == null ? null : tableRow.data('alertData');
        const StationsByRegion = this.mainSite.getStationsByRegions(true);
        const addNew = _alert == null;
        let modalDataClone = _alert !== null ? {
            ..._alert
        } : {
            StationId: '',
            SensorId: '',
            ParameterId: '',
            Active: true,
            EmailRecipients: [],
            MaxValue: null,
            MinValue: null
        }; //: use a clone or new object to help update data
        // console.info("EDIT PARAM ALERT", { alert: _alert, $row: tableRow });
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        let _page = this;
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        let modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        let modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        //: Modal Header:
        let modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) $('<h4 class="modal-title">Add New Parameter Alert</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit Parameter Alert</h4>').appendTo(modalHeaderContent);
        //: Modal Content:
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        let modalFeedbackWrap = $('<div class="modal-feedback"></div>').appendTo(this.modalBodyContent);
        //: Form wrapper:
        let modalForm = $('<form></form>').appendTo(this.modalBodyContent);
        modalForm.addClass("form-horizontal");
        modalForm.on("submit", (e)=>{
            return false;
        });
        //: Field: StationId
        const stationRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const stationLbl = $('<label class="col-sm-3 control-label">Station:</label>').appendTo(stationRow);
        const stationCol = $('<div class="col-sm-9"></div>').appendTo(stationRow);
        this.modalFieldStationId = $('<select class="form-control"></select>').appendTo(stationCol);
        if (addNew) this.modalFieldStationId.append('<option value="" selected="selected" disabled>Please select a Station...</option>');
        StationsByRegion.forEach((region)=>{
            let $optgroup = $('<optgroup></optgroup>').attr("label", region.Region.Label);
            region.Stations.forEach((station)=>{
                let $opt = $('<option value="' + station.Id + '">' + station.Label + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.StationId == station.Id) $opt.prop("selected", true);
                $opt.appendTo($optgroup);
            });
            $optgroup.appendTo(this.modalFieldStationId);
        });
        this.modalFieldStationId.on("change", (e)=>{
            const _stationId = $(e.target).val();
            modalDataClone.StationId = _stationId;
            let _sensors = {};
            if (_stationId && _stationId !== null && _stationId !== '') _sensors = _page.mainSite.getStationSensors(_stationId);
            this.modalFieldSensor.find('option').remove();
            let count = 0;
            for(let sensorId in _sensors){
                let $opt = $('<option value="' + sensorId + '">' + sensorId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.SensorId == sensorId) $opt.prop("selected", true);
                $opt.appendTo(this.modalFieldSensor);
                count++;
            }
            if (count == 0 || modalDataClone.SensorId == '') {
                let $opt = $('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
                $opt.prependTo(this.modalFieldSensor);
            }
            //: Trigger change on Sensor field to ensure that the list of Param Groups gets populated:
            this.modalFieldSensor.trigger("change");
        });
        //: Field: Sensor
        const sensorRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const sensorLbl = $('<label class="col-sm-3 control-label">Sensor:</label>').appendTo(sensorRow);
        const sensorCol = $('<div class="col-sm-9"></div>').appendTo(sensorRow);
        this.modalFieldSensor = $('<select class="form-control"></select>').appendTo(sensorCol);
        if (addNew) this.modalFieldSensor.append('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
        //: trigger onchange of station to populate list of sensors:
        this.modalFieldStationId.trigger("change");
        this.modalFieldSensor.on("change", (e)=>{
            const _sensorId = $(e.target).val();
            modalDataClone.SensorId = _sensorId;
            let _paramGroups = [];
            let _params = {};
            if (_sensorId && _sensorId !== null && _sensorId !== '') {
                _paramGroups = _page.mainSite.getStationParameterGroups(modalDataClone.StationId, modalDataClone.SensorId);
                _params = _page.mainSite.getStationSensorParameters(modalDataClone.StationId, modalDataClone.SensorId);
            }
            this.modalFieldParameterGroup.find('option').remove();
            let count = 0;
            for(let paramId in _params){
                let pi = _params[paramId];
                let pv = pi.Variants[0]; //: NB: this assumes always the first variant is set (which is expected)!!  TODO: check this is right with Ben!!
                let $opt = $('<option value="' + paramId + '">' + paramId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.ParameterId == paramId) $opt.prop("selected", true);
                if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(paramId) >= 0) {
                    $opt.prop("disabled", true);
                    $opt.text(`${paramId} [DISABLED - Use Buoy Alerts instead]`);
                }
                $opt.appendTo(this.modalFieldParameterGroup);
                count++;
            }
            if (count == 0 || modalDataClone.ParameterId == '') {
                let $opt = $('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter...</option>');
                $opt.prependTo(this.modalFieldParameterGroup);
            }
        });
        //: Field: ParamterGroup
        const pgRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const pgLbl = $('<label class="col-sm-3 control-label">Parameter:</label>').appendTo(pgRow);
        const pgCol = $('<div class="col-sm-9"></div>').appendTo(pgRow);
        this.modalFieldParameterGroup = $('<select class="form-control"></select>').appendTo(pgCol);
        if (addNew) this.modalFieldParameterGroup.append('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
        //: trigger onchange of sensor to populate list of param groups:
        this.modalFieldSensor.trigger("change");
        this.modalFieldParameterGroup.on("change", (e)=>{
            const _parameterGroup = $(e.target).val();
            modalDataClone.ParameterId = _parameterGroup;
        });
        //: other field groups:
        let $row = null;
        let $lbl = null;
        let $col = null;
        let $hlp = null; //: helper which is intended for typing, not re-usable elements..
        //: .Active
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label"></label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        $hlp = $('<label></label>').appendTo($('<div class="checkbox"></div>').appendTo($col));
        const $inputActive = $('<input type="checkbox" />').appendTo($hlp);
        $('<span>Active <em class="text-muted">(send emails if limits are reached)</em></span>').disableSelection().appendTo($hlp);
        $inputActive.prop("checked", modalDataClone.Active).on("change", (e)=>{
            modalDataClone.Active = $(e.target).is(':checked');
        });
        //: .Title (optional)
        /*
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Title:</label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        const $inputTitle: JQuery = $('<input type="text" class="form-control" placeholder="Title (optional)" />').appendTo($col);
        $inputTitle.val(modalDataClone.Title);
        */ //: .EmailRecipients
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Recipients:</label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        const $inputEmailRecipients = $('<textarea type="text" class="form-control" placeholder="Email recipients (separated by semi-colon)"></textarea>').appendTo($col);
        $('<span class="help-block"><em>Separate email addresses by semi-colons</em></span>').disableSelection().appendTo($col);
        $inputEmailRecipients.val(modalDataClone.EmailRecipients ? modalDataClone.EmailRecipients.join(";") : '').on("change", (e)=>{
            modalDataClone.EmailRecipients = $(e.target).val().split(";").map((x)=>x.trim());
        });
        //: Thresholds (.MinValue & .MaxValue)
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Limits:</label>').appendTo($row);
        $col = $('<div class="col-sm-4"></div>').appendTo($row);
        $hlp = $('<div>').addClass('input-group').appendTo($col);
        $('<span class="input-group-addon">Min:</span>').appendTo($hlp);
        const $inputMinValue = $('<input type="text" class="form-control" placeholder="Min" />').appendTo($hlp);
        $col = $('<div class="col-sm-4 col-sm-offset-1"></div>').appendTo($row);
        $hlp = $('<div>').addClass('input-group').appendTo($col);
        $('<span class="input-group-addon">Max:</span>').appendTo($hlp);
        const $inputMaxValue = $('<input type="text" class="form-control" placeholder="Max" />').appendTo($hlp);
        $inputMinValue.val(modalDataClone.MinValue == null ? '' : modalDataClone.MinValue.toString()).on("change", (e)=>{
            let _val = parseFloat($(e.target).val());
            if (isNaN(_val)) _val = null;
            modalDataClone.MinValue = _val;
        });
        $inputMaxValue.val(modalDataClone.MaxValue == null ? '' : modalDataClone.MaxValue.toString()).on("change", (e)=>{
            let _val = parseFloat($(e.target).val());
            if (isNaN(_val)) _val = null;
            modalDataClone.MaxValue = _val;
        });
        //: prevent PrimaryKey changes in case we're in edit mode:
        if (!addNew) {
            this.modalFieldStationId.prop("disabled", true);
            this.modalFieldSensor.prop("disabled", true);
            this.modalFieldParameterGroup.prop("disabled", true);
        }
        //: additional event handlers:
        modalForm.find(':input').on('change', (e)=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            modalForm.addClass('data-changed');
            window.onbeforeunload = ()=>{
                return "You have unsaved modifications on this page. If you navigate away from the page, your modifications will not be saved.";
            };
        });
        //: Footer:
        let modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-success">Save</button>').appendTo(modalFooterContent).click(()=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            let errors = [];
            //: validations:
            if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                errors.push("Please select a Station.");
                this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.SensorId == '' || modalDataClone.SensorId == null) {
                errors.push("Please select a Sensor.");
                this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.ParameterId == '' || modalDataClone.ParameterId == null) {
                errors.push("Please select a Parameter.");
                this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            } else if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(modalDataClone.ParameterId) >= 0) {
                errors.push("The selected Parameter is intended for Wave Buoys. Please use specific Wave Buoy Alerts instead of normal Parameter Alerts for this.");
                this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.Active == true && modalDataClone.MinValue == null && modalDataClone.MaxValue == null) {
                errors.push("Please provide at least one limit to use for this alert.");
                $inputMinValue.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                $inputMaxValue.addClass('midi_common_validation_warning');
            }
            let _emailErrors = [];
            let _emailsCount = 0;
            modalDataClone.EmailRecipients.forEach((email)=>{
                let valid = this.validateEmailAddresses(email);
                if (!valid) _emailErrors.push(email);
                else _emailsCount++;
            });
            if (_emailErrors.length > 0 || _emailsCount == 0) {
                errors.push("Please check that email recipients are all valid email addresses, and that there is at least one email provided.");
                $inputEmailRecipients.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (errors.length > 0) {
                modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                return false;
            }
            if (errors.length == 0) (0, $dae7e779a0d50afe$export$4dddbe59d264921d)(modalDataClone, (err)=>{
                if (err) {
                    errors.push("Server error: " + err.Message);
                    modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                } else {
                    modalForm.removeClass('data-changed');
                    this.modal.modal('hide');
                    if (addNew) this.refresh();
                    else {
                        tableRow.data('alertData', modalDataClone);
                        this.setRowValuesParameterAlert(tableRow, modalDataClone);
                        tableRow.addClass("bg-success");
                        setTimeout(()=>{
                            tableRow.removeClass("bg-success");
                        }, 3000);
                    }
                }
            });
        });
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);
        if (!addNew) $('<button type="button" class="btn btn-danger pull-left">Delete this Parameter Alert</button>').prependTo(modalFooterContent).click(()=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            this.deleteParameterAlert(modalDataClone, tableRow);
        });
        this.modal.modal('show');
        this.modal.on('hide.bs.modal', (e)=>{
            if (modalForm.hasClass('data-changed')) {
                let conf = confirm("You have unsaved changes on this popup.\n\nAre you sure you wish to cancel and close the popup?");
                if (!conf) return false;
            }
        });
        this.modal.on('hidden.bs.modal', (e)=>{
            this.modal.remove();
            this.modal = null;
            window.onbeforeunload = null;
        });
    }
    /**
     * This method will prompt the user (via browser prompt rather than modal, as this could be triggered from within the modal) to delete the given Alert.
     * @param _alert The Alert data in full to delete.
     * @param $row The table row to remove upon successful deletion (to prevent full refresh).
     */ deleteParameterAlert(_alert, $row) {
        let names = this.getAlertNames(_alert);
        // console.info("DELETE PARAM ALERT", { alert: _alert, $row: $row });
        let conf = confirm(`Are you certain you wish to permanently delete the Alert for ${names.station} / ${names.sensor} / ${names.parameter}?`);
        if (conf) (0, $dae7e779a0d50afe$export$d31c2575813e5515)(_alert, (err)=>{
            if (err) alert(`Error while trying to delete the Alert: ${err.Message}`);
            else {
                let $tbody = $row.closest('tbody');
                $row.data('alertData', null);
                $row.remove();
                this.setNoRowsMessage($tbody, 9, false);
                try {
                    if (this.modal) this.modal.modal('hide');
                } catch (_err) {
                    console.info('Unable to hide modal, most likely because it does not exist.');
                }
            }
        });
    }
    /**
     * A helper function to try retrieving display names for Station, Sensor & Parameter for a give Alert.
     * @param _alert
     */ getAlertNames(_alert) {
        let _out = {
            station: _alert.StationId,
            sensor: _alert.SensorId,
            parameter: _alert.ParameterId
        };
        try {
            _out.station = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[_alert.StationId].Station.Label;
        } catch (_err) {
        // no error or action as this is not very important.
        }
        try {
            _out.sensor = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[_alert.StationId].Sensors[_alert.SensorId].SensorDefinition.DisplayName;
            if (!_out.sensor) _out.sensor = _alert.SensorId;
        } catch (_err) {
        // no error or action as this is not very important.
        }
        return _out;
    }
    resetErrorText(errors) {
        if (this.validationErrorText) this.validationErrorText.remove();
        if (errors.length > 0) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"></div>').appendTo(this.modalBodyContent);
            errors.forEach((err)=>{
                this.validationErrorText.append('<p><i class="fa fa-exclamation-triangle"></i>&nbsp;' + err + '</p>');
            });
        }
    }
    validateEmailAddresses(email) {
        //currently allows up to xx@icon.software (NB {2,8} length for the .something part
        var validEmailFormatRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,8}(?:\.[a-z]{2})?)$/i;
        return validEmailFormatRegex.test(email);
    }
}



var $bf4b50e428f0d3b0$var$BASE_URL = '/api/ParameterGroupSettings';
function $bf4b50e428f0d3b0$export$7ff5d94120caa6d(callback) {
    $.ajax($bf4b50e428f0d3b0$var$BASE_URL + '/Get/All', {
        cache: false,
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $bf4b50e428f0d3b0$export$e376a20d05b7288b(req, callback) {
    $.ajax($bf4b50e428f0d3b0$var$BASE_URL + '/Set', {
        cache: false,
        type: 'POST',
        data: req,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}
function $bf4b50e428f0d3b0$export$edf3092f7c666b2e(stationId, sensorId, parameterGroupId, callback) {
    $.ajax($bf4b50e428f0d3b0$var$BASE_URL + '/Delete', {
        cache: false,
        type: 'POST',
        data: {
            "StationId": stationId,
            "Sensor": sensorId,
            "ParameterGroup": parameterGroupId
        },
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR));
        }
    });
}


class $2c06be4c877f41e8$export$7cb8074de2a08079 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'manageParameterGroupsSettings';
        this.hasLiveData = false;
        this.container = null;
        this.loadingContainer = null;
        this.table = null;
        this.tableBody = null;
        this.tableHead = null;
        this.tableHeadRow = null;
        this.modal = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.refresh();
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    refresh() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container"></div>').appendTo('body');
        this.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(this.container);
        /*
        this.mainSite.staticDataManager.getStaticData((err) => {
            this.data = this.mainSite.staticDataManager.Schema.ParameterGroupSettings;
            if (this.mainSite.liveDataManager.latestData == null) {
                this.mainSite.liveDataManager.addListener(this);
            } else {
                this.hasLiveData = true;
                this.render();
            }
        });
        */ (0, $bf4b50e428f0d3b0$export$7ff5d94120caa6d)((err, data)=>{
            if (err) this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Uable to get list of settings from server: ' + err.Message);
            else this.loadingContainer.removeClass('alert-danger').addClass('alert-info').html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...');
            this.data = data;
            if (this.mainSite.liveDataManager.latestData == null) this.mainSite.liveDataManager.addListener(this);
            else {
                this.hasLiveData = true;
                this.render();
            }
        });
    }
    liveDataChanged(latestData) {
        if (!this.hasLiveData && latestData !== null) {
            this.hasLiveData = true;
            this.render();
        }
    }
    render() {
        /* //: NB: container is being rendered in this.refresh(), to allow adding a loading indicator, as it can take a few seconds for the api/Schema/Get request to complete, and we're also waiting for LiveData to be updated with initial data.
        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body');
        */ $('<h1 class="midi_manageUsersPage_title">Manage Parameter Groups Settings</h1>').appendTo(this.container);
        $('<button type="button" class="btn btn-success midi_manageUsersPage_createUserButton"><i class="fa fa-plus"></i> Add Settings</button>').appendTo(this.container).click(()=>{
            this.renderModalEdit(null);
        });
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you can  manage Parameter Group Settings across all regions.</p>').appendTo(this.container);
        else {
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you can manage Parameter Group Settings for sites within your region.</p>').appendTo(this.container);
        }
        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Station</th> <th>Sensor</th> <th>Parameter Group</th> <th class="text-center">Masked</th>').appendTo(this.tableHeadRow);
        let _page = this;
        this.data.forEach((x)=>{
            var tableCurrentRow = $('<tr></tr>').appendTo(_page.tableBody);
            tableCurrentRow.data('paramGroupSettings', x);
            $('<td></td>').attr("data-field", "StationId").text(_page.mainSite.staticDataManager.Schema.ParameterSchema.Stations[x.StationId].Station.Label).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "Sensor").text(x.Sensor).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "ParameterGroup").text(x.ParameterGroup).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "Masked").addClass('text-center').html(x.Masked ? '<i class="fa fa-lg fa-fw fa-check"></i>' : '<i class="fa fa-lg fa-fw fa-times"></i>').appendTo(tableCurrentRow);
            tableCurrentRow.css({
                'cursor': 'pointer'
            }).on("click", (e)=>{
                _page.renderModalEdit(tableCurrentRow);
            });
        });
        this.setNoRowsMessage(this.tableBody, 4);
        $('[data-toggle="tooltip"]').tooltip();
        this.loadingContainer.hide();
    }
    setNoRowsMessage($tableBody, colsCount = 4) {
        $tableBody.find('tr.no-rows-message-row').remove();
        if ($tableBody.find('tr:not(.no-rows-message-row)').length == 0) {
            let $row = $('<tr>').addClass('no-rows-message-row').appendTo($tableBody);
            $(`<td colspan="${colsCount}" class="text-center text-muted"><div style="margin:40px 0;"><i class="fa fa-lg fa-info-circle"></i> There are no Parameter Group Settings yet.<br>Use the button above to add new Parameter Group Settings.</div></td>`).appendTo($row);
        }
    }
    renderModalEdit(tableRow = null) {
        const currentSetting = tableRow == null ? null : tableRow.data('paramGroupSettings');
        const StationsByRegion = this.mainSite.getStationsByRegions();
        const addNew = currentSetting == null;
        let modalDataClone = currentSetting !== null ? {
            ...currentSetting
        } : {
            StationId: '',
            Sensor: '',
            ParameterGroup: '',
            Masked: false
        }; //: use a clone or new object to help update data
        // console.log("renderModalEdit()", { new: addNew, currentSetting: currentSetting, row: tableRow, stations: StationsByRegion, schema: this.mainSite.staticDataManager.Schema });
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        let _page = this;
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        let modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        let modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        //: Modal Header:
        let modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) $('<h4 class="modal-title">Add Parameter Group Settings</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit Parameter Group Settings</h4>').appendTo(modalHeaderContent);
        //: Modal Content:
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        let modalFeedbackWrap = $('<div class="modal-feedback"></div>').appendTo(this.modalBodyContent);
        //: Form wrapper:
        let modalForm = $('<form></form>').appendTo(this.modalBodyContent);
        modalForm.addClass("form-horizontal");
        modalForm.on("submit", (e)=>{
            return false;
        });
        //: Field: StationId
        const stationRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const stationLbl = $('<label class="col-sm-3 control-label">Station:</label>').appendTo(stationRow);
        const stationCol = $('<div class="col-sm-9"></div>').appendTo(stationRow);
        this.modalFieldStationId = $('<select class="form-control"></select>').appendTo(stationCol);
        if (addNew) this.modalFieldStationId.append('<option value="" selected="selected" disabled>Please select a Station...</option>');
        StationsByRegion.forEach((region)=>{
            let $optgroup = $('<optgroup></optgroup>').attr("label", region.Region.Label);
            region.Stations.forEach((station)=>{
                let $opt = $('<option value="' + station.Id + '">' + station.Label + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.StationId == station.Id) $opt.prop("selected", true);
                $opt.appendTo($optgroup);
            });
            $optgroup.appendTo(this.modalFieldStationId);
        });
        this.modalFieldStationId.on("change", (e)=>{
            const _stationId = $(e.target).val();
            modalDataClone.StationId = _stationId;
            let _sensors = {};
            if (_stationId && _stationId !== null && _stationId !== '') _sensors = _page.mainSite.getStationSensors(_stationId);
            // console.info("changed STATION: ", { id: _stationId, sensors: _sensors, paramgroups: null, modalData: modalDataClone, modalDataOriginal: currentSetting });
            this.modalFieldSensor.find('option').remove();
            let count = 0;
            for(let sensorId in _sensors){
                let $opt = $('<option value="' + sensorId + '">' + sensorId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.Sensor == sensorId) $opt.prop("selected", true);
                $opt.appendTo(this.modalFieldSensor);
                count++;
            }
            if (count == 0 || modalDataClone.Sensor == '') {
                let $opt = $('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
                $opt.prependTo(this.modalFieldSensor);
            }
            //: Trigger change on Sensor field to ensure that the list of Param Groups gets populated:
            this.modalFieldSensor.trigger("change");
        });
        //: Field: Sensor
        const sensorRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const sensorLbl = $('<label class="col-sm-3 control-label">Sensor:</label>').appendTo(sensorRow);
        const sensorCol = $('<div class="col-sm-9"></div>').appendTo(sensorRow);
        this.modalFieldSensor = $('<select class="form-control"></select>').appendTo(sensorCol);
        if (addNew) this.modalFieldSensor.append('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
        //: trigger onchange of station to populate list of sensors:
        this.modalFieldStationId.trigger("change");
        this.modalFieldSensor.on("change", (e)=>{
            const _sensorId = $(e.target).val();
            modalDataClone.Sensor = _sensorId;
            let _paramGroups = [];
            if (_sensorId && _sensorId !== null && _sensorId !== '') _paramGroups = _page.mainSite.getStationParameterGroups(modalDataClone.StationId, modalDataClone.Sensor);
            // console.info("changed SENSOR: ", { id: _sensorId, sensors: null, paramgroups: _paramGroups, modalData: modalDataClone, modalDataOriginal: currentSetting });
            this.modalFieldParameterGroup.find('option').remove();
            let count = 0;
            for(let i in _paramGroups){
                const paramGroup = _paramGroups[i];
                let $opt = $('<option value="' + paramGroup + '">' + paramGroup + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.ParameterGroup == paramGroup) $opt.prop("selected", true);
                $opt.appendTo(this.modalFieldParameterGroup);
                count++;
            }
            if (count == 0 || modalDataClone.ParameterGroup == '') {
                let $opt = $('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
                $opt.prependTo(this.modalFieldParameterGroup);
            }
        });
        //: Field: ParamterGroup
        const pgRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const pgLbl = $('<label class="col-sm-3 control-label">Parameter Group:</label>').appendTo(pgRow);
        const pgCol = $('<div class="col-sm-9"></div>').appendTo(pgRow);
        this.modalFieldParameterGroup = $('<select class="form-control"></select>').appendTo(pgCol);
        if (addNew) this.modalFieldParameterGroup.append('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
        //: trigger onchange of sensor to populate list of param groups:
        this.modalFieldSensor.trigger("change");
        this.modalFieldParameterGroup.on("change", (e)=>{
            const _parameterGroup = $(e.target).val();
            modalDataClone.ParameterGroup = _parameterGroup;
        });
        //: Field(s): Settings:
        const settingsRow = $('<div class="form-group"></div>').appendTo(modalForm);
        const settingsLbl = $('<label class="col-sm-3 control-label">Settings:</label>').appendTo(settingsRow);
        const settingsCol = $('<div class="col-sm-9"></div>').appendTo(settingsRow);
        const settingMaskedWrap = $('<label></label>').appendTo($('<div class="checkbox"></div>').appendTo(settingsCol));
        this.modalFieldMasked = $('<input type="checkbox" />').appendTo(settingMaskedWrap);
        $('<span>Masked</span>').disableSelection().appendTo(settingMaskedWrap);
        this.modalFieldMasked.prop("checked", modalDataClone.Masked);
        // this.modalFieldMasked.on("change", (e) => { //: moved to being set in sumbit action..
        //     const _val: boolean = $(e.target).is(":checked");
        //     modalDataClone.Masked = _val;
        // });
        //: prevent PrimaryKey changes in case we're in edit mode:
        if (!addNew) {
            this.modalFieldStationId.prop("disabled", true);
            this.modalFieldSensor.prop("disabled", true);
            this.modalFieldParameterGroup.prop("disabled", true);
        }
        //: additional event handlers:
        modalForm.find(':input').on('change', (e)=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            modalForm.addClass('data-changed');
            window.onbeforeunload = ()=>{
                return "You have unsaved modifications on this page. If you navigate away from the page, your modifications will not be saved.";
            };
        });
        //: Footer:
        let modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success">Save</button>').appendTo(modalFooterContent).click(()=>{
            // console.info("save...", { old: currentSetting, new: modalDataClone });
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            let errors = [];
            //: validations:
            if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                errors.push("Please select a Station.");
                this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.Sensor == '' || modalDataClone.Sensor == null) {
                errors.push("Please select a Sensor.");
                this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.ParameterGroup == '' || modalDataClone.ParameterGroup == null) {
                errors.push("Please select a Parameter Group.");
                this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            //: ensure we have values from the modal form:
            modalDataClone.Masked = this.modalFieldMasked.is(":checked");
            if (errors.length > 0) {
                modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                return false;
            }
            if (errors.length == 0) {
                const req = modalDataClone;
                (0, $bf4b50e428f0d3b0$export$e376a20d05b7288b)(req, (err)=>{
                    if (err) {
                        errors.push("Server error: " + err.Message);
                        modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                    }
                    modalForm.removeClass('data-changed');
                    this.modal.modal('hide');
                    if (addNew) this.refresh();
                    else {
                        tableRow.data('paramGroupSettings', modalDataClone);
                        tableRow.find('td[data-field="Masked"]').html(modalDataClone.Masked ? '<i class="fa fa-lg fa-fw fa-check"></i>' : '<i class="fa fa-lg fa-fw fa-times"></i>');
                        tableRow.addClass("bg-success");
                        setTimeout(()=>{
                            tableRow.removeClass("bg-success");
                        }, 3000);
                    }
                });
            }
        });
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);
        if (!addNew) this.modalDeleteButton = $('<button type="button" class="btn btn-danger pull-left">Delete these settings</button>').prependTo(modalFooterContent).click(()=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            let errors = [];
            //: validations:
            if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                errors.push("Please select a Station.");
                this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.Sensor == '' || modalDataClone.Sensor == null) {
                errors.push("Please select a Sensor.");
                this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (modalDataClone.ParameterGroup == '' || modalDataClone.ParameterGroup == null) {
                errors.push("Please select a Parameter Group.");
                this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
            }
            if (errors.length > 0) {
                modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                return false;
            }
            if (errors.length == 0) {
                let stationName = this.modalFieldStationId.find('option[value="' + modalDataClone.StationId + '"]').text();
                let conf = confirm("Are you certain you wish to permanently delete the settings for " + stationName + " / " + modalDataClone.Sensor + " / " + modalDataClone.ParameterGroup + "?");
                if (conf) (0, $bf4b50e428f0d3b0$export$edf3092f7c666b2e)(modalDataClone.StationId, modalDataClone.Sensor, modalDataClone.ParameterGroup, (err)=>{
                    if (err) {
                        errors.push("Server error: " + err.Message);
                        modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                    }
                    modalForm.removeClass('data-changed');
                    this.modal.modal('hide');
                    // this.refresh();
                    tableRow.data('paramGroupSettings', null);
                    tableRow.remove();
                    this.setNoRowsMessage(this.tableBody, 4);
                });
            }
        });
        this.modal.modal('show');
        this.modal.on('hide.bs.modal', (e)=>{
            if (modalForm.hasClass('data-changed')) {
                let conf = confirm("You have unsaved changes on this popup.\n\nAre you sure you wish to cancel and close the popup?");
                if (!conf) return false;
            }
        });
        this.modal.on('hidden.bs.modal', (e)=>{
            this.modal.remove();
            this.modal = null;
            window.onbeforeunload = null;
        });
    }
}





class $f261ea049028d499$export$15590c1ff66dab4 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'manageUsers';
        this.container = null;
        this.modal = null;
        this.modalContent = null;
        this.modalSaveButton = null;
        this.newUserPermissionContainer = null;
        this.newUserPermissionInput = null;
        this.newUserRegionContainer = null;
        this.newUserRegionInput = null;
        this.table = null;
        this.tableBody = null;
        this.tableHead = null;
        this.tableHeadRow = null;
        this.$noPermissionsWarningContainer = null;
        this.$noPermissionsWarningCheckbox = null;
        this.userAccountSet = null;
        this.allPermissionGroups = [];
        this.newUserEmailInput = null;
        this.validationErrorText = null;
        this.pastExpiryWarningText = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.refresh();
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    getUserData(callback) {
        (0, $4b7cacdb38b8b78b$export$925a4945a6cd0f3e)((err, data)=>{
            if (!err) this.userAccountSet = data;
            callback();
        });
    }
    refresh() {
        this.getUserData(()=>{
            (0, $1d3f08d9fba35da9$export$4fa96983e3cd2c77)((pErr, allGroups)=>{
                if (!pErr) this.allPermissionGroups = allGroups.sort((obj1, obj2)=>{
                    if (obj1.GroupName.toLowerCase() > obj2.GroupName.toLowerCase()) return 1;
                    if (obj1.GroupName.toLowerCase() < obj2.GroupName.toLowerCase()) return -1;
                    return 0;
                });
                this.renderManageUsers();
            });
        });
    }
    compare(a, b) {
        if (a.email < b.email) return -1;
        if (a.email > b.email) return 1;
        return 0;
    }
    renderManageUsers() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container"></div>').appendTo('body');
        $('<h1 class="midi_manageUsersPage_title">Manage Users</h1>').appendTo(this.container);
        $('<button type="button" class="btn btn-success midi_manageUsersPage_createUserButton"><i class="fa fa-user-plus"></i> Pre-Approve Non-Shell User</button>').appendTo(this.container).click(()=>{
            this.renderModal(null, []);
        });
        var noneFound = $('<span class="empty-message">No users found.</span>');
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you have <strong>full control</strong> of all users within the system.</p>').appendTo(this.container);
            $('<input id="midi_ManageUsersPage-search-input" class="form-control" type="text" placeholder="Search users by email, type or region" />').on('keyup input', (e)=>{
                this.filterUsers($(e.target).val(), this.container, noneFound);
            }).appendTo(this.container);
        } else {
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you are able to pre-approve non-Shell users, or delete existing users, within your region.</p>').appendTo(this.container);
        }
        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Email</th> <th>Type</th> <th>Region</th> <th>Registration Status</th> <th>Account Expiry</th> <th></th> <th></th>').appendTo(this.tableHeadRow);
        noneFound.appendTo(this.container).hide();
        var userObjectArray = [];
        for(var userId in this.userAccountSet.UserAccounts){
            var user = this.userAccountSet.UserAccounts[userId];
            userObjectArray.push({
                email: user.Id,
                user: user
            });
        }
        userObjectArray.sort(this.compare);
        userObjectArray.forEach((userObj)=>{
            var user = userObj.user;
            if (this.mainSite.currentUser.Permissions.GlobalAdministrator) ;
            else if (this.mainSite.currentUser.Region !== user.Region) // Display nothing if the user is not in their region
            // This ensures that Admins will not see any Global Admins in the Manage Users page
            return;
            var tableCurrentRow = $('<tr></tr>').appendTo(this.tableBody);
            // write the user ID
            $('<td class="user_ID"></td>').text(user.Id).appendTo(tableCurrentRow);
            // Hard coded user types based on boolean permission settings
            var userType = 'Standard';
            if (user.Permissions.Administrator) userType = 'Administrator';
            if (user.Permissions.GlobalAdministrator) userType = 'Global Administrator';
            $('<td></td>').text(userType).appendTo(tableCurrentRow);
            // Write region, blank for Global Administrators
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[user.Region];
            $('<td></td>').text(region ? region.Label : '').appendTo(tableCurrentRow);
            // Hard coded registration statuses based on approved boolean
            $('<td></td>').text(user.EmailConfirmed ? 'Registered' : 'Pending Registration').appendTo(tableCurrentRow);
            var accountExpiry;
            if (user.ExpiryDate == 0) accountExpiry = "Account Never Expires";
            else accountExpiry = moment(user.ExpiryDate).format("DD/MM/YYYY");
            // write the account expiry
            $('<td></td>').text(accountExpiry).appendTo(tableCurrentRow);
            var deleteButtonCell = $('<td class="delete_user_button_cell" ></td>').appendTo(tableCurrentRow);
            var editButtonCell = $('<td class="edit_user_button_cell" ></td>').appendTo(tableCurrentRow);
            if (this.mainSite.currentUser.Id !== user.Id) {
                // global admins can delete anyone
                // regional admins can't delete other regional admins
                if (this.mainSite.currentUser.Permissions.GlobalAdministrator || !user.Permissions.Administrator) $('<a class= "midi_common_link" > Delete User </a>').click(()=>{
                    this.renderDeleteModal(user);
                }).appendTo(deleteButtonCell);
                // all admins are able to edit users which they can see
                $('<a class= "midi_common_link">Edit User</a>').click(()=>{
                    //get permissions groups for user before rendering modal
                    (0, $1d3f08d9fba35da9$export$65f9a167a0da0b67)(user.Id, (err, data)=>{
                        if (!err) {
                            var permissionGroupsForUser = data;
                            this.renderModal(user, permissionGroupsForUser);
                        }
                    });
                }).appendTo(editButtonCell);
            }
        });
    }
    renderModal(user, groupPermissionsForUser) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (!user) $('<h4 class="modal-title">Pre-approve Non-Shell User</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit User</h4>').appendTo(modalHeaderContent);
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        if (user) $('<p>Please remember that users <strong>will not</strong> be alerted to any modifications which you make.<p>').appendTo(this.modalBodyContent);
        else {
            $('<p>Please remember that users with an <strong>@shell.com</strong> email address are automatically pre-approved, and do not need to be created.<p>').appendTo(this.modalBodyContent);
            $('<p>This feature should only be used for pre-approving non-Shell users. Once pre-approved, they will be sent an <strong>automatically-generated email</strong> which will direct them to create an account on Shell ' + branding.siteName + '.<p>').appendTo(this.modalBodyContent);
            if (!this.mainSite.currentUser.Permissions.GlobalAdministrator) {
                var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
                $('<p>User will be pre-approved as a <strong>Standard</strong> user, in the <strong>' + region.Label + '</strong> region.</p>').appendTo(this.modalBodyContent);
            }
        }
        var newUserEmailContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>').appendTo(newUserEmailContainer);
        this.newUserEmailInput = $('<input type="text" class="form-control" placeholder="Email address" aria-describedby="basic-addon1">').appendTo(newUserEmailContainer);
        if (user) {
            this.newUserEmailInput.val(user.Id);
            this.newUserEmailInput.attr('active', 'false');
            this.newUserEmailInput.attr('readonly', 'readonly');
        }
        // START OF USER PERMISSIONS DROP-DOWN
        var updateUserPermissionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">User Type:</span>').appendTo(updateUserPermissionContainer);
        var updateUserPermissionInput = $('<select class="form-control"></select>').appendTo(updateUserPermissionContainer).change(()=>{
            if (updateUserPermissionInput.val() == 'Global Administrator') // hide the region picker box if we have selected Global Administrator permission
            updateUserRegionContainer.hide();
            else updateUserRegionContainer.show();
        });
        $('<option>Standard</option>').appendTo(updateUserPermissionInput);
        // only Global Administrators can create / promote Administrators
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            var administrator = $('<option>Administrator</option>').appendTo(updateUserPermissionInput);
            var globalAdministrator = $('<option>Global Administrator</option>').appendTo(updateUserPermissionInput);
            if (user && user.Permissions.GlobalAdministrator) globalAdministrator.attr('selected', 'selected');
            else if (user && user.Permissions.Administrator) administrator.attr('selected', 'selected');
        }
        // only Global Administrators can change permission
        if (!this.mainSite.currentUser.Permissions.GlobalAdministrator) updateUserPermissionContainer.hide();
        // START OF USER REGION DROP-DOWN
        var updateUserRegionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>').appendTo(this.modalBodyContent);
        $('<span class="input-group-addon" id="basic-addon1">User Management Region:</span>').appendTo(updateUserRegionContainer);
        var updateUserRegionInput = $('<select class="form-control"></select>').appendTo(updateUserRegionContainer);
        // only Global Administrators can change region
        if (!this.mainSite.currentUser.Permissions.GlobalAdministrator || user && user.Permissions.GlobalAdministrator) updateUserRegionContainer.hide();
        for(var regionId in this.mainSite.staticDataManager.Schema.RegionSet.Regions)((region)=>{
            if (this.mainSite.currentUser.Permissions.GlobalAdministrator || this.mainSite.currentUser.Region == region.Id) {
                var regionOption = $('<option value="' + region.Id + '">' + region.Label + '</option>').appendTo(updateUserRegionInput);
                if (user && user.Region === regionId) regionOption.attr('selected', 'selected');
            }
        })(this.mainSite.staticDataManager.Schema.RegionSet.Regions[regionId]);
        var noRegionOption = $('<option value="No Region">No Region</option>').appendTo(updateUserRegionInput);
        if (user && !user.Region) noRegionOption.attr('selected', 'selected');
        this.userExpiryDate = null;
        this.userAccountExpiryCheckbox = $('<div class="midi_ManageUsersPage_input_container midi_ManageUsersPage_input_container_checkbox checkbox"><label><input id="accountExpiryCheck" type="checkbox" value="">Account Never Expires</label></div>').appendTo(this.modalBodyContent).change(()=>{
            if ($("#accountExpiryCheck").prop('checked')) {
                this.userAccountExpiryContainer.hide();
                this.userExpiryDate = 0;
            } else this.userAccountExpiryContainer.show();
        });
        this.renderAccountDatePicker();
        //Group permissions section - START
        var permissionGroupContainer = $('<div class="input-group midi_ManageUsersPage_permissiongroups_container"></div>').appendTo(this.modalBodyContent);
        var permissionHeaderConatiner = $('<div class="midi_ManageUsersPage_permission_header_conatiner"><strong>Permission Groups assigned to  user:</strong></div>').appendTo(permissionGroupContainer);
        var assignToNewGroupButton = $('<button type="button" class="btn btn-default" > Assign to Group</button>').appendTo(permissionHeaderConatiner);
        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(permissionGroupContainer);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Group Name</th> <th>Permission</th><th></th>').appendTo(this.tableHeadRow);
        var noneFound = $('<span class="empty-message">No group permissions were assigned yet.</span>');
        noneFound.appendTo(permissionGroupContainer);
        this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);
        //: Hidden warning box with checkbox in case no permissions have been selected:
        this.$noPermissionsWarningContainer = $('<div class="alert alert-warning hidden" style="margin-top: 15px;"><p><strong>No Permission Groups were assigned to this User.</strong> This will cause the User not to be able to select Regions or Stations when they log in.<p><p>Are you sure you wish to proceed?</p></div>');
        this.$noPermissionsWarningCheckbox = $('<input type="checkbox">');
        this.$noPermissionsWarningContainer.append($('<p></p>').append($('<label> <span>Yes, proceed without assigning any Permission Groups to this User</span></label>').prepend(this.$noPermissionsWarningCheckbox)));
        assignToNewGroupButton.click(()=>{
            this.$noPermissionsWarningContainer.addClass('hidden');
            this.$noPermissionsWarningCheckbox.prop('checked', false);
            var addNewRow = $('<tr><td></td><td></td></tr>').appendTo(this.tableBody);
            //permission group picker
            var permissionSelector = $('<td></td>').prependTo(addNewRow);
            var dropDown = $('<select class="form-control"></select>').appendTo(permissionSelector);
            dropDown.append('<option value="" disabled selected><i>Select a Permission Group</i></option>');
            var assignedIds = groupPermissionsForUser.map((x)=>x.GroupId);
            this.allPermissionGroups.filter((x)=>assignedIds.indexOf(x.GroupId) == -1).forEach((pg)=>{
                if (groupPermissionsForUser.indexOf(pg) == -1) dropDown.append('<option value="' + pg.GroupId + '">' + pg.GroupName + '</option>');
            });
            assignToNewGroupButton.prop('disabled', true);
            dropDown.on('change', (evt)=>{
                this.$noPermissionsWarningContainer.addClass('hidden');
                this.$noPermissionsWarningCheckbox.prop('checked', false);
                var pg = this.allPermissionGroups.filter((x)=>x.GroupId == evt.target.value + "")[0];
                groupPermissionsForUser.push(pg);
                addNewRow.empty();
                this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);
            });
        });
        //Group permissions section - END       
        this.metnetSpatialPermissionsContainer = $('<div class="input-group midi_ManageUsersPage_input_container">METNET Spatial permissions:<br /></div>').appendTo(this.modalBodyContent);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_none" type="radio" value="0"> None</label>').appendTo(this.metnetSpatialPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_user" type="radio" value="1"> User</label>').appendTo(this.metnetSpatialPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="mns_permission" id="mns_permission_administrator" type="radio" value="2"> Administrator</label>').appendTo(this.metnetSpatialPermissionsContainer);
        this.digitalWeatherPermissionsContainer = $('<div class="input-group midi_ManageUsersPage_input_container">DigitalWeather permissions:<br /></div>').appendTo(this.modalBodyContent);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_none" type="radio" value="0"> None</label>').appendTo(this.digitalWeatherPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_normal" type="radio" value="2"> Normal (released modules)</label>').appendTo(this.digitalWeatherPermissionsContainer);
        $('<label class="midi_ManageUsersPage_input_container_checkbox_label"><input name="dw_permission" id="dw_permission_beta" type="radio" value="1"> Beta (all modules)</label>').appendTo(this.digitalWeatherPermissionsContainer);
        this.$noPermissionsWarningContainer.appendTo(this.modalBodyContent);
        if (user) {
            $('#mns_permission_none').prop('checked', user.Permissions.MetnetSpatialPermissions == (0, $4b7cacdb38b8b78b$export$43fbffa919743dc0).None);
            $('#mns_permission_user').prop('checked', user.Permissions.MetnetSpatialPermissions == (0, $4b7cacdb38b8b78b$export$43fbffa919743dc0).User);
            $('#mns_permission_administrator').prop('checked', user.Permissions.MetnetSpatialPermissions == (0, $4b7cacdb38b8b78b$export$43fbffa919743dc0).Administrator);
            $('#dw_permission_none').prop('checked', user.Permissions.DigitalWeatherPermissions == (0, $4b7cacdb38b8b78b$export$c71834b3651dbd0b).None);
            $('#dw_permission_beta').prop('checked', user.Permissions.DigitalWeatherPermissions == (0, $4b7cacdb38b8b78b$export$c71834b3651dbd0b).User);
            $('#dw_permission_normal').prop('checked', user.Permissions.DigitalWeatherPermissions == (0, $4b7cacdb38b8b78b$export$c71834b3651dbd0b).Essential);
            if (user.ExpiryDate == 0) {
                $('#accountExpiryCheck').prop('checked', true);
                this.userExpiryDate = 0;
                this.userAccountExpiryContainer.hide();
            } else $('#midi_ManageUsersPage_expiry_date_picker').datepicker("setDate", new Date(user.ExpiryDate));
        } else {
            $('#accountCSVCheck').prop('checked', true);
            $('#accountDLPCheck').prop('checked', true);
        }
        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Close </button>').appendTo(modalFooterContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Submit</button>').appendTo(modalFooterContent).click(()=>{
            $('.midi_ManageUsersPage_warningBox').remove();
            var setRegion = updateUserRegionInput.val() == 'No Region' ? null : updateUserRegionInput.val();
            var userPermissionUpdate = updateUserPermissionInput.val();
            var setAdmin = userPermissionUpdate == "Administrator";
            var setGlobalAdmin = userPermissionUpdate == "Global Administrator";
            var metnetSpatialPermissions = $('input[name="mns_permission"]:checked').val();
            var digitalWeatherPermissions = $('input[name="dw_permission"]:checked').val();
            if (groupPermissionsForUser.length == 0 && !this.$noPermissionsWarningCheckbox.prop('checked')) {
                this.$noPermissionsWarningContainer.removeClass('hidden');
                return;
            }
            if (!user) {
                var setEmail = this.newUserEmailInput.val();
                if (this.validateNewUser(setEmail, this.modalBodyContent) && this.validateChangeUser(setGlobalAdmin, setAdmin, setRegion, this.modalBodyContent)) (0, $4b7cacdb38b8b78b$export$b51ea21071015da9)(setEmail, setRegion, setAdmin, setGlobalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, this.userExpiryDate, (err)=>{
                    if (err) {
                        $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                        return;
                    }
                    //Save permission groups
                    (0, $1d3f08d9fba35da9$export$67b175837b7a13be)({
                        UserId: setEmail,
                        GroupIds: groupPermissionsForUser.map((gp)=>gp.GroupId)
                    }, (pErr)=>{
                        if (pErr) {
                            $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                            return;
                        }
                        this.modal.modal('hide');
                        if (this.pastExpiryWarningText) {
                            this.pastExpiryWarningText.remove();
                            this.pastExpiryWarningText = null;
                        }
                        this.refresh();
                    });
                });
            } else {
                this.removePreviousErrors();
                if (this.validateAccountExpiry(this.modalBodyContent) && this.validateChangeUser(setGlobalAdmin, setAdmin, setRegion, this.modalBodyContent)) (0, $4b7cacdb38b8b78b$export$e3ac7a5d19605772)(user.Id, setRegion, setAdmin, setGlobalAdmin, metnetSpatialPermissions, digitalWeatherPermissions, this.userExpiryDate, (err)=>{
                    if (err) {
                        $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                        return;
                    }
                    //Update permission groups
                    (0, $1d3f08d9fba35da9$export$67b175837b7a13be)({
                        UserId: user.Id,
                        GroupIds: groupPermissionsForUser.map((gp)=>gp.GroupId)
                    }, (pErr)=>{
                        if (pErr) {
                            $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating User: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                            return;
                        }
                        this.modal.modal('hide');
                        if (this.pastExpiryWarningText) {
                            this.pastExpiryWarningText.remove();
                            this.pastExpiryWarningText = null;
                        }
                        this.refresh();
                    });
                });
            }
        });
        this.modal.modal('show');
    }
    renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton) {
        this.tableBody.empty();
        assignToNewGroupButton.prop('disabled', false);
        if (groupPermissionsForUser.length == 0) noneFound.show();
        else {
            noneFound.hide();
            groupPermissionsForUser.forEach((gp)=>{
                var tr = $('<tr></tr>').appendTo(this.tableBody);
                $('<td>' + gp.GroupName + '</td>').appendTo(tr);
                $('<td>' + (0, $601490302ecedb8f$export$e5a161874de28443).getGroupPermissionTypeName(gp.GroupPermissionType) + '</td>').appendTo(tr);
                $('<td><i class="fa fa-fw fa-times"></i></td>').click(()=>{
                    this.$noPermissionsWarningContainer.addClass('hidden');
                    this.$noPermissionsWarningCheckbox.prop('checked', false);
                    groupPermissionsForUser.splice(groupPermissionsForUser.indexOf(gp), 1);
                    this.renderPermissionGroupTable(noneFound, groupPermissionsForUser, assignToNewGroupButton);
                }).appendTo(tr);
            });
        }
    }
    renderDeleteModal(user) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        this.modal = $('<div id="myModal" class="modal fade" ></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        $('<h4 class="modal-title">Confirm Delete</h4>').appendTo(modalHeaderContent);
        var modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        $('<p>Are you sure you want to delete <strong>' + user.Id + '</strong> from the system?<p>').appendTo(modalBodyContent);
        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Cancel </button>').appendTo(modalFooterContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Delete</button>').click(()=>{
            (0, $4b7cacdb38b8b78b$export$7d0f10f273c0438a)(user.Id, (err)=>{
                if (err) {
                    $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Deleting User: ' + err.Message + '</div>').appendTo(modalBodyContent);
                    return;
                }
                this.modal.modal('hide');
                this.refresh();
            });
        }).appendTo(modalFooterContent);
        this.modal.modal('show');
    }
    renderAccountDatePicker() {
        this.userAccountExpiryContainer = $('<div class="input-group midi_ManageUsersPage_input_container" style="padding-top: 0;"></div>').appendTo(this.modalBodyContent);
        $('<div class="panel panel-default"><div class="panel-body">Please note that the user account will expire at <strong>00:00 UTC</strong> on the selected expiry date.</div></div>').appendTo(this.userAccountExpiryContainer);
        var accountExpiryDatePickerContainer = $('<div class="input-group"></div>').appendTo(this.userAccountExpiryContainer);
        $('<span class="input-group-addon" id="basic-addon2"><i class="fa fa-calendar fa-fw"></i></span>').appendTo(accountExpiryDatePickerContainer);
        this.accountExpiryDatePicker = $('<input class="input-sm form-control" placeholder="Account expiry date" type="text" id="midi_ManageUsersPage_expiry_date_picker" aria-describedby="basic-addon2"></input>').appendTo(accountExpiryDatePickerContainer).datepicker({
            format: "yyyy-mm-dd"
        }).on('changeDate', ()=>{
            this.userExpiryDate = moment.utc(this.accountExpiryDatePicker.val(), 'YYYY-MM-DD').valueOf();
        });
    }
    validateChangeUser(globalAdmin, admin, region, modalBodyContent) {
        if (admin && region === null) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Administrators must be assigned a region.</div>').appendTo(modalBodyContent);
            return false;
        }
        return true;
    }
    validateNewUser(email, modalBodyContent) {
        //currently allows up to xx@icon.software (NB {2,8} length for the .something part
        var validEmailFormatRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,8}(?:\.[a-z]{2})?)$/i;
        this.removePreviousErrors();
        if (!validEmailFormatRegex.test(email)) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Please enter a valid email address.</div>').appendTo(modalBodyContent);
            this.newUserEmailInput.addClass("midi_common_validation_warning");
            return false;
        }
        return this.validateAccountExpiry(modalBodyContent);
    }
    removePreviousErrors() {
        if (this.validationErrorText) {
            this.validationErrorText.remove();
            this.newUserEmailInput.removeClass("midi_common_validation_warning");
        }
    }
    validateAccountExpiry(modalBodyContent) {
        if (!$("#accountExpiryCheck").prop('checked') && $('#midi_ManageUsersPage_expiry_date_picker').val() == "") {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Please enter a valid expiry date or select <strong>Account Never Expires</strong>.</div>').appendTo(modalBodyContent);
            this.accountExpiryDatePicker.addClass("midi_common_validation_warning");
            return false;
        }
        if (this.userExpiryDate >= moment.utc().valueOf()) {
            if (this.pastExpiryWarningText) {
                this.pastExpiryWarningText.remove();
                this.pastExpiryWarningText = null;
            }
        }
        if (!$("#accountExpiryCheck").prop('checked') && !this.pastExpiryWarningText && this.userExpiryDate < moment.utc().valueOf()) {
            this.pastExpiryWarningText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"><i class="fa fa-exclamation-triangle"></i> Warning account expiry already past, please submit again to confirm.</div>').appendTo(modalBodyContent);
            return false;
        }
        return true;
    }
    filterUsers(searchString, container, noneFound) {
        searchString = searchString.toLowerCase().replace(/\s/g, "");
        var found = 0;
        for(var i = 0; i < container.find('tbody').eq(0).find('tr').length; i++){
            let tableRow = container.find('tbody').eq(0).find('tr').eq(i);
            const email = tableRow.find('td').eq(0).text();
            const type = tableRow.find('td').eq(1).text();
            const region = tableRow.find('td').eq(2).text();
            if (email.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1 || type.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1 || region.toLowerCase().replace(/\s/g, "").indexOf(searchString) > -1) {
                found++;
                tableRow.show();
            } else tableRow.hide();
            if (found === 0) noneFound.show();
            else noneFound.hide();
        }
    }
}




class $4bb487869fb3a4b9$export$5bbd98196cb66ba8 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'changePassword';
        this.container = null;
        this.submitButton = null;
        this.inputValidation = false;
        this.inputValidationWarningContainer = null;
        this.validationCompleteAllFields = null;
        this.validationInvalidNewPasswords = null;
        this.passwordResetError = null;
        this.newPasswordContainer1 = null;
        this.newPasswordContainer2 = null;
        this.oldPasswordContainer = null;
        this.passwordResetSuccess = null;
        this.formBox = null;
        this.returntoPreviousPageOrCancel = null;
        this.oldPasswordInput = null;
        this.newPasswordInput1 = null;
        this.newPasswordInput2 = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.render();
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    //public currentUser: UserAccount;
    render() {
        this.container = $('<div class="container"></div>').appendTo('body');
        $('<h1>Change Password</h1>').appendTo(this.container);
        $('<p>Use the form below to change your password.</p><p>If you have forgotten your password, then please log out and click <strong>Forgotten your password</strong> on the log in page to recieve a new one.</p>').appendTo(this.container);
        this.formBox = $('<div class="col-md-6"></div>').appendTo($('<div class="row"></div>').appendTo(this.container));
        this.oldPasswordContainer = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">Old Password:</span>').appendTo(this.oldPasswordContainer);
        this.oldPasswordInput = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.oldPasswordContainer);
        this.newPasswordContainer1 = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">New Password:</span>').appendTo(this.newPasswordContainer1);
        this.newPasswordInput1 = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.newPasswordContainer1);
        this.newPasswordContainer2 = $('<div class="input-group midi_PasswordResetPage_input"></div>').appendTo(this.formBox);
        $('<span class="input-group-addon" id="basic-addon1">Confirm New Password:</span>').appendTo(this.newPasswordContainer2);
        this.newPasswordInput2 = $('<input class="form-control midi_PasswordResetPage_password_input"type="password" aria-describedby="basic-addon1">').appendTo(this.newPasswordContainer2);
        $('<button type="button" class="btn btn-success midi_PasswordResetPage_button">Change Password</button>').appendTo($('<div></div>').appendTo(this.formBox)).click(()=>{
            this.checkInputs();
            if (this.inputValidation) this.tryPasswordReset((0, $52db63ea8facb471$export$1a86835baa79d770).instance.currentUser.Id, this.oldPasswordInput.val(), this.newPasswordInput1.val());
        });
        this.returntoPreviousPageOrCancel = $('<div class="midi_common_link">Cancel</div>').appendTo(this.formBox).click(()=>{
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            window.history.back();
        });
        this.inputValidationWarningContainer = $('<div class="alert midi_PasswordResetPage_input_warning_container"></div>').appendTo(this.formBox).hide();
    }
    //public staticDataManager: StaticDataManager = new StaticDataManager();
    tryPasswordReset(email, oldPassword, newPassword) {
        (0, $4b7cacdb38b8b78b$export$dc726c8e334dd814)(email, oldPassword, newPassword, (err)=>{
            this.inputValidationWarningContainer.empty().hide();
            this.inputValidationWarningContainer.removeClass("alert-danger").removeClass("alert-success");
            if (err) {
                // there has been an error reseting the password
                this.inputValidationWarningContainer.addClass("alert-danger");
                this.inputValidationWarningContainer.show();
                this.passwordResetError = $('<div class="midi_common_validation_text_container_warning">Error changing password: ' + err.Message + '</div>').appendTo(this.inputValidationWarningContainer);
            //is there a nicer way to clear the input boxes? apparently can't do .reset()
            } else {
                // password reset has worked
                this.inputValidationWarningContainer.addClass("alert-success");
                this.inputValidationWarningContainer.show();
                this.passwordResetSuccess = $('<div class="midi_PasswordResetPage_input_warning_container">Password reset was successful.</div>').appendTo(this.inputValidationWarningContainer);
                this.returntoPreviousPageOrCancel.text("Return to Previous Page");
            }
            $('.midi_PasswordResetPage_password_input').val("");
        });
    }
    checkInputs() {
        this.inputValidation = true;
        this.inputValidationWarningContainer.empty();
        this.inputValidationWarningContainer.show();
        if (!this.oldPasswordInput.val() || !this.newPasswordInput1.val() || !this.newPasswordInput2.val()) {
            this.validationCompleteAllFields = $('<div class="midi_common_validation_text_container_warning">Please complete all fields.</div>').appendTo(this.inputValidationWarningContainer);
            this.inputValidation = false;
        }
        if (!this.oldPasswordInput.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.oldPasswordInput.addClass("midi_common_validation_warning");
        } else this.oldPasswordInput.removeClass("midi_common_validation_warning");
        if (!this.newPasswordInput1.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.newPasswordInput1.addClass("midi_common_validation_warning");
        } else this.newPasswordInput1.removeClass("midi_common_validation_warning");
        if (!this.newPasswordInput2.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.newPasswordInput2.addClass("midi_common_validation_warning");
        } else this.newPasswordInput2.removeClass("midi_common_validation_warning");
        if (this.newPasswordInput1.val() !== this.newPasswordInput2.val()) {
            this.inputValidationWarningContainer.addClass("alert-danger");
            this.validationInvalidNewPasswords = $('<div class="midi_common_validation_text_container_warning">Passwords do not match, please re-enter.</div>').appendTo(this.inputValidationWarningContainer);
            this.inputValidation = false;
            this.newPasswordInput1.val("").addClass("midi_common_validation_warning");
            this.newPasswordInput2.val("").addClass("midi_common_validation_warning");
        }
    }
}



class $76904d5bf2f2b36c$export$3b628956c133cac7 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'support';
        this.container = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.render();
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    render() {
        this.container = $('<div class="container"></div>').appendTo('body');
        var pageBack = $('<div class="midi_common_link midi_supportPage_backLink">Back</div>').appendTo(this.container).click(()=>{
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            window.history.back();
        });
        $('<div class="list-group midi_supportPage_list-group"></div>').append($('<a href="#midi-support-section-navBar" class="midi-scroll-to list-group-item">Navigation Bar</a>')).append($('<a href="#midi-support-section-mapPage" class="midi-scroll-to list-group-item">Map Page</a>')).append($('<a href="#midi-support-section-tablePage" class="midi-scroll-to list-group-item">Table Page</a>')).append($('<a href="#midi-support-section-plotPage" class="midi-scroll-to list-group-item">Plot Page</a>')).append($('<a href="#midi-support-section-stationPage" class="midi-scroll-to list-group-item">Station Page</a>')).append($('<a href="#midi-support-section-dataDisplays" class="midi-scroll-to list-group-item">Data Displays</a>')).append($('<a href="#midi-support-section-glossary" class="midi-scroll-to list-group-item">Glossary</a>')).appendTo(this.container);
        let container = $('<div class="midi_supportPage_content"></div>').appendTo(this.container);
        $('<h1>Support</h1>').appendTo(container);
        var regionalAdminLink = (0, $52db63ea8facb471$export$1a86835baa79d770).instance.setupRegionalAdminPopover($('<strong>Regional Administrator</strong>').css("cursor", "pointer"));
        $(`<p>This page describes the main features and functionality of this website. You can use the panel on the left to 
scroll to the section you are interested in.
</p>`).appendTo(container);
        $('<p></p>').appendTo(container).append($('<span>If you experience any problems with this website, or have any questions which are not answered on this page, then please contact your </span>').append(regionalAdminLink).append('.'));
        //---------Nav bar---------//
        $('<div id="midi-support-section-navBar" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Navigation Bar</h3>')).append($(`<p>You can access the <a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a>,
<a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> and 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> pages from the navigation bar at the top of the window.
The page that is currently selected is highlighted in <span class="midi_supportPage_yellow">yellow</span>.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/mainnavbar.png">
<figcaption>The main navigation bar.</figcaption>
</figure>`)).append($(`<p>The navigation bar also includes the 
<a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>, 
<a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a>,
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">Warning rules selector</a> and the 
<a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a>. If the <strong>North Sea</strong>
region is selected, links to <a href="https://offshore.meteogroup.com/ocw/">METCAST</a> and
<a href="https://www.helimet.com/">HELIMET</a> are also shown.</p>`)).append($('<h5 id="midi-support-section-regionSelector">Region selector</h5>')).append($(`<p>The region selector can be found next to the 
<a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page tab in the navigation bar. 
The region that is currently selected is displayed in the navigation bar itself and clicking
on the region label brings up a drop-down list of the other regions that are available to the user. 
Note that not all users will have access to all regions.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/regionselector.png">
<figcaption>The region selector drop-down.</figcaption>
</figure>`)).append($(`<p>Selecting a region changes the stations that are available in the 
<a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a></strong> - 
only stations that are in the selected region are available. It also changes the region that is shown on the
<a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page as well as limits the data that is shown 
on the <a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> and 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> pages to stations within the selected region.
</p>`)).append($('<h5 id="midi-support-section-stationSelector">Station selector</h5>')).append($(`<p>The station selector can be found next to the 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> page tab in the navigation bar. Clicking 
on the <strong>Station</strong> tab opens the station drop-down.
The stations that are listed in the station selector are dependent on the region that is selected in the 
<a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a> - only stations 
that are in the selected region are displayed. Clicking on a station in the drop-down opens the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/stationselector.png">
<figcaption>The station selector drop-down.</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-warningRulesSelector">Warning rules selector</h5>')).append($(`<p>The warning rules selector is found on the right-hand side of the navigation bar, 
next to the <a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a> tab.</p>`)).append($(`<p>The user has the option of selecting between <strong>Aviation</strong> and <strong>Marine</strong>
warning rule sets and the rule set that is currently selected in always displayed in the navigation bar. Clicking on the rule
set label brings up the warning rules selector.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/warningrulesselector.png">
<figcaption>The warning rules selector drop-down.</figcaption>
</figure>`)).append($(`<p>The selected warning rule set modifies the thresholds at which warnings are displayed in the 
data boxes (i.e. the highlighting of the data values), as described in the
<a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide.</p>`)).append($(`<p>Clicking on the <i class="fa fa-info-circle" style="color: #2895F1"></i>
<span class="sr-only">i</span> icon in the warning selector drop-down shows the colour-coding rules that are applied to the
displayed data values.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/aviationwarningrules.png">
<figcaption>Colour-coding for the <strong>Aviation</strong> warning rule set.</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-userMenu">User menu</h5>')).append($(`<p>The user menu button is found at the right-hand side of the navigation bar, next to the 
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">Warning rules selector</a>. The username of the currently
logged in user is always displayed and clicking on the username opens the menu. Note that depending on your permission level,
this menu may display fewer options.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/usermenu.png">
<figcaption>The user menu.</figcaption>
</figure>`)).append($(`<p>From this menu, you can: 
<ul>
<li>log out of this website</li>
<li>change your password</li>
<li>access this guide from the <strong>support</strong> link</li>
<li>change the data display time between UTC, PC time or region/station time</li>
<li>switch to basic parameter view to show a subset of the available parameters on the 
<a href="#midi-support-section-basicParameterView" class="midi-scroll-to">Station</a> page</li>
<li>switch to night mode to dim the page for operation at night</li>
<li>access various other options if you have administrator privileges</li>
</ul>
</p>`)).append($('<h5>Small screens</h5>')).append($(`<p>On small screens, the navigation bar collapses. All of the above functionality 
is maintained and each option that has been described is accessible by clicking on the 
<img src="images/supportpage/navigation/collapsednavbtn.png"> button on the
right-hand side.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/collapsednav.png">
<figcaption>The collapsed navigation bar on small screens.</figcaption>
</figure>`));
        //---------Map page---------//
        $('<div id="midi-support-section-mapPage" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Map Page</h3>')).append($(`<p>The map page is accessible by clicking on the <strong>Map</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It shows a map of the selected region which can 
be changed using the <a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>. The stations within
the selected region are displayed as an overlay on the map.
</p>`)).append($(`<p>Clicking on a station on the map page opens the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station. Hovering over the
station with the cursor opens the <a href="#midi-support-section-stationPopup" class="midi-scroll-to">Latest observations pop-up</a>
for the selected station. By default, the station name is displayed in the label next to the circle that represents the station 
on the map. This label can show different station information, depending on what is selected in the 
<a href="#midi-support-section-stationLabelsSelector" class="midi-scroll-to">Station labels selector</a>.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/mappage.png">
<figcaption>A snippet of the map page showing some stations for the <strong>North Sea</strong> region.</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-stationPopup">Latest observations pop-up</h5>')).append($(`<p>Hovering over a station on the map page displays the latest observations pop-up for the 
station of interest. Data for a number of parameters are available in this pop-up, in the format described in
the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide. If a data value 
exceeds any of the warning thresholds for the currently selected warning rule set 
(see <a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide) then the corresponding 
box will be coloured appropriately.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/latestobservationspopup.png">
<figcaption>An example of the latest observations popup showing a warning for <strong>Wind Spd</strong>.</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-stationLabelsSelector">Station labels selector</h5>')).append($(`<p>The station labels selector is shown on the right-hand side of the map page. Clicking on this 
button shows a drop-down that you can use to include the current value for a parameter, as well as the station name,
in the label that is shown next to each station on the map. For a full description of the parameters that are available,
please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of this guide.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/stationlabelselector.png">
<figcaption>The station labels selector.</figcaption>
</figure>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/windstationlabels.png">
<figcaption>An example of station labels that include the <strong>Wind Spd</strong> parameter.</figcaption>
</figure>`));
        //-------Table Page-------//
        $('<div id="midi-support-section-tablePage" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Table Page</h3>')).append($(`<p>The table page is accessible by clicking on the <strong>Table</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It shows a table containing key parameter values 
for all of the stations in the selected region, which can 
be changed using the <a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>. For a full
list of all of the parameters, please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of this guide.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/table/tablepage.png">
<figcaption>A snippet of the table page for the <strong>North Sea</strong> region, showing warnings for 
some of the <strong>Wind Spd</strong> values.</figcaption>
</figure>`)).append($(`<p>The data in each of the table cells is formatted as described in
the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide. If a data value 
exceeds any of the warning thresholds for the currently selected warning rule set 
(see <a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide) then the corresponding 
cell will be coloured appropriately.</p>`)).append($(`<p>Clicking on the station name will open the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station. Clicking on
one of the table cells that show data will open the
<a href="#midi-support-section-parameterpopup" class="midi-scroll-to">Parameter pop-up</a> for the selected parameter.</p>`)).append($(`<p>The <strong>Obs. Time</strong> column shows the time that the last data was received for a particular 
station.</p>`)).append($('<h5 id="midi-support-section-parameterpopup">Parameter pop-up</h5>')).append($(`<p>The parameter pop-up shows a chart of recent data for the selected parameter for the 
selected station. This is the same pop-up as is shown when clicking on a data value on the
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/table/parameterpopup.png">
<figcaption>An example of a parameter pop-up which shows both 
<span class="midi_supportPage_historicalBlue">historical</span> and  
<span class="midi_supportPage_forecastBlack">forecast</span> data.</figcaption>
</figure>`)).append($(`<p>The main feature of the parameter pop-up is the chart at the bottom. This chart shows a 
snapshot of the <span class="midi_supportPage_historicalBlue">historical</span> data for the selected parameter. The 
chart may also show <span class="midi_supportPage_forecastBlack">forecast</span> data, depending on the selected site/parameter.
</p>
<p>Users can change the time period of the chart to 12 hours, 24 hours, 2 days, 7 days or 30 days by using the 
buttons above the chart. Note that if both forecast and historical data are shown, selecting the time period using
these buttons will show that time period for both the forecast and historical components of the chart. For example,
selecting 12 hours will show 12 hours of historical data and 12 hours of forecast data.
The time period can also be changed by dragging the highlighted section of the navigator which sits below the main chart.
</p>`)).append($(`<p>The top section of the pop-up shows the name of the station, an abbreviation of the 
parameter name, the units, the time at which the latest data was received, a description of the
parameter and the name of the sensor for the data that is displayed in the chart.</p>`)).append($(`<p>The grouping section of the pop-up allows the user to select between 
<strong>High</strong>, <strong>Average</strong> and <strong>Low</strong> data grouping for the data that is shown
on the chart. Please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of
this guide for a description of data grouping.</p>`));
        //--------Plot Page ------//
        $('<div id="midi-support-section-plotPage" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Plot Page</h3>')).append($(`<p>The plot page is accessible by clicking on the <strong>Plot</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It allows users to generate plots of 
historical data for any of the plottable parameters of the stations within the selected region. By default, 
the last 30 days of data for the selected parameters is shown.</p>
<p>This page consists of the
<a href="#midi-support-section-plotNavBar" class="midi-scroll-to">plotting navigation bar</a>, the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">parameter select tree</a>, the 
<a href="#midi-support-section-plotParamSet" class="midi-scroll-to">parameter sets pane</a> and the main plotting area. 
Users manipulate what is shown in the plotting area by selecting parameters/parameter sets and selecting options in the 
<a href="#midi-support-section-plotNavBar" class="midi-scroll-to">plotting navigation bar</a>.
</p>`)).append($(`<p>Below the plot is a navigator that users can use to scroll to a particular time period. 
There is also a legend, the label of which takes the form <strong>Region_Station.Sensor.Parameter/Units</strong>. There is no
limit to the number of parameters that can be displayed on the plot.</p>`)).append($(`<p>On mouseover, tooltips are displayed that show the value for each parameter displayed
in the chart at the given timestamp. The tooltip label uses the same format as the chart legend.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/exampleplot.png">
<figcaption>An example of a plot showing data for 4 parameters. Tooltips are displayed on mouseover
which show the data values for each parameter at a given timestamp.</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-plotNavBar">Plotting navigation bar</h5>')).append($(`<p>The plotting navigation bar contains a number of buttons that allow the user to 
modify the data that is shown in the chart as well as 
<a href="#midi-support-section-plotNavDataDownload" class="midi-scroll-to">download</a> the data that is currently
displayed. Note that on small screens the plotting navigation bar collapses as with the main
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. When collapsed, clicking the 
<img src="images/supportpage/navigation/collapsednavbtn.png"> button shows all of the options described below in a drop-down
list.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/plottingnavbar.png">
<figcaption>The plotting navigation bar.</figcaption>
</figure>`)).append($('<h6 id="midi-support-section-plotNavTimePeriod">Changing time period</h6>')).append($(`<p>Users can quickly change the time period shown on the plot to 24 hours, 
7 days, 14 days, 30 days or 90 days by clicking on the corresponding button. 
If one of these time periods is selected, it is highlighted in <span class="midi_supportPage_yellow">yellow</span> 
and the dates displayed in the date select boxes are updated. Users can also set a specific date range for 
the chart by clicking the date select boxes and manually choosing a start and end date. 
Note that the chart will show data from 00:00 on the start date until 23:59 on the end date.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/plotnavdateselect.png">
<figcaption>The date selector in the plotting navigation bar. The user is in the process of choosing a start date.
</figcaption>
</figure>`)).append($('<h6>Data grouping</h6>')).append($(`<p>The grouping section of the plotting navigation bar allows the user to select between 
<strong>High</strong>, <strong>Average</strong> and <strong>Low</strong> data grouping for the data that is shown
on the chart. Please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of
this guide for a description of data grouping.</p>`)).append($('<h6>Function</h6>')).append($(`<p>The function section of the plotting navigation bar allows the user to select between 
<strong>None</strong> and <strong>RoC</strong> functions. If <strong>None</strong> is selected then the default
time-series data is shown. If <strong>RoC</strong> is selected, then the <em>rate of change</em> of the data values per 
hour are displayed instead. This allows the user to see where the data is changing quickly over a short space of time.
</p>`)).append($('<h6>Stacked plots</h6>')).append($(`<p>Clicking the <img src="images/supportpage/plot/stackedplotsbtn.png">
button toggles the plot display from grouped to stacked. The plots are stacked if this button is 
highlighted <span class="midi_supportPage_yellow">yellow</span>. 
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/stackedplots.png">
<figcaption>An example of stacked plots.
</figcaption>
</figure>`)).append($('<h6 id="midi-support-section-plotNavDataDownload">Downloading data</h6>')).append($(`<p>One click snap-shots of the data displayed in the plot 
can be downloaded in either CSV or Shell DLP file formats by clicking 
the corresponding button on the right-hand side of the plotting navigation bar. There is also the option to save an 
image of the plot in PNG format.</p>`)).append($('<h5 id="midi-support-section-plotParamSelect">Parameter select tree</h5>')).append($(`<p>The parameter select tree sits on the right-hand side of the plotting page. 
First, the user clicks a station name to expand a list of sensors for that station. Clicking on a sensor shows a list of all of the 
plottable parameters that the selected sensor collects data for. Clicking on a parameter label toggles whether or not that parameter 
is shown on the plot. Note that not all parameters are plottable but data for these parameters can still be downloaded using the 
<a href="#midi-support-section-plotParamSetDownload" class="midi-scroll-to">Data download</a> feature.
</p>
<p>
There is no limit to the number of these plottable parameters that the user can choose to show on the plot and those that 
are currently selected are highlighted <span class="midi_supportPage_yellow">yellow</span>.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/parameterselecttree.png">
<figcaption>A snippet of the parameter select tree with 2 selected parameters.
</figcaption>
</figure>`)).append($(`<p>
The width of the parameter select tree can be increased by clicking and dragging the left-hand side of the box that it sits in - the 
mouse cursor will change to a double headed arrow. Increasing the width of this box 
also increases the width of the <a href="#midi-support-section-plotParamSet" class="midi-scroll-to">Parameter sets pane</a>
and decreases the width of the plot.
</p>`)).append($(`<p>
Users may wish to save the selected parameters as a <strong>parameter set</strong> so that they can readily plot the same parameters 
again when they next come to the plotting page. Parameter sets can be saved by clicking the <strong>Save Set</strong> button at the top 
of the parameter select tree. In the pop-up that appears, users must either enter a name for the parameter set 
if they would like to create a new one or choose from a list of existing parameter sets to overwrite an 
existing set. Clicking the <strong>Save</strong> button saves the parameter set and saved parameter sets are displayed in the 
<a href="#midi-support-section-plotParamSet" class="midi-scroll-to">Parameter sets pane</a>.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/saveparamset.png">
<figcaption>The pop-up that appears when the user clicks the <strong>Save Set</strong> button to save a 
new parameter set or overwrite an existing set.
</figcaption>
</figure>`)).append($('<h6 id="midi-support-section-plotParamSetDownload">Data download</h6>')).append($(`<p>Data from an individual station can be download by clicking the 
<img src="/images/icons/download.png" style="height: 16px; width: 16px"></img> icon next to the station name in the 
tree. Clicking this button brings up the download data pop-up.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/datadownload.png">
<figcaption>The data download pop-up with all temperature parameters selected and some wave parameters selected for the station 
<strong>Nelson</strong>.
</figcaption>
</figure>`)).append($(`<p>The data download pop-up allows the user to specify a data interval and time period for the data
they wish to download. Users can download data in either CSV or Shell DLP format and can select between downloading all data for the 
selected station or a sub-set of the data, which may include non-plottable parameters.</p>`)).append($('<h5 id="midi-support-section-plotParamSet">Parameter sets pane</h5>')).append($(`<p>This pane shows the parameter sets that the user has created using the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a> and allows users to
easily reproduce charts for parameters of interest without selecting them individually from the tree.</p>`)).append($(`<p>Clicking the name of the parameter set automatically selects the parameters 
within the <a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a> and shows
the latest data for these parameters on the chart. Clicking <strong>None</strong> de-selects all currently selected parameters.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/parametersets.png">
<figcaption>The parameter sets pane.
</figcaption>
</figure>`)).append($(`<p>Users can delete a parameter set by clicking the <i class="fa fa-trash-o"></i> 
button next to the name of the parameter set and clicking <strong>Delete</strong> in the pop-up that appears.</p>`)).append($(`<p>
The width of the parameter sets pane can be increased by clicking and dragging the left-hand side 
of the box that it sits in - the  mouse cursor will change to a double headed arrow. Increasing the width of this box 
also increases the width of the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a>
and decreases the width of the plot.
</p>`));
        //----------Station Page ------//
        $('<div id="midi-support-section-stationPage" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Station Page</h3>')).append($(`<p>The station page shows a full data display for the selected station and can be accessed either 
by clicking on the station of interest on the <a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page,
clicking on the station name on the <a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> page or
clicking on the station name in the <a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a>.
The name of the selected station is highlighted in <span class="midi_supportPage_yellow">yellow</span> in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a>.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/stationpage.png">
<figcaption>An example of the <a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview</a> 
station page with a <span class="midi_supportPage_yellow">yellow</span> warning for <strong>Wind Spd</strong>.
</figcaption>
</figure>`)).append($(`<p>The top left of this page shows the timestamp that data was last received for the selected station.
Depending on the station that has been selected, and the number of available sensors/parameters, this page may contain more than 
one tab. The tabs that are available sit at the top of the page next to the timestamp. A brief description of each of the tabs that might be present 
for a given site is provided in this section and the selected tab is highlighted <span class="midi_supportPage_yellow">yellow</span>.
</p>`)).append($(`<p>The majority of the data present on each tab is presented as a series of parameter boxes. The formatting 
of the data is described in the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section. 
If the data in these boxes exceeds the relevant warning rules, as described in 
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide, the background colour 
of the box will reflect the warning level.</p><p>Hovering over a parameter box shows the latest  timestamp that data for that 
parameter was received.
Clicking on a parameter box opens a pop-up plot which is the same as is described in the 
<a href="#midi-support-section-parameterpopup" class="midi-scroll-to">Parameter pop-up</a> section of this guide, as part of the 
<a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> section. Note that not all of the parameters shown 
on the station page are plottable, in which case the parameter pop-up will show the text <em>this parameter is not plottable</em>.
</p>`)).append($(`<p>Note that a description of each of the parameters is provided in the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a>.
</p>`)).append($('<h5 id="midi-support-section-overviewTab">Overview tab</h5>')).append($(`<p>If a station has more than one sensor then the overview tab will be available. This tab will 
be open by default and will show:
<ul>
<li>The wind compass (see the <a href="#midi-support-section-windCompass" class="midi-scroll-to">Wind compass</a> section below)</li>
<li>Vessel heading (if the station is a vessel)</li>
<li>Helideck status information (if the station has helidecks)</li>
<li>Wind direction, variation, speed and gust speed</li>
<li>Cloud information including the cloud cover (amount) and height of up to 3 cloud layers</li>
<li>Visibility</li>
<li>METAR</li>
</ul>
</p>`)).append($('<h5 id="midi-support-section-cloudsTab">Clouds tab</h5>')).append($(`<p>If a station has more than one sensor or if its only sensor is a cloud sensor then the 
clouds tab will be available. If the station has only a single cloud sensor then this tab is opened by default.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/cloudstab.png">
<figcaption>An example the clouds station page.
</figcaption>
</figure>`)).append($(`<p>
At the top of this page is a timeseries plot of <span class="midi_supportPage_cloudsRed">visibility</span> and 
<span class="midi_supportPage_cloudsGrey">instantaneous cloud height</span>. This page also shows:
<ul>
<li>The cloud cover and height of up to 3 cloud layers</li>
<li>The instantaneous cloud height of up to 3 cloud layers</li>
<li>Visibility</li>
<li>Present weather as METAR</li>
<li>Rainfall intensity</li>
<li>Solar radiation</li>
</ul>
</p>`)).append($('<h5 id="midi-support-section-wavesTab">Waves tab</h5>')).append($(`<p>If a station has more than one sensor or if its only sensor is a sensor that records <strong>Hs</strong> 
then the waves tab will be available. If the station only has a single <strong>Hs</strong> sensor then this tab is opened by default.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/wavestab.png">
<figcaption>An example of the waves station page.
</figcaption>
</figure>`)).append($(`<p>
The right-hand side of this page may show a different chart, from a selection of the following, depending on if the wave sensor 
is directional or not:
<ul>
<li>a <span class="midi_supportPage_wavesBlue">wave spectrum</span> (default) chart which may also show 
<span class="midi_supportPage_cloudsRed">mean direction</span> and <span class="midi_supportPage_wavesPink">directional spread</span>
if the sensor is directional.</li>
<li>a polar chart of <strong>Hs</strong> versus mean direction if the wave sensor is directional. 
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
<li>a directional wave spectrum rose (polar spectrum) if the wave sensor is directional. Each coloured segment corresponds to 
one frequency component from the directional wave spectrum. The direction of the segment corresponds to the mean direction 
of the component. The length of the segment corresponds to the spectral density of that component and the colour of the 
segment corresponds to the period of that component.</li>
</ul></p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/polarwaves.png">
<img src="images/supportpage/station/polarspectrumwaves.png">
<figcaption>An example of the polar charts that may also be available on the waves station page. The first chart represents 
<strong>Hs</strong> versus mean direction and the second is the directional wave spectrum rose.
</figcaption>
</figure>`)).append($(`<p>This page also shows parameter boxes for the following parameters (see the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> for a description of each of the parameters):
<ul>
<li>Buoy latitude and longitude (if the station is a buoy)</li>
<li>Buoy excursion (if the station is a buoy)</li>
<li>Mean WL (if the station is not a buoy)</li>
<li>Max TWL (if the station is not a buoy)</li>
<li>Hs and Hmax</li>
<li>Cmax and Cass</li>
<li>Tz, T2 and Tp</li>
<li>The radar air gap</li>
<li>Mean and peak wave directions as well as mean and peak spreads</li>
</ul>
</p>`)).append($('<h5 id="midi-support-section-currentTab">Current tab</h5>')).append($(`<p>If a station has more than one sensor or if its only sensor is a current sensor 
then the current tab will be available. If the station only has a single current sensor then this tab is opened by default.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/currenttab.png">
<figcaption>An example of the current station page.
</figcaption>
</figure>`)).append($(`<p>
The right-hand side of this page may show a different chart, from a selection of the following, depending on if the station 
has a current sensor and, if so, the sensor measures bottom current or just surface current:
<ul>
<li>a current profile chart showing <span class="midi_supportPage_cloudsRed">speed</span> and 
<span class="midi_supportPage_currentGreen">direction</span> at different depths (requires an ADCP sensor)</li>
<li>a progressive vector diagram (pvd) chart which shows the path a floating particle would take if the 
currents were spatially uniform (and the floating particle was not directly influenced by wind and waves). 
This chart is based on <em>surface</em> current speed and direction and uses historical data, not just the latest record.
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
<li>a polar chart of surface current speed versus mean direction. 
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
</ul></p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/pvdchart.png">
<img src="images/supportpage/station/polarcurrent.png">
<figcaption>An example of the two other charts that may be displayed on the current page. The first is an example of a progressive
vector diagram (pvd) and the second is a polar chart for current.
</figcaption>
</figure>`)).append($(`<p>This page also shows parameter boxes for the following parameters:
<ul>
<li>Surface current direction and speed</li>
<li>Mid-depth current direction and speed (if the sensor measures more than surface current)</li>
<li>Bottom current direction and speed (if the sensor measures more than surface current)</li>
<li>Peak current direction and speed (if the sensor measures more than surface current)</li>
<li>Peak current depth (if the sensor measures more than surface current)</li>
</ul>
</p>`)).append($('<h5 id="midi-support-section-motionTab">Motion tab</h5>')).append($(`<p>If a station has more than one sensor or if its only sensor is a motion sensor 
then the motion tab will be available. If the station only has a single motion sensor then this tab is opened by default.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/motiontab.png">
<figcaption>An example of the motion station page.
</figcaption>
</figure>`)).append($(`<p>This page shows parameter boxes for the following parameters (see the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> for a description of each parameter):
<ul>
<li>Maximum roll left and right</li>
<li>Excursion distance and bearing</li>
<li>Pitch bow up and pitch bow down</li>
<li>Heave rate, max heave and heave period</li>
<li>Motion severity parameters <strong>MMS</strong> and <strong>MSI</strong></li>
<li>Max inclination</li>
</ul>
</p>`)).append($('<h5 id="midi-support-section-windTab">Wind tab</h5>')).append($(`<p>If a station has more than one sensor or if its only sensor is a wind sensor 
then the wind tab will be available. If the station only has a single wind sensor then this tab is opened by default.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/windtab.png">
<figcaption>An example of the wind station page.
</figcaption>
</figure>`)).append($(`<p>For each of the station's wind sensors, this page shows:
<ul>
<li>A <a href="#midi-support-section-windCompass" class="midi-scroll-to">Wind compass</a> or polar chart of wind speed versus 
mean wind direction (selectable at the top of the page)</li>
<li>1-minute and 10-minute mean wind direction</li>
<li>1-minute and 10-minute wind speed</li>
<li>1-minute and 10-minute gust speed</li>
</ul>
</p>`)).append($(`<p>At the bottom of the page is a chart showing 10-minute means of wind speed, direction and gust speed for 
each of the station's wind sensors.
</p>`)).append($('<h5 id="midi-support-section-motionTab">Risers tab</h5>')).append($(`<p>This tab is currently only available for the station <strong>Malikai</strong> and shows the riser 
tension and tensioner pressures for the FPSO, as well as motion parameters.
</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/riserstab.png">
<figcaption>An example of Malikai's risers station page.
</figcaption>
</figure>`)).append($('<h5 id="midi-support-section-windCompass">Wind compass</h5>')).append($(`<p>The wind compass is accessible from the 
<a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview tab</a> (if the station has more than one
sensor) or the <a href="#midi-support-section-windTab" class="midi-scroll-to">Wind tab</a>.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/windcompass.png">
<figcaption>The wind compass.
</figcaption>
</figure>`)).append($(`<p>In the centre of the compass, the name of the wind sensor is displayed as well as the numerical 
value for wind direction and speed. If the height of the wind sensor is known, this is also displayed in the centre of the
compass, following the <strong>@</strong> symbol.</p>`)).append($(`<p>On the outer ring of the compass, the green arrow represents the direction that the wind 
is coming from and the yellow block represents the variation in wind direction.</p>`)).append($('<h5 id="midi-support-section-basicParameterView">Basic parameter view</h5>')).append($(`<p>If the user has selected to switch to basic parameter view from the 
<a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a> section of the
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a> then a reduced subset of the parameters
will be shown on the station's <a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview</a>
and <a href="#midi-support-section-wavesTab" class="midi-scroll-to">Wave</a> pages.</p>`)).append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/stationpagebasic.png">
<figcaption>An example of the overview station page with basic parameter view.
</figcaption>
</figure>`));
        //------------Data displays -------//
        $('<div id="midi-support-section-dataDisplays" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Data Displays</h3>')).append($(`<p>This section describes how the parameter values are displayed throughout this website.
</p>`)).append($('<h5>Parameter values</h5>')).append($('<p>The value for a given parameter may be displayed in one of four ways:</p>')).append($('<ul></ul>').append('<li><span class="midi_supportPage_parameterValueKey">---</span>&nbsp;&nbsp;There is no instrument installed for the parameter</li>').append('<li><span class="midi_supportPage_parameterValueKey">///</span>&nbsp;&nbsp;The parameter has been received in the past but there have been no new values in the last two hours</li>').append('<li><span class="midi_supportPage_parameterValueKey midi_supportPage_parameterValueKey_oldData">23.4</span>&nbsp;&nbsp;The value is between one and two hours old</li>').append('<li><span class="midi_supportPage_parameterValueKey">23.4</span>&nbsp;&nbsp;The value was received in the last hour</li>')).append($('<h5 id=""midi-support-section-warningRules">Warning rules</h5>')).append($(`<p>Value boxes are colour coded depending on the selected <strong>Warning Rules</strong>. 
These can be viewed or changed from the navigation bar, as described in the
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a> section.</p>`));
        $('<div id="midi-support-section-glossary" class="midi-support-section"></div>').appendTo(container).append($('<h3 class="page-header">Glossary</h3>')).append($(`<p>This section provides a description of each of the parameters and 
parameter units displayed on this website as well as definitions for some of the more technical terms/abbreviations used.</p>`)).append($('<h5>Parameters</h5>')).append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>Air Gap</th><td>Radar air gap (Mean)</td></tr>
<tr><th>Air Temp</th><td>Dry bulb air temperature</td></tr>
<tr><th>Bottom Current Spd</th><td>Bottom current speed</td></tr>
<tr><th>Btm. Current Dir.</th><td>Bottom current direction</td></tr>
<tr><th>Cass</th><td>Crest associated with the maximum wave height</td></tr>
<tr><th>Cloud Amt 1</th><td>The amount of sky obscured by clouds in the lowest cloud base</td></tr>
<tr><th>Cloud Amt 2</th><td>The amount of sky obscured by clouds in the second lowest cloud base</td></tr>
<tr><th>Cloud Amt 3</th><td>The amount of sky obscured by clouds in the third lowest cloud base</td></tr>
<tr><th>Cloud Ht 1</th><td>Height of lowest cloud base</td></tr>
<tr><th>Cloud Ht 1 Inst</th><td>Instantaneous height of lowest cloud base</td></tr>
<tr><th>Cloud Ht 2</th><td>Height of second lowest cloud base</td></tr>
<tr><th>Cloud Ht 2 Inst</th><td>Instantaneous height of second lowest cloud base</td></tr>
<tr><th>Cloud Ht 3</th><td>Height of third lowest cloud base</td></tr>
<tr><th>Cloud Ht 3 Inst</th><td>Instantaneous height of third lowest cloud base</td></tr>
<tr><th>Cmax</th><td>Maximum crest height</td></tr>
<tr><th>Dew Point</th><td>The temperature at which condensation occurs</td></tr>
<tr><th>Draft</th><td>Vessel draft</td></tr>
<tr><th>Excursion</th><td>Buoy excursion from target location</td></tr>
<tr><th>Excursion Bearing</th><td>Bearing of maximum excursion</td></tr>
<tr><th>Gust Spd</th><td>Maximum gust speed in recording interval</td></tr>
<tr><th>Gust Spd (1 min)</th><td>Maximum gust speed observed over 1 minute</td></tr>
<tr><th>Gust Spd (10 min)</th><td>Maximum gust speed observed over 10 minutes</td></tr>
<tr><th>Heading</th><td>Heading towards which bow of vessel is pointing</td></tr>
<tr><th>Heave</th><td>Vessel heave</td></tr>
<tr><th>Helideck Status</th><td>Helideck status based on station-specific wind speed and direction rules</td></tr>
<tr><th>Hmax</th><td>Maximum upcrossing individual wave height from time domain</td></tr>
<tr><th>Hs</th><td>Significant wave height</td></tr>
<tr><th>Humidity</th><td>Percentage of the maximum possible amount of water contained in the air</td></tr>
<tr><th>Latitude</th><td>Vessel or buoy latitude</td></tr>
<tr><th>Longitude</th><td>Vessel or buoy longitude</td></tr>
<tr><th>Max Excursion</th><td>Maximum excursion distance</td></tr>
<tr><th>Max Heave</th><td>Maximum magnitude of vertical displacement</td></tr>
<tr><th>Max Heave Rate</th><td>Maximum rate of vertical displacement</td></tr>
<tr><th>Max Inclination</th><td>Maximum angle of deck from normal</td></tr>
<tr><th>Max Pitch Bow Down</th><td>Maximum angle of rotation from vertical,  positive bow down</td></tr>
<tr><th>Max Pitch Bow Up</th><td>Maximum angle of rotation from vertical,  positive bow up</td></tr>
<tr><th>Max Roll Left</th><td>Maximum angle of rotation from vertical,  positive portside down</td></tr>
<tr><th>Max Roll Right</th><td>Maximum angle of rotation from vertical,  positive portside up</td></tr>
<tr><th>Max TWL</th><td>Maximum total water level</td></tr>
<tr><th>Mean Dir.</th><td>Average wave direction of the full spectrum</td></tr>
<tr><th>Mean Heave Period</th><td>Mean period of vertical displacement motion</td></tr>
<tr><th>Mean Spread</th><td>Average directional spreading of the full spectrum</td></tr>
<tr><th>Mean WL</th><td>Mean total water level</td></tr>
<tr><th>Mid. Current Dir.</th><td>Middle current direction</td></tr>
<tr><th>Mid. Current Spd</th><td>Middle current speed</td></tr>
<tr><th>Mid. Current Spd</th><td>Middle current speed</td></tr>
<tr><th>MMS</th><td>Measure of motion severity</td></tr>
<tr><th>MSI</th><td>Motion severity index</td></tr>
<tr><th>Peak Current Depth</th><td>Peak current depth</td></tr>
<tr><th>Peak Current Dir.</th><td>Peak current direction</td></tr>
<tr><th>Peak Current Spd</th><td>Peak current speed</td></tr>
<tr><th>Peak Dir.</th><td>Peak wave direction of the full spectrum</td></tr>
<tr><th>Peak Spread</th><td>Directional spreading of peak frequency</td></tr>
<tr><th>Pitch</th><td>Vessel pitch</td></tr>
<tr><th>Present Weather</th><td>Present Weather in METAR coding format</td></tr>
<tr><th>QFE</th><td>Barometric pressure adjusted to field elevation</td></tr>
<tr><th>QNH</th><td>Barometric pressure adjusted to sea level</td></tr>
<tr><th>Rainfall</th><td>Total rainfall in 1 hour</td></tr>
<tr><th>Roll</th><td>Vessel roll</td></tr>
<tr><th>Sfc. Current Dir.</th><td>Surface current direction</td></tr>
<tr><th>Sfc. Current Spd</th><td>Surface current speed</td></tr>
<tr><th>Solar Rad.</th><td>Solar radiation flux density</td></tr>
<tr><th>Spectrum</th><td>Wave spectrum</td></tr>
<tr><th>Surge Acceleration</th><td>Surge acceleration</td></tr>
<tr><th>Sway Acceleration</th><td>Sway acceleration</td></tr>
<tr><th>T2</th><td>Average wave period defined by SQRT(M0/M2) from frequency domain</td></tr>
<tr><th>Tp</th><td>Spectral peak period of the full spectrum</td></tr>
<tr><th>Tz</th><td>Mean zero-upcrossing wave period from time domain</td></tr>
<tr><th>Visibility</th><td>Distance that can be seen clearly</td></tr>
<tr><th>Wind Backed</th><td>Maximum counter-clockwise extent of wind variation</td></tr>
<tr><th>Wind Chill</th><td>The apparent temperature felt on exposed skin due to wind</td></tr>
<tr><th>Wind Dir.</th><td>Vector mean direction of wind velocity</td></tr>
<tr><th>Wind Dir. (1 min)</th><td>Vector mean direction of wind velocity over 1 minute</td></tr>
<tr><th>Wind Dir. (10 min)</th><td>Vector mean direction of wind velocity over 10 minutes</td></tr>
<tr><th>Wind Selected Sensor</th><td>The selected wind sensor</td></tr>
<tr><th>Wind Spd</th><td>Scalar mean speed of wind velocity</td></tr>
<tr><th>Wind Spd (1 min)</th><td>Vector mean speed of wind velocity over 1 minute</td></tr>
<tr><th>Wind Spd (10 min)</th><td>Vector mean speed of wind velocity over 10 minutes</td></tr>
<tr><th>Wind Veered</th><td>Maximum clockwise extent of wind variation</td></tr>
</tbody>
</table>
`)).append($('<h5>Units</h5>')).append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>\xb0C</th><td>Degrees Celsius</td></tr>
<tr><th>\xb0T</th><td>Degrees True</td></tr>
<tr><th>ft</th><td>Feet</td></tr>
<tr><th>hPa</th><td>Hectopascals</td></tr>
<tr><th>kts</th><td>Knots</td></tr>
<tr><th>m</th><td>Metres</td></tr>
<tr><th>m/s</th><td>Metres per second</td></tr>
<tr><th>m/s\xb2</th><td>Metres per second squared</td></tr>
<tr><th>mm / hour</th><td>Millimetres per hour</td></tr>
<tr><th>mps</th><td>Metres per second</td></tr>
<tr><th>mW/cm\xb2</th><td>Milliwatts per square centimetre</td></tr>
<tr><th>s</th><td>Seconds</td></tr>
</tbody>
</table>
`)).append($('<h5>Other definitions</h5>')).append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>Data grouping</th><td>Where there are too many points to comfortably display on a chart, data grouping replaces a
sequence of data points in a series with a single <strong>grouped</strong> point. The values of each
<strong>grouped</strong> point is calculated from the original values of every point used. Users can select between 
<strong>average</strong>, <strong>high</strong> and <strong>low</strong> grouping approximations, which determine 
which value from the original data is used to represent the group.</td></tr>
<tr><th>Obs. time</th><td>Observation time</td></tr>
<tr><th>Pvd</th><td>Progressive vector diagram</td></tr>
<tr><th>RoC</th><td>Rate of change</td></tr>

</tbody>
</table>
`));
        $(".midi-scroll-to").on('click', function(e) {
            e.preventDefault();
            var target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top - 70
            }, 1000);
        });
    }
}











class $eeb3ccf9dc569714$export$1e4baea7053fc0e3 extends (0, $bfbbca38eee2856d$export$3f0be2c6920005ae) {
    constructor(mainSite, container, valueFormatter, station, valueObject, openPopups){
        super(mainSite), this.mainSite = mainSite;
        this.station = station;
        this.valueFormatter = valueFormatter;
        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        var cell = $('<td></td>').appendTo(container).attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.').click((e)=>{
            this.renderPopup(e, openPopups);
        });
        cell.text(valueObject.Value);
        if (valueObject.Status === null || valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expired) cell.css('font-size', '0.8em');
        if (valueObject.Status !== (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good) cell.addClass('midi_siteObsPage_expiring');
        if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level3) cell.addClass('midi_siteObsPage_exceeded_threshold_3');
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level2) cell.addClass('midi_siteObsPage_exceeded_threshold_2');
        else if (valueObject.WarningThreshold == (0, $3f0b9745f7124153$export$23811558a05557).Level1) cell.addClass('midi_siteObsPage_exceeded_threshold_1');
    }
}


class $861ab839460151df$export$955bdf2e8a60d4bc {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'table';
        this.openPopups = [];
        this.container = null;
        this.table = null;
        this.tableBody = null;
    }
    initialize() {
        this.mainSite.liveDataManager.addListener(this);
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);
        $('<a></a>').attr('href', '#').click(()=>{
            this.mainSite.changePage(this.id);
            return false;
        }).text('Table').appendTo(this.navBarLink);
    }
    handleHashChange(hashData) {
        if (this.mainSite.selectedRegion.Id == "GOM") this.navBarLink.hide();
        else this.navBarLink.show();
        if (hashData.Page === this.id && this.mainSite.selectedRegion.Id != "GOM") {
            this.navBarLink.addClass('active');
            if (!this.container) {
                this.container = $('<div class="container"></div>').appendTo('body');
                this.table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"><tbody><tr><td><span class="text-muted"><i class="fa fa-spin fa-refresh"></i> Loading table...</span></td></tr></tbody></table>').appendTo(this.container);
            }
            this.updateTable();
            return true;
        } else {
            this.navBarLink.removeClass('active');
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    liveDataChanged(latestData) {
        this.updateTable();
    }
    updateTable() {
        if (!this.mainSite.liveDataManager.latestData || !this.table) // No data received yet or table does not exist
        return;
        if (this.mainSite.selectedRegion.Id === "GOM") {
            this.paramGroupInfos = [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).DewPoint_degC,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Tp_s
            ];
            this.backupParamGroupInfos = {};
        } else {
            this.paramGroupInfos = [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindDirection_deg,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).WindSpeed_kts,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).GustSpeed_kts,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).AirTemperature_degC,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).DewPoint_degC,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).QNH_mbar,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudCover,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).First_CloudBaseHeight_ft,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Visibility_m,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Hs_m,
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).Tz_s
            ];
            this.backupParamGroupInfos = {};
            this.backupParamGroupInfos[(0, $24b391ec3014929b$export$5d65fdcfff509e37).Tz_s.Id] = [
                (0, $24b391ec3014929b$export$5d65fdcfff509e37).T2_s
            ];
        }
        this.table.empty();
        // build the header
        var headerRow = $('<tr class="midi_tablePage_main_table_header"></tr>');
        var periodsRow = $('<tr class="midi_tablePage_main_table_periods"></tr>');
        var unitsRow = $('<tr class="midi_tablePage_main_table_units"></tr>');
        $('<thead></thead').append(headerRow).append(periodsRow).append(unitsRow).appendTo(this.table);
        headerRow.append($('<th></th>').text('Station'));
        unitsRow.append($('<th></th>').text(''));
        periodsRow.append('<th></th>');
        headerRow.append($('<th></th>').text('Obs. Time'));
        var timeZoneString;
        timeZoneString = this.mainSite.getTimeZoneString();
        periodsRow.append($('<th></th>'));
        unitsRow.append($('<th></th>').text(timeZoneString));
        var periods = [];
        let unitsConverter = (0, $52db63ea8facb471$export$1a86835baa79d770).getUnitConverter();
        this.paramGroupInfos.forEach((paramGroupInfo)=>{
            var headerCell = $('<th></th>').text(paramGroupInfo.ShortName).attr('title', paramGroupInfo.Description).appendTo(headerRow);
            var unitsCell = $('<th></th>').appendTo(unitsRow);
            if (paramGroupInfo.Units) unitsCell.text(unitsConverter.getConvertedUnits(paramGroupInfo.Units, paramGroupInfo.Id));
            periods.push("");
        });
        $('<tbody class="midi_tablePage_main_table_body">').appendTo(this.table);
        var stationsOrdered = [];
        for(let stationId in this.mainSite.liveDataManager.latestData.Stations)stationsOrdered.push(this.mainSite.liveDataManager.latestData.Stations[stationId]);
        stationsOrdered.sort((a, b)=>{
            if (a.Station.RegionOrder < b.Station.RegionOrder) return -1;
            else if (a.Station.RegionOrder > b.Station.RegionOrder) return 1;
            else return b.Station.Latitude - a.Station.Latitude;
        });
        stationsOrdered.forEach((_station)=>{
            var station = _station.Station;
            if (station.Region !== this.mainSite.selectedRegion.Id) return;
            if (station.SpaceAboveInTable) $('<tr class="midi_table-spacer"><td colspan="14"></td></tr>').appendTo(this.table);
            var row = $('<tr data-siteid="' + station.Id + '"></tr>').appendTo(this.table);
            ((station)=>{
                row.append($('<td class= "midi_tablePage_main_table_body_small" ></td>').text(station.Label).attr('title', 'Click for ' + station.Label + ' station overview page').click((e)=>{
                    this.mainSite.changePage('siteObs', {
                        Station: station.Id,
                        Tab: (0, $6feb48abab9d78f7$export$432915b0d85cff8d).getLandingPageId(station)
                    });
                }));
            })(station);
            var obsTimeCell = $('<td class="midi_tablePage_main_table_obstime midi_tablePage_main_table_body_small"></td>').appendTo(row);
            var mostRecentTimeStamp = null;
            this.paramGroupInfos.forEach((paramGroupInfo, index)=>{
                let id = paramGroupInfo.Id;
                let valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(paramGroupInfo);
                if (paramGroupInfo.Id === (0, $24b391ec3014929b$export$5d65fdcfff509e37).PresentWeather.Id) valueFormatter = new (0, $49efe750b1982432$export$8ba89689dcbc989e)();
                let valueObject = valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[station.Id], this.mainSite.selectedWarningRules);
                if (valueObject.Status === null && paramGroupInfo.Id in this.backupParamGroupInfos) // parameter does not exist for this station
                this.backupParamGroupInfos[paramGroupInfo.Id].some((x)=>{
                    const _valueFormatter = new (0, $a4663bfc5dfa90cb$export$8bd1d4ad1d5568f4)(x);
                    const _valueObject = _valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[station.Id], this.mainSite.selectedWarningRules);
                    if (_valueObject.Status !== null) {
                        // we have found a suitable backup parameter. we will keep the rules from the primary parameter.
                        valueFormatter = _valueFormatter;
                        valueObject = _valueObject;
                        id = x.Id;
                        return true;
                    }
                });
                const cell = new (0, $eeb3ccf9dc569714$export$1e4baea7053fc0e3)(this.mainSite, row, valueFormatter, station, valueObject, this.openPopups);
                if (valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Good || valueObject.Status == (0, $d391c862b0fffdce$export$96e9906d6d93a972).Expiring) {
                    var timeStamp = this.mainSite.liveDataManager.latestData.Stations[station.Id].GroupValues[id][0].Timestamp;
                    if (!mostRecentTimeStamp || timeStamp < mostRecentTimeStamp) mostRecentTimeStamp = timeStamp;
                    // only look at averaging periods of values which are displayed
                    if (valueObject.ParameterDefinition) {
                        var suffix = valueObject.ParameterDefinition.Suffix;
                        if (periods[index] === "") periods[index] = suffix;
                        else if (suffix !== periods[index]) periods[index] = null;
                    }
                }
            });
            if (mostRecentTimeStamp != null) switch(this.mainSite.displayTimeType){
                case (0, $52db63ea8facb471$export$3e8712ab6ec35620).UTC:
                    obsTimeCell.text(moment.utc(mostRecentTimeStamp).format("HH:mm").toString());
                    break;
                case (0, $52db63ea8facb471$export$3e8712ab6ec35620).PcTime:
                    obsTimeCell.text(moment(moment.utc(mostRecentTimeStamp)).tz(moment.tz.guess()).format("HH:mm"));
                    break;
                case (0, $52db63ea8facb471$export$3e8712ab6ec35620).StationRegionTime:
                    obsTimeCell.text(moment(moment.utc(mostRecentTimeStamp)).tz(station.TimeZone).format("HH:mm"));
                    break;
                default:
            }
        });
        periods.forEach((period)=>{
            var cell = $('<th>');
            if (period) cell.text(period);
            periodsRow.append(cell);
        });
        $('</tbody>').appendTo(this.table);
    }
}



var $8aafbe7659c87eff$var$BASE_URL = '/api/AutoNotifications';
var $8aafbe7659c87eff$export$7676726d9cb38d1f = /*#__PURE__*/ function(DownloadPermissionType) {
    DownloadPermissionType[DownloadPermissionType["None"] = 0] = "None";
    DownloadPermissionType[DownloadPermissionType["Regional"] = 1] = "Regional";
    DownloadPermissionType[DownloadPermissionType["All"] = 2] = "All";
    return DownloadPermissionType;
}({});
function $8aafbe7659c87eff$export$4a67313ebf2ec6d8(regionId, callback) {
    $.ajax($8aafbe7659c87eff$var$BASE_URL + '/?regionId=' + encodeURIComponent(regionId), {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}
function $8aafbe7659c87eff$export$65616d87a7e5010f(regions, callback) {
    $.ajax($8aafbe7659c87eff$var$BASE_URL + '/MultiRegions/?regions=' + encodeURIComponent(regions.join(',')), {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $8aafbe7659c87eff$export$a20484f50be81dde(data, callback) {
    $.ajax($8aafbe7659c87eff$var$BASE_URL + '/RequestChanges', {
        cache: false,
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify(data),
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}
function $8aafbe7659c87eff$export$898d6323e45afbb1(data, callback) {
    $.ajax($8aafbe7659c87eff$var$BASE_URL + '/ConfirmChanges', {
        cache: false,
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify(data),
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new (0, $caf8dff7ec31a733$export$a57056401d57e984)(jqXHR), null);
        }
    });
}



class $dd8ec096a60950f0$export$c41fe2f235c3ae77 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'autoNotifications';
        this.container = null;
        this.blocks = null;
        this.$saveButton = null;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.getData();
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    topRender() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container"></div>').appendTo('body');
        $('<h1>Automatic Notifications</h1>').appendTo(this.container);
        $('<p>The email addresses listed below will receive automatic notifications in the event of a sensor drop out, for the corresponding region.</p>').appendTo(this.container);
        $('<p>Email addresses should be separated by a semi-colon (<strong>;</strong>). Click the <strong><i class="fa fa-floppy-o"></i> Save Changes</strong> button when you have finished editing.</p>').appendTo(this.container);
        this.$saveButton = $('<button type="button" class="btn btn-success midi_autoNotificationsPage_saveChangesButton"><i class="fa fa-floppy-o"></i> Save Changes</button>').prop('disabled', true).appendTo(this.container).click(()=>{
            let valid = true;
            for(let i = 0; i < this.blocks.length; i++){
                this.validate(this.blocks[i]);
                if (this.blocks[i].invalidEmailAddresses.length) {
                    this.blocks[i].warning.text("The following email addresses are invalid: " + this.blocks[i].invalidEmailAddresses.join("; ")).show();
                    this.blocks[i].emailContainer.addClass("has-error");
                    valid = false;
                } else {
                    this.blocks[i].emailContainer.removeClass("has-error");
                    this.blocks[i].warning.hide();
                }
            }
            if (valid) this.modifyEmailAddresses();
        });
    }
    getData() {
        this.mainSite.pageBlock("Retrieving data...");
        this.blocks = [];
        let regionsIds = [];
        this.topRender();
        for(let key in this.mainSite.staticDataManager.Schema.RegionSet.Regions){
            regionsIds.push(key);
            this.blocks.push({
                regionId: key,
                currentEmails: [],
                invalidEmailAddresses: [],
                newEmailAddresses: [],
                heading: $('<h3></h3>').text(this.mainSite.staticDataManager.Schema.RegionSet.Regions[key].Label),
                emailContainer: $('<textarea rows="8" cols="80" class="midi_autoNotificationsPage_box" placeholder="Enter email addresses here"></textarea>'),
                warning: $('<div class="alert alert-danger"></div>').hide()
            });
        }
        this.blocks.sort((a, b)=>{
            if (a.regionId < b.regionId) return -1;
            if (a.regionId > b.regionId) return 1;
            return 0;
        });
        regionsIds.sort((a, b)=>{
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
        (0, $8aafbe7659c87eff$export$65616d87a7e5010f)(regionsIds, (err, data)=>{
            if (err) {
                new (0, $07be79b8daca7111$export$3efe75ad489a5e73)("Server Error", "Unable to retrieve data for this page: " + err.Message).show();
                this.mainSite.pageUnblock();
                return;
            }
            this.$saveButton.prop('disabled', false);
            let ii = 0;
            for(let regionId in data.Data){
                let item = data.Data[regionId];
                this.blocks.filter((x)=>x.regionId == regionId).forEach((block)=>{
                    block.currentEmails = item.EmailRecipientsList;
                    let emailsText = block.currentEmails ? block.currentEmails.join("; ") : "";
                    block.heading.appendTo(this.container);
                    block.warning.appendTo(this.container);
                    block.emailContainer.appendTo(this.container).val(emailsText);
                    ii++;
                    if (ii == this.blocks.length - 1) this.mainSite.pageUnblock();
                });
            }
        });
    }
    modifyEmailAddresses() {
        this.mainSite.pageBlock("Sending changes request to the server...");
        let data = {
            Regions: []
        };
        for(let i = 0; i < this.blocks.length; i++){
            let rd = {
                RegionId: this.blocks[i].regionId,
                EmailAddresses: this.blocks[i].newEmailAddresses
            };
            data.Regions.push(rd);
        }
        (0, $8aafbe7659c87eff$export$a20484f50be81dde)(data, (err, data)=>{
            if (err) {
                this.blocks[0].warning.text("Error updating email addresses: " + err.Message);
                this.blocks[0].warning.show();
                this.mainSite.pageUnblock();
                return;
            }
            this.blocks[0].warning.hide();
            let confirmRemovesCount = 0;
            let regionsGroupedMessages = [];
            data.Regions.forEach((region)=>{
                let regionMessages = [];
                if (region.EmailsRemoved.length > 0) region.EmailsRemoved.forEach((email)=>{
                    regionMessages.push(`<i class="fa fa-fw fa-lg fa-minus-square text-danger"></i> <span class="label label-danger">REMOVE</span> ${email}`);
                    confirmRemovesCount++;
                });
                if (region.EmailsAdded.length > 0) region.EmailsAdded.forEach((email)=>{
                    regionMessages.push(`<i class="fa fa-fw fa-lg fa-plus text-success"></i> <span class="label label-success">ADD</span> ${email}`);
                });
                if (regionMessages.length > 0) regionsGroupedMessages.push(`<strong>${region.RegionLabel}:</strong><br>${regionMessages.join('<br>')}`);
            });
            if (regionsGroupedMessages.length > 0) {
                let _html = "<p><em>You are about to make the following modifications. <strong>Please confirm this is correct.</strong></em></p>";
                if (confirmRemovesCount > 0) _html += "<p class=\"text-muted\">Note: each removed email will be sent a notification that they were removed from the list of recipients.</p>";
                _html += `<p>${regionsGroupedMessages.join('</p><p>')}</p>`;
                let sd = new (0, $07be79b8daca7111$export$3efe75ad489a5e73)("Confirm changes", _html, true, true, (_sd)=>{
                    this.mainSite.pageBlock("Sending confirmation of changes to the server...");
                    (0, $8aafbe7659c87eff$export$898d6323e45afbb1)(data, (err, data)=>{
                        if (err) {
                            this.blocks[0].warning.text("Error updating email addresses: " + err.Message);
                            this.blocks[0].warning.show();
                            this.mainSite.pageUnblock();
                            return;
                        }
                        this.blocks[0].warning.hide();
                        this.mainSite.pageUnblock();
                        new (0, $07be79b8daca7111$export$3efe75ad489a5e73)("Success", "You have successfully updated the automatic notification settings.").show();
                    });
                    _sd.hide();
                });
                this.mainSite.pageUnblock();
                sd.show();
            }
        });
    }
    validate(block) {
        let emailAddresses = block.emailContainer.val().split(";");
        block.newEmailAddresses = [];
        block.invalidEmailAddresses = [];
        for(let i = 0; i < emailAddresses.length; i++){
            emailAddresses[i] = emailAddresses[i].trim();
            if (emailAddresses[i] !== "") {
                let emailValid = this.validateEmailAddress(emailAddresses[i]);
                if (!emailValid && emailAddresses[i]) block.invalidEmailAddresses.push(emailAddresses[i]);
                else block.newEmailAddresses.push(emailAddresses[i]);
            }
        }
    }
    validateEmailAddress(s) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(s);
    }
}


var $8610fc92097e2395$var$BASE_URL = '/api/AutoNotificationThresholds';
const $8610fc92097e2395$export$ee8c5cffe32fc5e1 = [
    "title",
    "expanded",
    "folder",
    "icon",
    "children",
    "NodeType",
    "RegionId",
    "RegionLabel",
    "StationId",
    "StationLabel",
    "SensorId",
    "SensorLabel",
    "ParameterId",
    "ParameterLabel",
    "AutoNotificationThreshold",
    "TreeNodeThresholdMinutes",
    "TreeNodeThresholdInheritFrom"
];
function $8610fc92097e2395$export$2774c37398bee8b2(callback) {
    $.ajax($8610fc92097e2395$var$BASE_URL + '/Get/All', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new RESTError(jqXHR), null);
        }
    });
}
function $8610fc92097e2395$export$9eeae14280545765(callback) {
    $.ajax($8610fc92097e2395$var$BASE_URL + '/Get/TreeData', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 180000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new RESTError(jqXHR), null);
        }
    });
}
function $8610fc92097e2395$export$9498728a968f4980(data, callback) {
    $.ajax($8610fc92097e2395$var$BASE_URL + '/Set', {
        cache: false,
        type: 'POST',
        data: data,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data, jqXHR);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new RESTError(jqXHR), null, jqXHR);
        }
    });
}
function $8610fc92097e2395$export$c8006ce14ca9172e(data, callback) {
    $.ajax($8610fc92097e2395$var$BASE_URL + '/Delete', {
        cache: false,
        type: 'POST',
        data: data,
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(new RESTError(jqXHR), null);
        }
    });
}



class $8047f304747b3dc0$export$ec8eae642da3f1b7 {
    constructor(mainSite){
        this.mainSite = mainSite;
        this.id = 'autoNotificationThresholds';
        this.hasLiveData = false;
        this.container = null;
        this.pageHeaderContainer = null;
        this.loadingContainer = null;
        this.table = null;
        this.tableBody = null;
        this.tableHead = null;
        this.tableHeadRow = null;
        this.modal = null;
        this.tree = null;
        this.$treeCont = null;
        this.filterInput = null;
        this.filterItemsSetCheckbox = null;
        this.checkboxEnableRowClick = null;
        this.isEditingEntry = false;
    }
    initialize() {}
    handleHashChange(hashData) {
        if (hashData.Page === this.id) {
            if (!this.container) this.refresh();
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    refresh() {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
        this.container = $('<div class="container no-select"></div>').appendTo('body');
        this.pageHeaderContainer = $('<div>').addClass('clearfix page-inner-header').appendTo(this.container);
        $('<h1 class="midi_manageUsersPage_title">Manage Outage Notification Thresholds</h1>').appendTo(this.pageHeaderContainer);
        this.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(this.container);
        (0, $8610fc92097e2395$export$9eeae14280545765)((err, data)=>{
            if (err) this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Unable to get list of data from server: ' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(err.Message));
            else this.loadingContainer.removeClass('alert-danger').addClass('alert-info').html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...');
            const valid = this.checkReceivedDataIntegrity(data);
            if (!valid) this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> The data received from the server does not seem valid. As a security measure, the page will not load the data received.');
            else {
                this.data = data;
                if (this.mainSite.liveDataManager.latestData == null) this.mainSite.liveDataManager.addListener(this);
                else {
                    this.hasLiveData = true;
                    this.render();
                }
            }
        });
    }
    checkReceivedDataIntegrity(data) {
        let result = true;
        if (data && data.TreeNodes && $.isArray(data.TreeNodes)) for(let i = 0; i < data.TreeNodes.length; i++){
            result = this.checkNodeDataKeysValidity(data.TreeNodes[i]);
            if (!result) return false;
        }
        return result;
    }
    checkNodeDataKeysValidity(node) {
        let result = Object.keys(node).every((x)=>(0, $8610fc92097e2395$export$ee8c5cffe32fc5e1).indexOf(x) >= 0); //: inspired from https://stackoverflow.com/a/44240254/753113
        if (result && node.children && $.isArray(node.children)) for(let i = 0; i < node.children.length; i++){
            result = this.checkNodeDataKeysValidity(node.children[i]);
            if (!result) return false;
        }
        return result;
    }
    liveDataChanged(latestData) {
        if (!this.hasLiveData && latestData !== null) {
            this.hasLiveData = true;
            this.render();
        }
    }
    render() {
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you can  manage Outage Notifications Thresholds across all regions.</p>').appendTo(this.container);
        else {
            var region = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(region.Label) + '</strong> region, you can manage Outage Notifications Thresholds for sites within your region.</p>').appendTo(this.container);
        }
        $('<p class="midi_manageUsersPage_topParagraph">Thresholds are hierarchical. Where a threshold is set to a Parameter, it will be used. If a Parameter does not have a threshold set, but either its Sensor <strong>or</strong> Station have a threshold set, then the latter will be used for that Parameter (it is <em>inherited</em> from the closest parent). If a Parameter does not have a threshold set, and nor does its Sensor and Station, then the default threshold will be used.</p>').appendTo(this.container);
        $('<p class="midi_manageUsersPage_topParagraph" style="margin-bottom:30px;">Click on a row or on the edit button to modify a threshold. Thresholds are indicated like so:<br>- <em class="text-muted op-fade op-hover-100 op-40">60&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em> The <strong>default</strong> threshold to be used when none set or inherited,<br>- <strong class="text-primary">120&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> The threshold is <strong>set</strong> against this item (either Parameter, Sensor or Station, but not by way of inheritance from a parent item),<br>- <em class="text-primary"><i class="fa fa-fw fa-mail-reply-all fa-rotate-180 op-40"></i> 90&nbsp;&nbsp;</em> The threshold is <strong>inherited</strong> from a parent item (either the Sensor if it has a threshold set, or the Station).</p>').appendTo(this.container);
        let $innerNavWrap = $('<div>').appendTo(this.container);
        let $innerNavWrapRow = $('<div>').addClass('row').appendTo($innerNavWrap);
        let $innerNav = $('<div>').addClass('btn-group btn-group-sm').appendTo($('<div>').addClass('col-sm-3').appendTo($innerNavWrapRow));
        let $innerFilterWrap = $('<div>').addClass('input-group input-group-sm').appendTo($('<div>').addClass('col-sm-3').appendTo($innerNavWrapRow));
        let $innerExtrasWrap = $('<div>').addClass('col-sm-6').appendTo($innerNavWrapRow);
        let $table = $('<table>').addClass('table table-hover midi_common_table').appendTo(this.container);
        $table.append('<colgroup><col width="*"></col><col width="90px"></col><col width="50px"></col></colgroup>');
        $table.append('<thead><tr><th></th><th class="text-center">Threshold <span class="text-muted op-60">(Minutes)</span></th><th></th></tr></thead>');
        $table.append('<tbody></tbody>');
        let treeOpts = {
            extensions: [
                "table",
                "filter"
            ],
            checkbox: false,
            table: {
                indentation: 20,
                nodeColumnIdx: 0,
                checkboxColumnIdx: -1 // render the checkboxes into the 1st column
            },
            filter: {
                autoApply: false,
                autoExpand: true,
                counter: false,
                fuzzy: true,
                hideExpanders: true,
                highlight: true,
                mode: 'hide'
            },
            source: this.data.TreeNodes,
            clickFolderMode: 4,
            click: (event, data)=>{
                if (data.targetType == "expander") {
                    console.info("NODE CLICK - EXPANDER (IGNORED)", {
                        event: event,
                        data: data
                    });
                    return true; //: otherwise expansion of folders may be prevents further down.
                } else {
                    if (this.checkboxEnableRowClick.is(":checked")) this.renderModalEdit(data.node);
                    else return true;
                }
                return false; //: NB: this prevents expansion of folders.
            },
            renderColumns: (event, data)=>{
                let node = data.node, $tdList = $(node.tr).find(">td");
                let tnd = data.node.data;
                $tdList.eq(1).addClass("text-right");
                $tdList.eq(2).addClass("text-center");
                if (tnd.NodeType !== "Region") {
                    $tdList.eq(1).html(this.treeGenerateMinutesCellHTMLString(tnd));
                    let $edit = $('<button>').appendTo($tdList.eq(2)).addClass('btn btn-xs btn-link').html('<i class="fa fa-fw fa-lg fa-pencil-square-o"></i> <span class="sr-only">Edit</span>').on("click", (e)=>{
                        e.stopPropagation();
                        $(e.target).blur();
                        this.renderModalEdit(node);
                    });
                }
            },
            renderTitle: (event, data)=>{
                let tnd = data.node.data;
                if (tnd.NodeType == "Region") return `<span class="fancytree-title"><i class="fa fa-fw fa-lg ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('region')}"></i> <strong>${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(data.node.title)}</strong></span>`;
                else if (tnd.NodeType == "Station") return `<span class="fancytree-title" title="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)}"><i class="fa fa-fw fa-lg  ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('station')}"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(data.node.title)}</span>`;
                else if (tnd.NodeType == "Sensor") return `<span class="fancytree-title" title="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)} / ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.StationLabel)}"><i class="fa fa-fw  ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('sensor')}"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(data.node.title)}</span>`;
                else return `<span class="fancytree-title" title="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)} / ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.StationLabel)} / ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.SensorLabel)}"><i class="fa fa-fw  ${(0, $52db63ea8facb471$export$1a86835baa79d770).getAwesomeIconClass('parameter')}"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(data.node.title)}</span>`;
            }
        };
        $table.fancytree(treeOpts);
        this.$treeCont = $table;
        this.tree = $table.fancytree('getTree');
        //: add buttons to nav, input/buttons to filter:
        $('<button>').appendTo($innerNav).addClass('btn btn-default').html('<i class="fa fa-fw fa-minus-square"></i> <span>Collapse All</span>').on("click", (e)=>{
            this.treeExpand(false);
            $(e.target).blur();
        });
        $('<button>').appendTo($innerNav).addClass('btn btn-default').html('<i class="fa fa-fw fa-plus-square"></i> <span>Expand All</span>').on("click", (e)=>{
            this.treeExpand(true);
            $(e.target).blur();
        });
        let $checkboxWrap = $('<label>').addClass('checkbox-inline').text('Show only items with thresholds set').appendTo($innerExtrasWrap);
        this.filterItemsSetCheckbox = $('<input type="checkbox">').prependTo($checkboxWrap).on("change", (e)=>{
            this.treeApplyFilters();
        });
        $checkboxWrap = $('<label class="checkbox-inline" data-toggle="tooltip" title="Untick this box to disable the editor upon clicking on a row (use the edit button only).">Clicking a row opens the editor</label>').appendTo($innerExtrasWrap);
        this.checkboxEnableRowClick = $('<input type="checkbox" checked>').prependTo($checkboxWrap);
        $('<span class="input-group-addon"><i class="fa fa-fw fa-filter"></i></span>').appendTo($innerFilterWrap);
        this.filterInput = $('<input type="search" placeholder="Filter..." />').addClass('form-control').appendTo($innerFilterWrap);
        $('<button>').appendTo($('<span class="input-group-btn"></span>').appendTo($innerFilterWrap)).addClass('btn btn-default').html('<i class="fa fa-fw fa-times"></i> <span class="sr-only">Clear filter</span>').on("click", (e)=>{
            $(e.target).blur();
            this.filterInput.val('');
            // this.tree.clearFilter();
            this.treeApplyFilters();
        });
        this.filterInput.on("keyup", (e)=>{
            this.treeApplyFilters();
        });
        $('[data-toggle="tooltip"]').tooltip();
        this.loadingContainer.hide();
    }
    treeApplyFilters() {
        const onlyWithSetThreshold = this.filterItemsSetCheckbox.is(":checked");
        try {
            $(this.filterInput).val().replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
            let val = (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString($(this.filterInput).val()).toUpperCase();
            this.tree.filterNodes((node)=>{
                let tnd = node.data;
                if (val == ":SET") {
                    if (tnd.AutoNotificationThreshold == null) return false;
                    else return true;
                }
                if ((node.title.toUpperCase().indexOf(val) >= 0 || tnd.RegionLabel.toUpperCase().indexOf(val) >= 0 || tnd.StationLabel && tnd.StationLabel.toUpperCase().indexOf(val) >= 0 || tnd.SensorLabel && tnd.SensorLabel.toUpperCase().indexOf(val) >= 0 || tnd.ParameterLabel && tnd.ParameterLabel.toUpperCase().indexOf(val) >= 0) && (!onlyWithSetThreshold || tnd.AutoNotificationThreshold !== null)) return true;
                return false;
            });
        } catch (err) {
            console.warn("Tree filter error: ", err);
        }
    }
    treeExpand(expand = true) {
        this.mainSite.pageBlock();
        expand = expand !== false;
        this.tree.visit((node)=>{
            if (node.hasChildren() && node.isExpanded() !== expand) node.setExpanded(expand);
        });
        this.mainSite.pageUnblock();
    }
    treeGenerateMinutesCellHTMLString(tnd) {
        let result = "";
        if (tnd.NodeType !== "Region") {
            if (tnd.TreeNodeThresholdInheritFrom == "Default") result = `<em class="text-muted op-fade op-hover-100 op-40" title="None set (uses default threshold)" data-toggle="tooltip">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.TreeNodeThresholdMinutes.toString())}</em>`;
            else if (tnd.NodeType == tnd.TreeNodeThresholdInheritFrom && tnd.AutoNotificationThreshold !== null) result = `<strong class="text-primary" title="Set on this ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.NodeType)}" data-toggle="tooltip">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.AutoNotificationThreshold.MinutesThreshold.toString())}</strong>`;
            else result = `<em class="text-primary" title="Inherited from ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.TreeNodeThresholdInheritFrom)}" data-toggle="tooltip"><i class="fa fa-fw fa-mail-reply-all fa-rotate-180 op-40"></i> ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.TreeNodeThresholdMinutes.toString())}</em>`;
        }
        return result;
    }
    finishEditing() {
        $('[data-toggle="tooltip"]:not([data-original-title])').tooltip(); //: helps by re-applying tooltips on edited cells/contents.
        this.isEditingEntry = false;
        this.mainSite.pageUnblock();
    }
    updateTreeNodesAfterEdit(node, editResponse) {
        let tnd = node.data;
        tnd.AutoNotificationThreshold = editResponse.AutoNotificationThreshold;
        if (editResponse.AutoNotificationThreshold == null) {
            let parentWithThreshold = this.checkParentNodes(node, editResponse);
            if (parentWithThreshold !== null && parentWithThreshold.AutoNotificationThreshold) {
                tnd.TreeNodeThresholdMinutes = parentWithThreshold.AutoNotificationThreshold.MinutesThreshold;
                tnd.TreeNodeThresholdInheritFrom = parentWithThreshold.NodeType;
            } else {
                tnd.TreeNodeThresholdMinutes = editResponse.AutoNotificationThreshold !== null ? editResponse.AutoNotificationThreshold.MinutesThreshold : this.data.DefaultMinutesThreshold;
                tnd.TreeNodeThresholdInheritFrom = editResponse.AutoNotificationThreshold !== null ? tnd.NodeType : "Default";
            }
        } else {
            tnd.TreeNodeThresholdMinutes = editResponse.AutoNotificationThreshold.MinutesThreshold;
            tnd.TreeNodeThresholdInheritFrom = tnd.NodeType;
        }
        $(node.tr).find(">td").eq(1).html(this.treeGenerateMinutesCellHTMLString(tnd));
        //: update any children:
        if (node.hasChildren()) this.updateTreeChildrenNodes(node.children, node, editResponse);
        else this.finishEditing();
    }
    checkParentNodes(node, editResponse) {
        let parentWithThresholdMatched = null;
        node.visitParents((parent)=>{
            let parentTnd = parent.data;
            if (parentTnd.AutoNotificationThreshold !== null) {
                parentWithThresholdMatched = parentTnd;
                return false;
            }
        });
        return parentWithThresholdMatched;
    }
    updateTreeChildrenNodes(children, parent, editResponse) {
        let parentTnd = parent.data;
        children.forEach((node, i)=>{
            let tnd = node.data;
            if (tnd.AutoNotificationThreshold !== null) return;
            if (tnd.AutoNotificationThreshold == null && editResponse.AutoNotificationThreshold !== null) {
                tnd.TreeNodeThresholdMinutes = editResponse.AutoNotificationThreshold.MinutesThreshold;
                tnd.TreeNodeThresholdInheritFrom = parentTnd.NodeType;
            }
            if (tnd.AutoNotificationThreshold == null && editResponse.AutoNotificationThreshold == null) {
                let parentWithThreshold = this.checkParentNodes(node, editResponse);
                if (parentWithThreshold !== null && parentWithThreshold.AutoNotificationThreshold) {
                    tnd.TreeNodeThresholdMinutes = parentWithThreshold.AutoNotificationThreshold.MinutesThreshold;
                    tnd.TreeNodeThresholdInheritFrom = parentWithThreshold.NodeType;
                } else {
                    tnd.TreeNodeThresholdMinutes = editResponse.AutoNotificationThreshold !== null ? editResponse.AutoNotificationThreshold.MinutesThreshold : this.data.DefaultMinutesThreshold;
                    tnd.TreeNodeThresholdInheritFrom = editResponse.AutoNotificationThreshold !== null ? tnd.NodeType : "Default";
                }
            }
            $(node.tr).find(">td").eq(1).html(this.treeGenerateMinutesCellHTMLString(tnd));
            if (node.hasChildren()) this.updateTreeChildrenNodes(node.children, node, editResponse);
            else this.finishEditing();
        });
    }
    renderModalEdit(node) {
        $('[data-toggle="tooltip"]').tooltip('hide');
        if (this.isEditingEntry) {
            console.warn("NODE CLICK ERROR: an entry is already being (or about to be) edited. Please wait for edition to be completed before trying to edit another entry.");
            return;
        }
        const tnd = node.data;
        if (tnd.NodeType == "Region") {
            console.warn("NODE CLICK IGNORED: user clicked a 'Region' node.");
            return;
        }
        this.isEditingEntry = true;
        this.mainSite.pageBlock();
        const addNew = tnd.AutoNotificationThreshold == null;
        let modalDataClone = tnd.AutoNotificationThreshold !== null ? {
            ...tnd.AutoNotificationThreshold
        } : {
            Id: null,
            StationId: tnd.StationId,
            SensorId: tnd.SensorId,
            ParameterId: tnd.ParameterId,
            MinutesThreshold: null
        }; //: use a clone or new object to help update data
        const defaultThreshold = this.data.DefaultMinutesThreshold;
        const appliesToLabel = `${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.RegionLabel)} / ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.StationLabel)}${tnd.NodeType == "Sensor" || tnd.NodeType == "Parameter" ? ' / ' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.SensorLabel) : ''}${tnd.NodeType == "Parameter" ? ' / ' + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.ParameterLabel) : ''}`;
        // console.info("MODAL: ", { addNew: addNew, node: node, tnd: tnd, modalDataClone: modalDataClone });
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }
        this.modal = $('<div class="modal fade" data-backdrop="static"></div>').appendTo('body');
        let modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        let modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        //: Modal Header:
        let modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) $('<h4 class="modal-title">Set Outage Notification Threshold</h4>').appendTo(modalHeaderContent);
        else $('<h4 class="modal-title">Edit Outage Notification Threshold</h4>').appendTo(modalHeaderContent);
        //: Modal Content:
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        let modalFeedbackWrap = $('<div class="modal-feedback"></div>').appendTo(this.modalBodyContent);
        //: Form wrapper:
        let modalForm = $('<form></form>').appendTo(this.modalBodyContent);
        modalForm.addClass("form-horizontal");
        modalForm.on("submit", (e)=>{
            return false;
        });
        //: reusable Jquery placeholders + input elements:
        let $row, $label, $field;
        let $inputMinutesThreshold;
        //: Field: Station/Sensor/Param (info, non-editable):
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $label = $('<label class="col-sm-3 control-label">Applies to:</label>').appendTo($row);
        $field = $('<div class="col-sm-9"></div>').appendTo($row);
        $(`<p class="form-control-static">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(appliesToLabel)}</p>`).appendTo($field);
        //: Field: level of item (info, non-editable):
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $label = $('<label class="col-sm-3 control-label">Level:</label>').appendTo($row);
        $field = $('<div class="col-sm-9"></div>').appendTo($row);
        $(`<p class="form-control-static">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.NodeType)}</p>`).appendTo($field);
        //: Field: threshold inheritance (info, non-editable):
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $label = $('<label class="col-sm-3 control-label">Inheritance:</label>').appendTo($row);
        $field = $('<div class="col-sm-9"></div>').appendTo($row);
        if (tnd.AutoNotificationThreshold !== null && tnd.TreeNodeThresholdInheritFrom == tnd.NodeType) $(`<p class="form-control-static"><em class="text-muted">none (threshold set for this ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.NodeType)})</em></p>`).appendTo($field);
        else $(`<p class="form-control-static"><span class="text-primary">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.TreeNodeThresholdMinutes.toString())}</span> minutes from <em class="text-primary">${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.TreeNodeThresholdInheritFrom)}</em></p>`).appendTo($field);
        //: Field: minutes threshold value:
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $label = $('<label class="col-sm-3 control-label">Threshold:</label>').appendTo($row);
        $field = $('<div class="col-sm-4"></div>').appendTo($row); //: NB: not using full-width here..
        let $ig = $('<div>').addClass('input-group input-group-sm').appendTo($field);
        $inputMinutesThreshold = $(`<input class="form-control" type="number" min="0" placeholder="${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(defaultThreshold.toString())}" value="${tnd.AutoNotificationThreshold == null ? '' : (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(tnd.AutoNotificationThreshold.MinutesThreshold.toString())}" />`).appendTo($ig);
        $('<span>').addClass('input-group-addon').text('Minutes').appendTo($ig);
        //: additional event handlers:
        modalForm.find(':input').on('change', (e)=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            modalForm.addClass('data-changed');
            window.onbeforeunload = ()=>{
                return "You have unsaved modifications on this page. If you navigate away from the page, your modifications will not be saved.";
            };
        });
        //: Footer:
        let modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success">Save</button>').appendTo(modalFooterContent).click(()=>{
            // console.info("save...", { old: currentSetting, new: modalDataClone });
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            let errors = [];
            if (isNaN(parseInt($inputMinutesThreshold.val())) || $inputMinutesThreshold.val() == '') errors.push("Please set a valid number for the minutes threshold to use.");
            if (errors.length > 0) {
                modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                return false;
            }
            //: ensure we have values from the modal form:
            modalDataClone.MinutesThreshold = parseInt($inputMinutesThreshold.val());
            if (errors.length == 0) {
                const req = modalDataClone;
                this.mainSite.pageBlock();
                (0, $8610fc92097e2395$export$9498728a968f4980)(req, (err, data, xhr)=>{
                    if (err) {
                        errors.push("Server error: " + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(err.Message));
                        modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                        this.mainSite.pageUnblock();
                        return false;
                    }
                    modalForm.removeClass('data-changed');
                    if (xhr.status !== 304) this.updateTreeNodesAfterEdit(node, data); //: NB: this calls this.finishEditing() to return UI to usable state.
                    this.modal.modal('hide');
                });
            }
        });
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);
        if (!addNew) this.modalDeleteButton = $('<button type="button" class="btn btn-danger pull-left">Reset to default</button>').prependTo(modalFooterContent).click(()=>{
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            let errors = [];
            if (errors.length > 0) {
                modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                return false;
            }
            if (errors.length == 0) {
                let conf = confirm(`Are you certain you wish to permanently delete the settings for ${(0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(appliesToLabel)}?`);
                if (conf) {
                    const req = {
                        Id: tnd.AutoNotificationThreshold.Id,
                        StationId: tnd.AutoNotificationThreshold.StationId
                    };
                    (0, $8610fc92097e2395$export$c8006ce14ca9172e)(req, (err, data)=>{
                        if (err) {
                            errors.push("Server error: " + (0, $52db63ea8facb471$export$1a86835baa79d770).escapeString(err.Message));
                            modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                            this.mainSite.pageUnblock();
                            return false;
                        }
                        modalForm.removeClass('data-changed');
                        this.updateTreeNodesAfterEdit(node, data); //: NB: this calls this.finishEditing() to return UI to usable state.
                        this.modal.modal('hide');
                    });
                }
            }
        });
        this.modal.on('shown.bs.modal', (e)=>{
            this.mainSite.pageUnblock();
        });
        this.modal.on('hide.bs.modal', (e)=>{
            if (modalForm.hasClass('data-changed')) {
                let conf = confirm("You have unsaved changes on this popup.\n\nAre you sure you wish to cancel and close the popup?");
                if (!conf) return false;
            }
        });
        this.modal.on('hidden.bs.modal', (e)=>{
            this.modal.remove();
            this.modal = null;
            this.isEditingEntry = false;
            this.mainSite.pageUnblock();
            window.onbeforeunload = null;
        });
        this.modal.modal('show');
    }
}


var $2326b5a79b00338a$var$BASE_URL = '/api/LiveData';
function $2326b5a79b00338a$export$262254f3241cb5cf(callback) {
    $.ajax($2326b5a79b00338a$var$BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data, text, jqXHR)=>{
            callback(null, data);
        },
        error: (jqXHR, textStatus, errorThrown)=>{
            callback(errorThrown, null);
        }
    });
}


class $85ea18c47a274df3$export$bfc11a595882ce5b {
    addListener(listener) {
        this.listeners.push(listener);
    }
    start() {
        this.cancelled = false;
        this.refresh(true);
    }
    stop() {
        this.cancelled = true;
    }
    refresh(repeat = false) {
        (0, $2326b5a79b00338a$export$262254f3241cb5cf)((err, data)=>{
            if (this.cancelled) return;
            if (data !== null) this.latestData = data;
            this.listeners.forEach((listener)=>{
                try {
                    listener.liveDataChanged(this.latestData, null);
                } catch (error) {}
            });
            if (repeat && !this.timeoutWaiting) {
                window.setTimeout(()=>{
                    this.timeoutWaiting = false;
                    this.refresh(true);
                }, this.interval);
                this.timeoutWaiting = true;
            }
        });
    }
    constructor(){
        this.interval = 30000;
        this.latestData = null;
        this.listeners = [];
        this.timeoutWaiting = false;
    }
}


var $52db63ea8facb471$export$3e8712ab6ec35620 = /*#__PURE__*/ function(DisplayTimeType) {
    DisplayTimeType["UTC"] = "UTC";
    DisplayTimeType["PcTime"] = "Pc Time";
    DisplayTimeType["StationRegionTime"] = "Station/Region Time";
    DisplayTimeType["StationTime"] = "Station Time";
    return DisplayTimeType;
}({});
var $52db63ea8facb471$var$_unitConverter;
class $52db63ea8facb471$export$1a86835baa79d770 {
    static run() {
        $52db63ea8facb471$export$1a86835baa79d770.instance = new $52db63ea8facb471$export$1a86835baa79d770();
        $(()=>{
            $52db63ea8facb471$export$1a86835baa79d770.instance.currentLoginPage = new (0, $e51d30a246217e6f$export$f14c0e3f98d164c0)();
            $52db63ea8facb471$export$1a86835baa79d770.instance.currentLoginPage.render();
            $52db63ea8facb471$export$1a86835baa79d770.instance.tryLogin();
        });
    }
    static getUnitConverter() {
        if (!$52db63ea8facb471$var$_unitConverter) {
            let ucOptKey = (0, $f423c86e63025694$export$369c46f21624ab3a);
            let ucOptVal = $52db63ea8facb471$export$1a86835baa79d770.localStorageGet(ucOptKey, undefined); //: uses the first enum option as a default.
            $52db63ea8facb471$var$_unitConverter = new (0, $4eb6084635bdf082$export$35091a304fd420cb)((0, $f423c86e63025694$export$796b35110415361b)(ucOptVal));
        }
        return $52db63ea8facb471$var$_unitConverter;
    }
    constructor(){
        this.staticDataManager = new (0, $b71f12c6d614c68e$export$e6fac6e2831a7e0c)();
        this.hashDataManager = new (0, $0c26b1f9a32f22f6$export$2e5b55ed27df6e11)();
        this.modal = null;
        this.displayTimeType = null;
        this.basicViewSelectorBool = null;
        this.selectedWarningRules = null;
        this.selectedRegion = null;
        this.pages = [
            new (0, $5fa05bf4f86fed5f$export$213b832c8898a3e1)(this),
            new (0, $861ab839460151df$export$955bdf2e8a60d4bc)(this),
            new (0, $98a6c938873fa897$export$529d77624eeace21)(this),
            //...(((this.selectedRegion) && (this.selectedRegion.Id == "GOM"))
            //    ? [new GOMTablePage(this)]
            //    : [new TablePage(this)]),
            //...(this.selectedRegion?.Id !== "GOM"
            //    ? [new TablePage(this)]
            //    : []),
            //...(true
            //    ? [new GOMTablePage(this)]
            //    : []),
            new (0, $b01a240ac09ad487$export$cdddf4d2bf535e26)(this),
            new (0, $6feb48abab9d78f7$export$432915b0d85cff8d)(this),
            new (0, $4bb487869fb3a4b9$export$5bbd98196cb66ba8)(this),
            new (0, $f261ea049028d499$export$15590c1ff66dab4)(this),
            new (0, $601490302ecedb8f$export$e5a161874de28443)(this),
            new (0, $a61c85924a8d2ca1$export$47bc8c4da376913b)(this),
            new (0, $dd8ec096a60950f0$export$c41fe2f235c3ae77)(this),
            new (0, $76904d5bf2f2b36c$export$3b628956c133cac7)(this),
            new (0, $242442f944181932$export$f258f7b590b5b095)(this),
            new (0, $2c06be4c877f41e8$export$7cb8074de2a08079)(this),
            new (0, $8047f304747b3dc0$export$ec8eae642da3f1b7)(this),
            new (0, $98dff5d8a5ad4885$export$5ad692d53399ec36)(this)
        ];
        this.navBar = new (0, $a1e5cb2ae53999f6$export$ef8da11641c635de)();
        //regionalAdminPopover = $('<strong data-toggle="popover" role="button" data-placement="bottom" title="Regional Administrators" data-content="North Sea Administrator">Regional Administrator</strong>').popover({ html: true });
        this._regionalAdministrators = null;
        this.currentLoginPage = null;
        this.liveDataManager = new (0, $85ea18c47a274df3$export$bfc11a595882ce5b)();
        this.GOMAveragesManager = new (0, $4acb3cf7b4b3d043$export$dbda8fa3766d94fa)();
        this.scroller = function(stations, callback, timeout) {
            let i = 0;
            let j = 0;
            let caller = ()=>{
                callback(stations[i].stationId, stations[i].params[j]);
                if (j == stations[i].params.length - 1) {
                    j = 0;
                    if (i == stations.length - 1) i = 0;
                    else i++;
                } else j++;
                setTimeout(caller, timeout);
            };
            caller();
        };
        this.userNavMenu = null;
        this.regionSelector = null;
        this.regionSelectorSpan = null;
        this.stationSelector = null;
        this.selectedStationSpan = null;
        this.warningRulesSelector = null;
        this.warningRulesDropdown = null;
        this.warningRulesSelectorSpan = null;
        this._pageBlockJquerySelector = window //: NB: this should correspond to one single element, otherwise onBlock option will be executed once for each matching element! (so I've added blocking of the navbar separately!)
        ;
        this.pages.forEach((page)=>{
            page.initialize();
        });
    }
    retrieveRegionalAdministrators(callback) {
        if (this._regionalAdministrators == null) (0, $4b7cacdb38b8b78b$export$ec4426d16f40cbaa)((err, data)=>{
            if (!err && data) this._regionalAdministrators = data;
            callback(err, data);
        });
        else callback(null, this._regionalAdministrators);
    }
    setupRegionalAdminPopover(link) {
        var showCount = 0;
        link.popover({
            html: true,
            title: 'Regional Administrators',
            placement: 'bottom',
            trigger: 'hover',
            content: ()=>{
                let div_id = "tmp-id-" + $.now(); //: thanks to https://stackoverflow.com/a/14560039
                let _content = `<div id="${div_id}"><span class="text-muted"><i class="fa fa-refresh fa-lg fa-spin"></i> Retrieving list of Administrators...</span></div>`;
                // console.info('setupRegionalAdminPopover', { this: this, showCount: showCount, div_id: div_id, _content: _content, divs: $('#' + div_id).length, link: link, linkData: link.data(), linkDataPopoverInstance: link.data('bs.popover') });
                this.retrieveRegionalAdministrators((err, data)=>{
                    if (!err && data) {
                        var $table = $('<table class="table-striped midi_common_popover_table" style="margin: 0;"></table>');
                        var $tbody = $('<tbody></tbody>').appendTo($table);
                        data.Regions.forEach((region)=>{
                            var $tr = $('<tr></tr>');
                            $('<td>').text(region.RegionLabel).appendTo($tr);
                            $('<td>').addClass('midi_common_link').html(region.Administrators.join('<br>')).appendTo($tr);
                            $tr.appendTo($tbody);
                        });
                        _content = $('<div>').append($table).html();
                        $('#' + div_id).empty().append($table);
                    } else {
                        $('#' + div_id).empty().append('Error while retrieving list of Regional Administrators.');
                        console.warn('Error while retrieving list of Regional Administrators', {
                            err: err,
                            data: data
                        });
                    }
                });
                showCount++;
                return _content;
            }
        });
        return link;
    }
    getTimeZoneString() {
        switch(this.displayTimeType){
            case "UTC":
                return "UTC";
            case "Pc Time":
                return moment(moment.utc()).tz(moment.tz.guess()).format("z").toString();
            case "Station/Region Time":
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).format("z").toString();
            default:
        }
    }
    getTimeZoneStringFormat(format = 'ZZ') {
        switch(this.displayTimeType){
            case "UTC":
                return moment(moment.utc()).tz("UTC").format(format).toString();
            case "Pc Time":
                return moment(moment.utc()).tz(moment.tz.guess()).format(format).toString();
            case "Station/Region Time":
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).format(format).toString();
            default:
        }
    }
    getTimeZoneName() {
        switch(this.displayTimeType){
            case "UTC":
                return "UTC";
            case "Pc Time":
                return moment.tz.guess();
            case "Station/Region Time":
                return this.selectedRegion.TimeZone;
            default:
        }
    }
    getTimeZoneUtcOffset() {
        switch(this.displayTimeType){
            case "UTC":
                return moment(moment.utc()).tz("UTC").utcOffset();
            case "Pc Time":
                return moment(moment.utc()).tz(moment.tz.guess()).utcOffset();
            case "Station/Region Time":
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).utcOffset();
            default:
        }
    }
    /**
     * A helper function to get appropriately format timezone data for a given timezone ID and its corresponding DisplayTimeType.
     */ getTimeZoneData(tzName, displayTimeTypeId) {
        let offsetMinutes = moment(moment.utc()).tz(tzName).utcOffset();
        let offsetString = moment(moment.utc()).tz(tzName).format('ZZ').toString();
        let timezoneCode = moment(moment.utc()).tz(tzName).format('z').toString();
        let label = `${timezoneCode} ${offsetString} (${displayTimeTypeId})`;
        if (offsetMinutes == 0 || displayTimeTypeId == "UTC") label = `${displayTimeTypeId} (${offsetString})`;
        return {
            timeZoneName: tzName,
            timeZoneCode: timezoneCode,
            offsetMinutes: offsetMinutes,
            offsetString: offsetString,
            label: label,
            displayTimeType: displayTimeTypeId
        };
    }
    /**
     * A helper function to get a list of possible timezones for use in user options and plot/data downloads..
     */ getAllAvailableTimeZones() {
        let res = [];
        res.push(this.getTimeZoneData("UTC", "UTC"));
        res.push(this.getTimeZoneData(moment.tz.guess(), "Pc Time"));
        res.push(this.getTimeZoneData(this.selectedRegion.TimeZone, "Station/Region Time"));
        return res;
    }
    getDisplayTime(timestamp, timeZone) {
        switch(this.displayTimeType){
            case "UTC":
                return moment.utc(timestamp).format("YYYY-MM-DD HH:mm").toString() + ' UTC';
            case "Pc Time":
                var t = moment.utc(timestamp).tz(moment.tz.guess());
                return t.format("YYYY-MM-DD HH:mm") + ' ' + t.format('z');
            case "Station/Region Time":
                var t = moment.utc(timestamp).tz(timeZone);
                return t.format("YYYY-MM-DD HH:mm") + ' ' + t.format('z');
            default:
        }
    }
    tryLogin(email, password) {
        this.currentLoginPage.setLoggingInInProgressState(true);
        if (email && password) (0, $f1e9408cace300d7$export$596d806903d1f59e)(email, password, (err)=>{
            if (err) {
                if (typeof err.Message !== 'undefined') this.currentLoginPage.setError(err.Message);
                else this.currentLoginPage.setError('Unknown error occurred');
                this.currentLoginPage.setLoggingInInProgressState(false);
            } else this.tryLogin();
        });
        else (0, $f1e9408cace300d7$export$e5432d4c8eb97ea7)((err, data)=>{
            if (err) {
                this.currentLoginPage.setError(err.Message);
                this.currentLoginPage.setLoggingInInProgressState(false);
            } else {
                this.currentUser = data;
                (0, $1d3f08d9fba35da9$export$65f9a167a0da0b67)(this.currentUser.Id, (pgErr, pGroups)=>{
                    if (pgErr) {
                        this.currentLoginPage.setError(err.Message);
                        this.currentLoginPage.setLoggingInInProgressState(false);
                    } else {
                        this.currentUserGroupPermissions = pGroups;
                        this.staticDataManager = new (0, $b71f12c6d614c68e$export$e6fac6e2831a7e0c)();
                        this.staticDataManager.getStaticData((err)=>{
                            if (err) {
                                this.currentLoginPage.setError('Error getting Static Data: ' + err);
                                this.currentLoginPage.setLoggingInInProgressState(false);
                                return;
                            }
                            this.currentLoginPage.setLoggingInInProgressState(false);
                            this.renderAfterLogin();
                        });
                    }
                });
            }
        });
    }
    renderAfterLogin() {
        this.buildUserNavMenu();
        this.buildRegionSelector();
        //this.buildWarningRulesSelector();
        this.liveDataManager.start();
        this.GOMAveragesManager.start();
        this.currentLoginPage.cleanUp();
        if (this.checkPointerEventsEnabled()) this.dayNightModeDiv = $('<div class="nightmode-box"></div>').appendTo('body');
        this.navBar.navBar.appendTo('body');
        this.hashChange();
        $(window).on('hashchange', ()=>{
            this.hashChange();
        });
        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MainSite.renderAfterLogin() - no Regions available!');
            let $dialogContentWrap = $('<div>');
            let $dialogContent = $('<div>').appendTo($dialogContentWrap);
            $dialogContent.addClass('alert alert-danger').css('margin', 0);
            $('<p></p>').appendTo($dialogContent).append($('<span>Your Account on this site does not seem to have any Permissions set or access to any Regions. Please contact your </span>').append('<span class="regionalAdminLink--placeholder"><strong><u>Regional Administrator</u></strong></span>').append('<span> to request access.</span>'));
            let dialog = new (0, $07be79b8daca7111$export$3efe75ad489a5e73)('No Regions or Permissions for this Account', $dialogContentWrap.html(), true);
            dialog.getModal().on('shown.bs.modal', ()=>{
                let regionalAdminLink = this.setupRegionalAdminPopover($('<strong><u>Regional Administrator</u></strong>').css("cursor", "pointer"));
                dialog.getModal().find('.regionalAdminLink--placeholder').empty().append(regionalAdminLink);
            });
            dialog.show();
        }
    /*try {
                if (("NorthSea_Gannet" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Shearwater" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Nelson" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_HaeweneBrim" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Penguins" in this.staticDataManager.Schema.ParameterSchema.Stations)) {
                        
                    new SimpleDialog('Adura assets are leaving METNET Global',
                        '<p>Please note that real-time data from Gannet, Nelson, Shearwater, Haewene Brim and Penguins will not be available on METNET Global starting from 1 December 2025. All users who require access to this data should migrate to the Elements Online portal. Contact Dmitry Besedin at <a href="mailto:d.besedin@adura.com">d.besedin@adura.com</a> for details.</p>',
                        true).show();
                }
            } catch {}*/ }
    /**
         * Returns to the login screen. It is essential that all pages have cleaned up themselves,
         * which is why this should only be called in handleHashChange().
         */ logout() {
        this.liveDataManager.stop();
        this.GOMAveragesManager.stop();
        $(window).off('hashchange');
        $.removeCookie('session', {
            path: '/'
        });
        window.location.hash = '';
        // Detach the navBar without unbinding events
        this.navBar.navBar.detach();
        $52db63ea8facb471$export$1a86835baa79d770.instance.currentLoginPage = new (0, $e51d30a246217e6f$export$f14c0e3f98d164c0)();
        $52db63ea8facb471$export$1a86835baa79d770.instance.currentLoginPage.render();
        this.tryLogin();
    }
    hashChange() {
        //this.pages.push(
        //    ...(((this.selectedRegion) && (this.selectedRegion.Id == "GOM"))
        //        ? [new GOMTablePage(this)]
        //        : [new TablePage(this)]),
        //)
        var newHashData = this.hashDataManager.decode(window.location.hash);
        if (this.hashData) {
            if (this.hashData.Page !== newHashData.Page) // things to do when page changes
            $('.midi_siteObsPage_popup').remove();
            if (this.hashData.Page == newHashData.Page && this.hashData.Page == 'siteObs' && this.hashData.PageSpecificData !== newHashData.PageSpecificData) // things to do when a site obs tab changes
            $('.midi_siteObsPage_popup').remove();
        }
        this.hashData = newHashData;
        if (this.hashData.Page == "scrollingSiteObs") {
            let stationIds;
            if (this.hashData.StationIds) stationIds = this.hashData.StationIds;
            else {
                stationIds = [];
                for(let stationId in this.staticDataManager.Schema.ParameterSchema.Stations)stationIds.push(stationId);
            }
            let stations = [];
            for(let i = 0; i < stationIds.length; i++){
                let station = this.staticDataManager.Schema.ParameterSchema.Stations[stationIds[i]];
                if (!station) return;
                let station_ = {
                    stationId: stationIds[i],
                    params: []
                };
                let sensorCount = 0;
                for(let sensorId in station.Sensors)sensorCount++;
                let gotOverview = false;
                let gotClouds = false;
                let gotWaves = false;
                let gotCurrent = false;
                let gotMotion = false;
                let gotWind = false;
                for(let sensorId in station.Sensors){
                    if (sensorCount !== 1) gotOverview = true;
                    const sensor = station.Sensors[sensorId];
                    for(let paramId in sensor.Parameters){
                        if (paramId.indexOf('Cloud') != -1 || sensorCount > 1) gotClouds = true;
                        if (paramId.indexOf('HsT/') != -1 || paramId.indexOf('Hs/') != -1 || sensorCount > 1) gotWaves = true;
                        if (paramId.indexOf('Current') != -1 || sensorCount > 1) gotCurrent = true;
                        if (paramId.indexOf('Motion') != -1 || sensorCount > 1) gotMotion = true;
                        if (paramId.indexOf('Wind') != -1 || sensorCount > 1) gotWind = true;
                    }
                }
                gotOverview && station_.params.push("overview");
                gotClouds && station_.params.push("clouds");
                gotWaves && station_.params.push("waves");
                gotCurrent && station_.params.push("current");
                gotMotion && station_.params.push("motion");
                gotWind && station_.params.push("wind");
                stations.push(station_);
            }
            this.scroller(stations, (stationId, parameterId)=>{
                this.changePage('siteObs', {
                    Station: stationId,
                    Tab: parameterId
                });
            }, this.hashData.Interval ? this.hashData.Interval * 1000 : 10000);
        }
        this.selectRegion();
        this.buildWarningRulesSelector();
        this.selectWarningRules();
        this.updateStaticLinks();
        this.buildStationSelector();
        this.selectStation();
        //removes any open modals (such as warning modals) when the hash changes.
        if (this.modal) {
            this.modal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            this.modal.remove();
            this.modal = null;
        }
        this.pages.forEach((page)=>{
            page.handleHashChange(this.hashData);
        });
        if (!this.hashData.Page || this.hashData.Page === 'map' || this.hashData.Page.toLowerCase().includes('table') || this.hashData.Page === 'plot' || this.hashData.Page === "forecastsPDFs") this.regionSelector.show();
        else this.regionSelector.hide();
        if (this.hashData.Page === 'logout') this.logout();
    }
    changePage(pageId, pageSpecificData = null) {
        var newHashData = {
            Page: pageId,
            Region: this.hashData.Region,
            WarningGroup: this.hashData.WarningGroup
        };
        if (pageSpecificData) newHashData.PageSpecificData = pageSpecificData;
        window.location.hash = this.hashDataManager.encode(newHashData);
    }
    buildUserNavMenu() {
        if (this.userNavMenu) {
            this.userNavMenu.remove();
            this.userNavMenu = null;
        }
        this.userNavMenu = $('<li class="dropdown"></li>').appendTo(this.navBar.navLinksRight);
        $('<a href="#" title="Open User Menu" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>').prepend($('<span></span>').text(this.currentUser.Id)).appendTo(this.userNavMenu).dropdown();
        var dd = $('<ul class="dropdown-menu" role="menu"></ul>').appendTo(this.userNavMenu);
        $('<li><a href="#Page=logout">Log Out</a></li>').appendTo(dd);
        $('<li><a href="#">Change Password</a></li>').click(()=>{
            this.changePage('changePassword');
            this.userNavMenu.removeClass('open');
            return false;
        }).appendTo(dd);
        $('<li><a href="#">Support</a></li>').click(()=>{
            this.changePage('support');
            this.userNavMenu.removeClass('open');
            return false;
        }).appendTo(dd);
        // local time selector
        var displayTimeSelector = $('<li></li>').appendTo(dd);
        if ($.cookie('displayTimeType') != null) switch($.cookie('displayTimeType')){
            case "UTC":
                this.displayTimeType = "UTC";
                break;
            case "Pc Time":
                this.displayTimeType = "Pc Time";
                break;
            case "Station/Region Time":
                this.displayTimeType = "Station/Region Time";
                break;
            default:
        }
        else //initial display time type
        this.displayTimeType = "UTC";
        $('<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"> Display Time: </a>').appendTo(displayTimeSelector);
        var UTCTimeSelector = $('<a href="#" style="margin-left: 20px"> UTC </a>').appendTo(displayTimeSelector).click(()=>{
            $.cookie('displayTimeType', "UTC", {
                expires: 1825
            });
            location.reload();
        });
        var UTCTimeSelectorUnchecked = $('<i id="midi_common_disply_utc_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(UTCTimeSelector);
        var UTCTimeSelectorChecked = $('<i id="midi_common_display_utc_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(UTCTimeSelector);
        var pcTimeSelector = $('<a href="#" style="margin-left: 20px"> PC Time </a>').appendTo(displayTimeSelector).click(()=>{
            $.cookie('displayTimeType', "Pc Time", {
                expires: 1825
            });
            location.reload();
        });
        var pcTimeSelectorUnchecked = $('<i id="midi_common_disply_pc_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(pcTimeSelector);
        var pcTimeSelectorChecked = $('<i id="midi_common_display_pc_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(pcTimeSelector);
        var stationTimeSelector = $('<a href="#" style="margin-left: 20px"> Region/Station Time </a>').appendTo(displayTimeSelector).click(()=>{
            $.cookie('displayTimeType', "Station/Region Time", {
                expires: 1825
            });
            location.reload();
        });
        var stationTimeSelectorUnchecked = $('<i id="midi_common_disply_station_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(stationTimeSelector);
        var stationTimeSelectorChecked = $('<i id="midi_common_display_station_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(stationTimeSelector);
        switch(this.displayTimeType){
            case "UTC":
                UTCTimeSelectorChecked.show();
                UTCTimeSelectorUnchecked.hide();
                pcTimeSelectorChecked.hide();
                pcTimeSelectorUnchecked.show();
                stationTimeSelectorChecked.hide();
                stationTimeSelectorUnchecked.show();
                break;
            case "Pc Time":
                UTCTimeSelectorChecked.hide();
                UTCTimeSelectorUnchecked.show();
                pcTimeSelectorChecked.show();
                pcTimeSelectorUnchecked.hide();
                stationTimeSelectorChecked.hide();
                stationTimeSelectorUnchecked.show();
                break;
            case "Station/Region Time":
                UTCTimeSelectorChecked.hide();
                UTCTimeSelectorUnchecked.show();
                pcTimeSelectorChecked.hide();
                pcTimeSelectorUnchecked.show();
                stationTimeSelectorChecked.show();
                stationTimeSelectorUnchecked.hide();
                break;
        }
        // Units Conversion Preference:
        $('<a href="#">Units Conversion:</a>').appendTo($('<li></li>').appendTo(dd)).on('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        let ucOptKey = (0, $f423c86e63025694$export$369c46f21624ab3a);
        let ucOptVal = $52db63ea8facb471$export$1a86835baa79d770.localStorageGet(ucOptKey, undefined); //: uses the first enum option as a default.
        if (!ucOptVal) {
            const tsOffset = -new Date().getTimezoneOffset();
            console.log(`Detecting default unit conversions using time zone offset: ${tsOffset} minutes`);
            if (tsOffset < 0) ucOptVal = "imperial";
            else ucOptVal = "default";
        }
        for(const ucmKey in 0, $f423c86e63025694$export$b7e51c16914c4c09){
            if (ucmKey == 'METRIC') continue;
            let ucmLbl = (0, $f423c86e63025694$export$b7e51c16914c4c09)[ucmKey];
            $(`<a href="#" style="margin-left: 20px">${ucmLbl}</a>`).prepend(`<i class="fa ${ucOptVal == ucmKey.toLowerCase() ? 'fa-check-square-o' : 'fa-square-o'}"></i> `).appendTo($('<li></li>').appendTo(dd)).on('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                $52db63ea8facb471$export$1a86835baa79d770.localStorageSet(ucOptKey, ucmKey.toLowerCase());
                location.reload();
            });
        }
        // basic view
        var basicViewSelector = $('<li></li>').click(()=>{
            if (this.basicViewSelectorBool) {
                $.cookie('basicViewSelectorBool', 'false', {
                    expires: 1825
                });
                location.reload();
            } else {
                $.cookie('basicViewSelectorBool', 'true', {
                    expires: 1825
                });
                location.reload();
            }
            return false;
        }).appendTo(dd);
        if ($.cookie('basicViewSelectorBool') != null) {
            if ($.cookie('basicViewSelectorBool') == "true") this.basicViewSelectorBool = true;
            else this.basicViewSelectorBool = false;
        } else this.basicViewSelectorBool = false;
        var basicViewDropdown = $('<a href="#"> Basic Parameter View </a>').appendTo(basicViewSelector);
        var basicViewCheckboxUnchecked = $('<i id="midi_common_display_basic_view_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(basicViewDropdown);
        var basicViewCheckboxChecked = $('<i id="midi_common_display_basic_view_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(basicViewDropdown);
        if (this.basicViewSelectorBool) {
            basicViewCheckboxUnchecked.hide();
            basicViewCheckboxChecked.show();
        } else {
            basicViewCheckboxUnchecked.show();
            basicViewCheckboxChecked.hide();
        }
        if (this.checkPointerEventsEnabled()) {
            var dayNightModeDropDown = $('<li></li>').click(()=>{
                if (dayNightText.text() == 'Switch to Night Mode') {
                    dayNightText.text('Switch to Day Mode');
                    this.dayNightModeDiv.addClass('midi_common_night_mode');
                } else {
                    dayNightText.text('Switch to Night Mode');
                    this.dayNightModeDiv.removeClass('midi_common_night_mode');
                }
                return false;
            }).appendTo(dd);
            var dayNightText = $('<a href="#">Switch to Night Mode</a>').appendTo(dayNightModeDropDown);
        }
        if (this.currentUser.Permissions.Administrator == true) {
            $('<li><a href="#">Manage Users</a></li>').click(()=>{
                this.changePage('manageUsers');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
            $('<li><a href="#">Manage Group Permissions</a></li>').click(()=>{
                this.changePage('managePermissionGroups');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
        }
        if (this.currentUser.Permissions.Administrator == true) $('<li><a href="#">User Emails</a></li>').click(()=>{
            this.changePage('emailUsers');
            this.userNavMenu.removeClass('open');
            return false;
        }).appendTo(dd);
        if (this.currentUser.Permissions.GlobalAdministrator == true || this.currentUser.Permissions.Administrator == true) {
            $('<li><a href="#">Manage Outage Notifications Recipients</a></li>').click(()=>{
                this.changePage('autoNotifications');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
            $('<li><a href="#">Manage Outage Notifications Thresholds</a></li>').click(()=>{
                this.changePage('autoNotificationThresholds');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
        }
        if (this.currentUser.Permissions.Administrator == true) $('<li><a href="#">Manage Range Alerts</a></li>').click(()=>{
            this.changePage('manageAlerts');
            this.userNavMenu.removeClass('open');
            return false;
        }).appendTo(dd);
        if (this.currentUser.Permissions.Administrator == true) $('<li><a href="#">Parameter Groups Settings</a></li>').click(()=>{
            this.changePage('manageParameterGroupsSettings');
            this.userNavMenu.removeClass('open');
            return false;
        }).appendTo(dd);
    }
    selectRegion() {
        if (!$.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            //if no region set, check to see if we have a cookie for "selectedRegion" and select that region
            if (!this.hashData.Region || !this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region]) {
                if ($.cookie("selectedRegion") && $.cookie("selectedRegion") in this.staticDataManager.Schema.RegionSet.Regions) this.hashData.Region = $.cookie("selectedRegion");
                else {
                    const tsOffset = -new Date().getTimezoneOffset();
                    console.log(`Detecting default region using time zone offset: ${tsOffset} minutes`);
                    if ("GOM" in this.staticDataManager.Schema.RegionSet.Regions && tsOffset < 0) this.hashData.Region = "GOM";
                    else if ("Australia" in this.staticDataManager.Schema.RegionSet.Regions && tsOffset >= 420) this.hashData.Region = "Australia";
                    else if ("NorthSea" in this.staticDataManager.Schema.RegionSet.Regions) //set region to North Sea by default
                    this.hashData.Region = "NorthSea";
                    else // set region to the first available
                    for(var regionId in this.staticDataManager.Schema.RegionSet.Regions){
                        this.hashData.Region = regionId;
                        break;
                    }
                }
            }
            // we can guarantee we have a valid region by this point
            this.regionSelectorSpan.text(this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region].Label);
            this.selectedRegion = this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region];
            // The GOM region has a special table page. 
            // Make sure not to "loose" the page when changing between regions while on the table page.
            if (this.selectedRegion.Id == "GOM" && this.hashData.Page == "table") this.hashData.Page = "GOMTable";
            else if (this.selectedRegion.Id != "GOM" && this.hashData.Page == "GOMTable") this.hashData.Page = "table";
        }
        // highcharts will use UTC if the cookie is set to use UTC
        // otherwise, highcharts will be using the browser local time
        // getTimezoneOffset looks at the timezone offset of each point to ensure the correct DST handling   
        Highcharts.setOptions({
            global: {
                useUTC: $.cookie('displayTimeType') != "Pc Time",
                timezone: $.cookie('displayTimeType') == "Station/Region Time" ? this.selectedRegion.TimeZone : ''
            }
        });
    }
    buildRegionSelector() {
        if (this.regionSelector) {
            this.regionSelector.remove();
            this.regionSelector = null;
        }
        this.regionSelector = $('<li class="dropdown"></li>').prependTo(this.navBar.navLinksLeft);
        this.regionSelectorSpan = $('<span></span>').text("Select Region");
        $('<a href="javascript:;" title="Selected Region" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>').prepend(this.regionSelectorSpan).appendTo(this.regionSelector).dropdown();
        var dd = $('<ul class="dropdown-menu" role="menu"></ul>').appendTo(this.regionSelector);
        var selectedRegion;
        var selectedRegionId = this.hashDataManager.decode(window.location.hash).Region;
        if (selectedRegionId) selectedRegion = this.staticDataManager.Schema.RegionSet.Regions[selectedRegionId];
        for(var regionId in this.staticDataManager.Schema.RegionSet.Regions)((region)=>{
            $('<a href="#">' + region.Label + '</a>').click((e)=>{
                this.hashData.Region = region.Id;
                //create selectedRegion cookie once a region is selected from the drop down. Until a new region is selected, this is the default for the user.
                $.cookie("selectedRegion", this.hashData.Region, {
                    expires: 3000
                });
                $(e.target).attr('href', this.hashDataManager.encode(this.hashData));
                this.selectWarningRules();
                this.refreshWarningRulesSelectorContent();
                this.updateStaticLinks();
            }).appendTo($('<li></li>').appendTo(dd));
        })(this.staticDataManager.Schema.RegionSet.Regions[regionId]);
    }
    selectStation() {
        if (this.hashData.Page !== 'siteObs') {
            this.stationSelector.removeClass('active');
            this.selectedStationSpan.text('Station');
            return;
        }
        // if no station group set, or invalid station, set to the first available
        if (!this.hashData.PageSpecificData || !this.hashData.PageSpecificData.Station || !this.staticDataManager.Schema.ParameterSchema.Stations[this.hashData.PageSpecificData.Station]) for(var stationId in this.staticDataManager.Schema.ParameterSchema.Stations){
            this.hashData.PageSpecificData = {
                Station: stationId
            };
            break;
        }
        // we can guarantee we have a valid station id by this point
        var station = this.staticDataManager.Schema.ParameterSchema.Stations[this.hashData.PageSpecificData.Station].Station;
        this.stationSelector.addClass('active');
        this.selectedStationSpan.text(station.Label);
    }
    buildStationSelector() {
        if (this.stationSelector) {
            this.stationSelector.remove();
            this.stationSelector = null;
        }
        this.stationSelector = $('<li class="dropdown"></li>').appendTo(this.navBar.navLinksLeft);
        this.selectedStationSpan = $('<span></span>');
        $('<a href="#" title="Select Station" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>').prepend(this.selectedStationSpan).appendTo(this.stationSelector).dropdown();
        var dd = $('<ul class="dropdown-menu" style="max-height: 350px; overflow: auto;" role="menu"></ul>').appendTo(this.stationSelector);
        let stationsOrdered = [];
        for(var stationId in this.staticDataManager.Schema.ParameterSchema.Stations){
            var station = this.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station;
            if (station.Region !== this.hashData.Region) continue;
            stationsOrdered.push(station);
        }
        stationsOrdered.sort((a, b)=>{
            if (a.RegionOrder < b.RegionOrder) return -1;
            else if (a.RegionOrder > b.RegionOrder) return 1;
            else return b.Latitude - a.Latitude;
        });
        stationsOrdered.forEach((station)=>{
            $('<a title="Jump to Station Overview" href="javascript:void(0);">' + station.Label + '</a>').click((e)=>{
                this.selectedStationSpan.text(station.Label);
                this.changePage('siteObs', {
                    Station: station.Id,
                    Tab: (0, $6feb48abab9d78f7$export$432915b0d85cff8d).getLandingPageId(station)
                });
                return true;
            }).appendTo($('<li></li>').appendTo(dd));
        });
    }
    selectWarningRules() {
        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            this.warningRulesSelectorSpan.text("No Warning Rules");
            console.warn('MainSite.selectWarningRules() - no Regions available!');
            return;
        }
        var allowedGroupIds = this.staticDataManager.Schema.RegionSet.Regions[this.selectedRegion.Id].WarningGroupIds;
        if (allowedGroupIds.length == 0) {
            this.warningRulesSelectorSpan.text("No Warning Rules");
            this.selectedWarningRules = null;
            this.hashData.WarningGroup = null;
            return;
        }
        // if no warning group set, or invalid warning group, set to the first allowed
        if (!this.hashData.WarningGroup || allowedGroupIds.indexOf(this.hashData.WarningGroup) == -1) this.hashData.WarningGroup = allowedGroupIds[0];
        // we can guarantee that hashData contains a valid warning group by this point
        this.warningRulesSelectorSpan.text(this.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.hashData.WarningGroup].Label);
        this.selectedWarningRules = this.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.hashData.WarningGroup];
    }
    updateStaticLinks() {
        this.navBar.navLinksCustom.empty();
        if (this.selectedRegion && this.selectedRegion.Id == "NorthSea" && !this.currentUser.Permissions.GlobalAdministrator // Hide static links for global admin to preserve nav bar space
        ) {
            $('<li><a href="https://www.helimet.com" target="_blank"><img class="midi_common_navbar-shell" src="images/oilgasuk.png"/></a></li>').prependTo(this.navBar.navLinksCustom);
            $('<li><a href="https://offshore.meteogroup.com/ocw/" target="_blank"><img class="midi_common_navbar-shell" src="images/meteogroup.png"/></a></li>').prependTo(this.navBar.navLinksCustom);
        }
    }
    buildWarningRulesSelector() {
        if (this.warningRulesSelector) {
            this.warningRulesSelector.remove();
            this.warningRulesSelector = null;
        }
        this.warningRulesSelector = $('<li class="dropdown"></li>').prependTo(this.navBar.navLinksRight);
        this.warningRulesSelectorSpan = $('<span></span>').text("Select Rules");
        $('<a href="#" title="Selected Warning Rules" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>').prepend(this.warningRulesSelectorSpan).appendTo(this.warningRulesSelector).dropdown();
        this.warningRulesDropdown = $('<ul class="dropdown-menu" role="menu"></ul>').appendTo(this.warningRulesSelector);
        var selectedWarningGroup;
        this.refreshWarningRulesSelectorContent();
    }
    refreshWarningRulesSelectorContent() {
        this.warningRulesDropdown.empty();
        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MainSite.refreshWarningRulesSelectorContent() - no Regions available!');
            return;
        }
        this.staticDataManager.Schema.RegionSet.Regions[this.selectedRegion.Id].WarningGroupIds.forEach((warningGroupId)=>{
            ((warningGroup)=>{
                $('<a title="Select Warning Rule" href="#">' + warningGroup.Label + '</a>').click((e)=>{
                    this.hashData.WarningGroup = warningGroup.Id;
                    $(e.target).attr('href', this.hashDataManager.encode(this.hashData));
                }).appendTo($('<li></li>').append($('<a class="midi_common_dropdownInfo" title="Show Warning Rule Information"><i class="fa fa-info-circle"></i><span class="sr-only">i</span></a>').click(()=>{
                    this.renderWarningGroupsModal(warningGroup);
                })).appendTo(this.warningRulesDropdown));
            })(this.staticDataManager.Schema.WarningGroupSet.WarningGroups[warningGroupId]);
        });
    }
    renderWarningGroupsModal(warningGroup) {
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog" ></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        modalHeader.append($('<button type="button" class= "close" data-dismiss="modal">&times;</button>'));
        modalHeader.append($('<h4 class="modal-title">Warning Rules - ' + warningGroup.Label + '</h4>'));
        var modalBody = $('<div class="modal-body"></div>').appendTo(modalContent);
        if (!warningGroup.IsFrontEndWarningRuleSet) {
            // the old-style simple server side warning groups
            modalBody.append($('<p>The table below shows the colour-coding rules which are applied to displayed values, when the <strong>' + warningGroup.Label + '</strong> warning rule set is selected.</p>'));
            var tableBody = $('<tbody></tbody>').appendTo($('<table class="table table-striped midi_common_warning_rules_table"></table>').appendTo(modalBody));
            for(var parameterGroupId in warningGroup.Rules){
                var rule = warningGroup.Rules[parameterGroupId];
                var row = $('<tr></tr>').append('<td class="midi_common_warning_rules_title_column">' + parameterGroupId + '</td>');
                if (rule.Lt_HighPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_3">&lt; ' + rule.Lt_HighPriority + '</td>');
                if (rule.Lt_MediumPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_2">&lt; ' + rule.Lt_MediumPriority + '</td>');
                if (rule.Lt_LowPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_1">&lt; ' + rule.Lt_LowPriority + '</td>');
                if (rule.Gt_LowPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_1">&gt; ' + rule.Gt_LowPriority + '</td>');
                if (rule.Gt_MediumPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_2">&gt; ' + rule.Gt_MediumPriority + '</td>');
                if (rule.Gt_HighPriority !== null) row.append('<td class="midi_siteObsPage_exceeded_threshold_3">&gt; ' + rule.Gt_HighPriority + '</td>');
                tableBody.append(row);
            }
        }
        // else if (warningGroup.Id in FrontEndWarningRules.map) {
        //     var ruleSet = FrontEndWarningRules.map[warningGroup.Id];
        //     modalBody.append(ruleSet.buildInfo());
        // }
        this.modal.modal('show');
    }
    checkPointerEventsEnabled() {
        return this.isIE() == 0 || this.isIE() > 10;
    }
    isIE() {
        var myNav = navigator.userAgent.toLowerCase();
        return myNav.indexOf('msie') != -1 ? parseInt(myNav.split('msie')[1]) : 0;
    }
    dispatchResize() {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            var evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        } else window.dispatchEvent(new Event('resize'));
    }
    //: helper functions to get lists of Region/Station/Parameters (initially setup on ManageParameterGroupsSettings.ts, then brought to MainSite to use in ManageAlerts.ts and eventually others if needed)
    getStationsByRegions(sortAlpha = false) {
        const { Regions: Regions } = this.staticDataManager.Schema.RegionSet;
        const { Stations: Stations } = this.staticDataManager.Schema.ParameterSchema;
        let _list = [];
        for(const regionId in Regions){
            let _region = {
                Region: Regions[regionId],
                Stations: []
            };
            for(let stationId in Stations){
                const station = Stations[stationId];
                if (station.Station.Region == _region.Region.Id) _region.Stations.push(station.Station);
            }
            if (sortAlpha) _region.Stations.sort((a, b)=>a.Label > b.Label ? 1 : -1);
            _list.push(_region);
        }
        if (sortAlpha) _list.sort((a, b)=>a.Region.Label > b.Region.Label ? 1 : -1);
        return _list;
    }
    getStationSensors(stationId) {
        let _list = {};
        const { Stations: Stations } = this.staticDataManager.Schema.ParameterSchema;
        if (stationId in Stations) _list = Stations[stationId].Sensors;
        // TODO: sort alpha?..
        return _list;
    }
    getStationSensorParameters(stationId, sensorId) {
        let _list = {};
        let _sensors = {};
        const { Stations: Stations } = this.staticDataManager.Schema.ParameterSchema;
        if (stationId in Stations) {
            _sensors = Stations[stationId].Sensors;
            if (sensorId in _sensors) _list = Stations[stationId].Sensors[sensorId].Parameters;
        }
        // TODO: sort alpha?..
        return _list;
    }
    getStationParameterGroups(stationId, sensorId) {
        let _list = [];
        const ldStations = this.liveDataManager.latestData.Stations;
        if (stationId in ldStations) {
            const ldStation = ldStations[stationId];
            for(let groupId in ldStation.GroupValues){
                let _include = false;
                const groupValues = ldStation.GroupValues[groupId];
                groupValues.forEach((ldsv)=>{
                    if (ldsv.Sensor == sensorId) _include = true;
                });
                if (_include) _list.push(groupId);
            }
        }
        _list.sort((a, b)=>a > b ? 1 : -1);
        return _list;
    }
    /**
     * Helper function to set a key/value pair to browser's local storage. This will try using localStorage API before using cookies, to avoid overloading server requests with unecessary cookies data.
     * @param key
     * @param value If this is set to null, the local storage key/value pair will be deleted.
     */ static localStorageSet(key, value) {
        if (this.localStorageCheckCapability()) {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, value);
        } else if (value === null) $.removeCookie(key);
        else $.cookie(key, value, {
            expires: 1825,
            path: '/'
        });
    }
    /**
     * Helper function to get a value from a key/value pair stored in browser's local storage (trying to use localStorage API before using cookies).
     * @param key
     * @param defaultValue If key does not exist, then the defaultValue is returned.
     * @param setIfNotExists If set to TRUE and the key does not exist (in either localStorage or cookie), then the defaultValue will be set in local storage via localStorageSet() method.
     */ static localStorageGet(key, defaultValue, setIfNotExists = false) {
        if (this.localStorageCheckCapability()) {
            let val = localStorage.getItem(key);
            if (val === null) {
                if ($.cookie(key) !== undefined) {
                    val = $.cookie(key);
                    this.localStorageSet(key, val);
                    return val;
                }
                if (setIfNotExists) this.localStorageSet(key, defaultValue);
                return defaultValue;
            } else return val;
        } else {
            let val = $.cookie(key);
            if (val === null || val === undefined) {
                if (setIfNotExists) this.localStorageSet(key, defaultValue);
                return defaultValue;
            } else return val;
        }
    }
    static localStorageCheckCapability() {
        let test = 'LocalStorageTest';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
     * UI Page blocking (for AJAX actions... initially setup in Plotting Page, later made available throughout the site for other pages.)
     * @param message
     * @param blockNavBar Should we also block the top navbar? (recommended)
     * @param callback Function to be executed once blocking is complete.
     */ pageBlock(message = '', blockNavBar = true, callback) {
        let _msg = '';
        let progressBar = '<div class="progress" style="margin:0"><div class="progress-bar progress-bar-striped active" style="width: 100%"></div></div>';
        let css = {
            border: 'none',
            backgroundColor: 'transparent',
            color: '#fff'
        };
        let $msg = $('<div>');
        if (message.length > 0) {
            $msg.text(message); //: use this to escape content..
            _msg = progressBar + '<div style="margin-top: 5px;">' + $msg.html() + '</div>';
        } else _msg = progressBar;
        if (blockNavBar) $(".navbar.navbar-fixed-top").block({
            message: '',
            css: css
        });
        $(this._pageBlockJquerySelector).block({
            message: _msg,
            css: css,
            onBlock: ()=>{
                $('body').css({
                    overflow: 'hidden'
                });
                if (typeof callback == "function") callback();
            }
        });
    }
    /**
     * Unblock the UI page.
     */ pageUnblock() {
        $('body').css({
            overflow: ''
        });
        $(".navbar.navbar-fixed-top").unblock();
        $(this._pageBlockJquerySelector).unblock();
    }
    /**
     * A utility function to help with string escaping to prevent XSS attacks, where we're using $().html() if necessary.
     * @param str
     */ static escapeString(str) {
        return str.replace(/(<([^>]+)>)/gi, ""); //: https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/ (alternatively, use $(`<div>${str}</div>`).text())
    }
    /**
     * Returns the "fa-" prefixed classname relevant for the provided type (region, station, sensor, parameter..)
     * @param type Should be region, station, sensor, parameter or parametervariant.
     */ static getAwesomeIconClass(type = "station") {
        switch(type.toLowerCase()){
            case "region":
                return "fa-globe";
            case "station":
                return "fa-map-pin";
            case "sensor":
                return "fa-cog";
            case "parameter":
                return "fa-circle-thin";
            case "parametervariant":
                return "fa-circle";
            default:
                return "fa-question-circle";
        }
    }
}


(0, $52db63ea8facb471$export$1a86835baa79d770).run();

})();
//# sourceMappingURL=index.js.map
